webpackJsonp([2],{

/***/ "+4WN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AUTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTH_SOCIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_OK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUTH_REGISTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_COMPLATE_REGISTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPLATE_REGISTRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_USER_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return REGISTRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REGISTRATION_ERROR; });
/* unused harmony export SET_TAPPA */
var AUTH_REQUEST = 'AUTH_REQUEST';
var AUTH_SOCIAL = 'AUTH_SOCIAL';
var AUTH_OK = 'AUTH_OK';
var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = 'AUTH_ERROR';
var AUTH_LOGOUT = 'AUTH_LOGOUT';
var AUTH_REGISTRATION = 'AUTH_REGISTRATION';
var AUTH_COMPLATE_REGISTRATION = 'AUTH_COMPLATE_REGISTRATION';
var COMPLATE_REGISTRATION_SUCCESS = 'COMPLATE_REGISTRATION_SUCCESS';
var SET_USER_TOKEN = 'COMPLATE_REGISTRATION_SUCCESS';

var REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
var REGISTRATION_ERROR = 'REGISTRATION_ERROR';
var SET_TAPPA = 'SET_TAPPA';

/***/ }),

/***/ "+eg0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "+mhg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-e4b69a2e] {\n  font-size: 26px;\n}\n.imageIcons[data-v-e4b69a2e] {\n\t\tvertical-align: bottom!important;\n\t\twidth: 50px;\n}\n.hSize[data-v-e4b69a2e] {\n    font-size: 33px!important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-e4b69a2e] {\n\t\tmax-width: 333px;\n\t\ttext-align: left;\n\t\tmargin: 0 auto;\n\t\tline-height: 27px;\n\t\tpadding-left: 61px;\n}\n\n\n\t/* new PRICE */\n.swal2-popup .swal2-title[data-v-e4b69a2e], #swal2-content[data-v-e4b69a2e] {\n\t\tcolor: #fffbde!important;\n\t\tdisplay: block!important;\n}\n.replaceButton[data-v-e4b69a2e]{\n\t\tmax-width: 40px;\n}\n.inputHelper[data-v-e4b69a2e]{\n    margin-top: -32px;\n    color: #0e3d8b;\n    font-size: 16px;\n    left: 0;\n}\n.priceVal[data-v-e4b69a2e], .priceCent[data-v-e4b69a2e]{\n\t\twidth: calc(50% - 1.5vw - 7.5px);\n\t\tdisplay: inline-table;\n}\n.pseudoEuro[data-v-e4b69a2e] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n}\n.pseudoCent[data-v-e4b69a2e] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n\t\tright:0;\n}\n.group input:focus + .pseudoEuro[data-v-e4b69a2e] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoEuro[data-v-e4b69a2e]{\n\t\tdisplay:block;\n}\n.group input:focus + .pseudoCent[data-v-e4b69a2e] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoCent[data-v-e4b69a2e]{\n\t\tdisplay:block;\n}\n.euroInput[data-v-e4b69a2e]{\n\t\tposition: relative;\n\t\twidth:200%;\n\t\tz-index: 4;\n}\n.euroInput[data-v-e4b69a2e]::before{\n\t\tcontent: 'Euro';\n}\n.euroInput[data-v-e4b69a2e]:focus, .euroInput.valid[data-v-e4b69a2e]{\n\t\twidth:100%;\n}\n.euroInput[data-v-e4b69a2e]:focus::before, .euroInput.valid[data-v-e4b69a2e]::before{\n\t\tcontent: 'Euro';\n\t\tcolor: white;\n\t\tposition: absolute;\n}\n.table[data-v-e4b69a2e]{\n\t\tdisplay: table;\n}\n.newPriceLabel[data-v-e4b69a2e]{\n\t\tz-index: 5;\n\t\tbackground: white;\n\t\tmargin-left: -5px;\n\t\tpadding-left: 5px;\n\t\toverflow: initial;\n\t\tmin-width: calc(200% + 17px);\n}\n\n\n\t/*  ------------ */\n.image-margin0[data-v-e4b69a2e]{\n\t\tmargin: 0!important;\n}\n.helper[data-v-e4b69a2e]{\n\t\tcolor: #0e3d8b;\n\t\tfont-size: 23px;\n\t\tfont-family: Oswald-Medium;\n}\n.greyDesc2[data-v-e4b69a2e]{\n\t\tfont-size: 1.1vw;\n\t\tcolor: #fffbde;\n}\n.redDesc[data-v-e4b69a2e]{\n\t\tfont-size: 1.1vw;\n\t\ttext-decoration: underline;\n\t\tcursor: pointer;\n}\n.uploadDone[data-v-e4b69a2e] {\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\tright: 0;\n\t\tcolor: #a1614f;\n}\n.helperUnderline[data-v-e4b69a2e] {\n}\n.labelFileInput[data-v-e4b69a2e]{\n\t\ttop: -20px!important;\n\t\tfont-size: 22px;\n\t\tcolor: #000000;\n}\n.fileInput[data-v-e4b69a2e]{\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\ttop: 17px;\n\t\tborder-bottom: none;\n\t\tcolor: #000000;\n}\n.fileInputLabel[data-v-e4b69a2e]{\n\t\tz-index: 3;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\tpadding-right: 20px;\n\t\ttext-overflow: ellipsis;\n\t\tcolor: #fffbde;\n}\n.removeProduct[data-v-e4b69a2e]{\n\t\tposition: absolute;\n\t\tright: 21px;\n\t\tmargin: 0px!important;\n\t\ttop: 48px;\n\t\tcolor: #e7201d;\n}\n.typeDisabled[data-v-e4b69a2e]{\n\t\tcolor: #676767;\n\t\tcursor: pointer;\n}\n.typeSelected[data-v-e4b69a2e] {\n\t\tcolor: #fffbde!important;\n\t\tcursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-e4b69a2e] {\n      margin-top: -12px;\n      color: #0e3d8b;\n      font-size: 16px;\n      left: 0;\n}\n.hSize[data-v-e4b69a2e] {\n      font-size: 19px!important;\n}\n.sweetText[data-v-e4b69a2e] {\n      font-size: 19px;\n}\n.removeProduct[data-v-e4b69a2e]{\n    position: absolute;\n    right: 21px;\n    margin: 0px!important;\n    top: 26px;\n    color: #e7201d;\n}\n.greyDesc2[data-v-e4b69a2e], .redDesc[data-v-e4b69a2e]{\n\t\t\tfont-size: 3.1vw;\n}\n.fluid[data-v-e4b69a2e] {\n\t\t\tmax-width: 107px;\n}\n.mobTQ[data-v-e4b69a2e]{\n\t\t\tfont-size: 23px;\n}\n.smMob[data-v-e4b69a2e]{\n\t\t\tfont-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-e4b69a2e] {\n\t\t\tmax-width: 350px;\n\t\t\ttext-align: left;\n\t\t\tmargin: 0 auto;\n\t\t\tline-height: 27px;\n\t\t\tpadding-left: 43px;\n\t\t\tfont-size: 17px;\n}\n.helper[data-v-e4b69a2e] {\n\t\t\tcolor: #0e3d8b;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: Oswald-Medium;\n}\n.imageIcons[data-v-e4b69a2e] {\n\t\t\tvertical-align: bottom!important;\n\t\t\twidth: 39px;\n}\n.fileInput[data-v-e4b69a2e] {\n\n\t\t\ttop: 8px!important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-e4b69a2e]{\n\t\t\t top: -250%;\n}\n}\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "+qws":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("iedL");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2fadcc87", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415b2084\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415b2084\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "+tnh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-3a1cdd68] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-3a1cdd68] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-3a1cdd68] {\n  width: 75px;\n}\n.bigTitle[data-v-3a1cdd68] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-3a1cdd68] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-3a1cdd68] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-3a1cdd68] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-3a1cdd68] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-3a1cdd68] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-3a1cdd68] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-3a1cdd68] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-3a1cdd68] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-3a1cdd68] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 177px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-3a1cdd68] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-3a1cdd68] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-3a1cdd68] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-3a1cdd68] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-3a1cdd68] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-3a1cdd68] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-3a1cdd68]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-3a1cdd68] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-3a1cdd68] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-3a1cdd68]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-3a1cdd68]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-3a1cdd68]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-3a1cdd68] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-3a1cdd68] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-3a1cdd68] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "/DdD":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BBef");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("18e8ac6a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4359101c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./editDocumentCDP.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4359101c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./editDocumentCDP.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/TeD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAACkBAMAAADrm5hyAAAAJ1BMVEVHcEzQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NAqIRN/e3Q1LB+urKkIdpttAAAACHRSTlMA2meLJEjutDa7/S0AAAO1SURBVGjevZtNbhNBEIVniC1YOgoILy2BkJcOEsJLgxQpSyNYsEQgolkGsYiXzNieaUVcwIYDYE4QixzAyDkUwXHssd1d9aanKnWAp69/qrq6ujoIeDt6crZ/EqUn+2fP3wUCdvSybnIWfy2r+vqL2bHHT0sIVg+N1Q66vopvI+Ow9IWXYOXQEHbQ8Rh0z5CWFR78vbphLG4UVIwMa2lDlrEoZxVSvNaE57PSM6Bl6Lq3DWx9TPGNKWCPEMU9U8hawETWi0nG/HQ+MwXto/CwgaHj+wfeSa+Mhz0k3SbykUwpJ2oaL0uIaGE8rSENSWB6Q7oxm/6SiTikC/N9GcnPVseJykimHSnHoV2oV04yEwlBXEBqlpVMZBfHukChKW01/4MWPICrRsC60uPeHnlbQnJj5BUjYvk1vy8jeSoVhNY2zEnWZSRjoeBrD8ShlGRNLmTsho5ISjIVn8r1ZIZykjXZXZnfmdCp87vICQQ5+PnoVwE3hw6yyWhc4FALIcgRhlmDV2dyLTnG16eNQWKYfdR3JgvJMeo/VRQSw+xiCz5ZSo7BJQ9hSAjz/5Ifw5AQ5gAJlmtIBDNBPHySkxxDXl7HIP+AmDEQNG4gf1xNQcwOuy2XkJdmDmJ22W25hJyZ7yBmi8tdVpAGxTzldvoK0qCYteABColifmOcJweJYg7oALwBCWIOaX/cgAQxEzKmb0FimH3SxbcgMcyMktyBhDAzKmrsQEKYMSFpgUQwY+J8tEAimKlb0goJYBKSVkgAMw0KQgKYQUFIANM1cCcki+mcSycki+mSJCA5zNSx1QlIDtPhPSQkgxnbwwYJyWDaIxEDSWNm1hDMQNKYfdtBwUKSmIntOGMhScyh5dAFICnMgS01mLKQK8yfttQgdMzlJZOn3GDObAmMLc36y0IuMS+saZY1GZyykAvMsT0ZtKas5yzkAnNmT1ntifUVcGmaX7hu5N6VrLmzotUzopZJ1p3WV6ljWcmBbJXo9lq6JyvZkipWb17x5Yp460JeW1KyL11yuy3qhNILLrzkLck6fb6MJ+nlmV5JVKFwq1BeViiCa5TqxSbzg+azh8LjjMYTksJDl8JznMKjocbTpsIDrMIzscZjtsKTu0JjgEb7QtkTKL6bVhCFhpVy4Wh4V80/Ci1KGo1UCu1eGk1pCq1zGg1+Cm2IGs2SCi2dGo2nGu2xCk28Gq3GGg3RGm3bCs3lGi3wGo36Gt8JND49cF8zPnl8zdD4QKLyzUXjM47KlyGfj03/ABEeF/D0lWFjAAAAAElFTkSuQmCC"

/***/ }),

/***/ "0rFJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Poste.12db539.jpg";

/***/ }),

/***/ "0w8F":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.boxNt{\n\n  border-top: 3px solid #00897e;\n}\n.customNItem{\n\n  height: 60px!important;\n  border: 1px solid grey!important;\n  padding-top: 15px;\n  font-size: 20px;\n  background:white;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.seachMobButton {\n    padding: 0 !important;\n    height: 30px !important;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "1mNM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_NOTIFICATIONS; });
var ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS';
var GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2TQw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/calcBack.637a734.jpg";

/***/ }),

/***/ "2czj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc_condominio.e2a423d.jpg";

/***/ }),

/***/ "3/Hm":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-10101776] {\n  font-size: 26px;\n}\n.imageIcons[data-v-10101776] {\n\t\tvertical-align: bottom!important;\n\t\twidth: 50px;\n}\n.hSize[data-v-10101776] {\n    font-size: 33px!important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-10101776] {\n\t\tmax-width: 333px;\n\t\ttext-align: left;\n\t\tmargin: 0 auto;\n\t\tline-height: 27px;\n\t\tpadding-left: 61px;\n}\n\n\n\t/* new PRICE */\n.swal2-popup .swal2-title[data-v-10101776], #swal2-content[data-v-10101776] {\n\t\tcolor: #fffbde!important;\n\t\tdisplay: block!important;\n}\n.replaceButton[data-v-10101776]{\n\t\tmax-width: 40px;\n}\n.inputHelper[data-v-10101776]{\n    margin-top: -32px;\n    color: #0e3d8b;\n    font-size: 16px;\n    left: 0;\n}\n.priceVal[data-v-10101776], .priceCent[data-v-10101776]{\n\t\twidth: calc(50% - 1.5vw - 7.5px);\n\t\tdisplay: inline-table;\n}\n.pseudoEuro[data-v-10101776] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n}\n.pseudoCent[data-v-10101776] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n\t\tright:0;\n}\n.group input:focus + .pseudoEuro[data-v-10101776] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoEuro[data-v-10101776]{\n\t\tdisplay:block;\n}\n.group input:focus + .pseudoCent[data-v-10101776] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoCent[data-v-10101776]{\n\t\tdisplay:block;\n}\n.euroInput[data-v-10101776]{\n\t\tposition: relative;\n\t\twidth:200%;\n\t\tz-index: 4;\n}\n.euroInput[data-v-10101776]::before{\n\t\tcontent: 'Euro';\n}\n.euroInput[data-v-10101776]:focus, .euroInput.valid[data-v-10101776]{\n\t\twidth:100%;\n}\n.euroInput[data-v-10101776]:focus::before, .euroInput.valid[data-v-10101776]::before{\n\t\tcontent: 'Euro';\n\t\tcolor: white;\n\t\tposition: absolute;\n}\n.table[data-v-10101776]{\n\t\tdisplay: table;\n}\n.newPriceLabel[data-v-10101776]{\n\t\tz-index: 5;\n\t\tbackground: white;\n\t\tmargin-left: -5px;\n\t\tpadding-left: 5px;\n\t\toverflow: initial;\n\t\tmin-width: calc(200% + 17px);\n}\n\n\n\t/*  ------------ */\n.image-margin0[data-v-10101776]{\n\t\tmargin: 0!important;\n}\n.helper[data-v-10101776]{\n\t\tcolor: #0e3d8b;\n\t\tfont-size: 23px;\n\t\tfont-family: Oswald-Medium;\n}\n.greyDesc2[data-v-10101776]{\n\t\tfont-size: 1.1vw;\n\t\tcolor: #fffbde;\n}\n.redDesc[data-v-10101776]{\n\t\tfont-size: 1.1vw;\n\t\ttext-decoration: underline;\n\t\tcursor: pointer;\n}\n.uploadDone[data-v-10101776] {\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\tright: 0;\n\t\tcolor: #a1614f;\n}\n.helperUnderline[data-v-10101776] {\n}\n.labelFileInput[data-v-10101776]{\n\t\ttop: -20px!important;\n\t\tfont-size: 22px;\n\t\tcolor: #000000;\n}\n.fileInput[data-v-10101776]{\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\ttop: 17px;\n\t\tborder-bottom: none;\n\t\tcolor: #000000;\n}\n.fileInputLabel[data-v-10101776]{\n\t\tz-index: 3;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\tpadding-right: 20px;\n\t\ttext-overflow: ellipsis;\n\t\tcolor: #fffbde;\n}\n.removeProduct[data-v-10101776]{\n\t\tposition: absolute;\n\t\tright: 21px;\n\t\tmargin: 0px!important;\n\t\ttop: 48px;\n\t\tcolor: #e7201d;\n}\n.typeDisabled[data-v-10101776]{\n\t\tcolor: #676767;\n\t\tcursor: pointer;\n}\n.typeSelected[data-v-10101776] {\n\t\tcolor: #fffbde!important;\n\t\tcursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-10101776] {\n      margin-top: -12px;\n      color: #0e3d8b;\n      font-size: 16px;\n      left: 0;\n}\n.hSize[data-v-10101776] {\n      font-size: 19px!important;\n}\n.sweetText[data-v-10101776] {\n      font-size: 19px;\n}\n.removeProduct[data-v-10101776]{\n    position: absolute;\n    right: 21px;\n    margin: 0px!important;\n    top: 26px;\n    color: #e7201d;\n}\n.greyDesc2[data-v-10101776], .redDesc[data-v-10101776]{\n\t\t\tfont-size: 3.1vw;\n}\n.fluid[data-v-10101776] {\n\t\t\tmax-width: 107px;\n}\n.mobTQ[data-v-10101776]{\n\t\t\tfont-size: 23px;\n}\n.smMob[data-v-10101776]{\n\t\t\tfont-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-10101776] {\n\t\t\tmax-width: 350px;\n\t\t\ttext-align: left;\n\t\t\tmargin: 0 auto;\n\t\t\tline-height: 27px;\n\t\t\tpadding-left: 43px;\n\t\t\tfont-size: 17px;\n}\n.helper[data-v-10101776] {\n\t\t\tcolor: #0e3d8b;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: Oswald-Medium;\n}\n.imageIcons[data-v-10101776] {\n\t\t\tvertical-align: bottom!important;\n\t\t\twidth: 39px;\n}\n.fileInput[data-v-10101776] {\n\n\t\t\ttop: 8px!important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-10101776]{\n\t\t\t top: -250%;\n}\n}\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "3Dg/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact2.477dcdb.png";

/***/ }),

/***/ "3Gu/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.center-container[data-v-896ab43a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "3XyK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.table-striped[data-v-7191a0d4] {\n\toverflow-x: auto;\n\tdisplay: table;\n\tmax-height: 63vh;\n}\n.priceVal[data-v-7191a0d4], .priceCent[data-v-7191a0d4]{\n\twidth: calc(50% - 1.5vw - 7.5px);\n\tdisplay: inline-grid;\n}\n.pseudoEuro[data-v-7191a0d4] {\n\tposition: absolute;\n\ttop: 6px;\n}\n.pseudoCent[data-v-7191a0d4] {\n\tposition: absolute;\n\ttop: 6px;\n\tright:0;\n}\n.group input:focus + .pseudoEuro[data-v-7191a0d4] {\n\tdisplay:block;\n}\n.group .valid + .pseudoEuro[data-v-7191a0d4]{\n\tdisplay:block;\n}\n.group input:focus + .pseudoCent[data-v-7191a0d4] {\n\tdisplay:block;\n}\n.group .valid + .pseudoCent[data-v-7191a0d4]{\n\tdisplay:block;\n}\n.euroInput[data-v-7191a0d4]{\n\tposition: relative;\n\twidth:200%;\n\tz-index: 4;\n}\n.euroInput[data-v-7191a0d4]::before{\n\tcontent: 'Euro';\n}\n.euroInput[data-v-7191a0d4]:focus, .euroInput.valid[data-v-7191a0d4]{\n\twidth:100%;\n}\n.euroInput[data-v-7191a0d4]:focus::before, .euroInput.valid[data-v-7191a0d4]::before{\n\tcontent: 'Euro';\n\tcolor: #2b773c;\n\tposition: absolute;\n}\n.table[data-v-7191a0d4]{\n\tdisplay: table;\n}\n.priceVal[data-v-7191a0d4]{\n}\n.priceCent[data-v-7191a0d4]{\n}\n.labelFileInput[data-v-7191a0d4]{\n\ttop: -20px;\n\tfont-size: 14px;\n\tcolor: #d3a399;\n}\n.fileInput[data-v-7191a0d4]{\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 0;\n\ttop: 4px;\n\tborder-bottom: none;\n\tcolor: #000000;\n}\n.fileInputLabel[data-v-7191a0d4]{\n\tz-index: 3;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tpadding-right: 20px;\n\ttext-overflow: ellipsis;\n\tcolor: #fffbde;\n}\n.newPriceLabel[data-v-7191a0d4]{\n\tz-index: 5;\n\tbackground: #fcfcfc;\n\tmargin-left: -5px;\n\tpadding-left: 5px;\n\toverflow: initial;\n\tmin-width: calc(200% + 17px);\n}\n.formHeader[data-v-7191a0d4] {\n\tfont-size: 18px;\n\tbackground: #990033!important;\n\twidth: 100%;\n\tcolor: #ffffff!important;\n\ttext-transform: uppercase;\n\tfont-family: CoreRhino75Heavy;\n}\n.greyDesc[data-v-7191a0d4]{\n\tfont-size: 3vw;\n}\nimg.playVideoButton[data-v-7191a0d4] {\n\tmax-width: 200px;\n\tcursor: pointer;\n}\n.zindex1[data-v-7191a0d4]{\n\tz-index: 1;\n}\n.maxCertificate[data-v-7191a0d4]{\n\tmax-width: 130px;\n}\n.reflection[data-v-7191a0d4]{\n\tposition: absolute;\n\twidth: 20vw;\n\theight: 19vw;\n\ttop: -3%;\n\tright: 0%;\n\tborder-radius: 50%;\n\tbackground: radial-gradient(#ffffff59,#e7798985,#eee0,#eee0);\n\tz-index: 0;\n}\n.relative[data-v-7191a0d4]{\n\tposition: relative;\n}\n.cup4Shadow[data-v-7191a0d4]{\n\tposition: absolute;\n\theight: 40px;\n\tbackground: radial-gradient(#0e0e0ee0,#000000e3, #ffffff00, #f9f9f900);\n\tborder-radius: 50%;\n\twidth: 50%;\n\tright: 19%;\n\tbottom: 37.4%;\n\tz-index: 0;\n}\n.cup1Shadow[data-v-7191a0d4] {\n\tposition: absolute;\n\theight: 57px;\n\tbackground: radial-gradient(#0e0e0ec4,#ffc80024, #00000000, #38383845);\n\tborder-radius: 50%;\n\twidth: 67%;\n\tright: 24%;\n\tbottom: 35%;\n\tz-index: 1;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.greyDesc[data-v-7191a0d4]{\n\t\ttext-align: center;\n\t\tfont-size: 4vw;\n}\nimg.playVideoButton[data-v-7191a0d4] {\n\t\tposition: relative!important;\n\t\ttop: 0!important;\n\t\tmargin-top: 20px;\n}\n.maxCertificate[data-v-7191a0d4]{\n\t\tmax-width: 100px;\n}\n.reflection[data-v-7191a0d4] {\n\t\twidth: 73vw;\n\t\theight: 64vw;\n}\n.cup4Shadow[data-v-7191a0d4]{\n\t\theight: 57px;\n\t\twidth: 50vw;\n\t\tright: 18%;\n\t\tbottom: 36.4%;\n}\n.cup1Shadow[data-v-7191a0d4] {\n\t\theight: 74px;\n\t\twidth: 80%;\n\t\tright: 10%;\n\t\tbottom: 35%;\n}\n}\n\n\n", ""]);

// exports


/***/ }),

/***/ "3t9Z":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0w8F");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("75f5064f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c1f74d14\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c1f74d14\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "4AGf":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4GjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.5e8d5cb.jpg";

/***/ }),

/***/ "54oZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-415b2084] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-415b2084] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-415b2084] {\n  width: 75px;\n}\n.bigTitle[data-v-415b2084] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-415b2084] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-415b2084] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: .4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-415b2084] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-415b2084] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-415b2084] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-415b2084] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-415b2084] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-415b2084] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-415b2084] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-415b2084] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-415b2084] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-415b2084] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-415b2084] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-415b2084] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important;\n    left: 0;\n}\n.front-image > label > span[data-v-415b2084] {\n      background-color: #dee6ff;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: 1px solid white;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-415b2084]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-415b2084] {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-415b2084] {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n.front-image > label[data-v-415b2084]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-415b2084]:after {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-415b2084]:after {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-415b2084] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin-bottom: 40px !important;\n        margin: 0 auto !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-415b2084] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin-bottom: 40px !important !important;\n        margin: 0 auto !important;\n}\n}\n.center-container[data-v-415b2084] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "5uEW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/card.0fd5b53.png";

/***/ }),

/***/ "5vhL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/newHomeHSD.19bb7d0.jpg";

/***/ }),

/***/ "6A3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6PKJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6Z51":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6fPw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9Oa/");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5fa7d56d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6487464\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./practicesFinished.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6487464\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./practicesFinished.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7EV4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8C68");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("04110622", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38471c95\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38471c95\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7KbZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7N6W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7sA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__("gCMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4588f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__("l+T2");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("l+gf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4588f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-timepicker/src/vue-timepicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c4588f32", Component.options)
  } else {
    hotAPI.reload("data-v-c4588f32", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "879u":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("x/1t");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("82340ad2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-67f3a69c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-67f3a69c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "8C68":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-38471c95] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.customAccordion > dl > dt[data-v-38471c95] {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  padding: 0;\n  margin-bottom: 0;\n}\n.customAccordion > dl > dt > div > button > .badger-accordion-title[data-v-38471c95] {\n  -webkit-box-flex: 0 !important;\n      -ms-flex: 0 0 94% !important;\n          flex: 0 0 94% !important;\n}\n.customAccordion > dl > dt > div > button > .badger-toggle-indicator[data-v-38471c95] {\n  -webkit-box-flex: 0 !important;\n      -ms-flex: 0 0 6% !important;\n          flex: 0 0 6% !important;\n}\n.borderTop[data-v-38471c95] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-38471c95] {\n  width: 75px;\n}\n.bigTitle[data-v-38471c95] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-38471c95] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-38471c95] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-38471c95] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-38471c95] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-38471c95] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-38471c95] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-38471c95] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-38471c95] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image2[data-v-38471c95] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 29px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 100%;\n  margin-bottom: 0;\n  background: #00897e !important;\n  color: white;\n  border-radius: 5px;\n  overflow: hidden;\n  cursor: pointer;\n}\n@media screen and (max-width: 1024px) {\n.front-image2[data-v-38471c95] {\n      margin-top: 15px !important;\n}\n}\n.front-image2 > .fileInputLabel[data-v-38471c95] {\n    display: none;\n}\n.front-image2 > .invalid-feedback[data-v-38471c95] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image2 > input[data-v-38471c95] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 30px;\n    z-index: 10;\n    top: 0;\n    cursor: pointer !important;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 99;\n    /*This makes the button huge. If you want a bigger button, increase the font size*/\n    font-size: 50px;\n    /*Opacity settings for all browsers*/\n    opacity: 0;\n    -moz-opacity: 0;\n    filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);\n}\n.front-image2 > label[data-v-38471c95] {\n    /*display: none;*/\n    cursor: pointer;\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image2 > label > span[data-v-38471c95] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 100%;\n      margin-top: 0 !important;\n      display: block;\n      height: 29px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 0;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 19px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n      cursor: pointer;\n}\n.front-image2 > label > span[data-v-38471c95]:before {\n        cursor: pointer;\n        content: \"CARICA\";\n        font-family: Regular;\n        font-weight: 300 !important;\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 29px;\n        width: 100%;\n        border-radius: 7px;\n        padding-top: 3px;\n        font-size: 0.775rem !important;\n        font-weight: 600;\n        color: white;\n        border: 3px solid #00917e;\n        /*padding: .55rem .55rem !important;*/\n        font-size: 0.775rem !important;\n        line-height: 0.9 !important;\n        border-radius: 0.1rem !important;\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label > span[data-v-38471c95] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label > span[data-v-38471c95] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image2 > label[data-v-38471c95]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 100%;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      cursor: pointer;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-38471c95]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-38471c95]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-38471c95] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-38471c95] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.niceInputLabel2[data-v-38471c95] {\n  color: #ffffff !important;\n  font-size: 21px;\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  left: 0;\n  top: 0;\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-right: 0;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n.center-container[data-v-38471c95] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "8gwm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("K4Pf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("101a46a2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6428c8d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6428c8d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "8r3S":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAACkCAYAAAAZtYVBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA25pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo5ZTQyOTQ0ZC1jZDBmLTU3NDYtOGFkNS02ZGNlZjJlMGIzOTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6REQxMDREMDFBNDA1MTFFQjlDRDdCNkVENjAzRDYzRUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6REQxMDREMDBBNDA1MTFFQjlDRDdCNkVENjAzRDYzRUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEE4RDg3RkY4QkIxMTFFQkJFMkY4OEZGMjc2NzIzNTYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEE4RDg4MDA4QkIxMTFFQkJFMkY4OEZGMjc2NzIzNTYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz57qCopAAAMI0lEQVR42uydDZBWVRnHH9Z1KcBRgmaMzwWpWUVmnZxm4sugQBSYRqRFE0H50CQxviwiCakxaBpcGs0UcaWANCFwmkERDLFAmKbBWaIICJZl3YWpICGWtZWvnof7vPTu8n7c9773vffce/6/mb8L7It773N+3I9zzzm3TXV1NYEr6MDpxSlN+vppTmdOJ811nDacq/XzQiPnLOci5yTnBOe4fv0Xp5ZzOOlro+2FLi8vb/H7YrhHXTn9ObdybuHcxOmRh8gJPsXpneXzdZy9HDkq7OLs5DTY3Bg2CilHuxGcQZzBnJ4hbksPzR1Jf3aEs42znbNJj6YQMkZcxRnKGcm5k1Nm+Pb21Nyvv9/H2ch5k7OVcx5CRlPC2zj3cO7W67+oUqaZpdej6zivcf4QRznjJqQcWaZwJnG6xfAfmtxUfUNTz1nBqdLTfCwoisE+yJ3uKM5bnBrO92MqY2u66b7W6L6P0lpAyJBoq0fDv3A26I1KEdlHke77Bq3FFK0NhAyIEs5jemR4iZxuGuBwk9akRmvUFkIWDumAfphzkPMMpwv8S0sXrdHftWYlENJfxpDTgbyM0x2+uaa71uyvWkMImSfS3bGZs57TB355po/WUGp5I4T0dp24gLObMxw++YbUUh5TPmnqadxEIeW58vucH0Tp2idiN4ULtcYDIGTmm5bF5DzD7QtvCo7UeJvW/GoI2ZLPcd7jfJfs7EsMs/2l5ju1DSAkOYMI5PTxBfgRGrdqG0ywWUg5TUhf2SpOezgROtIGKznPhnkKD0vI68kZSvUYPDCO6do219sipFxM/5EzEG1vLAO1jW6Ou5DD9OalB9rceKSNtmubxVLI8eSMer4WbR0ZrtU2Gx83IeUB/y/JoP4ukNPN50ptw1gIKUPvXyBnWgGIJkXahrOiLuRMTiXFYCQzuNSGldqmkRTyId0BEC8qtW0jJeR9nOdxZIztkfL5Qt3oFELIL5MzGw7XjPFF2vZlbWujhexHzkBQDBuLPyXa1v1MFVLmcaCf0S4S/ZRdTBNS/rWsITvmQ4OWdNO2LzFJyCWEZ9M2I23/tClCTiSM2gHOKKGJYQtZpl0AAJC6cGNYQsqqCL/mtEM7AEVceJXyWDEjHyGf4pSjDUArytWNQIWU6ZOzUXuQhtnkcYqtFyHlcLycMDsQZPZquZdTtxepZNokVhwD2RBH5hVayDIvPwRYyzzKcU33XIWspAgvhgkCR57eLC2UkIm3GACQC/LKk1F+CynzKp5GbYFHlpDL+VRuhZxE5r/fBZiLuDPZLyHlmnE+agryZL6b+w83Qsr8CSyjDPJFhqk9nK+QJYRuHuAf87IdJbMJKcuz4W0HwC8+Q1mGqGUSUmaX4Xk18JuZlGE2aiYhpf8IjwiB34hTI70I+S3UDhSI6bkKKW9VvR11AwVC3CrNRcgphOFloHCIW5PdCimrEkxCzUCBmUwpVjdJJeSXCPOrQeHpyhniRshxqBUIiIpsQhZzxqJOICDG7t69uziTkHII7Yw6gYAQ14ZmEnI0agQCZnQmIUegPiBgbk8nZG/CIFwQPGV8HXlDKiHxZAaExfBUQg5GXUBIDE4l5ICobP3Fixepvq4WzZiGutoaOnfuXJQ2eWBrIeXJTGkUtry5uZlmTZtAC783g2oO7od9rZCa/HD+LJpYMYI+qDsclc3uydeR3ZKF7B+FrT54YC9Nunck/fMfx6jpTCMtWvgdSNlKRqmJ1EaYO2Mq/ebVX0Rl8/snC2n0snpyiq56YSktmNtyoV5ImV7GBOvXrKI5jz4QhVN4ebKQ/UzdyqamM/TIg2Npy6YNqb8PKdPKmODY0fpLp/CjDXUm70Y/44V8/087aer4r9Lp/5zKLK3FUmaTMZnHp0+i3657xXghO5h4Q7Nz+7u0ZJH79QlslDIXGRO8troq7dkmZHrxjc01ImQvMvCdhP0HDaGK+3IbJ2yTlF5kFCq+/iB9ZYSxQxZ6JYQ0kjEV90NKn2UcM26CybtmtpCQ0ioZhdIiikCHOKS0QsbLQkZiqRTbpbRARqGbCBmZEeK2SmmJjEInEbJjlLbYNik9y8g1ipiMQsfICWmTlHnJyDWKINeJkJ+I4pbHXUoLZRTaiZCfjOrWe5byyW8bLaWlMgptRchIr+HjScqmM8ZKabGMwlUi4zVR34u4SGm5jEKH2KxwFnUpIaODCHkaUoYrJWS8TKMIeSFOexQ1KSFjC86LkP+N215FRUrIeAXNIuRHcdwz06WEjKmbQIQ8Gde9M1VKyJiWkyLkv+O8h6ZJCRkz8qEIeTzue2mKlJAxKydEyKM27GnYUkJGV9SLkLW27G1YUkJG19RaJWQYUkLG3IWssW2vg5ISMno/Ql6ElP5KCRm9Xd0knmXX2rj3hZLykoz8GciY29GxvLz8dGK0zx5bq+C3lJdl5M9Axpz4s/zHeiH9lBIy5sWeZCF3216NfKWEjP4cIdtUV1fLV1lO9wPUhOj1tatp7Ssrcvo77dq1vywoZPRMd76GrE8cIes5R1AT70dKyJgXR0TG5FO28B7q4l1KyJgXOxK/SBZyG+pSeCkhY0q2pRLybdTlSinHjZ8MGQvP5lRCHuLsQ21actfXxvsiJWRMy36+fjyUSsgWpgL/pISMGdmU/JvWQm5AffyVEjJmZUMmIbeSBSPIg5ISMmbluDqXVkh53dM61Cl/KSGjK9bz9eO5TEIKa1Gn/KSEjK5Z0/oPUgn5LqcBtfImJWR0TYO6llXI85yXUa/cpYSMObFCXWtBcZoPi5BPUMTXjgxKSkHeWAsZXSPrSVWl+kY6IWvJ6ZO8A7VzLyVwzWZKM0sh0xHwWdQNFIifpftGJiE3cvaidsBnxKk3vQgpMxGXon7AZ35KGWa5ZrtpWUmWLLUCAuEYZ1WmD2QT8mPOj1FH4BOLKcsCuW66dV4kzLcB+SNTFJZn+5AbIZs5P0I9QZ48RS6WD3fb8S0d5Ri8C7yyn1w+/XMr5FnO46gr8Mgcdcg3IYU3OG+htiBHNqk75LeQwiy98wbADeLKzFz+Qq5C7tNbdwDcsDjXe48ijz8EjxRBNvZ6OXh5EVK6gR6imL2SDvjKBXWkOQghBVn6ohJ1B2mopKTlUYIQUphPuoQaAEnsUTcoaCHlcHwvpwltABRx4R4vp2o/hBT+xpmGdgDKNHWCwhJSkCFqz6EtrOc5dYHCFlKYTVhf0mZ2qANkipDSIz+OnCFGwC6kzSvIpyd4fk5zlZHlIzmn0EbWcErb3LdZBX7Pu5Zb/rsJz7tt4GNta19fKVOIhQDe4chyDufRZrHlgrbxO37/jwu1MsWvON8kC9+haAHSptO0jSkqQgoyF2cO2i92zNG2pagJKSzVHcCRMh5HxjlU4Ln6QSwmVamHeIwOivY14zQKYEBNUKubLeM8QC7nVQCjOKtttyyIHxbkcnurOaMI/ZRRQtpqtLYdxU1IQV7ONJhTh7Y2njptq0BfFRPGgqTSkfpF8jiAEwTCDm2jwN+jHtYKubLo0BDCKCET+TlnqLYR2SJk4mJ5OmciYZCvCTTpzcujFOKjXxPWEJfl2T7P2QUnQmOXtsHKsDfElEXtZe2X/uQs/Yf+yuCQWv9Ea7/fhA0y6S0Lcgqfx7mNcwCuFJwDWuu5ZFD/sImv/ZCR57eQswQghrH5j9R0kdbYuFH+pr6H5iNyplJK0X4Hh3xji9b0Ca0xQcjckBlsw8kZCHoQPnnmoNZwGOU5K9B2IRO8zunLeYSwvHQu1GvN+moNjSdKr46Tax95wP9ZzgzC2yEycUxr1EdrFplr8Si+y1BWRXiG05szlbASWzJ7tSa9tEbNUduBKL9cU4otL3C8mZwRKbJSq419mBd030drLaqiKGKC4hg0iIxkfkPTkzOFnAlIXWMu4lGVT3IkLjsVt9cPS8MsUDGH6fXT8Rjtn+zLi7pvPXRfj8SpAYspnsgU3C0aGcAho1fu1JRFbF9kSeSNmq2cc3E+7BdT/JEGfFsj68+UckaQ89hskB5pTEIGxsoTlN/rtWGtTRfExWQftXoqT8wRkWvNAeQ8weinKQ1wW/ZoqskZGNtgczdBMQERYK0mQQfODSqmRLpROnM6JaWjfraE015/fYb+3+f3IedEUuT677BKKDnEaUT5W/I/AQYA9uSly8w8hUwAAAAASUVORK5CYII="

/***/ }),

/***/ "98bG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("pWsl");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("23c4de96", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bcfb22e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bcfb22e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9Oa/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.csHeight2[data-v-f6487464]{\n    min-height: 52vh!important;\n}\n.selectListBox[data-v-f6487464] {\n  background: #d4ebe9;\n  border: 1px solid grey;\n  padding: 3%;\n  max-height: 254px;\n  height: 254px;\n  overflow-y: scroll;\n  -webkit-transition: all .1s;\n  transition: all .1s;\n}\n.borderTop[data-v-f6487464]{\n  border-top: 1px solid lightgrey!important;\n}\n.borderTop2[data-v-f6487464]{\n  border-top: 1px solid lightgrey;\n}\n.lightYellow[data-v-f6487464] {\n  background:   #f393241c\n}\n.custLabelFontSize[data-v-f6487464]{\n    font-size: 14px;\n}\n.selectBlock[data-v-f6487464]{\n    background: #eeeeee;\n    border: 1px solid #a5a5a5;\n    border-top: none;\n}\n.blockActive[data-v-f6487464]{\n    background: white;\n    border-bottom: none!important;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "9fMG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.component-badger-accordion .badger-accordion__panel {\n  max-height: 0;\n}\n.badger-accordion__panel {\n  max-height: 75vh;\n  overflow: hidden;\n}\n.badger-accordion__panel.-ba-is-hidden {\n    max-height: 0 !important;\n}\n.badger-accordion--initialized .badger-accordion__panel {\n  -webkit-transition: max-height ease-in-out 0.2s;\n  transition: max-height ease-in-out 0.2s;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle {\n  width: 100%;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-accordion-title {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 90%;\n            flex: 0 0 90%;\n    cursor: pointer;\n    text-align: left;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-toggle-indicator {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 10%;\n            flex: 0 0 10%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "9pkI":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dPwX");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7832977b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-648fb19c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-648fb19c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9x6x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/traficLight_green.b87a01f.png";

/***/ }),

/***/ "AEYR":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.vaillantCont[data-v-0d25b78e] {\r\n  height: 100%;\n}\n.wa_icon[data-v-0d25b78e]{\r\n  max-width: 40px;\r\n  margin-top: -11px;\n}\r\n\r\n", ""]);

// exports


/***/ }),

/***/ "AaPU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.select-checkbox, .select-all-checkbox {\n  cursor: pointer;\n}\n.vdtnet-footer .dataTables_length {\n  padding-top: 6px;\n  padding-right: 10px;\n}\n.vdtnet-footer .dataTables_length, .vdtnet-footer .dataTables_paginate {\n  float: right;\n}\n.hide-footer .vdtnet-footer {\n  display: none;\n}\n.master .details-plus\n{\n  cursor: pointer;\n  display: none;\n}\n.details-minus\n{\n  cursor: pointer;\n  display: none;\n}\n.master .details-minus\n{\n  cursor: pointer;\n  display: inline;\n}\n.details-control {\n  cursor: pointer;\n  font-weight: 700;\n}\n", ""]);

// exports


/***/ }),

/***/ "AiJu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("tv1e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6397c808", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4e3aaf92\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4e3aaf92\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "BBef":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-4359101c] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-4359101c] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-4359101c] {\n  width: 75px;\n}\n.bigTitle[data-v-4359101c] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-4359101c] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-4359101c] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-4359101c] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-4359101c] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-4359101c] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-4359101c] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-4359101c] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-4359101c] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-4359101c] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-4359101c] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-4359101c] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-4359101c] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-4359101c] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-4359101c] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-4359101c] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-4359101c]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-4359101c] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-4359101c] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-4359101c]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-4359101c]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-4359101c]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-4359101c] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-4359101c] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.front-image2[data-v-4359101c] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 29px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 100%;\n  margin-bottom: 0;\n  background: #00897e !important;\n  color: white;\n  border-radius: 5px;\n  overflow: hidden;\n  cursor: pointer;\n}\n@media screen and (max-width: 1024px) {\n.front-image2[data-v-4359101c] {\n      margin-top: 15px !important;\n}\n}\n.front-image2 > .fileInputLabel[data-v-4359101c] {\n    display: none;\n}\n.front-image2 > .invalid-feedback[data-v-4359101c] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image2 > input[data-v-4359101c] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 30px;\n    z-index: 10;\n    top: 0;\n    cursor: pointer !important;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 99;\n    /*This makes the button huge. If you want a bigger button, increase the font size*/\n    font-size: 50px;\n    /*Opacity settings for all browsers*/\n    opacity: 0;\n    -moz-opacity: 0;\n    filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);\n}\n.front-image2 > label[data-v-4359101c] {\n    /*display: none;*/\n    cursor: pointer;\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image2 > label > span[data-v-4359101c] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 100%;\n      margin-top: 0 !important;\n      display: block;\n      height: 29px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 0;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 19px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n      cursor: pointer;\n}\n.front-image2 > label > span[data-v-4359101c]:before {\n        cursor: pointer;\n        content: \"CARICA\";\n        font-family: Regular;\n        font-weight: 300 !important;\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 29px;\n        width: 100%;\n        border-radius: 7px;\n        padding-top: 3px;\n        font-size: 0.775rem !important;\n        font-weight: 600;\n        color: white;\n        border: 3px solid #00917e;\n        /*padding: .55rem .55rem !important;*/\n        font-size: 0.775rem !important;\n        line-height: 0.9 !important;\n        border-radius: 0.1rem !important;\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label > span[data-v-4359101c] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label > span[data-v-4359101c] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image2 > label[data-v-4359101c]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 100%;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      cursor: pointer;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-4359101c]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-4359101c]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-4359101c] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-4359101c] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.niceInputLabel2[data-v-4359101c] {\n  color: #ffffff !important;\n  font-size: 21px;\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  left: 0;\n  top: 0;\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-right: 0;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n.center-container[data-v-4359101c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "CCTN":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ftX1");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("468bddf0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-baeb6964\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./login.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-baeb6964\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "CXbD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "CufG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("YABF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0d0304ea", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e4b69a2e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e4b69a2e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Cz55":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Gu8a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0cef7764", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5414bf37\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5414bf37\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DaEW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "DjRw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3XyK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1c38b49d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7191a0d4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7191a0d4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DydT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mainBack2.0d1c67d.jpg";

/***/ }),

/***/ "FIF3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/servicesBack.89ca335.jpg";

/***/ }),

/***/ "FMAQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var myUniqueId = 1;

var compiler = __webpack_require__("p255");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VdtnetTable',
  props: {
    /**
     * The table id
     *
     * @type String
     */
    id: {
      type: String,
      default: null
    },
    /**
     * The table id
     *
     * @type String
     */
    url: {
      type: String,
      default: null
    },
    /**
     * Set the container classes.
     *
     * @type String
     */
    containerClassName: {
      type: String,
      default: 'table-responsive d-print-inline'
    },
    /**
     * Set the table classes you wish to use, default with bootstrap4
     * but you can override with: themeforest, foundation, etc..
     *
     * @type String
     */
    className: {
      type: String,
      default: 'table mt-0 table-striped table-borderless nowrap w-100'
    },
    /**
     * the options object: https://datatables.net/manual/options
     *
     * @type Object
     */
    opts: {
      type: Object
    },
    /**
     * List all fields to be converted to opts columns
     *
     * @type Object
     */
    fields: {
      type: Object
    },
    /**
     * Pass in DataTables.Net jQuery to resolve any conflict from
     * multiple jQuery loaded in the browser
     *
     * @type Object
     */
    jquery: {
      type: Object
    },
    /**
     * Pass in Vue to resolve any conflict from multiple loaded
     *
     * @type Object
     */
    vue: {
      type: Object
    },
    /**
     * The select-checkbox column index (start at 1)
     * Current implementation require datatables.net-select
     *
     * @type Number
     */
    selectCheckbox: {
      type: Number
    },
    /**
     * Provide custom local data loading.  Warning: this option has not been
     * thoroughly tested.  Please use ajax and serverSide instead.
     *
     * @type Function
     */
    dataLoader: {
      type: Function
    },
    /**
     * true to hide the footer of the table
     *
     * @type Boolean
     */
    hideFooter: {
      type: Boolean
    },
    /**
     * The details column configuration of master/details.
     *
     * @type {Object}
     */
    details: {
      type: Object
    }
  },
  data: function data() {
    // initialize defaults
    return {
      tableId: null,
      fieldsNew: {},
      options: {
        /*eslint-disable */
        dom: "tr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",
        /*eslint-enable */
        columns: [],
        language: {
          emptyTable: "La tabella non contiene informazioni",
          info: "Visualizzazione da _START_ a _END_ di _TOTAL_ righe totali",
          infoEmpty: "Visualizzazione da  0 a 0 di 0 righe totali",
          infoFiltered: "(dati filtrati da _MAX_ record totali)",
          lengthMenu: " _MENU_ Mostra righe",
          loadingRecords: "Sto caricando ...",
          processing: "Processing...",
          search: "Cerca:",
          searchPlaceholder: "Scrivi e premi INVIO...",
          zeroRecords: "Nessun record trovato",
          paginate: {
            first: "Prima",
            last: "Ultima",
            next: "Successiva",
            previous: "Precedente"
          }
        },
        lengthMenu: [[-1, 5, 10, 15, 20], ['All', 5, 10, 15, 20]],
        pageLength: 1000,
        buttons: [] // remove any button defaults
      },
      dataTable: null,
      vdtnet: this
    };
  },

  computed: {
    jq: function jq() {
      return this.jquery || __webpack_provided_window_dot_jQuery;
    },
    myVue: function myVue() {
      return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */] || window.Vue;
    },
    classes: function classes() {
      var that = this;
      var classes = that.containerClassName + ' vdtnet-container';
      if (this.hideFooter) {
        classes += ' hide-footer';
      }

      return classes;
    }
  },
  created: function created() {
    var that = this;
    var jq = that.jq;
    that.tableId = that.id || 'vdtnetable' + myUniqueId++;

    // allow user to override default options
    if (that.opts) {
      that.options = jq.extend({}, that.options, that.opts);
    }
  },
  beforeMount: function beforeMount() {
    var url = this.url;

    //this.loadRegistrationData()
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var that, jq, $el, orders, startCol, icol, fields, cols, k, field, _col, col, _col2, renderFunc;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _this;
              jq = that.jq;
              $el = jq(that.$refs.table);
              orders = [];
              startCol = 0;
              icol = 0;

              // if fields are passed in, generate column definition
              // from our custom fields schema

              console.log('I AM START WAITIIIIING');
              //await this.loadRegistrationData()
              console.log('OK FINISH WAITIIIIING');
              if (that.fieldsNew) {
                fields = that.fields;
                cols = that.options.columns;


                for (k in fields) {
                  field = fields[k];

                  field.name = field.name || k;

                  // disable search and sort for local field
                  if (field.isLocal) {
                    field.searchable = false;
                    field.sortable = false;
                  }

                  // generate
                  _col = {
                    title: field.label || field.name,
                    data: field.data || field.name,
                    width: field.width,
                    name: field.name,
                    className: field.className,
                    index: field.index || icol + 1
                  };


                  if (field.width) {
                    _col.width = field.width;
                  }

                  if (field.hasOwnProperty('defaultContent')) {
                    _col.defaultContent = field.defaultContent;
                  }

                  if (field.hasOwnProperty('sortable')) {
                    _col.orderable = field.sortable;
                  }

                  if (field.hasOwnProperty('visible')) {
                    _col.visible = field.visible;
                  }

                  if (field.hasOwnProperty('searchable')) {
                    _col.searchable = field.searchable;
                  }

                  if (field.template || that.$scopedSlots[field.name]) {
                    field.render = that.compileTemplate(field, that.$scopedSlots[field.name]);
                  }

                  if (field.render) {
                    if (!field.render.templated) {
                      (function () {
                        var myRender = field.render;
                        field.render = function () {
                          return myRender.apply(that, Array.prototype.slice.call(arguments));
                        };
                      })();
                    }

                    _col.render = field.render;
                  }

                  // console.log(col)
                  cols.push(_col);

                  if (field.defaultOrder) {
                    orders.push([icol, field.defaultOrder]);
                  }

                  icol++;
                }

                // sort columns
                cols = cols.sort(function (a, b) {
                  return a.index - b.index;
                });
              }

              // apply orders calculated from above
              that.options.order = that.options.order || orders;

              if (that.selectCheckbox) {
                that.selectCheckbox = that.selectCheckbox || 1;

                // create checkbox column
                col = {
                  orderable: false,
                  searchable: false,
                  name: '_select_checkbox',
                  className: 'select-checkbox d-print-none',
                  data: null,
                  defaultContent: '',
                  title: '<input type="checkbox" class="select-all-checkbox d-print-none">',
                  index: that.selectCheckbox - 1
                };

                that.options.columns.splice(that.selectCheckbox - 1, 0, col);

                // console.log(that.options.columns)
                that.options.select = jq.extend(that.options.select || {}, {
                  style: 'os',
                  selector: 'td.select-checkbox'
                });

                if (that.selectCheckbox === 1) {
                  startCol++;
                }
              }

              // handle master details
              if (that.details) {
                that.details.index = that.details.index || 1;

                // create details column
                _col2 = {
                  orderable: false,
                  searchable: false,
                  name: '_details_control',
                  className: 'details-control d-print-none',
                  data: null,
                  defaultContent: that.details.icons || '<span class="details-plus" title="Show details">+</span><span class="details-minus" title="Hide details">-</span>',
                  index: that.details.index - 1
                };

                that.options.columns.splice(that.details.index - 1, 0, _col2);

                if (that.details.index === 1) {
                  startCol++;
                }
              }

              if (startCol > 0) {
                if (that.options.order) {
                  that.options.order.forEach(function (v) {
                    v[0] += startCol;
                  });
                } else {
                  that.options.order = [[startCol, 'asc']];
                }
              }

              // handle local data loader
              if (that.dataLoader) {
                delete that.options.ajax;
                that.options.serverSide = false;
              }

              // you can access and update the that.options and $el here before we create the DataTable


              that.$emit('table-creating', that, $el);

              that.dataTable = $el.DataTable(that.options);

              if (that.selectCheckbox) {
                // handle select all checkbox
                $el.on('click', 'th input.select-all-checkbox', function (e) {
                  if (jq(e.target).is(':checked')) {
                    that.dataTable.rows().select();
                  } else {
                    that.dataTable.rows().deselect();
                  }
                });

                // handle individual row select events
                that.dataTable.on('select deselect', function () {
                  var $input = $el.find('th input.select-all-checkbox');
                  if (that.dataTable.rows({
                    selected: true
                  }).count() !== that.dataTable.rows().count()) {
                    jq('th.select-checkbox').removeClass('selected');
                    $input.attr('checked', false);
                  } else {
                    jq('th.select-checkbox').addClass('selected');
                    $input.attr('checked', true);
                  }
                  // TODO: that.$emit the selected row?
                });
              }

              // wire up edit, delete, and/or action buttons
              $el.on('click', '[data-action]', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var target = jq(e.target);
                var action = target.attr('data-action');
                while (!action) {
                  // don't let it propagate outside of container
                  if (target.hasClass('vdtnet-container') || target.prop('tagName') === 'table') {
                    // no action, simply exit
                    return;
                  }
                  target = target.parent();
                  action = target.attr('data-action');
                }

                // only emit if there is action
                if (action) {
                  // detect if row action
                  console.log(action);

                  var tr = target.closest('tr');

                  if (action == 'link') {

                    // BIND ROUTER PATH AND URL **********************************************************************************

                    var par = that.url;
                    par = par.replace("https://wsbot.eu/21005back/public/" + 'api/loadProducts?id=', "");

                    if (tr.attr('role') !== 'row') {
                      tr = tr.prev();
                    }
                    var row1 = that.dataTable.row(tr);
                    var data1 = row1.data();

                    _this.$router.push({
                      name: 'addDocuments',
                      params: { id: par, data: data1 }
                    });

                    // BIND ROUTER PATH AND URL **********************************************************************************
                  }

                  if (tr) {
                    if (tr.attr('role') !== 'row') {
                      tr = tr.prev();
                    }
                    var row = that.dataTable.row(tr);
                    var data = row.data();
                    that.$emit(action, data, row, tr, target);
                  } else {
                    // not a row click, must be other kind of action
                    // such as bulk, csv, pdf, etc...
                    if (action == 'link') {} else {
                      that.$emit(action, null, null, null, target);
                    }
                  }
                }
              });

              // handle master/details
              if (that.details) {
                // default to render function
                renderFunc = that.details.render;

                // must be string template

                if (that.details.template || that.$scopedSlots['_details']) {
                  renderFunc = that.compileTemplate(that.details, that.$scopedSlots['_details']);
                } else if (renderFunc) {
                  renderFunc = function renderFunc() {
                    return that.details.render.apply(that, Array.prototype.slice.call(arguments));
                  };
                }

                // handle master/details
                // Add event listener for opening and closing details
                $el.on('click', 'td.details-control', function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  var target = jq(e.target);
                  var tr = target.closest('tr');
                  if (tr.attr('role') !== 'row') {
                    tr = tr.prev();
                  }
                  var row = that.dataTable.row(tr);
                  if (row.child.isShown()) {
                    // This row is already open - close it
                    row.child.hide();
                    tr.removeClass('master');
                  } else {
                    // Open this row
                    var data = row.data();
                    row.child(renderFunc(data, 'child', row, tr)).show();
                    tr.addClass('master');
                  }
                });
              }

              // handle master/Search on specific field
              // Add event listener for all search fields
              $el.on('keyup', '.footSearch', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var target = jq(e.target);
                if (e.keyCode == 13) {
                  console.log('Enter was pressed');
                  var fieldK = jq(target).data('field');
                  console.log(fieldK);
                  console.log(that.dataTable);
                  that.dataTable.columns(fieldK).search(target[0].value);
                  that.dataTable.draw();
                }
              });

              that.$emit('table-created', that);

              // finally, load data
              if (that.dataLoader) {
                that.reload();
              }

              console.log('BEFORE CREATE FOOTER ################################');

              // CREATE FOOTER
              jq('.dataTable thead tr').each(function (e) {
                var elemX = this;
                if (jq(elemX).html() != '') {
                  var k = 0;
                  jq(elemX).children('th').each(function (e) {
                    if (k != 500) {
                      var title = jq(this).text();
                      var style = jq(this).attr("style");
                      console.log(title);

                      jq('thead').append('<th><input class="footSearch p-0 m-0 center" type="text" data-field="' + k + '" rows="3" style="' + style + 'min-width:70px;" placeholder="Cerca" /></th>');
                    } else {
                      jq('thead').append('<th></th>');
                    }
                    k++;
                  });
                }
              });

              console.log('END CREATE FOOTER ################################');

            case 25:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    var that = this;
    if (that.dataTable) {
      that.dataTable.destroy(true);
    }

    that.dataTable = null;
  },

  methods: {
    loadRegistrationData: function loadRegistrationData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _vue, fields, data, l;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _vue = _this2;
                fields = {};
                data = { getFieldsNames: true };
                l = _this2.url;
                fields = {
                  confirmed: {
                    label: 'Esito',
                    sortable: true,
                    searchable: false,
                    render: function render(data, display, row) {

                      if (data == 0) {
                        return ' In Verifica ';
                      }

                      if (data == 1) {
                        return ' Approvato ';
                      }

                      if (data == 2) {
                        return ' Respinto <br/> <small> ' + row.confirm_info + '</small>';
                      }
                    }
                  },

                  azienda: { label: 'Azienda', sortable: true, searchable: true },
                  partita_iva: { label: 'Partita IVA', sortable: true, searchable: true },
                  codice_fiscale: { label: 'Codice Fiscale', sortable: true, searchable: true },

                  barcode: {
                    label: 'Matricola',
                    sortable: true,
                    searchable: true,
                    render: function render(data, display, row) {
                      return ' <a class="simpleLink green" target="_blank" href="' + row.image + '"> <small>' + data + '</small> </a> ';
                    }
                  },
                  product: { label: 'Prodotto', sortable: true, searchable: true },

                  invoice_number: {
                    label: 'Prova d`acquisto',
                    sortable: true,
                    searchable: true,
                    render: function render(data, display, row) {
                      return ' <a class="simpleLink green" target="_blank" href="' + row.invoice + '"> <small>' + data + '</small> </a> ';
                    }
                  },

                  invoice_date: { label: 'Data Doc.', sortable: true, searchable: true }

                };


                _vue.fieldsNew = fields;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    /**
     * Vue.compile a template string and return the compiled function
     *
     * @param  {Object} object with template property
     * @param  {Object} the slot
     * @return {Function}          the compiled template function
     */
    compileTemplate: function compileTemplate(field, slot) {
      var that = this;
      var jq = that.jq;
      var vue = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */];
      var res = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].compile('<div>' + (field.template || '') + '</div>');

      var renderFunc = function renderFunc(data, type, row, meta) {
        var myRender = res.render;

        if (slot) {
          console.log(slot);
          myRender = function myRender(createElement) {
            return createElement('div', [slot({
              data: data,
              type: type,
              row: row,
              meta: meta,
              vdtnet: that,
              def: field,
              comp: that.$parent
            })]);
          };
        }

        var comp = new vue({
          data: {
            data: data,
            type: type,
            row: row,
            meta: meta,
            vdtnet: that,
            def: field,
            comp: that.$parent
          },
          render: myRender,
          staticRenderFns: res.staticRenderFns
        }).$mount();
        return jq(comp.$el).html();
      };

      renderFunc.templated = true;

      return renderFunc;
    },

    /**
     * Set table data array that was loaded from somewhere else
     * This method allow for local setting of data; though, it
     * is recommended to use ajax instead of this.
     *
     * @param {Array} data   the array of data
     * @return {Object}            the component
     */
    setTableData: function setTableData(data) {
      var that = this;
      if (data.constructor === Array) {
        that.dataTable.clear().rows.add(data);
        that.dataTable.draw(false);
        that.dataTable.columns.adjust();
      }
      return that;
    },

    /**
     * pass through reload method
     *
     * @param  {Boolean}  resetPaging true to reset current page position
     * @return {Object}            the component
     */
    reload: function reload() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var that = this;
      if (that.dataLoader) {
        // manual data loading
        that.dataLoader(function (data) {
          if (data && !data.data) {
            data = { data: data };
          }
          that.setTableData(data.data);

          that.$emit('reloaded', data, that);
        });
      } else {
        that.dataTable.ajax.reload(function (data) {
          that.$emit('reloaded', data, that);
        }, resetPaging);
      }

      return that;
    },
    search: function search(value) {
      var that = this;
      that.dataTable.search(value).draw();

      return that;
    },
    setPageLength: function setPageLength(value) {
      var that = this;
      that.dataTable.page.len(value);

      return that.reload();
    },
    getServerParams: function getServerParams() {
      if (this.dataLoader) {
        return {};
      }

      return this.dataTable.ajax.params();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "FiR5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc_singola.b9000bb.jpg";

/***/ }),

/***/ "Fp4o":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n@media (min-width: 20px) and (max-width: 767px) {\n.seachMobButton {\n    padding: 0 !important;\n    height: 30px !important;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "Gu8a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-5414bf37] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-5414bf37] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-5414bf37] {\n  width: 75px;\n}\n.bigTitle[data-v-5414bf37] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-5414bf37] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-5414bf37] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-5414bf37] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-5414bf37] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-5414bf37] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-5414bf37] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-5414bf37] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-5414bf37] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-5414bf37] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 177px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-5414bf37] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-5414bf37] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-5414bf37] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-5414bf37] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-5414bf37] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-5414bf37] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-5414bf37]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-5414bf37] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-5414bf37] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-5414bf37]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-5414bf37]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-5414bf37]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-5414bf37] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-5414bf37] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-5414bf37] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "H0mA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.timeElement[data-v-0de2e1c8] {\n  background: white;\n  color: #eb6608;\n  padding: 18px;\n  width: 64px;\n  height: 64px;\n  font-size: 20px;\n  border-radius: 7px;\n  font-family: Bold;\n}\n.headerLogo[data-v-0de2e1c8] {\n  max-width: 115px;\n}\n@media screen and (max-width: 667px) {\n.headerLogo[data-v-0de2e1c8] {\n      max-width: 70px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.headerLogo[data-v-0de2e1c8] {\n      max-width: 100px;\n}\n}\n.coca-logo[data-v-0de2e1c8] {\n  top: -5px;\n  height: 40px;\n  position: relative;\n}\n@media screen and (max-width: 667px) {\n.coca-logo[data-v-0de2e1c8] {\n      height: 20px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.coca-logo[data-v-0de2e1c8] {\n      height: 23px;\n}\n}\n.ce-logo[data-v-0de2e1c8] {\n  top: -15px;\n  height: 65px;\n  position: relative;\n}\n@media screen and (max-width: 667px) {\n.ce-logo[data-v-0de2e1c8] {\n      top: -7px;\n      height: 37px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.ce-logo[data-v-0de2e1c8] {\n      top: -7px;\n      height: 37px;\n}\n}\n.mainFont[data-v-0de2e1c8] {\n  font-size: 14px;\n}\n.big-red[data-v-0de2e1c8] {\n  font-family: 'Gotham Rounded', sans-serif;\n  font-weight: bold;\n  font-size: 26px;\n  color: #E30613;\n}\n@media screen and (max-width: 667px) {\n.big-red[data-v-0de2e1c8] {\n      font-size: 14px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.big-red[data-v-0de2e1c8] {\n      font-size: 16px;\n}\n}\n.main[data-v-0de2e1c8] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-position: 0% 50% !important;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n", ""]);

// exports


/***/ }),

/***/ "HJqQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("q2xu"), "");
exports.i(__webpack_require__("bYAS"), "");

// module
exports.push([module.i, "\n\n", ""]);

// exports


/***/ }),

/***/ "IM0E":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/store/actions/user.js
var actions_user = __webpack_require__("yLEp");

// EXTERNAL MODULE: ./src/store/actions/auth.js
var auth = __webpack_require__("+4WN");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/store/modules/user.js


var _actions, _mutations;





var user_state = { status: '', profile: {}, user_paid: false, defaultShipData: {}, checkAge: localStorage.getItem('checkAge') || false, acceptCookies: localStorage.getItem('acceptCookies') || false };

var getters = {
  getProfile: function getProfile(state) {
    return state.profile;
  },
  userPaid: function userPaid(state) {
    return state.user_paid;
  },
  getDefaultShipData: function getDefaultShipData(state) {
    return state.defaultShipData;
  },
  isComplateAccount: function isComplateAccount(state) {
    return !!state.profile.name;
  },
  isProfileLoaded: function isProfileLoaded(state) {
    return !!state.profile.name;
  },
  checkAge: function checkAge(state) {
    return !!state.checkAge;
  },
  acceptCookies: function acceptCookies(state) {
    return !!state.acceptCookies;
  }
};

var actions = (_actions = {}, defineProperty_default()(_actions, actions_user["d" /* USER_REQUEST */], function (_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  commit(actions_user["d" /* USER_REQUEST */]);
  if (localStorage.getItem('user-token')) {

    axios_default()({ url: "https://wsbot.eu/21005back/public/" + 'api/getUser', data: { token: localStorage.getItem('user-token') }, method: 'POST', headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
      commit(actions_user["f" /* USER_SUCCESS */], resp.data);
      dispatch(auth["d" /* AUTH_OK */]);
    }).catch(function (resp) {

      dispatch(auth["c" /* AUTH_LOGOUT */], resp.response.data.message);

      commit(actions_user["c" /* USER_ERROR */], resp.response.data.message);
      // if resp is unauthorized, logout, to
    });
  }
}), defineProperty_default()(_actions, actions_user["g" /* USER_UPDATE_DATA */], function (_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  commit(actions_user["g" /* USER_UPDATE_DATA */]);
}), defineProperty_default()(_actions, actions_user["e" /* USER_SET_DEFAULT_SHIP_DATA */], function (_ref3, shipData) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  commit(actions_user["e" /* USER_SET_DEFAULT_SHIP_DATA */], shipData);
}), defineProperty_default()(_actions, actions_user["b" /* USER_CHECK_AGE */], function (_ref4) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  localStorage.setItem('checkAge', true); // store the token in localstorage
  commit(actions_user["b" /* USER_CHECK_AGE */]);
}), defineProperty_default()(_actions, actions_user["a" /* ACCEPT_COOKIES */], function (_ref5) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  localStorage.setItem('acceptCookies', true); // store the token in localstorage
  commit(actions_user["a" /* ACCEPT_COOKIES */]);
}), _actions);

var mutations = (_mutations = {}, defineProperty_default()(_mutations, actions_user["d" /* USER_REQUEST */], function (state) {
  state.status = 'loading';
}), defineProperty_default()(_mutations, actions_user["f" /* USER_SUCCESS */], function (state, resp) {
  state.status = 'success';
  vue_esm["a" /* default */].set(state, 'profile', resp.user);

  vue_esm["a" /* default */].set(state, 'user_paid', resp.user_paid);
}), defineProperty_default()(_mutations, actions_user["c" /* USER_ERROR */], function (state, resp) {
  state.status = resp;
}), defineProperty_default()(_mutations, actions_user["g" /* USER_UPDATE_DATA */], function (state) {
  state.status = 'success';
  vue_esm["a" /* default */].set(state.profile, 'support_id', true);
}), defineProperty_default()(_mutations, auth["c" /* AUTH_LOGOUT */], function (state) {
  state.profile = {};
}), defineProperty_default()(_mutations, actions_user["e" /* USER_SET_DEFAULT_SHIP_DATA */], function (state, shipData) {
  vue_esm["a" /* default */].set(state, 'defaultShipData', shipData);
}), defineProperty_default()(_mutations, actions_user["b" /* USER_CHECK_AGE */], function (state) {
  state.checkAge = true;
}), defineProperty_default()(_mutations, actions_user["a" /* ACCEPT_COOKIES */], function (state) {
  state.acceptCookies = true;
}), _mutations);

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./src/store/modules/auth.js



var auth__actions, auth__mutations;

/* eslint-disable promise/param-names */




var auth_state = { token: localStorage.getItem('user-token') || '', status: '', login_error: '', loadingState: '', hasLoadedOnce: false };

var auth_getters = {
  isAuthenticated: function isAuthenticated(state) {
    return !!state.token;
  },
  authStatus: function authStatus(state) {
    return state.status;
  },
  loginerror: function loginerror(state) {
    return state.login_error;
  },
  loadingState: function loadingState(state) {
    return state.loadingState;
  }
};

var auth_actions = (auth__actions = {}, defineProperty_default()(auth__actions, auth["f" /* AUTH_REQUEST */], function (_ref, user) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(auth["f" /* AUTH_REQUEST */]);
    axios_default()({ url: "https://wsbot.eu/21005back/public/" + 'api/login', data: user, method: 'POST', crossDomain: true, headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
      var token = resp.data.userToken;
      localStorage.setItem('user-token', token); // store the token in localstorage
      commit(auth["h" /* AUTH_SUCCESS */], token);
      // you have your token, now log in your user :)
      dispatch(actions_user["d" /* USER_REQUEST */], resp.data);
      resolve(resp.data);
    }).catch(function (err) {
      commit(auth["b" /* AUTH_ERROR */], err.response.data.status);
      localStorage.removeItem('user-token'); // if the request fails, remove any possible user token if possible
      reject(err);
    });
  });
}), defineProperty_default()(auth__actions, auth["e" /* AUTH_REGISTRATION */], function (_ref2, user) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(auth["e" /* AUTH_REGISTRATION */]);
    axios_default()({
      url: "https://wsbot.eu/21005back/public/" + 'add_new_user.php',
      data: user,
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
      commit(auth["k" /* REGISTRATION_SUCCESS */], resp.data);
      resolve(resp.data);
    }).catch(function (err) {
      commit(auth["j" /* REGISTRATION_ERROR */]);
      reject(err);
    });
  });
}), defineProperty_default()(auth__actions, auth["a" /* AUTH_COMPLATE_REGISTRATION */], function (_ref3, user) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(auth["a" /* AUTH_COMPLATE_REGISTRATION */]);
    axios_default()({
      url: "https://wsbot.eu/21005back/public/" + 'editUser.php',
      data: user,
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
      commit(auth["i" /* COMPLATE_REGISTRATION_SUCCESS */], resp.data);
      dispatch(actions_user["g" /* USER_UPDATE_DATA */], resp.data);
      resolve(resp.data);
    }).catch(function (err) {
      commit(auth["j" /* REGISTRATION_ERROR */]);
      reject(err);
    });
  });
}), defineProperty_default()(auth__actions, auth["c" /* AUTH_LOGOUT */], function (_ref4) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(auth["c" /* AUTH_LOGOUT */]);
    localStorage.removeItem('user-token');
    resolve();
  });
}), defineProperty_default()(auth__actions, auth["l" /* SET_USER_TOKEN */], function (_ref5, token) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(auth["l" /* SET_USER_TOKEN */], token);

    dispatch(actions_user["d" /* USER_REQUEST */], token);

    resolve();
  });
}), defineProperty_default()(auth__actions, auth["d" /* AUTH_OK */], function (_ref6) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;

  return new promise_default.a(function (resolve, reject) {
    resolve();
  });
}), auth__actions);

var auth_mutations = (auth__mutations = {}, defineProperty_default()(auth__mutations, auth["f" /* AUTH_REQUEST */], function (state) {
  state.status = 'loading';
  state.login_error = false;
  state.loadingState = true;
}), defineProperty_default()(auth__mutations, auth["l" /* SET_USER_TOKEN */], function (state, token) {
  state.status = 'success';
  state.token = token;
  state.hasLoadedOnce = true;
}), defineProperty_default()(auth__mutations, auth["g" /* AUTH_SOCIAL */], function (state) {
  state.status = 'loading';
  state.login_error = false;
  state.loadingState = true;
}), defineProperty_default()(auth__mutations, auth["h" /* AUTH_SUCCESS */], function (state, resp) {
  state.status = 'success';
  state.token = resp;
  state.hasLoadedOnce = true;
  state.loadingState = false;
}), defineProperty_default()(auth__mutations, auth["b" /* AUTH_ERROR */], function (state, error) {
  state.status = error;
  state.login_error = true;
  state.hasLoadedOnce = true;
  state.loadingState = false;
}), defineProperty_default()(auth__mutations, auth["c" /* AUTH_LOGOUT */], function (state) {
  state.token = '';
  state.status = '';
}), defineProperty_default()(auth__mutations, auth["e" /* AUTH_REGISTRATION */], function (state) {
  state.status = 'loading';
  state.loadingState = true;
}), defineProperty_default()(auth__mutations, auth["a" /* AUTH_COMPLATE_REGISTRATION */], function (state) {
  state.status = 'loading';
  state.loadingState = true;
}), defineProperty_default()(auth__mutations, auth["k" /* REGISTRATION_SUCCESS */], function (state) {
  state.status = 'success';
  state.loadingState = false;
}), defineProperty_default()(auth__mutations, auth["i" /* COMPLATE_REGISTRATION_SUCCESS */], function (state) {
  state.status = 'success';
  state.loadingState = false;
}), defineProperty_default()(auth__mutations, auth["j" /* REGISTRATION_ERROR */], function (state) {
  state.status = 'error';
  state.loadingState = false;
}), auth__mutations);

/* harmony default export */ var modules_auth = ({
  state: auth_state,
  getters: auth_getters,
  actions: auth_actions,
  mutations: auth_mutations
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./src/store/actions/notifications.js
var notifications = __webpack_require__("1mNM");

// CONCATENATED MODULE: ./src/store/modules/notifications.js




var notifications__actions;

/* eslint-disable promise/param-names */




var notifications_state = {
  notifications: localStorage.getItem('notifications') || {},
  status: '',
  count: 0
};

var notifications_getters = {
  hasNotifications: function hasNotifications(state) {
    return !!state.notifications;
  },
  NotificationsStatus: function NotificationsStatus(state) {
    return state.status;
  },
  getNotifications: function getNotifications(state) {
    return state.notifications;
  },
  getNotificationsCount: function getNotificationsCount(state) {
    return state.count;
  }
};

var notifications_actions = (notifications__actions = {}, defineProperty_default()(notifications__actions, notifications["a" /* ADD_NOTIFICATIONS */], function (_ref, value) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(notifications["a" /* ADD_NOTIFICATIONS */], value);
    //localStorage.removeItem('user-token')
    resolve();
  });
}), defineProperty_default()(notifications__actions, notifications["b" /* GET_NOTIFICATIONS */], function (_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  return new promise_default.a(function (resolve, reject) {
    resolve();
  });
}), notifications__actions);

var notifications_mutations = defineProperty_default()({}, notifications["a" /* ADD_NOTIFICATIONS */], function (state, value) {
  var notf = state.notifications;
  var size = 0,
      key;
  for (key in notf) {
    if (notf.hasOwnProperty(key)) size++;
  }
  notf[size] = value;
  // /notf = notf.slice().reverse();
  vue_esm["a" /* default */].set(state, 'count', size + 1);
  state.notifications = assign_default()({}, state.notifications, notf);
});

/* harmony default export */ var modules_notifications = ({
  state: notifications_state,
  getters: notifications_getters,
  actions: notifications_actions,
  mutations: notifications_mutations
});
// CONCATENATED MODULE: ./src/store/index.js





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = __webpack_exports__["a"] = (new vuex_esm["a" /* default */].Store({
  modules: {
    user: modules_user,
    auth: modules_auth,
    notifications: modules_notifications
  },
  strict: debug
}));

/***/ }),

/***/ "JHcX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.regulationContainer[data-v-2a523c12]{\n\tfont-size: 18px;\n}\n.page__title[data-v-2a523c12]{\n\tfont-size: 18px!important;\n\tfont-weight: 800;\n}\n.navigation[data-v-2a523c12] {\n\tposition: fixed;\n\tbottom: 0;\n\tbackground: #fffbde;\n\tcolor: #8a222f;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 5px;\n\tfont-size: 22px;\n\ttext-align: center;\n}\n.navItem[data-v-2a523c12] {\n\tmargin: 10px;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.regulationContainer[data-v-2a523c12]{\n\t\tfont-size: 14px;\n}\n.col-md-4.text-right[data-v-2a523c12]{\n\t\ttext-align: left!important;\n}\n.navigation[data-v-2a523c12] {\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "JLVR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Jkjn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/traficLight_yellow.361e8d9.png";

/***/ }),

/***/ "K4Pf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  LOADSCREEN  */\n.bg_load[data-v-6428c8d2] {\n\t\n\tposition: fixed;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: #00000082;\n\tz-index: 100;\n}\n.imgLoad[data-v-6428c8d2]{\n\tposition: absolute;\n\ttop: 48.5%;\n\tmargin-left: 48.5vw;\n\twidth: 3vw;\n\tbackground: transparent;\n}\n@media (min-width: 767px) and (max-width: 1140px) {\n.imgLoad[data-v-6428c8d2]{\n\t\tposition: absolute;\n\t\ttop: 47.5%;\n\t\tmargin-left: -1.5vw;\n\t\twidth: 5vw;\n}\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.imgLoad[data-v-6428c8d2]{\n\t\tposition: absolute;\n\t\ttop: 45%;\n\t\tmargin-left: -1.5vw;\n\t\twidth: 10vw;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "KwyM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ki2I");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("824e365e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62fe346e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62fe346e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "L4aP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3/Hm");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("99fa6bac", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-10101776\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./delegaForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-10101776\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./delegaForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "LdOU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/arial.c3c1625.woff";

/***/ }),

/***/ "MPp2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+tnh");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0eab8069", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a1cdd68\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a1cdd68\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "MoJE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.maxSem[data-v-777bab22]{\n  max-width: 100px;\n}\n", ""]);

// exports


/***/ }),

/***/ "MoMY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Mrum":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/polyfill/lib/index.js
var lib = __webpack_require__("u7Vc");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/store/actions/auth.js
var auth = __webpack_require__("+4WN");

// EXTERNAL MODULE: ./src/store/actions/user.js
var actions_user = __webpack_require__("yLEp");

// EXTERNAL MODULE: ./src/store/actions/notifications.js
var notifications = __webpack_require__("1mNM");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/navigation/index.vue



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var moment = __webpack_require__("PJh5");

/* harmony default export */ var navigation = ({
  name: 'navigation',
  components: {},
  data: function data() {
    return {
      moment: __webpack_require__("PJh5"),
      scroll: 0,
      toggleTabState: 'close',
      vw: window.innerWidth,
      notifications: {},
      countNotification: 0,
      showNotification: false,
      menuOFF: false,
      brand: "CHEBONUS",
      phone: "02 9475 6677",
      email: "info@chebonus.it",
      phone_hsd: "02 9475 1001",
      email_hsd: "info@happybonus.it"
    };
  },


  methods: (_methods = {
    handleResize: function handleResize() {
      this.vw = window.innerWidth;
    },
    toggleTab: function toggleTab() {
      console.log(this.toggleTabState);
      if (this.toggleTabState == 'close') {
        this.toggleTabState = 'open';
      } else {
        this.toggleTabState = 'close';
      }
    },
    toggleNotification: function toggleNotification() {
      if (this.showNotification) {
        this.showNotification = false;
      } else {
        this.showNotification = true;
      }
    },

    updateScroll: function updateScroll() {
      this.scroll = window.pageYOffset;
    },
    outside2: function outside2(e) {
      if (this.toggleTabState == 'open') {
        this.toggleTabState = 'close';
      }
    },
    outside3: function outside3(e) {
      if (this.showNotification) {
        this.showNotification = false;
      }
    },
    doAcceptCookies: function doAcceptCookies() {

      this.$store.dispatch(actions_user["a" /* ACCEPT_COOKIES */]).then(function (resp) {
        //this.$router.push('/')
      });
    },
    logout: function logout() {
      var _this = this;

      this.$store.dispatch(auth["c" /* AUTH_LOGOUT */]).then(function () {
        return _this.$router.push('/login');
      });
    }
  }, defineProperty_default()(_methods, 'handleResize', function handleResize() {
    this.vw = window.innerWidth;
  }), defineProperty_default()(_methods, 'checkForfettario', function checkForfettario() {

    if (this.getProfile) {

      if ((this.getProfile.tipo_azienda == "Ditta Individuale" || this.getProfile.tipo_azienda == "Professionista iscritto ad albi") && this.getProfile.reg_forfettario == '0') {

        this.$swal({
          type: 'warning',
          title: 'Attenzione!',
          text: 'Indica nell`apposito form se rientri o meno nel Regime Forfettario e clicca sul pulsante SALVA.'
        });

        this.$router.push('/account');
      }
    }
  }), defineProperty_default()(_methods, 'checkSoftwareVersion', function checkSoftwareVersion() {
    console.log('CHECK VERSION SW ************');
    var version = localStorage.getItem('sw_version');

    if (!version) {
      console.log('VERSION NOT SAVED => ' + version);
      version = false;
    } else {
      console.log('ACTUAL VERSION => ' + version);
    }

    axios_default()({
      url: "https://wsbot.eu/21005back/public/" + 'api/checkSoftwareVersion',
      method: 'POST',
      data: {
        version: version
      },
      headers: {
        'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
        'Content-type': 'application/json'
      }
    }).then(function (resp) {

      if (resp.data.version) {
        console.log('SERVER VERSION => ' + resp.data.version);
        if (version != resp.data.version) {
          localStorage.setItem('sw_version', resp.data.version);
          window.location.reload();
        }
      }
    }).catch(function (error) {});
  }), defineProperty_default()(_methods, 'checkNews', function checkNews() {

    var hasSeeNews = localStorage.getItem('news5');

    if (this.isAuthenticated) {
      //var html = 'Siamo felici di segnalarti che sono stati attivati sulla CHEBONUS Suite i servizi opzionali <br/>per la compilazione e l`invio telematico della <b class="Bold ">pratica ENEA</b> <br/>e per l`estrazione della <b>Visura Catastale</b>.'
      //var html = 'A causa di un`anomalia sulla rete telefonica nazionale il numero del contact center risulta momentaneamente non raggiungibile. <br/> Rimaniamo a vostra disposizione sull`indirizzo email info@chebonus.it'

      //html += '<h2 class="white">Attenzione!</h2>L’aliquota degli oneri di attualizzazione dei crediti d’imposta di Poste Italiane relativi a Bonus Casa 50%, Ecobonus 50%, Ecobonus 65% e Superbonus 110% indicata nei Preventivatore di CheBonus è puramente indicativa ed estratta il giorno precedente all’elaborazione del Preventivo dal simulatore di cessione del credito di Poste Italiane.'
      //html += 'Prima di confermare il preventivo su CheBonus, sottoporlo al tuo cliente ed emettere fattura allo stesso, ti invitiamo a verificare sempre l’aliquota aggiornata degli oneri di attualizzazione dei crediti d’imposta di Poste Italiane relativi a Bonus Casa 50%, Ecobonus 50%, Ecobonus 65% e Superbonus 110%  sul Simulatore di cessione dei crediti d’imposta di Poste Italiane disponibile al seguente <a target="_blank" href="https://cessionecrediti.poste.it/simulatore/index.html?wt.ac=1476524448679">LINK</a> <br/>'
      //html += 'Novatag, Vaillant Group Italia, Società di Consulenza per gli adempimenti connessi alle agevolazioni fiscali previste alla fornitura del servizio CheBonus non si ritengono responsabili per eventuali danni economici derivanti dall’omissione della verifica dell’aliquota aggiornata degli oneri di attualizzazione dei crediti d’imposta di Poste Italiane da parte dell’installatore o altre Società aderenti a CheBonus'

      var html = '';
      html += '<h5 class="text-left white">Nuove funzionalità del preventivatore per il calcolo dell`IVA<br/></h5>';

      html += '<h3 class="center white"> Avviso! </h3> ';

      html += '<h5 class="center white"> Nuovo tasso di cessione Poste Italiane vs Ecobonus 65%-50% e Bonus Casa 50% </h5> ';
      html += '<p class="text-left">Gentile professionista,<br/>';
      html += 'Poste Italiane ha da poco comunicato sul suo sito web che a partire dal <b>28 maggio 2021</b> i prezzi di acquisto del credito d’imposta per i bonus ripartiti in 10 quote annuali saranno oggetto di revisione.<br/>';
      html += 'Il comunicato di Poste Italiane è disponibile al seguente  <a target="_blank" href="https://business.poste.it/professionisti-imprese/prodotti/cessione-dei-crediti-di-imposta.html">link </a> <br/><br/>';
      html += 'Il Preventivatore è stato aggiornamento con il nuovo tasso di cessione dei relativi bonus che sarà applicato da Poste Italiane a partire dal 28 maggio 2021.<br/>';
      html += 'Per ogni tua richiesta non esitare a contattarci al numero tel. 02.94756.677, sempre disponibili dal lunedì al venerdì negli orari 09:00-13:00 e 14:00-18:00, oppure inviaci una mail a info@chebonus.it<br/>';

      html += 'Ringraziandoti per aver scelto di installare i nostri prodotti, <a target="_blank" href="https://www.vaillant.it/home/"> Vaillant </a> ti augura una serena giornata e Buon lavoro!<br/><br/>';
      html += 'Il tuo team Vaillant CheBonus!<br/></p>';

      alert.text = html;
      alert.type = 'SUCCESS';
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
    }

    if (false) {
      localStorage.setItem('news5', 'type1');

      this.$swal({
        type: 'info',
        title: 'Novità',
        //title: 'AVVISO',
        html: html
      });
    }
  }), _methods),
  watch: {
    $route: function $route(to, from) {
      this.checkSoftwareVersion();
    },
    getProfile: function getProfile() {
      this.checkForfettario();
    },
    isAuthenticated: function isAuthenticated() {
      this.checkNews();
    },

    'getNotifications': function getNotifications() {
      this.notifications = this.getNotifications;
      this.countNotification = this.getNotificationsCount;

      // CHECK MENU OFF
      for (var x in this.notifications) {
        if (this.notifications[x].type == 'MENU_OFF') {
          this.menuOFF = true;
        }
      }

      var _vue = this;
      setTimeout(function () {
        //_vue.showNotification = true
      }, 200);
      setTimeout(function () {
        //_vue.showNotification = false
      }, 12000);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getNotifications', 'getNotificationsCount', 'getProfile', 'isAuthenticated', 'isProfileLoaded', 'acceptCookies', 'checkAge']), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === 'loading';
    },
    name: function name(state) {
      return '' + state.user.profile.name;
    }
    //notifications: state => `${state.notifications}`,

  })),
  updated: function updated() {},
  mounted: function mounted() {
    var _vue = this;
    this.checkNews();
    window.addEventListener('scroll', this.updateScroll);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.checkForfettario();
  },

  directives: {
    'click-outside': {
      bind: function bind(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          var compName = vNode.context.name;
          var warn = '[Vue-click-outside:] provided expression \'' + binding.expression + '\' is not a function, but has to be';
          if (compName) {
            warn += 'Found in component \'' + compName + '\'';
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        var bubble = binding.modifiers.bubble;
        var handler = function handler(e) {
          if (bubble || !el.contains(e.target) && el !== e.target) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function unbind(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eacecb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/index.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull", attrs: { id: "site-nav" } }, [
    _c("div", { staticClass: "container widthFull" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6 col-md-6 pt-1 pb-1" }, [
          _c("ul", { staticClass: "navbar-nav m-auto mb-lg-0 mb-md-5" }, [
            _c(
              "li",
              {
                staticClass: "nav-item",
                attrs: {
                  "data-toggle": "collapse",
                  "data-target": ".navbar-collapse.show"
                }
              },
              [
                _c(
                  "router-link",
                  {
                    directives: [
                      {
                        name: "scroll-to",
                        rawName: "v-scroll-to",
                        value: ".main",
                        expression: "'.main'"
                      }
                    ],
                    staticClass: "nav-link",
                    attrs: {
                      to: "/",
                      "data-toggle": "collapse",
                      "data-target": ".navbar-collapse.show"
                    }
                  },
                  [
                    _c("span", { staticClass: "menuItem Bold" }, [
                      _vm.brand == "CHEBONUS"
                        ? _c("b", { staticClass: "Bold" }, [_vm._v("CheBonus")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("b", { staticClass: "Bold" }, [
                            _vm._v("HappyBonus")
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 col-md-6 pt-1 pb-1" }, [
          _c(
            "ul",
            { staticClass: "navbar-nav d-block  mb-lg-0 mb-md-5 text-right " },
            [
              _vm.isProfileLoaded
                ? _c(
                    "li",
                    {
                      staticClass:
                        "nav-item dropdown mr-0 pd-0 custNavWidth float-right"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link dropdown-toggle menuItem mr-0 pd-0",
                          attrs: {
                            href: "#",
                            id: "navbardrop",
                            "data-toggle": "dropdown"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "pointer mr-0 pd-0",
                            attrs: { icon: "user", size: "1x" }
                          }),
                          _vm._v(" "),
                          _vm.vw > 500 ? [_vm._v(" Gestione ")] : _vm._e(),
                          _vm._v(" Profilo "),
                          _vm.vw > 500 ? [_vm._v("aderente")] : _vm._e(),
                          _vm._v(" e FAQ\n        ")
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu bgDrop",
                          attrs: {
                            "data-toggle": "collapse ",
                            "data-target": ".navbar-collapse.show"
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: ".main",
                                  expression: "'.main'"
                                }
                              ],
                              staticClass: "dropdown-item menuItem ",
                              attrs: {
                                to: "/account",
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Modifica Profilo aderente")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item pointer menuItem black",
                              on: { click: _vm.logout }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Esci")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isProfileLoaded
                ? _c(
                    "li",
                    {
                      staticClass: "nav-item ",
                      attrs: {
                        "data-toggle": "collapse",
                        "data-target": ".navbar-collapse.show"
                      }
                    },
                    [
                      _c(
                        "router-link",
                        { staticClass: "nav-link", attrs: { to: "/login" } },
                        [
                          _c("span", { staticClass: "menuItem " }, [
                            _vm._v("Registrati/Accedi")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "nav",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.menuOFF,
            expression: "!menuOFF"
          }
        ],
        staticClass: "navbar navbar-light  navbar-expand-lg bgWhite ",
        class: { "fixed-top": _vm.scroll > 48 },
        staticStyle: { "z-index": "11" }
      },
      [
        _c("div", { staticClass: "container widthFull center" }, [
          _c(
            "div",
            { staticClass: "navbar-header " },
            [
              _c(
                "router-link",
                {
                  staticClass:
                    "navbar-brand router-link-exact-active router-link-active",
                  attrs: { to: "/" }
                },
                [
                  _vm.brand == "CHEBONUS"
                    ? _c("img", {
                        ref: "mainNavLogo",
                        staticClass: "img-fluid logo ml-0",
                        attrs: {
                          src: __webpack_require__("JLVR"),
                          alt: ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brand == "HAPPYBONUS"
                    ? _c("img", {
                        ref: "mainNavLogo",
                        staticClass: "img-fluid logo ml-0",
                        attrs: {
                          src: __webpack_require__("Mrum"),
                          alt: ""
                        }
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "  navbar-toggler navbar-toggler-right align-self-center navbar-toggle collapsed",
                  class: { btnBurgrHSDRed: _vm.brand == "HAPPYBONUS" },
                  attrs: {
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#navbarCollapse",
                    "aria-expanded": "false"
                  }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Toggle navigation")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-bar top-bar" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-bar middle-bar" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-bar bottom-bar" })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse flex-column ml-0 pl-3",
              attrs: { id: "navbarCollapse" }
            },
            [
              _c("ul", { staticClass: "navbar-nav mr-auto mb-lg-0 mb-5" }, [
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/flowSettings" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "menuItem Bold" },
                              [
                                _vm._v(
                                  "\n                    Gestione Prerequisiti Cessione\n                    "
                                ),
                                _vm.getProfile.cdp_expired_at
                                  ? [
                                      _vm.moment().add(10, "days") >
                                      _vm.moment(_vm.getProfile.cdp_expired_at)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "badge badge-danger"
                                            },
                                            [_vm._v("!")]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/calcolatore" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Crea nuovo Preventivo")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/offerte" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Preventivi")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/pratiche" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Pratiche")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/cessioni" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Cessioni")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c("li", { staticClass: "nav-item" }, [
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                href:
                                  "https://www.vaillant.it/professionisti/prodotti/che-bonus/",
                                target: "_blank"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem Bold" }, [
                                _vm._v("Scopri CheBonus")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                href:
                                  "https://www.hermann-saunierduval.it/per-il-professionista/happy-bonus/",
                                target: "_blank"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem Bold" }, [
                                _vm._v("Scopri HappyBonus")
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/cessioni" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Area riservata aderente")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/registration" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Registrati")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "notificationContent",
              class: { notificationC: _vm.showNotification }
            },
            [
              _c(
                "div",
                { staticClass: "container relative pb-5 maxNotification" },
                [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center widthFull" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-8 pl-5 pb-2 pt-4 pb-4 reverse" },
                        [
                          _vm._l(_vm.notifications, function(item, index) {
                            return _c(
                              "div",
                              {
                                staticClass:
                                  "row justify-content-center widthFull "
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-md-11 pl-5 mb-2",
                                    class: {
                                      errorBg: item.type == "ERROR",
                                      successBg: item.type == "SUCCESS"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(parseInt(index) + 1) +
                                        ") "
                                    ),
                                    _c("span", {
                                      domProps: { innerHTML: _vm._s(item.text) }
                                    })
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.countNotification == 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row justify-content-center widthFull"
                                },
                                [_vm._m(1)]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }),
    _vm._v(" "),
    _vm.vw > 767 && _vm.isProfileLoaded
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.menuOFF,
                expression: "!menuOFF"
              },
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.outside2,
                expression: "outside2"
              }
            ],
            staticClass: "sidetab",
            class: {
              "sidebar-opened": _vm.toggleTabState == "open",
              "sidebar-closed": _vm.toggleTabState == "close",
              tabMobile: _vm.vw < 533,
              sidetabHSD: _vm.brand == "HAPPYBONUS"
            }
          },
          [
            _c("div", { staticClass: "label", on: { click: _vm.toggleTab } }, [
              _vm.vw < 533
                ? _c("img", {
                    staticClass: "img-fluid contactImg",
                    attrs: { src: __webpack_require__("3Dg/") }
                  })
                : _c("span", [
                    _c("img", {
                      staticClass: "leftIm",
                      class: { posWA: _vm.toggleTabState != "close" },
                      attrs: { src: __webpack_require__("7KbZ") }
                    }),
                    _vm._v("\n        Per assistenza\n        "),
                    _c("img", {
                      staticClass: "rightIm",
                      class: { posTEL: _vm.toggleTabState != "close" },
                      attrs: { src: __webpack_require__("+eg0") }
                    })
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "inner-content" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "media chat-available voice-available video-available"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "media-label",
                        staticStyle: {
                          "padding-top": "5px",
                          "font-size": "12px",
                          "font-weight": "bold",
                          color: "rgba(0, 0, 0, 0.54)"
                        }
                      },
                      [
                        _vm._v("\n\n            Chiama il numero "),
                        _c("span", {
                          staticClass: "black",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.brand == "CHEBONUS"
                                ? _vm.phone
                                : _vm.phone_hsd
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v("o invia WhatsApp a "),
                        _c(
                          "span",
                          {
                            staticClass: "green",
                            class: { redHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("b", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.brand == "CHEBONUS"
                                    ? _vm.phone
                                    : _vm.phone_hsd
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v("oppure scrivi a:\n            "),
                        _c("br"),
                        _c("a", {
                          staticClass: "black",
                          attrs: {
                            href:
                              "mailto:" +
                              (_vm.brand == "CHEBONUS"
                                ? _vm.email
                                : _vm.email_hsd)
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.brand == "CHEBONUS"
                                ? _vm.email
                                : _vm.email_hsd
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v("dal lunedì al venerdì\n            "),
                        _c("br"),
                        _vm._v("dalle 09:00-13:00 e 14:00-18:00\n            "),
                        _c("br"),
                        _vm._v("esclusi i giorni festivi\n            "),
                        _c("br"),
                        _c("br")
                      ]
                    )
                  ]
                )
              ])
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.acceptCookies
      ? _c(
          "div",
          {
            staticClass: "container-fluid fixed cookieBaner",
            class: { redHSDBack: _vm.brand == "HAPPYBONUS" }
          },
          [
            _c("div", { staticClass: "row justify-content-center widthFull" }, [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-2 center col-md-2 col-lg-2 mt-sm-5 pt-3 pt-md-2 mt-md-3"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary btn-lg yellowBtn mb-5 pr-3 pl-3",
                      class: { btnYellow: _vm.brand == "HAPPYBONUS" },
                      on: { click: _vm.doAcceptCookies }
                    },
                    [_vm._v(" OK")]
                  )
                ]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 pl-5 pb-2" }, [
      _c("h2", { staticClass: "black widthFull pb-0 mb-1" }, [
        _c("b", { staticClass: "widthFull" }, [_vm._v("Notifiche")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "widthFull" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center pl-5 " }, [
      _c("h5", {}, [_c("b", [_vm._v("Non hai nessuna notifica")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-message" }, [
      _c("strong", [_vm._v("Hai bisogno di assistenza?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-sm-10 col-md-9 col-lg-6 pt-sm-0 pt-md-3" },
      [
        _c("span", { staticClass: "cookieText" }, [
          _vm._v(
            "\n          Utilizziamo i cookie al fine di personalizzare e migliorare la tua esperienza sul nostro sito.\n          Visita la nostra "
          ),
          _c(
            "a",
            {
              staticStyle: {
                color: "#f39324!important",
                "text-decoration": "underline"
              },
              attrs: { target: "_blank", href: "informativa.pdf" }
            },
            [_vm._v("informativa")]
          ),
          _vm._v(
            " per acquisire maggiori informazioni.\n          Utilizzando il nostro sito accetti l'utilizzo dei cookie da parte nostra.\n        "
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_navigation = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eacecb2", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/navigation/index.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("QCBm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1eacecb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  navigation,
  components_navigation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/navigation/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1eacecb2", Component.options)
  } else {
    hotAPI.reload("data-v-1eacecb2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var src_components_navigation = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/footer/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var footer_moment = __webpack_require__("PJh5");

/* harmony default export */ var footer = ({
  name: 'sqreen-footer',
  data: function data() {
    return {
      moment: footer_moment,
      brand: "CHEBONUS"
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'loadingState', 'isAuthenticated', 'isProfileLoaded', 'authStatus', 'checkAge']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fe346e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
var footer_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid footer", attrs: { id: "footer" } },
    [
      _c("div", { staticClass: "row mt-5" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row mt-5" }, [
            _c(
              "div",
              {
                staticClass: "col-md-4  align-self-center center pt-2 pr-0 pb-3"
              },
              [
                _c("div", { staticClass: "container-fluid" }, [
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-12  align-self-center text-left "
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "h5",
                          {
                            staticClass: "black   text-left pb-0 ",
                            staticStyle: { "line-height": "30px" }
                          },
                          [
                            _vm._v(
                              "\n                  © " +
                                _vm._s(_vm.moment().format("YYYY")) +
                                " Cap. Soc. EUR 81.0"
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "black p-0 m-0",
                                attrs: { to: "/cobrowsing" }
                              },
                              [_vm._v("0")]
                            ),
                            _vm._v("0,00 Int. Vers.\n                  "),
                            _c("br"),
                            _vm._v(
                              " P.IVA 09012690963\n                  REA MI 2062710\n                "
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"
              },
              [
                _vm.brand == "CHEBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/chebonus/Privacy.pdf?v=2",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Privacy Policy")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.brand == "HAPPYBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/happybonus/Privacy.pdf?v=2",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Privacy Policy")])]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"
              },
              [
                _vm.brand == "CHEBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/chebonus/Cookie.pdf",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Cookie Policy")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.brand == "HAPPYBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/happybonus/Cookie.pdf",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Cookie Policy")])]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-2  align-self-end text-left pt-0 pr-0 pb-2 pb-md-4 mb-1"
              },
              [
                _vm.brand == "CHEBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/chebonus/Conditions.pdf?v=2",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Termini di utilizzo")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.brand == "HAPPYBONUS"
                  ? _c(
                      "a",
                      {
                        staticClass: "grey pl-4 pl-md-2",
                        attrs: {
                          href:
                            "https://storage.googleapis.com/happybonus/Conditions.pdf?v=2",
                          target: "_blank"
                        }
                      },
                      [_c("b", [_vm._v("Termini di utilizzo")])]
                    )
                  : _vm._e()
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var footer_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h5",
      {
        staticClass: "black   text-left pb-0 ",
        staticStyle: { "line-height": "20px" }
      },
      [
        _c("b", { staticClass: "pb-3 widthFull" }, [
          _vm._v("Powered by NOVATAG S.R.L.")
        ])
      ]
    )
  }
]
footer_render._withStripped = true
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var components_footer = (footer_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62fe346e", footer_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/footer/index.vue
var footer_disposed = false
function footer_injectStyle (ssrContext) {
  if (footer_disposed) return
  __webpack_require__("KwyM")
}
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = footer_injectStyle
/* scopeId */
var footer___vue_scopeId__ = "data-v-62fe346e"
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  components_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)
footer_Component.options.__file = "src/components/footer/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62fe346e", footer_Component.options)
  } else {
    hotAPI.reload("data-v-62fe346e", footer_Component.options)
  }
  module.hot.dispose(function (data) {
    footer_disposed = true
  })
})()}

/* harmony default export */ var src_components_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "A5ue"));

/* harmony default export */ var App = ({
  components: {
    SqreenFooter: src_components_footer,
    Navigation: src_components_navigation
    //loading,
  },
  name: 'app',
  data: function data() {
    return {
      fullscreen: false,
      restoreId: false,
      brand: "CHEBONUS",
      popupbg:  true ? 'linear-gradient(0deg, #00917e, #00dcbf)' : 'linear-gradient(0deg, #cd0c2d, #ff6680)'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['isAuthenticated', 'userPaid', 'getProfile'])),
  watch: {
    isAuthenticated: function isAuthenticated() {

      var _vue = this;

      this.$store.dispatch(actions_user["d" /* USER_REQUEST */]).then(function (resp) {
        console.log('LOG USER');

        setTimeout(function () {
          if (_vue.userPaid == 'yes') {
            //_vue.initiateCall()
          }
        }, 2500);
      });
    }
  },
  methods: {
    initFreshChat: function initFreshChat() {
      console.log('initFreshChat');
      var _vue = this;

      window.fcWidget.init({
        token: "8bf45de4-3dc3-4817-8dca-ea03e411009e",
        host: "https://wchat.freshchat.com",
        externalId: _vue.getProfile.partita_iva,
        restoreId: _vue.getProfile.freshchatID ? _vue.getProfile.freshchatID : null,
        locale: "it",
        tags: ["chebonus", "consulenzafiscale"],
        siteId: "CHEBONUS"
      });

      var firstName = _vue.getProfile.name;
      var lastName = _vue.getProfile.cognome;
      var email = _vue.getProfile.email;
      var phone = _vue.getProfile.cellulare ? _vue.getProfile.cellulare : _vue.getProfile.telefono;

      var data1 = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        phoneCountryCode: "+39",
        plan: "Estate",
        status: "Active"
      };
      console.log(data1);
      window.fcWidget.user.get(function (resp) {
        console.log(resp);
        var status = resp && resp.status,
            data = resp && resp.data;
        if (status !== 200) {
          console.log('STATUS => USER NOT FOUND');

          window.fcWidget.user.setProperties(data1);
          window.fcWidget.on('user:created', function (resp) {
            console.log('USER_CREATED');
            var status = resp && resp.status,
                data = resp && resp.data;
            if (status === 200) {
              if (data.restoreId) {
                // Update restoreId in your database
                console.log(data.restoreId);
                _vue.restoreId = data.restoreId;
                _vue.editUser();
              }
            }
          });
        } else {
          console.log('EXIST USER FRESHCHAT');
        }
      }, data1);
    },
    initialize: function initialize(i, t) {
      console.log('initialize');
      var e;
      i.getElementById(t) ? this.initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.freshchat.com/js/widget.js", e.onload = this.initFreshChat, i.head.appendChild(e));
    },
    initiateCall: function initiateCall() {
      console.log('initiateCall');
      this.initialize(document, "freshchat-js-sdk");
    },
    editUser: function editUser() {
      var _this = this;

      this.loadingState = true;
      var data = {
        email: this.getProfile.email,
        freshchatID: this.restoreId
      };

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/editUser',
        method: 'POST',
        data: {
          user: data,
          regType: 'new'
        },
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this.$store.dispatch(actions_user["d" /* USER_REQUEST */]);
        //this.proccess = 'REG_SUCCESS'
        _this.loadingState = false;
      }).catch(function (error) {
        _this.loadingState = false;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _vue;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this2.isAuthenticated) {
                _vue = _this2;


                _this2.$store.dispatch(actions_user["d" /* USER_REQUEST */]).then(function (resp) {
                  console.log('LOG USER');
                  setTimeout(function () {
                    if (_vue.userPaid == 'yes') {
                      //_vue.initiateCall()
                    }
                  }, 2500);
                });
              }

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("vue-headful", {
        attrs: {
          title:
            _vm.brand == "CHEBONUS"
              ? "Vaillant CheBonus"
              : "Hermann Saunier Duval HappyBonus",
          description:
            "Incentivi fiscali. Ci pensiamo noi. Offri ai tuoi clienti sconti immediati direttamente in fattura. Noi gestiamo tutta la parte burocratica"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("navigation"),
          _vm._v(" "),
          _c("div", { staticClass: "main-container" }, [_c("router-view")], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c("sqreen-footer")
    ],
    1
  )
}
var App_staticRenderFns = []
App_render._withStripped = true
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", App_esExports)
  }
}
// CONCATENATED MODULE: ./src/App.vue
var App_disposed = false
function App_injectStyle (ssrContext) {
  if (App_disposed) return
  __webpack_require__("x3vu")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-7ba5bd90"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)
App_Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", App_Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", App_Component.options)
  }
  module.hot.dispose(function (data) {
    App_disposed = true
  })
})()}

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/areaRiservata/login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var login_moment = __webpack_require__("PJh5");

/* harmony default export */ var areaRiservata_login = ({
  name: 'login',
  data: function data() {
    return {
      username: '',
      password: '',
      token: '',
      loading: false,
      tempMail: '',
      socialEmail: false,
      social: '',
      confirmed: true,
      resend_success: false,
      loadingState2: false,
      passwordFieldType: 'password',
      moment: login_moment,
      finish: "2030-12-15 23:59:59",
      registration: true,
      to_activate: false,
      brand: "CHEBONUS"
    };
  },

  methods: {
    switchVisibility: function switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    },

    login: function login() {
      var _this = this;

      var username = this.username,
          password = this.password;


      this.$validator.validate().then(function (valid) {
        if (valid) {

          _this.$store.dispatch(auth["f" /* AUTH_REQUEST */], {
            username: username,
            password: password
          }).then(function (resp) {
            _this.$router.push('/');
          }).catch(function (error) {

            console.log(error.response.data.status);

            if (error.response.data.status == 'to_activate') {
              _this.to_activate = true;
            }
          });
        }
      });
    },

    resetState: function resetState() {

      this.resend_success = false;
      this.confirmed = true;
    },

    resendConfirmEmail: function resendConfirmEmail() {
      var _this2 = this;

      var username = this.username;


      if (username) {
        this.loadingState2 = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/resend_registration_email',
          method: 'POST',
          data: {
            username: username
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this2.resend_success = true;
          _this2.loadingState2 = false;
        }).catch(function (error) {
          _this2.loadingState2 = false;

          _this2.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message
          });
        });
      } else {
        this.confirmed = true;
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'loadingState', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  })),
  watch: {
    authStatus: function authStatus(value) {
      if (value == 'not_confirmed') {
        this.confirmed = false;
      }
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baeb6964","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/areaRiservata/login.vue
var login_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader widthFull pt-3" },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-3 " }, [
        _c(
          "div",
          { staticClass: "row justify-content-center vaillantCont pb-4" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12 col-lg-12 pt-4 pb-4 " }, [
              _c(
                "form",
                {
                  staticClass: "login widthFull",
                  attrs: { id: "login-form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.login($event)
                    }
                  }
                },
                [
                  _vm.confirmed && !_vm.to_activate
                    ? _c("div", { staticClass: "widthFull" }, [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-md-12 mb-1" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput ",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.username,
                                        expression: "username"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          email: true,
                                          temporaryEmail: true,
                                          plusIssueEmail: true,
                                          max: 56
                                        },
                                        expression:
                                          "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has("username"),
                                      valid: !!_vm.username
                                    },
                                    attrs: {
                                      type: "text",
                                      id: "username",
                                      name: "username",
                                      "data-vv-as": "Email"
                                    },
                                    domProps: { value: _vm.username },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.username = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "username" }
                                    },
                                    [_vm._v("Email")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("username")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.errors.first("username")
                                              ) +
                                              "\n\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.socialEmail
                                    ? _c(
                                        "div",
                                        { staticClass: "text-danger mt-3" },
                                        [
                                          _vm._v(
                                            "\n                    Sei registrato con: "
                                          ),
                                          _c(
                                            "strong",
                                            { staticClass: "text-capitalize" },
                                            [_vm._v(_vm._s(_vm.socialEmail))]
                                          ),
                                          _vm._v(
                                            ". Per effetuare accesso clicca sulla apposita icona\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-md-12 mb-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          min: 8,
                                          max: 56
                                        },
                                        expression:
                                          "{required:true, min: 8, max: 56}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has("password"),
                                      valid: !!_vm.password
                                    },
                                    attrs: {
                                      type: "password",
                                      id: "password",
                                      name: "password",
                                      "data-vv-as": "Password"
                                    },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "password" }
                                    },
                                    [_vm._v("Password")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("password")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.errors.first("password")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.loginerror
                                    ? _c("div", { staticClass: "mb-3" }, [
                                        _c(
                                          "span",
                                          { staticClass: "formError ml-1" },
                                          [_vm._v("Email o password errati.")]
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.confirmed && !_vm.to_activate
                    ? _c("div", { staticClass: "widthFull" }, [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-12 text-right pr-4" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary  shadow mb-4 mt-0",
                                    class: {
                                      btnHSDRed: _vm.brand == "HAPPYBONUS"
                                    },
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v("Accedi")]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-12 mb-3" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "black Medium pl-3 ",
                                    attrs: { to: "/forgot-password" }
                                  },
                                  [_vm._v("Password dimenticata?")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 col-lg-12 pt-1 pb-4 vaillantCont" },
              [
                _vm.confirmed && !_vm.to_activate
                  ? _c("div")
                  : _vm.resend_success && !_vm.to_activate
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-12 mb-3 center" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { to: "/login" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.resetState($event)
                                    }
                                  }
                                },
                                [_vm._v("Accedi")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : !_vm.resend_success && !_vm.to_activate
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12 mb-3 center" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mt-3",
                                class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.resendConfirmEmail($event)
                                  }
                                }
                              },
                              [_vm._v("Invia")]
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.to_activate
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-12 mb-3 center" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary mt-3",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { to: "/" }
                                },
                                [_vm._v("Home")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var login_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center pl-4 pb-1 mt-3 mb-2" }, [
      _c("h4", { staticClass: "Regular text-left  pt-2 h0" }, [
        _vm._v("Area riservata aderente")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v(
            "L'e-mail di conferma della registrazione è stata inviata alla tua casella di posta elettronica"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v("Non hai ricevuto l'e-mail "),
          _c("br"),
          _vm._v("di conferma della registrazione?")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4 mt-5" }, [
        _vm._v(
          "Controlla che il tuo gestore di posta elettronica non abbia inserito il messaggio nella cartella di posta indesiderata (spam) o con destinatario sconosciuto."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4" }, [
        _vm._v(
          "Se sono passati diversi minuti da quando hai fatto la richiesta e il messaggio non è ancora arrivato clicca sul bottone qui sotto per chiederne il reinivio."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [_vm._v("La tua richiesta è in fase di approvazione.")]),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(
          "A breve riceverai la conferma via email e potrai accedere alla piattaforma."
        )
      ])
    ])
  }
]
login_render._withStripped = true
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var components_areaRiservata_login = (login_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-baeb6964", login_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/areaRiservata/login.vue
var login_disposed = false
function login_injectStyle (ssrContext) {
  if (login_disposed) return
  __webpack_require__("CCTN")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-baeb6964"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  areaRiservata_login,
  components_areaRiservata_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)
login_Component.options.__file = "src/components/areaRiservata/login.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-baeb6964", login_Component.options)
  } else {
    hotAPI.reload("data-v-baeb6964", login_Component.options)
  }
  module.hot.dispose(function (data) {
    login_disposed = true
  })
})()}

/* harmony default export */ var src_components_areaRiservata_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/areaRiservata/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var areaRiservata_moment = __webpack_require__("PJh5");

/* harmony default export */ var areaRiservata = ({
  components: {
    login: src_components_areaRiservata_login
  },
  data: function data() {
    return {
      moment: __webpack_require__("PJh5"),
      status: 'home',
      id: '',
      registration: true,
      brand: "CHEBONUS"
    };
  },

  name: 'areaRiservata',
  methods: {
    logout: function logout() {
      var _this = this;

      this.$store.dispatch(auth["c" /* AUTH_LOGOUT */]).then(function () {
        return _this.$router.push('/login');
      });
    }

  },
  watch: {

    getProfile: function getProfile() {}

  },
  mounted: function mounted() {
    this.$scrollTo('#app', 700, {
      offset: -775
    });
  },
  beforeUpdate: function beforeUpdate() {},
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['isAuthenticated', 'authStatus', 'getProfile']), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === 'loading';
    }
  }), {
    loading: function loading() {
      return this.authStatus === 'loading' && !this.isAuthenticated;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3aaf92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/areaRiservata/index.vue
var areaRiservata_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull " }, [
    _c("div", { staticClass: "container mt-3  mt-md-5" }, [
      _c("div", { staticClass: "row justify-content-center " }, [
        !_vm.isAuthenticated
          ? _c("div", { staticClass: "col-md-4 pl-md-0" }, [_c("login")], 1)
          : _vm._e(),
        _vm._v(" "),
        !_vm.isAuthenticated
          ? _c("div", { staticClass: "col-md-4  pt-3 mt-3" }, [
              _vm.registration
                ? _c(
                    "div",
                    {
                      staticClass:
                        "form-row justify-content-center vaillantCont"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-12 mb-0 pb-0 text-center pr-0 pl-0"
                        },
                        [
                          _vm.brand == "CHEBONUS"
                            ? _c("img", {
                                staticClass: "img-fluid widthFull",
                                attrs: {
                                  src: __webpack_require__("dF35")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand == "HAPPYBONUS"
                            ? _c("img", {
                                staticClass: "img-fluid widthFull",
                                attrs: {
                                  src: __webpack_require__("X6x5")
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-12 mb-4 pb-3 text-center" },
                        [
                          _vm.brand == "CHEBONUS"
                            ? _c(
                                "h4",
                                {
                                  staticClass:
                                    " Regular text-left pb-0 pl-4 pr-4"
                                },
                                [
                                  _vm._v(
                                    "Non sei ancora registrato a CheBonus?"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand == "HAPPYBONUS"
                            ? _c(
                                "h4",
                                {
                                  staticClass:
                                    " Regular text-left pb-0 pl-4 pr-4"
                                },
                                [
                                  _vm._v(
                                    "Non sei ancora registrato a HappyBonus?"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand == "CHEBONUS"
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    " Regular text-left pb-4 pl-4 pr-4"
                                },
                                [
                                  _vm._v(
                                    "\n              L'accesso all'area riservata è soggetto all'approvazione di Vaillant ed il servizio è rivolto ai professionisti del settore\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand == "HAPPYBONUS"
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    " Regular text-left pb-4 pl-4 pr-4"
                                },
                                [
                                  _vm._v(
                                    "\n              L'accesso all'area riservata è soggetto all'approvazione di Hermann Saunier Duval ed il servizio è rivolto ai professionisti del settore\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isAuthenticated
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary  mb-1",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { to: "/registration" }
                                },
                                [
                                  _vm._v(
                                    "\n              Registrati subito\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAuthenticated
          ? _c("div", { staticClass: "col-md-4 pt-3 mt-3" }, [
              _c(
                "div",
                { staticClass: "form-row justify-content-center vaillantCont" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12 mb-0 pb-0 text-center pr-0 pl-0"
                    },
                    [
                      _vm.brand == "CHEBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: __webpack_require__("OJIF")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: __webpack_require__("muof")
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 mb-4 pb-3 text-center" },
                    [
                      _c(
                        "h4",
                        { staticClass: " Regular text-left pb-0 pl-4 pr-4" },
                        [_vm._v("Area riservata aderente")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: " Regular text-left pl-4 pr-4" }, [
                        _vm._v(
                          "\n              Benvenuto " +
                            _vm._s(_vm.getProfile.name) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            " Regular text-left pb-3 pl-4 pr-4 underline pointer"
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "green mb-1",
                              class: { redHSD: _vm.brand == "HAPPYBONUS" },
                              attrs: { to: "/account" }
                            },
                            [_c("b", [_vm._v("Modifica profilo ")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary white mb-1",
                          class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                          on: { click: _vm.logout }
                        },
                        [_vm._v("\n              Esci\n            ")]
                      )
                    ]
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAuthenticated
          ? _c("div", { staticClass: "col-md-4 pt-3 mt-3" }, [
              _c(
                "div",
                { staticClass: "form-row justify-content-center vaillantCont" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12 mb-0 pb-0 text-center pr-0 pl-0"
                    },
                    [
                      _vm.brand == "CHEBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: __webpack_require__("TMYC")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: __webpack_require__("Rb+6")
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 mb-4 pb-3 text-center" },
                    [
                      _c(
                        "h4",
                        { staticClass: " Regular text-left pb-0 pl-4 pr-4" },
                        [_vm._v("Servizio clienti")]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: " Regular text-left pb-0 pl-4 pr-4 " },
                        [
                          _vm._v(
                            "\n              Se hai bisogno di ulteriori informazioni\n\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "widthFull text-left pl-4 pr-4 pb-3" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "widthFull text-left mb-1",
                              attrs: { to: "/contact" }
                            },
                            [
                              _c("img", {
                                staticClass: "wa_icon mr-3",
                                attrs: {
                                  src: __webpack_require__("7KbZ")
                                }
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "green mr-3",
                                class: { redHSD: _vm.brand == "HAPPYBONUS" },
                                attrs: { icon: "headset", size: "2x" }
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "green mr-3",
                                class: { redHSD: _vm.brand == "HAPPYBONUS" },
                                attrs: { icon: "envelope", size: "2x" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-primary  mb-1",
                          class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                          attrs: { to: "/contact" }
                        },
                        [_vm._v("\n              Contattaci qui\n            ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 pr-md-0 pt-3 mt-3" }, [
          _vm.registration
            ? _c(
                "div",
                { staticClass: "form-row justify-content-center vaillantCont" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12 mb-0 pb-0 text-center pr-0 pl-0"
                    },
                    [
                      _vm.brand == "CHEBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: __webpack_require__("NdTM")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("img", {
                            staticClass: "img-fluid widthFull",
                            attrs: {
                              src: __webpack_require__("ctsv")
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 mb-4 pb-3 text-center" },
                    [
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "h4",
                            {
                              staticClass: " Regular text-left pb-0 pl-4 pr-4"
                            },
                            [_vm._v("Installa Vaillant e attiva CheBonus!")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c(
                            "h4",
                            {
                              staticClass: " Regular text-left pb-0 pl-4 pr-4"
                            },
                            [
                              _vm._v(
                                "Installa Hermann Saunier Duval e attiva HappyBonus"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "p",
                            {
                              staticClass: " Regular text-left pb-3 pl-4 pr-4"
                            },
                            [
                              _vm._v(
                                "\n              Scopri i vantaggi unici di CheBonus, il servizio di Vaillant per fornire al tuo cliente lo sconto immediato in fattura.\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c(
                            "p",
                            {
                              staticClass: " Regular text-left pb-3 pl-4 pr-4"
                            },
                            [
                              _vm._v(
                                "\n              Scopri i vantaggi unici di HappyBonus, il servizio di Hermann Saunier Duval per fornire al tuo cliente lo sconto immediato in fattura.\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary mb-1 mt-4",
                              class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                              attrs: {
                                href:
                                  "https://www.vaillant.it/professionisti/prodotti/che-bonus/",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n              Scopri di più\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary mb-1 mt-1",
                              class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                              attrs: {
                                href:
                                  "https://www.hermann-saunierduval.it/per-il-professionista/happy-bonus/",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n              Scopri di più\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var areaRiservata_staticRenderFns = []
areaRiservata_render._withStripped = true
var areaRiservata_esExports = { render: areaRiservata_render, staticRenderFns: areaRiservata_staticRenderFns }
/* harmony default export */ var components_areaRiservata = (areaRiservata_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e3aaf92", areaRiservata_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/areaRiservata/index.vue
var areaRiservata_disposed = false
function areaRiservata_injectStyle (ssrContext) {
  if (areaRiservata_disposed) return
  __webpack_require__("AiJu")
}
var areaRiservata_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var areaRiservata___vue_template_functional__ = false
/* styles */
var areaRiservata___vue_styles__ = areaRiservata_injectStyle
/* scopeId */
var areaRiservata___vue_scopeId__ = "data-v-4e3aaf92"
/* moduleIdentifier (server only) */
var areaRiservata___vue_module_identifier__ = null
var areaRiservata_Component = areaRiservata_normalizeComponent(
  areaRiservata,
  components_areaRiservata,
  areaRiservata___vue_template_functional__,
  areaRiservata___vue_styles__,
  areaRiservata___vue_scopeId__,
  areaRiservata___vue_module_identifier__
)
areaRiservata_Component.options.__file = "src/components/areaRiservata/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4e3aaf92", areaRiservata_Component.options)
  } else {
    hotAPI.reload("data-v-4e3aaf92", areaRiservata_Component.options)
  }
  module.hot.dispose(function (data) {
    areaRiservata_disposed = true
  })
})()}

/* harmony default export */ var src_components_areaRiservata = (areaRiservata_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var home_moment = __webpack_require__("PJh5");

/* harmony default export */ var home = ({
  components: {
    areaRiservata: src_components_areaRiservata
  },
  data: function data() {
    return {
      moment: __webpack_require__("PJh5"),
      status: 'home',
      id: '',
      brand: "CHEBONUS"
    };
  },

  name: 'home',
  methods: {
    showError: function showError(text) {
      this.$swal({
        type: 'error',
        title: text,
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#b61617'

      });
    }
  },
  watch: {

    getProfile: function getProfile() {}

  },
  mounted: function mounted() {},
  beforeUpdate: function beforeUpdate() {},
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['isAuthenticated', 'authStatus', 'getProfile']), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === 'loading';
    }
  }), {
    loading: function loading() {
      return this.authStatus === 'loading' && !this.isAuthenticated;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f3a69c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
var home_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull " },
    [
      _c("div", { staticClass: "container  bgWhite " }, [
        _vm.brand == "CHEBONUS" && !_vm.isAuthenticated
          ? _c("div", { staticClass: "row justify-content-center " }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-4 pb-3 mb-5 text-md-left text-center pl-md-5 pt-5 order-2 order-md-1"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      "\n            Accedi a Vaillant CheBonus e fornisci al tuo cliente i vantaggi dello sconto in fattura!\n          "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isAuthenticated
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-primary  mr-md-4 mt-5 btnYellow",
                          attrs: { to: "/registration" }
                        },
                        [_vm._v("\n            Registrati subito!\n          ")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.brand == "HAPPYBONUS" && !_vm.isAuthenticated
          ? _c("div", { staticClass: "row justify-content-center " }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-4 pb-3 mb-5 text-md-left text-center pl-md-5 pt-5 order-2 order-md-1"
                },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      "\n            Accedi a Hermann Saunier Duval HappyBonus e fornisci al tuo cliente i vantaggi dello sconto in fattura!\n\n          "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isAuthenticated
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-primary  mr-md-4 mt-5 btnHSDRed",
                          attrs: { to: "/registration" }
                        },
                        [_vm._v("\n            Registrati subito!\n          ")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(3)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(4)
      ]),
      _vm._v(" "),
      _c("areaRiservata")
    ],
    1
  )
}
var home_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "mt-md-5 pt-md-5" }, [
      _vm._v("\n            Installa Vaillant e attiva\n            "),
      _c("br"),
      _vm._v("CheBonus!\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-8 headerBack order-1 order-md-2" },
      [
        _c("img", {
          staticClass: "imf-fluid widthFull",
          attrs: { src: __webpack_require__("re5U") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "mt-md-5 pt-md-5" }, [
      _vm._v("\n            HappyBonus\n            "),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-8 headerBack order-1 order-md-2 pl-0 pr-0" },
      [
        _c("img", {
          staticClass: "imf-fluid widthFull",
          attrs: { src: __webpack_require__("5vhL") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 pr-0 pl-0 csmrtop" }, [
      _c("div", { staticClass: "row justify-content-center " }, [
        _c("img", {
          staticClass: "img-fluid widthFull",
          attrs: { src: __webpack_require__("vQ6k") }
        })
      ])
    ])
  }
]
home_render._withStripped = true
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var components_home = (home_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f3a69c", home_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/home/index.vue
var home_disposed = false
function home_injectStyle (ssrContext) {
  if (home_disposed) return
  __webpack_require__("879u")
}
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = home_injectStyle
/* scopeId */
var home___vue_scopeId__ = "data-v-67f3a69c"
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  home,
  components_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)
home_Component.options.__file = "src/components/home/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-67f3a69c", home_Component.options)
  } else {
    hotAPI.reload("data-v-67f3a69c", home_Component.options)
  }
  module.hot.dispose(function (data) {
    home_disposed = true
  })
})()}

/* harmony default export */ var src_components_home = (home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/faq/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var faq = ({
  name: 'faq',
  components: {},
  data: function data() {

    return {
      loadingState: false,
      brand: "CHEBONUS"
    };
  },

  methods: {},
  mounted: function mounted() {
    this.$scrollTo('#app', 700, {
      offset: -775
    });
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d25b78e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq/index.vue
var faq_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mb-5" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row justify-content-center vaillantCont pb-5 pt-3" },
          [
            _c("div", { staticClass: "col-md-12 mt-4" }, [
              _vm.brand == "HAPPYBONUS"
                ? _c(
                    "a",
                    {
                      staticClass: "black underline h5",
                      attrs: {
                        href:
                          "https://storage.googleapis.com/happybonus/Guida_HappyBonus_Novembre_2021.pdf",
                        target: "_blank"
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          " Guida all’utilizzo della nuova web app HappyBonus ed. Novembre ’21 "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.brand == "CHEBONUS"
                ? _c(
                    "a",
                    {
                      staticClass: "black underline h5",
                      attrs: {
                        href:
                          "https://storage.googleapis.com/chebonus/Guida_CheBonus_Novembre_2021.pdf",
                        target: "_blank"
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          " Guida all’utilizzo della nuova web app CheBonus ed. Novembre ’21 "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ],
    1
  )
}
var faq_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center mb-3 " }, [
      _c("div", { staticClass: "col-md-12 mt-4" }, [
        _c("h2", { staticClass: " ", attrs: { type: "text" } }, [
          _vm._v(" Guida all'utilizzo e FAQ ")
        ])
      ])
    ])
  }
]
faq_render._withStripped = true
var faq_esExports = { render: faq_render, staticRenderFns: faq_staticRenderFns }
/* harmony default export */ var components_faq = (faq_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d25b78e", faq_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/faq/index.vue
var faq_disposed = false
function faq_injectStyle (ssrContext) {
  if (faq_disposed) return
  __webpack_require__("yTXc")
}
var faq_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var faq___vue_template_functional__ = false
/* styles */
var faq___vue_styles__ = faq_injectStyle
/* scopeId */
var faq___vue_scopeId__ = "data-v-0d25b78e"
/* moduleIdentifier (server only) */
var faq___vue_module_identifier__ = null
var faq_Component = faq_normalizeComponent(
  faq,
  components_faq,
  faq___vue_template_functional__,
  faq___vue_styles__,
  faq___vue_scopeId__,
  faq___vue_module_identifier__
)
faq_Component.options.__file = "src/components/faq/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d25b78e", faq_Component.options)
  } else {
    hotAPI.reload("data-v-0d25b78e", faq_Component.options)
  }
  module.hot.dispose(function (data) {
    faq_disposed = true
  })
})()}

/* harmony default export */ var src_components_faq = (faq_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/regulation/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var regulation = ({
  name: 'regulation',
  data: function data() {
    return {
      loadingState: '',
      userToken: ''
    };
  },

  methods: {},
  watch: {},
  mounted: function mounted() {},
  computed: Object(vuex_esm["c" /* mapState */])({ profile: function profile(state) {
      return state.user.profile;
    } })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-711de7bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/regulation/index.vue
var regulation_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bbaBackground widthFull fitAvailableHeight",
      staticStyle: { color: "white" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container regulationContainer" })
    ],
    1
  )
}
var regulation_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row mb-4 pt-5 pb-5 center" }, [
        _c("h3", { staticClass: "tizaFont bbaWhite center pt-5 widthFull" }, [
          _c("span", { staticStyle: { color: "white" } }, [
            _c("strong", [_vm._v("REGOLAMENTO")])
          ])
        ])
      ])
    ])
  }
]
regulation_render._withStripped = true
var regulation_esExports = { render: regulation_render, staticRenderFns: regulation_staticRenderFns }
/* harmony default export */ var components_regulation = (regulation_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-711de7bd", regulation_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/regulation/index.vue
var regulation_disposed = false
function regulation_injectStyle (ssrContext) {
  if (regulation_disposed) return
  __webpack_require__("en44")
}
var regulation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var regulation___vue_template_functional__ = false
/* styles */
var regulation___vue_styles__ = regulation_injectStyle
/* scopeId */
var regulation___vue_scopeId__ = "data-v-711de7bd"
/* moduleIdentifier (server only) */
var regulation___vue_module_identifier__ = null
var regulation_Component = regulation_normalizeComponent(
  regulation,
  components_regulation,
  regulation___vue_template_functional__,
  regulation___vue_styles__,
  regulation___vue_scopeId__,
  regulation___vue_module_identifier__
)
regulation_Component.options.__file = "src/components/regulation/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-711de7bd", regulation_Component.options)
  } else {
    hotAPI.reload("data-v-711de7bd", regulation_Component.options)
  }
  module.hot.dispose(function (data) {
    regulation_disposed = true
  })
})()}

/* harmony default export */ var src_components_regulation = (regulation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/privacy/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var privacy = ({
	name: 'privacy',
	data: function data() {
		return {
			loadingState: '',
			userToken: ''
		};
	},

	methods: {
		scrollToTop: function scrollToTop() {
			window.scrollTo(0, 0);
		}
	},
	watch: {},
	mounted: function mounted() {
		window.location.replace('https://storage.googleapis.com/chebonus/Privacy.pdf');
	}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-665f5baa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/privacy/index.vue
var privacy_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "privacy",
      staticClass: " widthFull fitAvailableHeight pt-5",
      staticStyle: { color: "black" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container regulationContainer pb-5" })
    ],
    1
  )
}
var privacy_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row mb-5 pt-5 center" }, [
        _c("h3", { staticClass: "tizaFont bbaWhite center  widthFull" }, [
          _c("span", { staticStyle: { color: "black" } }, [
            _vm._v("Informativa per il trattamento dei dati personali")
          ])
        ])
      ])
    ])
  }
]
privacy_render._withStripped = true
var privacy_esExports = { render: privacy_render, staticRenderFns: privacy_staticRenderFns }
/* harmony default export */ var components_privacy = (privacy_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-665f5baa", privacy_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/privacy/index.vue
var privacy_disposed = false
function privacy_injectStyle (ssrContext) {
  if (privacy_disposed) return
  __webpack_require__("b+/z")
}
var privacy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var privacy___vue_template_functional__ = false
/* styles */
var privacy___vue_styles__ = privacy_injectStyle
/* scopeId */
var privacy___vue_scopeId__ = "data-v-665f5baa"
/* moduleIdentifier (server only) */
var privacy___vue_module_identifier__ = null
var privacy_Component = privacy_normalizeComponent(
  privacy,
  components_privacy,
  privacy___vue_template_functional__,
  privacy___vue_styles__,
  privacy___vue_scopeId__,
  privacy___vue_module_identifier__
)
privacy_Component.options.__file = "src/components/privacy/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-665f5baa", privacy_Component.options)
  } else {
    hotAPI.reload("data-v-665f5baa", privacy_Component.options)
  }
  module.hot.dispose(function (data) {
    privacy_disposed = true
  })
})()}

/* harmony default export */ var src_components_privacy = (privacy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cookie/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var cookie = ({
	name: 'privacy',
	data: function data() {
		return {
			loadingState: '',
			userToken: ''
		};
	},

	methods: {
		scrollToTop: function scrollToTop() {
			window.scrollTo(0, 0);
		}
	},
	watch: {},
	mounted: function mounted() {
		window.location.replace('https://storage.googleapis.com/chebonus/Cookie.pdf');
	}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a523c12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookie/index.vue
var cookie_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "privacy",
      staticClass: " widthFull fitAvailableHeight pt-5",
      staticStyle: { color: "black" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container regulationContainer pb-5" })
    ],
    1
  )
}
var cookie_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row mb-5 pt-5 center" }, [
        _c("h3", { staticClass: "tizaFont bbaWhite center  widthFull" }, [
          _c("span", { staticStyle: { color: "black" } }, [
            _vm._v("Informativa per il trattamento dei dati personali")
          ])
        ])
      ])
    ])
  }
]
cookie_render._withStripped = true
var cookie_esExports = { render: cookie_render, staticRenderFns: cookie_staticRenderFns }
/* harmony default export */ var components_cookie = (cookie_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a523c12", cookie_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/cookie/index.vue
var cookie_disposed = false
function cookie_injectStyle (ssrContext) {
  if (cookie_disposed) return
  __webpack_require__("biI2")
}
var cookie_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cookie___vue_template_functional__ = false
/* styles */
var cookie___vue_styles__ = cookie_injectStyle
/* scopeId */
var cookie___vue_scopeId__ = "data-v-2a523c12"
/* moduleIdentifier (server only) */
var cookie___vue_module_identifier__ = null
var cookie_Component = cookie_normalizeComponent(
  cookie,
  components_cookie,
  cookie___vue_template_functional__,
  cookie___vue_styles__,
  cookie___vue_scopeId__,
  cookie___vue_module_identifier__
)
cookie_Component.options.__file = "src/components/cookie/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a523c12", cookie_Component.options)
  } else {
    hotAPI.reload("data-v-2a523c12", cookie_Component.options)
  }
  module.hot.dispose(function (data) {
    cookie_disposed = true
  })
})()}

/* harmony default export */ var src_components_cookie = (cookie_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var admin = ({
	name: 'privacy',
	data: function data() {
		return {
			loadingState: '',
			userToken: '',
			brand: "CHEBONUS"
		};
	},

	methods: {
		scrollToTop: function scrollToTop() {
			window.scrollTo(0, 0);
		}
	},
	watch: {},
	mounted: function mounted() {

		if (this.$route.query) {
			if (this.$route.query.confidi) {
				if (this.brand == 'CHEBONUS') {
					window.location.replace('https://wsbot.eu/21005Verifica/validUserForCDP');
				} else {
					window.location.replace('https://wsbot.eu/21006Verifica/validUserForCDP');
				}
			} else if (this.$route.query.agileEnergy) {
				if (this.brand == 'CHEBONUS') {
					window.location.replace('https://wsbot.eu/21005Verifica/validUserForAgileEnergy');
				} else {
					window.location.replace('https://wsbot.eu/21006Verifica/validUserForAgileEnergy');
				}
			} else if (this.$route.query.mbfacta) {
				if (this.brand == 'CHEBONUS') {
					window.location.replace('https://wsbot.eu/21005Verifica/validUserForMbfacta');
				} else {
					window.location.replace('https://wsbot.eu/21006Verifica/validUserForMbfacta');
				}
			} else {
				if (this.brand == 'CHEBONUS') {
					window.location.replace('https://wsbot.eu/21005Verifica/');
				} else {
					window.location.replace('https://wsbot.eu/21006Verifica/');
				}
			}
		} else {
			if (this.brand == 'CHEBONUS') {
				window.location.replace('https://wsbot.eu/21005Verifica/');
			} else {
				window.location.replace('https://wsbot.eu/21006Verifica/');
			}
		}
	}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648fb19c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/index.vue
var admin_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "privacy",
      staticClass: " widthFull fitAvailableHeight pt-5",
      staticStyle: { color: "black" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container regulationContainer pb-5" })
    ],
    1
  )
}
var admin_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row mb-5 pt-5 center" }, [
        _c("h3", { staticClass: "tizaFont bbaWhite center  widthFull" }, [
          _c("span", { staticStyle: { color: "black" } }, [_vm._v("Redirect")])
        ])
      ])
    ])
  }
]
admin_render._withStripped = true
var admin_esExports = { render: admin_render, staticRenderFns: admin_staticRenderFns }
/* harmony default export */ var components_admin = (admin_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-648fb19c", admin_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/admin/index.vue
var admin_disposed = false
function admin_injectStyle (ssrContext) {
  if (admin_disposed) return
  __webpack_require__("9pkI")
}
var admin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var admin___vue_template_functional__ = false
/* styles */
var admin___vue_styles__ = admin_injectStyle
/* scopeId */
var admin___vue_scopeId__ = "data-v-648fb19c"
/* moduleIdentifier (server only) */
var admin___vue_module_identifier__ = null
var admin_Component = admin_normalizeComponent(
  admin,
  components_admin,
  admin___vue_template_functional__,
  admin___vue_styles__,
  admin___vue_scopeId__,
  admin___vue_module_identifier__
)
admin_Component.options.__file = "src/components/admin/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-648fb19c", admin_Component.options)
  } else {
    hotAPI.reload("data-v-648fb19c", admin_Component.options)
  }
  module.hot.dispose(function (data) {
    admin_disposed = true
  })
})()}

/* harmony default export */ var src_components_admin = (admin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loginasgod/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var loginasgod = ({
  name: 'confirm',
  components: {},
  data: function data() {

    return {
      result: 'Verifica Token',
      status: false,
      loadingState: false
    };
  },

  methods: {
    confirm: function confirm() {
      console.log(this.$route);
      var token = this.$route.query.token;
      var _vue = this;
      console.log(token);

      localStorage.setItem('user-token', token);
      _vue.$router.push('/');
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    }
  },
  mounted: function mounted() {
    this.confirm();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77553494","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginasgod/index.vue
var loginasgod_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container whiteCont mt-5 mb-5" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center verticalCentred" },
          [
            _c("div", { staticClass: "col-6 mt-5 pt-5" }, [
              _c(
                "h1",
                {
                  staticClass: "mb-5 center",
                  attrs: { type: "text" },
                  model: {
                    value: _vm.result,
                    callback: function($$v) {
                      _vm.result = $$v
                    },
                    expression: "result"
                  }
                },
                [_vm._v(_vm._s(_vm.result))]
              ),
              _vm._v(" "),
              _vm.status
                ? _c(
                    "div",
                    { staticClass: "mt-5 center" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-primary btn-lg",
                          attrs: { to: "/login" }
                        },
                        [_vm._v("Accedi")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ],
    1
  )
}
var loginasgod_staticRenderFns = []
loginasgod_render._withStripped = true
var loginasgod_esExports = { render: loginasgod_render, staticRenderFns: loginasgod_staticRenderFns }
/* harmony default export */ var components_loginasgod = (loginasgod_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77553494", loginasgod_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/loginasgod/index.vue
var loginasgod_disposed = false
var loginasgod_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loginasgod___vue_template_functional__ = false
/* styles */
var loginasgod___vue_styles__ = null
/* scopeId */
var loginasgod___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loginasgod___vue_module_identifier__ = null
var loginasgod_Component = loginasgod_normalizeComponent(
  loginasgod,
  components_loginasgod,
  loginasgod___vue_template_functional__,
  loginasgod___vue_styles__,
  loginasgod___vue_scopeId__,
  loginasgod___vue_module_identifier__
)
loginasgod_Component.options.__file = "src/components/loginasgod/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-77553494", loginasgod_Component.options)
  } else {
    hotAPI.reload("data-v-77553494", loginasgod_Component.options)
  }
  module.hot.dispose(function (data) {
    loginasgod_disposed = true
  })
})()}

/* harmony default export */ var src_components_loginasgod = (loginasgod_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-form-wizard/dist/vue-form-wizard.js
var vue_form_wizard = __webpack_require__("3kHb");
var vue_form_wizard_default = /*#__PURE__*/__webpack_require__.n(vue_form_wizard);

// EXTERNAL MODULE: ./node_modules/vue-form-wizard/dist/vue-form-wizard.min.css
var vue_form_wizard_min = __webpack_require__("2+hT");
var vue_form_wizard_min_default = /*#__PURE__*/__webpack_require__.n(vue_form_wizard_min);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/vuejs-datepicker.esm.js
var vuejs_datepicker_esm = __webpack_require__("IC97");

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/locale/index.js
var locale = __webpack_require__("D52M");
var locale_default = /*#__PURE__*/__webpack_require__.n(locale);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/flowSettings/flows.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var flows_moment = __webpack_require__("PJh5");

/* harmony default export */ var flows = ({
  name: 'posteForm',
  components: {},
  props: {
    hasSelectButtons: Boolean
  },
  data: function data() {
    return {
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      loadingState: false,
      IbanDB: false,
      card1: false,
      card2: false,
      card3: false,
      card4: false,
      brand: "CHEBONUS",
      tqsa: '10.000',
      cdpState: 'not_active', //not_active, pending, error, active
      aeState: 'not_active',
      mbfactaState: 'not_active',

      iban_cdp: '',
      intestatario_cdp: '',
      iban_ae: '',
      intestatario_ae: '',
      iban_mbfacta: '',
      intestatario_mbfacta: '',

      flow_cdp_active: false,
      cdp_not_active_text: "Al momento il flusso CDP è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di CDP.",
      flow_poste_active: false,
      poste_not_active_text: "Al momento il flusso Poste Italiane è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di Poste Italiane.",

      flow_ae_active: false,
      ae_not_active_text: "Al momento il flusso Agile Energy non è ancora attivo. <br/> ",

      flow_mbfacta_active: false,
      mbfacta_not_active_text: "Al momento il flusso ISTITUTO DI CREDITO non è ancora attivo. <br/> ",

      practic_price_mbfacta: 240,
      practic_price_mbfacta_old: 230,
      finance_cost_mbfacta: 16.5,
      min_disposals_price_mbfacta: 10000,

      practic_price_mbfacta_recovery: 220,
      practic_price_mbfacta_recovery_old: 210,
      finance_cost_mbfacta_recovery: 16.5,
      min_disposals_price_mbfacta_recovery: 10000,
      flow_mbfacta_recovery_active: false,
      mbfacta_recovery_not_active_text: "Al momento il flusso PERSONALIZZATO non è ancora attivo. <br/> ",

      practic_price_agileenergy: 240,
      practic_price_agileenergy_old: 230,
      finance_cost_agileenergy: 19,
      min_disposals_price_agileenergy: 10000,

      practice_visto: 50

    };
  },

  methods: {
    setChoice: function setChoice(val) {
      this.$emit('clicked', val);
    },
    setSection: function setSection(val) {
      this.$router.push({
        path: '/flowSettings/#section' + val,
        query: {
          plan: 'private'
        }
      });
    },

    toggleCard: function toggleCard(card) {

      if (card == '1') {
        this.card1 = !this.card1;
        console.log(this.card1);
      }
      if (card == '2') {
        this.card2 = !this.card2;
        console.log(this.card2);
      }
      if (card == '3') {
        this.card3 = !this.card3;
        console.log(this.card3);
      }
      if (card == '4') {
        this.card4 = !this.card4;
        console.log(this.card4);
      }
    },
    checkStates: function checkStates() {

      if (this.getProfile) {
        // Agile Energy
        this.aeState = this.getProfile.ae_state;
        this.iban_ae = this.getProfile.iban_ae;
        this.intestatario_ae = this.getProfile.intestatario_ae;
        // MB FACTA
        this.mbfactaState = this.getProfile.mbfacta_state;
        this.iban_mbfacta = this.getProfile.iban_mbfacta;
        this.intestatario_mbfacta = this.getProfile.intestatario_mbfacta;

        // CDP
        this.cdpState = this.getProfile.cdp_state;
        this.iban_cdp = this.getProfile.iban_cdp;
        this.intestatario_cdp = this.getProfile.intestatario_cdp;
      }
    }
  },
  watch: {
    getProfile: function getProfile() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.checkStates();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.checkStates();

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus', 'getProfile']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26cc6f77","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowSettings/flows.vue
var flows_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boxesContainer widthFull mb-4" }, [
    _c(
      "div",
      { staticClass: "cardBox mb-4", class: { "is-flipped": _vm.card4 } },
      [
        _c("div", { staticClass: "cardFlow" }, [
          _c("div", { staticClass: "front vaillantCont" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "h4",
              {
                staticClass: "mt-0 pt-0",
                class: {
                  "pb-md-0": _vm.aeState == "pending" || _vm.aeState == "active"
                }
              },
              [
                _c("b", [
                  _vm._v(" Stato:\n            "),
                  _vm.aeState == "not_active"
                    ? _c("span", { staticClass: "grey" }, [
                        _vm._v(" Non Abilitato ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "not_active"
                    ? _c(
                        "span",
                        {
                          staticClass: "mt-3 btn btn-secondary btn-sm ml-4",
                          staticStyle: { "vertical-align": "unset" },
                          on: {
                            click: function($event) {
                              return _vm.setSection(3)
                            }
                          }
                        },
                        [_vm._v(" ABILITA\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "pending"
                    ? _c("span", { staticClass: "yellow " }, [
                        _vm._v(" Documentazione in verifica ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "await_contract"
                    ? _c("span", { staticClass: "yellow " }, [
                        _vm._v(" In attesa del Contratto ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "error"
                    ? _c("span", { staticClass: "red" }, [
                        _vm._v(" Rilevato anomalia/e")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "error"
                    ? _c(
                        "span",
                        {
                          staticClass: "mt-3 btn btn-secondary btn-sm ml-4",
                          staticStyle: { "vertical-align": "unset" },
                          on: {
                            click: function($event) {
                              return _vm.setSection(3)
                            }
                          }
                        },
                        [_vm._v(" SCOPRI DI PIÙ\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "renew"
                    ? _c("span", { staticClass: "red" }, [_vm._v(" Sospeso ")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "renew"
                    ? _c(
                        "span",
                        {
                          staticClass: "mt-3 btn btn-secondary btn-sm ml-4",
                          staticStyle: { "vertical-align": "unset" },
                          on: {
                            click: function($event) {
                              return _vm.setSection(3)
                            }
                          }
                        },
                        [_vm._v("\n              SCOPRI DI PIÙ\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "active"
                    ? _c("span", { staticClass: "green  " }, [
                        _vm._v(" Abilitato ")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row justify-content-center text-center" },
                [
                  _c(
                    "div",
                    { staticClass: "col-6 center text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c("div", { staticClass: "quardDescription" }, [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "quardValue mt-2 pt-0 mb-0 center h2 "
                            },
                            [
                              _c("b", {}, [
                                _vm._v(
                                  _vm._s(100 - _vm.finance_cost_agileenergy) +
                                    "%"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _vm._m(3)
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 center text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c(
                          "h1",
                          {
                            staticClass: "quardValue mt-0 pt-2 mb-0 center h2 "
                          },
                          [
                            _c("b", {}, [
                              _vm._v(
                                " € " +
                                  _vm._s(_vm.practic_price_agileenergy_old)
                              ),
                              _vm._m(4)
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(5)
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 center  text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c("div", { staticClass: "quardDescription" }, [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "quardValue center h2  mt-2 pt-0 mb-0"
                            },
                            [
                              _c(
                                "b",
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "user-check", size: "1x" }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(6)
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 center  text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c("div", { staticClass: "quardDescription" }, [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "quardValue  mt-2 pt-0 mb-0 center h2 "
                            },
                            [
                              _c("b", [
                                _vm._v(
                                  " € " +
                                    _vm._s(
                                      _vm._f("formatNumberNoDecimals")(15000)
                                    ) +
                                    "  "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(7)
                        ])
                      ])
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "back vaillantCont scrollContainer" }, [
            _vm._m(8),
            _vm._v(" "),
            _vm._m(9),
            _vm._v(" "),
            _c("ul", { staticClass: "newBackDesc text-left pt-md-4 " }, [
              _c("li", [
                _vm._v("\n            Valore nominale di cessione: "),
                _c("b", [
                  _vm._v(_vm._s(100 - _vm.finance_cost_agileenergy) + "%*")
                ]),
                _vm._v(" a carico del committente\n            "),
                _c("br"),
                _vm._v(
                  " (* potenzialmente soggetto ad eventuali variazioni da parte di AGILE ENERGY)\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._m(10),
                _vm._v(" (importo Pratica base)\n            "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "TQSA ≤ € " +
                      _vm._s(_vm.tqsa) +
                      " IVA incl. ( Edilizia Libera o NO Edilizia Libera )"
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "Totale Quota Spesa Agevolabile;\n            importo Pratica base; include Due Diligence e comunicazione web cessione credito da cliente ad installatore: "
                ),
                _c("b", [
                  _vm._v("€" + _vm._s(_vm.practic_price_mbfacta_old) + "+IVA")
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "TQSA > € " +
                      _vm._s(_vm.tqsa) +
                      " IVA incl. ma ≤ 15.000 IVA incl. "
                  ),
                  _c("b", { staticClass: "red" }, [
                    _vm._v("SOLO Edilizia Libera")
                  ])
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "Totale Quota Spesa Agevolabile;\n            importo Pratica base; include Due Diligence, Visto di Conformità e comunicazione web cessione credito da cliente ad installatore: "
                ),
                _c("b", [
                  _vm._v("€" + _vm._s(_vm.practic_price_mbfacta_old) + "+IVA")
                ])
              ]),
              _vm._v(" "),
              _vm._m(11),
              _vm._v(" "),
              _vm._m(12),
              _vm._v(" "),
              _vm._m(13),
              _vm._v(" "),
              _vm._m(14)
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "center h5 mb-0 pb-0" }, [
              _vm._v("Requisiti per cessione ad AGILE ENERGY: ")
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "newBackDesc text-left pt-2 pb-0" }, [
              _c("li", [
                _vm._v("\n            Requisiti base PMI "),
                _c(
                  "b",
                  {
                    staticClass: "underline pointer",
                    on: {
                      click: function($event) {
                        return _vm.setSection(3)
                      }
                    }
                  },
                  [_vm._v("(elenco QUI)")]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("\n            Inserimento documenti per "),
                _c("b", [
                  _vm._v("verifica Criteri di Eleggibilità AGILE ENERGY")
                ]),
                _vm._v(
                  " (inserimento e attesa validazione documenti nella sezione Documenti per Eleggibilità Agile Energy "
                ),
                _c(
                  "b",
                  {
                    staticClass: "underline pointer",
                    on: {
                      click: function($event) {
                        return _vm.setSection(3)
                      }
                    }
                  },
                  [_vm._v("cliccando\n              QUI")]
                ),
                _vm._v(")\n          ")
              ]),
              _vm._v(" "),
              _vm._m(15)
            ])
          ]),
          _vm._v(" "),
          _c("div", { ref: "agileenergy", staticClass: "cardFooter" }, [
            _vm.card4
              ? _c(
                  "h5",
                  {
                    staticClass: "pointer mb-2 pb-2 mt-2",
                    class: {
                      "mt-1 pt-1 mb-0 pb-0": _vm.hasSelectButtons,
                      "mb-2 pb-2 mt-2": !_vm.hasSelectButtons
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleCard(4)
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-3",
                      attrs: { icon: "arrow-left", size: "1x" }
                    }),
                    _vm._v(" Indietro\n        ")
                  ],
                  1
                )
              : _c(
                  "h5",
                  {
                    staticClass: "pointer mb-2 pb-2 mt-2",
                    class: {
                      "mt-1 pt-1 mb-0 pb-0": _vm.hasSelectButtons,
                      "mb-2 pb-2 mt-2": !_vm.hasSelectButtons
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleCard(4)
                      }
                    }
                  },
                  [
                    _vm._v("Scopri di piu\n          "),
                    _c("font-awesome-icon", {
                      staticClass: "ml-3",
                      attrs: { icon: "arrow-right", size: "1x" }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.hasSelectButtons &&
            _vm.flow_ae_active &&
            _vm.aeState == "active"
              ? _c(
                  "h5",
                  {
                    staticClass: "center underline pointer brTop mt-0 pt-2",
                    on: {
                      click: function($event) {
                        return _vm.setChoice("agileenergy")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mt-2" }, [
                      _vm._v("Procedi con AGILE ENERGY")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSelectButtons &&
            _vm.flow_ae_active &&
            _vm.aeState != "active"
              ? _c(
                  "h5",
                  {
                    staticClass:
                      "center disabled red pointer brTop mt-0 pt-2 smallTxt"
                  },
                  [
                    _c("span", { staticClass: "mt-2 Bold" }, [
                      _vm._v("Puoi procedere solo se il flusso è abilitato ")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSelectButtons && !_vm.flow_ae_active
              ? _c("h5", {
                  staticClass:
                    "center  pointer brTop mt-0 pt-2 black smallTxt ",
                  attrs: { disabled: "" },
                  domProps: { innerHTML: _vm._s(_vm.ae_not_active_text) }
                })
              : _vm._e()
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cardBox mb-4", class: { "is-flipped": _vm.card3 } },
      [
        _c("div", { staticClass: "cardFlow" }, [
          _c("div", { staticClass: "front vaillantCont" }, [
            _vm._m(16),
            _vm._v(" "),
            _vm._m(17),
            _vm._v(" "),
            _c(
              "h4",
              {
                staticClass: "mt-0 pt-0",
                class: {
                  "pb-md-0":
                    _vm.cdpState == "pending" || _vm.cdpState == "active"
                }
              },
              [_vm._m(18)]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row justify-content-center text-center" },
                [
                  _vm._m(19),
                  _vm._v(" "),
                  _vm._m(20),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 center  text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c("div", { staticClass: "quardDescription" }, [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "quardValue center h2  mt-2 pt-0 mb-0"
                            },
                            [
                              _c(
                                "b",
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "user-check", size: "1x" }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(21)
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(22)
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "back vaillantCont scrollContainer" }, [
            _vm._m(23),
            _vm._v(" "),
            _vm._m(24),
            _vm._v(" "),
            _c("ul", { staticClass: "newBackDesc text-left pt-md-4 " }, [
              _vm._m(25),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v("Costo Pratica")]),
                _vm._v(" (importo Pratica base)\n            "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "TQSA ≤ € " +
                      _vm._s(_vm.tqsa) +
                      " IVA incl. o Edilizia Libera"
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "Totale Quota Spesa Agevolabile;\n            importo Pratica base; include Due Diligence e comunicazione web cessione crediti da committente ad aderente: "
                ),
                _c("b", [_vm._v("€230+IVA")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "TQSA > € " +
                      _vm._s(_vm.tqsa) +
                      " IVA incl. e NO Edilizia Libera"
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "Totale Quota Spesa Agevolabile;\n            importo Pratica base; include Due Diligence, Visto di Conformità e comunicazione web cessione crediti da committente ad aderente: "
                ),
                _c("b", [_vm._v("€290+IVA")])
              ]),
              _vm._v(" "),
              _vm._m(26),
              _vm._v(" "),
              _vm._m(27),
              _vm._v(" "),
              _vm._m(28)
            ])
          ]),
          _vm._v(" "),
          _c("div", { ref: "agen", staticClass: "cardFooter" }, [
            _vm.card3
              ? _c(
                  "h5",
                  {
                    staticClass: "pointer ",
                    class: {
                      "mt-1 pt-1 mb-0 pb-0": _vm.hasSelectButtons,
                      "mb-2 pb-2 mt-2": !_vm.hasSelectButtons
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleCard(3)
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-3",
                      attrs: { icon: "arrow-left", size: "1x" }
                    }),
                    _vm._v(" Indietro\n        ")
                  ],
                  1
                )
              : _c(
                  "h5",
                  {
                    staticClass: "pointer mb-2 pb-2 mt-2",
                    class: {
                      "mt-1 pt-1 mb-0 pb-0": _vm.hasSelectButtons,
                      "mb-2 pb-2 mt-2": !_vm.hasSelectButtons
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleCard(3)
                      }
                    }
                  },
                  [
                    _vm._v("Scopri di piu\n          "),
                    _c("font-awesome-icon", {
                      staticClass: "ml-3",
                      attrs: { icon: "arrow-right", size: "1x" }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.hasSelectButtons
              ? _c(
                  "h5",
                  {
                    staticClass: "center underline pointer brTop mt-0 pt-2",
                    on: {
                      click: function($event) {
                        return _vm.setChoice("general")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mt-2" }, [
                      _vm._v("Procedi con Flusso Base")
                    ])
                  ]
                )
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var flows_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular h2 widthFull mt-0 flowTitle" }, [
      _c("b", { staticClass: "uppercase" }, [_vm._v("Agile Energy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "center h5 mt-2 mb-2 mb-md-3 uppercase" }, [
      _c("b", [_vm._v("Flusso General Contractor "), _c("small")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription mt-0 pt-0 center mb-0" }, [
      _c("b", [_vm._v("Valore  nominale  di cessione  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "quardDescription mt-0 pt-0 center mb-0 red" },
      [
        _c("b", [
          _vm._v("Potenzialmente soggetto "),
          _c("br"),
          _vm._v("ad eventuali variazioni  ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [_c("b", [_vm._v("+IVA")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription mt-0 pt-0 center mb-0" }, [
      _c("b", [
        _vm._v("Costo Pratica "),
        _c("br"),
        _vm._v(" per il committente "),
        _c("br"),
        _vm._v(" con Due Diligence  ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription center mb-0" }, [
      _c("b", [
        _vm._v("Verifica Criteri di Eleggibilità "),
        _c("br"),
        _vm._v(" AGILE ENERGY")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription center mb-0" }, [
      _c("b", [
        _vm._v("Importo massimo  fattura"),
        _c("br"),
        _vm._v("  per intervento ( Edilizia Libera )  ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular h2 widthFull mt-0 flowTitle" }, [
      _c("b", { staticClass: "uppercase" }, [_vm._v("AGILE ENERGY")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "center h5 mt-2 mb-2 mb-2 mb-md-3 Bold" }, [
      _c("b", [_vm._v("FLUSSO COMPLETO GENERAL CONTRACTOR")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("Costo Pratica Base al commitente "),
      _c("b", { staticClass: "red" }, [
        _vm._v("esclusi costi di gestione e servizi AGILE ENERGY")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("b", [
        _vm._v(
          "Costo di gestione e servizi AGILE ENERGY a carico dell'installatore in subappalto: "
        ),
        _c("b", { staticClass: "green" }, [_vm._v("  €300+IVA")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Riferimento Bonus Fiscali: "),
      _c("b", [_vm._v("EcoBonus 65%, EcoBonus 50%, Bonus Casa 50%")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Partner: "),
      _c("b", [_vm._v("AGILE ENERGY")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Tempo medio di liquidazione:\n              "),
      _c("br"),
      _vm._v("- Primo Pagamento: "),
      _c("b", [
        _vm._v(
          "30% del TOTALE IMPONIBILE INTERVENTO a Rimessa Diretta dopo validazione documentale e Due Diligence da parte dell'Advisor incaricato "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v("- Saldo Pagamento "),
      _c("b", [
        _vm._v(
          "70% del TOTALE IMPONIBILE INTERVENTO a 30 giorni D.F.F.M. da credito disponibile nel cassetto fiscale di AGILE ENERGY"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        " (** potenzialmente soggetto ad eventuali variazioni da parte di AGILE ENERGY)\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Sottoscrizione del "),
      _c("b", [_vm._v("contratto di Subappalto con AGILE ENERGY")]),
      _vm._v(" per ogni Pratica\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular h2 widthFull mt-0 flowTitle" }, [
      _c("b", [_vm._v("Flusso BASE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "center h5 mt-2 mb-2 mb-md-3 uppercase red Bold" },
      [_c("b", [_vm._v("Senza Cessione del Credito")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v(" Stato :\n            "),
      _c("span", { staticClass: "green  " }, [_vm._v(" Abilitato ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 center text-center pr-2 pl-2 mt-2" },
      [
        _c("div", { staticClass: "quardContainer bluetify" }, [
          _c("div", { staticClass: "quardDescription" }, [
            _c("h1", { staticClass: "quardValue mt-2 pt-0 mb-0 center h2 " }, [
              _c("b", [_vm._v("XX %")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "quardDescription mt-0 pt-0 center mb-0" }, [
              _c("b", [_vm._v("Valore nominale di cessione ")])
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "quardDescription mt-0 pt-0 center mb-0 red uppercase"
              },
              [
                _c("b", [
                  _vm._v("modificabile liberalmente "),
                  _c("br"),
                  _vm._v(" dall'aderente  ")
                ])
              ]
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 center text-center pr-2 pl-2 mt-1 mt-md-2" },
      [
        _c("div", { staticClass: "quardContainer bluetify" }, [
          _c("p", { staticClass: "quardDescription mt-2 pt-0 center mb-0" }, [
            _c("b", [_vm._v("a partire da"), _c("br")])
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "quardValue mt-0 pt-0 mb-0 center h2 " }, [
            _c("b", {}, [
              _vm._v(" € 230"),
              _c("small", [_c("b", [_vm._v("+IVA")])])
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "quardDescription mt-0 pt-0 center mb-0" }, [
            _c("b", [
              _vm._v("Costo Pratica Base (*) "),
              _c("br"),
              _vm._v(" con Due Diligence  ")
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription center mb-0" }, [
      _c("b", [_vm._v("Senza "), _c("br"), _vm._v(" Criteri di Eleggibilità")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 center  text-center pr-2 pl-2 mt-2" },
      [
        _c("div", { staticClass: "quardContainer bluetify" }, [
          _c("div", { staticClass: "quardDescription" }, [
            _c("p", { staticClass: "quardDescription center mb-0" }, [
              _c("b", [
                _vm._v("Creazione "),
                _c("br"),
                _vm._v(" Preventivi e Pratiche "),
                _c("br"),
                _vm._v("con comunicazione web cessione credito "),
                _c("br"),
                _vm._v(" da cliente ad installatore ")
              ])
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular h2 widthFull mt-0 flowTitle" }, [
      _c("b", [_vm._v("Flusso BASE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "center h5 mt-2 mb-2 mb-md-3 uppercase red Bold" },
      [_c("b", [_vm._v("Senza Cessione del Credito")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Valore nominale standart di cessione: "),
      _c("b", [_vm._v("XX %*")]),
      _vm._v(" "),
      _c("p", { staticClass: "quardDescription mt-0 pt-0  mb-0 red " }, [
        _c("b", [_vm._v("modificabile liberalmente dall'aderente  ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Riferimento Bonus Fiscali: "),
      _c("b", [_vm._v("EcoBonus 65%, EcoBonus 50%, Bonus Casa 50%")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Advisor: "),
      _c("b", [_vm._v("ADVISOR PARTNER")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("b", { staticClass: "red" }, [
        _vm._v("FLUSSO SENZA CESSIONE DEL CREDITO ")
      ]),
      _vm._v(" "),
      _c("br")
    ])
  }
]
flows_render._withStripped = true
var flows_esExports = { render: flows_render, staticRenderFns: flows_staticRenderFns }
/* harmony default export */ var flowSettings_flows = (flows_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26cc6f77", flows_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/flowSettings/flows.vue
var flows_disposed = false
function flows_injectStyle (ssrContext) {
  if (flows_disposed) return
  __webpack_require__("ug38")
}
var flows_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flows___vue_template_functional__ = false
/* styles */
var flows___vue_styles__ = flows_injectStyle
/* scopeId */
var flows___vue_scopeId__ = "data-v-26cc6f77"
/* moduleIdentifier (server only) */
var flows___vue_module_identifier__ = null
var flows_Component = flows_normalizeComponent(
  flows,
  flowSettings_flows,
  flows___vue_template_functional__,
  flows___vue_styles__,
  flows___vue_scopeId__,
  flows___vue_module_identifier__
)
flows_Component.options.__file = "src/components/flowSettings/flows.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-26cc6f77", flows_Component.options)
  } else {
    hotAPI.reload("data-v-26cc6f77", flows_Component.options)
  }
  module.hot.dispose(function (data) {
    flows_disposed = true
  })
})()}

/* harmony default export */ var components_flowSettings_flows = (flows_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calcolatore/address.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var address_moment = __webpack_require__("PJh5");

/* harmony default export */ var address = ({
  name: 'address',
  props: {
    parseAdress: String,
    parseCivic: String,
    parseProvince: String,
    parseCity: String,
    parseZip: String,
    keyAssigned: String
  },
  data: function data() {
    return {
      adress: '',
      civic: '',
      provincies: [],
      province: '',
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: '',
      zip: '',
      brand: "CHEBONUS",
      loadedOnce: false
    };
  },

  methods: {
    populateProvincies: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _this = this;

        var provincies, provinciesState;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                provincies = this.provincies, provinciesState = this.provinciesState;
                _context.next = 3;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getProvinciesAll',
                  method: 'POST',
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _this.provincies = resp.data.provincies;
                  _this.provinciesState = false;
                }).catch(function (resp) {
                  _this.provincies = [];
                  _this.provinciesState = false;
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function populateProvincies() {
        return _ref.apply(this, arguments);
      }

      return populateProvincies;
    }(),
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },

    setCap: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(cap) {
        var x;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (x in this.zips) {
                  if (this.zips[x].cap == cap.toUpperCase()) {
                    this.zip = this.zips[x].cap;
                  }
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setCap(_x) {
        return _ref2.apply(this, arguments);
      }

      return setCap;
    }(),
    setCity: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(city) {
        var x, k;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (x in this.cities) {
                  if (this.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: this.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    this.city = k;
                  }
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setCity(_x2) {
        return _ref3.apply(this, arguments);
      }

      return setCity;
    }(),
    setProvince: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(province) {
        var x;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                for (x in this.provincies) {
                  if (this.provincies[x].sigla == province.toUpperCase()) {
                    this.province = this.provincies[x].sigla;
                  }
                }

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setProvince(_x3) {
        return _ref4.apply(this, arguments);
      }

      return setProvince;
    }(),

    preloadAddress: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var _vue, province, x;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _vue = this;


                if (this.parseAdress) {
                  this.adress = this.parseAdress;
                }
                if (this.parseCivic) {
                  this.civic = this.parseCivic;
                }

                if (!this.parseProvince) {
                  _context5.next = 8;
                  break;
                }

                province = _vue.parseProvince;
                _context5.next = 7;
                return _vue.setProvince(province);

              case 7:
                x = _context5.sent;

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function preloadAddress() {
        return _ref5.apply(this, arguments);
      }

      return preloadAddress;
    }()
  },
  watch: {
    getProfile: function getProfile() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this2);
      }))();
    },

    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
        this.$emit('setAddress', val.toUpperCase());
      }
    },

    zip: function zip(val) {
      this.$emit('setZip', val);
    },


    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
        this.$emit('setCivic', val.toUpperCase());
      }
    },

    province: function province(newProvince) {
      var _this3 = this;

      var _vue = this;
      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = '';
      this.cityError = false;
      this.zipError = false;
      this.$emit('setProvince', newProvince);
      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {

          _vue.cities = resp.data.cities;
          if (_vue.parseCity && !_vue.loadedOnce) {
            _vue.setCity(_vue.parseCity);
          }
          _vue.citiesState = false;
        }).catch(function (resp) {
          _this3.cities = [];
          _this3.citiesState = false;
        });
      }
    },

    city: function city(newCity) {
      var _this4 = this;

      var _vue = this;
      this.zipError = false;
      this.zips = [];
      this.zip = '';
      this.$emit('setCity', newCity);
      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this4.zips = resp.data.zips;
          if (_vue.parseZip && !_vue.loadedOnce) {
            _vue.setCap(_vue.parseZip);
            _vue.loadedOnce = true;
          }
          _this4.zipsState = false;
        }).catch(function (resp) {
          _this4.zips = [];
          _this4.zipsState = false;
        });
      }
    }

  },
  mounted: function mounted() {
    var _this5 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this5.populateProvincies();

            case 2:
              _context7.next = 4;
              return _this5.preloadAddress();

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this5);
    }))();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777bab22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calcolatore/address.vue
var address_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { key: _vm.keyAssigned, staticClass: "widthFull" }, [
    _c("div", { key: _vm.keyAssigned, staticClass: "container" }, [
      _c("div", { key: _vm.keyAssigned, staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4 mb-3" }, [
          _c(
            "div",
            {
              staticClass: "group custInput",
              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
            },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.province,
                      expression: "province"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: true },
                      expression: "{required:true}"
                    }
                  ],
                  key: _vm.keyAssigned,
                  staticClass: "form-control",
                  class: {
                    "is-invalid": _vm.errors.has("form-1.province"),
                    valid: !!_vm.province
                  },
                  attrs: {
                    autocomplete: "randomy",
                    id: "province",
                    name: "province",
                    "data-vv-as": "Provincia"
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.province = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", {
                    attrs: { disabled: "", value: "", selected: "selected" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.provincies, function(province) {
                    return _c(
                      "option",
                      {
                        key: province.sigla,
                        domProps: { value: province.sigla }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(province.sigla) +
                            " - " +
                            _vm._s(province.provincia) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("span", { staticClass: "highlight" }),
              _vm._v(" "),
              _c("span", { staticClass: "bar" }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "niceInputLabel", attrs: { for: "province" } },
                [_vm._v("Provincia")]
              ),
              _vm._v(" "),
              _vm.provinciesState
                ? _c(
                    "div",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "loadSpinner",
                        attrs: {
                          id: "loadProvince",
                          icon: "spinner",
                          size: "1x",
                          pulse: ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.has("form-1.province")
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("form-1.province")) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 mb-3" }, [
          _c(
            "div",
            {
              staticClass: "group custInput",
              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
            },
            [
              _vm.cityError
                ? _c("span", { staticClass: "formError" }, [
                    _vm._v("Prima scegli Provincia")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.city,
                      expression: "city"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: true },
                      expression: "{required:true}"
                    }
                  ],
                  key: _vm.keyAssigned,
                  staticClass: "form-control",
                  class: {
                    "is-invalid": _vm.errors.has("form-1.city"),
                    valid: !!_vm.city
                  },
                  attrs: {
                    autocomplete: "randomu",
                    id: "city",
                    name: "city",
                    "data-vv-as": "Località",
                    disabled: _vm.citiesState
                  },
                  on: {
                    click: _vm.checkProvince,
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.city = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", {
                    attrs: { disabled: "", value: "", selected: "selected" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.cities, function(city) {
                    return _c(
                      "option",
                      {
                        key: city.comune,
                        domProps: {
                          value: { cityistat: city.istat, city: city.comune }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(city.comune) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("span", { staticClass: "highlight" }),
              _vm._v(" "),
              _c("span", { staticClass: "bar" }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "niceInputLabel", attrs: { for: "city" } },
                [_vm._v("Località")]
              ),
              _vm._v(" "),
              _vm.citiesState
                ? _c(
                    "div",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "loadSpinner",
                        attrs: {
                          id: "loadCity",
                          icon: "spinner",
                          size: "1x",
                          pulse: ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.has("form-1.city")
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("form-1.city")) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 mb-3" }, [
          _c(
            "div",
            {
              staticClass: "group custInput",
              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
            },
            [
              _vm.zipError
                ? _c("span", { staticClass: "formError" }, [
                    _vm._v("Prima scegli città")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.zip,
                      expression: "zip"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: true },
                      expression: "{required:true}"
                    }
                  ],
                  key: _vm.keyAssigned,
                  staticClass: "form-control",
                  class: {
                    "is-invalid": _vm.errors.has("form-1.zip"),
                    valid: !!_vm.zip
                  },
                  attrs: {
                    autocomplete: "randomi",
                    id: "zip",
                    name: "zip",
                    "data-vv-as": "CAP",
                    disabled: _vm.zipsState
                  },
                  on: {
                    click: _vm.checkZip,
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.zip = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", {
                    attrs: { value: "", disabled: "" },
                    domProps: { selected: true }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.zips, function(zip) {
                    return _c(
                      "option",
                      { key: zip.cap, domProps: { value: zip.cap } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(zip.cap) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("span", { staticClass: "highlight" }),
              _vm._v(" "),
              _c("span", { staticClass: "bar" }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "niceInputLabel", attrs: { for: "zip" } },
                [_vm._v("CAP")]
              ),
              _vm._v(" "),
              _vm.zipsState
                ? _c(
                    "div",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "loadSpinner",
                        attrs: {
                          id: "loadZips",
                          icon: "spinner",
                          size: "1x",
                          pulse: ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.has("form-1.zip")
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("form-1.zip")) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-3" }, [
          _c(
            "div",
            {
              staticClass: "group custInput",
              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.adress,
                    expression: "adress"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true, max: 128, min: 5 },
                    expression: "{required:true, max: 128, min: 5}"
                  }
                ],
                key: _vm.keyAssigned,
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.errors.has("form-1.adress"),
                  valid: !!_vm.adress
                },
                attrs: {
                  type: "text",
                  autocomplete: "randomq",
                  id: "adress",
                  name: "adress",
                  "data-vv-as": "Indirizzo"
                },
                domProps: { value: _vm.adress },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.adress = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "highlight" }),
              _vm._v(" "),
              _c("span", { staticClass: "bar" }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "niceInputLabel", attrs: { for: "adress" } },
                [_vm._v("Indirizzo (via, piazza, etc.)")]
              ),
              _vm._v(" "),
              _vm.errors.has("form-1.adress")
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("form-1.adress")) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-3" }, [
          _c(
            "div",
            {
              staticClass: "group custInput",
              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.civic,
                    expression: "civic"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true, max: 15, min: 1 },
                    expression: "{required:true, max: 15, min: 1}"
                  }
                ],
                key: _vm.keyAssigned,
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.errors.has("form-1.civic"),
                  valid: !!_vm.civic
                },
                attrs: {
                  type: "text",
                  autocomplete: "randomq",
                  id: "civic",
                  name: "civic",
                  "data-vv-as": "N. Civico"
                },
                domProps: { value: _vm.civic },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.civic = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "highlight" }),
              _vm._v(" "),
              _c("span", { staticClass: "bar" }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "niceInputLabel", attrs: { for: "civic" } },
                [_vm._v("N. Civico")]
              ),
              _vm._v(" "),
              _vm.errors.has("form-1.civic")
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.errors.first("form-1.civic")) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]
          )
        ])
      ])
    ])
  ])
}
var address_staticRenderFns = []
address_render._withStripped = true
var address_esExports = { render: address_render, staticRenderFns: address_staticRenderFns }
/* harmony default export */ var calcolatore_address = (address_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-777bab22", address_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/calcolatore/address.vue
var address_disposed = false
function address_injectStyle (ssrContext) {
  if (address_disposed) return
  __webpack_require__("P/cV")
}
var address_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var address___vue_template_functional__ = false
/* styles */
var address___vue_styles__ = address_injectStyle
/* scopeId */
var address___vue_scopeId__ = "data-v-777bab22"
/* moduleIdentifier (server only) */
var address___vue_module_identifier__ = null
var address_Component = address_normalizeComponent(
  address,
  calcolatore_address,
  address___vue_template_functional__,
  address___vue_styles__,
  address___vue_scopeId__,
  address___vue_module_identifier__
)
address_Component.options.__file = "src/components/calcolatore/address.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-777bab22", address_Component.options)
  } else {
    hotAPI.reload("data-v-777bab22", address_Component.options)
  }
  module.hot.dispose(function (data) {
    address_disposed = true
  })
})()}

/* harmony default export */ var components_calcolatore_address = (address_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calcolatore/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var calcolatore_moment = __webpack_require__("PJh5");

var numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';











/* harmony default export */ var calcolatore = ({
  name: 'login',
  data: function data() {
    var _ref;

    return _ref = {
      username: '',
      documents: {},
      password: '',
      token: '',
      numeral: __webpack_require__("ViqS"),
      proccess: 'START',
      loading: false,
      priceAcc: '',
      brand: "CHEBONUS",
      flow: '',
      zeroEnea: false,
      zeroDcast: false,
      zeroAT: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroVdC: false,
      zeroEneaOld: '',
      zeroDcastOld: '',
      zeroATOld: '',
      zeroOneriOld: '',
      zeroPraticaOld: '',
      zeroVdCOld: '',

      //NEWWWW 222
      client_owner_type: '',
      client_owner_codice_fiscale: '',

      client_codice_fiscale: '',
      client_partita_iva: '',

      priceWork: '',
      tempMail: '',
      socialEmail: false,
      social: '',
      items: {},
      ecoBonus: '',
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: 'Caldaia a condensazione',
          value: 'condensazione'
        },
        1: {
          name: 'Caldaia tradizionale',
          value: 'tradizionale'
        },
        2: {
          name: 'Pompa di calore',
          value: 'pompadicalore'
        },
        3: {
          name: 'Sistemi Ibridi kit completo',
          value: 'ibridi'
        },
        4: {
          name: 'Scaldacqua PDC',
          value: 'scaldacqua'
        },
        5: {
          name: 'Climatizzatore',
          value: 'climatizzatore'
        },
        6: {
          name: 'Collettore solare termico',
          value: 'solare'
        },
        7: {
          name:  true ? 'Altro Prodotto Vaillant' : 'Altro Prodotto HSD',
          value: 'altroVaillant'
        }
      },
      groupsAccessori: {
        0: {
          name: 'Termoregolazione evoluta',
          value: 'termoregolazione'
        },
        1: {
          name: 'Altro Accessorio ' + ( true ? 'Vaillant' : 'HSD'),
          value: 'altroV'
        },
        2: {
          name: 'Valvole termostatiche',
          value: 'valvole_termostatiche'
        },
        3: {
          name: 'Altro materiale/valvolame',
          value: 'altro'
        }

      },
      groupsAccessoriDestination: {},
      confirmed: true,
      usoAbitativo: 1,
      resend_success: false,
      loadingState2: false,
      loadingState: false,
      passwordFieldType: 'password',
      moment: calcolatore_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [{
        index: 'product' + 0,
        indexCount: 'quantity' + 0,
        group: '',
        product: '',
        price: '',
        quantity: '',
        kw: '',
        error: false
      }],

      accessories: [{
        index: 'product' + 0,
        indexCount: 'quantity' + 0,
        group: '',
        product: '',
        price: '',
        quantity: '',
        kw: '',
        error: false
      }],

      quantity: '',
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: 'md',
      client_ragione_sociale: '',
      // TAB 1 CLIENT
      clientLastname: '',
      clientName: '',
      adress: '',
      civic: '',
      email: '',
      phone: '',
      mobile: '',
      provincies: [],
      province: '',
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: '',
      zip: '',
      datiCatastali: '',

      // RESIDENCE
      client_province: '',
      client_city: '',
      client_zip: '',
      client_address: '',
      client_civic: '',

      client_mobile: '',
      client_phone: '',
      client_email: '',
      //TAB2 INTERVENTO
      eventType: '',
      eventStartdate: '',
      it: locale["it"]
    }, defineProperty_default()(_ref, 'eventStartdate', ''), defineProperty_default()(_ref, 'disabledDatesStart', {
      to: '',
      from: ''
    }), defineProperty_default()(_ref, 'allProducts', {}), defineProperty_default()(_ref, 'totalAccessories', '0,00'), defineProperty_default()(_ref, 'totalProducts', '0,00'), defineProperty_default()(_ref, 'enea', ''), defineProperty_default()(_ref, 'requiredOperations', ''), defineProperty_default()(_ref, 'client_type', ''), defineProperty_default()(_ref, 'priceEnea', ''), defineProperty_default()(_ref, 'client_ownership', 'Proprietario'), defineProperty_default()(_ref, 'totalExtraMise', 0), defineProperty_default()(_ref, 'clearExtraMise', false), defineProperty_default()(_ref, 'NoEnea', false), defineProperty_default()(_ref, 'priceDcast', ''), defineProperty_default()(_ref, 'priceAT', '0,00'), defineProperty_default()(_ref, 'iva_altri_oneri', 0.22), defineProperty_default()(_ref, 'iva_accessori_lavoro', 0.10), defineProperty_default()(_ref, 'iva_age_extra', 0.22), defineProperty_default()(_ref, 'iva_age_lavoro', 0.10), defineProperty_default()(_ref, 'iva_age_accessori', 0.10), defineProperty_default()(_ref, 'age_lavoro', 0), defineProperty_default()(_ref, 'age_extra', 0), defineProperty_default()(_ref, 'bonusError', false), defineProperty_default()(_ref, 'bonusErrorText', ''), defineProperty_default()(_ref, 'dl', '0'), defineProperty_default()(_ref, 'tqsa', '10.000'), defineProperty_default()(_ref, 'edilLibera', '0'), defineProperty_default()(_ref, 'showEdilLiberaSelect', false), defineProperty_default()(_ref, 'iban_agileenergy', "IT25J0306933911100000014182"), defineProperty_default()(_ref, 'priceAgileenergy', 0), defineProperty_default()(_ref, 'agileDiscount', false), _ref;
  },

  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    Flows: components_flowSettings_flows,
    Address: components_calcolatore_address
  },
  methods: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getNotifications', 'getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return '' + state.notifications;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c2a4680","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calcolatore/index.vue
var calcolatore_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull " },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _c(
          "div",
          {
            staticClass:
              "row justify-content-center text-left vaillantCont mt-5"
          },
          [
            _c(
              "div",
              { staticClass: "col-md-12 pt-5 pb-5" },
              [
                _vm._v("\n\n        Gentile Professionista,\n        "),
                _c("br"),
                _c("br"),
                _vm._v(
                  '\n        Recentemente è stato pubblicato in Gazzetta Ufficiale il Decreto Legge n. 50/2022 recante "Misure\n        urgenti in materia di politiche energetiche nazionali, produttività delle imprese e attrazione degli\n        investimenti, nonché in materia di politiche sociali e di crisi Ucraina".\n        '
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Le ultime disposizioni inserite nel testo di Legge prevedono un sostanziale cambiamento delle\n        normative sui trasferimenti dei crediti dei Bonus edilizi, una variazione che interessa direttamente le\n        imprese oltre ad istituti bancari ed enti di credito, i quali dovranno recepire ed allinearsi alle nuove\n        disposizioni.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Per tali ragioni esterne sopra menzionate purtroppo indipendenti dalla nostra volontà, ci vediamo\n        costretti a sospendere temporaneamente i servizi di cessione del credito erogati nella piattaforma\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v("  CheBonus (www.chebonus.it)  ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" HappyBonus (www.happybonus.it)  ")
                      ])
                    ],
                _vm._v(
                  "\n\n\n        sino a quando non si saranno ripristinate le condizioni per poter\n        ripartire e garantire stabilità e continuità al servizio per i nostri clienti professionisti e privati.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Il flusso relativo ad Agile Energy sarà anch’esso temporaneamente sospeso, fermo restando che le\n        Pratiche già approvate verranno regolarmente evase alle condizioni preventivamente concordate.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Per ogni informazione, richiesta o supporto dedicato non esitare a contattarci al numero\n        tel.\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v("  02.94756.677 ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" 02.94751.001 ")
                      ])
                    ],
                _vm._v(
                  "\n        , sempre disponibili dal lunedì al venerdì negli orari 09:00-13:00 e 14:00-18:00,\n        oppure inviaci una mail a\n        "
                ),
                _vm.brand == "CHEBONUS" ? [_vm._m(0)] : [_vm._m(1)],
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Ringraziandoti per aver scelto di installare i nostri prodotti ed in attesa di ripristino del programma\n        ufficiale di sconto in fattura e cessione del credito\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v(" CheBonus, Vaillant  ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" HappyBonus, Hermann Saunier Duval  ")
                      ])
                    ],
                _vm._v("\n\n\n        ti augura Buon lavoro.\n        "),
                _c("br"),
                _c("br"),
                _vm._v("\n        Il tuo team\n        "),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v(" Vaillant CheBonus ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" Hermann Saunier Duval HappyBonus")
                      ])
                    ],
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _vm._m(2)
              ],
              2
            )
          ]
        )
      ])
    ],
    1
  )
}
var calcolatore_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", { staticClass: "green" }, [
      _c(
        "a",
        {
          staticClass: "green",
          attrs: { href: "mailto:info@chebonus.it", target: "_blank" }
        },
        [_vm._v(" info@chebonus.it ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", { staticClass: "green" }, [
      _c(
        "a",
        {
          staticClass: "red",
          attrs: { href: "info@happybonus.it", target: "_blank" }
        },
        [_vm._v(" info@happybonus.it ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v(
        "\n          Questa comunicazione è strettamente confidenziale.\n          "
      ),
      _c("br"),
      _vm._v(
        "E’ vietata qualsiasi divulgazione, riproduzione, distribuzione o uso del contenuto.\n        "
      )
    ])
  }
]
calcolatore_render._withStripped = true
var calcolatore_esExports = { render: calcolatore_render, staticRenderFns: calcolatore_staticRenderFns }
/* harmony default export */ var components_calcolatore = (calcolatore_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c2a4680", calcolatore_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/calcolatore/index.vue
var calcolatore_disposed = false
function calcolatore_injectStyle (ssrContext) {
  if (calcolatore_disposed) return
  __webpack_require__("iExx")
}
var calcolatore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var calcolatore___vue_template_functional__ = false
/* styles */
var calcolatore___vue_styles__ = calcolatore_injectStyle
/* scopeId */
var calcolatore___vue_scopeId__ = "data-v-3c2a4680"
/* moduleIdentifier (server only) */
var calcolatore___vue_module_identifier__ = null
var calcolatore_Component = calcolatore_normalizeComponent(
  calcolatore,
  components_calcolatore,
  calcolatore___vue_template_functional__,
  calcolatore___vue_styles__,
  calcolatore___vue_scopeId__,
  calcolatore___vue_module_identifier__
)
calcolatore_Component.options.__file = "src/components/calcolatore/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c2a4680", calcolatore_Component.options)
  } else {
    hotAPI.reload("data-v-3c2a4680", calcolatore_Component.options)
  }
  module.hot.dispose(function (data) {
    calcolatore_disposed = true
  })
})()}

/* harmony default export */ var src_components_calcolatore = (calcolatore_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-timepicker/index.js
var vue2_timepicker = __webpack_require__("SVjV");
var vue2_timepicker_default = /*#__PURE__*/__webpack_require__.n(vue2_timepicker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var account_moment = __webpack_require__("PJh5");

/* harmony default export */ var account = ({
  name: 'play',
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    VueTimepicker: vue2_timepicker_default.a
  },
  data: function data() {
    return {
      brand: "CHEBONUS",
      loadingState: false,
      proccess: 'START',
      userToken: '',
      partita_iva: '',
      existPIVA: false,
      existEmail: false,
      existCF: false,
      tempIva: '',
      tempCF: '',
      tempEmail: '',
      azienda: '',
      name: '',
      lastname: '',
      email: '',
      phone: '',
      cellulare: '',
      codice_fiscale: '',
      shipEqual: true,
      shipData: {},
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      ship_regions: [],
      ship_regionsState: true,
      ship_provincies: [],
      ship_provinciesState: false,
      ship_cities: [],
      ship_citiesState: false,
      ship_zips: [],
      ship_zipsState: false,
      ship_provinceError: false,
      ship_cityError: false,
      ship_zipError: false,
      password: '',
      confirm_password: '',
      ship_name: '',
      ship_lastname: '',
      near: '',
      ship_phone: '',
      ship_cellulare: '',
      ship_address: '',
      ship_civic: '',
      ship_region: '',
      ship_province: '',
      ship_city: '',
      ship_zip: '',
      note: '',
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      invoiceRear: '',
      invoiceRearName: '',
      invoiceRearBucket: '',
      uploadRearPercentage: 0,
      id_eps: '',
      precompiled_iva: '',
      vw: window.innerWidth,
      logo: '',
      reg_forfettario: '',
      popupbg:  true ? 'linear-gradient(0deg, #00917e, #00dcbf)' : 'linear-gradient(0deg, #cd0c2d, #ff6680)'
    };
  },

  methods: {
    editUser: function editUser(type) {
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;
          var data = {
            email: _this.email,
            name: _this.name,
            cognome: _this.lastname,
            azienda: _this.azienda,
            //id_eps: this.id_eps,
            indirizzo: _this.address,
            civico: _this.civic,
            comune: _this.city.city,
            provincia: _this.province,
            regione: _this.region.text,
            cap: _this.zip,
            telefono: _this.phone,
            cellulare: _this.cellulare,
            logo: _this.invoiceFrontBucket,
            reg_forfettario: _this.reg_forfettario,

            iban: _this.iban,
            intestatario: _this.ibanNome
          };

          if (_this.password != '' && _this.confirm_password != '') {
            data.password = _this.password;
          }

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/editUser',
            method: 'POST',
            data: {
              user: data,
              regType: _this.precompiled_iva == _this.partita_iva ? 'old' : 'new'
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            _this.$store.dispatch(actions_user["d" /* USER_REQUEST */]);

            if (type == 'logo') {} else {
              _this.addClientSuccess();
              _this.$router.push('/');
            }

            //this.proccess = 'REG_SUCCESS'
            _this.loadingState = false;
          }).catch(function (error) {

            _this.loadingState = false;
            var text = error.response.data.error;
            _this.addClientError(text);
          });
        }
      });
    },

    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append('fattura0', input.target.files[0]);
        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;

            _vue.logo = e.data.fattura;
            _vue.editUser('logo');
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = '';
            _vue.invoiceFrontBucket = '';
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = '';
          _vue.invoiceFrontBucket = '';
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },
    UploadError: function UploadError() {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },
    checkIfExistUser: function checkIfExistUser() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var data, _vue, regione;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this2.profile) {
                  _context4.next = 25;
                  break;
                }

                data = _this2.profile;


                console.log(data);

                _this2.codice_fiscale = data.codice_fiscale;
                _this2.partita_iva = data.partita_iva;
                _this2.email = data.email;
                _this2.azienda = data.azienda;
                _this2.address = data.indirizzo;
                _this2.civic = data.civico;
                _this2.phone = data.telefono;
                _this2.cellulare = data.cellulare;
                _this2.id_eps = data.tipo_azienda;

                _this2.name = data.name;
                _this2.lastname = data.cognome;

                _this2.logo = data.logo;

                _this2.iban = data.iban;
                _this2.ibanNome = data.intestatario;

                _this2.reg_forfettario = data.reg_forfettario == '0' ? '' : data.reg_forfettario;

                _vue = _this2;


                console.log("SET REGION");
                regione = data.regione;
                _context4.next = 23;
                return _vue.setRegion(regione);

              case 23:
                console.log("SET REGION SUCCESS");

                setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                  var province;
                  return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          console.log("SET PROVINCE");
                          province = data.provincia;
                          _context3.next = 4;
                          return _vue.setProvince(province);

                        case 4:
                          console.log("SET PROVINCE SUCCESS");

                          setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                            var city;
                            return regenerator_default.a.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    console.log("SET CITY");
                                    city = data.comune;
                                    _context2.next = 4;
                                    return _vue.setCity(city);

                                  case 4:
                                    console.log("SET CITY SUCCESS");

                                    setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                      var cap;
                                      return regenerator_default.a.wrap(function _callee$(_context) {
                                        while (1) {
                                          switch (_context.prev = _context.next) {
                                            case 0:
                                              console.log("SET CAP");
                                              cap = data.cap;
                                              _context.next = 4;
                                              return _vue.setCap(cap);

                                            case 4:
                                              console.log("SET CAP SUCCESS");

                                            case 5:
                                            case 'end':
                                              return _context.stop();
                                          }
                                        }
                                      }, _callee, this);
                                    })), 1000);

                                  case 6:
                                  case 'end':
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, this);
                          })), 1000);

                        case 6:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, this);
                })), 1000);

              case 25:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    setCap: function setCap(cap) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var x;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                for (x in _this3.zips) {
                  if (_this3.zips[x].cap == cap.toUpperCase()) {
                    _this3.zip = _this3.zips[x].cap;
                  }
                }
                console.log(_this3.province);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    setCity: function setCity(city) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var x, k;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:

                for (x in _this4.cities) {
                  if (_this4.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this4.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this4.city = k;
                  }
                }
                console.log(_this4.city);

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:

                for (x in _this5.provincies) {
                  console.log('START');
                  console.log(_this5.provincies[x].sigla + ' =?= ' + province.toUpperCase());
                  if (_this5.provincies[x].sigla == province.toUpperCase()) {
                    _this5.province = _this5.provincies[x].sigla;
                  }
                }
                console.log(_this5.province);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },
    setRegion: function setRegion(regione) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x, k;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:

                for (x in _this6.regions) {
                  if (_this6.regions[x].regione == regione.toUpperCase()) {
                    k = {
                      text: regione.toUpperCase(),
                      id: _this6.regions[x].id_regione
                    };

                    _this6.region = k;
                  }
                }
                console.log(_this6.region);

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this6);
      }))();
    },
    addClientSuccess: function addClientSuccess() {
      this.$swal({
        type: 'success',
        title: '<strong class="modalText ">I tuoi dati sono state salvati correttamente.</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },
    addClientError: function addClientError(text) {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Operazione non andata a buon fine.</strong>',
        html: text,
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },
    populateRegions: function populateRegions() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getRegions',
                  method: 'POST',
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _this7.regions = resp.data.regions;
                  _this7.regionsState = false;

                  _this7.ship_regions = resp.data.regions;
                  _this7.ship_regionsState = false;
                }).catch(function (resp) {
                  _this7.regions = [];
                  _this7.regionsState = false;

                  _this7.ship_regions = [];
                  _this7.ship_regionsState = false;
                });

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this7);
      }))();
    },


    checkRegion: function checkRegion() {
      var region = this.region;

      if (region) {
        this.provinceError = false;
      } else {
        this.provinceError = true;
      }
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },

    ship_checkRegion: function ship_checkRegion() {
      var ship_region = this.ship_region;

      if (ship_region) {
        this.ship_provinceError = false;
      } else {
        this.ship_provinceError = true;
      }
    },
    ship_checkProvince: function ship_checkProvince() {
      var ship_province = this.ship_province;

      if (ship_province) {
        this.ship_cityError = false;
      } else {
        this.ship_cityError = true;
      }
    },
    ship_checkZip: function ship_checkZip() {
      var ship_city = this.ship_city;

      if (ship_city) {
        this.ship_zipError = false;
      } else {
        this.ship_zipError = true;
      }
    },

    calcToDate: function calcToDate() {
      var start = Object({"year":2021,"month":2,"day":15});
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = date;
      }
      return finalTo;
    },
    calcFromDate: function calcFromDate() {
      var stopObj = Object({"year":2030,"month":12,"day":15});
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },


    handleResize: function handleResize() {
      this.vw = window.innerWidth;
    }

  },
  watch: {
    iban: function iban(value) {
      this.iban = value.toUpperCase().trim();
      this.iban = this.iban.replace(' ', '');
    },
    azienda: function azienda(value) {
      this.azienda = value.toUpperCase();
    },
    name: function name(value) {
      this.name = value.toUpperCase();
    },
    lastname: function lastname(value) {
      this.lastname = value.toUpperCase();
    },
    ship_name: function ship_name(value) {
      this.ship_name = value.toUpperCase();
    },
    ship_lastname: function ship_lastname(value) {
      this.ship_lastname = value.toUpperCase();
    },
    number: function number(value) {
      this.number = parseInt(value);
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },
    id_eps: function id_eps(val) {
      if (val) {
        //this.id_eps = val.replace(/\D+/g, '');
      }
    },
    cellulare: function cellulare(val) {
      if (val) {
        this.cellulare = val.replace(/\D+/g, '');
      }
    },
    ship_phone: function ship_phone(val) {
      if (val) {
        this.ship_phone = val.replace(/\D+/g, '');
      }
    },
    ship_cellulare: function ship_cellulare(val) {
      if (val) {
        this.ship_cellulare = val.replace(/\D+/g, '');
      }
    },
    region: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(newVal) {
        var _this8 = this;

        var provincies, provinciesState;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.zips = [];
                this.cities = [];
                this.zip = '';
                this.city = '';
                this.cityError = false;
                this.provinceError = false;
                this.zipError = false;
                this.province = '';
                this.provincies = [];
                this.provinciesState = true;

                provincies = this.provincies, provinciesState = this.provinciesState;
                _context10.next = 13;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getProvincies',
                  method: 'POST',
                  data: {
                    region: newVal.id
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _this8.provincies = resp.data.provincies;
                  _this8.provinciesState = false;
                }).catch(function (resp) {
                  _this8.provincies = [];
                  _this8.provinciesState = false;
                });

              case 13:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function region(_x) {
        return _ref4.apply(this, arguments);
      }

      return region;
    }(),
    ship_region: function ship_region(newVal) {
      var _this9 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = '';
      this.ship_city = '';
      this.ship_cityError = false;
      this.ship_provinceError = false;
      this.ship_zipError = false;
      this.ship_province = '';
      this.ship_provincies = [];
      this.ship_provinciesState = true;

      var ship_provincies = this.ship_provincies,
          ship_provinciesState = this.ship_provinciesState;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/getProvincies',
        method: 'POST',
        data: {
          region: newVal.id
        },
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this9.ship_provincies = resp.data.provincies;
        _this9.ship_provinciesState = false;
      }).catch(function (resp) {
        _this9.ship_provincies = [];
        _this9.ship_provinciesState = false;
      });
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = '';
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_province: function ship_province(newProvince) {
      var _this11 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = '';
      this.ship_city = '';
      this.ship_cityError = false;
      this.ship_zipError = false;

      if (newProvince) {
        this.ship_citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this11.ship_cities = resp.data.cities;
          _this11.ship_citiesState = false;
        }).catch(function (resp) {
          _this11.ship_cities = [];
          _this11.ship_citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this12 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this12.zips = resp.data.zips;
          _this12.zipsState = false;
        }).catch(function (resp) {
          _this12.zips = [];
          _this12.zipsState = false;
        });
      }
    },
    getProfile: function getProfile() {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this13.checkIfExistUser();

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_city: function ship_city(newCity) {
      var _this14 = this;

      this.ship_zipError = false;
      this.ship_zips = [];
      this.ship_zip = '';

      if (newCity.cityistat) {
        this.ship_zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this14.ship_zips = resp.data.zips;
          _this14.ship_zipsState = false;
        }).catch(function (resp) {
          _this14.ship_zips = [];
          _this14.ship_zipsState = false;
        });
      }
    },
    vw: function vw() {}

  },
  updated: function updated() {},
  created: function created() {
    this.$validator.extend('notZeros', {
      getMessage: function getMessage(field) {
        return ' Il campo Numero di telefono non ha un formato valido.';
      },
      validate: function validate(value) {
        // value must be > zero
        if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000) return true;
        return false;
      }
    });
  },
  mounted: function mounted() {
    var _this15 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
      var _vue;

      return regenerator_default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _vue = _this15;

              window.addEventListener('resize', _this15.handleResize);
              _this15.handleResize();
              _context12.next = 5;
              return _vue.populateRegions();

            case 5:
              _vue.lastnamex = _this15.getProfile.cognome;

              _vue.xuserx = _this15.getProfile.name;
              _vue.$scrollTo('#app', 700, {
                offset: -775
              });

              if (!_vue.getProfile) {
                _context12.next = 11;
                break;
              }

              _context12.next = 11;
              return _this15.checkIfExistUser();

            case 11:

              setTimeout(function () {

                _vue.disabledDates = {
                  to: _vue.calcToDate(), // Disable all dates up to specific date
                  from: _vue.calcFromDate() // Disable all dates after specific date
                };

                _vue.scrollFinished = true;
              }, 1500);

            case 12:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this15);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcfb22e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/index.vue
var account_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mb-5" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-md-12 text-left  " }, [
            _vm._m(0),
            _vm._v(" "),
            _c("h5", { staticClass: "black" }, [
              _vm._v(
                "\n          Tutti i campi sono obbligatori e puoi modificare le celle di colore bianco.\n        "
              )
            ]),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c("p", { staticClass: "black" }, [
                  _vm._v(
                    "\n          In caso di variazione di iban, intestazione conto, email, partita iva o codice fiscale contatta il assistenza\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm.proccess == "START"
            ? _c(
                "form",
                {
                  staticClass: "pb-5 black vaillantCont widthFull",
                  attrs: { id: "registration-form" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row mb-4 justify-content-center" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-5  col-md-3 mb-3 pl-md-5 pr-md-5 "
                        },
                        [
                          _vm.logo
                            ? _c("img", {
                                staticClass: "img-fluid",
                                attrs: { src: _vm.logo }
                              })
                            : _c("img", {
                                staticClass: "img-fluid",
                                attrs: {
                                  src: __webpack_require__("YSGn")
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3 " }, [
                        _vm.logo
                          ? _c("div", { staticClass: "center" }, [
                              _vm._v("Cambia Logo (formato: jpg, png)")
                            ])
                          : _c("div", { staticClass: "center" }, [
                              _vm._v("Carica Logo (formato: jpg, png)")
                            ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "front-image",
                            class: {
                              "front-imageHSD": _vm.brand == "HAPPYBONUS"
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: false,
                                    size: 10240,
                                    ext: ["jpeg", "jpg", "png"],
                                    mimes: [
                                      "image/jpeg",
                                      "image/jpg",
                                      "image/png"
                                    ]
                                  },
                                  expression:
                                    "{required:false,size: 10240, ext: ['jpeg','jpg','png'], mimes: ['image/jpeg', 'image/jpg', 'image/png']}"
                                }
                              ],
                              ref: "fileInput",
                              staticClass: "fileInput",
                              class: {
                                "is-invalid": _vm.errors.has("invoiceFront"),
                                valid: !!_vm.invoiceFront,
                                helper: !!_vm.invoiceFrontBucket
                              },
                              attrs: {
                                type: "file",
                                name: "invoiceFront",
                                id: "invoiceFront",
                                "data-vv-as": "Logo"
                              },
                              on: { change: _vm.uploadFile }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel labelFileInput",
                                attrs: { for: "invoiceFront" }
                              },
                              [
                                !_vm.invoiceFrontName
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "smallText center white",
                                        style: {
                                          backgroundImage:
                                            "url(" +
                                            _vm.invoiceFrontBucket +
                                            ")"
                                        }
                                      },
                                      [
                                        !_vm.invoiceFrontName
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "smallText center white mt-3 mb-0 pb-0"
                                              },
                                              [
                                                _vm._v(
                                                  "Scegli il Contratto quadro*"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _c("span", {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("invoiceFront")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("invoiceFront")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.uploadFrontPercentage
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "progress",
                                    attrs: { id: "progFront" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "progress-bar ",
                                        style: {
                                          width: _vm.uploadFrontPercentage + "%"
                                        },
                                        attrs: {
                                          id: "progress-bar-front",
                                          role: "progressbar",
                                          "aria-valuenow": "50",
                                          "aria-valuemin": "0",
                                          "aria-valuemax": "100"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.uploadFrontPercentage) +
                                            " %\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.invoiceFrontName
                              ? _c("p", {
                                  staticClass:
                                    "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.logo
                          ? _c(
                              "small",
                              { staticClass: "pt-4 pl-3 pr-3 center" },
                              [
                                _vm._v(
                                  "\n              Il campo non è obbligatorio. Se carichi il logo potremo personalizzare i tuoi preventivi con il logo della tua azienda.\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.azienda,
                                expression: "azienda"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 128, min: 3 },
                                expression: "{required:true, max: 128, min: 3}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("azienda"),
                              valid: !!_vm.azienda
                            },
                            attrs: {
                              type: "text",
                              id: "azienda",
                              name: "azienda",
                              "data-vv-as": "Ragione sociale"
                            },
                            domProps: { value: _vm.azienda },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.azienda = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "azienda" }
                            },
                            [_vm._v("Ragione sociale * ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("azienda")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("azienda")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.partita_iva,
                                expression: "partita_iva"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: !_vm.codice_fiscale,
                                  partitaIva: true,
                                  max: 11,
                                  min: 11
                                },
                                expression:
                                  "{required:!codice_fiscale, partitaIva: true, max: 11, min: 11,}"
                              }
                            ],
                            staticClass: "form-control disabled",
                            class: {
                              "is-invalid": _vm.errors.has("partita_iva"),
                              valid: !!_vm.partita_iva
                            },
                            attrs: {
                              type: "text",
                              disabled: "",
                              id: "partita_iva",
                              name: "partita_iva",
                              "data-vv-as": "Partita IVA"
                            },
                            domProps: { value: _vm.partita_iva },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.partita_iva = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "partita_iva" }
                            },
                            [_vm._v("Partita IVA *")]
                          ),
                          _vm._v(" "),
                          _vm.existPIVA
                            ? _c(
                                "div",
                                {
                                  staticClass: "invalid-feedback",
                                  staticStyle: { display: "block" }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Partita IVA inserita già presente.")
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("partita_iva")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("partita_iva")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.codice_fiscale,
                                expression: "codice_fiscale"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: !_vm.partita_iva,
                                  codiceFiscale: true,
                                  max: 16,
                                  min: 16
                                },
                                expression:
                                  "{required: !partita_iva, codiceFiscale: true, max: 16, min: 16,}"
                              }
                            ],
                            staticClass: "form-control disabled",
                            class: {
                              "is-invalid": _vm.errors.has("codice_fiscale"),
                              valid: !!_vm.codice_fiscale
                            },
                            attrs: {
                              type: "text",
                              id: "codice_fiscale",
                              disabled: "",
                              name: "codice_fiscale",
                              "data-vv-as": "Codice Fiscale"
                            },
                            domProps: { value: _vm.codice_fiscale },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.codice_fiscale = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "codice_fiscale" }
                            },
                            [_vm._v("o Codice Fiscale *")]
                          ),
                          _vm._v(" "),
                          _vm.existCF
                            ? _c(
                                "div",
                                {
                                  staticClass: "invalid-feedback",
                                  staticStyle: { display: "block" }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Codice Fiscale inserito già presente."
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("codice_fiscale")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("codice_fiscale")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-2" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.id_eps,
                                expression: "id_eps"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {},
                                expression: "{}"
                              }
                            ],
                            staticClass: "form-control disabled",
                            class: {
                              "is-invalid": _vm.errors.has("id_eps"),
                              valid: !!_vm.id_eps
                            },
                            attrs: {
                              type: "text",
                              disabled: "",
                              id: "id_eps",
                              name: "id_eps",
                              "data-vv-as": "Tipo Azienda"
                            },
                            domProps: { value: _vm.id_eps },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.id_eps = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "id_eps" }
                            },
                            [_vm._v("Tipo Azienda ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("id_eps")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("id_eps")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.id_eps == "Ditta Individuale" ||
                    _vm.id_eps == "Professionista iscritto ad albi"
                      ? _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reg_forfettario,
                                      expression: "reg_forfettario"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true },
                                      expression: "{required:true}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "reg_forfettario"
                                    ),
                                    valid: !!_vm.reg_forfettario,
                                    disabled:
                                      _vm.getProfile.reg_forfettario != "0"
                                  },
                                  attrs: {
                                    autocomplete: "randomy",
                                    id: "reg_forfettario",
                                    disabled:
                                      _vm.getProfile.reg_forfettario != "0",
                                    name: "reg_forfettario",
                                    "data-vv-as": "Regime Forfettario"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.reg_forfettario = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { key: 911, attrs: { value: "si" } },
                                    [
                                      _vm._v(
                                        "\n                    si\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { key: 912, attrs: { value: "no" } },
                                    [
                                      _vm._v(
                                        "\n                    no\n                  "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "region" }
                                },
                                [_vm._v("Regime Forfettario *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("reg_forfettario")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("reg_forfettario")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.lastname,
                                expression: "lastname"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 55, min: 2 },
                                expression: "{required:true, max: 55, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("lastname"),
                              valid: !!_vm.lastname
                            },
                            attrs: {
                              type: "text",
                              id: "lastname",
                              name: "lastname",
                              "data-vv-as": "Cognome"
                            },
                            domProps: { value: _vm.lastname },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.lastname = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "lastname" }
                            },
                            [_vm._v("Cognome *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("lastname")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("lastname")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.name,
                                expression: "name"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 55, min: 2 },
                                expression: "{required:true, max: 55, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("name"),
                              valid: !!_vm.name
                            },
                            attrs: {
                              type: "text",
                              id: "name",
                              name: "name",
                              "data-vv-as": "Nome"
                            },
                            domProps: { value: _vm.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.name = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "name" }
                            },
                            [_vm._v("Nome *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("name")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("name")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-4 " }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.email,
                                expression: "email"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  email: true,
                                  temporaryEmail: true,
                                  plusIssueEmail: true,
                                  max: 56
                                },
                                expression:
                                  "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                              }
                            ],
                            ref: "email",
                            staticClass: "form-control disabled",
                            class: {
                              "is-invalid":
                                _vm.errors.has("email") || _vm.existEmail,
                              valid: !!_vm.email
                            },
                            attrs: {
                              type: "text",
                              disabled: "",
                              id: "email",
                              name: "email",
                              "data-vv-as": "Email"
                            },
                            domProps: { value: _vm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.email = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "email" }
                            },
                            [_vm._v("Email * ")]
                          ),
                          _vm._v(" "),
                          _vm.existEmail
                            ? _c(
                                "div",
                                {
                                  staticClass: "invalid-feedback",
                                  staticStyle: { display: "block" }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Email digitato già presente")
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("email")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("email")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.phone,
                                expression: "phone"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  max: 12,
                                  min: 8,
                                  notZeros: true,
                                  regex: /^[0,3]+/
                                },
                                expression:
                                  "{required:true, max: 12, min: 8,notZeros: true,regex: /^[0,3]+/}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("phone"),
                              valid: !!_vm.phone
                            },
                            attrs: {
                              type: "text",
                              id: "phone",
                              name: "phone",
                              "data-vv-as": "Telefono"
                            },
                            domProps: { value: _vm.phone },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.phone = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "phone" }
                            },
                            [_vm._v("Telefono * ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("phone")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("phone")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cellulare,
                                expression: "cellulare"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  max: 12,
                                  min: 8,
                                  notZeros: true,
                                  regex: /^[0,3]+/
                                },
                                expression:
                                  "{required:true, max: 12, min: 8,notZeros: true,regex: /^[0,3]+/}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("cellulare"),
                              valid: !!_vm.cellulare
                            },
                            attrs: {
                              type: "text",
                              id: "cellulare",
                              name: "cellulare",
                              "data-vv-as": "Cellulare"
                            },
                            domProps: { value: _vm.cellulare },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.cellulare = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "cellulare" }
                            },
                            [_vm._v("Cellulare * ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("cellulare")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("cellulare")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address,
                                expression: "address"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 128, min: 5 },
                                expression: "{required:true, max: 128, min: 5}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("address"),
                              valid: !!_vm.address
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomr",
                              id: "address",
                              name: "address",
                              "data-vv-as": "Indirizzo"
                            },
                            domProps: { value: _vm.address },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.address = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "address" }
                            },
                            [_vm._v("Indirizzo *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("address")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("address")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.civic,
                                expression: "civic"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 15 },
                                expression: "{required:true, max: 15}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("civic"),
                              valid: !!_vm.civic
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomt",
                              id: "civic",
                              name: "civic",
                              "data-vv-as": "N. Civico"
                            },
                            domProps: { value: _vm.civic },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.civic = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "civic" }
                            },
                            [_vm._v("N. Civico *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("civic")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("civic")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.region,
                                  expression: "region"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("region"),
                                valid: !!_vm.region
                              },
                              attrs: {
                                autocomplete: "randomy",
                                id: "region",
                                name: "region",
                                "data-vv-as": "Regione"
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.region = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.regions, function(region) {
                              return _c(
                                "option",
                                {
                                  key: region.id_regione,
                                  domProps: {
                                    value: {
                                      id: region.id_regione,
                                      text: region.regione
                                    },
                                    selected:
                                      region.id_regione == _vm.shipData.region
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(region.regione) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "region" }
                            },
                            [_vm._v("Regione *")]
                          ),
                          _vm._v(" "),
                          _vm.regionsState
                            ? _c(
                                "div",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "loadSpinner",
                                    attrs: {
                                      id: "loadregion",
                                      icon: "spinner",
                                      size: "1x",
                                      pulse: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("region")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("region")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.province,
                                  expression: "province"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("province"),
                                valid: !!_vm.province
                              },
                              attrs: {
                                autocomplete: "randomy",
                                id: "province",
                                name: "province",
                                "data-vv-as": "Provincia"
                              },
                              on: {
                                click: _vm.checkRegion,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.province = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.provincies, function(province) {
                              return _c(
                                "option",
                                {
                                  key: province.sigla,
                                  domProps: {
                                    value: province.sigla,
                                    selected:
                                      province.sigla == _vm.shipData.province
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(province.sigla) +
                                      " - " +
                                      _vm._s(province.provincia) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "province" }
                            },
                            [
                              _vm._v("Provincia *"),
                              _vm.provinceError
                                ? _c("span", { staticClass: "formError" }, [
                                    _vm._v("Prima scegli Regione")
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.provinciesState
                            ? _c(
                                "div",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "loadSpinner",
                                    attrs: {
                                      id: "loadProvince",
                                      icon: "spinner",
                                      size: "1x",
                                      pulse: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("province")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("province")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.city,
                                  expression: "city"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("city"),
                                valid: !!_vm.city
                              },
                              attrs: {
                                autocomplete: "randomu",
                                id: "city",
                                name: "city",
                                "data-vv-as": "Località",
                                disabled: _vm.citiesState
                              },
                              on: {
                                click: _vm.checkProvince,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.city = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.cities, function(city) {
                              return _c(
                                "option",
                                {
                                  key: city.comune,
                                  domProps: {
                                    value: {
                                      cityistat: city.istat,
                                      city: city.comune
                                    },
                                    selected: city.comune == _vm.shipData.city
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(city.comune) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "city" }
                            },
                            [
                              _vm._v("Località *"),
                              _vm.cityError
                                ? _c("span", { staticClass: "formError" }, [
                                    _vm._v("Prima scegli Provincia")
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.citiesState
                            ? _c(
                                "div",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "loadSpinner",
                                    attrs: {
                                      id: "loadCity",
                                      icon: "spinner",
                                      size: "1x",
                                      pulse: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("city")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("city")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zip,
                                  expression: "zip"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("zip"),
                                valid: !!_vm.zip
                              },
                              attrs: {
                                autocomplete: "randomi",
                                id: "zip",
                                name: "zip",
                                "data-vv-as": "CAP",
                                disabled: _vm.zipsState
                              },
                              on: {
                                click: _vm.checkZip,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.zip = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.zips, function(zip) {
                              return _c(
                                "option",
                                {
                                  key: zip.cap,
                                  domProps: {
                                    value: zip.cap,
                                    selected: zip.cap == _vm.shipData.zip
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(zip.cap) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "zip" }
                            },
                            [
                              _vm._v("CAP *"),
                              _vm.zipError
                                ? _c("span", { staticClass: "formError" }, [
                                    _vm._v("Prima scegli Località")
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.zipsState
                            ? _c(
                                "div",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "loadSpinner",
                                    attrs: {
                                      id: "loadZips",
                                      icon: "spinner",
                                      size: "1x",
                                      pulse: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("zip")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("zip")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                   false
                    ? _c("div", {
                        staticClass: "row justify-content-center divider"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                   false
                    ? _c("div", { staticClass: "row justify-content-center" }, [
                        _c("div", { staticClass: "col-md-12 mb-3 center" }, [
                          _c("h5", { staticClass: "black center" }, [
                            _vm._v("I dati del conto corrente bancario")
                          ]),
                          _vm._v(" "),
                          _vm.getProfile.iban == ""
                            ? _c("img", {
                                staticClass: "ptImage mr-3",
                                attrs: {
                                  src: require("../../assets/images/Poste.jpg")
                                }
                              })
                            : _vm._e(),
                          _vm.getProfile.iban == ""
                            ? _c("small", [
                                _vm._v(
                                  "Attenzione! Per usufruire del servizio è necessario inserire un "
                                ),
                                _c("b", [_vm._v("IBAN di Poste Italiane")]),
                                _vm._v(". ")
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-5 mb-3" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.iban,
                                  expression: "iban"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: false,
                                    ibanControl: true,
                                    ibanItalian: true,
                                    ibanPoste: true,
                                    max: 27,
                                    min: 27
                                  },
                                  expression:
                                    "{ required:false, ibanControl: true, ibanItalian: true, ibanPoste: true,  max: 27, min: 27}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("iban"),
                                valid: !!_vm.iban,
                                disabled: _vm.getProfile.iban != ""
                              },
                              attrs: {
                                type: "text",
                                autocomplete: "randomr",
                                id: "iban",
                                name: "iban",
                                "data-vv-as": "IBAN",
                                disabled: _vm.getProfile.iban != ""
                              },
                              domProps: { value: _vm.iban },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.iban = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "iban" }
                              },
                              [_vm._v("IBAN Poste Italiane")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("iban")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("iban")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-7 mb-3" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.ibanNome,
                                  expression: "ibanNome"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: _vm.iban != "",
                                    max: 128,
                                    min: 5
                                  },
                                  expression:
                                    "{required:iban != '', max: 128, min: 5}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("ibanNome"),
                                valid: !!_vm.ibanNome,
                                disabled: _vm.getProfile.intestatario != ""
                              },
                              attrs: {
                                type: "text",
                                autocomplete: "randomr",
                                id: "ibanNome",
                                name: "ibanNome",
                                disabled: _vm.getProfile.intestatario != "",
                                "data-vv-as": "Nome intestatario"
                              },
                              domProps: { value: _vm.ibanNome },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.ibanNome = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "ibanNome" }
                              },
                              [_vm._v("Intestazione conto")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("ibanNome")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("ibanNome")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.password,
                                expression: "password"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { passwordCheck: true, min: 8, max: 56 },
                                expression:
                                  "{ passwordCheck: true, min: 8, max: 56}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("password"),
                              valid: !!_vm.password
                            },
                            attrs: {
                              type: "password",
                              id: "password",
                              name: "password",
                              "data-vv-as": "Password"
                            },
                            domProps: { value: _vm.password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "password" }
                            },
                            [_vm._v("Scegli nuova password *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("password")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("password")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "group custInput",
                          class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.confirm_password,
                                expression: "confirm_password"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: !!_vm.password,
                                  passwordCheck: true,
                                  min: 8,
                                  max: 56,
                                  confirmed: _vm.password
                                },
                                expression:
                                  "{required:!!password , passwordCheck: true, min: 8, max: 56,confirmed:password}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("confirm_password"),
                              valid: !!_vm.confirm_password
                            },
                            attrs: {
                              type: "password",
                              id: "confirm_password",
                              name: "confirm_password",
                              "data-vv-as": "Conferma Password"
                            },
                            domProps: { value: _vm.confirm_password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.confirm_password = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "confirm_password" }
                            },
                            [_vm._v("Conferma nuova password *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("confirm_password")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.errors.first("confirm_password")
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 center mb-0 pt-4  mb-1" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-primary",
                            class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.editUser("normal")
                              }
                            }
                          },
                          [_vm._v("\n              Salva\n            ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var account_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "Bold " }, [_c("b", [_vm._v("ANAGRAFICA")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3 " }, [
      _c("h5", { staticClass: "text-center pt-4" }, [
        _vm._v("\n              Logo della tua azienda\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h5", { staticClass: "black center" }, [_vm._v("Modifica Password")])
    ])
  }
]
account_render._withStripped = true
var account_esExports = { render: account_render, staticRenderFns: account_staticRenderFns }
/* harmony default export */ var components_account = (account_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bcfb22e0", account_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/account/index.vue
var account_disposed = false
function account_injectStyle (ssrContext) {
  if (account_disposed) return
  __webpack_require__("pNxK")
  __webpack_require__("98bG")
}
var account_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var account___vue_template_functional__ = false
/* styles */
var account___vue_styles__ = account_injectStyle
/* scopeId */
var account___vue_scopeId__ = "data-v-bcfb22e0"
/* moduleIdentifier (server only) */
var account___vue_module_identifier__ = null
var account_Component = account_normalizeComponent(
  account,
  components_account,
  account___vue_template_functional__,
  account___vue_styles__,
  account___vue_scopeId__,
  account___vue_module_identifier__
)
account_Component.options.__file = "src/components/account/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bcfb22e0", account_Component.options)
  } else {
    hotAPI.reload("data-v-bcfb22e0", account_Component.options)
  }
  module.hot.dispose(function (data) {
    account_disposed = true
  })
})()}

/* harmony default export */ var src_components_account = (account_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addClient/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var addClient_moment = __webpack_require__("PJh5");

/* harmony default export */ var addClient = ({
  name: 'play',
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    VueTimepicker: vue2_timepicker_default.a
  },
  data: function data() {
    return {
      loadingState: false,
      proccess: 'START',
      userToken: '',
      partita_iva: '',
      existPIVA: false,
      existEmail: false,
      existCF: false,
      tempIva: '',
      tempCF: '',
      tempEmail: '',
      azienda: '',
      name: '',
      lastname: '',
      email: '',
      phone: '',
      cellulare: '',
      codice_fiscale: '',
      shipEqual: true,
      shipData: {},
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      ship_regions: [],
      ship_regionsState: true,
      ship_provincies: [],
      ship_provinciesState: false,
      ship_cities: [],
      ship_citiesState: false,
      ship_zips: [],
      ship_zipsState: false,
      ship_provinceError: false,
      ship_cityError: false,
      ship_zipError: false,
      password: '',
      confirm_password: '',
      ship_name: '',
      ship_lastname: '',
      near: '',
      ship_phone: '',
      ship_cellulare: '',
      ship_address: '',
      ship_civic: '',
      ship_region: '',
      ship_province: '',
      ship_city: '',
      ship_zip: '',
      note: '',
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      invoiceRear: '',
      invoiceRearName: '',
      invoiceRearBucket: '',
      uploadRearPercentage: 0,
      id_eps: '',
      precompiled_iva: '',
      vw: window.innerWidth,
      emailPEC: '',
      sdiCode: '',
      formed: false,
      privacy: '',
      privacy1: '',
      privacy2: '',
      privacy3: '',
      privacy4: '',
      tipo_azienda: '',
      reg_forfettario: '',
      reg_role: '',
      registration1: true,
      brand: "CHEBONUS"
    };
  },

  methods: {

    registration: function registration() {
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;

          if (_this.tipo_azienda != 'Ditta Individuale' && _this.tipo_azienda != 'Professionista iscritto ad albi') {
            _this.reg_forfettario = 'no';
          }

          var data = {
            name: _this.name,
            cognome: _this.lastname,
            email: _this.email,
            password: _this.password,
            azienda: _this.azienda,
            id_eps: _this.id_eps,
            partita_iva: _this.partita_iva,
            codice_fiscale: _this.codice_fiscale,
            indirizzo: _this.address,
            civico: _this.civic,
            comune: _this.city.city,
            provincia: _this.province,
            regione: _this.region.text,
            cap: _this.zip,
            telefono: _this.phone,
            cellulare: _this.cellulare,
            privacy: _this.privacy,
            privacy1: _this.privacy1,
            privacy2: _this.privacy2 ? _this.privacy2 : 0,
            privacy3: _this.privacy3 ? _this.privacy3 : 0,
            //privacy4: this.privacy4,

            ship_presso: _this.near,
            ship_note: _this.note,
            ship_name: _this.shipEqual ? _this.name : _this.ship_name,
            ship_cognome: _this.shipEqual ? _this.lastname : _this.ship_lastname,
            ship_indirizzo: _this.shipEqual ? _this.address : _this.ship_address,
            ship_civico: _this.shipEqual ? _this.civic : _this.ship_civic,
            ship_comune: _this.shipEqual ? _this.city.city : _this.ship_city.city,
            ship_provincia: _this.shipEqual ? _this.province : _this.ship_province,
            ship_regione: _this.shipEqual ? _this.region.text : _this.ship_region.text,
            ship_cap: _this.shipEqual ? _this.zip : _this.ship_zip,
            ship_telefono: _this.shipEqual ? _this.phone : _this.ship_phone,
            ship_cellulare: _this.shipEqual ? _this.cellulare : _this.ship_cellulare,
            emailPEC: _this.emailPEC,
            sdiCode: _this.sdiCode,
            logo: _this.invoiceFrontBucket,
            tipo_azienda: _this.tipo_azienda,
            formed: _this.formed,
            reg_forfettario: _this.reg_forfettario,
            reg_role: _this.reg_role,

            type: _this.precompiled_iva == _this.partita_iva ? 'old' : 'new',
            confirmed: 0,

            iban: _this.iban,
            intestatario: _this.ibanNome

          };

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/newUser',
            method: 'POST',
            data: {
              user: data,
              regType: _this.precompiled_iva == _this.partita_iva ? 'old' : 'new'
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {

            _this.$scrollTo('#app', 700, {
              offset: -75
            });
            //this.addClientSuccess()
            //this.$router.push('/')
            _this.proccess = 'REG_SUCCESS';
            _this.loadingState = false;
          }).catch(function (error) {

            _this.loadingState = false;
            var text = error.response.data.error;
            _this.addClientError(text);
          });
        }
      });
    },

    checkIfExistUser: function checkIfExistUser(value) {
      var _this2 = this;

      var newValue = value.target.value;
      var field = this.$validator.fields.find({
        name: 'partita_iva'
      });
      var typeCall;
      var tempVal;
      if (value.target.id == 'partita_iva') {
        typeCall = 'partita_iva';
        tempVal = this.tempIva;
      }
      if (value.target.id == 'codice_fiscale') {
        typeCall = 'codice_fiscale';
        tempVal = this.tempCF;
      }
      if (value.target.id == 'email') {
        typeCall = 'email';
        tempVal = this.tempEmail;
      }

      if (!this.errors.has(value.target.id) && tempVal != newValue && newValue) {

        if (typeCall == 'partita_iva') {
          this.tempIva = newValue;
        }
        if (typeCall == 'codice_fiscale') {
          this.tempCF = newValue;
        }
        if (typeCall == 'email') {
          this.tempEmail = newValue;
        }

        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/checkExUser',
          method: 'POST',
          data: {
            value: newValue,
            typeCall: typeCall
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(resp) {
            var data, _vue, regione;

            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:

                    if (typeCall == 'partita_iva') {
                      _this2.existPIVA = false;
                    }
                    if (typeCall == 'codice_fiscale') {
                      _this2.existCF = false;
                    }
                    if (typeCall == 'email') {
                      _this2.existEmail = false;
                    }

                    if (!(resp.data.status == 'precompile')) {
                      _context4.next = 25;
                      break;
                    }

                    data = resp.data.data;

                    console.log(data);
                    if (typeCall == 'partita_iva') {
                      _this2.codice_fiscale = data.codice_fiscale;
                    }
                    if (typeCall == 'codice_fiscale') {
                      _this2.partita_iva = data.partita_iva;
                    }

                    if (data.formed == 1) {
                      _this2.formed = true;
                    } else {
                      _this2.formed = false;
                    }

                    _this2.precompiled_iva = data.partita_iva;

                    _this2.email = data.email;
                    _this2.azienda = data.azienda;
                    _this2.address = data.indirizzo;
                    _this2.civic = data.indirizzo_num;
                    _this2.civic = data.indirizzo_num;
                    //this.city.city = data.Comune
                    //this.province = data.Provincia
                    //this.region.text = data.Regione
                    //this.zip = data.CAP
                    _this2.phone = data.telefono;
                    _this2.cellulare = data.telefono_mobile;
                    _this2.id_eps = data.id_eps;

                    _vue = _this2;


                    console.log("SET REGION");
                    regione = data.Regione;
                    _context4.next = 23;
                    return _vue.setRegion(regione);

                  case 23:
                    console.log("SET REGION SUCCESS");

                    setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                      var province;
                      return regenerator_default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              console.log("SET PROVINCE");
                              province = data.Provincia;
                              _context3.next = 4;
                              return _vue.setProvince(province);

                            case 4:
                              console.log("SET PROVINCE SUCCESS");

                              setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                var city;
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        console.log("SET CITY");
                                        city = data.Comune;
                                        _context2.next = 4;
                                        return _vue.setCity(city);

                                      case 4:
                                        console.log("SET CITY SUCCESS");

                                        setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                          var cap;
                                          return regenerator_default.a.wrap(function _callee$(_context) {
                                            while (1) {
                                              switch (_context.prev = _context.next) {
                                                case 0:
                                                  console.log("SET CAP");
                                                  cap = data.CAP;
                                                  _context.next = 4;
                                                  return _vue.setCap(cap);

                                                case 4:
                                                  console.log("SET CAP SUCCESS");

                                                case 5:
                                                case 'end':
                                                  return _context.stop();
                                              }
                                            }
                                          }, _callee, this);
                                        })), 1000);

                                      case 6:
                                      case 'end':
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, this);
                              })), 1000);

                            case 6:
                            case 'end':
                              return _context3.stop();
                          }
                        }
                      }, _callee3, this);
                    })), 1000);

                  case 25:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (error) {

          if (typeCall == 'partita_iva') {
            _this2.existPIVA = true;
          }
          if (typeCall == 'codice_fiscale') {
            _this2.existCF = true;
          }
          if (typeCall == 'email') {
            _this2.existEmail = true;
          }
        });
      }
    },
    setCap: function setCap(cap) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var x;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (x in _this3.zips) {
                  console.log('START');
                  console.log(_this3.zips[x].cap + ' =?= ' + cap.toUpperCase());
                  if (_this3.zips[x].cap == cap.toUpperCase()) {
                    _this3.zip = _this3.zips[x].cap;
                  }
                }
                console.log(_this3.province);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    setCity: function setCity(city) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var x, k;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:

                for (x in _this4.cities) {
                  if (_this4.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this4.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this4.city = k;
                  }
                }
                console.log(_this4.city);

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (x in _this5.provincies) {
                  console.log('START');
                  console.log(_this5.provincies[x].sigla + ' =?= ' + province.toUpperCase());
                  if (_this5.provincies[x].sigla == province.toUpperCase()) {
                    _this5.province = _this5.provincies[x].sigla;
                  }
                }
                console.log(_this5.province);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },
    setRegion: function setRegion(regione) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x, k;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:

                for (x in _this6.regions) {
                  if (_this6.regions[x].regione == regione.toUpperCase()) {
                    k = {
                      text: regione.toUpperCase(),
                      id: _this6.regions[x].id_regione
                    };

                    _this6.region = k;
                  }
                }
                console.log(_this6.region);

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this6);
      }))();
    },

    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append('fattura0', input.target.files[0]);
        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = '';
            _vue.invoiceFrontBucket = '';
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = '';
          _vue.invoiceFrontBucket = '';
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },

    uploadFileRear: function uploadFileRear(input) {
      var file = input.target.files[0].name;

      this.invoiceRearName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceRear = input.target.files[0].name;

        var formData = new FormData();
        var _vue = this; // << here
        formData.append('fattura0', input.target.files[0]);

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadRearPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {

            _vue.uploadRearPercentage = 0;
            _vue.invoiceRearBucket = e.data.fattura;
          } else {
            _vue.uploadRearPercentage = 0;
            _vue.invoiceRear = '';
            _vue.invoiceRearBucket = '';
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadRearPercentage = 0;
          _vue.invoiceRear = '';
          _vue.invoiceRearBucket = '';
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },

    addClientSuccess: function addClientSuccess() {
      this.$swal({
        type: 'success',
        title: '<strong class="modalText ">Registrazione andata a buon fine.</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },
    addClientError: function addClientError(text) {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Registrazione non andato a buon fine.</strong>',
        html: text,
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },
    UploadError: function UploadError() {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },


    populateRegions: function populateRegions() {
      var _this7 = this;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/getRegions',
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this7.regions = resp.data.regions;
        _this7.regionsState = false;

        _this7.ship_regions = resp.data.regions;
        _this7.ship_regionsState = false;
      }).catch(function (resp) {
        _this7.regions = [];
        _this7.regionsState = false;

        _this7.ship_regions = [];
        _this7.ship_regionsState = false;
      });
    },

    checkRegion: function checkRegion() {
      var region = this.region;

      if (region) {
        this.provinceError = false;
      } else {
        this.provinceError = true;
      }
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },

    ship_checkRegion: function ship_checkRegion() {
      var ship_region = this.ship_region;

      if (ship_region) {
        this.ship_provinceError = false;
      } else {
        this.ship_provinceError = true;
      }
    },
    ship_checkProvince: function ship_checkProvince() {
      var ship_province = this.ship_province;

      if (ship_province) {
        this.ship_cityError = false;
      } else {
        this.ship_cityError = true;
      }
    },
    ship_checkZip: function ship_checkZip() {
      var ship_city = this.ship_city;

      if (ship_city) {
        this.ship_zipError = false;
      } else {
        this.ship_zipError = true;
      }
    },

    calcToDate: function calcToDate() {
      var start = Object({"year":2021,"month":2,"day":15});
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = date;
      }
      return finalTo;
    },
    calcFromDate: function calcFromDate() {
      var stopObj = Object({"year":2030,"month":12,"day":15});
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },


    handleResize: function handleResize() {
      this.vw = window.innerWidth;
    }

  },
  watch: {
    iban: function iban(value) {
      this.iban = value.toUpperCase().trim();
      this.iban = this.iban.replace(' ', '');
    },
    azienda: function azienda(value) {
      this.azienda = value.toUpperCase();
    },
    sdiCode: function sdiCode(value) {
      this.sdiCode = value.toUpperCase();
    },
    codice_fiscale: function codice_fiscale(value) {
      this.codice_fiscale = value.toUpperCase();
    },

    address: function address(value) {
      this.address = value.toUpperCase();
    },
    civic: function civic(value) {
      this.civic = value.toUpperCase();
    },
    name: function name(value) {
      this.name = value.toUpperCase();
    },
    lastname: function lastname(value) {
      this.lastname = value.toUpperCase();
    },
    ship_name: function ship_name(value) {
      this.ship_name = value.toUpperCase();
    },
    ship_lastname: function ship_lastname(value) {
      this.ship_lastname = value.toUpperCase();
    },
    number: function number(value) {
      this.number = parseInt(value);
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },
    id_eps: function id_eps(val) {
      if (val) {
        this.id_eps = val.replace(/\D+/g, '');
      }
    },
    cellulare: function cellulare(val) {
      if (val) {
        this.cellulare = val.replace(/\D+/g, '');
      }
    },
    ship_phone: function ship_phone(val) {
      if (val) {
        this.ship_phone = val.replace(/\D+/g, '');
      }
    },
    ship_cellulare: function ship_cellulare(val) {
      if (val) {
        this.ship_cellulare = val.replace(/\D+/g, '');
      }
    },
    region: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9(newVal) {
        var _this8 = this;

        var provincies, provinciesState;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.zips = [];
                this.cities = [];
                this.zip = '';
                this.city = '';
                this.cityError = false;
                this.provinceError = false;
                this.zipError = false;
                this.province = '';
                this.provincies = [];
                this.provinciesState = true;

                provincies = this.provincies, provinciesState = this.provinciesState;
                _context9.next = 13;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getProvincies',
                  method: 'POST',
                  data: {
                    region: newVal.id
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _this8.provincies = resp.data.provincies;
                  _this8.provinciesState = false;
                }).catch(function (resp) {
                  _this8.provincies = [];
                  _this8.provinciesState = false;
                });

              case 13:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function region(_x2) {
        return _ref5.apply(this, arguments);
      }

      return region;
    }(),
    ship_region: function ship_region(newVal) {
      var _this9 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = '';
      this.ship_city = '';
      this.ship_cityError = false;
      this.ship_provinceError = false;
      this.ship_zipError = false;
      this.ship_province = '';
      this.ship_provincies = [];
      this.ship_provinciesState = true;

      var ship_provincies = this.ship_provincies,
          ship_provinciesState = this.ship_provinciesState;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/getProvincies',
        method: 'POST',
        data: {
          region: newVal.id
        },
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this9.ship_provincies = resp.data.provincies;
        _this9.ship_provinciesState = false;
      }).catch(function (resp) {
        _this9.ship_provincies = [];
        _this9.ship_provinciesState = false;
      });
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = '';
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_province: function ship_province(newProvince) {
      var _this11 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = '';
      this.ship_city = '';
      this.ship_cityError = false;
      this.ship_zipError = false;

      if (newProvince) {
        this.ship_citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this11.ship_cities = resp.data.cities;
          _this11.ship_citiesState = false;
        }).catch(function (resp) {
          _this11.ship_cities = [];
          _this11.ship_citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this12 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this12.zips = resp.data.zips;
          _this12.zipsState = false;
        }).catch(function (resp) {
          _this12.zips = [];
          _this12.zipsState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_city: function ship_city(newCity) {
      var _this13 = this;

      this.ship_zipError = false;
      this.ship_zips = [];
      this.ship_zip = '';

      if (newCity.cityistat) {
        this.ship_zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this13.ship_zips = resp.data.zips;
          _this13.ship_zipsState = false;
        }).catch(function (resp) {
          _this13.ship_zips = [];
          _this13.ship_zipsState = false;
        });
      }
    },
    vw: function vw() {}

  },
  updated: function updated() {},
  created: function created() {
    this.$validator.extend('notZeros', {
      getMessage: function getMessage(field) {
        return ' Il campo Numero di telefono non ha un formato valido.';
      },
      validate: function validate(value) {
        // value must be > zero
        if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000) return true;
        return false;
      }
    });
  },
  mounted: function mounted() {
    this.$scrollTo('#app', 700, {
      offset: -775
    });
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.lastnamex = this.getProfile.cognome;
    this.xuserx = this.getProfile.name;

    var _vue = this;

    setTimeout(function () {

      _vue.populateRegions(), _vue.disabledDates = {
        to: _vue.calcToDate(), // Disable all dates up to specific date
        from: _vue.calcFromDate() // Disable all dates after specific date
      };

      _vue.scrollFinished = true;
    }, 1500);
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a5036f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addClient/index.vue
var addClient_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.registration1
        ? _c("div", { staticClass: "container whiteCont  mb-5" }, [
            _c("div", { staticClass: "row  justify-content-center" }, [
              _c("div", { staticClass: "col-md-12 center " }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 text-left mb-4 " }, [
                _vm.proccess == "START"
                  ? _c("h2", { staticClass: "black" }, [
                      _vm.brand == "CHEBONUS"
                        ? _c("b", [_vm._v("Registrazione a CheBonus")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("b", [_vm._v("Registrazione a HappyBonus")])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.proccess == "START"
                  ? _c(
                      "h5",
                      { staticClass: "black" },
                      [
                        _vm._v(
                          '\n          Inserisci i dati richiesti,  clicca su "Registrati" ed attendi l\'approvazione di\n          '
                        ),
                        _vm.brand == "CHEBONUS"
                          ? [_vm._v(" Vaillant ")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brand == "HAPPYBONUS"
                          ? [_vm._v(" Hermann Saunier Duval ")]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.proccess == "START"
                  ? _c("p", { staticClass: "black" }, [
                      _vm._v(
                        "\n          I campi contrassegnati con * sono obbligatori\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.proccess == "REG_SUCCESS"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "widthFull center pb-5 mb-5 vaillantCont pt-5"
                    },
                    [
                      _c("h1", { staticClass: "widthFull center mt-3 black" }, [
                        _vm._v("Ci sei quasi! ")
                      ]),
                      _vm._v(" "),
                      !_vm.formed
                        ? _c(
                            "h3",
                            { staticClass: "widthFull center black mt-5 mb-5" },
                            [
                              _vm._v(
                                "\n          La tua richiesta è stata inoltrata per approvazione.\n          "
                              ),
                              _c("br"),
                              _c("br"),
                              _vm._v(
                                "A breve riceverai la conferma della registrazione "
                              ),
                              _c("br"),
                              _vm._v(
                                "via email e potrai accedere alla piattaforma.\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formed
                        ? _c(
                            "h3",
                            { staticClass: "widthFull center black mt-5" },
                            [
                              _vm._v(
                                "\n          TI abbiamo inviato una mail al tuo indirizzo di posta elettronica\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formed
                        ? _c("h3", { staticClass: "widthFull center" }, [
                            _c("b", [
                              _vm._v(
                                "Per confermare la tua registrazione clicca sul link che trovi all’interno."
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formed
                        ? _c(
                            "h4",
                            {
                              staticClass: "widthFull center mt-5 mb-5",
                              staticStyle: { color: "black" }
                            },
                            [
                              _vm._v(
                                "\n          Verifica per favore anche nella cartella Spam o Posta indesiderata\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formed
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary",
                              class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                              attrs: { to: "/login" }
                            },
                            [_vm._v("\n          LOGIN\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.formed
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary",
                              class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                              attrs: { to: "/" }
                            },
                            [_vm._v("\n          HOME\n        ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c(
                  "form",
                  {
                    staticClass: "pb-5 pt-4 black vaillantCont",
                    attrs: { id: "registration-form" }
                  },
                  [
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "row justify-content-center" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.azienda,
                                    expression: "azienda"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 3 },
                                    expression:
                                      "{required:true, max: 128, min: 3}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("azienda"),
                                  valid: !!_vm.azienda
                                },
                                attrs: {
                                  type: "text",
                                  id: "azienda",
                                  name: "azienda",
                                  "data-vv-as": "Ragione sociale"
                                },
                                domProps: { value: _vm.azienda },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.azienda = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "azienda" }
                                },
                                [_vm._v("Ragione sociale * ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("azienda")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("azienda")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.partita_iva,
                                    expression: "partita_iva"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      partitaIva: true,
                                      max: 11,
                                      min: 11
                                    },
                                    expression:
                                      "{required:true, partitaIva: true, max: 11, min: 11,}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("partita_iva"),
                                  valid: !!_vm.partita_iva
                                },
                                attrs: {
                                  type: "text",
                                  id: "partita_iva",
                                  name: "partita_iva",
                                  "data-vv-as": "Partita IVA"
                                },
                                domProps: { value: _vm.partita_iva },
                                on: {
                                  blur: _vm.checkIfExistUser,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.partita_iva = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "partita_iva" }
                                },
                                [_vm._v("Partita IVA *")]
                              ),
                              _vm._v(" "),
                              _vm.existPIVA
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "invalid-feedback",
                                      staticStyle: { display: "block" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Partita IVA inserita già presente."
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("partita_iva")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("partita_iva")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.codice_fiscale,
                                    expression: "codice_fiscale"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      codiceFiscale:
                                        _vm.tipo_azienda ==
                                          "Ditta Individuale" ||
                                        _vm.tipo_azienda ==
                                          "Professionista iscritto ad albi",
                                      partitaIva:
                                        _vm.tipo_azienda !=
                                          "Ditta Individuale" &&
                                        _vm.tipo_azienda !=
                                          "Professionista iscritto ad albi",
                                      max:
                                        _vm.tipo_azienda ==
                                          "Ditta Individuale" ||
                                        _vm.tipo_azienda ==
                                          "Professionista iscritto ad albi"
                                          ? 16
                                          : 11,
                                      min:
                                        _vm.tipo_azienda ==
                                          "Ditta Individuale" ||
                                        _vm.tipo_azienda ==
                                          "Professionista iscritto ad albi"
                                          ? 16
                                          : 11
                                    },
                                    expression:
                                      "{required: true, codiceFiscale: tipo_azienda == 'Ditta Individuale' || tipo_azienda == 'Professionista iscritto ad albi', partitaIva: tipo_azienda != 'Ditta Individuale' && tipo_azienda != 'Professionista iscritto ad albi',  max: tipo_azienda == 'Ditta Individuale' || tipo_azienda == 'Professionista iscritto ad albi' ? 16 : 11, min:  tipo_azienda == 'Ditta Individuale' || tipo_azienda == 'Professionista iscritto ad albi' ? 16 : 11}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(
                                    "codice_fiscale"
                                  ),
                                  valid: !!_vm.codice_fiscale
                                },
                                attrs: {
                                  type: "text",
                                  id: "codice_fiscale",
                                  name: "codice_fiscale",
                                  "data-vv-as": "Codice Fiscale"
                                },
                                domProps: { value: _vm.codice_fiscale },
                                on: {
                                  blur: _vm.checkIfExistUser,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.codice_fiscale = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "codice_fiscale" }
                                },
                                [_vm._v("Codice Fiscale *")]
                              ),
                              _vm._v(" "),
                              _vm.existCF
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "invalid-feedback",
                                      staticStyle: { display: "block" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Codice Fiscale inserito già presente."
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("codice_fiscale")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("codice_fiscale")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row justify-content-center" }, [
                        _c(
                          "div",
                          {
                            staticClass: "mb-3 ",
                            class: {
                              "col-md-3":
                                _vm.tipo_azienda != "Ditta Individuale" &&
                                _vm.tipo_azienda !=
                                  "Professionista iscritto ad albi",
                              "col-md-3":
                                _vm.tipo_azienda == "Ditta Individuale" ||
                                _vm.tipo_azienda ==
                                  "Professionista iscritto ad albi"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "group custInput",
                                class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.tipo_azienda,
                                        expression: "tipo_azienda"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: { required: true },
                                        expression: "{required:true}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "tipo_azienda"
                                      ),
                                      valid: !!_vm.tipo_azienda
                                    },
                                    attrs: {
                                      autocomplete: "randomy",
                                      id: "tipo_azienda",
                                      name: "tipo_azienda",
                                      "data-vv-as": "Forma Giuridica"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.tipo_azienda = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "optgroup",
                                      {
                                        attrs: {
                                          label:
                                            "SOGGETTI CON PERSONALITA’ GIURIDICA"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            key: 111,
                                            attrs: {
                                              value:
                                                "Società in accomandita per azioni"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società in accomandita per azioni\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 112,
                                            attrs: {
                                              value:
                                                "Società a responsabilità limitata"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società a responsabilità limitata\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 113,
                                            attrs: {
                                              value: "Società per azioni"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società per azioni\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 114,
                                            attrs: {
                                              value:
                                                "Società in nome collettivo"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società in nome collettivo\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 115,
                                            attrs: {
                                              value:
                                                "Società in accomandita semplice"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società in accomandita semplice\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 116,
                                            attrs: {
                                              value: "Società cooperative"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società cooperative\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 117,
                                            attrs: {
                                              value:
                                                "Consorzi con o senza personalità giuridica"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Consorzi con o senza personalità giuridica\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 118,
                                            attrs: {
                                              value: "Associazioni riconosciute"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Associazioni riconosciute\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 119,
                                            attrs: {
                                              value:
                                                "STP Società tra professionisti"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  STP Società tra professionisti\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "optgroup",
                                      { attrs: { label: "PERSONE FISICHE" } },
                                      [
                                        _c(
                                          "option",
                                          {
                                            key: 311,
                                            attrs: {
                                              value: "Ditta Individuale"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Ditta Individuale\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 312,
                                            attrs: {
                                              value:
                                                "Professionista iscritto ad albi"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Professionista iscritto ad albi\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "region" }
                                  },
                                  [_vm._v("Forma Giuridica *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("tipo_azienda")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first("tipo_azienda")
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.tipo_azienda == "Ditta Individuale" ||
                        _vm.tipo_azienda == "Professionista iscritto ad albi"
                          ? _c("div", { staticClass: "col-md-3 mb-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.reg_forfettario,
                                          expression: "reg_forfettario"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: { required: true },
                                          expression: "{required:true}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "reg_forfettario"
                                        ),
                                        valid: !!_vm.reg_forfettario
                                      },
                                      attrs: {
                                        autocomplete: "randomy",
                                        id: "reg_forfettario",
                                        name: "reg_forfettario",
                                        "data-vv-as": "Regime Forfettario"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.reg_forfettario = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { key: 911, attrs: { value: "si" } },
                                        [
                                          _vm._v(
                                            "\n                  si\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { key: 912, attrs: { value: "no" } },
                                        [
                                          _vm._v(
                                            "\n                  no\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "region" }
                                    },
                                    [_vm._v("Regime Forfettario *")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("reg_forfettario")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "reg_forfettario"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reg_role,
                                      expression: "reg_role"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true },
                                      expression: "{required:true}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("reg_role"),
                                    valid: !!_vm.reg_role
                                  },
                                  attrs: {
                                    autocomplete: "randomy",
                                    id: "reg_role",
                                    name: "reg_role",
                                    "data-vv-as":
                                      "Tipologia fornitura ed installazione prodotti"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.reg_role = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      key: 911,
                                      attrs: { value: "Installatore" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Formula installatore ( Flusso MBFACTA e/o General Contractor Agile Energy )\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      key: 912,
                                      attrs: { value: "General Contractor" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Formula General Contractor ( solo Flusso MBFACTA )\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "region" }
                                },
                                [_vm._v("Formula di installazione prodotti *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("reg_role")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("reg_role")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-4",
                          class: {
                            "col-md-3":
                              _vm.tipo_azienda != "Ditta Individuale" &&
                              _vm.tipo_azienda !=
                                "Professionista iscritto ad albi",
                            "col-md-3":
                              _vm.tipo_azienda == "Ditta Individuale" ||
                              _vm.tipo_azienda ==
                                "Professionista iscritto ad albi"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.lastname,
                                    expression: "lastname"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 55, min: 2 },
                                    expression:
                                      "{required:true, max: 55, min: 2}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("lastname"),
                                  valid: !!_vm.lastname
                                },
                                attrs: {
                                  type: "text",
                                  id: "lastname",
                                  name: "lastname",
                                  "data-vv-as": "Cognome"
                                },
                                domProps: { value: _vm.lastname },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.lastname = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "lastname" }
                                },
                                [_vm._v("Cognome *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("lastname")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("lastname")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-md-4",
                          class: {
                            "col-md-3":
                              _vm.tipo_azienda != "Ditta Individuale" &&
                              _vm.tipo_azienda !=
                                "Professionista iscritto ad albi",
                            "col-md-3":
                              _vm.tipo_azienda == "Ditta Individuale" ||
                              _vm.tipo_azienda ==
                                "Professionista iscritto ad albi"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.name,
                                    expression: "name"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 55, min: 2 },
                                    expression:
                                      "{required:true, max: 55, min: 2}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("name"),
                                  valid: !!_vm.name
                                },
                                attrs: {
                                  type: "text",
                                  id: "name",
                                  name: "name",
                                  "data-vv-as": "Nome"
                                },
                                domProps: { value: _vm.name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.name = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "name" }
                                },
                                [_vm._v("Nome *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("name")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("name")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-4 mb-3 " }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    email: true,
                                    temporaryEmail: true,
                                    plusIssueEmail: true,
                                    max: 56
                                  },
                                  expression:
                                    "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                }
                              ],
                              ref: "email",
                              staticClass: "form-control",
                              class: {
                                "is-invalid":
                                  _vm.errors.has("email") || _vm.existEmail,
                                valid: !!_vm.email
                              },
                              attrs: {
                                type: "text",
                                id: "email",
                                name: "email",
                                "data-vv-as": "Email"
                              },
                              domProps: { value: _vm.email },
                              on: {
                                blur: _vm.checkIfExistUser,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "email" }
                              },
                              [_vm._v("Email* ")]
                            ),
                            _vm._v(" "),
                            _vm.existEmail
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "invalid-feedback",
                                    staticStyle: { display: "block" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Email digitato già presente")
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("email")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("email")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    passwordCheck: true,
                                    min: 8,
                                    max: 56
                                  },
                                  expression:
                                    "{required:true, passwordCheck: true, min: 8, max: 56}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("password"),
                                valid: !!_vm.password
                              },
                              attrs: {
                                type: "password",
                                id: "password",
                                name: "password",
                                "data-vv-as": "Password"
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "password" }
                              },
                              [_vm._v("Inserisci una password *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("password")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("password")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.confirm_password,
                                  expression: "confirm_password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    passwordCheck: true,
                                    min: 8,
                                    max: 56,
                                    confirmed: _vm.password
                                  },
                                  expression:
                                    "{required:true, passwordCheck: true, min: 8, max: 56,confirmed:password}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "confirm_password"
                                ),
                                valid: !!_vm.confirm_password
                              },
                              attrs: {
                                type: "password",
                                id: "confirm_password",
                                name: "confirm_password",
                                "data-vv-as": "Conferma Password"
                              },
                              domProps: { value: _vm.confirm_password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.confirm_password = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "confirm_password" }
                              },
                              [_vm._v("Conferma la password *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("confirm_password")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first("confirm_password")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _vm.phone
                              ? _c("span", { staticClass: "custLabel" }, [
                                  _vm._v("+39 ")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.phone,
                                  expression: "phone"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    max: 10,
                                    min: 8,
                                    notZeros: true,
                                    regex: /^[0,3]+/
                                  },
                                  expression:
                                    "{required:true, max: 10, min: 8,notZeros: true,regex: /^[0,3]+/}"
                                }
                              ],
                              staticClass: "form-control cspad",
                              class: {
                                "is-invalid": _vm.errors.has("phone"),
                                valid: !!_vm.phone
                              },
                              attrs: {
                                type: "text",
                                id: "phone",
                                name: "phone",
                                "data-vv-as": "Telefono"
                              },
                              domProps: { value: _vm.phone },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.phone = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "phone" }
                              },
                              [_vm._v("Telefono * ")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("phone")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("phone")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _vm.cellulare
                              ? _c("span", { staticClass: "custLabel" }, [
                                  _vm._v("+39 ")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cellulare,
                                  expression: "cellulare"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    max: 10,
                                    min: 8,
                                    notZeros: true,
                                    regex: /^[0,3]+/
                                  },
                                  expression:
                                    "{required:true, max: 10, min: 8,notZeros: true,regex: /^[0,3]+/}"
                                }
                              ],
                              staticClass: "form-control cspad",
                              class: {
                                "is-invalid": _vm.errors.has("cellulare"),
                                valid: !!_vm.cellulare
                              },
                              attrs: {
                                type: "text",
                                id: "cellulare",
                                name: "cellulare",
                                "data-vv-as": "Cellulare"
                              },
                              domProps: { value: _vm.cellulare },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.cellulare = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "cellulare" }
                              },
                              [_vm._v("Cellulare * ")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("cellulare")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("cellulare")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.address,
                                  expression: "address"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 128, min: 5 },
                                  expression:
                                    "{required:true, max: 128, min: 5}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("address"),
                                valid: !!_vm.address
                              },
                              attrs: {
                                type: "text",
                                autocomplete: "randomr",
                                id: "address",
                                name: "address",
                                "data-vv-as": "Indirizzo"
                              },
                              domProps: { value: _vm.address },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.address = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "address" }
                              },
                              [_vm._v("Indirizzo (via, piazza, etc. ) *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("address")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("address")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.civic,
                                  expression: "civic"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 15 },
                                  expression: "{required:true, max: 15}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("civic"),
                                valid: !!_vm.civic
                              },
                              attrs: {
                                type: "text",
                                autocomplete: "randomt",
                                id: "civic",
                                name: "civic",
                                "data-vv-as": "N. Civico"
                              },
                              domProps: { value: _vm.civic },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.civic = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "civic" }
                              },
                              [_vm._v("N. Civico *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("civic")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("civic")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.region,
                                    expression: "region"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{required:true}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("region"),
                                  valid: !!_vm.region
                                },
                                attrs: {
                                  autocomplete: "randomy",
                                  id: "region",
                                  name: "region",
                                  "data-vv-as": "Regione"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.region = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.regions, function(region) {
                                return _c(
                                  "option",
                                  {
                                    key: region.id_regione,
                                    domProps: {
                                      value: {
                                        id: region.id_regione,
                                        text: region.regione
                                      },
                                      selected:
                                        region.id_regione == _vm.shipData.region
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(region.regione) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "region" }
                              },
                              [_vm._v("Regione *")]
                            ),
                            _vm._v(" "),
                            _vm.regionsState
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "loadSpinner",
                                      attrs: {
                                        id: "loadregion",
                                        icon: "spinner",
                                        size: "1x",
                                        pulse: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("region")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("region")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.province,
                                    expression: "province"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{required:true}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("province"),
                                  valid: !!_vm.province
                                },
                                attrs: {
                                  autocomplete: "randomy",
                                  id: "province",
                                  name: "province",
                                  "data-vv-as": "Provincia"
                                },
                                on: {
                                  click: _vm.checkRegion,
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.province = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.provincies, function(province) {
                                return _c(
                                  "option",
                                  {
                                    key: province.sigla,
                                    domProps: {
                                      value: province.sigla,
                                      selected:
                                        province.sigla == _vm.shipData.province
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(province.sigla) +
                                        " - " +
                                        _vm._s(province.provincia) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "province" }
                              },
                              [
                                _vm._v("Provincia *"),
                                _vm.provinceError
                                  ? _c("span", { staticClass: "formError" }, [
                                      _vm._v("Prima scegli Regione")
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.provinciesState
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "loadSpinner",
                                      attrs: {
                                        id: "loadProvince",
                                        icon: "spinner",
                                        size: "1x",
                                        pulse: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("province")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("province")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.city,
                                    expression: "city"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{required:true}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("city"),
                                  valid: !!_vm.city
                                },
                                attrs: {
                                  autocomplete: "randomu",
                                  id: "city",
                                  name: "city",
                                  "data-vv-as": "Località",
                                  disabled: _vm.citiesState
                                },
                                on: {
                                  click: _vm.checkProvince,
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.city = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.cities, function(city) {
                                return _c(
                                  "option",
                                  {
                                    key: city.comune,
                                    domProps: {
                                      value: {
                                        cityistat: city.istat,
                                        city: city.comune
                                      },
                                      selected: city.comune == _vm.shipData.city
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(city.comune) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "city" }
                              },
                              [
                                _vm._v("Località *"),
                                _vm.cityError
                                  ? _c("span", { staticClass: "formError" }, [
                                      _vm._v("Prima scegli Provincia")
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.citiesState
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "loadSpinner",
                                      attrs: {
                                        id: "loadCity",
                                        icon: "spinner",
                                        size: "1x",
                                        pulse: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("city")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("city")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.zip,
                                    expression: "zip"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{required:true}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("zip"),
                                  valid: !!_vm.zip
                                },
                                attrs: {
                                  autocomplete: "randomi",
                                  id: "zip",
                                  name: "zip",
                                  "data-vv-as": "CAP",
                                  disabled: _vm.zipsState
                                },
                                on: {
                                  click: _vm.checkZip,
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.zip = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.zips, function(zip) {
                                return _c(
                                  "option",
                                  {
                                    key: zip.cap,
                                    domProps: {
                                      value: zip.cap,
                                      selected: zip.cap == _vm.shipData.zip
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(zip.cap) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "zip" }
                              },
                              [
                                _vm._v("CAP *"),
                                _vm.zipError
                                  ? _c("span", { staticClass: "formError" }, [
                                      _vm._v("Prima scegli Località")
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.zipsState
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "loadSpinner",
                                      attrs: {
                                        id: "loadZips",
                                        icon: "spinner",
                                        size: "1x",
                                        pulse: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("zip")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("zip")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "row justify-content-center divider"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row justify-content-center pt-3" },
                      [
                        _c("div", { staticClass: "col-md-12 mb-3 center" }, [
                          _c("h5", { staticClass: "black center" }, [
                            _vm._v(
                              "Inserisci PEC ( Posta Elettronica Certificata ) e codice SDI ( Codice Destinatario per fatturazione elettronica )"
                            )
                          ]),
                          _vm._v(" "),
                           false
                            ? _c("img", {
                                staticClass: "ptImage mr-3",
                                attrs: {
                                  src: require("../../assets/images/Poste.jpg")
                                }
                              })
                            : _vm._e(),
                           false
                            ? _c("small", [
                                _vm._v(
                                  "Attenzione! Per usufruire del servizio è necessario inserire "
                                ),
                                _c("b", [
                                  _vm._v(
                                    "iban del conto corrente affari di poste italiane"
                                  )
                                ]),
                                _vm._v(". ")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                           false
                            ? _c("small", [
                                _vm._v(
                                  " ( può essere inserito anche successivamente ) "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                         false
                          ? _c("div", { staticClass: "col-md-5 mb-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.iban,
                                        expression: "iban"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          ibanControl: true,
                                          ibanItalian: true,
                                          ibanPoste: true,
                                          max: 27,
                                          min: 27
                                        },
                                        expression:
                                          "{ ibanControl: true, ibanItalian: true, ibanPoste: true,  max: 27, min: 27}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has("iban"),
                                      valid: !!_vm.iban
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomr",
                                      id: "iban",
                                      name: "iban",
                                      "data-vv-as": "IBAN"
                                    },
                                    domProps: { value: _vm.iban },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.iban = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "iban" }
                                    },
                                    [_vm._v("IBAN Poste Italiane")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("iban")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.errors.first("iban")) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                         false
                          ? _c("div", { staticClass: "col-md-7 mb-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.ibanNome,
                                        expression: "ibanNome"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: _vm.iban != "",
                                          max: 128,
                                          min: 5
                                        },
                                        expression:
                                          "{required:iban != '', max: 128, min: 5}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has("ibanNome"),
                                      valid: !!_vm.ibanNome
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomr",
                                      id: "ibanNome",
                                      name: "ibanNome",
                                      "data-vv-as": "Nome intestatario"
                                    },
                                    domProps: { value: _vm.ibanNome },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.ibanNome = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "ibanNome" }
                                    },
                                    [_vm._v("Intestazione conto")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("ibanNome")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first("ibanNome")
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 mb-3 " }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.emailPEC,
                                    expression: "emailPEC"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      email: true,
                                      temporaryEmail: true,
                                      plusIssueEmail: true,
                                      max: 56
                                    },
                                    expression:
                                      "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                  }
                                ],
                                ref: "emailPEC",
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("emailPEC"),
                                  valid: !!_vm.emailPEC
                                },
                                attrs: {
                                  type: "text",
                                  id: "emailPEC",
                                  name: "emailPEC",
                                  "data-vv-as": "email PEC"
                                },
                                domProps: { value: _vm.emailPEC },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.emailPEC = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "email" }
                                },
                                [_vm._v("Email PEC* ")]
                              ),
                              _vm._v(" "),
                              _vm.existEmail
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "invalid-feedback",
                                      staticStyle: { display: "block" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Email digitato già presente")
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("emailPEC")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("emailPEC")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 mb-3 " }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sdiCode,
                                    expression: "sdiCode"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 7, max: 7 },
                                    expression:
                                      "{required:true, min: 7, max: 7}"
                                  }
                                ],
                                ref: "sdiCode",
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("sdiCode"),
                                  valid: !!_vm.sdiCode
                                },
                                attrs: {
                                  type: "text",
                                  id: "sdiCode",
                                  name: "sdiCode",
                                  "data-vv-as": "CODICE SDI"
                                },
                                domProps: { value: _vm.sdiCode },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.sdiCode = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "sdiCode" }
                                },
                                [
                                  _vm._v(
                                    "CODICE SDI fatturazione elettronica * "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("sdiCode")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("sdiCode")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-4" }, [
                      _c("div", { staticClass: "col-md-2 mb-3 center" }, [
                        _vm.invoiceFrontBucket
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.invoiceFrontBucket,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm.invoiceFrontBucket.substring(
                                  _vm.invoiceFrontBucket.lastIndexOf(".") + 1,
                                  _vm.invoiceFrontBucket.length
                                ) == "pdf"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "center widthFull pdfLink",
                                        attrs: {
                                          href: _vm.invoiceFrontBucket,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v("APRI "),
                                        _c("br"),
                                        _vm._v(" PDF")
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3 " }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "front-image",
                            class: {
                              "front-imageHSD": _vm.brand == "HAPPYBONUS"
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: false,
                                    size: 10240,
                                    ext: ["jpeg", "jpg", "png"],
                                    mimes: [
                                      "image/jpeg",
                                      "image/jpg",
                                      "image/png"
                                    ]
                                  },
                                  expression:
                                    "{required:false,size: 10240, ext: ['jpeg','jpg','png'], mimes: ['image/jpeg', 'image/jpg', 'image/png']}"
                                }
                              ],
                              ref: "fileInput",
                              staticClass: "fileInput",
                              class: {
                                "is-invalid": _vm.errors.has("invoiceFront"),
                                valid: !!_vm.invoiceFront,
                                helper: !!_vm.invoiceFrontBucket
                              },
                              attrs: {
                                type: "file",
                                name: "invoiceFront",
                                id: "invoiceFront",
                                "data-vv-as": "Logo"
                              },
                              on: { change: _vm.uploadFile }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel labelFileInput",
                                attrs: { for: "invoiceFront" }
                              },
                              [
                                !_vm.invoiceFrontName
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "smallText center white",
                                        style: {
                                          backgroundImage:
                                            "url(" +
                                            _vm.invoiceFrontBucket +
                                            ")"
                                        }
                                      },
                                      [
                                        !_vm.invoiceFrontName
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "smallText center white mt-3 mb-0 pb-0"
                                              },
                                              [
                                                _vm._v(
                                                  "Scegli il Contratto quadro*"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _c("span", {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("invoiceFront")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("invoiceFront")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.uploadFrontPercentage
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "progress",
                                    attrs: { id: "progFront" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "progress-bar ",
                                        style: {
                                          width: _vm.uploadFrontPercentage + "%"
                                        },
                                        attrs: {
                                          id: "progress-bar-front",
                                          role: "progressbar",
                                          "aria-valuenow": "50",
                                          "aria-valuemin": "0",
                                          "aria-valuemax": "100"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.uploadFrontPercentage) +
                                            " %\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.invoiceFrontName
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                  },
                                  [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(1)
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row " }, [
                      _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("div", { staticClass: "p-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.privacy,
                                  expression: "privacy"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required: true}"
                                }
                              ],
                              staticClass: "form-check-input",
                              class: {
                                "is-invalid": _vm.errors.has("privacy")
                              },
                              attrs: {
                                type: "checkbox",
                                id: "privacy",
                                name: "privacy",
                                "data-vv-as": "Termini di utilizzo"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.privacy)
                                  ? _vm._i(_vm.privacy, null) > -1
                                  : _vm.privacy
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.privacy,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.privacy = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.privacy = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.privacy = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label textStable",
                                attrs: { for: "privacy" }
                              },
                              [
                                _vm._v(
                                  "\n                Effettuando la registrazione ed utilizzando i servizi forniti da questo Sito accetto i presenti\n                "
                                ),
                                _vm.brand == "CHEBONUS"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "green",
                                        class: {
                                          redHSD: _vm.brand == "HAPPYBONUS"
                                        },
                                        attrs: {
                                          href:
                                            "https://storage.googleapis.com/chebonus/Conditions.pdf?v=2",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Termini di utilizzo\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.brand == "HAPPYBONUS"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "green",
                                        class: {
                                          redHSD: _vm.brand == "HAPPYBONUS"
                                        },
                                        attrs: {
                                          href:
                                            "https://storage.googleapis.com/happybonus/Conditions.pdf?v=2",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Termini di utilizzo\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("privacy")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("privacy")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row " }, [
                      _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("div", { staticClass: "p-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.privacy1,
                                  expression: "privacy1"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required: true}"
                                }
                              ],
                              staticClass: "form-check-input",
                              class: {
                                "is-invalid": _vm.errors.has("privacy1")
                              },
                              attrs: {
                                type: "checkbox",
                                id: "privacy1",
                                name: "privacy1",
                                "data-vv-as": "Informativa privacy"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.privacy1)
                                  ? _vm._i(_vm.privacy1, null) > -1
                                  : _vm.privacy1
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.privacy1,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.privacy1 = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.privacy1 = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.privacy1 = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label textStable",
                                attrs: { for: "privacy1" }
                              },
                              [
                                _vm._v(
                                  "\n                Dichiaro di aver letto, compreso ed accettato\n                "
                                ),
                                _vm.brand == "CHEBONUS"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "green",
                                        class: {
                                          redHSD: _vm.brand == "HAPPYBONUS"
                                        },
                                        attrs: {
                                          href:
                                            "https://storage.googleapis.com/chebonus/Privacy.pdf?v=2",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  l’Informativa privacy\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.brand == "HAPPYBONUS"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "green",
                                        class: {
                                          redHSD: _vm.brand == "HAPPYBONUS"
                                        },
                                        attrs: {
                                          href:
                                            "https://storage.googleapis.com/happybonus/Privacy.pdf?v=2",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  l’Informativa privacy\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("privacy1")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("privacy1")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: 1 == 2,
                            expression: "1==2"
                          }
                        ],
                        staticClass: "row "
                      },
                      [
                        _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                          _c("div", { staticClass: "form-check" }, [
                            _c("div", { staticClass: "p-3" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.privacy2,
                                    expression: "privacy2"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {},
                                    expression: "{}"
                                  }
                                ],
                                staticClass: "form-check-input",
                                class: {
                                  "is-invalid": _vm.errors.has("privacy2")
                                },
                                attrs: {
                                  type: "checkbox",
                                  id: "privacy2",
                                  name: "privacy2",
                                  "data-vv-as": "Informativa privacy2"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.privacy2)
                                    ? _vm._i(_vm.privacy2, null) > -1
                                    : _vm.privacy2
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.privacy2,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.privacy2 = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.privacy2 = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.privacy2 = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label textStable",
                                  attrs: { for: "privacy2" }
                                },
                                [
                                  _vm._v(
                                    "\n                Dichiaro di aver letto e compreso\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "green",
                                      class: {
                                        redHSD: _vm.brand == "HAPPYBONUS"
                                      },
                                      attrs: {
                                        href: "privacy.pdf",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  l’Informativa privacy\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                resa dal Titolare del trattamento ai sensi dell’art. 13 del GDPR*\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("privacy2")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("privacy2")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: 1 == 2,
                            expression: "1==2"
                          }
                        ],
                        staticClass: "row "
                      },
                      [
                        _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                          _c("div", { staticClass: "form-check" }, [
                            _c("div", { staticClass: "p-3" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.privacy3,
                                    expression: "privacy3"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {},
                                    expression: "{}"
                                  }
                                ],
                                staticClass: "form-check-input",
                                class: {
                                  "is-invalid": _vm.errors.has("privacy3")
                                },
                                attrs: {
                                  type: "checkbox",
                                  id: "privacy3",
                                  name: "privacy3",
                                  "data-vv-as": "Informativa privacy3"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.privacy3)
                                    ? _vm._i(_vm.privacy3, null) > -1
                                    : _vm.privacy3
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.privacy3,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.privacy3 = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.privacy3 = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.privacy3 = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label textStable",
                                  attrs: { for: "privacy3" }
                                },
                                [
                                  _vm._v(
                                    "\n                Dichiaro di aver letto e compreso\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "green",
                                      class: {
                                        redHSD: _vm.brand == "HAPPYBONUS"
                                      },
                                      attrs: {
                                        href: "privacy.pdf",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  l’Informativa privacy\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                resa dal Titolare del trattamento ai sensi dell’art. 13 del GDPR*\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("privacy3")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("privacy3")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12 center mb-0  mb-1" },
                        [
                          !_vm.isAuthenticated
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-lg btn-primary",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { type: "button" },
                                  on: { click: _vm.registration }
                                },
                                [_vm._v("\n            Registrati\n          ")]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var addClient_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center" }, [
      _vm._v("Logo Azienda "),
      _c("small", [_vm._v("(formato: jpg, png)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mb-3 " }, [
      _c("h5", { staticClass: "text-left pt-4" }, [
        _vm._v("\n            Carica il logo della tua Azienda\n          ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Il logo non è obbligatorio. Se lo carichi, potrai personalizzare i tuoi Preventivi con il logo della tua azienda.\n          "
        )
      ])
    ])
  }
]
addClient_render._withStripped = true
var addClient_esExports = { render: addClient_render, staticRenderFns: addClient_staticRenderFns }
/* harmony default export */ var components_addClient = (addClient_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03a5036f", addClient_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/addClient/index.vue
var addClient_disposed = false
function addClient_injectStyle (ssrContext) {
  if (addClient_disposed) return
  __webpack_require__("fcBF")
  __webpack_require__("v4hK")
}
var addClient_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addClient___vue_template_functional__ = false
/* styles */
var addClient___vue_styles__ = addClient_injectStyle
/* scopeId */
var addClient___vue_scopeId__ = "data-v-03a5036f"
/* moduleIdentifier (server only) */
var addClient___vue_module_identifier__ = null
var addClient_Component = addClient_normalizeComponent(
  addClient,
  components_addClient,
  addClient___vue_template_functional__,
  addClient___vue_styles__,
  addClient___vue_scopeId__,
  addClient___vue_module_identifier__
)
addClient_Component.options.__file = "src/components/addClient/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03a5036f", addClient_Component.options)
  } else {
    hotAPI.reload("data-v-03a5036f", addClient_Component.options)
  }
  module.hot.dispose(function (data) {
    addClient_disposed = true
  })
})()}

/* harmony default export */ var src_components_addClient = (addClient_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-badger-accordion/index.js
var vue_badger_accordion = __webpack_require__("paJE");

// EXTERNAL MODULE: ./node_modules/vue-pagination-2/compiled/main.js
var main = __webpack_require__("laN8");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/vue-svg-gauge/dist/vue-svg-gauge.js
var vue_svg_gauge = __webpack_require__("o39/");
var vue_svg_gauge_default = /*#__PURE__*/__webpack_require__.n(vue_svg_gauge);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/offerte/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var offerte_moment = __webpack_require__("PJh5");





/* harmony default export */ var offerte = ({
  name: 'login',
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"],
    Pagination: main_default.a
  },
  data: function data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      practices: {},
      countPractices: 0,
      countCashClient: 0,
      countloop: 1,
      countCashInst: 0,
      practicesFiltred: {},
      presentPractices: true,
      moment: __webpack_require__("PJh5"),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      showFilterText: false,
      hasRemovedPractics: false,
      brand: "CHEBONUS",

      // NEW PAGINATION
      length: 0,
      filter: '',
      filterVal: '',
      counts: {
        countCashClient: "0",
        countCashInst: "0",
        countErrorPractice: "0",
        countPractices: "0",
        countStep1Practice: "0",
        countStep2Practice: "0",
        countStep3Practice: "0",
        countStep4Practice: "0",
        sumTotal: "0",
        hasRemovedPractics: '0'
      },
      displayPerPage: 10,
      page: 1,
      loaded: false,
      loadedCount: false,
      filterType: false,
      practicesFiltredCount: 0,
      flow_cdp_active: false,
      cdp_not_active_text: "Al momento il flusso CDP è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di CDP.",
      flow_poste_active: false,
      poste_not_active_text: "Al momento il flusso Poste Italiane è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di Poste Italiane."

    };
  },

  methods: {
    sendOfferToVerificationAgileEnergy: function sendOfferToVerificationAgileEnergy(practice) {
      //console.warn(practice)
      var _vue = this;
      this.loadingState = true;

      var token = _vue.getProfile.userToken;
      if (token) {
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/sendOfferToVerificationAgileEnergy',
          method: 'POST',
          data: {
            practice: practice,
            userToken: token
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _vue.loadingState = false;

          _vue.$swal('Preventivo In Verifica', '', 'success');
          _vue.getPractices();
        }).catch(function (resp) {

          _vue.$swal('Ops. Riprova piu tardi', '', 'error');
          _vue.loadingState = false;
        });
      } else {
        _vue.loadingState = false;
      }
    },
    getPractices2: function getPractices2() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _vue, token;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _vue = _this;

                _this.loadingState = true;

                token = _vue.getProfile.userToken;

                if (!token) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getPractices',
                  method: 'POST',
                  data: {
                    type: 0,
                    user_token: token
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  _vue.practices = resp.data.practices;

                  _vue.totCash = 0;
                  _vue.countPractices = 0;
                  _vue.countCashInst = 0;
                  _vue.countCashClient = 0;
                  for (var x in _vue.practices) {
                    if (_vue.practices[x].status == '0') {
                      // CALC ONLY VALID ORDERS
                      _vue.countPractices++;
                      _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_bonus_savings)).toFixed(2);

                      _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_bonus_savings)).toFixed(2);
                      _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                    }

                    if (_vue.practices[x].status == '9') {
                      _vue.hasRemovedPractics = true;
                    }
                  }
                  _this.totCash = parseFloat(_this.totCash);
                  if (_this.totCash < 10000) {
                    _this.maxTotCash = 10000;
                    _this.step = 1000;
                  } else if (_this.totCash < 100000) {
                    _this.maxTotCash = 100000;
                    _this.step = 10000;
                  } else if (_this.totCash < 1000000) {
                    _this.maxTotCash = 1000000;
                    _this.step = 100000;
                  } else if (_this.totCash < 100000000) {
                    _this.maxTotCash = 100000000;
                    _this.step = 1000000;
                  }
                  _vue.practicesFiltred = _vue.practices;

                  _vue.loadingState = false;
                }).catch(function (resp) {

                  _this.presentPractices = false;
                  _vue.loadingState = false;
                  //_vue.$swal({
                  //  type: 'error',
                  //  title: 'Oops...',
                  //  text: 'Riprova piu tardi!',
                  //});
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    searchBy: function searchBy(type, filter) {

      this.page = 1;
      this.getPractices(type, filter);
      if (filter == '10' || filter == '9') {
        this.hasRemovedPractics = true;
      } else {
        this.hasRemovedPractics = false;
      }
    },


    callback: function callback(page) {
      console.log('CHANGE PAGE => To: ' + page);
      this.page = page;
      this.getPractices(this.filterType, this.filterVal);
    },

    getPractices: function getPractices(type, filter) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _vue, token;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('SEARCH BY => ' + type + ' / ' + filter);
                _vue = _this2;

                _vue.practicesFiltred = {};

                _vue.showFilterText = false;

                if (type && type != '') {
                  _this2.filterType = type;
                } else {
                  _this2.filterType = false;
                }

                if (filter && filter != '') {
                  _this2.filterVal = filter;
                } else {
                  _this2.filterVal = '';
                }

                _this2.loadingState = true;
                token = _vue.getProfile.userToken;

                if (!token) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 11;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getPracticesPagination',
                  method: 'POST',
                  data: {
                    type: 'orders',
                    user_token: token,
                    displayPerPage: _this2.displayPerPage,
                    page: _this2.page,
                    filterType: _this2.filterType,
                    filter: _this2.filterVal
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _vue.practices = resp.data.practices;

                  if (_vue.practices.length == 0) {
                    _vue.showFilterText = true;
                  }

                  _vue.practicesFiltred = _vue.practices;
                  _vue.practicesFiltredCount = parseInt(resp.data.total);

                  _vue.loadingState = false;
                  _vue.loaded = true;
                }).catch(function (resp) {
                  console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor');
                  _vue.presentPractices = false, _vue.loadingState = false;
                  _vue.loaded = true;
                });

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPracticesCounts: function getPracticesCounts() {

      var _vue = this;

      this.loadingState = true;
      var token = _vue.getProfile.userToken;

      if (token) {
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getPracticesCounts',
          method: 'POST',
          data: {
            type: 'orders',
            user_token: token
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          console.log('COUNT PRACTICES => ' + resp.data.counts);

          _vue.counts = resp.data.counts;

          _vue.length = parseInt(_vue.counts.countPractices);

          _vue.totCash = parseFloat(_vue.counts.sumTotal);
          if (_vue.totCash < 10000) {
            _vue.maxTotCash = 10000;
            _vue.step = 1000;
          } else if (_vue.totCash < 100000) {
            _vue.maxTotCash = 100000;
            _vue.step = 10000;
          } else if (_vue.totCash < 1000000) {
            _vue.maxTotCash = 1000000;
            _vue.step = 100000;
          } else if (_vue.totCash < 10000000) {
            _vue.maxTotCash = 10000000;
            _vue.step = 1000000;
          }

          _vue.loadingState = false;

          _vue.loadedCount = true;

          _vue.getPractices();
        }).catch(function (resp) {
          console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor');
          _vue.presentPractices = false, _vue.loadingState = false;
        });
      }
    },
    removeOrder: function removeOrder(id, code, key) {
      var id_order = id;
      var _vue = this;

      if (key == 'restore') {
        var type = 0;
        var popUpText = '<br/>Sei sicuro di voler ripristinare Preventivo N. ' + code + '?<br/><br/>';
      } else {
        var type = 9;
        var popUpText = '<br/>Sei sicuro di voler archiviare Preventivo N. ' + code + '?<br/><br/>';
      }

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: popUpText,
        showCancelButton: true,
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        console.log(result);
        if (result.value) {

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/changeOrderState',
            method: 'POST',
            data: {
              id: id,
              user_token: _vue.getProfile.userToken,
              status: type
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {

            _vue.getPractices();

            if (key == 'restore') {
              _vue.$swal('Preventivo N. ' + code + ' <br/>è stato ripristinato ', '', 'success');
            } else {
              _vue.$swal('Preventivo N. ' + code + ' <br/>è stato archiviato ', '', 'success');
            }
          }).catch(function (resp) {
            _vue.$swal('Ops. Riprova piu tardi', '', 'error');
          });
        }
      });
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      if (val) {
        console.log(val);
        //this.getPractices()
        this.getPracticesCounts();
      }
    },
    filter: function filter(val) {
      this.filterValues();
    }
  },
  created: function created() {},
  mounted: function mounted() {

    if (this.getProfile) {
      //this.getPractices()
      this.getPracticesCounts();
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8b643a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/offerte/index.vue
var offerte_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-md-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("Non hai Preventivi")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Crea Preventivo")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-3 pt-md-3 align-items-end"
              },
              [
                _c("div", { staticClass: "col-md-4 pb-0" }, [
                  _c("h5", { staticClass: "grey pt-0 pb-0" }, [
                    _vm._v("Totale Preventivi: "),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(" " + _vm._s(_vm.counts.countPractices))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "grey pt-0 mt-2" }, [
                    _vm._v("Totale Fatt. quota Clienti: "),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(
                        "€ " +
                          _vm._s(
                            _vm._f("formatNumber")(_vm.counts.countCashClient)
                          )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "grey pt-0 mt-2" }, [
                    _vm._v("Totale Fatt. quota Cessione: "),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(
                        "€ " +
                          _vm._s(
                            _vm._f("formatNumber")(_vm.counts.countCashInst)
                          )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-10 col-md-4 center pl-5 pr-5" },
                  [
                    _vm.counts.countCashInst
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.counts.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v(" € ")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.counts.countCashInst
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("small", [
                                  _vm._v("Totale Fatt. quota Cessione")
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.searchBy("text", _vm.filterVal)
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "text-center grey mobSearchT" }, [
                        _vm._v("Ricerca Preventivo")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterVal,
                              expression: "filterVal"
                            }
                          ],
                          staticClass: "form-control seachMobButton",
                          attrs: {
                            type: "text",
                            placeholder: "Numero Preventivo o Cognome ....."
                          },
                          domProps: { value: _vm.filterVal },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filterVal = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append " }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary btnYellow",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.searchBy("text", _vm.filterVal)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "white",
                                attrs: { icon: "search", size: "sm" }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger mt-2",
                      staticStyle: { width: "68%" },
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "9")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "trash-alt", size: "sm" }
                      }),
                      _vm._v("  Preventivi Archiviati "),
                      _c("b", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " + _vm._s(_vm.counts.hasRemovedPractics) + " "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btnYellow mt-2",
                      staticStyle: { width: "28%" },
                      on: {
                        click: function($event) {
                          return _vm.searchBy("", "")
                        }
                      }
                    },
                    [_vm._v("\n           Reset\n        ")]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5 " }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator"
            },
            [
              _vm.loaded
                ? _c("pagination", {
                    attrs: {
                      options: {
                        theme: "bootstrap4",
                        texts: {
                          count:
                            "Visualizzazione da {from} a {to} di {count} Preventivi|{count} Preventivi|Un Preventivo"
                        }
                      },
                      records: _vm.practicesFiltredCount,
                      "per-page": _vm.displayPerPage
                    },
                    on: { paginate: _vm.callback },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.showFilterText
            ? _c(
                "div",
                { staticClass: "col-md-12 col-lg-12" },
                [
                  _c(
                    "badger-accordion",
                    {
                      key: "1231dsdfh32354134",
                      staticClass: "pb-5 mt-4",
                      attrs: {
                        icons: {
                          opened: "<span></span>",
                          closed: "<span></span>"
                        }
                      }
                    },
                    _vm._l(_vm.practicesFiltred, function(item, key) {
                      return item.status != 9
                        ? _c(
                            "badger-accordion-item",
                            { key: item.code + "_" + _vm.countloop },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-9" },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              "Cessionario Finale:\n                    "
                                            ),
                                            item.flow == "poste"
                                              ? _c("b", [
                                                  _vm._v(" Poste Italiane ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "cdp"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Cassa Depositi e Prestiti "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "general"
                                              ? _c("b", [
                                                  _vm._v(" Flusso Base ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "agileenergy"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Flusso Agile Energy "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "mbfacta"
                                              ? _c("b", [
                                                  _vm._v(" Flusso MBFACTA ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "mbfacta_recovery"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Flusso Personalizzato "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "h5",
                                            {
                                              staticClass: "black csLineHeight2"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Preventivo N. "
                                              ),
                                              _c(
                                                "b",
                                                { staticClass: "underline" },
                                                [_vm._v(_vm._s(item.code))]
                                              ),
                                              _vm._v(
                                                "\n                    del " +
                                                  _vm._s(
                                                    _vm
                                                      .moment(item.created_at)
                                                      .format(
                                                        "DD-MM-YYYY HH:mm"
                                                      )
                                                  ) +
                                                  " ( " +
                                                  _vm._s(item.bonus) +
                                                  " )\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v(" Cliente: "),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.client_lastname
                                                    ) +
                                                    " " +
                                                    _vm._s(item.client_name) +
                                                    "  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                " Indirizzo dell'immobile: "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.building_address
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      item.building_civic
                                                    ) +
                                                    " " +
                                                    _vm._s(item.building_city) +
                                                    " (" +
                                                    _vm._s(
                                                      item.building_province
                                                    ) +
                                                    ") CAP " +
                                                    _vm._s(item.building_zip) +
                                                    "  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              item.flow != "agileenergy"
                                                ? [
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            " Totale Fatturato quota Cliente: "
                                                          ),
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "€ " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item.total_transfer_for_client
                                                                    )
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " Totale Fatturato quota Cessione: "
                                                        ),
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass: "black"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.total_bonus_savings
                                                                  )
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("span", [
                                                          _c("br"),
                                                          _vm._v(
                                                            "Totale Fattura da installatore professionista in subappalto verso AGILE ENERGY\n                         "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "per il materiale e l'installazione, come indicati nel Preventivo: "
                                                          ),
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "green"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "€ " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item.totale_imponibile
                                                                    )
                                                                  ) +
                                                                  "*"
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("small", [
                                                          _vm._v(
                                                            "* Da fatturare "
                                                          ),
                                                          _c("b", [
                                                            _vm._v("senza IVA ")
                                                          ]),
                                                          _vm._v(
                                                            " in quanto operazione soggetta al reverse charge art. 17, comma 6, lett. a-ter DPR 633/1972.\n\n                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " Costo di gestione del Servizio del General Contractor AGILE ENERGY\n                      "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "a supporto della gestione di questa Pratica è pari a:\n                      "
                                                        ),
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass: "green"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.price_agile
                                                                  )
                                                                ) +
                                                                " + IVA (22%)"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "che sarà fatturato da AGILE ENERGY verso l'installatore professionista in subappalto\n\n\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    item.state_agile == 4
                                                      ? [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "pt-1 green"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _c("small", [
                                                                  _vm._v(
                                                                    "\n                          La Lettera di Affidamento ed il Contratto per la fornitura e l’installazione sono in verifica da AGILE ENERGY.\n                          A seguito dell'approvazione "
                                                                  ),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      " verranno inviate al Committente le indicazioni per procedere al pagamento della quota parte relativa alla voce “Totale altri Oneri per il Committente”\n\n                            all'indirizzo e-mail "
                                                                    ),
                                                                    _c(
                                                                      "b",
                                                                      {
                                                                        staticClass:
                                                                          "black"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          '"' +
                                                                            _vm._s(
                                                                              item.client_email
                                                                            ) +
                                                                            '"'
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    ".\n                       "
                                                                  )
                                                                ])
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          item.flow == "poste" &&
                                          _vm.flow_poste_active
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Modifica Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "poste" &&
                                          !_vm.flow_poste_active
                                            ? [
                                                _c(
                                                  "h5",
                                                  { staticClass: "red Bold" },
                                                  [
                                                    _vm._v(
                                                      'Valore nominale di Cessione modificabile liberalmente dall\'aderente ( cliccando "Modifica Preventivo" )\n                    '
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Modifica Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "cdp" &&
                                          _vm.flow_cdp_active
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-green m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "acceptInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "clipboard-check",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Conferma Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Modifica Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "cdp" &&
                                          !_vm.flow_cdp_active
                                            ? [
                                                _c(
                                                  "h5",
                                                  { staticClass: "red Bold" },
                                                  [
                                                    _vm._v(
                                                      'Valore nominale di Cessione modificabile liberalmente dall\'aderente ( cliccando "Modifica Preventivo" )\n                    '
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                    Modifica Preventivo\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("br")
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "general"
                                            ? [
                                                _c(
                                                  "h5",
                                                  { staticClass: "red Bold" },
                                                  [
                                                    _vm._v(
                                                      'Valore nominale di Cessione modificabile liberalmente dall\'aderente ( cliccando "Modifica Preventivo" )\n                    '
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-green m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "acceptInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "clipboard-check",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Conferma Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnYellow m-2 btn-sm",
                                                    attrs: {
                                                      to: {
                                                        name: "editInvoice",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "edit",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Modifica Preventivo\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "mbfacta"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "mbfacta_recovery"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "agileenergy"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btnBlue m-2 btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.invoice_quotation_pdf,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "print",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza/Stampa/Scarica\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                item.state_agile == 3
                                                  ? _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-green m-2 btn-sm",
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "acceptInvoice",
                                                            params: {
                                                              item: item
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon:
                                                                "clipboard-check",
                                                              size: "1x"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n                      Conferma Preventivo\n                    "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-danger m-2 btn-sm mr-md-5 ",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.removeOrder(
                                                    item.id,
                                                    item.code,
                                                    key
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "archive",
                                                  size: "sm"
                                                }
                                              }),
                                              _vm._v(
                                                " Annulla ed Archivia Preventivo\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-7 col-md-1 center pl-md-0 pr-md-0 pt-3 "
                                        },
                                        [
                                          item.enea_request == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                attrs: {
                                                  src: __webpack_require__("vg18")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.to_get_cadastral_data == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                attrs: {
                                                  src: __webpack_require__("6Z51")
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-2" }, [
                                        item.flow != "agileenergy"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "inline-block center relative mt-3"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "qrcodeImg mb-3",
                                                  attrs: { src: item.qrcode }
                                                }),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "qrcodeText mt-3 pt-4"
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "Conferma con QRCode"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      item.error_agile != null &&
                                      item.flow == "agileenergy"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black widthFull text-left"
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull mr-4"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "red" },
                                                        [_vm._v(" Attenzione ")]
                                                      ),
                                                      _vm._v(
                                                        " abbiamo rilevato le seguenti anomalie:"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "red widthFull text-left pl-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.error_agile) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                               false
                                ? _c(
                                    "template",
                                    {
                                      staticClass: "bbaLightColor",
                                      slot: "content"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-md-12 col-lg-12"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                { staticClass: "black" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Indirizzo dell'immobile"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 col-lg-12 pt-4 pb-3"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                { staticClass: " pt-0 mt-2" },
                                                [
                                                  _vm._v(
                                                    "Totale Fatt. quota Cliente: "
                                                  ),
                                                  _c(
                                                    "b",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              item.total_transfer_for_client
                                                            )
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                { staticClass: " pt-0 mt-2" },
                                                [
                                                  _vm._v(
                                                    "Totale Fatt. quota Cessione: "
                                                  ),
                                                  _c(
                                                    "b",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              item.total_bonus_savings
                                                            )
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasRemovedPractics
                    ? _c(
                        "div",
                        [
                          _vm.hasRemovedPractics
                            ? _c("h5", { staticClass: "text-left black" }, [
                                _vm._v("Preventivi Archiviati")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRemovedPractics
                            ? _c("p", { staticClass: "text-left black Bold" }, [
                                _vm._v(
                                  "Attenzione! I dati contenuti in questa schermata non includono i Preventivi archiviati. "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "badger-accordion",
                            { staticClass: "pb-5 mt-4 greyBg" },
                            _vm._l(_vm.practicesFiltred, function(item, key) {
                              return item.status == 9 && _vm.filter == ""
                                ? _c(
                                    "badger-accordion-item",
                                    {
                                      key: item.code + "_r_" + _vm.countloop,
                                      attrs: { id: "id" + item.code }
                                    },
                                    [
                                      _c(
                                        "template",
                                        {
                                          staticClass: "center",
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-9" },
                                                [
                                                  _c(
                                                    "h5",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        "\n                          Preventivo N. "
                                                      ),
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "underline"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.code)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                          del " +
                                                          _vm._s(
                                                            _vm
                                                              .moment(
                                                                item.created_at
                                                              )
                                                              .format(
                                                                "DD-MM-YYYY HH:mm"
                                                              )
                                                          ) +
                                                          " ( " +
                                                          _vm._s(item.bonus) +
                                                          " )\n                          per "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.client_name
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.client_lastname
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary m-2 btn-sm",
                                                      attrs: {
                                                        href:
                                                          item.invoice_quotation_pdf,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "print",
                                                          size: "sm"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        " visualizza/stampa/scarica\n                        "
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-danger m-2 btn-sm mr-md-5",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.removeOrder(
                                                            item.id,
                                                            item.code,
                                                            "restore"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon:
                                                            "trash-restore-alt",
                                                          size: "sm"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        " Ripristina\n                        "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "col-md-3"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "template",
                                        {
                                          staticClass: "bbaLightColor",
                                          slot: "content"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 col-lg-12"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    { staticClass: "black" },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Indirizzo dell'immobile"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 col-lg-12"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        item.building_address
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item.building_civic
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item.building_city
                                                      ) +
                                                      " (" +
                                                      _vm._s(
                                                        item.building_province
                                                      ) +
                                                      ") CAP: " +
                                                      _vm._s(
                                                        item.building_zip
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 col-lg-12"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass: "black pb-0"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Dati dell'intervento"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-6" },
                                                [
                                                  _vm._v(
                                                    "\n                        Tipo: "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "uppercase"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.intervention_type
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-6" },
                                                [
                                                  _vm._v(
                                                    "\n                        Data: "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "uppercase"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .moment(
                                                              item.intervention_date
                                                            )
                                                            .format(
                                                              "DD-MM-YYYY"
                                                            )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5"
                },
                [
                  _c("h5", { staticClass: "center" }, [
                    _vm._v(
                      "Nessun risultato  " +
                        _vm._s(
                          _vm.filterVal != 1 &&
                            _vm.filterVal != 2 &&
                            _vm.filterVal != 3 &&
                            _vm.filterVal != 0
                            ? " per " + _vm.filterVal
                            : ""
                        )
                    )
                  ])
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator"
            },
            [
              _vm.loaded
                ? _c("pagination", {
                    attrs: {
                      options: {
                        theme: "bootstrap4",
                        texts: {
                          count:
                            "Visualizzazione da {from} a {to} di {count} Preventivi|{count} Preventivi|Un Preventivo"
                        }
                      },
                      records: _vm.practicesFiltredCount,
                      "per-page": _vm.displayPerPage
                    },
                    on: { paginate: _vm.callback },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var offerte_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("div", { staticClass: "col-md-12 pb-0" }, [
        _c("h3", { staticClass: "Regular text-left h0 widthFull" }, [
          _c("b", [_vm._v("Gestione Preventivi")])
        ])
      ])
    ])
  }
]
offerte_render._withStripped = true
var offerte_esExports = { render: offerte_render, staticRenderFns: offerte_staticRenderFns }
/* harmony default export */ var components_offerte = (offerte_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8b643a0", offerte_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/offerte/index.vue
var offerte_disposed = false
function offerte_injectStyle (ssrContext) {
  if (offerte_disposed) return
  __webpack_require__("oiZF")
}
var offerte_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var offerte___vue_template_functional__ = false
/* styles */
var offerte___vue_styles__ = offerte_injectStyle
/* scopeId */
var offerte___vue_scopeId__ = "data-v-d8b643a0"
/* moduleIdentifier (server only) */
var offerte___vue_module_identifier__ = null
var offerte_Component = offerte_normalizeComponent(
  offerte,
  components_offerte,
  offerte___vue_template_functional__,
  offerte___vue_styles__,
  offerte___vue_scopeId__,
  offerte___vue_module_identifier__
)
offerte_Component.options.__file = "src/components/offerte/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8b643a0", offerte_Component.options)
  } else {
    hotAPI.reload("data-v-d8b643a0", offerte_Component.options)
  }
  module.hot.dispose(function (data) {
    offerte_disposed = true
  })
})()}

/* harmony default export */ var src_components_offerte = (offerte_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/superbonus/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var superbonus_moment = __webpack_require__("PJh5");



/* harmony default export */ var superbonus = ({
  name: 'superbonus',
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"]
  },
  data: function data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      practices: {},
      countPractices: 0,
      countCashClient: 0,
      countCashInst: 0,
      practicesFiltred: {},
      filter: '',
      presentPractices: true,
      moment: __webpack_require__("PJh5"),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      showFilterText: false,
      hasRemovedPractics: false
    };
  },

  methods: {
    getPractices: function getPractices() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _vue, token;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _vue = _this;

                _this.loadingState = true;
                console.log(_vue.getProfile.userToken);
                token = _vue.getProfile.userToken;

                if (!token) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getPractices',
                  method: 'POST',
                  data: {
                    type: 0,
                    user_token: token
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  _vue.practices = resp.data.practices;
                  _vue.totCash = 0;
                  _vue.countPractices = 0;
                  _vue.countCashInst = 0;
                  _vue.countCashClient = 0;
                  for (var x in _vue.practices) {
                    if (_vue.practices[x].status == '0') {
                      // CALC ONLY VALID ORDERS
                      _vue.countPractices++;
                      _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_work_and_iva)).toFixed(2);

                      _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2);
                      _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                    }

                    if (_vue.practices[x].status == '9') {
                      _vue.hasRemovedPractics = true;
                    }
                  }
                  _this.totCash = parseFloat(_this.totCash);
                  if (_this.totCash < 10000) {
                    _this.maxTotCash = 10000;
                    _this.step = 1000;
                  } else if (_this.totCash < 100000) {
                    _this.maxTotCash = 100000;
                    _this.step = 10000;
                  } else if (_this.totCash < 1000000) {
                    _this.maxTotCash = 1000000;
                    _this.step = 100000;
                  } else if (_this.totCash < 100000000) {
                    _this.maxTotCash = 100000000;
                    _this.step = 1000000;
                  }
                  _vue.practicesFiltred = _vue.practices;

                  _vue.loadingState = false;
                }).catch(function (resp) {

                  _this.presentPractices = false;
                  _vue.loadingState = false;
                  //_vue.$swal({
                  //  type: 'error',
                  //  title: 'Oops...',
                  //  text: 'Riprova piu tardi!',
                  //});
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filterValues: function filterValues() {
      var text = this.filter.toLowerCase();
      console.log(text);
      this.practicesFiltred = {};
      var z = 0;

      for (var x in this.practices) {
        if (this.practices[x].code.toLowerCase().includes(text) || this.practices[x].client_lastname.toLowerCase().includes(text) || this.practices[x].client_name.toLowerCase().includes(text) || this.practices[x].building_city.toLowerCase().includes(text)) {
          this.practicesFiltred[x] = this.practices[x];
          z = z + 1;
        }
      }

      if (z == 0) {
        this.showFilterText = true;
      } else {
        this.showFilterText = false;
      }
    },
    removeOrder: function removeOrder(id, code, key) {
      var id_order = id;
      var _vue = this;

      if (key == 'restore') {
        var type = 0;
        var popUpText = '<br/>Sei sicuro di voler ripristinare Preventivo N. ' + code + '?<br/><br/>';
      } else {
        var type = 9;
        var popUpText = '<br/>Sei sicuro di voler eliminare Preventivo N. ' + code + '?<br/><br/>';
      }

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: popUpText,
        showCancelButton: true,
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        console.log(result);
        if (result.value) {

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/changeOrderState',
            method: 'POST',
            data: {
              id: id,
              user_token: _vue.getProfile.userToken,
              status: type
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {

            _vue.getPractices();

            if (key == 'restore') {
              _vue.$swal('Preventivo N. ' + code + ' <br/>è stato ripristinato ', '', 'success');
            } else {
              _vue.$swal('Preventivo N. ' + code + ' <br/>è stato eliminato ', '', 'success');
            }
          }).catch(function (resp) {
            _vue.$swal('Ops. Riprova piu tardi', '', 'error');
          });
        }
      });
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      if (val) {
        console.log(val);
        this.getPractices();
      }
    },
    filter: function filter(val) {
      this.filterValues();
    }
  },
  created: function created() {},
  mounted: function mounted() {

    if (this.getProfile) {
      this.getPractices();
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0b1917","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superbonus/index.vue
var superbonus_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mb-5" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "row justify-content-center text-left vaillantCont mb-5"
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-5  center" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Indietro")]
                )
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var superbonus_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("h3", { staticClass: "Regular  h0 widthFull" }, [
        _c("b", [_vm._v(" Superbonus 110% ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h5", [
        _vm._v(
          "Se vuoi gestire una pratica di Cessione del credito per il Superbonus 110% questi sono il documenti necessari\n          "
        ),
        _c("br"),
        _vm._v(
          "( seleziona l'elenco in base al tipo di unita immobiliare oggetto dell'intervento )"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs mt-5",
          attrs: { id: "myTab", role: "tablist" }
        },
        [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link active black",
                attrs: {
                  id: "home-tab",
                  "data-toggle": "tab",
                  href: "#home",
                  role: "tab",
                  "aria-controls": "home",
                  "aria-selected": "true"
                }
              },
              [_vm._v("Unità Singola")]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link black",
                attrs: {
                  id: "profile-tab",
                  "data-toggle": "tab",
                  href: "#profile",
                  role: "tab",
                  "aria-controls": "profile",
                  "aria-selected": "false"
                }
              },
              [_vm._v("Condominio")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tab-content", attrs: { id: "myTabContent" } }, [
        _c(
          "div",
          {
            staticClass: "tab-pane fade show active center",
            attrs: {
              id: "home",
              role: "tabpanel",
              "aria-labelledby": "home-tab"
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-md-9" }, [
                _c("img", {
                  staticClass: "img-fluid widthFull mt-4",
                  attrs: { src: __webpack_require__("FiR5") }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            attrs: {
              id: "profile",
              role: "tabpanel",
              "aria-labelledby": "profile-tab"
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-md-9" }, [
                _c("img", {
                  staticClass: "img-fluid widthFull mt-4",
                  attrs: {
                    src: __webpack_require__("2czj")
                  }
                })
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-5 mt-5 center" }, [
      _c("h5", [
        _vm._v(
          "Per procedere con la gestione della pratica contatta il supporto clienti al numero 02 9475 6677\n          "
        ),
        _c("br"),
        _vm._v(" oppure invia una mail a "),
        _c(
          "a",
          {
            staticClass: "link yellow",
            attrs: { href: "mailto:info@chebonus.it" }
          },
          [_vm._v("info@chebonus.it")]
        )
      ])
    ])
  }
]
superbonus_render._withStripped = true
var superbonus_esExports = { render: superbonus_render, staticRenderFns: superbonus_staticRenderFns }
/* harmony default export */ var components_superbonus = (superbonus_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b0b1917", superbonus_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/superbonus/index.vue
var superbonus_disposed = false
var superbonus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var superbonus___vue_template_functional__ = false
/* styles */
var superbonus___vue_styles__ = null
/* scopeId */
var superbonus___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var superbonus___vue_module_identifier__ = null
var superbonus_Component = superbonus_normalizeComponent(
  superbonus,
  components_superbonus,
  superbonus___vue_template_functional__,
  superbonus___vue_styles__,
  superbonus___vue_scopeId__,
  superbonus___vue_module_identifier__
)
superbonus_Component.options.__file = "src/components/superbonus/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b0b1917", superbonus_Component.options)
  } else {
    hotAPI.reload("data-v-0b0b1917", superbonus_Component.options)
  }
  module.hot.dispose(function (data) {
    superbonus_disposed = true
  })
})()}

/* harmony default export */ var src_components_superbonus = (superbonus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/editCalc/index.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var editCalc_moment = __webpack_require__("PJh5");

var editCalc_numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';












/* harmony default export */ var editCalc = ({
  name: 'login',
  data: function data() {
    var _ref;

    return _ref = {
      brand: "CHEBONUS",
      //  ONLY FOR EDIT *****************************
      item: {},
      // *****************************
      documents: {},
      username: '',
      password: '',
      token: '',
      numeral: __webpack_require__("ViqS"),
      proccess: 'START',
      loading: false,
      priceAcc: '',
      cdpState: 'not_active', //not_active, pending, error, active
      flow: '',

      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroAT: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroVdC: false,
      zeroEneaOld: '',
      zeroDcastOld: '',
      zeroATOld: '',
      zeroOneriOld: '',
      zeroPraticaOld: '',
      zeroVdCOld: '',

      //NEWWWW 222
      client_owner_type: '',
      client_owner_codice_fiscale: '',

      client_codice_fiscale: '',
      client_partita_iva: '',

      priceWork: '',
      tempMail: '',
      socialEmail: false,
      social: '',
      items: {},
      ecoBonus: '',
      fin_cost: 0,
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: 'Caldaia a condensazione',
          value: 'condensazione'
        },
        1: {
          name: 'Caldaia tradizionale',
          value: 'tradizionale'
        },
        2: {
          name: 'Pompa di calore',
          value: 'pompadicalore'
        },
        3: {
          name: 'Sistemi Ibridi kit completo',
          value: 'ibridi'
        },
        4: {
          name: 'Scaldacqua PDC',
          value: 'scaldacqua'
        },
        5: {
          name: 'Climatizzatore',
          value: 'climatizzatore'
        },
        6: {
          name: 'Collettore solare termico',
          value: 'solare'
        },
        7: {
          name:  true ? 'Altro Prodotto Vaillant' : 'Altro Prodotto HSD',
          value: 'altroVaillant'
        }
      },
      groupsAccessori: {
        0: {
          name: 'Termoregolazione evoluta',
          value: 'termoregolazione'
        },
        1: {
          name: 'Altro Accessorio ' + ( true ? 'Vaillant' : 'HSD'),
          value: 'altroV'
        },
        2: {
          name: 'Valvole termostatiche',
          value: 'valvole_termostatiche'
        },
        3: {
          name: 'Altro materiale/valvolame',
          value: 'altro'
        }

      },
      groupsAccessoriDestination: {},
      confirmed: true,
      usoAbitativo: 1,
      resend_success: false,
      loadingState2: false,
      loadingState: false,

      passwordFieldType: 'password',
      moment: editCalc_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [],

      accessories: [],

      quantity: '',
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: 'md',

      // TAB 1 CLIENT
      client_ragione_sociale: '',
      clientLastname: '',
      clientName: '',
      adress: '',
      civic: '',
      email: '',
      phone: '',
      mobile: '',
      provincies: [],
      province: '',
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: '',
      zip: '',
      datiCatastali: '',

      parse_adress: '',
      parse_civic: '',
      parse_province: '',
      parse_city: '',
      parse_zip: '',

      client_mobile: '',
      client_phone: '',
      client_email: '',
      //TAB2 INTERVENTO
      eventType: '',
      eventStartdate: '',
      it: locale["it"]
    }, defineProperty_default()(_ref, 'eventStartdate', ''), defineProperty_default()(_ref, 'disabledDatesStart', {
      to: '',
      from: ''
    }), defineProperty_default()(_ref, 'allProducts', {}), defineProperty_default()(_ref, 'totalAccessories', '0,00'), defineProperty_default()(_ref, 'totalProducts', '0,00'), defineProperty_default()(_ref, 'enea', ''), defineProperty_default()(_ref, 'requiredOperations', ''), defineProperty_default()(_ref, 'client_type', ''), defineProperty_default()(_ref, 'priceEnea', ''), defineProperty_default()(_ref, 'client_ownership', 'Proprietario'), defineProperty_default()(_ref, 'totalExtraMise', 0), defineProperty_default()(_ref, 'clearExtraMise', false), defineProperty_default()(_ref, 'NoEnea', false), defineProperty_default()(_ref, 'priceDcast', ''), defineProperty_default()(_ref, 'priceAT', ''), defineProperty_default()(_ref, 'iva_altri_oneri', 0.22), defineProperty_default()(_ref, 'iva_accessori_lavoro', 0.10), defineProperty_default()(_ref, 'iva_age_extra', 0.22), defineProperty_default()(_ref, 'iva_age_lavoro', 0.10), defineProperty_default()(_ref, 'iva_age_accessori', 0.10), defineProperty_default()(_ref, 'age_lavoro', 0), defineProperty_default()(_ref, 'age_extra', 0), defineProperty_default()(_ref, 'bonusError', false), defineProperty_default()(_ref, 'bonusErrorText', ''), defineProperty_default()(_ref, 'dl', '0'), defineProperty_default()(_ref, 'tqsa', '10.000'), defineProperty_default()(_ref, 'edilLibera', '0'), defineProperty_default()(_ref, 'showEdilLiberaSelect', false), defineProperty_default()(_ref, 'iban_agileenergy', "IT25J0306933911100000014182"), defineProperty_default()(_ref, 'priceAgileenergy', 0), defineProperty_default()(_ref, 'agileDiscount', false), defineProperty_default()(_ref, 'client_province', ''), defineProperty_default()(_ref, 'client_city', ''), defineProperty_default()(_ref, 'client_zip', ''), defineProperty_default()(_ref, 'client_address', ''), defineProperty_default()(_ref, 'client_civic', ''), defineProperty_default()(_ref, 'parse_client_province', ''), defineProperty_default()(_ref, 'parse_client_city', ''), defineProperty_default()(_ref, 'parse_client_zip', ''), defineProperty_default()(_ref, 'parse_client_address', ''), defineProperty_default()(_ref, 'parse_client_civic', ''), defineProperty_default()(_ref, 'addressLoaded', false), _ref;
  },

  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    Flows: components_flowSettings_flows,
    Address: components_calcolatore_address
  },
  methods: {
    setDestinationAccessories: function setDestinationAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].destination;

      this.calcTotalPriceAccessories();

      this.calcTotalPriceProducts();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    agilePricePopUp: function agilePricePopUp() {
      var _this = this;

      var text = '';

      if (!this.agileDiscount) {
        text = 'Cliccando Procedi attivi <br/> Servizio del General Contractor AGILE ENERGY <br/> a supporto della gestione di questa Pratica pari a:';
        text += '<br/>€ ' + (this.priceAgileenergy | this.formatNumber) + ' ( IVA escl. )';
        text += '<br/><br/> Questo costo non è incluso in questo Preventivo, pertanto l`installatore professionista in subappalto ad AGILE ENERGY riceverà la relativa fattura da AGILE ENERGY in compensazione della fattura che l`installatore professionista in subappalto emetterà ad AGILE ENERGY per il materiale e l`installazione, come indicati nel Preventivo.';
      } else {

        text = 'Cliccando Procedi attivi <br/> Servizio del General Contractor AGILE ENERGY <br/> a supporto della gestione di questa Pratica pari a:';
        text += '<br/>€ ' + ((this.priceAgileenergy / 70 * 100).toFixed(2) | this.formatNumber) + ' - Sconto 30% = € ' + (this.priceAgileenergy | this.formatNumber) + ' ( IVA escl. )';
        text += '<br/><br/> Questo costo non è incluso in questo Preventivo, pertanto l`installatore professionista in subappalto ad AGILE ENERGY riceverà la relativa fattura da AGILE ENERGY in compensazione della fattura che l`installatore professionista in subappalto emetterà ad AGILE ENERGY per il materiale e l`installazione, come indicati nel Preventivo.';
      }

      this.$swal({
        type: 'info',
        html: text,
        showCancelButton: true,
        confirmButtonText: 'Procedi',
        cancelButtonText: 'Indietro'
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        console.log(result);
        if (result.value) {
          _this.onComplate();
        }
      });
    },
    setProvinceResidence: function setProvinceResidence(val) {
      //console.log(val)
      this.client_province = val;
    },
    setCityResidence: function setCityResidence(val) {
      //console.log(val)
      this.client_city = val;
    },
    setZipResidence: function setZipResidence(val) {
      //console.log(val)
      this.client_zip = val;
    },
    setAddressResidence: function setAddressResidence(val) {
      //console.log(val)
      this.client_address = val;
    },
    setCivicResidence: function setCivicResidence(val) {
      //console.log(val)
      this.client_civic = val;
    },
    setProvinceBuilding: function setProvinceBuilding(val) {
      //console.log(val)
      this.province = val;
    },
    setCityBuilding: function setCityBuilding(val) {
      //console.log(val)
      this.city = val;
    },
    setZipBuilding: function setZipBuilding(val) {
      //console.log(val)
      this.zip = val;
    },
    setAddressBuilding: function setAddressBuilding(val) {
      //console.log(val)
      this.adress = val;
    },
    setCivicBuilding: function setCivicBuilding(val) {
      //console.log(val)
      this.civic = val;
    },
    setFlowFromComponent: function setFlowFromComponent(val) {
      if (val) {
        this.flow = val;

        if (val == 'agileenergy') {
          this.priceEnea = 50;
          this.priceDcast = 10;

          this.priceEnea = '50,00';
          this.priceDcast = '10,00';

          this.iva_altri_oneri = 0.22;
          this.iva_accessori_lavoro = 0.1;
          this.iva_age_extra = 0.22;
          this.iva_age_lavoro = 0.1;
          this.iva_age_accessori = 0.1;
        }

        this.calcIvaCustom(this.client_type);

        //console.warn(val)
        this.nextTab();
      }
    },
    setSection: function setSection(val) {
      this.$router.push({
        path: '/flowSettings/#section' + val,
        query: {
          plan: 'private'
        }
      });
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab0: function validateZeroTab0() {
      var _vue = this;
      //console.log(_vue.flow)
      if (_vue.flow != '') {
        this.$scrollTo('#app', 700, {
          offset: -170
        });
        return true;
      } else {
        _vue.showFlowError();
        this.$scrollTo('#app', 700, {
          offset: -170
        });
        return false;
      }
    },
    flowNotActive: function flowNotActive() {
      this.$swal({
        type: 'warning',
        title: 'ATTENZIONE!',
        html: 'Per procedere con questo Cessionario Finale, clicca su pulsante "ABILITA" e completa la procedura di attivazione. '
      });
    },
    showFlowError: function showFlowError() {
      this.$swal({
        type: 'warning',
        title: 'ATTENZIONE!',
        html: 'Per procedere seleziona il Cessionario Finale'
      });
    },
    nextTab: function nextTab() {
      var wizard = this.$refs.mainWizard;
      wizard.nextTab();
    },
    keymonitor: function keymonitor(event, index, type) {
      //console.log(event)
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace('.', ',');
        } else {
          //console.log(event.key)
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace('.', ',');
        }
      }
    },
    setBonus: function setBonus(value) {

      this.ecoBonus = value;
      var note = {};
      note.text = 'Perfetto hai scelto ' + value + ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = 'NOTIFICATION';
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], note);

      var _vue = this;

      setTimeout(function () {
        // NEWWWWWWWW
        //console.log('ECOBONUS => ' + _vue.ecoBonus)
        if (_vue.ecoBonus == 'Bonus Casa 50%') {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        //console.log('clearExtraMise => ' + _vue.clearExtraMise)
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex: function stepIndex(from, to) {
      if (to == 3) {
        //console.log('CHECK ALL PRODUCTS WITH EXIST RULES')
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          //console.log(prod[x])
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 1 && to == 2 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push('/superbonus');
      }
    },
    checkIfEmpty: function checkIfEmpty(element) {
      //console.log(element.target.id)
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == '') {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab: function validateZeroTab() {
      var _vue = this;
      this.$validator.validateAll('form-0').then(function (result) {
        if (!result) {
          //console.log('ERROR IN FORM')
          _vue.$scrollTo('#app', 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo('#app', 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll('form-0');
    },
    validateFirstTab: function validateFirstTab() {
      var _vue = this;
      console.warn(this.$validator.errors);
      this.$validator.validateAll('form-1').then(function (result) {
        if (!result) {
          //console.log('ERROR IN FORM')
          _vue.$scrollTo('#app', 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo('#app', 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll('form-1');
    },

    validateSecondTab: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _vue;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //console.log(this.$validator)
                _vue = this;
                _context2.next = 3;
                return this.$validator.validateAll('form-2').then(function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(result) {
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (result) {
                              _context.next = 4;
                              break;
                            }

                            //console.log('ERROR IN FORM')
                            _vue.$scrollTo('#app', 700, {
                              offset: -170
                            });
                            _context.next = 8;
                            break;

                          case 4:
                            _vue.$scrollTo('#app', 700, {
                              offset: -170
                            });

                            if (_vue.bonusError) {
                              _context.next = 8;
                              break;
                            }

                            _context.next = 8;
                            return _vue.beginCalc('si');

                          case 8:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 3:
                if (!_vue.bonusError) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', false);

              case 7:
                return _context2.abrupt('return', this.$validator.validateAll('form-2'));

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validateSecondTab() {
        return _ref2.apply(this, arguments);
      }

      return validateSecondTab;
    }(),
    validateThirdTab: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _vue;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _vue = this;
                _context4.next = 3;
                return this.$validator.validateAll('form-3').then(function () {
                  var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(result) {
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!result) {
                              //console.log('ERROR IN FORM')
                              _vue.$scrollTo('#app', 700, {
                                offset: -170
                              });
                            } else {
                              _vue.$scrollTo('#app', 700, {
                                offset: -170
                              });
                            }

                          case 1:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));

                  return function (_x2) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 3:
                if (!_vue.bonusError) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt('return', false);

              case 7:
                return _context4.abrupt('return', this.$validator.validateAll('form-3'));

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function validateThirdTab() {
        return _ref4.apply(this, arguments);
      }

      return validateThirdTab;
    }(),
    getDocumentsList: function () {
      var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(flow, type, client) {
        var clientType, _vue, data, x;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                if (client == 'Persona fisica') {
                  clientType = 'documents_physical_person';
                } else if (client == 'Partita IVA') {
                  clientType = 'documents_legal_person';
                } else if (client == 'Amministratore di condominio') {
                  clientType = 'documents_condominium';
                }

                _vue = this;
                //console.warn('INSIDE getDocumentsList')

                data = {
                  flow: flow,
                  type: type,
                  clientType: clientType
                  //_vue.loadingState = true

                  //console.warn('DATA getDocumentsList', data)

                };
                _context5.next = 5;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getDocumentsList',
                  method: 'POST',
                  data: data,
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  //_vue.loadingState = false
                  if (resp.data.documents) {
                    return resp.data.documents;
                  } else {
                    return false;
                  }
                }).catch(function (resp) {
                  _vue.$swal({
                    type: 'error',
                    title: 'Ops....',
                    html: 'Riprova più tardi'
                  });
                  return false;
                  //_vue.loadingState = false
                });

              case 5:
                x = _context5.sent;
                return _context5.abrupt('return', x);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getDocumentsList(_x3, _x4, _x5) {
        return _ref6.apply(this, arguments);
      }

      return getDocumentsList;
    }(),
    prepareDocumentList: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var docs, docTemp, docsFinal, docHtml, i, x, obl, from, template;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getDocumentsList(this.flow, this.dl == 'old' ? 'short' : 'full', this.client_type);

              case 2:
                docs = _context6.sent;

                //console.warn(docs)

                //this.documents = docs
                docTemp = docs;

                this.documents = {};

                docsFinal = docs;
                docHtml = '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>In carico a</th> <th>Modello disponibile</th> </tr>';
                i = 1;

                // NEWWWW REMOVE DELEGE

                if (this.datiCatastali == '0' || this.datiCatastali == 0) {
                  // DELEGA VISURA
                  delete docsFinal['2050D111'];
                } else {
                  delete docsFinal['2050D11'];
                }
                if (this.enea == '0' || this.enea == 0) {
                  // DELEGA ENEA
                  delete docsFinal['2050D112'];
                } else {
                  delete docsFinal['2050D15'];
                }

                if (this.ecoBonus == 'Bonus Casa 50%' && this.client_type != 'Amministratore di condominio') {
                  delete delete docsFinal['2050D19'];
                }

                for (x in docsFinal) {
                  obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";
                  from = docsFinal[x].owner;
                  template = docsFinal[x].template == "yes" ? "SI" : "";


                  docHtml = docHtml + '<tr> <th>' + i + '</th><th align="left"> ' + docsFinal[x].name + '</th><th> ' + from + '</th><th> ' + template + '</th></tr>';
                  i = i + 1;
                }
                docHtml = docHtml + '</tbody></table>';
                return _context6.abrupt('return', docHtml);

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function prepareDocumentList() {
        return _ref7.apply(this, arguments);
      }

      return prepareDocumentList;
    }(),
    onComplate: function onComplate() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var docsFinal, data, part2, part4, AttPercent;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this2.loadingState = true;

                _context7.next = 3;
                return _this2.prepareDocumentList();

              case 3:
                docsFinal = _context7.sent;

                //var docsFinal = ''
                // PREPARE DATA TO POST
                data = {};
                // PASS DOC LIST

                data.docs = docsFinal;

                // NEW ADD FLOW CDP
                data.flow = _this2.flow;
                data.disposal = 0;

                /////// NEW *******************************************************************
                data.oldItem = _this2.item;
                /////// NEW *******************************************************************

                // ALL USER DATA
                data.user = _this2.getProfile;
                // BONUS SELECTED
                data.bonus = _this2.ecoBonus;
                // CLIENT DATA

                data.client_ragione_sociale = _this2.client_ragione_sociale;
                data.client_name = _this2.clientName;
                data.client_lastname = _this2.clientLastname;
                data.client_type = _this2.client_type;

                data.client_mobile = _this2.client_mobile;
                data.client_phone = _this2.client_phone;
                data.client_email = _this2.client_email;

                // NEWWWWWWWWW
                if (_this2.zeroEnea) {
                  data.client_price_enea = _this2.zeroEneaOld;
                } else {
                  data.client_price_enea = _this2.priceEnea;
                }

                // NEWWWWWWWWW 2
                if (_this2.zeroDcast) {
                  data.client_price_dcast = _this2.zeroDcastOld;
                } else {
                  data.client_price_dcast = _this2.priceDcast;
                }

                // NEWWWWWWWWW 2
                if (_this2.zeroAT) {
                  data.client_price_at = _this2.zeroATOld;
                } else {
                  data.client_price_at = _this2.priceAT;
                }
                //data.client_price_at = this.priceAT

                // CLIENT HOUSE DATA
                data.building_province = _this2.province;
                data.building_city = _this2.city.city;
                data.building_zip = _this2.zip;
                data.building_address = _this2.adress;
                data.building_civic = _this2.civic;

                // CLIENT RESIDENCE ================================================================
                if (_this2.flow == 'agileenergy' || _this2.flow == 'mbfacta_recovery') {
                  data.client_address = _this2.client_address;
                  data.client_civic = _this2.client_civic;
                  if (_this2.province != 'SE') {
                    data.client_province = _this2.client_province;
                    data.client_city = _this2.client_city.city;
                    data.client_zip = _this2.client_zip;
                  } else {
                    data.client_province = _this2.client_province;
                    data.client_city = _this2.client_city.city;
                    data.client_zip = _this2.client_zip;
                  }
                }

                // TO GET CADASTRAL DATA ?
                data.to_get_cadastral_data = _this2.datiCatastali;
                // INTERVENTION DATA
                data.intervention_type = _this2.eventType;
                data.intervention_date = editCalc_moment(_this2.eventStartdate).format('YYYY-MM-DD');
                // PRODUCTS & ACCESSORIES
                data.products = _this2.products;
                data.accessories = _this2.accessories;
                data.enea_request = _this2.enea;
                data.created_at = editCalc_moment().format('YYYY-MM-DD HH:mm:00');
                data.created_date = editCalc_moment().format('DD-MM-YYYY HH:mm');

                // CASH VALUES
                data.total_product_price = _this2.totalProducts;
                data.total_accessories_price = _this2.totalAccessories;
                data.price_work = _this2.priceWork;

                data.total_transfer_for_user = _this2.calcInfo.aInstallatore;
                data.total_transfer_for_client = _this2.calcInfo.finalPrice;
                data.total_bonus_savings = _this2.calcInfo.totalWithBonus;

                data.total_work_and_iva = _this2.calcInfo.totalBaseAndIva;

                // HTML FOR PDF
                data.htmlInvoice = _this2.$refs.invoiceData.innerHTML;

                if (typeof _this2.$refs.invoiceData_part2 != 'undefined') {
                  part2 = _this2.$refs.invoiceData_part2.outerHTML;
                } else {
                  part2 = '';
                }
                if (typeof _this2.$refs.invoiceData_part4 != 'undefined') {
                  part4 = _this2.$refs.invoiceData_part4.outerHTML;
                } else {
                  part4 = '';
                }
                console.log(_this2.$refs.invoiceData_part1.outerHTML);
                data.htmlInvoiceParts = {
                  prodotti: _this2.$refs.invoiceData_part1.outerHTML,
                  altri_oneri_agevolabili: part2,
                  totale_imponibile: _this2.$refs.invoiceData_part3.outerHTML,
                  riepilogo_iva: part4,
                  tqsa: _this2.$refs.invoiceData_part5.outerHTML,
                  bonus_and_oneri: _this2.$refs.invoiceData_part6.outerHTML,
                  total_for_user: _this2.$refs.invoiceData_part7.outerHTML
                  //requiredOperations: '',
                };data.building_uso_abitativo = _this2.usoAbitativo;

                data.client_ownership = _this2.client_ownership;

                data.iva_altri_oneri = _this2.iva_altri_oneri;
                data.iva_accessori_lavoro = _this2.iva_accessori_lavoro;
                data.iva_age_extra = _this2.iva_age_extra;
                data.iva_age_lavoro = _this2.iva_age_lavoro;
                data.iva_age_accessori = _this2.iva_age_accessori;

                // DL 12
                data.dl = _this2.dl;
                data.bl = 1;

                // NEW 2022
                if (_this2.flow == 'agileenergy') {
                  data.price_agile = _this2.priceAgileenergy;
                  data.state_agile = 1;
                  data.error_agile = null;
                } else {
                  data.price_agile = 0;
                }

                if (!(_this2.flow == 'poste')) {
                  _context7.next = 61;
                  break;
                }

                AttPercent = 17;
                _context7.next = 82;
                break;

              case 61:
                if (!(_this2.flow == 'cdp')) {
                  _context7.next = 65;
                  break;
                }

                AttPercent = 12.5;
                _context7.next = 82;
                break;

              case 65:
                if (!(_this2.flow == 'general')) {
                  _context7.next = 69;
                  break;
                }

                if (_this2.fin_cost) {
                  AttPercent = (100 - parseFloat(_this2.fin_cost)).toFixed(2);
                } else {
                  AttPercent = 40;
                }

                _context7.next = 82;
                break;

              case 69:
                if (!(_this2.flow == 'agileenergy')) {
                  _context7.next = 73;
                  break;
                }

                AttPercent = 19;
                _context7.next = 82;
                break;

              case 73:
                if (!(_this2.flow == 'mbfacta')) {
                  _context7.next = 77;
                  break;
                }

                AttPercent = 16.5;
                _context7.next = 82;
                break;

              case 77:
                if (!(_this2.flow == 'mbfacta_recovery')) {
                  _context7.next = 81;
                  break;
                }

                AttPercent = 16.5;
                _context7.next = 82;
                break;

              case 81:
                return _context7.abrupt('return', false);

              case 82:
                data.flow_oneri = AttPercent;
                data.totale_imponibile = _this2.calcInfo.totalBase;

                data.practice_price = (parseFloat(_this2.calcInfo.serviceCost) * (1 + parseFloat(_this2.iva_altri_oneri))).toFixed(2);
                data.flow_tax = (parseFloat(_this2.calcInfo.allOneri) - parseFloat(_this2.calcInfo.serviceCost) * (1 + parseFloat(_this2.iva_altri_oneri))).toFixed(2);

                if (_this2.getProfile.reg_forfettario != 'si' || _this2.flow == 'agileenergy') {
                  data.tot_extra_for_user = (parseFloat(_this2.totalExtraMise) + parseFloat(_this2.calcInfo.iva22NonAge) + parseFloat(_this2.calcInfo.iva10NonAge) + parseFloat(_this2.priceDcast) * (1 + parseFloat(_this2.iva_altri_oneri)) + parseFloat(_this2.priceEnea.replace('.', '').replace(',', '.')) * (1 + parseFloat(_this2.iva_altri_oneri)) + parseFloat(_this2.calcInfo.allOneri)).toFixed(2);
                } else {
                  data.tot_extra_for_user = (parseFloat(_this2.totalExtraMise) + parseFloat(_this2.calcInfo.iva22NonAge) + parseFloat(_this2.calcInfo.iva10NonAge) + parseFloat(_this2.priceDcast) + parseFloat(_this2.priceEnea.replace('.', '').replace(',', '.')) + parseFloat(_this2.calcInfo.allOneri)).toFixed(2);
                }

                data.tot_bonifico_for_user = (parseFloat(_this2.calcInfo.totalBaseAndIva) - parseFloat(_this2.calcInfo.totalWithBonus)).toFixed(2);
                data.total_non_advantaged = (parseFloat(_this2.totalExtraMise) + parseFloat(_this2.calcInfo.iva22NonAge) + parseFloat(_this2.calcInfo.iva10NonAge)).toFixed(2);

                // NEW CODICE FISCALE PROPRIETARIO PER DCAST
                data.client_owner_type = _this2.client_owner_type;
                if (_this2.client_owner_type == 'Proprietario o comproprietario') {
                  data.client_owner_codice_fiscale = '';
                } else {
                  data.client_owner_codice_fiscale = _this2.client_owner_codice_fiscale;
                }

                data.client_codice_fiscale = _this2.client_codice_fiscale;
                data.client_partita_iva = _this2.client_partita_iva;

                axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/editPriceQuotation',
                  method: 'POST',
                  data: data,
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  var alert = {};
                  alert.text = 'Il tuo Preventivo è stato modificato!';
                  alert.type = 'SUCCESS';
                  _this2.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
                  _this2.$swal({
                    type: 'success',
                    title: 'Preventivo modificato',
                    html: alert.text
                  });
                  _this2.loadingState = false;

                  _this2.$router.push('/offerte');
                }).catch(function (resp) {
                  _this2.$swal({
                    type: 'error',
                    title: 'Ops....',
                    html: 'Riprova più tardi'
                  });
                  _this2.loadingState = false;
                });

              case 94:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this2);
      }))();
    },

    // MAIN CALC ***************************************************************
    beginCalc: function beginCalc(display) {

      this.calcTotalPriceProducts();

      this.bonusError = false;
      this.bonusErrorText = '';
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == 'Bonus Casa 50%') {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == 'Ecobonus 50%') {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == 'Ecobonus 65%') {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == 'Superbonus 110%') {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != 'nopopup') {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != 'nopopup') {

        // NEW DL
        if (this.dl == 'new') {
          this.calcInfo.vistoCost = 50;
        } else {
          this.calcInfo.vistoCost = 0;
        }

        //this.calcInfo.serviceCost = 160
        if (this.flow == 'poste') {
          if (this.dl == 'new') {
            this.calcInfo.serviceCost = 220;
          } else {
            this.calcInfo.serviceCost = 160;
          }
        } else if (this.flow == 'cdp') {
          if (this.dl == 'new') {
            this.calcInfo.serviceCost = 240;
          } else {
            this.calcInfo.serviceCost = 230;
          }
        } else if (this.flow == 'general') {

          if (this.dl == 'new') {
            this.calcInfo.serviceCost = 240;
          } else {
            this.calcInfo.serviceCost = 230;
          }
        } else if (this.flow == 'agileenergy') {

          if (this.dl == 'new') {
            this.calcInfo.serviceCost = 240;
          } else {
            this.calcInfo.serviceCost = 230;
          }
        } else if (this.flow == 'mbfacta') {

          if (this.dl == 'new') {
            this.calcInfo.serviceCost = 240;
          } else {
            this.calcInfo.serviceCost = 230;
          }
        } else if (this.flow == 'mbfacta_recovery') {

          if (this.dl == 'new') {
            this.calcInfo.serviceCost = 220;
          } else {
            this.calcInfo.serviceCost = 210;
          }
        } else {
          return false;
        }
      }

      //var AttPercent = 10.58
      if (this.flow == 'poste') {
        var AttPercent = 17;
      } else if (this.flow == 'cdp') {
        var AttPercent = 12.5;
      } else if (this.flow == 'general') {

        console.warn(' fin_cost => ', this.fin_cost);
        if (this.fin_cost) {
          var AttPercent = (100 - parseFloat(this.fin_cost)).toFixed(2);
        } else {
          var AttPercent = 40;
        }

        console.warn(' AttPercent => ', AttPercent);
      } else if (this.flow == 'agileenergy') {
        var AttPercent = 19;
      } else if (this.flow == 'mbfacta') {
        var AttPercent = 16.5;
      } else if (this.flow == 'mbfacta_recovery') {
        var AttPercent = 16.5;
      } else {
        return false;
      }

      var totProducts = parseFloat(this.totalProducts.replace('.', '').replace(',', '.')).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (parseFloat(totProducts.replace(',', '.')) - parseFloat(totalExtraMise.replace(',', '.'))).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(this.totalAccessories.replace('.', '').replace(',', '.')).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(this.priceWork.replace('.', '').replace(',', '.')).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(2);
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)


      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totAge) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totAge - totAltroAcc;
      } else {
        var x10 = totAge;
        var x22 = 0;
      }

      this.age_lavoro = x10;
      this.age_extra = x22;

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      */
      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (parseFloat(totAge) + parseFloat(totAltroAcc)).toFixed(2);

      if (this.getProfile.reg_forfettario != 'si' || this.flow == 'agileenergy') {
        this.calcInfo.iva10Age = (parseFloat(totAltroAcc) * this.iva_accessori_lavoro + parseFloat(totAge) * this.iva_age_lavoro).toFixed(2);
        //this.calcInfo.iva10NonAge = ((((parseFloat(totalExtraMise) )) * this.iva_altri_oneri)).toFixed(2)
        this.calcInfo.iva10NonAge = 0;

        //this.calcInfo.iva22Age = ((((parseFloat(totAge) )) * this.iva_age_extra )).toFixed(2)
        this.calcInfo.iva22Age = (parseFloat(this.age_extra) * this.iva_age_extra).toFixed(2);
        this.calcInfo.iva22NonAge = (parseFloat(totalExtraMise) * this.iva_altri_oneri).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      //console.log('totProducts ' + totProducts)
      //console.log('totalExtraMise ' + totalExtraMise)
      //console.log('totAccess ' + totAccess)
      //console.log('workPrice ' + workPrice)
      //console.log('totAltroAcc ' + totAltroAcc)
      //console.log('totAge ' + totAge)
      //console.log('totalExtraMise ' + totalExtraMise)

      //console.log('x10 ' + x10)
      //console.log('x22 ' + x22)
      //console.log('ratio10 ' + ratio10)
      //console.log('ratio22 ' + ratio22)
      //console.log(this.calcInfo)


      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        } else {
          //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        }*/

      //console.log('totalBase - ' + this.calcInfo.totalBase)


      // CALC AGILE COSTS
      if (this.flow == 'agileenergy') {

        var totImponibile = parseFloat(this.calcInfo.totalBase);
        if (totImponibile <= 5000) {
          this.priceAgileenergy = 300;
        } else if (totImponibile <= 10000) {
          this.priceAgileenergy = 300;
        } else if (totImponibile <= 15000) {
          this.priceAgileenergy = 300;
        }

        // SCONTO 30%
        if (this.agileDiscount) {
          this.priceAgileenergy = this.priceAgileenergy * 0.7;
        }
        this.priceAgileenergy = this.priceAgileenergy.toFixed(2);
      }

      var temp = this.iva_age_extra;

      if (this.getProfile.reg_forfettario == 'si' && this.flow != 'agileenergy') {
        this.iva_accessori_lavoro = 0.00;
        this.iva_age_lavoro = 0.00;
        this.iva_age_accessori = 0.00;
        temp = 0.00;
      }

      //console.log('age_lavoro - ' + this.age_lavoro)
      //console.log('iva_age_lavoro - ' + this.iva_age_lavoro)
      //console.log('age_extra - ' + this.age_extra)
      //console.log('iva_age_extra - ' + this.iva_age_extra)
      //console.log('totAltroAcc - ' + totAltroAcc)
      //console.log('totAltroAcc - ' + this.iva_accessori_lavoro)


      //TOTAL BASE AND IVA 10 && 22
      //this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age)

      // MOD BL
      //this.calcInfo.totalBaseAndIva = (parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro))) + (parseFloat(this.age_extra) * (1 + parseFloat(temp))) + (parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro)))
      var prAT = this.priceAT.replace('.', '').replace(',', '.');
      //console.log('prAT - ' + prAT)

      this.calcInfo.totalBaseAndIva = parseFloat(prAT) * (1 + parseFloat(this.iva_altri_oneri)) + parseFloat(this.calcInfo.vistoCost) * (1 + parseFloat(this.iva_altri_oneri)) + parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro)) + parseFloat(this.age_extra) * (1 + parseFloat(temp)) + parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro));

      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBaseAndIva).toFixed(2);

      // TOTALE DETRAZIONE
      if (this.ecoBonus != 'Bonus Casa 50%' && this.client_type == 'Partita IVA' && this.usoAbitativo == 0 && this.iva_age_lavoro == '0.22' && this.iva_age_extra == '0.22' && this.iva_accessori_lavoro == '0.22') {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBase) / 100 * parseFloat(percentbonusDetr);
      } else {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentbonusDetr);
      }

      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalWithBonus).toFixed(2);

      this.calcInfo.total35 = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != 'nopopup') {
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.totalWithBonus) / 100 * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.costoAttualizazione).toFixed(2);
      }

      // NEW DL *****************************
      this.calcInfo.allOneri = parseFloat(this.calcInfo.costoAttualizazione) + (parseFloat(this.calcInfo.serviceCost) + parseFloat(this.calcInfo.serviceCost) * this.iva_altri_oneri);
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast = 10 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != 'si' || this.flow == 'agileenergy') {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace('.', '').replace(',', '.')) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.priceDcast) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace('.', '').replace(',', '.')) + parseFloat(this.priceDcast) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)


      if (this.enea) {
        var dEnea = 50 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (parseFloat(this.calcInfo.totalWithBonus) - parseFloat(this.calcInfo.costoAttualizazione) - dEnea - dCast).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(2);
      //console.log(this.calcInfo)

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      //console.warn( 'INIT CALC ****************' )


      if (parseFloat(this.calcInfo.totalBaseAndIva) > 15000 && this.flow == 'agileenergy') {
        // NEWWW BLOCK IF ERROR
        this.showEdilLiberaSelect = false;
        this.edilLibera == '0';
        this.bonusError = true;
        this.bonusErrorText = 'Il totale quota spesa agevolabile è superiore a € 15000 IVA incl.<br/><br/> Agile Energy accetta solo interventi di edilizia libera con Totale Quota Spesa Agevolabile ≤ € 15.000 IVA incl. e interventi di non edilizia libera con Totale Quota Spesa Agevolabile ≤ € 10.000 IVA incl. <br/>';
      } else {

        if (this.bonusErrorText == 'Il totale quota spesa agevolabile è superiore a € 15000 IVA incl.<br/><br/> Agile Energy accetta solo interventi di edilizia libera con Totale Quota Spesa Agevolabile ≤ € 15.000 IVA incl. e interventi di non edilizia libera con Totale Quota Spesa Agevolabile ≤ € 10.000 IVA incl. <br/>') {
          this.bonusError = false;
          this.bonusErrorText = '';
        }

        // new FLOW OLD RETURN CHECK -----------------------------------------------------------------------------
        if (parseFloat(this.calcInfo.totalBaseAndIva) <= 10000) {
          //console.warn( 'totalBaseAndIva < MIN_FOR_OLD_FLOW' )
          var dlCalculated = 'old';
          //console.warn( 'dlCalculated =>  ' + dlCalculated )
          this.priceAT = '0,00';

          if (this.priceAT != '0,00') {
            // NEWWW BLOCK IF ERROR
            //this.bonusError = true
            //this.bonusErrorText =  'Il totale quota spesa agevolabile è inferiore a € ' + this.tqsa + ' IVA incl. <br/> indicare € 0 come importo dell`asseverazione della congruità delle spese  <br/>'
          }
          this.showEdilLiberaSelect = false;
          this.edilLibera == '0';
        } else {
          //console.warn( 'totalBaseAndIva > MIN_FOR_OLD_FLOW' )

          if (this.edilLibera == '0') {
            this.bonusError = true;
            this.bonusErrorText = 'Il totale quota spesa agevolabile è superiore a € ' + this.tqsa + ' IVA incl. ';
            // NEW_
            this.showEdilLiberaSelect = true;
            return;
          }

          //this.priceAT = '0,00'
          if (this.edilLibera == '1') {
            this.priceAT = '0,00';
            var dlCalculated = 'old';
          } else if (this.edilLibera == '2') {

            if (this.priceAT == '0,00' || this.priceAT == '0') {
              this.bonusError = true;
              this.bonusErrorText = 'Inserisci l`importo dell`asseverazione della congruità delle spese rilasciata da un tuo tecnico abilitato ';
            }
            var dlCalculated = 'new';
          }

          //var dlCalculated = '0'
          //console.warn( ' dlCalculated  =>  ' + dlCalculated )
        }
        //console.warn( ' DL CALCOLATED =>  ' + this.dl )

        if (this.dl == '0' && parseFloat(this.calcInfo.totalBaseAndIva) <= 10000 || dlCalculated != this.dl && parseFloat(this.calcInfo.totalBaseAndIva) <= 10000) {
          this.dl = dlCalculated;
          this.beginCalc('si');
          return;
        }
        // ------------------------------------------------------------------------------------------------------

      }

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == 'Bonus Casa 50%' && display != 'nopopup') {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text = 'Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €';
          alert.type = 'ERROR';
          //console.warn(alert.text)

          // NEWWW BLOCK IF ERROR
          this.bonusError = true;
          this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == 'Ecobonus 50%' && display != 'nopopup') {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = 'Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €';
          alert.type = 'ERROR';
          //console.warn(alert.text)

          // NEWWW BLOCK IF ERROR
          this.bonusError = true;
          this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == 'condensazione') {

            for (var y in this.accessories) {
              if (this.accessories[y].group == 'valvole_termostatiche') {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text = 'Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica';
          alert.type = 'ERROR';
          //console.warn(alert.text)

          // NEWWW BLOCK IF ERROR
          //this.bonusError = true
          //this.bonusErrorText =  this.bonusErrorText + alert.text + '<br/>'

          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************


      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == 'Ecobonus 65%' && display != 'nopopup') {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text = 'Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €';
          alert.type = 'ERROR';
          //console.warn(alert.text)

          // NEWWW BLOCK IF ERROR
          this.bonusError = true;
          this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = 'Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €';
          alert.type = 'ERROR';
          //console.warn(alert.text)

          // NEWWW BLOCK IF ERROR
          this.bonusError = true;
          this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;
        var haveCondensed = false;
        for (var x in this.products) {
          if (this.products[x].group == 'condensazione') {
            haveCondensed = true;
            for (var y in this.accessories) {
              if (this.accessories[y].group == 'valvole_termostatiche') {
                presentValv = true;
              }
              if (this.accessories[y].group == 'termoregolazione') {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          if (haveCondensed) {
            var alert = {};
            alert.text = 'Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII';
            alert.type = 'ERROR';
            //console.warn(alert.text)

            // NEWWW BLOCK IF ERROR
            //this.bonusError = true
            //this.bonusErrorText =  this.bonusErrorText + alert.text + '<br/>'

            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: 'error',
              title: 'ATTENZIONE',
              html: alert.text
            });
          }
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************


      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == 'Superbonus 110%' && display != 'nopopup') {}
      // END SUPERBONUS 110   ******************************************************************************************************************


      this.calcFinish = true;
    },
    setEdiliziaLibera: function setEdiliziaLibera(val) {
      //console.log( 'SET EDILIZA LIBERA' + val )
      if (val == 'yes') {
        this.dl = 'old';
        this.edilLibera = '1';
        this.priceAT = '0,00';
      } else {
        this.dl = 'new';
        this.edilLibera = '2';
      }

      this.bonusError = false;
      this.bonusErrorText = '';
    },

    // ADD REMOVE ITEMS ***************************************************************
    addProduct: function addProduct() {
      var count = this.products.length;

      if (count) {
        this.productIndex = this.productIndex + 1;
      }

      this.products.push({
        index: 'product' + this.productIndex,
        indexCount: 'quantity' + this.productIndex,
        group: '',
        product: '',
        price: '',
        quantity: '',
        kw: '',
        error: false
      });
    },
    removeProduct: function removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories: function addAccessories() {

      var count = this.accessories.length;

      if (count) {
        this.accessoriesIndex = this.accessoriesIndex + 1;
      }

      this.accessories.push({
        index: 'product' + this.accessoriesIndex,
        indexCount: 'quantity' + this.accessoriesIndex,
        group: '',
        product: '',
        price: '',
        quantity: '',
        kw: '',
        error: false
      });
    },
    removeAccessories: function removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    },

    handleResize: function handleResize() {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = 'md';
      } else {
        this.stepSize = 'sm';
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function populateProvincies() {
      var _this3 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/getProvinciesAll',
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this3.provincies = resp.data.provincies;
        _this3.provinciesState = false;
      }).catch(function (resp) {
        _this3.provincies = [];
        _this3.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      //console.log(finalTo)
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork: function formatpriceWork() {
      this.priceWork = editCalc_numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea: function formatpriceEnea() {
      this.priceEnea = editCalc_numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast: function formatpriceDcast() {
      this.priceDcast = editCalc_numeral(this.priceDcast).format("0.0,[00]");
    },

    //new DL
    formatpriceAT: function formatpriceAT() {
      this.priceAT = editCalc_numeral(this.priceAT).format("0.0,[00]");

      if (this.bonusErrorText.includes("della congruità delle spese rilasciata")) {
        this.bonusErrorText = '';
        this.bonusError = false;
      }
    },


    // PRODUCTS ***************************************************************
    loadProducts: function loadProducts() {
      var _this4 = this;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/getProducts',
        method: 'POST',
        data: {
          key: 'calc'
        },
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this4.allProducts = resp.data.allProducts;
        //console.log(this.allProducts)
      }).catch(function (resp) {});
    },
    setGroup: function setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = '';
      this.products[i].price = '';
      this.products[i].kw = '';
      this.products[i].quantity = '';

      // NEW CALC MISE *********************************
      for (var y in this.products) {

        for (var x in this.groups) {
          if (this.groups[x].value == this.products[y].group) {
            this.groupsAccessoriDestination[y] = {
              name: this.groups[x].name,
              value: this.products[y].group
            };
          }
        }
      }
      // END NEWWWW    CALC MISE ******************************

      //console.log(this.items)
      this.calcTotalPriceProducts();
    },
    formatPrice: function formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = editCalc_numeral(this.products[i].price).format("0.0,[00]");
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct: function setProduct(index) {
      //console.log(1)
      var i = index.slice(7, index.length);

      if (this.products[i].group != 'ibridi') {
        if (this.products[i].group != 'altroVaillant') {
          this.products[i].kw = this.allProducts[this.products[i].group][this.products[i].product.index].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {

          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {

        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore).toFixed(2);

        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        //console.log('START LOAD IBRIDE')

        //console.log(this.products[i])
        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloCaldaiaACondensazione;
        var pompadicalore = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloPompaDiCalore;
        //console.log('condensazione => ' + condensazione)
        //console.log('pompadicalore => ' + pompadicalore)

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts['condensazione']) {
          //console.log(this.allProducts['condensazione'][x].Modello + ' = ' + condensazione)
          if (this.allProducts['condensazione'][x].Modello.includes(condensazione)) {
            condensazioneSearch = this.allProducts['condensazione'][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts['pompadicalore']) {
          if (this.allProducts['pompadicalore'][x].Modello.includes(pompadicalore)) {
            pompadicaloreSearch = this.allProducts['pompadicalore'][x];
          }
        }
      }

      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules: function checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      //console.log('FUNCTION => checkProductWithBonusRules')
      //console.log('BONUS SELECTED => ' + this.ecoBonus)

      this.bonusError = false;
      this.bonusErrorText = '';

      this.requiredOperations = '';

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == 'Bonus Casa 50%') {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        //console.warn('CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE')
        if (this.products[i].group == 'pompadicalore' && (this.province == "AL" || this.province == "AT" || this.province == "BI" || this.province == "CN" || this.province == "NO" || this.province == "TO" || this.province == "VB" || this.province == "VC")) {
          var canUseInPiemonte = this.allProducts[this.products[i].group][this.products[i].product.index].Piemonte;
          //console.warn('GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: ' + canUseInPiemonte)
          if (canUseInPiemonte == 'no') {
            var alert = {};
            alert.text = 'La pompa di calore selezionata risulta non installabile nella regione Piemonte';
            alert.type = 'ERROR';
            //console.warn(alert.text)

            // NEWWW BLOCK IF ERROR
            this.bonusError = true;
            this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: 'error',
              title: 'ATTENZIONE',
              html: alert.text
            });
          }
        }
        // SET requiredOperations
        if (this.products[i].group == 'pompadicalore' || this.products[i].group == 'condensazione' || this.products[i].group == 'ibridi' || this.products[i].group == 'tradizionale') {
          this.requiredOperations = 'Trattamento acqua UNI 8065 Prospetti 9 e 11';
        }
        // SET requiredOperations
        if (this.products[i].group == 'solare') {
          this.requiredOperations = 'Trattamento acqua UNI 8065 Prospetto 15';
        }
        // SET requiredOperations
        if (this.products[i].group == 'scaldacqua') {
          this.requiredOperations = 'Trattamento acqua UNI 8065 Prospetto 12';
        }

        // NO ENEA
        if (this.products[i].group == 'tradizionale') {
          this.NoEnea = true;
          this.priceEnea = '0';
          this.enea = 0;
        } else {
          this.NoEnea = false;
        }
      } else {
        //console.warn('CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%')
        if (this.products[i].group == 'pompadicalore') {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          //console.warn('GROUP => pompadicalore AND onlyBonusCasa: ' + onlyBonusCasa)
          if (onlyBonusCasa == 'yes') {
            var alert = {};
            alert.text = 'La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus';
            alert.type = 'ERROR';
            //console.warn(alert.text)

            // NEWWW BLOCK IF ERROR
            this.bonusError = true;
            this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: 'error',
              title: 'ATTENZIONE',
              html: alert.text
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == 'Ecobonus 50%') {
        if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {};
          alert.text = 'Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi';
          alert.type = 'ERROR';
          //console.warn(alert.text)

          // NEWWW BLOCK IF ERROR
          this.bonusError = true;
          this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text
          });
        } else {
          this.requiredOperations = ' - Trattamento acqua UNI 8065 Prospetti 9 e 11';
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == 'Ecobonus 65%') {
        /*
        if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {}
          alert.text = 'Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi'
          alert.type = 'ERROR'
          //console.warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }*/

        // FOR CONDENSAZIONE
        if (this.products[i].group == 'condensazione') {
          this.requiredOperations = ' - Trattamento acqua UNI 8065 Prospetti 9 e 11 ';
        }
        // FOR SOLARI
        if (this.products[i].group == 'solare') {
          this.requiredOperations = ' - Trattamento acqua UNI 8065 Prospetto 15';
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == 'Superbonus 110%') {}
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      /*if (this.eventType == 'Instalazione') {
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale' || this.products[i].group == 'pompadicalore' || this.products[i].group == 'ibridi' || this.products[i].group == 'scaldacqua') {
          var alert = {}
          alert.text = 'Per ' + this.ecoBonus + ' con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari'
          alert.type = 'ERROR'
          //console.warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }
      }*/
      // END EVENT TYPE  *********************************************************************************************************************

      // NEWWWW REVIEW POPUPS

      if (this.eventType == 'Instalazione' && this.ecoBonus == 'Bonus Casa 50%') {

        if (this.products[i].group != 'solare') {
          this.warning1();
        }
      }

      if (this.eventType == 'Instalazione' && this.ecoBonus == 'Ecobonus 50%') {

        if (this.products[i].group == 'condensazione') {
          this.warning2();
        }
      }

      if (this.eventType == 'Instalazione' && this.ecoBonus == 'Ecobonus 65%') {

        if (this.products[i].group != 'solare') {
          this.warning15();
        }
      }

      if (this.eventType != 'Instalazione' && this.ecoBonus == 'Ecobonus 65%') {

        if (this.products[i].group == 'climatizzatore') {
          this.warning16();
        }
      }

      if (this.ecoBonus != 'Bonus Casa 50%') {
        //console.warn('CHECK climatizzatore USED ONLY FOR BONUS CASA 50%')
        if (this.products[i].group == 'climatizzatore') {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          //console.warn('GROUP => climatizzatore AND onlyBonusCasa: ' + onlyBonusCasa)
          if (onlyBonusCasa == 'yes') {
            this.warning162();
          }
        }
      }
    },
    warning162: function warning162() {
      var _vue = this;
      var alert = {};
      //console.log('INSIDE 162')
      alert.text = 'Il climatizzatore selezionato risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus';
      alert.type = 'ERROR';

      // NEWWW BLOCK IF ERROR
      this.bonusError = true;
      this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

      setTimeout(function () {
        _vue.$swal({
          type: 'error',
          title: 'ATTENZIONE',
          html: alert.text
        });
      }, 1000);
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
    },
    warning16: function warning16() {
      var alert = {};
      alert.text = 'Con Ecobonus 65% la sostituzione di un climatizzatore è ammessa solo se si tratta dell`unico generatore di calore';
      alert.type = 'ERROR';
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: 'error',
        title: 'ATTENZIONE',
        html: alert.text
      });
    },
    warning15: function warning15() {
      var alert = {};
      alert.text = 'Con Ecobonus 65% la nuova installazione è consentita solo per Collettori Solari.';
      alert.type = 'ERROR';

      // NEWWW BLOCK IF ERROR
      this.bonusError = true;
      this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: 'error',
        title: 'ATTENZIONE',
        html: alert.text
      });
    },
    warning2: function warning2() {
      var alert = {};
      alert.text = 'Con Ecobonus 50% non è consentita la nuova installazione di apparecchi';
      alert.type = 'ERROR';

      // NEWWW BLOCK IF ERROR
      this.bonusError = true;
      this.bonusErrorText = this.bonusErrorText + alert.text + '<br/>';

      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: 'error',
        title: 'ATTENZIONE',
        html: alert.text
      });
    },
    warning1: function warning1() {
      var alert = {};
      alert.text = 'Con il BonusCasa 50% la nuova installazione è consentita solo per i Collettori Solari. È ammessa la nuova installazione anche di Climatizzatori e Pompe di Calore ma solo se l`impianto termico è esistente';
      alert.type = 'ERROR';
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: 'error',
        title: 'ATTENZIONE',
        html: alert.text
      });
    },
    insertProductCode: function insertProductCode(input) {
      var _this5 = this;

      var i = input.slice(7, input.length);
      //console.log(i)
      var _vue = this;

      this.$swal({
        title: 'Inserisci codice prodotto',
        input: 'text',
        text: 'esempio: 0010014674',
        inputAttributes: {
          autocapitalize: 'on'
        },
        showCancelButton: true,
        confirmButtonText: 'Cerca',
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return _this5.searchProduct(searchItem, i, input);

                  case 2:
                    result = _context8.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context8.next = 7;
                      break;
                    }

                    _this5.$swal.showValidationMessage('Codice Prodotto ' + 'deve essere composto da 10 caratteri');
                    return _context8.abrupt('return', false);

                  case 7:
                    if (!result) {
                      _context8.next = 12;
                      break;
                    }

                    _vue.checkProductWithBonusRules(input);
                    return _context8.abrupt('return', result);

                  case 12:
                    //throw new Error('Prodotto non trovato')
                    _this5.$swal.showValidationMessage(' ' + 'Prodotto non trovato');

                  case 13:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee8, _this5);
          }));

          return function preConfirm(_x6) {
            return _ref8.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this5.calcTotalPriceProducts();
      });
    },
    searchProduct: function searchProduct(searchItem, index, input) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                data = _this6.allProducts;
                _context9.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context9.t1 = _context9.t0()).done) {
                  _context9.next = 18;
                  break;
                }

                x = _context9.t1.value;
                _context9.t2 = regenerator_default.a.keys(data[x]);

              case 5:
                if ((_context9.t3 = _context9.t2()).done) {
                  _context9.next = 16;
                  break;
                }

                y = _context9.t3.value;

                if (!data[x][y].codice.includes(searchItem)) {
                  _context9.next = 14;
                  break;
                }

                //0010014674
                _this6.items[input] = _this6.allProducts[x];

                _this6.products[index].group = x;
                z = {
                  'index': y,
                  'name': data[x][y].Modello,
                  'serial': data[x][y].codice
                };

                _this6.products[index].product = z;
                _this6.products[index].quantity = 1;
                //this.products[index].price = data[x][y].prezzo

                return _context9.abrupt('return', data[x][y]);

              case 14:
                _context9.next = 5;
                break;

              case 16:
                _context9.next = 2;
                break;

              case 18:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this6);
      }))();
    },
    calcTotalPriceProducts: function calcTotalPriceProducts() {

      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        //new
        this.calcMaxPriceByKW(this.products[x].index);

        price += this.products[x].quantity * parseFloat(this.products[x].price.replace('.', '').replace(',', '.')).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise = parseFloat(this.totalExtraMise) + parseFloat(this.products[x].extraMise) * this.products[x].quantity;
        }
      }
      if (price) {
        this.totalProducts = editCalc_numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = '0,00';
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == 'Bonus Casa 50%') {

        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      //console.log('TOTAL EXTRA MISE ' + this.totalExtraMise)

      //console.warn(1)
      if (this.bonusErrorText.includes("totale quota spesa agevolabile")) {
        //console.warn(2)
        this.bonusErrorText = '';
        this.bonusError = false;
      }
    },
    calcMaxPriceByKW: function calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;
      var error = false;
      var errorType = false;

      // ADD ACCESSORIES PRICE TO CALC NEW MISE
      price = parseFloat(price.replace('.', ''));
      var priceAcc = 0;

      var countSameProductsGroup = 0;
      for (var b in this.products) {
        if (this.products[b].group == this.products[i].group) {
          countSameProductsGroup = (countSameProductsGroup + 1) * this.products[b].quantity;
        }
      }

      for (var a in this.accessories) {
        if (this.accessories[a].destination != '' && this.accessories[a].destination == this.products[i].group) {
          priceAcc = priceAcc + parseFloat(this.accessories[a].price.replace('.', '')) * this.accessories[a].quantity / countSameProductsGroup;
        }
      }

      price = parseFloat(price + priceAcc).toFixed(2);

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {

        // NEW POMPE DI CALORE
        if (this.products[i].group == 'climatizzatore') {
          if (this.products[i].kw) {
            //price = parseFloat(price.replace('.', '')).toFixed(2)
            var kw = parseFloat(this.products[i].kw.replace(',', '.')).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(',', '.'))).toFixed(2);
            if (res > 720) {
              error = '720';
              errorType = 'kw';
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(',', '.')) * 720).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == 'pompadicalore') {
          if (this.products[i].kw) {
            //price = parseFloat(price.replace('.', '')).toFixed(2)
            var kw = parseFloat(this.products[i].kw.replace(',', '.')).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(',', '.'))).toFixed(2);
            if (res > 1560 && !this.products[i].product.name.includes("flexo")) {
              error = '1560';
              errorType = 'kw';
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(',', '.')) * 1560).toFixed(2);
            }
            if (res > 2280 && this.products[i].product.name.includes("flexo")) {
              error = '2280';
              errorType = 'kw';
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(',', '.')) * 2280).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale') {
          if (this.products[i].kw) {
            //price = parseFloat(price.replace('.', '')).toFixed(2)
            var kw = parseFloat(this.products[i].kw.replace(',', '.')).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(',', '.'))).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 240) {
              error = '240';
              errorType = 'kw';
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(',', '.')) * 240).toFixed(2);
            } else if (kw > 35 && res > 216) {
              error = '216';
              errorType = 'kw';

              //console.log(price)
              //console.log(kw)
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(',', '.')) * 216).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == 'solare') {

          //price = parseFloat(price.replace('.', '')).toFixed(2)
          var type = this.allProducts[this.products[i].group][this.products[i].product.index].tipologia;
          var superfice = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].superficielorda.replace(',', '.')).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          //console.log('superfice ' + superfice)

          //console.log('res ' + res)

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == 'Piani' && res > 1200) {
            error = '1200';
            errorType = 'm2';
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1200).toFixed(2);
          } else if (type == 'Sottovuoto' && res > 1500) {
            error = '1500';
            errorType = 'm2';
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1500).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == 'scaldacqua') {
          if (this.products[i].kw) {
            //price = parseFloat(price.replace('.', '')).toFixed(2)
            var type = this.allProducts[this.products[i].group][this.products[i].product.index].capacita.replace(',', '.');
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            if (parseInt(type) <= 150 && price > 1200) {
              error = '1200';
              errorType = 'lt1';
              this.products[i].extraMise = (parseFloat(price) - 1200).toFixed(2);
            } else if (parseInt(type) > 150 && price > 1500) {
              error = '1500';
              errorType = 'lt2';
              this.products[i].extraMise = (parseFloat(price) - 1500).toFixed(2);
            }
          }

          //'climatizzatore'

        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == 'ibridi') {

          if (this.products[i].kw) {
            //price = parseFloat(price.replace('.', '')).toFixed(2)
            var kw = this.products[i].kw.replace(',', '.');
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1860) {
              error = '1860';
              errorType = 'kw';
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw) * 1860).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == 'kw') {
          alert.text = 'Il prezzo da te indicato (compreso accessori) supera il valore massimale MITE </br> €' + error + '/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura';
        }

        if (errorType == 'm2') {
          alert.text = 'Il prezzo da te indicato (compreso accessori) supera il valore massimale MITE </br> €' + error + '/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura';
        }

        if (errorType == 'lt1') {
          alert.text = 'Il prezzo da te indicato (compreso accessori) supera il valore massimale MITE </br> €' + error + ' fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura';
        }

        if (errorType == 'lt2') {
          alert.text = 'Il prezzo da te indicato (compreso accessori) supera il valore massimale MITE </br> €' + error + ' oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura';
        }

        alert.type = 'ERROR';
        this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
        this.$swal({
          type: 'error',
          title: 'ATTENZIONE',
          html: alert.text
        });
      }
    },


    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories: function calcTotalPriceAccessories() {
      var price = 0;
      for (var x in this.accessories) {
        price += this.accessories[x].quantity * parseFloat(this.accessories[x].price.replace('.', '').replace(',', '.')).toFixed(2);
      }
      if (price) {
        this.totalAccessories = editCalc_numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = '0,00';
      }

      //console.warn(1)
      if (this.bonusErrorText.includes("totale quota spesa agevolabile")) {
        //console.warn(2)
        this.bonusErrorText = '';
        this.bonusError = false;
      }
    },
    setTypeAccessories: function setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] = this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (x != 'condensazione' && x != 'tradizionale' && x != 'pompadicalore' && x != 'scaldacqua' && x != 'climatizzatore' && x != 'solare' && x != 'termoregolazione') {
        var z = {
          'index': i,
          'name': '',
          'serial': ''
        };
        this.accessories[i].product = z;
        this.accessories[i].destination = '';
        this.accessories[i].price = '';
        this.accessories[i].quantity = '';
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories: function formatPriceAccessories(index) {

      var i = index.slice(7, index.length);
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
      this.accessories[i].price = editCalc_numeral(this.accessories[i].price).format("0.0,[00]");

      this.calcTotalPriceProducts();
    },
    setAccessories: function setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      // /this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules: function checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (this.ecoBonus == 'Ecobonus 50%' || this.ecoBonus == 'Bonus Casa 50%') {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == 'condensazione') {
            presentCondenset = true;
          }
        }
        if (group == 'termoregolazione' && presentCondenset) {
          var alert = {};
          alert.text = 'Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%';
          alert.type = 'NOTIFICATION';
          //console.warn(alert.text)
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: 'info',
            title: 'ATTENZIONE',
            html: alert.text
          });
        }
      }
    },
    insertAccessoriesCode: function insertAccessoriesCode(input) {
      var _this7 = this;

      var i = input.slice(7, input.length);
      //console.log(i)

      this.$swal({
        title: 'Inserisci il codice accessorio',
        input: 'text',
        text: 'esempio: 0020124480',
        inputAttributes: {
          autocapitalize: 'on'
        },
        showCancelButton: true,
        confirmButtonText: 'Cerca',
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return _this7.searchAccessories(searchItem, i, input);

                  case 2:
                    result = _context10.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context10.next = 7;
                      break;
                    }

                    _this7.$swal.showValidationMessage('Codice Accessorio ' + 'deve essere composto da 10 caratteri');
                    return _context10.abrupt('return', false);

                  case 7:
                    if (!result) {
                      _context10.next = 11;
                      break;
                    }

                    return _context10.abrupt('return', result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this7.$swal.showValidationMessage(' ' + 'Accessorio non trovato');

                  case 12:
                  case 'end':
                    return _context10.stop();
                }
              }
            }, _callee10, _this7);
          }));

          return function preConfirm(_x7) {
            return _ref9.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this7.calcTotalPriceAccessories();
      });
    },
    searchAccessories: function searchAccessories(searchItem, index, input) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                data = _this8.allProducts;
                _context11.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context11.t1 = _context11.t0()).done) {
                  _context11.next = 20;
                  break;
                }

                x = _context11.t1.value;

                if (!(x != 'condensazione' && x != 'tradizionale' && x != 'pompadicalore' && x != 'scaldacqua' && x != 'climatizzatore' && x != 'solare')) {
                  _context11.next = 18;
                  break;
                }

                _context11.t2 = regenerator_default.a.keys(data[x]);

              case 6:
                if ((_context11.t3 = _context11.t2()).done) {
                  _context11.next = 18;
                  break;
                }

                y = _context11.t3.value;

                if (!(data[x][y].codice == searchItem)) {
                  _context11.next = 16;
                  break;
                }

                //0010014674
                _this8.itemsAccessories[input] = _this8.allProducts[x];
                _this8.accessories[index].group = x;
                z = {
                  'index': y,
                  'name': data[x][y].Modello,
                  'serial': data[x][y].codice

                };

                _this8.accessories[index].product = z;
                _this8.accessories[index].quantity = 1;
                _this8.accessories[index].destination = '';
                //this.accessories[index].price = data[x][y].prezzo

                //console.log(this.accessories)

                return _context11.abrupt('return', data[x][y]);

              case 16:
                _context11.next = 6;
                break;

              case 18:
                _context11.next = 2;
                break;

              case 20:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this8);
      }))();
    },
    mynotifications: function mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },
    getInvoiceProducts: function getInvoiceProducts(code) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getInvoiceProducts',
                  method: 'POST',
                  data: {
                    code: code
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  var items = resp.data.products;
                  var _vue = _this9;

                  //console.log(items)

                  _vue.productIndex = 0;
                  _vue.accessoriesIndex = 0;

                  var prodCount = 0;
                  var accCount = 0;

                  for (var x in items) {
                    // SET PRODUCTS

                    if (items[x].tipo == "product") {

                      _vue.addProduct();

                      // SET GROUP AND WAIT
                      _vue.products[prodCount].index = 'product' + prodCount;
                      _vue.products[prodCount].indexCount = 'quantity' + prodCount;
                      _vue.products[prodCount].group = items[x].gruppo;

                      _vue.setGroup(_vue.products[prodCount].index);

                      // FOR PRELOAD PRODUCTS OF THIS GROUP
                      setTimeout(function (x, items, Vue, prodCount) {
                        var y = {};

                        /////////////////////////////////////////////////////////////////////////
                        for (var u in _vue.items['product' + prodCount]) {
                          if (_vue.items['product' + prodCount][u]) {
                            if (_vue.items['product' + prodCount][u].Modello == items[x].nome) {
                              y.index = parseInt(u);
                            }
                          }
                        }

                        if (!y.index) {
                          y.index = accCount + 100;
                        }
                        //////////////////////////////////////////////////////////////////////////

                        y.name = items[x].nome;
                        y.serial = items[x].codice;
                        //_vue.products[x].product = y
                        _vue.products[prodCount].price = '';
                        _vue.products[prodCount].quantity = 1;

                        setTimeout(function (x, items, Vue, prodCount) {
                          var o = items[x].prezzo.replace('.', '');
                          _vue.products[prodCount].price = o;
                          _vue.products[prodCount].quantity = parseInt(items[x].quantita);
                          _vue.calcTotalPriceProducts();
                        }, 1000, x, items, Vue, prodCount);

                        _vue.products[prodCount].error = false;

                        //console.log(y)

                        var e = _vue.products[prodCount];
                        e.product = y;
                        Vue.set(_vue.products, prodCount, e);

                        _vue.setProduct(_vue.products[prodCount].index);
                      }, 1500, x, items, vue_esm["a" /* default */], prodCount);

                      prodCount = prodCount + 1;

                      //_vue.productIndex = prodCount

                    }
                    // SET ACCESORIES
                    else {

                        _vue.addAccessories();

                        // SET GROUP AND WAIT
                        _vue.accessories[accCount].index = 'product' + accCount;
                        _vue.accessories[accCount].indexCount = 'quantity' + accCount;
                        _vue.accessories[accCount].group = items[x].gruppo;
                        _vue.setTypeAccessories(_vue.accessories[accCount].index);

                        // FOR PRELOAD PRODUCTS OF THIS GROUP
                        setTimeout(function (x, items, Vue, accCount) {

                          var y = {};

                          for (var u in _vue.itemsAccessories['product' + accCount]) {
                            if (_vue.itemsAccessories['product' + accCount][u]) {

                              if (_vue.itemsAccessories['product' + accCount][u].Modello == items[x].nome) {
                                y.index = parseInt(u);
                              }
                            }
                          }

                          if (!y.index) {
                            y.index = accCount + 100;
                          }

                          y.name = items[x].nome;
                          y.serial = items[x].codice;

                          _vue.accessories[accCount].price = '';
                          _vue.accessories[accCount].destination = '';
                          _vue.accessories[accCount].quantity = 1;

                          //_vue.products[x].product = y
                          setTimeout(function (x, items, Vue, accCount) {
                            var p = items[x].prezzo.replace('.', '');
                            _vue.accessories[accCount].price = p;
                            _vue.accessories[accCount].quantity = parseInt(items[x].quantita);
                            _vue.accessories[accCount].destination = items[x].destinazione;
                            _vue.calcTotalPriceAccessories();
                          }, 1000, x, items, Vue, accCount);

                          _vue.accessories[accCount].error = false;

                          var e = _vue.accessories[accCount];
                          e.product = y;
                          Vue.set(_vue.accessories, accCount, e);

                          _vue.setAccessories(_vue.accessories[accCount].index);
                        }, 1500, x, items, vue_esm["a" /* default */], accCount);

                        accCount = accCount + 1;

                        //_vue.accessoriesIndex = accCount
                      }
                  }
                }).catch(function (resp) {});

              case 2:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this9);
      }))();
    },
    calcIvaCustom: function calcIvaCustom(val) {
      console.warn('calcIvaCustom');
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,*/

      if (val == 'Partita IVA') {
        this.iva_accessori_lavoro = 0.22;
        this.iva_age_lavoro = 0.22;
        this.iva_age_accessori = 0.22;
      } else {
        if (this.usoAbitativo == 0) {
          this.iva_accessori_lavoro = 0.22;
          this.iva_age_lavoro = 0.22;
          this.iva_age_accessori = 0.22;
        } else {
          this.iva_accessori_lavoro = parseFloat(0.10).toFixed(2);
          this.iva_age_lavoro = parseFloat(0.10).toFixed(2);
          this.iva_age_accessori = parseFloat(0.10).toFixed(2);
        }
      }
    }
  },
  watch: {
    fin_cost: function fin_cost(val) {
      console.warn(' fin_cost => ', val);
    },

    getProfile: function getProfile() {},

    client_type: function client_type(val) {
      this.calcIvaCustom(val);

      if (val == 'Partita IVA') {
        this.client_codice_fiscale = '';
      } else {
        this.client_partita_iva = '';
      }
    },
    usoAbitativo: function usoAbitativo(val) {
      this.calcIvaCustom(this.client_type);
    },

    zeroEnea: function zeroEnea(val) {
      //console.log('1')
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = '0';
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc('nopopup');
    },
    zeroDcast: function zeroDcast(val) {
      //console.log('1')
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = '0';
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc('nopopup');
    },
    zeroAT: function zeroAT(val) {
      //console.log('1')
      if (val) {
        this.zeroATOld = this.priceAT;
        this.priceAT = '0';
      } else {
        this.priceAT = this.zeroATOld;
      }
      this.beginCalc('nopopup');
    },
    zeroOneri: function zeroOneri(val) {
      //console.log('2')
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc('nopopup');
    },
    zeroPratica: function zeroPratica(val) {
      //console.log('3')
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc('nopopup');
    },
    zeroVdC: function zeroVdC(val) {
      //console.log('3')
      if (val) {
        this.zeroVdCOld = this.calcInfo.vistoCost;
        this.calcInfo.vistoCost = 0;
      } else {
        this.calcInfo.vistoCost = this.zeroVdCOld;
      }
      this.beginCalc('nopopup');
    },
    products: {
      handler: function handler(val) {},

      deep: true
    },
    priceWork: function priceWork(val) {
      this.priceWork = val.replace(/[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi, '');
    },
    clientName: function clientName(val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, '');
        this.clientName = this.clientName.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, '');
        this.clientName = this.clientName.toUpperCase();
      }
    },
    clientLastname: function clientLastname(val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, '');
        this.clientLastname = this.clientLastname.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, '');
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function client_mobile(val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, '');
      }
    },
    client_phone: function client_phone(val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, '');
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus: function authStatus(value) {
      if (value == 'not_confirmed') {
        this.confirmed = false;
      }
    },

    vw: function vw() {
      if (this.vw > 1200) {
        this.stepSize = 'md';
      } else if (this.vw > 600) {
        this.stepSize = 'sm';
      } else {
        this.stepSize = 'xs';
      }
    },
    priceAcc: function priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = '';
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this11 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this11.zips = resp.data.zips;
          _this11.zipsState = false;
        }).catch(function (resp) {
          _this11.zips = [];
          _this11.zipsState = false;
        });
      }
    },
    flow: function flow(val) {
      if (val == 'mbfacta_recovery') {
        this.groups[7] = {
          name: 'Altro Prodotto',
          value: 'altroVaillant'
        };
        this.groupsAccessori[1] = {
          name: 'Altro Accessorio',
          value: 'altroV'
        };

        this.datiCatastali = 0;
        this.enea = 0;
      } else {
        this.groups[7] = {
          name:  true ? 'Altro Prodotto Vaillant' : 'Altro Prodotto HSD',
          value: 'altroVaillant'
        };
        this.groupsAccessori[1] = {
          name: 'Altro Accessorio ' + ( true ? 'Vaillant' : 'HSD'),
          value: 'altroV'
        };
      }
    }
  },
  created: function created() {

    if (this.brand != 'CHEBONUS') {
      delete this.groups[3];
    }

    this.loadProducts();
  },
  mounted: function mounted() {

    // NEWWWWWWWWWWW


    // NEWWWWWW ***************************************************************
    if (this.$route.params.item) {
      this.item = this.$route.params.item;
      var data = this.item;
      // START POPULATE DATA
      //console.log(data)

      this.ecoBonus = data.bonus;
      // TAB 1 CLIENT
      this.clientLastname = data.client_name;
      this.clientName = data.client_lastname;
      this.client_ragione_sociale = data.client_ragione_sociale;

      this.email = '';
      this.phone = '';
      this.mobile = '';
      this.provincies = [];

      this.provinciesState = true;
      this.cities = [];
      this.citiesState = false;
      this.zips = [];
      this.zipsState = false;
      this.cityError = false;
      this.zipError = false;

      this.datiCatastali = parseInt(data.to_get_cadastral_data);

      this.client_mobile = data.client_mobile;
      this.client_phone = data.client_phone;
      this.client_email = data.client_email;
      //TAB2 INTERVENTO
      this.eventType = data.intervention_type;
      this.eventStartdate = data.intervention_date;
      this.totalAccessories = data.total_accessories_price;
      this.totalProducts = data.total_product_price;
      this.enea = parseInt(data.enea_request);
      this.requiredOperations = '';
      this.client_type = data.client_type;

      this.priceEnea = data.client_price_enea;
      this.priceDcast = data.client_price_dcast;

      this.priceAT = data.client_price_at;
      this.priceWork = data.price_work;
      this.totalExtraMise = 0;
      this.NoEnea = false;

      this.client_ownership = data.client_ownership;

      //this.flow = data.flow

      if (data.client_owner_type) {
        this.client_owner_type = data.client_owner_type;
      }
      if (data.client_owner_codice_fiscale) {
        this.client_owner_codice_fiscale = data.client_owner_codice_fiscale;
      }

      if (data.dl == 'new') {

        if (this.priceAT && this.priceAT != '0,00' && parseInt(data.total_work_and_iva) > 10000) {
          //console.log( parseInt( data.total_work_and_iva ) + '##############################################################################' )
          this.showEdilLiberaSelect = true;
          this.edilLibera = '2';
          this.dl = data.dl;
        } else {
          data.dl = '0';
        }
      } else {
        this.dl = data.dl;
      }

      this.client_codice_fiscale = data.client_codice_fiscale;
      this.client_partita_iva = data.client_partita_iva;

      var _vue = this;
      setTimeout(function () {
        this.usoAbitativo = parseInt(data.building_uso_abitativo);
        _vue.iva_altri_oneri = data.iva_altri_oneri;
        _vue.iva_accessori_lavoro = data.iva_accessori_lavoro;
        _vue.iva_age_extra = data.iva_age_extra;
        _vue.iva_age_lavoro = data.iva_age_lavoro;
        _vue.iva_age_accessori = data.iva_age_accessori;
      }, 2000);

      //if (data && data.client_type != 'Amministratore di condominio') {

      // BUILDING ADDRESS
      _vue.parse_province = _vue.item.building_province;
      _vue.parse_city = _vue.item.building_city;
      _vue.parse_zip = _vue.item.building_zip;
      _vue.parse_adress = _vue.item.building_address;
      _vue.parse_civic = _vue.item.building_civic;

      if (_vue.item.flow == "agileenergy" || _vue.item.flow == "mbfacta_recovery") {
        _vue.parse_client_province = _vue.item.client_province;
        _vue.parse_client_city = _vue.item.client_city;
        _vue.parse_client_zip = _vue.item.client_zip;
        _vue.parse_client_address = _vue.item.client_address;
        _vue.parse_client_civic = _vue.item.client_civic;
      }

      _vue.addressLoaded = true;

      if (data) {

        setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
          return regenerator_default.a.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.next = 2;
                  return _vue.getInvoiceProducts(data.id);

                case 2:

                  setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
                    return regenerator_default.a.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:

                            setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
                              return regenerator_default.a.wrap(function _callee13$(_context13) {
                                while (1) {
                                  switch (_context13.prev = _context13.next) {
                                    case 0:

                                      if (_vue.dl == 'new') {

                                        if (_vue.priceAT && _vue.priceAT != '0,00' && parseInt(data.total_work_and_iva) > 10000) {
                                          //console.log( parseInt( data.total_work_and_iva ) + '##############################################################################' )
                                          _vue.showEdilLiberaSelect = true;
                                          _vue.edilLibera = '2';
                                          _vue.dl = data.dl;
                                        } else {
                                          data.dl = '0';
                                        }
                                      }

                                    case 1:
                                    case 'end':
                                      return _context13.stop();
                                  }
                                }
                              }, _callee13, this);
                            })), 1500);

                          case 1:
                          case 'end':
                            return _context14.stop();
                        }
                      }
                    }, _callee14, this);
                  })), 1500);

                case 3:
                case 'end':
                  return _context15.stop();
              }
            }
          }, _callee15, this);
        })), 1500);
      }
    } else {
      this.$router.push('/offerte');
    }

    // ***********************************************************************************************

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    //this.populateProvincies()

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart() // Disable all dates after specific date
    };

    this.$scrollTo('#app', 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getNotifications', 'getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return '' + state.notifications;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d13b52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editCalc/index.vue
var editCalc_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-12 " }, [
            _vm.proccess == "START"
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _vm.flow != "mbfacta_recovery"
                    ? _c("b", [
                        _vm._v(
                          "Modifica Preventivo N. " + _vm._s(_vm.item.code)
                        )
                      ])
                    : _c("b", [
                        _vm._v("Modifica Pratica N. " + _vm._s(_vm.item.code))
                      ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c(
                  "p",
                  { staticClass: "black mt-0 text-left widthFull" },
                  [
                    _vm._v(
                      "\r\n          Segui il flusso sotto rappresentato completando le varie fasi richieste.\r\n          "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _vm.flow != "agileenergy" && _vm.flow != "mbfacta_recovery"
                      ? [
                          _vm._v(
                            "\r\n            Questa sezione ti consentira di modificare il Preventivo da stampare o inviare mezzo e-mail al tuo cliente per eventuale successiva accettazione.\r\n          "
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.flow == "agileenergy" ? [_vm._m(0)] : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          _vm.proccess == "START"
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
                  staticStyle: { "margin-top": "0!important" }
                },
                [
                  _c(
                    "form-wizard",
                    {
                      ref: "mainWizard",
                      staticClass: "mt-0 pb-2 formp ",
                      attrs: {
                        title: "",
                        subtitle: "",
                        nextButtonText: "Avanti >",
                        backButtonText: "< Indietro",
                        finishButtonText: "Salva preventivo",
                        stepSize: _vm.stepSize,
                        color: _vm.brand == "CHEBONUS" ? "#00917e" : "#cd0c2d",
                        errorColor: "#ff1100"
                      },
                      on: {
                        "on-change": _vm.stepIndex,
                        "on-complete": function($event) {
                          _vm.flow != "agileenergy"
                            ? _vm.onComplate()
                            : _vm.agilePricePopUp()
                        }
                      }
                    },
                    [
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Seleziona Cessionario Finale",
                            icon: "",
                            "before-change": _vm.validateZeroTab0
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull",
                              attrs: {
                                "data-vv-scope": "form-0v",
                                autocomplete: "qwerqrt23"
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row justify-content-center pb-4"
                                },
                                [
                                  _c("div", { staticClass: "col-md-12 " }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "pb-0 center section-heading"
                                      },
                                      [
                                        _vm._v(
                                          "Seleziona il Cessionario Finale "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "center black pb-2" },
                                      [
                                        _vm._v(
                                          "al quale si intende cedere il credito dopo che il Preventivo sarà accettato dal Cliente e convertito in Pratica pagata "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider "
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center text-left mb-4 widthFull flowBoxGrey"
                                    },
                                    [
                                      _c("Flows", {
                                        attrs: { hasSelectButtons: true },
                                        on: {
                                          clicked: _vm.setFlowFromComponent
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12 pt-4" }, [
                                    _c(
                                      "p",
                                      { staticClass: "center black pb-0" },
                                      [
                                        _vm._v(
                                          "Se hai bisogno di ulteriori informazioni, contattaci "
                                        ),
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "black underline",
                                            attrs: { to: "/contact" }
                                          },
                                          [_vm._v(" QUI ")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Seleziona Bonus",
                                icon: "",
                                "before-change": _vm.validateZeroTab
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-4"
                                    },
                                    [
                                      _c("div", { staticClass: "col-md-12 " }, [
                                        _c(
                                          "h2",
                                          {
                                            staticClass:
                                              "pb-3 center section-heading"
                                          },
                                          [
                                            _vm._v(
                                              "Seleziona il Bonus oggetto del Preventivo"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Bonus Casa 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Bonus Casa 50%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.brand == "CHEBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("6PKJ")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("DaEW")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.brand == "HAPPYBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("fjxO")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("DaEW")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Bonus Casa 50%"
                                                  }
                                                },
                                                [_vm._v(" Bonus Casa")]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6  col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Ecobonus 50%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.brand == "CHEBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Ecobonus 50%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("6PKJ")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("DaEW")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.brand == "HAPPYBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Ecobonus 50%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("fjxO")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("DaEW")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 50%"
                                                  }
                                                },
                                                [_vm._v(" Ecobonus")]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 65%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Ecobonus 65%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.brand == "CHEBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Ecobonus 65%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("w/IJ")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("CXbD")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.brand == "HAPPYBONUS"
                                                ? [
                                                    _vm.ecoBonus !=
                                                    "Ecobonus 65%"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("mLBv")
                                                          }
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "img-fluid widthFull mb-4",
                                                          attrs: {
                                                            src: __webpack_require__("CXbD")
                                                          }
                                                        })
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 65%"
                                                  }
                                                },
                                                [_vm._v(" Ecobonus")]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3",
                                          staticStyle: { display: "none" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.ecoBonus,
                                                    expression: "ecoBonus"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max: 63,
                                                      min: 2
                                                    },
                                                    expression:
                                                      "{required:true, max: 63, min: 2}"
                                                  }
                                                ],
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.ecoBonus"
                                                  ),
                                                  valid: !!_vm.ecoBonus
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ecobonus",
                                                  name: "ecobonus",
                                                  "data-vv-as": "ecoBonus"
                                                },
                                                domProps: {
                                                  value: _vm.ecoBonus
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.ecoBonus =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3 center"
                                        },
                                        [
                                          _vm.errors.has("form-0.ecobonus")
                                            ? _c(
                                                "div",
                                                { staticClass: "red" },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "h5 red" },
                                                    [
                                                      _vm._v(
                                                        "Per procedere devi selezionare una tra le quattro icone sopraindicate. "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.flow == "general"
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-12 center" },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "pb-3 center section-heading pb-1 mb-1"
                                                },
                                                [
                                                  _vm._v(
                                                    "Inserisci Valore Nominale di Cessione che verrà calcolato nel Preventivo "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  " Es. se dal Cessionario Finale viene trattenuto il 20% del valore di Cessione, inserire il Valore Nominale pari all'80 %   "
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.flow == "general"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 pb-4 center"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.fin_cost,
                                                    expression: "fin_cost"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max_value: 90,
                                                      min_value: 50
                                                    },
                                                    expression:
                                                      "{required:true, max_value: 90, min_value: 50}"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.fin_cost"
                                                  ),
                                                  valid: !!_vm.fin_cost
                                                },
                                                attrs: {
                                                  type: "number",
                                                  id: "fin_cost",
                                                  name: "fin_cost",
                                                  placeholder: "Es: 80",
                                                  "data-vv-as": "finCost"
                                                },
                                                domProps: {
                                                  value: _vm.fin_cost
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.fin_cost =
                                                      $event.target.value
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "inputLabel" },
                                                [_vm._v(" % ")]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.flow == "general"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 mb-3 center"
                                            },
                                            [
                                              _vm.errors.has("form-0.fin_cost")
                                                ? _c(
                                                    "div",
                                                    { staticClass: "red" },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "h5 red mt-3 pt-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Per procedere devi inserire Valore Nominale di Cessione. "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            " ( range valori dal 50% al 90% )"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Inserisci Dati Cliente",
                                icon: "",
                                "before-change": _vm.validateFirstTab
                              }
                            },
                            [
                              _vm.ecoBonus != "Superbonus 110%"
                                ? _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row justify-content-center"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                    Inserisci i dati del cliente finale\r\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-3 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.client_type,
                                                          expression:
                                                            "client_type"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 63,
                                                            min: 2
                                                          },
                                                          expression:
                                                            "{required:true, max: 63, min: 2}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.client_type"
                                                        ),
                                                        valid: !!_vm.client_type
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        autocomplete: "randomq",
                                                        id: "client_type",
                                                        name: "client_type",
                                                        "data-vv-as":
                                                          "Tipologia cliente"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.client_type = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Persona fisica"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Persona fisica"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.ecoBonus !=
                                                      "Bonus Casa 50%"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  "Partita IVA"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Partita IVA"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Amministratore di condominio"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Condominio (Amministratore)"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_type"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Tipologia cliente"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_type"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_type"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.client_owner_type,
                                                          expression:
                                                            "client_owner_type"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 123,
                                                            min: 2
                                                          },
                                                          expression:
                                                            "{required:true, max: 123, min: 2}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.client_owner_type"
                                                        ),
                                                        valid: !!_vm.client_owner_type
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        autocomplete: "randomq",
                                                        id: "client_owner_type",
                                                        name:
                                                          "client_owner_type",
                                                        "data-vv-as":
                                                          "Titolo di possesso"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.client_owner_type = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Proprietario o comproprietario"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Proprietario o comproprietario"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Detentore o co-detentore"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Detentore o co-detentore (es. locatario, comodatario, usufruttuario, ecc.)"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "Familiare convivente"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Familiare convivente con il possessore o con il detentore"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Amministratore di condominio"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  "Condominio"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Condominio"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_owner_type"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Titolo di possesso / diritto reale"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_owner_type"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_owner_type"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.client_owner_type !=
                                            "Proprietario o comproprietario" &&
                                          _vm.client_owner_type != ""
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-5 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.client_owner_codice_fiscale,
                                                            expression:
                                                              "client_owner_codice_fiscale"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: false,
                                                              partitaIva:
                                                                _vm
                                                                  .client_owner_codice_fiscale
                                                                  .length == 11
                                                                  ? true
                                                                  : false,
                                                              codiceFiscale:
                                                                _vm
                                                                  .client_owner_codice_fiscale
                                                                  .length == 16
                                                                  ? true
                                                                  : false,
                                                              max:
                                                                _vm
                                                                  .client_owner_codice_fiscale
                                                                  .length < 11
                                                                  ? 16
                                                                  : 16,
                                                              min:
                                                                _vm
                                                                  .client_owner_codice_fiscale
                                                                  .length > 11
                                                                  ? 16
                                                                  : 11
                                                            },
                                                            expression:
                                                              "{required:false, partitaIva: client_owner_codice_fiscale.length == 11 ? true : false, codiceFiscale: client_owner_codice_fiscale.length == 16 ? true : false, max: client_owner_codice_fiscale.length < 11 ? 16 : 16, min: client_owner_codice_fiscale.length > 11 ? 16 : 11}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-1.client_owner_codice_fiscale"
                                                          ),
                                                          valid: !!_vm.client_owner_codice_fiscale
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          autocomplete:
                                                            "randomq",
                                                          "data-vv-validate-on":
                                                            "blur",
                                                          id:
                                                            "client_owner_codice_fiscale",
                                                          name:
                                                            "client_owner_codice_fiscale",
                                                          "data-vv-as":
                                                            "P.IVA o codice fiscale del proprietario"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.client_owner_codice_fiscale
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.client_owner_codice_fiscale =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for:
                                                              "client_owner_codice_fiscale"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " P.Iva o Codice Fiscale "
                                                          ),
                                                          _c("small", [
                                                            _vm._v(
                                                              " del proprietario dell'immobile "
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "se non disponibile, potrai inserirlo in fase di conferma del preventivo"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-1.client_owner_codice_fiscale"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                      " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-1.client_owner_codice_fiscale"
                                                                    )
                                                                  ) +
                                                                  "\r\n                    "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.client_type ==
                                                    "Partita IVA",
                                                  expression:
                                                    "client_type == 'Partita IVA'"
                                                }
                                              ],
                                              staticClass: "col-md-8 mb-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.client_ragione_sociale,
                                                        expression:
                                                          "client_ragione_sociale"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required:
                                                            _vm.client_type ==
                                                            "Partita IVA"
                                                              ? true
                                                              : false,
                                                          max: 128,
                                                          min: 5
                                                        },
                                                        expression:
                                                          "{required: ( client_type == 'Partita IVA' ) ? true : false, max: 128, min: 5}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_ragione_sociale"
                                                      ),
                                                      valid: !!_vm.client_ragione_sociale
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id:
                                                        "client_ragione_sociale",
                                                      name:
                                                        "client_ragione_sociale",
                                                      "data-vv-as":
                                                        "Ragione Sociale"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.client_ragione_sociale
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_ragione_sociale =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "client_ragione_sociale"
                                                      }
                                                    },
                                                    [_vm._v("Ragione Sociale")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_ragione_sociale"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_ragione_sociale"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row " },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.clientLastname,
                                                        expression:
                                                          "clientLastname"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.clientLastname"
                                                      ),
                                                      valid: !!_vm.clientLastname
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "clientLastname",
                                                      name: "clientLastname",
                                                      "data-vv-as": "Cognome"
                                                    },
                                                    domProps: {
                                                      value: _vm.clientLastname
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.clientLastname =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "clientLastname"
                                                      }
                                                    },
                                                    [_vm._v("Cognome")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.clientLastname"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.clientLastname"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.clientName,
                                                        expression: "clientName"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.clientName"
                                                      ),
                                                      valid: !!_vm.clientName
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "clientName",
                                                      name: "clientName",
                                                      "data-vv-as": "Nome"
                                                    },
                                                    domProps: {
                                                      value: _vm.clientName
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.clientName =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "clientName"
                                                      }
                                                    },
                                                    [_vm._v("Nome")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.clientName"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.clientName"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3 " },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_email,
                                                        expression:
                                                          "client_email"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          email: true,
                                                          temporaryEmail: true,
                                                          plusIssueEmail: true,
                                                          max: 56
                                                        },
                                                        expression:
                                                          "{required:true, email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                                      }
                                                    ],
                                                    ref: "client_email",
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_email"
                                                      ),
                                                      valid: !!_vm.client_email
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "client_email",
                                                      name: "client_email",
                                                      "data-vv-as": "Email"
                                                    },
                                                    domProps: {
                                                      value: _vm.client_email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_email =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_email"
                                                      }
                                                    },
                                                    [_vm._v("Email* ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_email"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_email"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_phone,
                                                        expression:
                                                          "client_phone"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: _vm.client_mobile
                                                            ? false
                                                            : true,
                                                          max: 12,
                                                          min: 8,
                                                          regex: /^[0]+/
                                                        },
                                                        expression:
                                                          "{required: client_mobile ? false : true, max: 12, min: 8, regex: /^[0]+/}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_phone"
                                                      ),
                                                      valid: !!_vm.client_phone
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "client_phone",
                                                      name: "client_phone",
                                                      "data-vv-as": "Telefono"
                                                    },
                                                    domProps: {
                                                      value: _vm.client_phone
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_phone =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_phone"
                                                      }
                                                    },
                                                    [_vm._v("Telefono ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_phone"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_phone"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.client_mobile,
                                                        expression:
                                                          "client_mobile"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: _vm.client_phone
                                                            ? false
                                                            : true,
                                                          max: 12,
                                                          min: 8,
                                                          regex: /^[3]+/
                                                        },
                                                        expression:
                                                          "{required: client_phone ? false : true, max: 12, min: 8, regex: /^[3]+/}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_mobile"
                                                      ),
                                                      valid: !!_vm.client_mobile
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "client_mobile",
                                                      name: "client_mobile",
                                                      "data-vv-as": "Cellulare"
                                                    },
                                                    domProps: {
                                                      value: _vm.client_mobile
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_mobile =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "client_mobile"
                                                      }
                                                    },
                                                    [_vm._v("Cellulare ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_mobile"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_mobile"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.client_type ==
                                                      "Persona fisica" ||
                                                    _vm.client_type ==
                                                      "Amministratore di condominio",
                                                  expression:
                                                    "client_type == 'Persona fisica' || client_type == 'Amministratore di condominio'"
                                                }
                                              ],
                                              staticClass: "col-md-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.client_codice_fiscale,
                                                        expression:
                                                          "client_codice_fiscale"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required:
                                                            _vm.client_type ==
                                                              "Persona fisica" ||
                                                            _vm.client_type ==
                                                              "Amministratore di condominio"
                                                              ? true
                                                              : false,
                                                          codiceFiscale: true,
                                                          max: 16,
                                                          min: 16
                                                        },
                                                        expression:
                                                          "{required: ( client_type == 'Persona fisica' || client_type == 'Amministratore di condominio' ) ? true : false, codiceFiscale: true,  max: 16, min: 16}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_codice_fiscale"
                                                      ),
                                                      valid: !!_vm.client_codice_fiscale
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id:
                                                        "client_codice_fiscale",
                                                      name:
                                                        "client_codice_fiscale",
                                                      "data-vv-as":
                                                        "Codice Fiscale"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.client_codice_fiscale
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_codice_fiscale =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "client_codice_fiscale"
                                                      }
                                                    },
                                                    [_vm._v("Codice Fiscale *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_codice_fiscale"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_codice_fiscale"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.client_type ==
                                                    "Partita IVA",
                                                  expression:
                                                    "client_type == 'Partita IVA'"
                                                }
                                              ],
                                              staticClass: "col-md-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "group custInput",
                                                  class: {
                                                    inputHSD:
                                                      _vm.brand == "HAPPYBONUS"
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.client_partita_iva,
                                                        expression:
                                                          "client_partita_iva"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required:
                                                            _vm.client_type ==
                                                            "Partita IVA"
                                                              ? true
                                                              : false,
                                                          partitaIva: true,
                                                          max: 11,
                                                          min: 11
                                                        },
                                                        expression:
                                                          "{required: ( client_type == 'Partita IVA' ) ? true : false, partitaIva: true, max: 11, min: 11}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_partita_iva"
                                                      ),
                                                      valid: !!_vm.client_partita_iva
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "client_partita_iva",
                                                      name:
                                                        "client_partita_iva",
                                                      "data-vv-as":
                                                        "Partita IVA"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.client_partita_iva
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.client_partita_iva =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "client_partita_iva"
                                                      }
                                                    },
                                                    [_vm._v("Partita IVA *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-1.client_partita_iva"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-1.client_partita_iva"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.flow == "agileenergy" ||
                                          _vm.flow == "mbfacta_recovery"
                                            ? _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _vm.client_type !=
                                                  "Partita IVA"
                                                    ? _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "widthFull center black pb-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                   Indirizzo di residenza del cliente finale\r\n                 "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "widthFull center black pb-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                   Indirizzo Sede Legale\r\n                 "
                                                          )
                                                        ]
                                                      )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (_vm.flow == "agileenergy" ||
                                            _vm.flow == "mbfacta_recovery") &&
                                          _vm.addressLoaded
                                            ? _c("Address", {
                                                attrs: {
                                                  keyAssigned: "1",
                                                  parseAdress:
                                                    _vm.parse_client_address,
                                                  parseCivic:
                                                    _vm.parse_client_civic,
                                                  parseProvince:
                                                    _vm.parse_client_province,
                                                  parseCity:
                                                    _vm.parse_client_city,
                                                  parseZip: _vm.parse_client_zip
                                                },
                                                on: {
                                                  setProvince:
                                                    _vm.setProvinceResidence,
                                                  setCity: _vm.setCityResidence,
                                                  setZip: _vm.setZipResidence,
                                                  setAddress:
                                                    _vm.setAddressResidence,
                                                  setCivic:
                                                    _vm.setCivicResidence
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.ecoBonus != "Bonus Casa 50%"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-12 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-check"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-check-label widthFull black h5",
                                                              attrs: {
                                                                for:
                                                                  "usoAbitativo"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                        L'immobile oggetto dell'intervento è a prevalente uso abitativo?\r\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-check form-check-inline mt-2"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo = 1
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.usoAbitativo,
                                                                        expression:
                                                                          "usoAbitativo"
                                                                      },
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          "required|included:1,0",
                                                                        expression:
                                                                          "'required|included:1,0'"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-check-input inline mr-3",
                                                                    class: {
                                                                      "is-invalid": _vm.errors.has(
                                                                        "form-1.usoAbitativo"
                                                                      )
                                                                    },
                                                                    attrs: {
                                                                      type:
                                                                        "radio",
                                                                      value:
                                                                        "1",
                                                                      name:
                                                                        "usoAbitativo"
                                                                    },
                                                                    domProps: {
                                                                      checked: _vm._q(
                                                                        _vm.usoAbitativo,
                                                                        "1"
                                                                      )
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.usoAbitativo =
                                                                          "1"
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c("b", [
                                                                    _vm._v("SI")
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-check form-check-inline"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo = 0
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.usoAbitativo,
                                                                        expression:
                                                                          "usoAbitativo"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-check-input inline mr-3",
                                                                    class: {
                                                                      "is-invalid": _vm.errors.has(
                                                                        "form-1.usoAbitativo"
                                                                      )
                                                                    },
                                                                    attrs: {
                                                                      type:
                                                                        "radio",
                                                                      value:
                                                                        "0",
                                                                      name:
                                                                        "usoAbitativo"
                                                                    },
                                                                    domProps: {
                                                                      checked: _vm._q(
                                                                        _vm.usoAbitativo,
                                                                        "0"
                                                                      )
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.usoAbitativo =
                                                                          "0"
                                                                      }
                                                                    }
                                                                  }),
                                                                  _c("b", [
                                                                    _vm._v("NO")
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "form-1.usoAbitativo"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('form-1.usoAbitativo')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "errorMes red"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                        Il servizio deve essere accettato oppure rifiutato\r\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "row justify-content-center divider"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black pb-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                    Inserisci l'indirizzo dell'immobile oggetto dell'intervento\r\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.addressLoaded
                                            ? _c("Address", {
                                                attrs: {
                                                  keyAssigned: "2",
                                                  parseAdress: _vm.parse_adress,
                                                  parseCivic: _vm.parse_civic,
                                                  parseProvince:
                                                    _vm.parse_province,
                                                  parseCity: _vm.parse_city,
                                                  parseZip: _vm.parse_zip
                                                },
                                                on: {
                                                  setProvince:
                                                    _vm.setProvinceBuilding,
                                                  setCity: _vm.setCityBuilding,
                                                  setZip: _vm.setZipBuilding,
                                                  setAddress:
                                                    _vm.setAddressBuilding,
                                                  setCivic: _vm.setCivicBuilding
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "row justify-content-center divider"
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row " }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    LISTA DOCUMENTI\r\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title:
                              _vm.flow == "mbfacta_recovery"
                                ? "Inserisci Valori"
                                : "Compila il Preventivo",
                            icon: "",
                            "before-change": _vm.validateSecondTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull orangeBg",
                              attrs: {
                                "data-vv-scope": "form-2",
                                autocomplete: "qwerqrt3"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _vm.bonusError
                                    ? _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.bonusError
                                    ? _c("div", { staticClass: "col-md-12" }, [
                                        _c("h4", {
                                          staticClass: "widthFull center red",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.bonusErrorText
                                            )
                                          }
                                        })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showEdilLiberaSelect &&
                                  _vm.flow != "agileenergy"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 center pb-5"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                    L'intervento è di edilizia libera* ?\r\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v("* Vedi  "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "green underline",
                                                attrs: {
                                                  href:
                                                    "https://storage.googleapis.com/chebonus/glossario_edilizia_libera.pdf",
                                                  target: "_blank"
                                                }
                                              },
                                              [_c("b", [_vm._v(" glossario ")])]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "btn btn-secondary pl-5 pr-5",
                                              class: {
                                                "btn-primary":
                                                  _vm.edilLibera == "1"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setEdiliziaLibera(
                                                    "yes"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" Si ")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "btn btn-secondary pl-5 pr-5",
                                              class: {
                                                "btn-primary":
                                                  _vm.edilLibera == "2"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setEdiliziaLibera(
                                                    "no"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" No ")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showEdilLiberaSelect &&
                                  _vm.flow == "agileenergy"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 center pb-5"
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black red"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                    Agile Energy accetta solo interventi di edilizia libera con Totale Quota Spesa Agevolabile ≤ € 15.000 IVA incl. e interventi di non edilizia libera con Totale Quota Spesa Agevolabile ≤ € 10.000 IVA incl.\r\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                    L'intervento è di edilizia libera* ?\r\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v("* Vedi  "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "green underline",
                                                attrs: {
                                                  href:
                                                    "https://storage.googleapis.com/chebonus/glossario_edilizia_libera.pdf",
                                                  target: "_blank"
                                                }
                                              },
                                              [_c("b", [_vm._v(" glossario ")])]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "btn btn-secondary pl-5 pr-5",
                                              class: {
                                                "btn-primary":
                                                  _vm.edilLibera == "1"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setEdiliziaLibera(
                                                    "yes"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" Si ")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\r\n                    Inserisci la Tipologia di intervento\r\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "group custInput",
                                        class: {
                                          inputHSD: _vm.brand == "HAPPYBONUS"
                                        }
                                      },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.eventType,
                                                expression: "eventType"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{required:true, max: 63, min: 2}"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-2.eventType"
                                              ),
                                              valid: !!_vm.eventType
                                            },
                                            attrs: {
                                              type: "text",
                                              autocomplete: "randomq",
                                              id: "eventType",
                                              name: "eventType",
                                              "data-vv-as": "Tipo di intervento"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.eventType = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                value: "",
                                                disabled: "",
                                                selected: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "sostituzione" }
                                              },
                                              [_vm._v("Sostituzione")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "Instalazione" }
                                              },
                                              [_vm._v("Nuova Installazione")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "eventType" }
                                          },
                                          [_vm._v("Tipologia di intervento")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-2.eventType")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                      " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-2.eventType"
                                                      )
                                                    ) +
                                                    "\r\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\r\n                    Inserisci i Beni Significativi ( prodotti, sistemi )\r\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "widthFull" },
                                        _vm._l(_vm.products, function(
                                          elem,
                                          num
                                        ) {
                                          return _c(
                                            "div",
                                            { staticClass: "row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: elem.group,
                                                              expression:
                                                                "elem.group"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required: true,
                                                                is_not: ""
                                                              },
                                                              expression:
                                                                "{required:true, is_not:''}"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.g" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem.group
                                                          },
                                                          attrs: {
                                                            id:
                                                              "g" + elem.index,
                                                            name:
                                                              "g" + elem.index,
                                                            "data-vv-as":
                                                              "Gruppo"
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  elem,
                                                                  "group",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.setGroup(
                                                                  elem.index
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        },
                                                        [
                                                          _vm.ecoBonus ==
                                                          "Ecobonus 50%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      item.value ==
                                                                      "condensazione"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : _vm.ecoBonus ==
                                                              "Ecobonus 65%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      item.value !=
                                                                      "tradizionale"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "option",
                                                                        {
                                                                          attrs: {
                                                                            selected:
                                                                              "selected"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              item.value
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.name
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "group"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli gruppo prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.g" + elem.index
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.g" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "widthFull  black pointer m-0",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.insertProductCode(
                                                                elem.index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "search",
                                                                size: "sm"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.insertProductCode(
                                                                    elem.index
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c("small", [
                                                            _vm._v(
                                                              "o cerca con codice prodotto "
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-5" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      elem.group != "ibridi" &&
                                                      elem.group !=
                                                        "altroVaillant" &&
                                                      _vm.flow !=
                                                        "mbfacta_recovery"
                                                        ? _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{required:true, is_not:''}"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.Modello
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : elem.group ==
                                                            "altroVaillant" ||
                                                          _vm.flow ==
                                                            "mbfacta_recovery"
                                                        ? _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product
                                                                    .name,
                                                                expression:
                                                                  "elem.product.name"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required: true,
                                                                  is_not: ""
                                                                },
                                                                expression:
                                                                  "{required:true, is_not:''}"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.p" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id:
                                                                "p" +
                                                                elem.index,
                                                              name:
                                                                "p" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Prodotto"
                                                            },
                                                            domProps: {
                                                              value:
                                                                elem.product
                                                                  .name
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.setProduct(
                                                                  elem.index
                                                                )
                                                              },
                                                              click:
                                                                _vm.checkIfEmpty,
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  elem.product,
                                                                  "name",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{required:true, is_not:''}"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      selected:
                                                                        item.Modello ==
                                                                        elem
                                                                          .product
                                                                          .name,
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\r\n                              " +
                                                                        _vm._s(
                                                                          item.Modello
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          item.ModelloPompaDiCalore
                                                                        ) +
                                                                        " + " +
                                                                        _vm._s(
                                                                          item.ModelloCaldaiaACondensazione
                                                                        ) +
                                                                        "\r\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "product"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli Prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.p" + elem.index
                                                      ) && !elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.p" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            Prima scegli gruppo\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mr-md-0 pr-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              elem.quantity,
                                                            expression:
                                                              "elem.quantity"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0",
                                                              min_value: 1,
                                                              max: 4
                                                            },
                                                            expression:
                                                              "{required:true, is_not:'0', min_value: 1, max:4}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.q" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.quantity
                                                        },
                                                        attrs: {
                                                          type: "number",
                                                          id:
                                                            "q" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "q" +
                                                            elem.indexCount,
                                                          "data-vv-as":
                                                            "Quantità"
                                                        },
                                                        domProps: {
                                                          value: elem.quantity
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.calcTotalPriceProducts()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "quantity",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Quantità")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.q" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.q" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 pl-md-0 ml-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.price,
                                                            expression:
                                                              "elem.price"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0"
                                                            },
                                                            expression:
                                                              "{required:true, is_not:'0', }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.i" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.price
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          id:
                                                            "i" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "i" +
                                                            elem.indexCount,
                                                          "data-vv-as":
                                                            "Importo"
                                                        },
                                                        domProps: {
                                                          value: elem.price
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.formatPrice(
                                                              elem.index
                                                            ),
                                                              _vm.calcTotalPriceProducts()
                                                          },
                                                          keyup: function(
                                                            $event
                                                          ) {
                                                            return _vm.keymonitor(
                                                              $event,
                                                              elem.index,
                                                              "prod"
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "price",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Importo €")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "widthFull center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                            (IVA esclusa)\r\n                          "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.i" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.i" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\r\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "removeProduct pointer",
                                                      class: elem.index
                                                    },
                                                    [
                                                      num != 0
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "trash-alt",
                                                                size: "lg"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeProduct(
                                                                    num
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: { click: _vm.addProduct }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: { click: _vm.addProduct }
                                                }),
                                                _vm._v(
                                                  " Aggiungi Beni Significativi\r\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      Totale importo Beni Significativi (IVA esclusa): "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "€ " +
                                                    _vm._s(_vm.totalProducts) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                        Inserisci altri Beni e/o Accessori opzionali\r\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.accessories, function(
                                        elem,
                                        num
                                      ) {
                                        return _c(
                                          "div",
                                          { staticClass: "row accRow" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-5" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.group,
                                                            expression:
                                                              "elem.group"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {},
                                                            expression: "{}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.ac" +
                                                              elem.index
                                                          ),
                                                          valid: !!elem.group
                                                        },
                                                        attrs: {
                                                          id: "ac" + elem.index,
                                                          name:
                                                            "ac" + elem.index,
                                                          "data-vv-as":
                                                            "accessori opzionali"
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                elem,
                                                                "group",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function($event) {
                                                              return _vm.setTypeAccessories(
                                                                elem.index
                                                              )
                                                            }
                                                          ]
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.groupsAccessori,
                                                        function(item) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                selected:
                                                                  "selected"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.value
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: { for: "group" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Scegli accessori opzionali"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ac" + elem.index
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ac" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "widthFull  black pointer m-0",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.insertAccessoriesCode(
                                                              elem.index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "search",
                                                              size: "sm"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.insertAccessoriesCode(
                                                                  elem.index
                                                                )
                                                              }
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("small", [
                                                          _vm._v(
                                                            "o cerca con codice accessorio "
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-7" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    elem.group ==
                                                      "termoregolazione" &&
                                                    _vm.flow !=
                                                      "mbfacta_recovery"
                                                      ? _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product,
                                                                expression:
                                                                  "elem.product"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required:
                                                                    elem.group !=
                                                                    ""
                                                                },
                                                                expression:
                                                                  "{required: elem.group != ''}"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.ap" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              id:
                                                                "ap" +
                                                                elem.index,
                                                              name:
                                                                "ap" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Accessorio"
                                                            },
                                                            on: {
                                                              change: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    elem,
                                                                    "product",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                },
                                                                function(
                                                                  $event
                                                                ) {
                                                                  return _vm.setAccessories(
                                                                    elem.index
                                                                  )
                                                                }
                                                              ],
                                                              click:
                                                                _vm.checkIfEmpty
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm
                                                              .itemsAccessories[
                                                              elem.index
                                                            ],
                                                            function(
                                                              item,
                                                              ind
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "selected"
                                                                  },
                                                                  domProps: {
                                                                    value: {
                                                                      index: ind,
                                                                      name:
                                                                        item.Modello,
                                                                      serial:
                                                                        item.codice
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.Modello
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                elem.product
                                                                  .name,
                                                              expression:
                                                                "elem.product.name"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required:
                                                                  elem.group !=
                                                                  "",
                                                                max: 128
                                                              },
                                                              expression:
                                                                "{required: elem.group != '' , max: 128}"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.ap" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem
                                                              .product.name
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                            id:
                                                              "ap" + elem.index,
                                                            name:
                                                              "ap" + elem.index,
                                                            "data-vv-as":
                                                              "Accessorio"
                                                          },
                                                          domProps: {
                                                            value:
                                                              elem.product.name
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                elem.product,
                                                                "name",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    elem.group ==
                                                    "termoregolazione"
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Scegli Accessorio"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Inserisci Accessorio"
                                                            )
                                                          ]
                                                        ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ap" + elem.index
                                                    ) && !elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ap" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          Prima scegli tipo\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-6" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              elem.destination,
                                                            expression:
                                                              "elem.destination"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required:
                                                                elem.group != ""
                                                            },
                                                            expression:
                                                              "{required: elem.group != ''}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.act" +
                                                              elem.index
                                                          ),
                                                          valid: !!elem.destination
                                                        },
                                                        attrs: {
                                                          id:
                                                            "act" + elem.index,
                                                          name:
                                                            "act" + elem.index,
                                                          "data-vv-as":
                                                            "destinazione dell'accessorio"
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                elem,
                                                                "destination",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function($event) {
                                                              return _vm.setDestinationAccessories(
                                                                elem.index
                                                              )
                                                            }
                                                          ]
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.groupsAccessoriDestination,
                                                        function(item) {
                                                          return _vm.groupsAccessoriDestination
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "selected"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      item.value
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: "destination"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Seleziona destinazione dell'accessorio per calcolo massimale MITE"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("small"),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.act" + elem.index
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.act" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-3 mr-md-0 pr-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.quantity,
                                                          expression:
                                                            "elem.quantity"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0",
                                                            min_value: 1,
                                                            max: 4
                                                          },
                                                          expression:
                                                            "{required: elem.group != '', is_not:'0', min_value: 1, max:4}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.aq" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.quantity
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        id:
                                                          "aq" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "aq" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Quantità"
                                                      },
                                                      domProps: {
                                                        value: elem.quantity
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.calcTotalPriceAccessories()
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "quantity",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Quantità")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.aq" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.aq" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-3 pl-md-0 ml-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput",
                                                    class: {
                                                      inputHSD:
                                                        _vm.brand ==
                                                        "HAPPYBONUS"
                                                    }
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.price,
                                                          expression:
                                                            "elem.price"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0"
                                                          },
                                                          expression:
                                                            "{required: elem.group != '', is_not:'0', }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.ai" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.price
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id:
                                                          "ai" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "ai" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Importo"
                                                      },
                                                      domProps: {
                                                        value: elem.price
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.formatPriceAccessories(
                                                            elem.index
                                                          )
                                                          _vm.calcTotalPriceAccessories()
                                                        },
                                                        keyup: function(
                                                          $event
                                                        ) {
                                                          return _vm.keymonitor(
                                                            $event,
                                                            elem.index,
                                                            "accs"
                                                          )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "price",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Importo €")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "widthFull center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                          (IVA esclusa)\r\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ai" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ai" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "removeProduct pointer",
                                                    class: elem.index
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "trash-alt",
                                                        size: "lg"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeAccessories(
                                                            num
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: {
                                                  click: _vm.addAccessories
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: {
                                                    click: _vm.addAccessories
                                                  }
                                                }),
                                                _vm._v(
                                                  " Aggiungi altri Beni e/o Accessori opzionali\r\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      Totale importo accessori opzionali (IVA esclusa): "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalAccessories) +
                                                    " €"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                        Installazione/posa in opera\r\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput",
                                                class: {
                                                  inputHSD:
                                                    _vm.brand == "HAPPYBONUS"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.priceWork,
                                                      expression: "priceWork"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{required:true, max: 63, min: 2}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.priceWork"
                                                    ),
                                                    valid: !!_vm.priceWork
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "priceWork",
                                                    name: "priceWork",
                                                    "data-vv-as":
                                                      "Importo installazione/posa in opera"
                                                  },
                                                  domProps: {
                                                    value: _vm.priceWork
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.formatpriceWork()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.priceWork =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "priceWork" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera ( IVA esclusa )"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.priceWork"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.priceWork"
                                                              )
                                                            ) +
                                                            "\r\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      Totale installazione/posa in opera ( importo € IVA esclusa ): "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "€ " +
                                                    _vm._s(_vm.priceWork) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.dl == "new" || _vm.priceAT != "0,00"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                                          Inserisci l'eventuale importo dell'asseverazione della congruità delle spese rilasciata da un tuo tecnico abilitato "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        " se il totale importo spesa agevolabile > " +
                                                          _vm._s(_vm.tqsa) +
                                                          " IVA incl.\r\n                                        "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                                          Il documento di asseverazione della congruità delle spese dovrà essere richiesto\r\n                                          direttamente da parte dall’aderente " +
                                                          _vm._s(_vm.brand) +
                                                          " ad un professionista tecnico\r\n                                          abilitato, dopodiché caricato dall’aderente " +
                                                          _vm._s(_vm.brand) +
                                                          " nel set documentale della\r\n                                          Pratica " +
                                                          _vm._s(_vm.brand) +
                                                          "\r\n\r\n                                        "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-6 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.priceAT,
                                                            expression:
                                                              "priceAT"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              max: 63,
                                                              min: 2
                                                            },
                                                            expression:
                                                              "{required:true, max: 63, min: 2}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.priceAT"
                                                          ),
                                                          valid: !!_vm.priceAT
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          autocomplete:
                                                            "randomq",
                                                          id: "priceAT",
                                                          name: "priceAT",
                                                          "data-vv-as":
                                                            "Costo dell'asseverazione della congruità delle spese"
                                                        },
                                                        domProps: {
                                                          value: _vm.priceAT
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.formatpriceAT()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.priceAT =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "priceAT"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Costo dell'asseverazione della congruità delle spese"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "Valore visualizzato nel Preventivo ( importo € IVA esclusa )"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.priceAT"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.priceAT"
                                                                    )
                                                                  ) +
                                                                  "\r\n                                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "col-md-6 mb-3"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.flow != "agileenergy"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Inserisci l'eventuale importo della Visura Catastale dell'immobile oggetto dell'intervento\r\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.flow != "mbfacta_recovery"
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-left"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                        - Se il cliente dispone di una Visura Catastale aggiornata dell'immobile oggetto dell'intervento, inserisci € 0 nel campo \"Costo recupero dei dati catastali dell'immobile\"\r\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "- Se desideri procurare autonomamente la Visura Catastale dell'immobile oggetto dell'intervento per il tuo cliente, inserisci l'importo che vuoi addebitargli nel campo \"Costo recupero dei dati catastali dell'immobile\"\r\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "- Se desideri usufruire del nostro servizio opzionale a pagamento per il recupero della Visura Catastale dell'immobile oggetto dell'intervento, seleziona \"ACCETTO\" nella sezione sotto riportata e inserisci l'importo che\r\n                        vuoi addebitargli nel campo \"Costo recupero dei dati catastali dell'immobile\"\r\n\r\n\r\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-6 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.priceDcast,
                                                            expression:
                                                              "priceDcast"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              max: 63,
                                                              min: 2
                                                            },
                                                            expression:
                                                              "{required:true, max: 63, min: 2}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.priceDcast"
                                                          ),
                                                          valid: !!_vm.priceDcast
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          autocomplete:
                                                            "randomq",
                                                          id: "priceDcast",
                                                          name: "priceDcast",
                                                          "data-vv-as":
                                                            "Costo recupero dei dati catastali dell'immobile"
                                                        },
                                                        domProps: {
                                                          value: _vm.priceDcast
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.formatpriceDcast()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.priceDcast =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "priceDcast"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Costo recupero dei dati catastali dell'immobile"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "Valore visualizzato nel Preventivo ( importo € IVA esclusa )"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.priceDcast"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                          " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.priceDcast"
                                                                    )
                                                                  ) +
                                                                  "\r\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.flow != "mbfacta_recovery"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-6 mb-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label widthFull black h5",
                                                                  attrs: {
                                                                    for:
                                                                      "datiCatastali"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\r\n                            Servizio opzionale a pagamento di recupero "
                                                                  ),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      '"Visura Catastale"'
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " dell'immobile oggetto dell'intervento al costo di €10 +IVA\r\n                            "
                                                                  ),
                                                                  _c("small", [
                                                                    _c("br"),
                                                                    _vm._v(
                                                                      "( importo che ti sarà addebitato in fase di pagamento Pratica se accetti il servizio )"
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-check form-check-inline mt-2"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.datiCatastali = 1
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.datiCatastali,
                                                                              expression:
                                                                                "datiCatastali"
                                                                            },
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                "required|included:1,0",
                                                                              expression:
                                                                                "'required|included:1,0'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-check-input inline mr-3",
                                                                          class: {
                                                                            "is-invalid": _vm.errors.has(
                                                                              "form-1.datiCatastali"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "radio",
                                                                            value:
                                                                              "1",
                                                                            name:
                                                                              "datiCatastali"
                                                                          },
                                                                          domProps: {
                                                                            checked: _vm._q(
                                                                              _vm.datiCatastali,
                                                                              "1"
                                                                            )
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.datiCatastali =
                                                                                "1"
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "ACCETTO"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-check form-check-inline"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.datiCatastali = 0
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.datiCatastali,
                                                                              expression:
                                                                                "datiCatastali"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-check-input inline mr-3",
                                                                          class: {
                                                                            "is-invalid": _vm.errors.has(
                                                                              "form-1.datiCatastali"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "radio",
                                                                            value:
                                                                              "0",
                                                                            name:
                                                                              "datiCatastali"
                                                                          },
                                                                          domProps: {
                                                                            checked: _vm._q(
                                                                              _vm.datiCatastali,
                                                                              "0"
                                                                            )
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.datiCatastali =
                                                                                "0"
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "NON ACCETTO"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "form-1.datiCatastali"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('form-1.datiCatastali')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "errorMes red"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\r\n                            Il servizio deve essere accettato oppure rifiutato\r\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      !_vm.NoEnea && _vm.flow != "agileenergy"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pt-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Inserisci l'eventuale importo della Pratica ENEA dell'intervento\r\n\r\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "center widthFull Bold"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          'Attenzione! Questa sezione "Pratica ENEA" è relativa solo ad impianti con potenza nominale ≤ 100 kW. '
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(
                                                        "Per impianti con potenza nominale > 100 kW consulta il tuo progettista/tecnico abilitato\r\n\r\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.flow != "mbfacta_recovery"
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-left widthFull "
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                        - Se il cliente ti fornisce la Pratica ENEA con il codice CPID e la ricevuta dell'avvenuta trasmissione all'ENEA inserisci € 0 nel campo \"Costo Gestione Pratica ENEA\"\r\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "- Se desideri produrre autonomamente la Pratica ENEA con il codice CPID e la ricevuta dell'avvenuta trasmissione all'ENEA inserisci l'importo che vuoi addebitargli nel campo \"Costo Gestione Pratica ENEA\"\r\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "- Se desideri usufruire del nostro servizio opzionale a pagamento per il redazione e invio della "
                                                          ),
                                                          _c("b", [
                                                            _vm._v(
                                                              '"Pratica ENEA"'
                                                            )
                                                          ]),
                                                          _vm._v(
                                                            ' dell\'intervento seleziona "ACCETTO" nella sezione sotto riportata e inserisci l\'importo che vuoi\r\n                        addebitargli nel campo "Costo Gestione Pratica ENEA"\r\n                      '
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "col-md-6 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput",
                                                      class: {
                                                        inputHSD:
                                                          _vm.brand ==
                                                          "HAPPYBONUS"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.priceEnea,
                                                            expression:
                                                              "priceEnea"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              max: 63,
                                                              min: 2
                                                            },
                                                            expression:
                                                              "{required:true, max: 63, min: 2}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.priceEnea"
                                                          ),
                                                          valid: !!_vm.priceEnea
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          autocomplete:
                                                            "randomq",
                                                          id: "priceEnea",
                                                          name: "priceEnea",
                                                          "data-vv-as":
                                                            "Costo Gestione Pratica ENEA"
                                                        },
                                                        domProps: {
                                                          value: _vm.priceEnea
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.formatpriceEnea()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.priceEnea =
                                                              $event.target.value
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "priceEnea"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Costo Gestione Pratica ENEA"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "Valore visualizzato nel Preventivo ( importo € IVA esclusa )"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.priceEnea"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\r\n                          " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.priceEnea"
                                                                    )
                                                                  ) +
                                                                  "\r\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.flow != "mbfacta_recovery"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-6 mb-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "group"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label widthFull black h5",
                                                                  attrs: {
                                                                    for:
                                                                      "datiCatastali"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\r\n                            Servizio opzionale a pagamento di redazione e invio "
                                                                  ),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      '"Pratica ENEA"'
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    " dell'intervento al costo di €50 +IVA\r\n                            "
                                                                  ),
                                                                  _c("small", [
                                                                    _c("br"),
                                                                    _vm._v(
                                                                      "( importo che ti sarà addebitato in fase di pagamento Pratica se accetti il servizio )"
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-check form-check-inline mt-2"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.enea = 1
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.enea,
                                                                              expression:
                                                                                "enea"
                                                                            },
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                "required|included:1,0",
                                                                              expression:
                                                                                "'required|included:1,0'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-check-input inline mr-3",
                                                                          class: {
                                                                            "is-invalid": _vm.errors.has(
                                                                              "form-2.enea"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "radio",
                                                                            value:
                                                                              "1",
                                                                            name:
                                                                              "enea"
                                                                          },
                                                                          domProps: {
                                                                            checked: _vm._q(
                                                                              _vm.enea,
                                                                              "1"
                                                                            )
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.enea =
                                                                                "1"
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "ACCETTO"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-check form-check-inline"
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.enea = 0
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm.enea,
                                                                              expression:
                                                                                "enea"
                                                                            },
                                                                            {
                                                                              name:
                                                                                "validate",
                                                                              rawName:
                                                                                "v-validate",
                                                                              value:
                                                                                "required|included:1,0",
                                                                              expression:
                                                                                "'required|included:1,0'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "form-check-input inline mr-3",
                                                                          class: {
                                                                            "is-invalid": _vm.errors.has(
                                                                              "form-2.enea"
                                                                            )
                                                                          },
                                                                          attrs: {
                                                                            type:
                                                                              "radio",
                                                                            value:
                                                                              "0",
                                                                            name:
                                                                              "enea"
                                                                          },
                                                                          domProps: {
                                                                            checked: _vm._q(
                                                                              _vm.enea,
                                                                              "0"
                                                                            )
                                                                          },
                                                                          on: {
                                                                            change: function(
                                                                              $event
                                                                            ) {
                                                                              _vm.enea =
                                                                                "0"
                                                                            }
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "NON ACCETTO"
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value: _vm.errors.has(
                                                                        "form-2.enea"
                                                                      ),
                                                                      expression:
                                                                        "errors.has('form-2.enea')"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "errorMes red"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\r\n                            Il servizio deve essere accettato oppure rifiutato\r\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      Totale importo (IVA esclusa):\r\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "\r\n                        €\r\n                        " +
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        (
                                                          parseFloat(
                                                            _vm.totalProducts
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.totalAccessories
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceWork
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceEnea
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceDcast
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          )
                                                        ).toFixed(2)
                                                      )
                                                    ) +
                                                    "\r\n\r\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si" &&
                                      _vm.flow != "agileenergy"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pt-2 pb-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Gestione Aliquote IVA degli importi indicati nelle sezioni del Preventivo\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Beni significativi ( quota concorrente accessori e manodopera )\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_lavoro,
                                                          expression:
                                                            "iva_age_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{required:true}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_age_lavoro
                                                      },
                                                      attrs: {
                                                        id: "iva_age_lavoro",
                                                        name: "iva_age_lavoro",
                                                        "data-vv-as":
                                                          "Beni significativi, quota concorrente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [_vm._v("10% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [_vm._v("4% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22% ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reverse Charge "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Beni significativi ( quota eccedente accessori e manodopera )\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_extra,
                                                          expression:
                                                            "iva_age_extra"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{required:true}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_extra"
                                                        ),
                                                        valid: !!_vm.iva_age_extra
                                                      },
                                                      attrs: {
                                                        id: "iva_age_extra",
                                                        name: "iva_age_extra",
                                                        "data-vv-as":
                                                          "Beni significativi, quota eccedente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_extra = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [_vm._v("10% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [_vm._v("4% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22% ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reverse Charge "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Altri Beni / Accessori opzionali / Installazione e Posa in Opera\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_accessori_lavoro,
                                                          expression:
                                                            "iva_accessori_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{required:true}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_accessori_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_accessori_lavoro
                                                      },
                                                      attrs: {
                                                        id:
                                                          "iva_accessori_lavoro",
                                                        name:
                                                          "iva_accessori_lavoro",
                                                        "data-vv-as":
                                                          "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_accessori_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [_vm._v("10% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [_vm._v("4% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22% ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reverse Charge "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                        Altri oneri ( costo Visura Catastale, costo Pratica ENEA, costo Pratica cessione )\r\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_altri_oneri,
                                                          expression:
                                                            "iva_altri_oneri"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{required:true}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_altri_oneri"
                                                        ),
                                                        valid: !!_vm.iva_altri_oneri
                                                      },
                                                      attrs: {
                                                        id: "iva_altri_oneri",
                                                        name: "iva_altri_oneri",
                                                        "data-vv-as":
                                                          "Altri oneri per il Committente"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_altri_oneri = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [_vm._v("10% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [_vm._v("4% ")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22% ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Reverse Charge "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.client_type ==
                                                "Persona fisica" &&
                                              _vm.usoAbitativo == 1 &&
                                              (_vm.iva_altri_oneri == "0.04" ||
                                                _vm.iva_accessori_lavoro ==
                                                  "0.04" ||
                                                _vm.iva_age_extra == "0.04" ||
                                                _vm.iva_age_lavoro == "0.04")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-8 mb-3 center text-left"
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "Bold center"
                                                        },
                                                        [_vm._v("Attenzione! ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b", [
                                                        _vm._v(
                                                          "Non tutti gli acquisti e interventi, a prescindere, possono essere considerati secondo l’aliquota agevolata al 4% bensì esclusivamente quelli prettamente collegati alla specifica disabilità del cliente finale. "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _c("br"),
                                                      _c(
                                                        "b",
                                                        { staticClass: "red" },
                                                        [
                                                          _vm._v(
                                                            "Occorre, pertanto, verificare la tipologia di intervento da eseguire per verificare se il cliente potrà o meno beneficiare dell’aliquota IVA al 4%."
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mt-2 center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Consulta la "
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "Bold underline black",
                                                              attrs: {
                                                                href:
                                                                  "https://storage.googleapis.com/chebonus/Guida_alle_agevolazioni_fiscali_per_le_persone_con_disabilita.pdf",
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [_vm._v("guida")]
                                                          ),
                                                          _vm._v(
                                                            " relativa alle\r\n                        agevolazioni fiscali per le persone con disabilità. "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _vm.requiredOperations
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 mb-3 requiredCont"
                                              },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "green " },
                                                  [
                                                    _vm._v(
                                                      "Requisiti tecnici richiesti per aderire al bonus:"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("h5", {
                                                  staticClass: "black",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.requiredOperations
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title:
                              _vm.flow == "mbfacta_recovery"
                                ? "Pratica Completata"
                                : "Preventivo completato",
                            subtitle: "Tutti i campi sono obbligatori",
                            icon: "",
                            "before-change": _vm.validateThirdTab
                          }
                        },
                        [
                          _vm.calcFinish
                            ? _c(
                                "form",
                                {
                                  staticClass: "widthFull orio pt-3 pr-md-3",
                                  attrs: {
                                    "data-vv-scope": "form-3",
                                    autocomplete: "qwerqrt3"
                                  }
                                },
                                [
                                  _vm.bonusError
                                    ? _c("div", { staticClass: "widthFull" }, [
                                        _vm.bonusError
                                          ? _c("div", {
                                              staticClass:
                                                "row justify-content-center divider"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.bonusError
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-12" },
                                              [
                                                _c("h4", {
                                                  staticClass:
                                                    "widthFull center red",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.bonusErrorText
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.flow == "agileenergy"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "widthFull yellowBg  pb-4"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "row justify-content-center divider fordelete"
                                          }),
                                          _vm._v(" "),
                                          !_vm.agileDiscount
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass: "pt-4 yellowBg"
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Il costo di gestione del Servizio del General Contractor AGILE ENERGY a supporto della gestione di questa Pratica è pari a: "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b",
                                                    { staticClass: "green" },
                                                    [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.priceAgileenergy
                                                            )
                                                          ) +
                                                          "  ( IVA escl. )"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "p",
                                                { staticClass: "pt-4 " },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                  Il costo di gestione del Servizio del General Contractor AGILE ENERGY a supporto della gestione di questa Pratica è pari a:\r\n                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull center green"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                (_vm.priceAgileenergy /
                                                                  70) *
                                                                100
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                          "\r\n                    - Sconto 30% = € " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.priceAgileenergy
                                                            )
                                                          ) +
                                                          " ( IVA escl. )\r\n                  "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c("small", {}, [
                                            _vm._v(
                                              "\r\n                Questo costo non è incluso in questo Preventivo, pertanto l'installatore professionista in subappalto ad AGILE ENERGY\r\n                 riceverà la relativa fattura da AGILE ENERGY in compensazione\r\n                 della fattura che l'installatore professionista in subappalto emetterà ad AGILE ENERGY per il materiale\r\n                 e l'installazione, come indicati nel Preventivo.\r\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("br")
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      ref: "invoiceData",
                                      staticClass: "widthFull"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider fordelete"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0 mt-4"
                                        },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _vm.flow != "agileenergy"
                                                    ? [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Cessionario/prestatore (fornitore)"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Identificativo fiscale ai fini IVA: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .partita_iva
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Denominazione: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .azienda
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Indirizzo: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .indirizzo
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .civico
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Comune: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .comune
                                                            ) +
                                                              " (" +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .provincia
                                                              ) +
                                                              ")"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("CAP: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile.cap
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Email: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .email
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .cellulare
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "IBAN:\r\n                          "
                                                        ),
                                                        _vm.flow == "poste"
                                                          ? _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getProfile
                                                                    .iban
                                                                )
                                                              )
                                                            ])
                                                          : _vm.flow == "cdp"
                                                          ? _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getProfile
                                                                    .iban_cdp
                                                                )
                                                              )
                                                            ])
                                                          : _vm.flow ==
                                                              "mbfacta" ||
                                                            _vm.flow ==
                                                              "mbfacta_recovery"
                                                          ? _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getProfile
                                                                    .iban_mbfacta
                                                                )
                                                              )
                                                            ])
                                                          : _vm.flow ==
                                                            "agileenergy"
                                                          ? _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.iban_agileenergy
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Cessionario/prestatore (fornitore)"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Identificativo fiscale ai fini IVA: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v("10134260966")
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Denominazione: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            "AGILE ENERGY S.r.l."
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Sede Legale: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            "Piazza della Repubblica 9 20121 Milano (MI)"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Email: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            "info@agileenergy.it"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Telefono: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            "(+39) 02 3056 6476"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("IBAN:  "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.iban_agileenergy
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("b", [
                                                          _vm._v(
                                                            "Installatore in subappalto"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Identificativo fiscale ai fini IVA: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .partita_iva
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Denominazione: "
                                                        ),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .azienda
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Indirizzo: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .indirizzo
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .civico
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .cap
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .comune
                                                              ) +
                                                              " (" +
                                                              _vm._s(
                                                                _vm.getProfile
                                                                  .provincia
                                                              ) +
                                                              ")"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Email: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .email
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getProfile
                                                                .cellulare
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _vm.getProfile.logo &&
                                                  _vm.flow != "agileenergy"
                                                    ? _c("img", {
                                                        staticClass:
                                                          "img-fluid",
                                                        staticStyle: {
                                                          width:
                                                            "50%!important",
                                                          "max-width": "150px"
                                                        },
                                                        attrs: {
                                                          src:
                                                            _vm.getProfile.logo
                                                        }
                                                      })
                                                    : _vm.flow == "agileenergy"
                                                    ? _c("img", {
                                                        staticClass:
                                                          "img-fluid",
                                                        staticStyle: {
                                                          width:
                                                            "100%!important",
                                                          "max-width": "150px"
                                                        },
                                                        attrs: {
                                                          src:
                                                            "https://storage.googleapis.com/chebonus/agileenergy/LOGOF.png"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top"
                                                  }
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Benificiario/committente (cliente)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Denominazione: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.clientName) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.clientLastname
                                                        )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Indirizzo: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.adress) +
                                                        " " +
                                                        _vm._s(_vm.civic)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Comune: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.city.city) +
                                                        " (" +
                                                        _vm._s(_vm.province) +
                                                        ")"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("CAP: "),
                                                  _c("b", [
                                                    _vm._v(_vm._s(_vm.zip))
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Email: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.client_email)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_phone
                                                    ? _c("span", [
                                                        _vm._v("Telefono: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_phone
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_mobile
                                                    ? _c("span", [
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_mobile
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.flow != "mbfacta_recovery"
                                        ? _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left pt-4 h0 black"
                                            },
                                            [
                                              _c("b", [
                                                _vm._v("Il tuo Preventivo:")
                                              ])
                                            ]
                                          )
                                        : _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left pt-4 h0 black"
                                            },
                                            [
                                              _c("b", [
                                                _vm._v("La tua Pratica:")
                                              ])
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario == "si" &&
                                      _vm.flow != "agileenergy"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                  Operazione effettuata ai sensi dell'art. 1, commi da 54 a 89 della Legge n. 190/2014,\r\n                  così come modificato dalla Legge numero 208/2015 e dalla Legge 145/2018 art. 1 Commi 9-11.\r\n                "
                                              )
                                            ]
                                          )
                                        : _vm.client_type == "Partita IVA" &&
                                          _vm.iva_age_lavoro == "0.00" &&
                                          _vm.iva_age_extra == "0.00"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                  Operazione soggetta al reverse charge art. 17, comma 6, lett. a-ter DPR 633/1972.\r\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          ref: "invoiceData_part1",
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("thead"),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            [
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Beni significativi"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Importo unitario ")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.products, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(item.price) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm.totalProducts
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Agevolabile Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                parseFloat(
                                                                  _vm.totalProducts
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) -
                                                                parseFloat(
                                                                  _vm.totalExtraMise
                                                                )
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Altri beni ed accessori"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Importo unitario ")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.accessories, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(item.price) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", {
                                                  attrs: { scope: "row" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "2" } },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm.priceWork
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v("Totale "),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                          "si" ||
                                                        _vm.flow ==
                                                          "agileenergy"
                                                          ? [
                                                              _vm._v(
                                                                "imponibile"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(
                                                          " altri beni ed accessori "
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.totalAccessories
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) +
                                                                parseFloat(
                                                                  _vm.priceWork
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                )
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.dl == "new"
                                        ? _c(
                                            "table",
                                            {
                                              ref: "invoiceData_part2",
                                              staticClass:
                                                "table table-bordered "
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greenBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "4" }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Altri oneri agevolabili"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.dl == "new"
                                                  ? _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            align: "left",
                                                            scope: "row"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Visto di conformità "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .vistoCost
                                                                    )
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.dl == "new"
                                                  ? _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            align: "left",
                                                            scope: "row"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Asseverazione della congruità delle spese "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.getProfile
                                                        .reg_forfettario !=
                                                        "si" ||
                                                      _vm.flow == "agileenergy"
                                                        ? _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "€ " +
                                                                    _vm._s(
                                                                      _vm.priceAT
                                                                    ) +
                                                                    " "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        : _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "€ " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        _vm.priceAT
                                                                      )
                                                                    ) +
                                                                    " "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { align: "right" }
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v("Totale "),
                                                          _vm.getProfile
                                                            .reg_forfettario !=
                                                            "si" ||
                                                          _vm.flow ==
                                                            "agileenergy"
                                                            ? [
                                                                _vm._v(
                                                                  "imponibile"
                                                                )
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(
                                                            " altri oneri agevolabili "
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { align: "right" }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  _vm.priceAT
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) +
                                                                  parseFloat(
                                                                    _vm.calcInfo
                                                                      .vistoCost
                                                                  )
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "invoiceData_part3",
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v("Totale "),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                              "si" ||
                                                            _vm.flow ==
                                                              "agileenergy"
                                                              ? [
                                                                  _vm._v(
                                                                    "imponibile"
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(
                                                              " intervento "
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          width: "220",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "€ " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  parseFloat(
                                                                    _vm.calcInfo
                                                                      .totalBase
                                                                  ) +
                                                                    parseFloat(
                                                                      _vm.priceAT
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .vistoCost
                                                                    )
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si" ||
                                      _vm.flow == "agileenergy"
                                        ? _c(
                                            "table",
                                            {
                                              ref: "invoiceData_part4",
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("thead", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greenBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "4" }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase"
                                                          },
                                                          [_vm._v("Riepilogo")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", {
                                                    attrs: {
                                                      align: "left",
                                                      scope: "row"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm._v("Importo "),
                                                          _vm.getProfile
                                                            .reg_forfettario !=
                                                            "si" ||
                                                          _vm.flow ==
                                                            "agileenergy"
                                                            ? [
                                                                _vm._v(
                                                                  "imponibile"
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Aliquota IVA")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Totale (IVA Inclusa)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Beni significativi, quota concorrente accessori e manodopera"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(_vm.age_lavoro)
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                (
                                                                  parseFloat(
                                                                    _vm.age_lavoro
                                                                  ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_age_lavoro
                                                                    ))
                                                                ).toFixed(2)
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Beni significativi, quota eccedente accessori e manodopera"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(_vm.age_extra)
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_extra *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                (
                                                                  parseFloat(
                                                                    _vm.age_extra
                                                                  ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_age_extra
                                                                    ))
                                                                ).toFixed(2)
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  _vm.totalAccessories
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) +
                                                                  parseFloat(
                                                                    _vm.priceWork
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  )
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_accessori_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                (
                                                                  (parseFloat(
                                                                    _vm.totalAccessories
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  ) +
                                                                    parseFloat(
                                                                      _vm.priceWork
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    )) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_accessori_lavoro
                                                                    ))
                                                                ).toFixed(2)
                                                              )
                                                            ) +
                                                            "\r\n                        "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.dl == "new"
                                                  ? _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            align: "left",
                                                            scope: "row"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Altri oneri agevolabili"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    parseFloat(
                                                                      _vm.priceAT
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                      parseFloat(
                                                                        _vm
                                                                          .calcInfo
                                                                          .vistoCost
                                                                      )
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.iva_altri_oneri *
                                                                  100
                                                              ) + " %"
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    (
                                                                      (parseFloat(
                                                                        _vm.priceAT
                                                                          .replace(
                                                                            ".",
                                                                            ""
                                                                          )
                                                                          .replace(
                                                                            ",",
                                                                            "."
                                                                          )
                                                                      ) +
                                                                        parseFloat(
                                                                          _vm
                                                                            .calcInfo
                                                                            .vistoCost
                                                                        )) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        ))
                                                                    ).toFixed(2)
                                                                  )
                                                                ) +
                                                                "\r\n                        "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "invoiceData_part5",
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale quota Spesa agevolabile "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                              "si" ||
                                                            _vm.flow ==
                                                              "agileenergy"
                                                              ? [
                                                                  _vm._v(
                                                                    "(IVA INCLUSA)"
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "€ " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  _vm.calcInfo
                                                                    .totalBaseAndIva
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          ref: "invoiceData_part6",
                                          staticClass: "table table-bordered "
                                        },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "uppercase",
                                                  attrs: {
                                                    colspan: "2",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Sconto in fattura " +
                                                      _vm._s(this.ecoBonus) +
                                                      " "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm.ecoBonus !=
                                                          "Bonus Casa 50%" &&
                                                        this.client_type ==
                                                          "Partita IVA" &&
                                                        this.usoAbitativo ==
                                                          0 &&
                                                        this.iva_age_lavoro ==
                                                          "0.22" &&
                                                        this.iva_age_extra ==
                                                          "0.22" &&
                                                        this
                                                          .iva_accessori_lavoro ==
                                                          "0.22"
                                                          ? void 0
                                                          : [
                                                              _vm._v(
                                                                " (IVA INCLUSA)"
                                                              )
                                                            ]
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus !=
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (Art. 121, D.L. 34/20 convertito con Legge 17 luglio 2020) "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalWithBonus
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale fattura al committente per bonifico  "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                          "si" ||
                                                        _vm.flow ==
                                                          "agileenergy"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus ==
                                                          "Bonus Casa 50%" &&
                                                        _vm.flow !=
                                                          "agileenergy"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " (Art. 16 bis, D.P.R. 917/86)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus !=
                                                          "Bonus Casa 50%" &&
                                                        _vm.flow !=
                                                          "agileenergy"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " (Art. 1, Legge 296/2006 e art. 14 D.L. 63/2013)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .totalBaseAndIva
                                                              ) -
                                                                parseFloat(
                                                                  _vm.calcInfo
                                                                    .totalWithBonus
                                                                )
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greenBg" },
                                              [
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "4" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Altri oneri per il committente"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    colspan: "2",
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Quota spesa non agevolata "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " % INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva22NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva10NonAge
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            !_vm.NoEnea
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { align: "left" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Costo Gestione Pratica ENEA "
                                                      ),
                                                      _vm.getProfile
                                                        .reg_forfettario !=
                                                        "si" ||
                                                      _vm.flow == "agileenergy"
                                                        ? [
                                                            _vm._v(
                                                              "(IVA " +
                                                                _vm._s(
                                                                  _vm.iva_altri_oneri *
                                                                    100
                                                                ) +
                                                                " % INCLUSA)"
                                                            )
                                                          ]
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: { align: "left" }
                                                    },
                                                    [
                                                      _vm.flow != "agileenergy"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-check hideOnPdf"
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.zeroEnea,
                                                                    expression:
                                                                      "zeroEnea"
                                                                  }
                                                                ],
                                                                key: "1111",
                                                                staticClass:
                                                                  "form-check-input",
                                                                attrs: {
                                                                  type:
                                                                    "checkbox",
                                                                  id: "zeroEnea"
                                                                },
                                                                domProps: {
                                                                  checked: Array.isArray(
                                                                    _vm.zeroEnea
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm.zeroEnea,
                                                                        null
                                                                      ) > -1
                                                                    : _vm.zeroEnea
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm.zeroEnea,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c = $$el.checked
                                                                        ? true
                                                                        : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v = null,
                                                                        $$i = _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          (_vm.zeroEnea = $$a.concat(
                                                                            [
                                                                              $$v
                                                                            ]
                                                                          ))
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          (_vm.zeroEnea = $$a
                                                                            .slice(
                                                                              0,
                                                                              $$i
                                                                            )
                                                                            .concat(
                                                                              $$a.slice(
                                                                                $$i +
                                                                                  1
                                                                              )
                                                                            ))
                                                                      }
                                                                    } else {
                                                                      _vm.zeroEnea = $$c
                                                                    }
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                  attrs: {
                                                                    for:
                                                                      "zeroEnea"
                                                                  }
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      "Escludi questa voce dal preventivo"
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) *
                                                                    (1 +
                                                                      parseFloat(
                                                                        _vm.iva_altri_oneri
                                                                      ))
                                                                  ).toFixed(2)
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  parseFloat(
                                                                    _vm.priceEnea
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  ).toFixed(2)
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Costo Recupero Visura Catastale "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " % INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm.flow != "agileenergy"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check hideOnPdf"
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.zeroDcast,
                                                                expression:
                                                                  "zeroDcast"
                                                              }
                                                            ],
                                                            key: "2311",
                                                            staticClass:
                                                              "form-check-input",
                                                            attrs: {
                                                              type: "checkbox",
                                                              id: "zeroDcast"
                                                            },
                                                            domProps: {
                                                              checked: Array.isArray(
                                                                _vm.zeroDcast
                                                              )
                                                                ? _vm._i(
                                                                    _vm.zeroDcast,
                                                                    null
                                                                  ) > -1
                                                                : _vm.zeroDcast
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.zeroDcast,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v = null,
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.zeroDcast = $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.zeroDcast = $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                  }
                                                                } else {
                                                                  _vm.zeroDcast = $$c
                                                                }
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-check-label",
                                                              attrs: {
                                                                for: "zeroDcast"
                                                              }
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Escludi questa voce dal preventivo"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.getProfile.reg_forfettario !=
                                                "si" ||
                                              _vm.flow == "agileenergy"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              (
                                                                parseFloat(
                                                                  _vm.priceDcast
                                                                ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                              ).toFixed(2)
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "€ " +
                                                            _vm._s(
                                                              parseFloat(
                                                                _vm.priceDcast
                                                              ).toFixed(2)
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm._v(
                                                          " Oneri di Gestione Agile Energy "
                                                        )
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          " Oneri Finanziari "
                                                        )
                                                      ],
                                                  _vm._v(" "),
                                                  _vm.flow == "cdp"
                                                    ? [_vm._v(" CDP ")]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "poste"
                                                    ? [
                                                        _vm._v(
                                                          " Poste Italiane "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "general"
                                                    ? [
                                                        _vm._v(
                                                          " Flusso Base " +
                                                            _vm._s(
                                                              (
                                                                100 -
                                                                parseFloat(
                                                                  this.fin_cost
                                                                )
                                                              ).toFixed(2)
                                                            ) +
                                                            "%  "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "mbfacta"
                                                    ? [
                                                        _vm._v(
                                                          " Flusso MBFACTA "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.flow == "mbfacta_recovery"
                                                    ? [
                                                        _vm._v(
                                                          " Flusso Personalizzato "
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [_vm._v("(IVA ESENTE)")]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm.flow != "agileenergy"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check hideOnPdf"
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.zeroOneri,
                                                                expression:
                                                                  "zeroOneri"
                                                              }
                                                            ],
                                                            key: "2222",
                                                            staticClass:
                                                              "form-check-input",
                                                            attrs: {
                                                              type: "checkbox",
                                                              id: "zeroOneri"
                                                            },
                                                            domProps: {
                                                              checked: Array.isArray(
                                                                _vm.zeroOneri
                                                              )
                                                                ? _vm._i(
                                                                    _vm.zeroOneri,
                                                                    null
                                                                  ) > -1
                                                                : _vm.zeroOneri
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.zeroOneri,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v = null,
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.zeroOneri = $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.zeroOneri = $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                  }
                                                                } else {
                                                                  _vm.zeroOneri = $$c
                                                                }
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-check-label",
                                                              attrs: {
                                                                for: "zeroOneri"
                                                              }
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Escludi questa voce dal preventivo"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .allOneri
                                                            ) -
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .serviceCost
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Costo di gestione pratica "
                                                  ),
                                                  _vm.dl == "new"
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " e Due Diligence "
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si" ||
                                                  _vm.flow == "agileenergy"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " % INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm.flow != "agileenergy"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-check hideOnPdf"
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.zeroPratica,
                                                                expression:
                                                                  "zeroPratica"
                                                              }
                                                            ],
                                                            key: "3333",
                                                            staticClass:
                                                              "form-check-input",
                                                            attrs: {
                                                              type: "checkbox",
                                                              id: "zeroPratica"
                                                            },
                                                            domProps: {
                                                              checked: Array.isArray(
                                                                _vm.zeroPratica
                                                              )
                                                                ? _vm._i(
                                                                    _vm.zeroPratica,
                                                                    null
                                                                  ) > -1
                                                                : _vm.zeroPratica
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.zeroPratica,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v = null,
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.zeroPratica = $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.zeroPratica = $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                  }
                                                                } else {
                                                                  _vm.zeroPratica = $$c
                                                                }
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-check-label",
                                                              attrs: {
                                                                for:
                                                                  "zeroPratica"
                                                              }
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Escludi questa voce dal preventivo"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .serviceCost
                                                            ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale altri oneri per il committente "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                          "si" ||
                                                        _vm.flow ==
                                                          "agileenergy"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA " +
                                                                  _vm._s(
                                                                    _vm.iva_altri_oneri *
                                                                      100
                                                                  ) +
                                                                  " % INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _vm.getProfile
                                                      .reg_forfettario !=
                                                      "si" ||
                                                    _vm.flow == "agileenergy"
                                                      ? _c("b", [
                                                          _vm._v(
                                                            "\r\n                          €\r\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\r\n                        "
                                                          )
                                                        ])
                                                      : _c("b", [
                                                          _vm._v(
                                                            "\r\n                          €\r\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\r\n                        "
                                                          )
                                                        ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "invoiceData_part7",
                                          staticClass: "row ml-0 mr-0  pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale Importo € "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              " ( a carico dell’utente finale "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                              "si" ||
                                                            _vm.flow ==
                                                              "agileenergy"
                                                              ? [
                                                                  _vm._v(
                                                                    ", IVA inclusa"
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(" )")
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            "€ " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  _vm.calcInfo
                                                                    .finalPrice
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table mb-0 mt-3 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "left"
                                                        }
                                                      },
                                                      [
                                                        _vm.getProfile
                                                          .reg_forfettario ==
                                                          "si" &&
                                                        _vm.flow !=
                                                          "agileenergy"
                                                          ? [
                                                              _vm._v(
                                                                " Operazione in franchigia da Iva ex art. 1 cc. 54-89 L. 190/2014 "
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\r\n\r\n                          L’utilizzo dei servizi descritti sul Sito comporta l’integrale accettazione dei\r\n\r\n                          "
                                                        ),
                                                        _vm.brand == "CHEBONUS"
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    "https://storage.googleapis.com/chebonus/Conditions.pdf?v=2",
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\r\n                            Termini e delle condizioni di riferimento ( https://chebonus.it/Conditions.pdf )\r\n                          "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    "https://storage.googleapis.com/happybonus/Conditions.pdf?v=2",
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\r\n                            Termini e delle condizioni di riferimento ( https://happybonus.it/Conditions.pdf )\r\n                          "
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "widthFull mt-5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row justify-content-center"
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass: "table table-bordered "
                                          },
                                          [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "row" } },
                                                  [
                                                    _vm._v(
                                                      "\r\n                          IMPORTO TOTALE DEL CREDITO CEDUTO\r\n                          "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        "€ " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.calcInfo
                                                                .totalWithBonus
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12 mb-3 " },
                                          [
                                            _vm._v(
                                              "\r\n                    L’aliquota degli oneri di attualizzazione dei crediti d’imposta relativi a Bonus Casa 50%, Ecobonus 50%, Ecobonus 65% e Superbonus 110%\r\n                    indicata nel presente Preventivo è puramente indicativa e aggiornata al giorno precedente all’elaborazione del Preventivo.\r\n                    "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "Prima di far sottoscrivere al tuo cliente il Preventivo, ti invitiamo a verificare l’aliquota aggiornata degli oneri di\r\n                    attualizzazione dei crediti d’imposta dei Cessionari.\r\n                    "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\r\n                    Non si ritengono responsabili Novatag, Vaillant Group Italia e Società terze per eventuali danni\r\n                    economici derivanti dall’omissione della verifica da parte dell’installatore dell’aliquota aggiornata degli oneri di attualizzazione\r\n                    dei crediti d’imposta dei Cessionari e omissioni o errate valorizzazioni di tale Preventivo.\r\n\r\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var editCalc_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", { staticClass: "green" }, [
      _vm._v(
        "\r\n              Il Preventivo verrà generato a nome di Agile Energy con l'indicazione della tua ragione sociale come esecutore dei lavori in subappalto.\r\n              "
      ),
      _c("br"),
      _vm._v(
        "Prima di essere inviato al Cliente Finale (Committente) sarà oggetto di verifica interna per approvazione da parte di Agile Energy.\r\n            "
      )
    ])
  }
]
editCalc_render._withStripped = true
var editCalc_esExports = { render: editCalc_render, staticRenderFns: editCalc_staticRenderFns }
/* harmony default export */ var components_editCalc = (editCalc_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42d13b52", editCalc_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/editCalc/index.vue
var editCalc_disposed = false
function editCalc_injectStyle (ssrContext) {
  if (editCalc_disposed) return
  __webpack_require__("gEuQ")
}
var editCalc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editCalc___vue_template_functional__ = false
/* styles */
var editCalc___vue_styles__ = editCalc_injectStyle
/* scopeId */
var editCalc___vue_scopeId__ = "data-v-42d13b52"
/* moduleIdentifier (server only) */
var editCalc___vue_module_identifier__ = null
var editCalc_Component = editCalc_normalizeComponent(
  editCalc,
  components_editCalc,
  editCalc___vue_template_functional__,
  editCalc___vue_styles__,
  editCalc___vue_scopeId__,
  editCalc___vue_module_identifier__
)
editCalc_Component.options.__file = "src/components/editCalc/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42d13b52", editCalc_Component.options)
  } else {
    hotAPI.reload("data-v-42d13b52", editCalc_Component.options)
  }
  module.hot.dispose(function (data) {
    editCalc_disposed = true
  })
})()}

/* harmony default export */ var src_components_editCalc = (editCalc_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/acceptInvoice/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var acceptInvoice_moment = __webpack_require__("PJh5");

/* harmony default export */ var acceptInvoice = ({
  name: 'acceptInvoice',
  components: {},
  data: function data() {
    return {
      token: '',

      citySE: '',
      capSE: '',

      //NEWWWW 222
      client_owner_type: '',
      client_owner_codice_fiscale: '',

      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: {},
      hideData: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      mobile: '',
      cellulare: '',
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,

      invoiceRear: '',
      invoiceRearName: '',
      invoiceRearBucket: '',
      uploadRearPercentage: 0,

      client_ownership: '',
      subalterno: '',
      particella: '',
      foglio: '',
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      brand: "CHEBONUS"
    };
  },

  methods: {
    convertToPractice: function convertToPractice() {
      var _this = this;

      var _vue = this;
      console.log(this.$validator);
      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;
          // PREPARE
          var data = {};
          data.client_email = _this.item.client_email;
          data.client_codice_fiscale = _this.codice_fiscale;
          data.client_partita_iva = _this.partita_iva;
          data.client_phone = _this.item.client_phone;
          data.client_mobile = _this.item.client_mobile;
          data.client_address = _this.address;
          data.client_civic = _this.civic;

          // NEW DISPOSAL
          data.disposal = 0;

          if (_this.province != 'SE') {
            data.client_province = _this.province;
            data.client_city = _this.city.city;
            data.client_zip = _this.zip;
          } else {
            data.client_province = _this.province;
            data.client_city = _this.citySE;
            data.client_zip = _this.capSE;
          }

          data.client_ownership = _this.client_ownership;

          data.building_subalterno = _this.subalterno;
          data.building_particella = _this.particella;
          data.building_foglio = _this.foglio;
          data.practice_id = _this.item.id;

          data.date_accept_offer = acceptInvoice_moment().format('YYYY-MM-DD HH:mm:ss');

          data.code = _this.item.code;

          if (_this.tokenControl) {
            data.user_token = _this.$route.query.t;
          } else {
            data.user_token = _this.getProfile.userToken;
          }

          data.signed_order = _this.invoiceFrontBucket;

          // NEW CODICE FISCALE PROPRIETARIO PER DCAST
          data.client_owner_type = _this.client_owner_type;
          if (_this.client_owner_type == 'Proprietario o comproprietario') {
            data.client_owner_codice_fiscale = '';
          } else {
            data.client_owner_codice_fiscale = _this.client_owner_codice_fiscale;
          }

          if (_this.item.flow == 'agileenergy') {
            data.practice = _this.item;
            data.lettera_di_affidamento_signed = _this.invoiceRearBucket;
          }

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/acceptOrder',
            method: 'POST',
            data: data,
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            console.log(resp);

            _vue.loadingState = false;

            if (_this.item.flow == 'agileenergy') {

              _vue.$swal({
                type: 'success',
                title: '',
                html: 'La Lettera di Affidamento ed il Contratto per la fornitura e l’installazione sono in verifica. A seguito dell`approvazione verranno inviate al Committente all`indirizzo e-mail le indicazioni per procedere al pagamento della quota parte relativa alla voce “Totale altri Oneri per il Committente” '
              });

              _vue.$router.push('/offerte');
            } else {

              if (_vue.tokenControl) {

                _vue.$swal({
                  type: 'success',
                  title: 'Pratica Inizializzata',
                  html: 'Abbiamo creato la pratica <b>' + _this.item.code + '</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. '
                });

                _vue.hideData = true;
              } else {

                _vue.$swal({
                  type: 'success',
                  title: 'Pratica Inizializzata',
                  html: 'Abbiamo creato la pratica <b>' + _this.item.code + '</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. '
                });
              }

              _vue.$router.push('/pratiche');
            }
          }).catch(function (resp) {
            _vue.loadingState = false;
            _vue.$swal({
              type: 'error',
              title: 'Oops...',
              text: 'Riprova piu tardi!'
            });
          });
        } else {
          console.log('ERROR IN FORM');
          _vue.$scrollTo('#' + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        }
      });
    },
    populateProvincies: function populateProvincies() {
      var _this2 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/getProvinciesAll',
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this2.provincies = resp.data.provincies;
        _this2.provinciesState = false;
      }).catch(function (resp) {
        _this2.provincies = [];
        _this2.provinciesState = false;
      });
    },
    checkUserToken: function checkUserToken(token) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('QRcode CHECK TOKEN');
                _context.next = 3;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/tokenControl',
                  method: 'POST',
                  data: {
                    'user_token': token
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  console.log('QRcode CHECK TOKEN => OK');
                  _this3.tokenControl = true;
                }).catch(function (resp) {
                  console.log('QRcode CHECK TOKEN => ERROR');
                  _this3.tokenControl = false;
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getPracticById: function getPracticById(userToken, id) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('GET PRACTIC FOR QRcode ENTER');
                _context2.next = 3;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getPracticById',
                  method: 'POST',
                  data: {
                    'user_token': userToken,
                    'id': id
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  console.log('GET PRACTIC FOR QRcode => OK');
                  // CHECK IF ACTIVE YET

                  _this4.$route.params.item = resp.data.practices[0];

                  // MENU OFF FOR THIS CASE
                  var alert = {};
                  alert.text = 'NOT LOGED VIEW';
                  alert.type = 'MENU_OFF';
                  //this.$store.dispatch(ADD_NOTIFICATIONS, alert)
                }).catch(function (resp) {
                  console.log('GET PRACTIC FOR QRcode => ERROR');
                  _this4.tokenControl = false;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },

    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    },
    UploadError: function UploadError() {
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Errore caricamento immagine'
      });
    },
    setCap: function setCap(cap) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var x;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (x in _this5.zips) {
                  if (_this5.zips[x].cap == cap.toUpperCase()) {
                    _this5.zip = _this5.zips[x].cap;
                  }
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    setCity: function setCity(city) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var x, k;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:

                for (x in _this6.cities) {
                  if (_this6.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this6.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this6.city = k;
                  }
                }
                console.log(_this6.city);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var x;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                for (x in _this7.provincies) {
                  if (_this7.provincies[x].sigla == province.toUpperCase()) {
                    _this7.province = _this7.provincies[x].sigla;
                  }
                }
                console.log(_this7.province);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },

    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        var t = 0;
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1;
        }

        this.loadingState = true;

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.loadingState = false;
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = '';
            _vue.invoiceFrontBucket = '';
            _vue.UploadError();
            input.target.value = null;
            _vue.loadingState = false;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = '';
          _vue.invoiceFrontBucket = '';
          _vue.UploadError();
          input.target.value = null;
          _vue.loadingState = false;
        });
      }
    },

    uploadFile2: function uploadFile2(input) {
      var file = input.target.files[0].name;
      this.invoiceRearName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceRear = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        var t = 0;
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1;
        }

        this.loadingState = true;

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadRearPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.loadingState = false;
            _vue.uploadRearPercentage = 0;
            _vue.invoiceRearBucket = e.data.fattura;
          } else {
            _vue.uploadRearPercentage = 0;
            _vue.invoiceRear = '';
            _vue.invoiceRearBucket = '';
            _vue.UploadError();
            input.target.value = null;
            _vue.loadingState = false;
          }
        }).catch(function () {
          _vue.uploadRearPercentage = 0;
          _vue.invoiceRear = '';
          _vue.invoiceRearBucket = '';
          _vue.UploadError();
          input.target.value = null;
          _vue.loadingState = false;
        });
      }
    },

    enterPassword: function enterPassword(token) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var alert;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _this8.$swal({
                  title: 'Password',
                  html: 'Inserisci la password con cui ti sei registrato alla piattaforma. <br/>',
                  input: 'text',
                  type: 'info',
                  showCancelButton: true,
                  confirmButtonText: 'Entra',
                  cancelButtonText: 'Esci',
                  allowOutsideClick: false,
                  showLoaderOnConfirm: true,
                  preConfirm: function preConfirm(alert) {
                    if (alert == '') {
                      _this8.$swal.showValidationMessage('Il campo password richiesto');
                    } else {
                      //CHECK PASSWORD
                      return axios_default()({
                        url: "https://wsbot.eu/21005back/public/" + 'api/passwordControl',
                        method: 'POST',
                        data: {
                          'user_token': token,
                          'password': alert.trim()
                        },
                        headers: {
                          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                          'Content-type': 'application/json'
                        }
                      }).then(function (resp) {
                        console.log('QRcode CHECK PASSWORD => OK');
                        _this8.passwordControl = true;
                        return true;
                      }).catch(function (resp) {
                        _this8.passwordControl = false;
                        _this8.$swal.showValidationMessage('Password errata');
                        return false;
                      });
                    }
                  }
                });

              case 3:
                alert = _context6.sent;
                return _context6.abrupt('return', !!alert);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);
                return _context6.abrupt('return', false);

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 7]]);
      }))();
    }
  },
  watch: {
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },

    capSE: function capSE(val) {
      if (val) {
        this.capSE = val.replace(/\D+/g, '');
      }
    },

    mobile: function mobile(val) {
      if (val) {
        this.mobile = val.replace(/\D+/g, '');
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this9 = this;

      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = '';
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this9.cities = resp.data.cities;
          _this9.citiesState = false;
        }).catch(function (resp) {
          _this9.cities = [];
          _this9.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this10 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this10.zips = resp.data.zips;
          _this10.zipsState = false;
        }).catch(function (resp) {
          _this10.zips = [];
          _this10.zipsState = false;
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this11 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      var _vue;

      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:

              //http://localhost:8080/acceptInvoice?crt=38&t=9697a3c74a75d1393ce15644af776053
              console.log(_this11.$route);

              if (!(_this11.$route.query.crt && _this11.$route.query.t)) {
                _context10.next = 17;
                break;
              }

              console.log('QRcode ACCEPT INVOICE');

              _context10.next = 5;
              return _this11.enterPassword(_this11.$route.query.t);

            case 5:
              if (!_this11.passwordControl) {
                _context10.next = 16;
                break;
              }

              // CHECK USER TOKEN
              _this11.fromQRcode = true;
              _context10.next = 9;
              return _this11.checkUserToken(_this11.$route.query.t);

            case 9:
              if (!_this11.tokenControl) {
                _context10.next = 14;
                break;
              }

              // LOGIN USER
              localStorage.setItem('user-token', _this11.$route.query.t);

              _this11.$store.dispatch(auth["l" /* SET_USER_TOKEN */], _this11.$route.query.t);

              _context10.next = 14;
              return _this11.getPracticById(_this11.$route.query.t, _this11.$route.query.crt);

            case 14:
              _context10.next = 17;
              break;

            case 16:
              _this11.$router.push('/');

            case 17:

              if (_this11.$route.params.item) {
                _this11.item = _this11.$route.params.item;

                // CHECK IF ORDER OR PRACTICE
                if (_this11.$route.params.item.status == '0') {
                  console.log(0);
                  if (_this11.item && _this11.item.client_type != 'Amministratore di condominio') {
                    _this11.address = _this11.item.building_address;
                    _this11.civic = _this11.item.building_civic;

                    if (_this11.item.client_codice_fiscale) {
                      _this11.codice_fiscale = _this11.item.client_codice_fiscale;
                    }
                    if (_this11.item.client_partita_iva) {
                      _this11.partita_iva = _this11.item.client_partita_iva;
                    }

                    _this11.client_ownership = _this11.item.client_ownership;

                    // NEWWWWWW
                    if (_this11.item.client_owner_type) {
                      _this11.client_owner_type = _this11.item.client_owner_type;
                    }

                    if (_this11.item.client_owner_codice_fiscale) {
                      _this11.client_owner_codice_fiscale = _this11.item.client_owner_codice_fiscale;
                    }
                  }
                } else if (_this11.$route.params.item.status == '1') {
                  console.log(11);
                  _this11.$router.push({
                    name: 'loadDocuments',
                    params: {
                      item: _this11.item
                    }
                  });
                } else if (_this11.$route.params.item.status == '9') {
                  _this11.orderRemoved = true;
                } else {
                  _this11.$router.push('/pratiche');
                }
              } else {
                if (!_this11.tokenControl) {
                  _this11.$router.push('/offerte');
                }
              }

              _this11.populateProvincies();
              console.log(_this11.item);

              if (_this11.item && _this11.item.client_type != 'Amministratore di condominio') {
                _vue = _this11;


                console.log("SET REGION");

                setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                  var province;
                  return regenerator_default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          console.log("SET PROVINCE" + _vue.item.building_province);
                          province = _vue.item.building_province;
                          _context9.next = 4;
                          return _vue.setProvince(province);

                        case 4:
                          console.log("SET PROVINCE SUCCESS");

                          setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
                            var city;
                            return regenerator_default.a.wrap(function _callee8$(_context8) {
                              while (1) {
                                switch (_context8.prev = _context8.next) {
                                  case 0:
                                    console.log("SET CITY");
                                    city = _vue.item.building_city;
                                    _context8.next = 4;
                                    return _vue.setCity(city);

                                  case 4:
                                    console.log("SET CITY SUCCESS");

                                    setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                                      var cap;
                                      return regenerator_default.a.wrap(function _callee7$(_context7) {
                                        while (1) {
                                          switch (_context7.prev = _context7.next) {
                                            case 0:
                                              console.log("SET CAP");
                                              cap = _vue.item.building_zip;
                                              _context7.next = 4;
                                              return _vue.setCap(cap);

                                            case 4:
                                              console.log("SET CAP SUCCESS");

                                            case 5:
                                            case 'end':
                                              return _context7.stop();
                                          }
                                        }
                                      }, _callee7, this);
                                    })), 1500);

                                  case 6:
                                  case 'end':
                                    return _context8.stop();
                                }
                              }
                            }, _callee8, this);
                          })), 1500);

                        case 6:
                        case 'end':
                          return _context9.stop();
                      }
                    }
                  }, _callee9, this);
                })), 1500);
              }

              _this11.$scrollTo('#app', 700, {
                offset: -75
              });

            case 22:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this11);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1cdd68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acceptInvoice/index.vue
var acceptInvoice_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container  pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _vm.item.flow != "mbfacta_recovery"
                  ? _c("h3", { staticClass: "Regular h0 widthFull" }, [
                      _c("b", [
                        _vm._v(
                          "Conferma Preventivo N. " + _vm._s(_vm.item.code)
                        )
                      ])
                    ])
                  : _c("h3", { staticClass: "Regular h0 widthFull" }, [
                      _c("b", [
                        _vm._v("Conferma Pratica N. " + _vm._s(_vm.item.code))
                      ])
                    ]),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
                  _vm._v(
                    "\n\n        Verifica e completa i dati mancanti per la conferma del Preventivo\n      "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pb-5 pt-4  black vaillantCont widthFull",
                attrs: { id: "registration-form" }
              },
              [
                _vm.item.flow != "agileenergy"
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _c("div", { staticClass: "col-md-12" }, [
                          _vm.item.client_type != "Amministratore di condominio"
                            ? _c(
                                "h4",
                                { staticClass: "widthFull center black" },
                                [
                                  _vm._v(
                                    "\n            Completa i dati mancanti del cliente finale ("
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.item.client_name) +
                                        " " +
                                        _vm._s(_vm.item.client_lastname)
                                    )
                                  ]),
                                  _vm._v(")\n          ")
                                ]
                              )
                            : _c(
                                "h4",
                                { staticClass: "widthFull center black" },
                                [
                                  _vm._v(
                                    "\n            Completa i dati mancanti dell'Amministratore del condominio ("
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.item.client_name) +
                                        " " +
                                        _vm._s(_vm.item.client_lastname)
                                    )
                                  ]),
                                  _vm._v(")\n          ")
                                ]
                              )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.client_lastname,
                                    expression: "item.client_lastname"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 63, min: 2 },
                                    expression:
                                      "{required:true, max: 63, min: 2}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(
                                    "clientLastname"
                                  ),
                                  valid: !!_vm.item.client_lastname
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomq",
                                  id: "clientLastname",
                                  name: "clientLastname",
                                  "data-vv-as": "Cognome"
                                },
                                domProps: { value: _vm.item.client_lastname },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.item,
                                      "client_lastname",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "clientLastname" }
                                },
                                [_vm._v("Cognome *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("clientLastname")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first("clientLastname")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.client_name,
                                    expression: "item.client_name"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 63, min: 2 },
                                    expression:
                                      "{required:true, max: 63, min: 2}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("clientName"),
                                  valid: !!_vm.item.client_name
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomq",
                                  id: "clientName",
                                  name: "clientName",
                                  "data-vv-as": "Nome"
                                },
                                domProps: { value: _vm.item.client_name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.item,
                                      "client_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "clientName" }
                                },
                                [_vm._v("Nome *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("clientName")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first("clientName")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4 mb-3 " }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.client_email,
                                    expression: "item.client_email"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      email: true,
                                      temporaryEmail: true,
                                      plusIssueEmail: true,
                                      max: 56
                                    },
                                    expression:
                                      "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                  }
                                ],
                                ref: "email",
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("email"),
                                  valid: !!_vm.item.client_email
                                },
                                attrs: {
                                  type: "text",
                                  id: "email",
                                  name: "email",
                                  "data-vv-as": "Email"
                                },
                                domProps: { value: _vm.item.client_email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.item,
                                      "client_email",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "email" }
                                },
                                [_vm._v("Email* ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("email")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("email")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.item.client_type == "Persona fisica" ||
                        _vm.item.client_type == "Amministratore di condominio"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.codice_fiscale,
                                        expression: "codice_fiscale"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          codiceFiscale:
                                            _vm.codice_fiscale.length > 11
                                              ? true
                                              : false,
                                          partitaIva:
                                            _vm.codice_fiscale.length <= 11
                                              ? true
                                              : false,
                                          max: 16,
                                          min: 11
                                        },
                                        expression:
                                          "{required: true, codiceFiscale: codice_fiscale.length > 11 ? true : false , partitaIva: codice_fiscale.length <= 11 ? true : false,  max: 16, min: 11}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "codice_fiscale"
                                      ),
                                      valid: !!_vm.codice_fiscale
                                    },
                                    attrs: {
                                      type: "text",
                                      id: "codice_fiscale",
                                      name: "codice_fiscale",
                                      "data-vv-as": "Codice Fiscale"
                                    },
                                    domProps: { value: _vm.codice_fiscale },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.codice_fiscale = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "codice_fiscale" }
                                    },
                                    [_vm._v("Codice Fiscale *")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("codice_fiscale")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "codice_fiscale"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm.item.client_type == "Partita IVA"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.partita_iva,
                                        expression: "partita_iva"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          partitaIva: true,
                                          max: 11,
                                          min: 11
                                        },
                                        expression:
                                          "{required: true, partitaIva: true, max: 11, min: 11}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "partita_iva"
                                      ),
                                      valid: !!_vm.partita_iva
                                    },
                                    attrs: {
                                      type: "text",
                                      id: "partita_iva",
                                      name: "partita_iva",
                                      "data-vv-as": "Partita IVA"
                                    },
                                    domProps: { value: _vm.partita_iva },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.partita_iva = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "partita_iva" }
                                    },
                                    [_vm._v("Partita IVA *")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("partita_iva")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first("partita_iva")
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.client_phone,
                                    expression: "item.client_phone"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: _vm.item.client_mobile
                                        ? false
                                        : true,
                                      max: 12,
                                      min: 8,
                                      regex: /^[0,3]+/
                                    },
                                    expression:
                                      "{required: item.client_mobile ? false : true, max: 12, min: 8, regex: /^[0,3]+/}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("phone"),
                                  valid: !!_vm.item.client_phone
                                },
                                attrs: {
                                  type: "text",
                                  id: "phone",
                                  name: "phone",
                                  "data-vv-as": "Telefono"
                                },
                                domProps: { value: _vm.item.client_phone },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.item,
                                      "client_phone",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "phone" }
                                },
                                [_vm._v("Telefono ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("phone")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("phone")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.client_mobile,
                                    expression: "item.client_mobile"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: _vm.item.client_phone
                                        ? false
                                        : true,
                                      max: 12,
                                      min: 8,
                                      regex: /^[0,3]+/
                                    },
                                    expression:
                                      "{required: item.client_phone ? false : true, max: 12, min: 8, regex: /^[0,3]+/}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("mobile"),
                                  valid: !!_vm.item.client_mobile
                                },
                                attrs: {
                                  type: "text",
                                  id: "mobile",
                                  name: "mobile",
                                  "data-vv-as": "Cellulare"
                                },
                                domProps: { value: _vm.item.client_mobile },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.item,
                                      "client_mobile",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "mobile" }
                                },
                                [_vm._v("Cellulare * ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("mobile")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("mobile")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center pb-5 " }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "group custInput",
                        class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.client_owner_type,
                                expression: "client_owner_type"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 123, min: 2 },
                                expression: "{required:true, max: 123, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has(
                                "form-1.client_owner_type"
                              ),
                              valid: !!_vm.client_owner_type
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomq",
                              id: "client_owner_type",
                              name: "client_owner_type",
                              "data-vv-as": "Titolo di possesso"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.client_owner_type = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "Proprietario o comproprietario"
                                }
                              },
                              [_vm._v("Proprietario o comproprietario")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Detentore o co-detentore" } },
                              [
                                _vm._v(
                                  "Detentore o co-detentore (es. locatario, comodatario, usufruttuario, ecc.)"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Familiare convivente" } },
                              [
                                _vm._v(
                                  "Familiare convivente con il possessore o con il detentore"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.client_type == "Amministratore di condominio"
                              ? _c(
                                  "option",
                                  { attrs: { value: "Condominio" } },
                                  [_vm._v("Condominio")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "client_owner_type" }
                          },
                          [_vm._v("Titolo di possesso / diritto reale *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("form-1.client_owner_type")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.errors.first("form-1.client_owner_type")
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.client_owner_type != "Proprietario o comproprietario" &&
                  _vm.client_owner_type != ""
                    ? _c("div", { staticClass: "col-md-6 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.client_owner_codice_fiscale,
                                  expression: "client_owner_codice_fiscale"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    partitaIva:
                                      _vm.client_owner_codice_fiscale.length ==
                                      11
                                        ? true
                                        : false,
                                    codiceFiscale:
                                      _vm.client_owner_codice_fiscale.length ==
                                      16
                                        ? true
                                        : false,
                                    max:
                                      _vm.client_owner_codice_fiscale.length <
                                      11
                                        ? 16
                                        : 16,
                                    min:
                                      _vm.client_owner_codice_fiscale.length >
                                      11
                                        ? 16
                                        : 11
                                  },
                                  expression:
                                    "{required:true, partitaIva: client_owner_codice_fiscale.length == 11 ? true : false, codiceFiscale: client_owner_codice_fiscale.length == 16 ? true : false, max: client_owner_codice_fiscale.length < 11 ? 16 : 16, min: client_owner_codice_fiscale.length > 11 ? 16 : 11}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "client_owner_codice_fiscale"
                                ),
                                valid: !!_vm.client_owner_codice_fiscale
                              },
                              attrs: {
                                type: "text",
                                autocomplete: "randomq",
                                "data-vv-validate-on": "blur",
                                id: "client_owner_codice_fiscale",
                                name: "client_owner_codice_fiscale",
                                "data-vv-as":
                                  "P.IVA o codice fiscale del proprietario"
                              },
                              domProps: {
                                value: _vm.client_owner_codice_fiscale
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.client_owner_codice_fiscale =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _vm._m(1),
                            _vm._v(" "),
                            _vm.errors.has("client_owner_codice_fiscale")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "client_owner_codice_fiscale"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black" }, [
                      _vm._v(
                        "\n            Indirizzo dell'immobile oggetto dell'intervento: "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.item.building_address) +
                            " " +
                            _vm._s(_vm.item.building_civic) +
                            " - " +
                            _vm._s(_vm.item.building_zip) +
                            " " +
                            _vm._s(_vm.item.building_city) +
                            " (" +
                            _vm._s(_vm.item.building_province) +
                            ")"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.item.client_type !=
                    "Amministratore di condominio" /*&& item.to_get_cadastral_data != '1'*/
                      ? _c(
                          "h4",
                          { staticClass: "widthFull center black pb-0" },
                          [
                            _vm._v(
                              "\n            Dati Catastali dell'immobile oggetto dell'intervento\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.to_get_cadastral_data == "1"
                      ? _c("p", { staticClass: "center red" }, [
                          _vm._v(
                            "\n            Se disponibili, compila le seguenti informazioni per una migliore ricerca:\n          "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                   true /* item.client_type != 'Amministratore di condominio' && item.to_get_cadastral_data != '1'*/
                    ? _c("div", { staticClass: "col-md-2 mb-3 " }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.foglio,
                                  expression: "foglio"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required:
                                      _vm.item.to_get_cadastral_data != "1"
                                        ? true
                                        : false,
                                    max: 10,
                                    min: 1
                                  },
                                  expression:
                                    "{required:item.to_get_cadastral_data != '1' ? true : false,  max: 10, min: 1}"
                                }
                              ],
                              ref: "foglio",
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("foglio"),
                                valid: !!_vm.foglio
                              },
                              attrs: {
                                type: "text",
                                id: "foglio",
                                name: "foglio",
                                "data-vv-as": "foglio"
                              },
                              domProps: { value: _vm.foglio },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.foglio = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "foglio" }
                              },
                              [
                                _vm._v("Foglio "),
                                _vm.item.to_get_cadastral_data != "1"
                                  ? [_vm._v("*")]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.errors.has("foglio")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("foglio")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                   true /*item.client_type != 'Amministratore di condominio' /*&& item.to_get_cadastral_data != '1'*/
                    ? _c("div", { staticClass: "col-md-2 mb-3 " }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.particella,
                                  expression: "particella"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required:
                                      _vm.item.to_get_cadastral_data != "1"
                                        ? true
                                        : false,
                                    max: 10,
                                    min: 1
                                  },
                                  expression:
                                    "{required:item.to_get_cadastral_data != '1' ? true : false, max: 10, min: 1}"
                                }
                              ],
                              ref: "particella",
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("particella"),
                                valid: !!_vm.particella
                              },
                              attrs: {
                                type: "text",
                                id: "particella",
                                name: "particella",
                                "data-vv-as": "particella"
                              },
                              domProps: { value: _vm.particella },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.particella = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "particella" }
                              },
                              [
                                _vm._v("Particella "),
                                _vm.item.to_get_cadastral_data != "1"
                                  ? [_vm._v("*")]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.errors.has("particella")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("particella")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                   true /*item.client_type != 'Amministratore di condominio' /*&& item.to_get_cadastral_data != '1'*/
                    ? _c("div", { staticClass: "col-md-2 mb-3 " }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.subalterno,
                                  expression: "subalterno"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required:
                                      _vm.item.to_get_cadastral_data != "1"
                                        ? true
                                        : false,
                                    max: 10,
                                    min: 1
                                  },
                                  expression:
                                    "{required: item.to_get_cadastral_data != '1' ? true : false, max: 10, min: 1}"
                                }
                              ],
                              ref: "subalterno",
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("subalterno"),
                                valid: !!_vm.subalterno
                              },
                              attrs: {
                                type: "text",
                                id: "subalterno",
                                name: "subalterno",
                                "data-vv-as": "subalterno"
                              },
                              domProps: { value: _vm.subalterno },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.subalterno = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "subalterno" }
                              },
                              [
                                _vm._v("Subalterno "),
                                _vm.item.to_get_cadastral_data != "1"
                                  ? [_vm._v("*")]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.errors.has("subalterno")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("subalterno")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.item.flow != "agileenergy"
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _c("div", { staticClass: "col-md-12" }, [
                          _vm.item.client_type != "Partita IVA"
                            ? _c(
                                "h4",
                                { staticClass: "widthFull center black pb-4" },
                                [
                                  _vm._v(
                                    "\n            Indirizzo di residenza del cliente ( solo se diverso dall'indirizzo dell'immobile oggetto dell'intervento )\n          "
                                  )
                                ]
                              )
                            : _c(
                                "h4",
                                { staticClass: "widthFull center black pb-4" },
                                [
                                  _vm._v(
                                    "\n            Indirizzo Sede Legale ( solo se diverso dall'indirizzo dell'immobile oggetto dell'intervento  )\n          "
                                  )
                                ]
                              )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.province,
                                      expression: "province"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true },
                                      expression: "{required:true}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("province"),
                                    valid: !!_vm.province
                                  },
                                  attrs: {
                                    autocomplete: "randomy",
                                    id: "province",
                                    name: "province",
                                    "data-vv-as": "Provincia"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.province = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c("option", {
                                    attrs: {
                                      disabled: "",
                                      value: "",
                                      selected: "selected"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      key: 2341253542,
                                      domProps: { value: "SE" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                STATO ESTERO\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.provincies, function(province) {
                                    return _c(
                                      "option",
                                      {
                                        key: province.sigla,
                                        domProps: { value: province.sigla }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(province.sigla) +
                                            " - " +
                                            _vm._s(province.provincia) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "province" }
                                },
                                [_vm._v("Provincia *")]
                              ),
                              _vm._v(" "),
                              _vm.provinciesState
                                ? _c(
                                    "div",
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "loadSpinner",
                                        attrs: {
                                          id: "loadProvince",
                                          icon: "spinner",
                                          size: "1x",
                                          pulse: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("province")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("province")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _vm.cityError
                                ? _c("span", { staticClass: "formError" }, [
                                    _vm._v("Prima scegli Provincia")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.province != "SE"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.city,
                                          expression: "city"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: { required: true },
                                          expression: "{required:true}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has("city"),
                                        valid: !!_vm.city
                                      },
                                      attrs: {
                                        autocomplete: "randomu",
                                        id: "city",
                                        name: "city",
                                        "data-vv-as": "Località",
                                        disabled: _vm.citiesState
                                      },
                                      on: {
                                        click: _vm.checkProvince,
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.city = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c("option", {
                                        attrs: {
                                          disabled: "",
                                          value: "",
                                          selected: "selected"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.cities, function(city) {
                                        return _c(
                                          "option",
                                          {
                                            key: city.comune,
                                            domProps: {
                                              value: {
                                                cityistat: city.istat,
                                                city: city.comune
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(city.comune) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.citySE,
                                        expression: "citySE"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: { required: true },
                                        expression: "{required:true}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has("citySE"),
                                      valid: !!_vm.citySE
                                    },
                                    attrs: {
                                      autocomplete: "randomu",
                                      id: "citySE",
                                      name: "citySE",
                                      "data-vv-as": "Località",
                                      disabled: _vm.citiesState
                                    },
                                    domProps: { value: _vm.citySE },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.citySE = $event.target.value
                                      }
                                    }
                                  }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _vm.province != "SE"
                                ? _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "city" }
                                    },
                                    [_vm._v("Località *")]
                                  )
                                : _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "city" }
                                    },
                                    [_vm._v("Località e Paese*")]
                                  ),
                              _vm._v(" "),
                              _vm.citiesState
                                ? _c(
                                    "div",
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "loadSpinner",
                                        attrs: {
                                          id: "loadCity",
                                          icon: "spinner",
                                          size: "1x",
                                          pulse: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("city")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("city")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("citySE")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("citySE")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _vm.zipError
                                ? _c("span", { staticClass: "formError" }, [
                                    _vm._v("Prima scegli città")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.province != "SE"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.zip,
                                          expression: "zip"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: { required: true },
                                          expression: "{required:true}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has("zip"),
                                        valid: !!_vm.zip
                                      },
                                      attrs: {
                                        autocomplete: "randomi",
                                        id: "zip",
                                        name: "zip",
                                        "data-vv-as": "CAP",
                                        disabled: _vm.zipsState
                                      },
                                      on: {
                                        click: _vm.checkZip,
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.zip = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c("option", {
                                        attrs: { value: "", disabled: "" },
                                        domProps: { selected: true }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.zips, function(zip) {
                                        return _c(
                                          "option",
                                          {
                                            key: zip.cap,
                                            domProps: { value: zip.cap }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(zip.cap) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.capSE,
                                        expression: "capSE"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          min: 5,
                                          max: 5
                                        },
                                        expression:
                                          "{required:true, min:5, max:5}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has("capSE"),
                                      valid: !!_vm.capSE
                                    },
                                    attrs: {
                                      autocomplete: "randomi",
                                      id: "capSE",
                                      name: "capSE",
                                      "data-vv-as": "CAP",
                                      disabled: _vm.zipsState
                                    },
                                    domProps: { value: _vm.capSE },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.capSE = $event.target.value
                                      }
                                    }
                                  }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "zip" }
                                },
                                [_vm._v("CAP *")]
                              ),
                              _vm._v(" "),
                              _vm.zipsState
                                ? _c(
                                    "div",
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "loadSpinner",
                                        attrs: {
                                          id: "loadZips",
                                          icon: "spinner",
                                          size: "1x",
                                          pulse: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("zip")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("zip")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("capSE")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("capSE")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.address,
                                    expression: "address"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 5 },
                                    expression:
                                      "{required:true, max: 128, min: 5}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("address"),
                                  valid: !!_vm.address
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomq",
                                  id: "address",
                                  name: "address",
                                  "data-vv-as": "Indirizzo"
                                },
                                domProps: { value: _vm.address },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.address = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "address" }
                                },
                                [_vm._v("Indirizzo *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("address")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("address")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.civic,
                                    expression: "civic"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 15, min: 1 },
                                    expression:
                                      "{required:true, max: 15, min: 1}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("civic"),
                                  valid: !!_vm.civic
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomq",
                                  id: "civic",
                                  name: "civic",
                                  "data-vv-as": "N. Civico"
                                },
                                domProps: { value: _vm.civic },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.civic = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "civic" }
                                },
                                [_vm._v("N. Civico *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("civic")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("civic")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center pb-5 " }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _vm.item.flow != "agileenergy"
                      ? _c("h4", { staticClass: "widthFull center black" }, [
                          _vm._v(
                            "\n            Carica il Preventivo accettato e firmato dal cliente\n          "
                          )
                        ])
                      : _c("h4", { staticClass: "widthFull center black" }, [
                          _vm._v("\n            Carica il  Contratto "),
                          _c("br"),
                          _vm._v(" per la fornitura e l’installazione "),
                          _c("br"),
                          _vm._v(" firmato dal Cliente\n          ")
                        ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "center" }, [
                      _vm._v(
                        "\n            Se necessario è possibile caricare piu file\n            ( formati: JPG, PNG, PDF. )\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "front-image" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              size: 10240,
                              ext: ["jpeg", "jpg", "png", "pdf"],
                              mimes: [
                                "image/jpeg",
                                "image/jpg",
                                "image/png",
                                "application/pdf"
                              ]
                            },
                            expression:
                              "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                          }
                        ],
                        ref: "fileInput",
                        staticClass: "fileInput",
                        class: {
                          "is-invalid": _vm.errors.has("invoiceFront"),
                          valid: !!_vm.invoiceFront,
                          helper: !!_vm.invoiceFrontBucket
                        },
                        attrs: {
                          type: "file",
                          multiple: "",
                          name: "invoiceFront",
                          id: "invoiceFront",
                          "data-vv-as":
                            _vm.item.flow != "agileenergy"
                              ? "Preventivo accettato e firmato dal cliente"
                              : "Contratto per la fornitura e l’installazione"
                        },
                        on: { change: _vm.uploadFile }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel labelFileInput",
                          attrs: { for: "invoiceFront" }
                        },
                        [
                          !_vm.invoiceFrontName
                            ? _c(
                                "span",
                                {
                                  staticClass: "smallText center white",
                                  style: {
                                    backgroundImage:
                                      "url(" + _vm.invoiceFrontBucket + ")"
                                  }
                                },
                                [
                                  !_vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0"
                                        },
                                        [_vm._v("Scegli il Contratto quadro*")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _c("span", {
                                staticClass: "smallText center white",
                                style: {
                                  backgroundImage:
                                    "url(" + _vm.invoiceFrontBucket + ")"
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("invoiceFront")
                        ? _c(
                            "div",
                            {
                              staticClass: "invalid-feedback",
                              staticStyle: { top: "185px" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.first("invoiceFront")) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploadFrontPercentage
                        ? _c(
                            "div",
                            {
                              staticClass: "progress mt-5",
                              attrs: { id: "progFront" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress-bar ",
                                  style: {
                                    width: _vm.uploadFrontPercentage + "%"
                                  },
                                  attrs: {
                                    id: "progress-bar-front",
                                    role: "progressbar",
                                    "aria-valuenow": "50",
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.uploadFrontPercentage) +
                                      " %\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoiceFrontName
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "smallText center white mt-3 mb-0 pb-0 fileNameText"
                            },
                            [_vm._v(_vm._s(_vm.invoiceFrontName))]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.item.flow == "agileenergy"
                    ? _c("div", { staticClass: "col-md-6" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("p", { staticClass: "center" }, [
                          _vm._v(
                            "\n            Se necessario è possibile caricare piu file\n            ( formati: JPG, PNG, PDF. )\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "front-image" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  size: 10240,
                                  ext: ["jpeg", "jpg", "png", "pdf"],
                                  mimes: [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/pdf"
                                  ]
                                },
                                expression:
                                  "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                              }
                            ],
                            ref: "fileInput2",
                            staticClass: "fileInput2",
                            class: {
                              "is-invalid": _vm.errors.has("invoiceRear"),
                              valid: !!_vm.invoiceRear,
                              helper: !!_vm.invoiceRearBucket
                            },
                            attrs: {
                              type: "file",
                              multiple: "",
                              name: "invoiceRear",
                              id: "invoiceRear",
                              "data-vv-as": "Lettera di Affidamento"
                            },
                            on: { change: _vm.uploadFile2 }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel labelFileInput",
                              attrs: { for: "invoiceRear" }
                            },
                            [
                              !_vm.invoiceRearName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceRearBucket + ")"
                                      }
                                    },
                                    [
                                      !_vm.invoiceRearName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "smallText center white mt-3 mb-0 pb-0"
                                            },
                                            [
                                              _vm._v(
                                                "Scegli il Contratto quadro*"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "smallText center white",
                                    style: {
                                      backgroundImage:
                                        "url(" + _vm.invoiceRearBucket + ")"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("invoiceRear")
                            ? _c(
                                "div",
                                {
                                  staticClass: "invalid-feedback",
                                  staticStyle: { top: "185px" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("invoiceRear")) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.uploadRearPercentage
                            ? _c(
                                "div",
                                {
                                  staticClass: "progress mt-5",
                                  attrs: { id: "progRear" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar ",
                                      style: {
                                        width: _vm.uploadRearPercentage + "%"
                                      },
                                      attrs: {
                                        id: "progress-bar-front",
                                        role: "progressbar",
                                        "aria-valuenow": "50",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.uploadRearPercentage) +
                                          " %\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceRearName
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                },
                                [_vm._v(_vm._s(_vm.invoiceRearName))]
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 mt-5 mb-3 center" }, [
                    _vm.invoiceFrontBucket
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.invoiceFrontBucket,
                              target: "_blank"
                            }
                          },
                          [
                            _vm.invoiceFrontBucket.substring(
                              _vm.invoiceFrontBucket.lastIndexOf(".") + 1,
                              _vm.invoiceFrontBucket.length
                            ) == "pdf"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "center widthFull pdfLink",
                                    attrs: {
                                      href: _vm.invoiceFrontBucket,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("APRI PDF")]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 center mt-5 pt-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btnRed",
                        attrs: { type: "button" },
                        on: { click: _vm.convertToPractice }
                      },
                      [_vm._v("Procedi")]
                    )
                  ])
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [
                  _vm._v("Accetta preventivo N. " + _vm._s(_vm.item.code))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "black mt-0 text-center widthFull" }, [
                _vm._v(
                  "\n        Hai completatto correttamente la pratica.\n      "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.orderRemoved
        ? _c("div", { staticClass: "container pt-5 mt-5 " }, [
            _c(
              "div",
              {
                staticClass: "row justify-content-center text-left vaillantCont"
              },
              [
                _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                  _c("b", [
                    _vm._v("ATTENZIONE! "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" Preventivo N. " + _vm._s(_vm.item.code) + " "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" è stato eliminato ")
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-center widthFull" })
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var acceptInvoice_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Conferma la titolarità dell'immobile oggetto dell'intervento\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel",
        attrs: { for: "client_owner_codice_fiscale" }
      },
      [
        _vm._v(" P.Iva o Codice Fiscale "),
        _c("small", [_vm._v(" del proprietario dell'immobile *")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "widthFull center black" }, [
      _vm._v("\n            Carica la Lettera di Affidamento "),
      _c("br"),
      _vm._v(" firmata e timbrata dall'installatore "),
      _c("br"),
      _vm._v(" professionista in subappalto\n          ")
    ])
  }
]
acceptInvoice_render._withStripped = true
var acceptInvoice_esExports = { render: acceptInvoice_render, staticRenderFns: acceptInvoice_staticRenderFns }
/* harmony default export */ var components_acceptInvoice = (acceptInvoice_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a1cdd68", acceptInvoice_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/acceptInvoice/index.vue
var acceptInvoice_disposed = false
function acceptInvoice_injectStyle (ssrContext) {
  if (acceptInvoice_disposed) return
  __webpack_require__("MPp2")
}
var acceptInvoice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var acceptInvoice___vue_template_functional__ = false
/* styles */
var acceptInvoice___vue_styles__ = acceptInvoice_injectStyle
/* scopeId */
var acceptInvoice___vue_scopeId__ = "data-v-3a1cdd68"
/* moduleIdentifier (server only) */
var acceptInvoice___vue_module_identifier__ = null
var acceptInvoice_Component = acceptInvoice_normalizeComponent(
  acceptInvoice,
  components_acceptInvoice,
  acceptInvoice___vue_template_functional__,
  acceptInvoice___vue_styles__,
  acceptInvoice___vue_scopeId__,
  acceptInvoice___vue_module_identifier__
)
acceptInvoice_Component.options.__file = "src/components/acceptInvoice/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a1cdd68", acceptInvoice_Component.options)
  } else {
    hotAPI.reload("data-v-3a1cdd68", acceptInvoice_Component.options)
  }
  module.hot.dispose(function (data) {
    acceptInvoice_disposed = true
  })
})()}

/* harmony default export */ var src_components_acceptInvoice = (acceptInvoice_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/viewerjs/dist/viewer.css
var viewer = __webpack_require__("N1kN");
var viewer_default = /*#__PURE__*/__webpack_require__.n(viewer);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loadDocuments/stripe.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var stripe_moment = __webpack_require__("PJh5");

/* harmony default export */ var loadDocuments_stripe = ({
  name: 'stripe',
  components: {
    //StripeCheckout
  },
  props: {
    practice: String,
    userToken: String,
    items: Array,
    invoiceNumber: String,
    amount: String,
    PaypalOn: Boolean,
    flow: String,
    sepaOn: Boolean,
    discount: String,
    discountValue: String,
    dl: String
  },
  data: function data() {
    return {
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      error: '',
      loadingState: false,
      loading: false,
      moment: __webpack_require__("PJh5"),
      show_card: false,
      //STRIPE
      pk: "pk_live_51IWlkuFvWaF7faquM24pga2twdVliRJfhlnI4ouPn0mDKxbfpmt1263bQrP8hX2gUucBTDCEYkgrOwxwKJkZtBsA00V62GVWSX",
      front_url: "https://chebonus.it/",
      iva: Object({"NODE_ENV":"production","BRAND":"CHEBONUS","REGISTRATION":true,"CONTACT_PHONE":"02 9475 6677","CONTACT_EMAIL":"info@chebonus.it","CONTACT_PHONE_HSD":"02 9475 1001","CONTACT_EMAIL_HSD":"info@happybonus.it","FRONT_END_URL":"https://chebonus.it/","PRACTIC_PRICE":220,"PRACTIC_PRICE_OLD":160,"FINANCE_COST":17,"FLOW_POSTE_ACTIVE":false,"FLOW_POSTE_NOT_ACTIVE_TEXT":"Al momento il flusso Poste Italiane è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di Poste Italiane.","PRACTIC_PRICE_CDP":240,"PRACTIC_PRICE_CDP_OLD":230,"FINANCE_COST_CDP":12.5,"FLOW_CDP_ACTIVE":false,"FLOW_CDP_NOT_ACTIVE_TEXT":"Al momento il flusso CDP è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di CDP.","PRACTIC_PRICE_GENERAL":240,"PRACTIC_PRICE_GENERAL_OLD":230,"FINANCE_COST_GENERAL":40,"MIN_DISPOSAL_PRICE_GENERAL":10000,"PRACTIC_PRICE_MBFACTA":240,"PRACTIC_PRICE_MBFACTA_OLD":230,"FINANCE_COST_MBFACTA":16.5,"MIN_DISPOSAL_PRICE_MBFACTA":10000,"FLOW_MBFACTA_ACTIVE":false,"FLOW_MBFACTA_NOT_ACTIVE_TEXT":"Al momento il flusso ISTITUTO DI CREDITO non è ancora attivo. <br/> ","PRACTIC_PRICE_MBFACTA_RECOVERY":220,"PRACTIC_PRICE_MBFACTA_RECOVERY_OLD":210,"FINANCE_COST_MBFACTA_RECOVERY":16.5,"MIN_DISPOSAL_PRICE_MBFACTA_RECOVERY":10000,"FLOW_MBFACTA_RECOVERY_ACTIVE":false,"FLOW_MBFACTA_RECOVERY_NOT_ACTIVE_TEXT":"Al momento il flusso PERSONALIZZATO non è ancora attivo. <br/> ","PRACTIC_PRICE_AGILEENERGY":240,"PRACTIC_PRICE_AGILEENERGY_OLD":230,"FINANCE_COST_AGILEENERGY":19,"MIN_DISPOSAL_PRICE_AGILEENERGY":10000,"FLOW_AE_ACTIVE":false,"FLOW_AE_NOT_ACTIVE_TEXT":"Al momento il flusso Agile Energy non è ancora attivo. <br/> ","IBAN_AGILE_ENERGY":"IT25J0306933911100000014182","AGILEENERGY_SERVICE_COST_LEVEL_1":300,"AGILEENERGY_SERVICE_COST_LEVEL_2":300,"AGILEENERGY_SERVICE_COST_LEVEL_3":300,"AGILEENERGY_DISCOUNT":false,"AGILEENERGY_DISCOUNT_VALUE":0.7,"MIN_FOR_OLD_FLOW":10000,"PRICE_ENEA":50,"PRICE_DCAST":10,"PRACTIC_VISTO":50,"MIN_DISPOSAL_PRICE_CDP":75000,"MIN_DISPOSAL_PRICE_POSTE":2000,"PAYPAL_ENV":"PROD","STRIPE_PUBLISHABLE_KEY":"pk_live_51IWlkuFvWaF7faquM24pga2twdVliRJfhlnI4ouPn0mDKxbfpmt1263bQrP8hX2gUucBTDCEYkgrOwxwKJkZtBsA00V62GVWSX","PAYPAL_PRODUCT_ID":"PROD-91F89027CU5537934","PAYPAL_ID":"AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX","PAYPAL_SECRET":"EAmjv8eEUKp0-UQg9-x5hqPVCDi5pDsAl147g50IdCLsV3fH9Dc9yAxDTIinzHRH_Zi4KQWK03TT-SA7","ROOT_API":"https://wsbot.eu/21005back/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","START":"2021-02-15 00:00:00","FINISH":"2030-12-15 23:59:59","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).IVA,
      buyPlan: {
        price: 220,
        iva: 220 * 0.22,
        amount: 220 + 220 * 0.22,
        amount_enea: parseFloat(220 + 220 * 0.22 + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(220 + 220 * 0.22 + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(220 + 220 * 0.22 + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2
      }

    };
  },

  methods: {
    // composer require stripe/stripe-php
    create_stripe_session: function create_stripe_session() {
      var _this = this;

      this.loadingState = true;
      // Create an instance of the Stripe object with your publishable API key
      var stripe = Stripe(this.pk);

      if (this.discountValue != 0 && this.discountValue != '0') {
        var data = {
          userToken: this.userToken,
          practice: this.practice,
          items: this.items,
          amount: this.amount,
          invoiceNumber: this.invoiceNumber,
          pk: this.pk,
          errorUrl: "https://chebonus.it/" + 'paymentError/' + this.practice + '?discount=' + this.discount + '&discountValue=' + this.discountValue,
          successUrl: "https://chebonus.it/" + 'paymentSuccess/' + this.practice + '?discount=' + this.discount + '&discountValue=' + this.discountValue
        };
      } else {

        var data = {
          userToken: this.userToken,
          practice: this.practice,
          items: this.items,
          amount: this.amount,
          invoiceNumber: this.invoiceNumber,
          pk: this.pk,
          errorUrl: "https://chebonus.it/" + 'paymentError/' + this.practice,
          successUrl: "https://chebonus.it/" + 'paymentSuccess/' + this.practice
        };
      }

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/create-stripe-checkout-session',
        method: 'POST',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this.loadingState = false;
        console.log(resp.data);
        return stripe.redirectToCheckout({
          sessionId: resp.data.status.id
        });
      }).catch(function (resp) {

        _this.loadingState = false;
        _this.showAlert();
      });
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ci dispiace! Riprova piu tardi'
      });
    }
  },
  watch: {},
  created: function created() {
    var _this2 = this;

    this.$loadScript("https://js.stripe.com/v3/").then(function () {
      _this2.loadButtons = false;
    }).catch(function () {
      // Failed to fetch script
    });
  },
  mounted: function mounted() {

    if (this.dl == 'old') {
      // OLD FLOW
      var practicPrice = this.$route.params.item.flow == 'poste' ? 160 : 230;
      var visto = 0;
    } else {
      // NEW FLOW
      var practicPrice = this.$route.params.item.flow == 'poste' ? 220 : 240;
      var visto = 50;
    }

    var price = parseFloat(practicPrice + visto - this.discountValue);

    this.buyPlan = {
      price: practicPrice,
      iva: practicPrice * 0.22 + visto * 0.22,
      amount: practicPrice + 50 * 1.22 + practicPrice * 0.22,
      amount_enea: parseFloat(practicPrice + 50 * 1.22 + practicPrice * 0.22 + 50 * 1.22).toFixed(2),
      amount_dcast: parseFloat(practicPrice + 50 * 1.22 + practicPrice * 0.22 + 10 * 1.22).toFixed(2),
      amount_enea_dcast: parseFloat(practicPrice + 50 * 1.22 + practicPrice * 0.22 + 50 * 1.22 + 10 * 1.22).toFixed(2),
      priceEnea: 50,
      visto: visto,
      ivaEnea: 11,
      priceDcast: 10,
      ivaDcast: 2.2
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3e6f9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/stripe.vue
var stripe_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull center pt-1 pb-3" }, [
    _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _c("div", { staticClass: "col-md-11  center" }, [
        _vm.PaypalOn
          ? _c("h4", { staticClass: "center" }, [
              _c("b", [
                _vm._v("Oppure puoi pagare con la tua carta "),
                _vm.sepaOn
                  ? _c("span", [_vm._v("o addebito diretto SEPA")])
                  : _vm._e()
              ])
            ])
          : _c("h4", { staticClass: "center" }, [
              _c("b", [
                _vm._v("Paga con la tua carta "),
                _vm.sepaOn
                  ? _c("span", [_vm._v("o con addebito bancario diretto SEPA")])
                  : _vm._e()
              ])
            ]),
        _vm._v(" "),
        _vm.sepaOn
          ? _c("img", {
              staticClass: "img-fluid widthFull mb-3 mt-3",
              attrs: { src: __webpack_require__("5uEW") }
            })
          : _c("img", {
              staticClass: "img-fluid widthFull mb-3 mt-3",
              attrs: { src: __webpack_require__("vr5u") }
            })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8  center" }, [
        !_vm.show_card
          ? _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", id: "checkout-button" },
                on: { click: _vm.create_stripe_session }
              },
              [_vm._v(" Procedi ")]
            )
          : _vm._e()
      ])
    ])
  ])
}
var stripe_staticRenderFns = []
stripe_render._withStripped = true
var stripe_esExports = { render: stripe_render, staticRenderFns: stripe_staticRenderFns }
/* harmony default export */ var components_loadDocuments_stripe = (stripe_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c3e6f9a", stripe_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/loadDocuments/stripe.vue
var stripe_disposed = false
function stripe_injectStyle (ssrContext) {
  if (stripe_disposed) return
  __webpack_require__("QHXV")
}
var stripe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var stripe___vue_template_functional__ = false
/* styles */
var stripe___vue_styles__ = stripe_injectStyle
/* scopeId */
var stripe___vue_scopeId__ = "data-v-4c3e6f9a"
/* moduleIdentifier (server only) */
var stripe___vue_module_identifier__ = null
var stripe_Component = stripe_normalizeComponent(
  loadDocuments_stripe,
  components_loadDocuments_stripe,
  stripe___vue_template_functional__,
  stripe___vue_styles__,
  stripe___vue_scopeId__,
  stripe___vue_module_identifier__
)
stripe_Component.options.__file = "src/components/loadDocuments/stripe.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c3e6f9a", stripe_Component.options)
  } else {
    hotAPI.reload("data-v-4c3e6f9a", stripe_Component.options)
  }
  module.hot.dispose(function (data) {
    stripe_disposed = true
  })
})()}

/* harmony default export */ var src_components_loadDocuments_stripe = (stripe_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loadDocuments/paypal_nt.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var paypal_nt_moment = __webpack_require__("PJh5");

/* harmony default export */ var paypal_nt = ({
  name: 'paypal_nt',
  components: {
    //StripeCheckout
  },
  props: {
    practice: String,
    userToken: String,
    locale: String,
    currency: String,
    items: Array,
    invoiceNumber: String,
    amount: String,
    PaypalOn: Boolean,
    flow: String,
    sepaOn: Boolean,
    dl: String

  },
  data: function data() {
    var _ref;

    return _ref = {
      client_token: '',
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      error: '',
      loadingState: false,
      loading: false,
      moment: __webpack_require__("PJh5"),
      show_card: false,
      //STRIPE
      pk: "pk_live_51IWlkuFvWaF7faquM24pga2twdVliRJfhlnI4ouPn0mDKxbfpmt1263bQrP8hX2gUucBTDCEYkgrOwxwKJkZtBsA00V62GVWSX",
      front_url: "https://chebonus.it/",
      iva: Object({"NODE_ENV":"production","BRAND":"CHEBONUS","REGISTRATION":true,"CONTACT_PHONE":"02 9475 6677","CONTACT_EMAIL":"info@chebonus.it","CONTACT_PHONE_HSD":"02 9475 1001","CONTACT_EMAIL_HSD":"info@happybonus.it","FRONT_END_URL":"https://chebonus.it/","PRACTIC_PRICE":220,"PRACTIC_PRICE_OLD":160,"FINANCE_COST":17,"FLOW_POSTE_ACTIVE":false,"FLOW_POSTE_NOT_ACTIVE_TEXT":"Al momento il flusso Poste Italiane è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di Poste Italiane.","PRACTIC_PRICE_CDP":240,"PRACTIC_PRICE_CDP_OLD":230,"FINANCE_COST_CDP":12.5,"FLOW_CDP_ACTIVE":false,"FLOW_CDP_NOT_ACTIVE_TEXT":"Al momento il flusso CDP è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di CDP.","PRACTIC_PRICE_GENERAL":240,"PRACTIC_PRICE_GENERAL_OLD":230,"FINANCE_COST_GENERAL":40,"MIN_DISPOSAL_PRICE_GENERAL":10000,"PRACTIC_PRICE_MBFACTA":240,"PRACTIC_PRICE_MBFACTA_OLD":230,"FINANCE_COST_MBFACTA":16.5,"MIN_DISPOSAL_PRICE_MBFACTA":10000,"FLOW_MBFACTA_ACTIVE":false,"FLOW_MBFACTA_NOT_ACTIVE_TEXT":"Al momento il flusso ISTITUTO DI CREDITO non è ancora attivo. <br/> ","PRACTIC_PRICE_MBFACTA_RECOVERY":220,"PRACTIC_PRICE_MBFACTA_RECOVERY_OLD":210,"FINANCE_COST_MBFACTA_RECOVERY":16.5,"MIN_DISPOSAL_PRICE_MBFACTA_RECOVERY":10000,"FLOW_MBFACTA_RECOVERY_ACTIVE":false,"FLOW_MBFACTA_RECOVERY_NOT_ACTIVE_TEXT":"Al momento il flusso PERSONALIZZATO non è ancora attivo. <br/> ","PRACTIC_PRICE_AGILEENERGY":240,"PRACTIC_PRICE_AGILEENERGY_OLD":230,"FINANCE_COST_AGILEENERGY":19,"MIN_DISPOSAL_PRICE_AGILEENERGY":10000,"FLOW_AE_ACTIVE":false,"FLOW_AE_NOT_ACTIVE_TEXT":"Al momento il flusso Agile Energy non è ancora attivo. <br/> ","IBAN_AGILE_ENERGY":"IT25J0306933911100000014182","AGILEENERGY_SERVICE_COST_LEVEL_1":300,"AGILEENERGY_SERVICE_COST_LEVEL_2":300,"AGILEENERGY_SERVICE_COST_LEVEL_3":300,"AGILEENERGY_DISCOUNT":false,"AGILEENERGY_DISCOUNT_VALUE":0.7,"MIN_FOR_OLD_FLOW":10000,"PRICE_ENEA":50,"PRICE_DCAST":10,"PRACTIC_VISTO":50,"MIN_DISPOSAL_PRICE_CDP":75000,"MIN_DISPOSAL_PRICE_POSTE":2000,"PAYPAL_ENV":"PROD","STRIPE_PUBLISHABLE_KEY":"pk_live_51IWlkuFvWaF7faquM24pga2twdVliRJfhlnI4ouPn0mDKxbfpmt1263bQrP8hX2gUucBTDCEYkgrOwxwKJkZtBsA00V62GVWSX","PAYPAL_PRODUCT_ID":"PROD-91F89027CU5537934","PAYPAL_ID":"AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX","PAYPAL_SECRET":"EAmjv8eEUKp0-UQg9-x5hqPVCDi5pDsAl147g50IdCLsV3fH9Dc9yAxDTIinzHRH_Zi4KQWK03TT-SA7","ROOT_API":"https://wsbot.eu/21005back/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","START":"2021-02-15 00:00:00","FINISH":"2030-12-15 23:59:59","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).IVA,
      buyPlan: {
        price: 220,
        iva: 220 * 0.22,
        amount: 220 + 220 * 0.22,
        amount_enea: parseFloat(220 + 220 * 0.22 + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(220 + 220 * 0.22 + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(220 + 220 * 0.22 + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2
      },
      credentials: {
        sandbox: "AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX",
        production: "AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX"
        // SECRET ENSsI2hX79egH1CKfDNPQnf0SskbcGt0r9GRiVDwNMArGz2HAMP6c3-960hpQka2gXob5GzcDbAUNlfY
      },
      cartVisibile: false,
      ppButtonVisibile: false
    }, defineProperty_default()(_ref, 'loadingState', false), defineProperty_default()(_ref, 'orderId', false), defineProperty_default()(_ref, 'orderData', {}), defineProperty_default()(_ref, 'showCardPayButton', false), defineProperty_default()(_ref, 'cardClass', ''), _ref;
  },

  methods: {
    showPaypal: function showPaypal() {
      console.warn(' showPaypal ', !this.ppButtonVisibile);
      if (this.cartVisibile) {
        this.cartVisibile = false;
      }
      this.ppButtonVisibile = !this.ppButtonVisibile;
      this.create_paypal_client_token();
    },
    showCart: function showCart() {
      console.warn(' showCart ', !this.cartVisibile);
      if (this.ppButtonVisibile) {
        this.ppButtonVisibile = false;
      }
      this.cartVisibile = !this.cartVisibile;
      this.create_paypal_client_token();
    },

    create_order: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(source) {
        var items, _vue, x, item, pr, unit_ammount, item_total, breakdown, order, dataX;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                items = [];
                _vue = this;


                _vue.orderId = false;

                for (x in _vue.items) {
                  item = {};

                  item.name = _vue.items[x].name;
                  item.description = _vue.items[x].description;
                  pr = _vue.items[x].price;
                  unit_ammount = {
                    currency_code: _vue.currency,
                    value: parseFloat(pr).toFixed(2)

                    //item.tax = tax
                  };
                  item.unit_amount = unit_ammount;
                  item.quantity = _vue.items[x].quantity;
                  item.category = 'DIGITAL_GOODS';

                  items.push(item);
                }

                item_total = {
                  currency_code: _vue.currency,
                  value: parseFloat(_vue.amount).toFixed(2)
                };
                breakdown = {
                  item_total: item_total
                };
                order = {
                  intent: "CAPTURE",
                  purchase_units: [{
                    reference_id: _vue.invoiceNumber,
                    description: _vue.invoiceNumber,
                    invoice_id: _vue.invoiceNumber,
                    custom_id: _vue.practice,
                    soft_descriptor: _vue.getProfile.partita_iva,
                    amount: {
                      currency_code: _vue.currency,
                      value: parseFloat(_vue.amount).toFixed(2),
                      breakdown: breakdown
                    },
                    items: items
                  }],
                  application_context: {
                    "shipping_preference": "NO_SHIPPING"
                  }
                };
                dataX = {
                  practice: _vue.practice,
                  pratica: _vue.practice,
                  userToken: _vue.userToken,
                  locale: _vue.locale,
                  //currency: this.currency,
                  items: _vue.items,
                  invoiceNumber: _vue.invoiceNumber,
                  //amount: this.amount,
                  PaypalOn: _vue.PaypalOn,
                  flow: _vue.flow,
                  sepaOn: _vue.sepaOn,
                  dl: _vue.dl,
                  client_token: _vue.client_token,
                  env:  false ? '.sandbox' : '',
                  key:  false ? _vue.credentials.sandbox : _vue.credentials.production,
                  order: order
                };
                return _context.abrupt('return', axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/create_paypal_order',
                  method: 'POST',
                  data: dataX,
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _vue.loadingState = false;

                  if (resp.data.token.id) {
                    _vue.orderId = resp.data.token.id;
                    return resp.data.token.id;
                  } else {
                    _vue.showAlert();
                    return false;
                  }

                  //return data.id;
                }).catch(function (resp) {

                  _vue.loadingState = false;
                  _vue.showAlert();
                  return false;
                }));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create_order(_x) {
        return _ref2.apply(this, arguments);
      }

      return create_order;
    }(),
    capture_order: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(orderID, source) {
        var _vue, xd;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("ORDER:", orderID);

                _vue = this;

                _vue.loadingState = true;
                _vue.orderData = {};
                _context2.next = 6;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/capture_paypal_order',
                  method: 'POST',
                  data: {
                    order_id: orderID,
                    card: source == 'cart' ? true : false,
                    pratica: _vue.practice,
                    env:  false ? '.sandbox' : '',
                    key:  false ? _vue.credentials.sandbox : _vue.credentials.production
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _vue.loadingState = false;

                  if (resp.data.token) {
                    var errorDetail = Array.isArray(resp.data.token.details) && resp.data.token.details[0];

                    if (errorDetail && errorDetail.issue === 'DUPLICATE_INVOICE_ID') {
                      _vue.showAlert();
                      return false;
                    } else if (resp.data.token.id) {
                      // ALL OK
                      console.warn(' CAPTURE ORDER FUNCTION => OK', resp.data.token);
                      if (resp.data.token.status) {
                        if (resp.data.token.status == 'COMPLETED' || resp.data.token.status == 'APPROVED') {
                          var res = resp.data.token;
                          res.cart = source == 'cart' ? 'YES' : 'NO';

                          if (!res.payer) {
                            if (res.payment_source) {

                              if (res.payment_source.card) {
                                var payer = {
                                  name: {
                                    given_name: res.payment_source.card.brand,
                                    surname: res.payment_source.card.type
                                  },
                                  email_address: res.payment_source.card.last_digits,
                                  payer_id: "CARD_PAYMENT",
                                  address: {
                                    country_code: "IT"
                                  }
                                };
                              } else {
                                var payer = {
                                  name: {
                                    given_name: 'UNDEFINED',
                                    surname: 'UNDEFINED'
                                  },
                                  email_address: 'UNDEFINED',
                                  payer_id: "UNDEFINED_PAYMENT",
                                  address: {
                                    country_code: "IT"
                                  }
                                };
                              }

                              res.payer = payer;
                            }
                          }

                          res.payer.payment_method = source == 'cart' ? 'PAYPAL_CART' : 'PAYPAL_FORM';
                          _vue.$emit('paymentPPSuccess', res);
                        }
                      }

                      _vue.orderData = resp.data.token;
                      return resp.data.token;
                    } else {
                      _vue.loadingState = false;
                      return false;
                      _vue.showAlert();
                    }
                    _vue.loadingState = false;
                  } else {
                    _vue.loadingState = false;
                    return false;
                    _vue.showAlert();
                  }
                  //return data.id;
                }).catch(function (resp) {
                  console.error(' CAPTURE ORDER CATCH => ', resp);
                  return false;
                  _vue.loadingState = false;
                  _vue.showAlert();
                });

              case 6:
                xd = _context2.sent;
                return _context2.abrupt('return', xd);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function capture_order(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return capture_order;
    }(),
    paypal_render_buttons: function paypal_render_buttons() {
      var _vue = this;
      //let orderId;

      // PP BUTTONS
      if (_vue.ppButtonVisibile) {
        // BUTTON HANDLER
        paypal.Buttons({
          createOrder: function createOrder(data, actions) {
            _vue.loadingState = true;

            return _vue.create_order('button');
          },
          onApprove: function onApprove(data, actions) {

            return _vue.capture_order(data.orderID, 'button');
          }
        }).render('#paypal-button-container');
      } else {

        // PP CARD
        // If this returns false or the card fields aren't visible, see Step #1.
        if (paypal.HostedFields.isEligible()) {
          // Renders card fields
          paypal.HostedFields.render({
            // Call your server to set up the transaction
            createOrder: function createOrder() {
              return _vue.create_order('card');
            },
            styles: {
              '.valid': {
                'color': 'green'
              },
              '.invalid': {
                'color': 'red'
              }
            },
            fields: {
              number: {
                selector: "#card-number",
                placeholder: "4111 1111 1111 1111"
              },
              cvv: {
                selector: "#cvv",
                placeholder: "123"
              },
              expirationDate: {
                selector: "#expiration-date",
                placeholder: "MM/YY"
              }
            }
          }).then(function (cardFields) {
            var _this = this;

            cardFields.on('validityChange', function (event) {
              //console.log('CCF Event "validityChange", state='+cardFields.getState() + ",event=" + event);
              // Check if all fields are valid, then show submit button
              var formValid = keys_default()(event.fields).every(function (key) {
                return event.fields[key].isValid;
              });

              if (formValid) {
                _vue.showCardPayButton = true;
              } else {
                _vue.showCardPayButton = false;
              }
            });

            cardFields.on('cardTypeChange', function (event) {
              console.log('CCF Event "cardTypeChange", state=' + cardFields.getState() + ",event=" + event);
              console.log(event);

              // Change card bg depending on card type
              if (event.cards.length === 1) {
                _vue.cardClass = event.cards[0].type;
              }
            });

            document.querySelector("#button-pay").addEventListener('click', function (event) {
              event.preventDefault();
              _vue.loadingState = true;
              console.warn(' CLICK CARD PAY BUTTON ', cardFields);
              cardFields.submit({
                // Cardholder's first and last name
                // Trigger 3D Secure authentication
                contingencies: ['3D_SECURE'],
                cardholderName: document.getElementById('card-holder-name').value
                // Billing Address
                /*billingAddress: {
                  // Street address, line 1
                  streetAddress: document.getElementById('card-billing-address-street').value,
                  // Street address, line 2 (Ex: Unit, Apartment, etc.)
                  extendedAddress: document.getElementById('card-billing-address-unit').value,
                  // State
                  region: document.getElementById('card-billing-address-state').value,
                  // City
                  locality: document.getElementById('card-billing-address-city').value,
                  // Postal Code
                  postalCode: document.getElementById('card-billing-address-zip').value,
                  // Country Code
                  countryCodeAlpha2: document.getElementById('card-billing-address-country').value
                }*/
              }).then(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                var orderData, errorDetail, msg;
                return regenerator_default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _vue.capture_order(_vue.orderId, 'cart');

                      case 2:
                        orderData = _context3.sent;

                        if (!orderData) {
                          _context3.next = 18;
                          break;
                        }

                        //var orderData =  _vue.orderData
                        _vue.loadingState = true;
                        console.warn(' orderData => ', orderData);
                        // Three cases to handle:
                        //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                        //   (2) Other non-recoverable errors -> Show a failure message
                        //   (3) Successful transaction -> Show confirmation or thank you

                        // This example reads a v2/checkout/orders capture response, propagated from the server
                        // You could use a different API or structure for your 'orderData'
                        errorDetail = Array.isArray(orderData.details) && orderData.details[0];

                        if (!(errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED')) {
                          _context3.next = 9;
                          break;
                        }

                        return _context3.abrupt('return', actions.restart());

                      case 9:
                        if (!errorDetail) {
                          _context3.next = 15;
                          break;
                        }

                        msg = 'Sorry, your transaction could not be processed.';

                        if (errorDetail.description) msg += '\n\n' + errorDetail.description;
                        if (orderData.debug_id) msg += ' (' + orderData.debug_id + ')';
                        _vue.showAlert(msg);
                        return _context3.abrupt('return', alert(msg));

                      case 15:

                        // Show a success message or redirect
                        console.warn('Transaction completed!');

                        /*fetch('/your-server/api/order/' + orderId + '/capture/', {
                          method: 'post'
                        }).then(function(res) {
                          return res.json();
                        }).then(function(orderData) {
                         })*/
                        _context3.next = 20;
                        break;

                      case 18:
                        _vue.loadingState = false;
                        _vue.showAlert();

                      case 20:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this);
              }))).catch(function (err) {
                _vue.loadingState = false;
                _vue.showAlert();
                console.warn('Payment could not be captured! ' + stringify_default()(err));
              });
            });
          });
        } else {
          // Hides card fields if the merchant isn't eligible
          //document.querySelector("#card-form").style = 'display: none';
        }
      }
    },
    create_paypal_client_token: function create_paypal_client_token() {
      var _this2 = this;

      this.loadingState = true;
      // Create an instance of the Stripe object with your publishable API key

      if (false) {
        var data = {
          key: this.credentials.sandbox,
          env: '.sandbox'
        };
      } else {
        var data = {
          key: this.credentials.production,
          env: ''
        };
      }

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/create_paypal_client_token',
        method: 'POST',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {

        if (resp.data.token) {
          _this2.client_token = resp.data.token;
          _this2.loadPayPalScript(resp.data.token);
        }
      }).catch(function (resp) {

        _this2.loadingState = false;
      });
    },
    loadPayPalScript: function loadPayPalScript(val) {
      var _this3 = this;

      this.$loadScript("https://www.paypal.com/sdk/js?components=hosted-fields,buttons,funding-eligibility&client-id=" + "AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX" + '&currency=EUR&disable-funding=mybank&enable-funding=sofort', {
        'data-client-token': val
      }).then(function () {
        //this.loadButtons = false
        console.warn(' PAYPAL OK ');
        _this3.loadingState = false;
        _this3.paypal_render_buttons();
      }).catch(function () {
        // Failed to fetch script
        _this3.loadingState = false;
        console.error(' PAYPAL ERROR AUTH ');
      });
    },
    showAlert: function showAlert() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // Use sweetalret2

      if (text) {
        var msg = text;
      } else {
        var msg = 'Ci dispiace! Riprova piu tardi';
      }

      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: msg
      });
    }
  },
  watch: {},
  created: function created() {

    if (false) {
      this.envPP = 'sandbox';
    }
  },
  mounted: function mounted() {

    this.showPaypal();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b2d0d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/paypal_nt.vue
var paypal_nt_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-1 pb-3" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center pb-3" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "row justify-content-center pb-3" }, [
              _c(
                "div",
                {
                  staticClass: "col-6",
                  class: { underlineBox: _vm.cartVisibile }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "pointer small  Bold",
                      on: {
                        click: function($event) {
                          return _vm.showCart()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "img-fluid widthFull payImage mb-2",
                        attrs: {
                          src: __webpack_require__("zbSp")
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-6",
                  class: { underlineBox: _vm.ppButtonVisibile }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "pointer small Bold",
                      on: {
                        click: function($event) {
                          return _vm.showPaypal()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "img-fluid widthFull payImage mb-2 mt-2",
                        attrs: {
                          src: __webpack_require__("nIi4")
                        }
                      })
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "radio " }, [
                _vm.ppButtonVisibile
                  ? _c(
                      "div",
                      {
                        staticClass: "pp-container center",
                        attrs: { id: "pp-container" }
                      },
                      [
                        _c("div", { attrs: { id: "paypal-button-container" } }),
                        _vm._v(" "),
                        _vm._m(0)
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "radio " }, [
                _vm.cartVisibile
                  ? _c(
                      "div",
                      {
                        staticClass: "form-container",
                        attrs: { id: "form-container" }
                      },
                      [
                        _c("div", {
                          attrs: { id: "payments-sdk__contingency-lightbox" }
                        }),
                        _vm._v(" "),
                        _c(
                          "form",
                          { staticClass: "center", attrs: { id: "my-form" } },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "cardinfo-card-number" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "cardinfo-label text-left Bold",
                                  attrs: { for: "card-number" }
                                },
                                [_vm._v("Numero Carta")]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "input-wrapper ",
                                attrs: { id: "card-number" }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                class: _vm.cardClass,
                                attrs: { id: "card-image" }
                              })
                            ]),
                            _vm._v(" "),
                            _vm._m(2),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showCardPayButton,
                                  expression: "showCardPayButton"
                                }
                              ],
                              staticClass: "show-button",
                              attrs: {
                                id: "button-pay",
                                type: "button",
                                value: "Paga"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var paypal_nt_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "small2 mt-4" }, [
      _c("b", [_vm._v("SOFORT")]),
      _vm._v(" un sistema di pagamento Europeo per eseguire "),
      _c("b", [_vm._v("Bonifici Diretti")]),
      _vm._v(
        "\n                utilizzando le proprie credenziali bancarie online per trasferire denaro dal proprio conto bancario nella massima sicurezza.\n              "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-holder-name" }, [
      _c(
        "label",
        {
          staticClass: "cardinfo-label text-left Bold",
          attrs: { for: "card-holder-label" }
        },
        [_vm._v("Titolare Carta")]
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "input-wrapper widthFull p-4",
        attrs: {
          type: "text",
          id: "card-holder-name",
          name: "card-holder-name",
          autocomplete: "off",
          placeholder: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cardinfo-wrapper" }, [
      _c("div", { staticClass: "cardinfo-exp-date" }, [
        _c(
          "label",
          {
            staticClass: "cardinfo-label text-left Bold",
            attrs: { for: "expiration-date" }
          },
          [_vm._v("Scadenza")]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "input-wrapper ",
          attrs: { id: "expiration-date" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cardinfo-cvv" }, [
        _c(
          "label",
          {
            staticClass: "cardinfo-label text-left Bold",
            attrs: { for: "cvv" }
          },
          [_vm._v("CVV")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-wrapper ", attrs: { id: "cvv" } })
      ])
    ])
  }
]
paypal_nt_render._withStripped = true
var paypal_nt_esExports = { render: paypal_nt_render, staticRenderFns: paypal_nt_staticRenderFns }
/* harmony default export */ var loadDocuments_paypal_nt = (paypal_nt_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31b2d0d5", paypal_nt_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/loadDocuments/paypal_nt.vue
var paypal_nt_disposed = false
function paypal_nt_injectStyle (ssrContext) {
  if (paypal_nt_disposed) return
  __webpack_require__("pc4f")
}
var paypal_nt_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var paypal_nt___vue_template_functional__ = false
/* styles */
var paypal_nt___vue_styles__ = paypal_nt_injectStyle
/* scopeId */
var paypal_nt___vue_scopeId__ = "data-v-31b2d0d5"
/* moduleIdentifier (server only) */
var paypal_nt___vue_module_identifier__ = null
var paypal_nt_Component = paypal_nt_normalizeComponent(
  paypal_nt,
  loadDocuments_paypal_nt,
  paypal_nt___vue_template_functional__,
  paypal_nt___vue_styles__,
  paypal_nt___vue_scopeId__,
  paypal_nt___vue_module_identifier__
)
paypal_nt_Component.options.__file = "src/components/loadDocuments/paypal_nt.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31b2d0d5", paypal_nt_Component.options)
  } else {
    hotAPI.reload("data-v-31b2d0d5", paypal_nt_Component.options)
  }
  module.hot.dispose(function (data) {
    paypal_nt_disposed = true
  })
})()}

/* harmony default export */ var components_loadDocuments_paypal_nt = (paypal_nt_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loadDocuments/index.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var loadDocuments_moment = __webpack_require__("PJh5");

var loadDocuments_viewer = __webpack_require__("EAZf");

//import { StripeCheckout } from '@vue-stripe/vue-stripe'



var rand = Math.floor(Math.random() * 10000);

// GET DOC LIST

//import documentsOR from '../../components/documents/documents.js'
//import documents_cdpOR from '../../components/documents/documents_cdp.js'

//import documentsOROld from '../../components/documents/documentsOld.js'
//import documents_cdpOROld from '../../components/documents/documents_cdpOld.js'

/* harmony default export */ var loadDocuments = ({
  name: 'loadDocuments',
  components: {
    //StripeCheckout
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    stripePayment: src_components_loadDocuments_stripe,
    paypalPayment: components_loadDocuments_paypal_nt
  },
  data: function data() {
    return {
      brand: "CHEBONUS",
      token: '',
      preSend: false,
      icons: {
        opened: '<img class="img-fluid widthFull sssIcon" src="' + __webpack_require__("/TeD") + '" >',
        closed: '<img class="img-fluid widthFull sssIcon" src="' + __webpack_require__("8r3S") + '" >'
      },
      discount: '',
      enea_cpid: '',
      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      cellulare: '',
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: {},
      client_ownership: '',
      subalterno: '',
      particella: '',
      savedDocuments: {},
      foglio: '',
      documents: {}, //this.$route.params.item.flow == 'poste' ? documentsOR : documents_cdpOR,
      //documents: {},
      payment: false,
      paypalOn: true,
      sepaOn: false,
      paymentTypeD: '',
      paid: '',
      autoRenewD: '',
      priceIvaC: '',
      priceIvaA: '',
      priceIfYearSubIva: '',
      priceIva: '',

      //STRIPE
      pk: "pk_live_51IWlkuFvWaF7faquM24pga2twdVliRJfhlnI4ouPn0mDKxbfpmt1263bQrP8hX2gUucBTDCEYkgrOwxwKJkZtBsA00V62GVWSX",
      front_url: "https://chebonus.it/",
      iva: Object({"NODE_ENV":"production","BRAND":"CHEBONUS","REGISTRATION":true,"CONTACT_PHONE":"02 9475 6677","CONTACT_EMAIL":"info@chebonus.it","CONTACT_PHONE_HSD":"02 9475 1001","CONTACT_EMAIL_HSD":"info@happybonus.it","FRONT_END_URL":"https://chebonus.it/","PRACTIC_PRICE":220,"PRACTIC_PRICE_OLD":160,"FINANCE_COST":17,"FLOW_POSTE_ACTIVE":false,"FLOW_POSTE_NOT_ACTIVE_TEXT":"Al momento il flusso Poste Italiane è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di Poste Italiane.","PRACTIC_PRICE_CDP":240,"PRACTIC_PRICE_CDP_OLD":230,"FINANCE_COST_CDP":12.5,"FLOW_CDP_ACTIVE":false,"FLOW_CDP_NOT_ACTIVE_TEXT":"Al momento il flusso CDP è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di CDP.","PRACTIC_PRICE_GENERAL":240,"PRACTIC_PRICE_GENERAL_OLD":230,"FINANCE_COST_GENERAL":40,"MIN_DISPOSAL_PRICE_GENERAL":10000,"PRACTIC_PRICE_MBFACTA":240,"PRACTIC_PRICE_MBFACTA_OLD":230,"FINANCE_COST_MBFACTA":16.5,"MIN_DISPOSAL_PRICE_MBFACTA":10000,"FLOW_MBFACTA_ACTIVE":false,"FLOW_MBFACTA_NOT_ACTIVE_TEXT":"Al momento il flusso ISTITUTO DI CREDITO non è ancora attivo. <br/> ","PRACTIC_PRICE_MBFACTA_RECOVERY":220,"PRACTIC_PRICE_MBFACTA_RECOVERY_OLD":210,"FINANCE_COST_MBFACTA_RECOVERY":16.5,"MIN_DISPOSAL_PRICE_MBFACTA_RECOVERY":10000,"FLOW_MBFACTA_RECOVERY_ACTIVE":false,"FLOW_MBFACTA_RECOVERY_NOT_ACTIVE_TEXT":"Al momento il flusso PERSONALIZZATO non è ancora attivo. <br/> ","PRACTIC_PRICE_AGILEENERGY":240,"PRACTIC_PRICE_AGILEENERGY_OLD":230,"FINANCE_COST_AGILEENERGY":19,"MIN_DISPOSAL_PRICE_AGILEENERGY":10000,"FLOW_AE_ACTIVE":false,"FLOW_AE_NOT_ACTIVE_TEXT":"Al momento il flusso Agile Energy non è ancora attivo. <br/> ","IBAN_AGILE_ENERGY":"IT25J0306933911100000014182","AGILEENERGY_SERVICE_COST_LEVEL_1":300,"AGILEENERGY_SERVICE_COST_LEVEL_2":300,"AGILEENERGY_SERVICE_COST_LEVEL_3":300,"AGILEENERGY_DISCOUNT":false,"AGILEENERGY_DISCOUNT_VALUE":0.7,"MIN_FOR_OLD_FLOW":10000,"PRICE_ENEA":50,"PRICE_DCAST":10,"PRACTIC_VISTO":50,"MIN_DISPOSAL_PRICE_CDP":75000,"MIN_DISPOSAL_PRICE_POSTE":2000,"PAYPAL_ENV":"PROD","STRIPE_PUBLISHABLE_KEY":"pk_live_51IWlkuFvWaF7faquM24pga2twdVliRJfhlnI4ouPn0mDKxbfpmt1263bQrP8hX2gUucBTDCEYkgrOwxwKJkZtBsA00V62GVWSX","PAYPAL_PRODUCT_ID":"PROD-91F89027CU5537934","PAYPAL_ID":"AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX","PAYPAL_SECRET":"EAmjv8eEUKp0-UQg9-x5hqPVCDi5pDsAl147g50IdCLsV3fH9Dc9yAxDTIinzHRH_Zi4KQWK03TT-SA7","ROOT_API":"https://wsbot.eu/21005back/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","START":"2021-02-15 00:00:00","FINISH":"2030-12-15 23:59:59","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).IVA,
      practiceprice: (this.$route.params.item.flow == 'poste' ? 220 : 240) + 50,

      buyPlan: {
        price: this.$route.params.item.flow == 'poste' ? 220 : 240,
        iva: (this.$route.params.item.flow == 'poste' ? 220 : 240) * 0.22 + 50 * 0.22,
        amount: (this.$route.params.item.flow == 'poste' ? 220 : 240) + 50 * 1.22 + (this.$route.params.item.flow == 'poste' ? 220 : 240) * 0.22,
        amount_enea: parseFloat((this.$route.params.item.flow == 'poste' ? 220 : 240) + 50 * 1.22 + (this.$route.params.item.flow == 'poste' ? 220 : 240) * 0.22 + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat((this.$route.params.item.flow == 'poste' ? 220 : 240) + 50 * 1.22 + (this.$route.params.item.flow == 'poste' ? 220 : 240) * 0.22 + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat((this.$route.params.item.flow == 'poste' ? 220 : 240) + 50 * 1.22 + (this.$route.params.item.flow == 'poste' ? 220 : 240) * 0.22 + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        visto: 50,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2,
        discountValue: 0,
        discount: ''
      },
      buyPlan2: {
        price: this.$route.params.item.flow == 'poste' ? 60 : 10,
        iva: (this.$route.params.item.flow == 'poste' ? 60 : 10) * 0.22 + 50 * 0.22,
        amount: (this.$route.params.item.flow == 'poste' ? 60 : 10) + 50 * 1.22 + (this.$route.params.item.flow == 'poste' ? 60 : 10) * 0.22,
        visto: 50,
        discountValue: 0,
        discount: '',
        type: 'additionalPayment'
      },
      billingType: false,
      autoReNew: false,
      envPP: '',
      credentials: {
        sandbox: "AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX",
        production: "AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX"
      },
      experienceOptions: {
        input_fields: {
          no_shipping: 1
        }
      },
      paySuccess: false,
      PPAUTHTOKEN: false,
      loadButtons: false,
      loaded: false,
      concluded: false,
      discountError: false,
      discountValue: 0,
      paypalDiscountString: '',
      dl: 0,
      additionalPayment: false,
      paySuccess2: false
    };
  },

  methods: {
    precompileDocument: function precompileDocument(doc, user, practice) {
      var _this = this;

      var _vue = this;
      _vue.loadingState = true;
      var data = {
        document: doc,
        user: user,
        practice: practice
      };

      console.log(data);

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/precompileDocumentTemplate',
        method: 'POST',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _vue.loadingState = false;
        console.log(resp.data.document);
        window.open(resp.data.document, '_blank').focus();
      }).catch(function (error) {

        _vue.loadingState = false;
        _this.showAlert();
      });
    },
    changeDL: function changeDL(val) {
      var _this2 = this;

      var _vue = this;
      console.log(val);
      _vue.loadingState = true;
      var data = {
        code: _vue.item.code,
        user_token: _vue.item.user_token,
        dl: val
      };

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/changeDL',
        method: 'POST',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _vue.dl = val;
        _vue.item.dl = val;
        _vue.loadingState = false;
      }).catch(function (error) {

        _vue.loadingState = false;
        _this2.showAlert();
      });
    },
    saveCpid: function saveCpid() {
      var _this3 = this;

      if (this.enea_cpid) {
        var hasError = false;
        var _vue = this;
        for (var x in this.$validator.errors.items) {
          if (this.$validator.errors.items[x] == "enea_cpid") {
            hasError == true;
          }
        }

        if (hasError) {
          this.$validator.validate().then(function (valid) {});
        } else {

          _vue.loadingState = true;
          var data = {
            code: _vue.item.code,
            user_token: _vue.item.user_token,
            enea_cpid: this.enea_cpid
          };

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/savePracticeCpid',
            method: 'POST',
            data: data,
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {

            _vue.item.enea_cpid = _this3.enea_cpid;
            _vue.loadingState = false;
          }).catch(function (error) {

            _vue.loadingState = false;
            _this3.showAlert();
          });
        }
      } else {
        this.$validator.validate().then(function (valid) {});
      }
    },
    preSendPracticeToKPMG: function preSendPracticeToKPMG() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _vue, hasVisura, hasEnea, x;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _vue = _this4;

                // SEARCH VISURA

                hasVisura = false;
                hasEnea = false;


                console.log('HAS VISURA');
                console.log(_this4.savedDocuments);

                for (x in _this4.savedDocuments) {
                  if (_this4.savedDocuments[x].codice == '2050D11') {
                    hasVisura = true;
                  }
                }
                for (x in _this4.savedDocuments) {
                  if (_this4.savedDocuments[x].codice == '2050D15') {
                    hasEnea = true;
                  }
                }

                console.log('hasVisura :' + hasVisura);
                if ((_this4.item.to_get_cadastral_data == '1' && hasVisura == true || _this4.item.to_get_cadastral_data == '0') && (_this4.item.enea_request == '1' && hasEnea == true || _this4.item.enea_request == '0')) {

                  _this4.$validator.validate().then(function () {
                    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(valid) {
                      var _vue, p;

                      return regenerator_default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _vue = _this4;

                              _this4.concluded = true;

                              for (p in _vue.uploadFrontPercentage) {
                                if (!_vue.uploadFrontPercentage[p]['completed'] && _vue.uploadFrontPercentage[p]['mandatory'] == 'yes') {
                                  _this4.concluded = false;
                                }
                              }

                              if (!_this4.concluded) {
                                _context.next = 13;
                                break;
                              }

                              _context.t0 = _this4;
                              _context.next = 7;
                              return _vue.addWorkingDay(loadDocuments_moment(), 5);

                            case 7:
                              _context.t1 = _context.sent;
                              _context.t2 = '<h4 class=" white">Controlla di aver caricato correttamente tutti i documenti e che gli stessi siano ben visibili. La validazione della pratica dipende anche dalla completezza del set documentale e sarà verificata entro ' + _context.t1;
                              _context.t3 = _context.t2 + '. Clicca su procedi per inviare la pratica in verifica.</h4>';

                              _context.t4 = function onClose() {
                                _vue.preSend = true;
                              };

                              _context.t5 = {
                                type: 'warning',
                                title: '<strong class="modalText white">Attenzione </strong>',
                                html: _context.t3,
                                confirmButtonText: 'CHIUDI',
                                confirmButtonColor: '#15267',
                                onClose: _context.t4
                              };

                              _context.t0.$swal.call(_context.t0, _context.t5);

                            case 13:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this4);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                } else {

                  if (_this4.item.enea_request == '1' && _this4.item.aditional_enea_data == null || _this4.item.aditional_enea_data == '') {
                    _this4.$swal({
                      type: 'warning',
                      title: '<strong class="modalText white">Attenzione! </strong>',
                      html: '<h4 class=" white">Per procedere, compila i dati per redigere e inviare la Pratica ENEA cliccando sul pulsate "Inserisci Dati"  ',
                      confirmButtonText: 'CHIUDI',
                      confirmButtonColor: '#15267'
                    });
                  } else {
                    _this4.sendPracticeToKPMG();
                  }
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    addWorkingDay: function addWorkingDay(date, days) {
      var daysToAdd = days;
      var today = date;
      var nextWeekStart = today.clone().add(1, 'week').weekday(1);
      var weekEnd = today.clone().weekday(5);

      var daysTillWeekEnd = Math.max(0, weekEnd.diff(today, 'days'));
      if (daysTillWeekEnd >= daysToAdd) return today.clone().add(daysToAdd, 'days');

      daysToAdd = daysToAdd - daysTillWeekEnd - 1;

      return loadDocuments_moment(nextWeekStart.add(Math.floor(daysToAdd / 5), 'week').add(daysToAdd % 5, 'days')).format('DD-MM-YYYY');
    },
    checkDiscount: function checkDiscount() {
      var _this5 = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this5.loadingState = true;
          _this5.discountError = false;
          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/checkDiscountCode',
            method: 'POST',
            data: {
              discount: _this5.discount,
              userToken: _this5.getProfile.userToken,
              user: _this5.getProfile,
              practice: _this5.$route.params.item
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            _this5.loadingState = false;
            var value = resp.data.value;
            if (value) {
              _this5.discountValue = parseFloat(value.replace(',', '.')).toFixed(2);
              _this5.recalcPrices('discount');
            }
          }).catch(function (error) {
            _this5.loadingState = false;
            _this5.discountError = true;
          });
        }
      });
    },
    recalcPrices: function recalcPrices(val) {

      var practicPrice = 0;
      var visto = 0;

      // NEW DL
      if (this.item.dl == 'new') {
        visto = 50;
      } else {
        visto = 0;
      }

      //practicPrice = 160
      if (this.item.flow == 'poste') {
        if (this.item.dl == 'new') {
          practicPrice = 220;
        } else {
          practicPrice = 160;
        }
      } else if (this.item.flow == 'cdp') {
        if (this.item.dl == 'new') {
          practicPrice = 240;
        } else {
          practicPrice = 230;
        }
      } else if (this.item.flow == 'general') {

        if (this.item.dl == 'new') {
          practicPrice = 240;
        } else {
          practicPrice = 230;
        }
      } else if (this.item.flow == 'agileenergy') {

        if (this.item.dl == 'new') {
          practicPrice = 240;
        } else {
          practicPrice = 230;
        }
      } else if (this.item.flow == 'mbfacta') {

        if (this.item.dl == 'new') {
          practicPrice = 240;
        } else {
          practicPrice = 230;
        }
      } else if (this.item.flow == 'mbfacta_recovery') {

        if (this.item.dl == 'new') {
          practicPrice = 220;
        } else {
          practicPrice = 210;
        }
      }

      var price = parseFloat(practicPrice + visto - this.discountValue);
      console.log(price);

      if (val == 'discount') {
        this.paypalDiscountString = '?discount=' + this.discount + '&discountValue=' + this.discountValue;
        var discountValue = this.discountValue;
        var discount = this.discount;
      } else {
        var discountValue = 0;
        var discount = '';
      }

      this.buyPlan = {
        price: practicPrice,
        iva: price * 0.22,
        amount: price + price * 0.22,
        amount_enea: parseFloat(price + price * 0.22 + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(price + price * 0.22 + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(price + price * 0.22 + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        visto: visto,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2,
        discountValue: discountValue,
        discount: discount
      };
    },
    submit: function submit() {
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },

    sendPracticeToKPMG: function sendPracticeToKPMG() {
      var _this6 = this;

      console.log(this);

      this.$validator.validate().then(function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(valid) {
          var _vue, p, data;

          return regenerator_default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _vue = _this6;

                  _this6.concluded = true;
                  for (p in _vue.uploadFrontPercentage) {
                    if (!_vue.uploadFrontPercentage[p]['completed'] && _vue.uploadFrontPercentage[p]['mandatory'] == 'yes') {
                      _this6.concluded = false;
                    }
                  }

                  if (_this6.concluded && valid) {

                    _this6.loadingState = true;

                    data = {
                      docs: _this6.uploadFrontPercentage,
                      practice: _this6.item,
                      user: _this6.getProfile
                    };


                    axios_default()({
                      url: "https://wsbot.eu/21005back/public/" + 'api/sendPracticeToKPMG',
                      method: 'POST',
                      data: data,
                      headers: {
                        'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                        'Content-type': 'application/json'
                      }
                    }).then(function (resp) {
                      _this6.loadingState = false;
                      _vue.$router.push('/pratiche');
                    }).catch(function (resp) {

                      _this6.loadingState = false;
                      _this6.showAlert();
                    });
                  } else {
                    _this6.showAlertNotConcluded();
                  }

                case 4:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this6);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    paymentAuthorized: function paymentAuthorized(data) {
      //console.log(data);
    },
    paymentPPSuccess: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(data) {
        var trans, _vue, payer_info, transactions;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                trans = data;
                _vue = this;


                trans.intent = 'paypal_advanced_payment';
                trans.state = trans.purchase_units[0].payments.captures[0].status;
                trans.payer.status = trans.payer.payer_id;
                payer_info = {
                  email: trans.payer.email_address,
                  first_name: trans.payer.name.given_name,
                  last_name: trans.payer.name.surname,
                  payer_id: trans.payer.payer_id,
                  country_code: trans.payer.address.country_code ? trans.payer.address.country_code : 'X'
                };

                trans.payer.payer_info = payer_info;

                transactions = [{
                  amount: {
                    total: trans.purchase_units[0].payments.captures[0].amount.value,
                    currency: trans.purchase_units[0].payments.captures[0].amount.currency_code
                  }
                }];


                trans.transactions = transactions;

                _context4.next = 11;
                return _vue.saveSubscription(trans);

              case 11:
                _context4.next = 13;
                return _vue.forcereloadDocs();

              case 13:
                _vue.paySuccess = true;

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function paymentPPSuccess(_x3) {
        return _ref3.apply(this, arguments);
      }

      return paymentPPSuccess;
    }(),
    paymentCompleted: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(data) {
        var trans, _vue;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                trans = data;
                _vue = this;

                if (!(trans.state == 'approved')) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 5;
                return _vue.saveSubscription(trans);

              case 5:
                _context5.next = 7;
                return _vue.forcereloadDocs();

              case 7:
                _vue.paySuccess = true;

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function paymentCompleted(_x4) {
        return _ref4.apply(this, arguments);
      }

      return paymentCompleted;
    }(),
    paymentCancelled: function paymentCancelled(data) {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Ci dispiace, </strong>',
        html: '<p>il pagamento non è andato a buon fine</p>',
        confirmButtonText: 'CHIUDI',
        confirmButtonColor: '#15267'
      });
    },
    getAuthToken: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _vue, urlencoded, envNow;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('1) CREATE TOKEN');
                _vue = this;
                urlencoded = new URLSearchParams();

                urlencoded.append("grant_type", "client_credentials");

                envNow = '';

                if (false) {
                  envNow = '.sandbox';
                }

                _context6.next = 8;
                return axios_default()({
                  url: "https://api" + envNow + ".paypal.com/v1/oauth2/token",
                  method: 'POST',
                  data: urlencoded,
                  auth: {
                    username: "AehaxT9bqu_By8mjhlJ7pcT6zdNvpb57IlC8sIBQiefSxdiLeBfN9Z9siNSiGOgzb5A2YgrTzefylCXX"
                    /*password: process.env.PAYPAL_SECRET*/
                  },
                  headers: {
                    //'Authorization': 'Basic Basic QWVTNlpENmliWmNnVzJXUHFoX1ppVnBSQ09iWFlOdzJMUFAtTE1yTTIxNUFEYVhsWkRCeW5US0FPXy1uTDRJa3dycS1FQUY4TG9MZWRMNU06RU5Tc0kyaFg3OWVnSDFDS2ZETlBRbmYwU3NrYmNHdDByOUdSaVZEd05NQXJHejJIQU1QNmMzLTk2MGhwUWthMmdYb2I1R3pjRGJBVU5sZlk=',
                    'Content-type': 'application/x-www-form-urlencoded'
                  }
                }).then(function (resp) {
                  //console.log(resp.data)
                  _vue.PPAUTHTOKEN = resp.data.access_token;
                  console.log('1) SUCCESS');
                  //console.warn(urlencoded)

                  //_vue.test()

                  _vue.createBillingPlan();
                }).catch(function (resp) {
                  console.log(resp.response);
                });

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getAuthToken() {
        return _ref5.apply(this, arguments);
      }

      return getAuthToken;
    }(),
    saveSubscription: function () {
      var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(trans) {
        var _vue, recaptcha, token;

        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _vue = this;
                recaptcha = this.$recaptchaInstance;
                // (optional) Wait until recaptcha has been loaded.

                _context7.next = 4;
                return _vue.$recaptchaLoaded();

              case 4:
                _context7.next = 6;
                return _vue.$recaptcha('login');

              case 6:
                token = _context7.sent;


                this.paymentTypeD = 'Practice';

                _vue.buyPlan.paymentType = 'practice';
                _vue.buyPlan.expiredAt = loadDocuments_moment().add(1, 'months').format("YYYY-MM-DD HH:mm:ss");

                if (_vue.item.payment_id != 0 && _vue.item.payment_id != '0') {
                  _vue.buyPlan2.paymentType = 'practice';
                  _vue.buyPlan2.expiredAt = loadDocuments_moment().add(1, 'months').format("YYYY-MM-DD HH:mm:ss");
                }

                this.autoRenewD = 'Disattivato';
                _vue.buyPlan.autoRenew = 'no';

                //console.error(trans)
                axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/addPayment',
                  method: 'POST',
                  data: {
                    token: token,
                    userToken: _vue.getProfile.userToken,
                    user: _vue.getProfile,
                    subscription: _vue.item.payment_id != 0 && _vue.item.payment_id != '0' ? _vue.buyPlan2 : _vue.buyPlan,
                    transaction: trans,
                    practice: this.item
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  console.log('SUBSCRIPTION SAVED');
                  if (_vue.item.payment_id != 0 && _vue.item.payment_id != '0' || _vue.dl == 0) {
                    if (_vue.item.bl == 0) {
                      _vue.dl = 'new';
                      _vue.item.dl = 'new';
                    }

                    _vue.forcereloadDocs();
                  }
                }).catch(function (resp) {
                  //console.log(resp.response)
                });
                //await _vue.$recaptchaLoaded()
                //token = await _vue.$recaptcha('login')

              case 14:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function saveSubscription(_x5) {
        return _ref6.apply(this, arguments);
      }

      return saveSubscription;
    }(),
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      console.log(viewer);

      console.log("ZOOOOOM");

      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show(index) {
      console.log(this);
      var el = this.$refs['viewer' + index];

      console.log(this.$refs);

      console.log(el[0]);

      //const viewerV = el.$viewer

      el[0].destroyViewer();

      el[0].createViewer();

      el[0].$viewer.show();
      //viewer.zoomTo(2)
      //	viewer.move(-1, 0);
    },

    convertToPractice: function convertToPractice() {
      var _this7 = this;

      var _vue = this;
      console.log(this.$validator);
      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this7.loadingState = true;
          // PREPARE
          var data = {};
          data.client_email = _this7.email;
          data.client_codice_fiscale = _this7.codice_fiscale;
          data.client_partita_iva = _this7.partita_iva;
          data.client_phone = _this7.phone;
          data.client_address = _this7.address;
          data.client_civic = _this7.civic;
          data.client_province = _this7.province;
          data.client_city = _this7.city.city;
          data.client_zip = _this7.zip;
          data.client_ownership = _this7.ownership;

          data.building_subalterno = _this7.subalterno;
          data.building_particella = _this7.particella;
          data.building_foglio = _this7.foglio;
          data.practice_id = _this7.item.id;
          data.user_token = _this7.getProfile.userToken;
          data.signed_order = _this7.invoiceFrontBucket;

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/acceptOrder',
            method: 'POST',
            data: data,
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            console.log(resp);

            _vue.loadingState = false;

            _vue.$swal({
              type: 'success',
              title: 'Pratica Inizializzata',
              html: 'Abbiamo creato la pratica <b>' + _this7.item.code + '</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. '
            });

            _vue.$router.push('/pratiche');
          }).catch(function (resp) {
            _vue.loadingState = false;
            _vue.$swal({
              type: 'error',
              title: 'Oops...',
              text: 'Riprova piu tardi!'
            });
          });
        } else {
          console.log('ERROR IN FORM');
          _vue.$scrollTo('#' + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        }
      });
    },
    populateProvincies: function populateProvincies() {
      var _this8 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/getProvinciesAll',
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this8.provincies = resp.data.provincies;
        _this8.provinciesState = false;
      }).catch(function (resp) {
        _this8.provincies = [];
        _this8.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ci dispiace! Riprova piu tardi'
      });
    },
    showAlertNotConcluded: function showAlertNotConcluded() {
      // Use sweetalret2
      this.$swal({
        type: 'warning',
        title: 'Attenzione!',
        text: 'Prima di procedere concludi il caricamento di tutti i documenti'
      });
    },
    setCap: function setCap(cap) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                for (x in _this9.zips) {
                  if (_this9.zips[x].cap == cap.toUpperCase()) {
                    _this9.zip = _this9.zips[x].cap;
                  }
                }

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    setCity: function setCity(city) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var x, k;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:

                for (x in _this10.cities) {
                  if (_this10.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this10.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this10.city = k;
                  }
                }
                console.log(_this10.city);

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var x;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:

                for (x in _this11.provincies) {
                  console.log('START');
                  console.log(_this11.provincies[x].sigla + ' =?= ' + province.toUpperCase());
                  if (_this11.provincies[x].sigla == province.toUpperCase()) {
                    _this11.province = _this11.provincies[x].sigla;
                  }
                }
                console.log(_this11.province);

              case 2:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    closeDocumentBlock: function closeDocumentBlock(doc, code, name, docCode) {
      var _this12 = this;

      var _vue = this;
      var data = {};
      data.doc = doc;
      data.code = code;
      data.name = name;
      data.docCode = docCode;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/closeDocumentBlock',
        method: 'POST',
        data: {
          data: data
        },
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {

        var r = _this12.uploadFrontPercentage[data.doc];
        r['completed'] = 1;
        //r['hasError'] = 'no'
        vue_esm["a" /* default */].set(_this12.uploadFrontPercentage, data.doc, r);

        // NEW
        _vue.concluded = true;
        for (var p in _vue.uploadFrontPercentage) {
          if (!_vue.uploadFrontPercentage[p]['completed'] && _vue.uploadFrontPercentage[p]['mandatory'] == 'yes') {
            _vue.concluded = false;
          }
        }
      }).catch(function (resp) {});
    },
    uploadFile: function uploadFile(doc, code, name, docCode) {

      console.log(this.$refs['fileInput' + doc]);
      var input = this.$refs['fileInput' + doc][0];

      console.log(input);

      console.log(doc);
      console.log(code);
      console.log(name);
      console.log(docCode);

      var ind = doc;
      console.log(0);
      var file = input.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.files[0].size;
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append('fattura0', input.files[0]);

        console.log(this.uploadFrontPercentage);

        formData.append('doc', doc);
        formData.append('code', code);
        formData.append('name', name);
        formData.append('docCode', docCode);

        console.log(1);

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadDocument', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {

            var r = this.uploadFrontPercentage[ind];

            r['percent'] = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));

            //  Object.assign(this.uploadFrontPercentage, r)

            vue_esm["a" /* default */].set(this.uploadFrontPercentage, ind, r);

            //  this.uploadFrontPercentage[ind]['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          console.log(2);
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.document)) {
            _vue.uploadFrontPercentage[ind]['percent'] = 0;

            var x = _vue.uploadFrontPercentage[ind]['images'];

            x[e.data.id] = e.data.document;

            _vue.uploadFrontPercentage[ind]['images'] = x;
            _vue.uploadFrontPercentage[ind]['hasError'] = 'no';
            _vue.uploadFrontPercentage[ind]['countImages'] = 1;
            _vue.uploadFrontPercentage[ind]['date'] = loadDocuments_moment().format('YYYY-MM-DD HH:mm:00');

            console.log(_vue.uploadFrontPercentage);
            _vue.forcereloadDocs();
            //_vue.invoiceFrontBucket = e.data.fattura
          } else {
            _vue.uploadFrontPercentage[ind]['percent'] = 0;
            //_vue.invoiceFront = ''
            //_vue.invoiceFrontBucket = ''
            _vue.forcereloadDocs();
            //input.value = null
          }
        }).catch(function () {
          _vue.uploadFrontPercentage.doc = 0;
          //  _vue.invoiceFront = ''
          ///  _vue.invoiceFrontBucket = ''

          //input.value = null
        });
      }
    },
    getDocuments: function getDocuments(code, user_token) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getDocumentsByCode',
                  method: 'POST',
                  data: {
                    code: code,
                    user_token: user_token
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _this13.savedDocuments = resp.data.documents;
                }).catch(function (resp) {
                  _this13.savedDocuments = {};
                });

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    },
    checkIfIban: function checkIfIban() {
      if (this.getProfile) {

        if (this.getProfile.iban == '') {

          this.$swal({
            type: 'warning',
            title: 'Attenzione!',
            text: 'Ricordati, che dovrai inserire l`Iban delle Poste Italiane prima della cessione del credito.'
          });

          //this.$router.push('/account')
        }

        // CHECK IF CAN PAY WITH SEPA NEWWWWWWWWWWWWWWW
        if (this.getProfile.iban_pay == '1') {
          console.log('OK SEPAZAAAAA');
          this.sepaOn = true;
        }
      }
    },

    getDocumentsList: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12(flow, type, client) {
        var clientType, _vue, data, x;

        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:

                if (client == 'Persona fisica') {
                  clientType = 'documents_physical_person';
                } else if (client == 'Partita IVA') {
                  clientType = 'documents_legal_person';
                } else if (client == 'Amministratore di condominio') {
                  clientType = 'documents_condominium';
                }

                _vue = this;

                console.warn('INSIDE getDocumentsList');
                data = {
                  flow: flow,
                  type: type,
                  clientType: clientType
                  //_vue.loadingState = true

                };
                console.warn('DATA getDocumentsList', data);

                _context12.next = 7;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getDocumentsList',
                  method: 'POST',
                  data: data,
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  //_vue.loadingState = false
                  if (resp.data.documents) {
                    return resp.data.documents;
                  } else {
                    return false;
                  }
                }).catch(function (resp) {
                  _vue.$swal({
                    type: 'error',
                    title: 'Ops....',
                    html: 'Riprova più tardi'
                  });
                  return false;
                  //_vue.loadingState = false
                });

              case 7:
                x = _context12.sent;
                return _context12.abrupt('return', x);

              case 9:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getDocumentsList(_x6, _x7, _x8) {
        return _ref7.apply(this, arguments);
      }

      return getDocumentsList;
    }(),
    forcereloadDocs: function forcereloadDocs() {
      var _this14 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        var _vue, docs, docTemp, practice, x, z, y;

        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _vue = _this14;


                console.warn(' INIT GET DOCS ');
                _context13.next = 4;
                return _this14.getDocumentsList(_this14.$route.params.item.flow, _this14.$route.params.item.dl == 'old' ? 'short' : 'full', _this14.$route.params.item.client_type);

              case 4:
                docs = _context13.sent;

                console.warn(docs);

                if (false) {
                  _vue.envPP = 'sandbox';
                }

                //_vue.documents = docs
                docTemp = docs;

                _vue.documents = docs;

                // ******************************************************************************************


                _vue.loadingState = true;
                //_vue.uploadFrontPercentage = {}

                assign_default()(_vue.uploadFrontPercentage, {});

                practice = _vue.$route.params.item;
                _context13.next = 14;
                return _vue.getDocuments(practice.code, 'asdg2352rsdfgv');

              case 14:

                for (x in docs) {
                  console.warn(x);
                  if (practice.bonus == 'Bonus Casa 50%' && docs[x]['codice'] == '2050D19' && practice.client_type != 'Amministratore di condominio') {
                    console.warn('Delete 2050D19');
                    delete docs[x];
                  } else if (docs[x]['codice'] == '2050D111' && practice.to_get_cadastral_data == '0' || docs[x]['codice'] == '2050D111' && practice.to_get_cadastral_data == '1' && practice.disposal == 'old') {
                    // DELEGA VISURA
                    console.warn('Delete 2050D111 DELEGA VISURA');
                    delete docs[x];
                  } else if (docs[x]['codice'] == '2050D112' && practice.enea_request == '0' || docs[x]['codice'] == '2050D112' && practice.enea_request == '1' && practice.disposal == 'old') {
                    // DELEGA ENEA
                    console.warn('Delete 2050D111 DELEGA ENEA');
                    delete docs[x];
                  }
                  /*else if( ( docs[x]['codice'] == '2050D06D' && practice.flow == 'agileenergy' )  ){
                    // DELEGA ENEA
                    console.warn('Delete 2050D06D IF AGILE')
                    delete docs[x]
                  }*/
                  else {
                      z = {};

                      z.images = {};
                      z.countImages = 0;
                      z.completed = 0;

                      z.docname = docs[x]['name'];

                      if ((_vue.getProfile.tipo_azienda == 'Ditta Individuale' || _vue.getProfile.tipo_azienda == 'Professionista iscritto ad albi') && docs[x]['codice'] == '2050D0B') {
                        z.mandatory = 'no';
                        docs[x]['mandatory'] = 'no';
                      } else {
                        z.mandatory = docs[x]['mandatory'];
                      }

                      // NEWW REMOVE MANDATORY ID REQUEST DATA CATASTALE
                      if (docs[x]['codice'] == '2050D11' && practice.to_get_cadastral_data == '1') {
                        z.mandatory = 'no';
                        docs[x]['mandatory'] = 'no';
                      } else {
                        if (docs[x]['codice'] == '2050D11' && practice.to_get_cadastral_data == '0') {
                          z.mandatory = 'yes';
                          docs[x]['mandatory'] = 'yes';
                        } else {
                          z.mandatory = docs[x]['mandatory'];
                        }
                      }

                      // NEWW REMOVE MANDATORY ID REQUEST ENEA
                      if (docs[x]['codice'] == '2050D15' && practice.enea_request == '1' || docs[x]['codice'] == '2050D15' && practice.bonus == 'Bonus Casa 50%') {
                        z.mandatory = 'no';
                        docs[x]['mandatory'] = 'no';
                      } else {
                        if (docs[x]['codice'] == '2050D15' && practice.enea_request == '0') {
                          z.mandatory = 'yes';
                          docs[x]['mandatory'] = 'yes';
                        } else {
                          z.mandatory = docs[x]['mandatory'];
                        }
                      }

                      z.hasError = 'no';
                      for (y in _vue.savedDocuments) {
                        if (_vue.savedDocuments[y].codice == x) {
                          z.images[_vue.savedDocuments[y].id] = _vue.savedDocuments[y].url;
                          z.countImages = 1;
                          z.date = _vue.savedDocuments[y].date;
                          z.completed = parseInt(_vue.savedDocuments[y].completed);
                          z.hasError = _vue.savedDocuments[y].hasError;
                          z.error = _vue.savedDocuments[y].error;
                        }
                      }
                      z.percent = 0;
                      y = {};

                      y[x] = z;
                      vue_esm["a" /* default */].set(_vue.uploadFrontPercentage, x, z);
                    }
                }

                console.log(_vue.uploadFrontPercentage);

                console.warn(_vue.documents);

                _vue.loadingState = false;

              case 18:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this14);
      }))();
    },
    forcereloadDocsOld: function forcereloadDocsOld() {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
        var _vue, docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, x, z, y;

        return regenerator_default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _vue = _this15;


                if (_this15.$route.params.item.flow == 'poste') {

                  // NEW REMOVE 5 DOCUMENTS if OLD DL
                  console.log('forcereloadDocs DL *******************' + _this15.item.dl);
                  console.log(documentsOR[_this15.$route.params.item.client_type]);
                  if (_this15.item.dl == 'old' || _this15.$route.params.item.status != '1' && _this15.$route.params.item.dl == '0') {
                    console.log('forcereloadDocs DOC REMOVED');

                    _this15.documents = documentsOROld;
                  } else {
                    _this15.documents = documentsOR;
                  }
                } else {

                  // NEW REMOVE 5 DOCUMENTS if OLD DL
                  if (_this15.item.dl == 'old' || _this15.$route.params.item.status != '1' && _this15.$route.params.item.dl == '0') {
                    console.log('forcereloadDocs DOC REMOVED');
                    _this15.documents = documents_cdpOROld;
                  } else {
                    _this15.documents = documents_cdpOR;
                  }
                }

                if (false) {
                  _this15.envPP = 'sandbox';
                }
                // DOC LIST PARSER
                docTemp = _this15.documents[_this15.$route.params.item.client_type];

                _this15.documents[_this15.$route.params.item.client_type] = {};

                selettore_titoloPossesso = _this15.$route.params.item.client_ownership;
                selettore_enea = _this15.$route.params.item.enea_request;


                if (selettore_enea == '0') {
                  selettore_enea = 'no';
                } else {
                  selettore_enea = 'yes';
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty('codice')) {
                    _this15.documents[_this15.$route.params.item.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty('selector')) {
                    if (docTemp[ele]['selector'].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]['selector'][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]['selector'].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]['selector'][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _this15.documents[_this15.$route.params.item.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                // ******************************************************************************************


                _this15.loadingState = true;
                //this.uploadFrontPercentage = {}

                assign_default()(_this15.uploadFrontPercentage, {});

                _context14.next = 13;
                return _this15.getDocuments(_this15.$route.params.item.code, 'asdg2352rsdfgv');

              case 13:

                for (x in _this15.documents[_this15.$route.params.item.client_type]) {
                  if (_this15.$route.params.item.bonus == 'Bonus Casa 50%' && _this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D19' && _this15.$route.params.item.client_type != 'Amministratore di condominio') {
                    delete _this15.documents[_this15.$route.params.item.client_type][x];
                  } else if (_this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D111' && _this15.$route.params.item.to_get_cadastral_data == '0' || _this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D111' && _this15.$route.params.item.to_get_cadastral_data == '1' && _this15.$route.params.item.disposal == 'old') {
                    // DELEGA VISURA
                    delete _this15.documents[_this15.$route.params.item.client_type][x];
                  } else if (_this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D112' && _this15.$route.params.item.enea_request == '0' || _this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D112' && _this15.$route.params.item.enea_request == '1' && _this15.$route.params.item.disposal == 'old') {
                    // DELEGA ENEA
                    delete _this15.documents[_this15.$route.params.item.client_type][x];
                  } else {
                    z = {};

                    z.images = {};
                    z.countImages = 0;
                    z.completed = 0;

                    z.docname = _this15.documents[_this15.$route.params.item.client_type][x]['name'];

                    if ((_this15.getProfile.tipo_azienda == 'Ditta Individuale' || _this15.getProfile.tipo_azienda == 'Professionista iscritto ad albi') && _this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D0B') {
                      z.mandatory = 'no';
                      _this15.documents[_this15.$route.params.item.client_type][x]['mandatory'] = 'no';
                    } else {
                      z.mandatory = _this15.documents[_this15.$route.params.item.client_type][x]['mandatory'];
                    }

                    // NEWW REMOVE MANDATORY ID REQUEST DATA CATASTALE
                    if (_this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D11' && _this15.$route.params.item.to_get_cadastral_data == '1') {
                      z.mandatory = 'no';
                      _this15.documents[_this15.$route.params.item.client_type][x]['mandatory'] = 'no';
                    } else {
                      if (_this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D11' && _this15.$route.params.item.to_get_cadastral_data == '0') {
                        z.mandatory = 'yes';
                        _this15.documents[_this15.$route.params.item.client_type][x]['mandatory'] = 'yes';
                      } else {
                        z.mandatory = _this15.documents[_this15.$route.params.item.client_type][x]['mandatory'];
                      }
                    }

                    // NEWW REMOVE MANDATORY ID REQUEST ENEA
                    if (_this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D15' && _this15.$route.params.item.enea_request == '1' || _this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D15' && _this15.$route.params.item.bonus == 'Bonus Casa 50%') {
                      z.mandatory = 'no';
                      _this15.documents[_this15.$route.params.item.client_type][x]['mandatory'] = 'no';
                    } else {
                      if (_this15.documents[_this15.$route.params.item.client_type][x]['codice'] == '2050D15' && _this15.$route.params.item.enea_request == '0') {
                        z.mandatory = 'yes';
                        _this15.documents[_this15.$route.params.item.client_type][x]['mandatory'] = 'yes';
                      } else {
                        z.mandatory = _this15.documents[_this15.$route.params.item.client_type][x]['mandatory'];
                      }
                    }

                    z.hasError = 'no';
                    for (y in _this15.savedDocuments) {
                      if (_this15.savedDocuments[y].codice == x) {
                        z.images[_this15.savedDocuments[y].id] = _this15.savedDocuments[y].url;
                        z.countImages = 1;
                        z.date = _this15.savedDocuments[y].date;
                        z.completed = parseInt(_this15.savedDocuments[y].completed);
                        z.hasError = _this15.savedDocuments[y].hasError;
                        z.error = _this15.savedDocuments[y].error;
                      }
                    }
                    z.percent = 0;
                    y = {};

                    y[x] = z;
                    vue_esm["a" /* default */].set(_this15.uploadFrontPercentage, x, z);
                  }
                }

                //console.log(this.uploadFrontPercentage)

                _this15.loadingState = false;

              case 15:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this15);
      }))();
    }
  },
  watch: {
    dl: function dl(val) {
      if (val) {
        this.recalcPrices('norm');
        this.forcereloadDocs();
      }
    },
    discount: function discount(val) {
      if (val) {
        this.discount = this.discount.toUpperCase();
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },
    getProfile: function getProfile() {
      //this.checkIfIban()
      this.forcereloadDocs();
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this16 = this;

      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = '';
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this16.cities = resp.data.cities;
          _this16.citiesState = false;
        }).catch(function (resp) {
          _this16.cities = [];
          _this16.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this17 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this17.zips = resp.data.zips;
          _this17.zipsState = false;
        }).catch(function (resp) {
          _this17.zips = [];
          _this17.zipsState = false;
        });
      }
    }
  },
  created: function created() {
    var _this18 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
      return regenerator_default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:

              console.warn(" CREATED *************************************************************");

              if (false) {
                _this18.envPP = 'sandbox';
              }

              if (_this18.getProfile) {
                _this18.forcereloadDocs();
              }

            case 3:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this18);
    }))();
  },
  mounted: function mounted() {
    this.loadButtons = true;

    if (this.$route.params.item) {
      this.item = this.$route.params.item;

      this.recalcPrices('norm');

      if (this.item.enea_cpid) {
        this.enea_cpid = this.item.enea_cpid;
      }

      if (this.item && this.item.client_type != 'Amministratore di condominio') {
        this.address = this.item.building_address;
        this.civic = this.item.building_civic;
      }

      if (this.item.payment_id == 0) {
        this.payment = false;

        var _vue = this;
      } else {
        this.payment = true;
      }

      this.loaded = true;

      // NEW
      var _vue = this;
      setTimeout(function () {
        _vue.concluded = true;
        for (var p in _vue.uploadFrontPercentage) {

          if (!_vue.uploadFrontPercentage[p]['completed'] && _vue.uploadFrontPercentage[p]['mandatory'] == 'yes') {
            _vue.concluded = false;
          }
        }
      }, 1500);
    } else {
      this.$router.push('/pratiche');
    }

    //this.checkIfIban()

    this.populateProvincies();
    this.$scrollTo('#app', 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38471c95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/index.vue
var loadDocuments_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.item.dl == "0" && _vm.item.status == "1" && _vm.item.payment_id == 0
        ? _c("div", { staticClass: "container mb-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12  text-left" }, [
                _c("h3", { staticClass: "Regular h0 widthFull" }, [
                  _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
                ])
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-6 center mb-3 vaillantCont text-center pt-5 pb-5"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.changeDL("old")
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "white" }, [
                        _vm._v("\n\n            Confermo che:\n            "),
                        _c("br"),
                        _vm._v(
                          "- Copia di cortesia o Fattura trasmessa al Sistema di Interscambio (Sdi) dal professionista\n            aderente " +
                            _vm._s(_vm.brand) +
                            " verso il proprio cliente (committente) con Data Documento "
                        ),
                        _c("b", { staticClass: "black Bold uppercase" }, [
                          _vm._v(" entro ")
                        ]),
                        _vm._v(
                          " l’11\n            novembre 2021 (incluso)\n            "
                        ),
                        _c("br"),
                        _vm._v(
                          "− Data di esecuzione del Bonifico Bancario (parlante) disposto dal cliente (committente)\n            "
                        ),
                        _c("b", { staticClass: "black Bold uppercase" }, [
                          _vm._v(" entro ")
                        ]),
                        _vm._v(
                          ", l’11 novembre 2021 (incluso), in riferimento alla relativa fattura rilasciata dal\n            professionista aderente CheBonus\n            "
                        ),
                        _c("br")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-6 center mb-3 vaillantCont text-left pt-5 pb-5"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.changeDL("new")
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "white" }, [
                        _vm._v("\n          Confermo che:\n          "),
                        _c("br"),
                        _vm._v(
                          "- Copia di cortesia o Fattura trasmessa al Sistema di Interscambio (Sdi) dal professionista\n          aderente " +
                            _vm._s(_vm.brand) +
                            " verso il proprio cliente (committente) con Data Documento "
                        ),
                        _c("b", { staticClass: "black Bold uppercase" }, [
                          _vm._v(" oltre ")
                        ]),
                        _vm._v(
                          " l’11\n          novembre 2021 (incluso)\n          "
                        ),
                        _c("br"),
                        _vm._v(
                          "− Data di esecuzione del Bonifico Bancario (parlante) disposto dal cliente (committente)\n          "
                        ),
                        _c("b", { staticClass: "black Bold uppercase" }, [
                          _vm._v(" oltre ")
                        ]),
                        _vm._v(
                          ", l’11 novembre 2021 (incluso) in riferimento alla relativa fattura rilasciata dal\n          professionista aderente CheBonus\n          "
                        ),
                        _c("br")
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        : _vm.item.dl == "0" &&
          _vm.item.status == "1" &&
          _vm.item.payment_id != 0 &&
          _vm.item.payment_id != "0" &&
          _vm.item.aditional_payment == 0
        ? _c("div", { staticClass: "container mb-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12  text-left" }, [
                _c("h3", { staticClass: "Regular h0 widthFull" }, [
                  _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
                ])
              ]),
              _vm._v(" "),
              _vm._m(2)
            ]),
            _vm._v(" "),
            !_vm.additionalPayment
              ? _c(
                  "div",
                  { staticClass: "row justify-content-center text-left" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-5 center mb-0 vaillantCont text-center pb-5"
                      },
                      [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "Regular text-center h0 widthFull mt-5 "
                          },
                          [
                            _c("b", [
                              _vm._v(
                                "\n        Per completare la tua pratica a norma del D.L 157, bisogna integrare il visto di conformità\n          "
                              ),
                              _vm.item.flow == "poste"
                                ? _c("span", [_vm._v(" e la Due Diligence. ")])
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mt-5 mb-5",
                            on: {
                              click: function($event) {
                                _vm.additionalPayment = true
                              }
                            }
                          },
                          [_vm._v("\n\n            Avanti\n\n          ")]
                        )
                      ]
                    )
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "row justify-content-center text-left" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-12 center mb-0 vaillantCont text-left"
                      },
                      [
                        !_vm.paySuccess
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "row justify-content-center text-left"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-8 center mb-3 text-left"
                                  },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "Regular text-left h0 widthFull "
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            " Per completare la tua pratica a norma del D.L 157, bisogna integrare il visto di conformità\n              "
                                          ),
                                          _vm.item.flow == "poste"
                                            ? _c("span", [
                                                _vm._v(" e la Due Diligence. ")
                                              ])
                                            : _vm._e(),
                                          _vm._v("\n               Acquista  "),
                                          _vm.item.flow == "poste"
                                            ? _c("span", [_vm._v("i servizi ")])
                                            : _c("span", [
                                                _vm._v("il servizio ")
                                              ]),
                                          _vm._v(
                                            " con una Carta, PayPal o Bonifico Bancario (SOFORT)\n\n            "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "black mt-0 text-left widthFull "
                                      },
                                      [
                                        _vm._v(
                                          "\n              Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.\n            "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-4 pt-md-4 center mb-3 text-right"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-primary btnRed m-2 btn-sm ml-md-5 white",
                                        on: {
                                          click: function($event) {
                                            _vm.additionalPayment = false
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: {
                                            icon: "arrow-left",
                                            size: "1x"
                                          }
                                        }),
                                        _vm._v(
                                          "\n              Indietro\n            "
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "row justify-content-center text-left"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-12 pb-0 buyPlan center" },
                              [
                                _c("h3", {
                                  staticClass: "center darkBlue mb-3"
                                }),
                                _vm._v(" "),
                                !_vm.paySuccess
                                  ? _c("div", { staticClass: "widthFull" }, [
                                      _c("div", { staticClass: "row " }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-6 col-md-6 col-lg-6 text-left bgWhite"
                                          },
                                          [
                                            _c("div", { staticClass: "row " }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-left mb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Costo aggiuntivo "
                                                      ),
                                                      _vm.item.flow == "poste"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " di Due Diligence "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " Servizio/Pratica (IVA Esclusa) "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-right"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-right mb-0"
                                                    },
                                                    [
                                                      _c("b", {}, [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.buyPlan2.price
                                                            )
                                                          ) + " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row " }, [
                                              _vm._m(4),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-right"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-right mb-0"
                                                    },
                                                    [
                                                      _c("b", {}, [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.buyPlan2.visto
                                                            )
                                                          ) + " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.discountValue
                                              ? _c(
                                                  "div",
                                                  { staticClass: "row " },
                                                  [
                                                    _vm._m(5),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-3 text-right"
                                                      },
                                                      [
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticClass:
                                                              " text-right mb-0 red"
                                                          },
                                                          [
                                                            _c("b", {}, [
                                                              _vm._v(
                                                                "- " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      _vm.discountValue
                                                                    )
                                                                  ) +
                                                                  " € "
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row " }, [
                                              _vm._m(6),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-right"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-right mb-4"
                                                    },
                                                    [
                                                      _c("b", {}, [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(_vm.buyPlan2.iva)
                                                          ) + " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row " }, [
                                              _vm._m(7),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-right borderTopBlack"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        " text-right mb-4"
                                                    },
                                                    [
                                                      _c("b", {}, [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              _vm.buyPlan2
                                                                .amount
                                                            )
                                                          ) + " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "col-sm-0 col-md-1 col-lg-1 text-left"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-6 col-md-6 col-lg-4"
                                          },
                                          [
                                            _vm.paypalOn
                                              ? _c(
                                                  "h2",
                                                  {
                                                    staticClass:
                                                      "center widthFull mb-3 mt-3 bgWhite pb-3"
                                                  },
                                                  [
                                                    _vm._m(8),
                                                    _vm._v(" "),
                                                    _c("paypalPayment", {
                                                      attrs: {
                                                        amount:
                                                          "" +
                                                          _vm.buyPlan2.amount,
                                                        "invoice-number":
                                                          _vm.brand +
                                                          "_DL_PRATICA_" +
                                                          _vm.item.code +
                                                          _vm.paypalDiscountString,
                                                        items: [
                                                          {
                                                            name:
                                                              _vm.brand +
                                                              "-" +
                                                              _vm.item.code,
                                                            description:
                                                              "PRATICA_" +
                                                              _vm.item.code,
                                                            price:
                                                              "" +
                                                              _vm.buyPlan2
                                                                .amount,
                                                            quantity: "1",
                                                            currency: "EUR"
                                                          }
                                                        ],
                                                        currency: "EUR",
                                                        locale: "it_IT",
                                                        experience:
                                                          _vm.experienceOptions,
                                                        practice: _vm.item.code,
                                                        dl: _vm.item.dl,
                                                        flow: _vm.item.flow,
                                                        userToken:
                                                          _vm.getProfile
                                                            .userToken,
                                                        PaypalOn: _vm.paypalOn,
                                                        sepaOn: _vm.sepaOn
                                                      },
                                                      on: {
                                                        paymentPPSuccess:
                                                          _vm.paymentPPSuccess
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.paySuccess
                                  ? _c(
                                      "div",
                                      { staticClass: "col-sm-12 center pb-5" },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid payImage",
                                          attrs: {
                                            src: __webpack_require__("4AGf")
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("h1", { staticClass: "center" }, [
                                          _vm._v("Grazie per averci scelto, ")
                                        ]),
                                        _vm._v(" "),
                                        _c("h3", { staticClass: "center" }, [
                                          _vm._v(
                                            "il tuo pagamento è avvenuto con successo"
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary rn-btn-dark btnRed mt-5",
                                            on: {
                                              click: function($event) {
                                                _vm.payment = true
                                                _vm.item.aditional_payment = 1
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "hover hover-1" },
                                              [_vm._v("Procedi")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
          ])
        : !_vm.payment && _vm.loaded
        ? _c("div", { staticClass: "container mb-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular text-left h0 widthFull" }, [
                _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
              ]),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary btnRed m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\n          Indietro\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12 pb-0 buyPlan center" }, [
                _c("h3", { staticClass: "center darkBlue mb-3" }),
                _vm._v(" "),
                !_vm.paySuccess
                  ? _c("div", { staticClass: "widthFull" }, [
                      _c("div", { staticClass: "row " }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-6 col-md-6 col-lg-6 text-left bgWhite"
                          },
                          [
                            _c("div", { staticClass: "row " }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 text-left customAccordion mb-3"
                                },
                                [
                                  _c(
                                    "badger-accordion",
                                    {
                                      key: "1232323",
                                      attrs: { icons: _vm.icons }
                                    },
                                    [
                                      _c(
                                        "badger-accordion-item",
                                        [
                                          _c(
                                            "template",
                                            {
                                              staticClass: "center",
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "h4",
                                                { staticClass: "Bold" },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      icon: "gift",
                                                      size: "md"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    " Hai un codice sconto ?\n                        "
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "black mt-0 text-left widthFull "
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          Se possiedi un codice sconto, potrai utilizzarlo per il pagamento\n                        "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "template",
                                            {
                                              staticClass: "bbaLightColor",
                                              slot: "content"
                                            },
                                            [
                                              _vm.discountError
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "widthFull Bold text-center red"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          Codice sconto non valido\n                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "form",
                                                {
                                                  staticClass: "widthFull",
                                                  attrs: {
                                                    id: "discount-form"
                                                  },
                                                  on: {
                                                    submit: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.checkDiscount(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-row justify-content-center"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-8 mb-1"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "group custInput"
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.discount,
                                                                    expression:
                                                                      "discount"
                                                                  },
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value: {
                                                                      required: true,
                                                                      max: 26,
                                                                      min: 5
                                                                    },
                                                                    expression:
                                                                      "{required:true, max: 26, min: 5}"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control",
                                                                class: {
                                                                  "is-invalid": _vm.errors.has(
                                                                    "discount"
                                                                  ),
                                                                  valid: !!_vm.discount
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                  id:
                                                                    "discount",
                                                                  name:
                                                                    "discount",
                                                                  "data-vv-as":
                                                                    "Codice sconto"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.discount
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.discount =
                                                                      $event.target.value
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "highlight"
                                                              }),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "bar"
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "niceInputLabel",
                                                                  attrs: {
                                                                    for:
                                                                      "discount"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Codice Sconto"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.errors.has(
                                                                "discount"
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "invalid-feedback"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  " +
                                                                          _vm._s(
                                                                            _vm.errors.first(
                                                                              "discount"
                                                                            )
                                                                          ) +
                                                                          "\n                                "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4 mb-1 pt-3 text-center"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-primary btn-sm btnYellow shadow mb-4 mt-4",
                                                              attrs: {
                                                                type: "submit"
                                                              }
                                                            },
                                                            [_vm._v("Applica")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(10),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-3 text-right" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-0" },
                                    [
                                      _c("b", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.buyPlan.price
                                            )
                                          ) + " € "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.item.dl == "new"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(11),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.visto
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.discountValue
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(12),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0 red" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              "- " +
                                                _vm._s(
                                                  _vm._f("formatNumber")(
                                                    _vm.discountValue
                                                  )
                                                ) +
                                                " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(13),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-3 text-right" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-4" },
                                    [
                                      _c("b", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.buyPlan.iva
                                            )
                                          ) + " € "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.item.enea_request != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(14),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.priceEnea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.enea_request != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(15),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-4" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.ivaEnea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.to_get_cadastral_data != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(16),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.priceDcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.to_get_cadastral_data != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(17),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-4" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.ivaDcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(18),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 text-right borderTopBlack"
                                },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-4" },
                                    [
                                      _vm.item.enea_request == "0" &&
                                      _vm.item.to_get_cadastral_data == "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request != "0" &&
                                      _vm.item.to_get_cadastral_data == "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_enea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request == "0" &&
                                      _vm.item.to_get_cadastral_data != "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_dcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request != "0" &&
                                      _vm.item.to_get_cadastral_data != "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_enea_dcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "col-sm-0 col-md-1 col-lg-1 text-left"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-md-6 col-lg-4" },
                          [
                            _vm.paypalOn
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "center widthFull mb-3 mt-0 bgWhite pb-3"
                                  },
                                  [
                                    _vm._m(19),
                                    _vm._v(" "),
                                    _vm.item.enea_request == "0" &&
                                    _vm.item.to_get_cadastral_data == "0"
                                      ? _c("paypalPayment", {
                                          attrs: {
                                            amount: "" + _vm.buyPlan.amount,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code +
                                              _vm.paypalDiscountString,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            currency: "EUR",
                                            locale: "it_IT",
                                            experience: _vm.experienceOptions,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn
                                          },
                                          on: {
                                            paymentPPSuccess:
                                              _vm.paymentPPSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request != "0" &&
                                    _vm.item.to_get_cadastral_data == "0"
                                      ? _c("paypalPayment", {
                                          attrs: {
                                            amount:
                                              "" + _vm.buyPlan.amount_enea,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code +
                                              _vm.paypalDiscountString,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Pratica ENEA",
                                                description:
                                                  "Servizio di redazione e invio pratica ENEA",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceEnea * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            currency: "EUR",
                                            locale: "it_IT",
                                            experience: _vm.experienceOptions,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn
                                          },
                                          on: {
                                            paymentPPSuccess:
                                              _vm.paymentPPSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request == "0" &&
                                    _vm.item.to_get_cadastral_data != "0"
                                      ? _c("paypalPayment", {
                                          attrs: {
                                            amount:
                                              "" + _vm.buyPlan.amount_dcast,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code +
                                              _vm.paypalDiscountString,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Visura Catastale",
                                                description:
                                                  "Servizio Visura Catastale",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceDcast * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            currency: "EUR",
                                            locale: "it_IT",
                                            experience: _vm.experienceOptions,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn
                                          },
                                          on: {
                                            paymentPPSuccess:
                                              _vm.paymentPPSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request != "0" &&
                                    _vm.item.to_get_cadastral_data != "0"
                                      ? _c("paypalPayment", {
                                          attrs: {
                                            amount:
                                              "" +
                                              _vm.buyPlan.amount_enea_dcast,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code +
                                              _vm.paypalDiscountString,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Pratica ENEA",
                                                description:
                                                  "Servizio di redazione e invio pratica ENEA",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceEnea * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Visura Catastale",
                                                description:
                                                  "Servizio Visura Catastale",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceDcast * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            currency: "EUR",
                                            locale: "it_IT",
                                            experience: _vm.experienceOptions,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn
                                          },
                                          on: {
                                            paymentPPSuccess:
                                              _vm.paymentPPSuccess
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.autoReNew && !_vm.loadButtons
                                      ? _c("div", {
                                          attrs: {
                                            id: "paypal-button-container"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                             false
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "center widthFull mb-3 mt-3 bgWhite"
                                  },
                                  [
                                    _vm.item.enea_request == "0" &&
                                    _vm.item.to_get_cadastral_data == "0"
                                      ? _c("stripePayment", {
                                          attrs: {
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            invoiceNumber:
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            amount: "" + _vm.buyPlan.amount,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn,
                                            discount: _vm.discount,
                                            discountValue: _vm.discountValue
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request != "0" &&
                                    _vm.item.to_get_cadastral_data == "0"
                                      ? _c("stripePayment", {
                                          attrs: {
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Pratica ENEA",
                                                description:
                                                  "Servizio di redazione e invio pratica ENEA",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceEnea * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            amount:
                                              "" + _vm.buyPlan.amount_enea,
                                            invoiceNumber:
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            practice: _vm.item.code,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            sepaOn: _vm.sepaOn,
                                            discount: _vm.discount,
                                            discountValue: _vm.discountValue
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request == "0" &&
                                    _vm.item.to_get_cadastral_data != "0"
                                      ? _c("stripePayment", {
                                          attrs: {
                                            amount:
                                              "" + _vm.buyPlan.amount_dcast,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Visura Catastale",
                                                description:
                                                  "Servizio Visura Catastale",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceDcast * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            invoiceNumber:
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            practice: _vm.item.code,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            sepaOn: _vm.sepaOn,
                                            discount: _vm.discount,
                                            discountValue: _vm.discountValue
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.item.enea_request != "0" &&
                                    _vm.item.to_get_cadastral_data != "0"
                                      ? _c("stripePayment", {
                                          attrs: {
                                            amount:
                                              "" +
                                              _vm.buyPlan.amount_enea_dcast,
                                            "invoice-number":
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            items: [
                                              {
                                                name:
                                                  _vm.brand +
                                                  "-" +
                                                  _vm.item.code,
                                                description:
                                                  "PRATICA_" + _vm.item.code,
                                                price: "" + _vm.buyPlan.amount,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Pratica ENEA",
                                                description:
                                                  "Servizio di redazione e invio pratica ENEA",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceEnea * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              },
                                              {
                                                name: "Visura Catastale",
                                                description:
                                                  "Servizio Visura Catastale",
                                                price:
                                                  "" +
                                                  _vm.buyPlan.priceDcast * 1.22,
                                                quantity: "1",
                                                currency: "EUR"
                                              }
                                            ],
                                            invoiceNumber:
                                              _vm.brand +
                                              "_PRATICA_" +
                                              _vm.item.code,
                                            practice: _vm.item.code,
                                            userToken: _vm.getProfile.userToken,
                                            PaypalOn: _vm.paypalOn,
                                            dl: _vm.item.dl,
                                            flow: _vm.item.flow,
                                            sepaOn: _vm.sepaOn,
                                            discount: _vm.discount,
                                            discountValue: _vm.discountValue
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.paySuccess
                  ? _c("div", { staticClass: "col-sm-12 center" }, [
                      _c("img", {
                        staticClass: "img-fluid payImage",
                        attrs: {
                          src: __webpack_require__("4AGf")
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("h1", { staticClass: "center" }, [
                        _vm._v("Grazie per averci scelto, ")
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "center" }, [
                        _vm._v("il tuo pagamento è avvenuto con successo")
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary rn-btn-dark btnRed mt-5",
                          on: {
                            click: function($event) {
                              _vm.payment = true
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "hover hover-1" }, [
                            _vm._v("Procedi")
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm.payment && _vm.loaded
        ? _c("div", { staticClass: "container  mb-5 pb-5 pt-2" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12  text-left" }, [
                _c("h3", { staticClass: "Regular h0 widthFull" }, [
                  _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8 center mb-3 text-left" }, [
                _vm._m(20),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-left widthFull " }, [
                  _vm._v(
                    "\n          Prepara e carica tutti i documenti richiesti. Al termine dell caricamento ogni singolo documento clicca su pulsante CONCLUDI.\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "black mt-0 text-left widthFull " },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-2",
                      attrs: { icon: "star-of-life", size: "" }
                    }),
                    _vm._v(" "),
                    _c("b", [_vm._v("Documenti Obbligatori")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary btnRed m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\n          Indietro\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass:
                  "pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont",
                attrs: { id: "doc-form" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "row  pt-2 mb-3",
                    staticStyle: {
                      "border-bottom": "1px solid grey",
                      "padding-bottom": "0!important"
                    }
                  },
                  [
                    _vm._m(21),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-5 bordered text-center text-md-center"
                      },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "widthFull black mt-0 pt-0 docTitleMob pl-md-3"
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "mandatoryDoc",
                              staticStyle: { opacity: "0" },
                              attrs: { icon: "star-of-life", size: "xs" }
                            }),
                            _vm._v(" "),
                            _c("small", [_vm._v("Documento")])
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(22),
                    _vm._v(" "),
                    _vm._m(23),
                    _vm._v(" "),
                    _vm._m(24),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-21 col-md-1 center bordered tablePdMob"
                      },
                      [_vm._v("\n            Caricamento Concluso\n          ")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.documents, function(doc, index, k) {
                  return (doc.codice != "2050D11" ||
                    (_vm.item.dcast_export == "10" &&
                      doc.codice == "2050D11") ||
                    (_vm.item.to_get_cadastral_data == "0" &&
                      doc.codice == "2050D11")) &&
                    (doc.codice != "2050D15" ||
                      (_vm.item.enea_pdf && doc.codice == "2050D15") ||
                      (_vm.item.enea_request == "0" && doc.codice == "2050D15"))
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-center vaillantCont pt-2 pb-2",
                          class: {
                            "pt-0": k == 0,
                            even: String(k / 2).includes(".")
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-1 bordered center tablePdMob"
                            },
                            [
                              doc.mandatory == "no" && doc.codice == "2050D0B"
                                ? [
                                    !_vm.uploadFrontPercentage[index][
                                      "countImages"
                                    ] ||
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes"
                                      ? _c("img", {
                                          staticClass:
                                            "img-fluid widthFull maxBomTr",
                                          attrs: {
                                            src: __webpack_require__("9x6x")
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                : [
                                    !_vm.uploadFrontPercentage[index][
                                      "countImages"
                                    ] ||
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes"
                                      ? _c("img", {
                                          staticClass:
                                            "img-fluid widthFull maxBomTr",
                                          attrs: {
                                            src: __webpack_require__("ckMO")
                                          }
                                        })
                                      : _vm._e()
                                  ],
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: __webpack_require__("Jkjn")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: __webpack_require__("9x6x")
                                    }
                                  })
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-5 bordered text-center text-md-left"
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "widthFull black mt-0 pt-0 docTitleMob pl-md-3"
                                },
                                [
                                  doc.mandatory == "yes"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "mandatoryDoc",
                                        attrs: {
                                          icon: "star-of-life",
                                          size: "xs"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.flow == "agileenergy" &&
                                  doc.codice == "2050D06E"
                                    ? [
                                        _vm._v(
                                          " Contratto per la fornitura e l’installazione accettato e firmato dal cliente "
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.flow == "agileenergy" &&
                                  doc.codice == "2050D07A"
                                    ? [
                                        _vm._v(
                                          " Evidenze di pagamento da parte del Cliente Finale (bonifico ordinario)"
                                        )
                                      ]
                                    : [_vm._v(" " + _vm._s(doc.name) + " ")],
                                  _vm._v(" "),
                                  doc.codice == "2050D01" ||
                                  doc.codice == "2050D02" ||
                                  doc.codice == "2050D03"
                                    ? _c("span", [_c("br"), _vm._m(25, true)])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage[index][
                                    "hasError"
                                  ] == "yes"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "widthFull red mt-0 pt-0 docTitleMob pl-md-3"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Rilevata la seguente anomalia: "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.uploadFrontPercentage[index][
                                                "error"
                                              ]
                                            ) + "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.errors.has("fileInput" + index)
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback-custom" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "fileInput" + index
                                            )
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["percent"]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "progress",
                                      attrs: { id: "progFront" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "progress-bar",
                                          style: {
                                            width:
                                              _vm.uploadFrontPercentage[index][
                                                "percent"
                                              ] + "%"
                                          },
                                          attrs: {
                                            id: "progress-bar-front",
                                            role: "progressbar",
                                            "aria-valuenow": "50",
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.uploadFrontPercentage[
                                                  index
                                                ]["percent"]
                                              ) +
                                              " %\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-md-2 text-right bordered  tablePdMob",
                              class: {
                                "d-none d-md-block": doc.template == "no",
                                "d-block d-md-block": doc.template == "yes"
                              }
                            },
                            [
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice == "2050D20"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("linee guida")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice != "2050D0B" &&
                              doc.codice != "2050D20"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Modulo")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice != "2050D0B" &&
                              doc.codice != "2050D20"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0 white",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.precompileDocument(
                                            doc.codice,
                                            _vm.getProfile,
                                            _vm.item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("PRECOMPILATO")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              (_vm.getProfile.tipo_azienda !=
                                "Ditta Individuale" &&
                                _vm.getProfile.tipo_azienda !=
                                  "Professionista iscritto ad albi" &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              ((_vm.getProfile.tipo_azienda ==
                                "Ditta Individuale" ||
                                _vm.getProfile.tipo_azienda ==
                                  "Professionista iscritto ad albi") &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href:
                                          "https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf",
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: " col-md-1 bordered tablePdMob",
                              class: {
                                "col-12 center": doc.template == "no",
                                "col-6": doc.template == "yes"
                              }
                            },
                            [
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.item.status == 1 &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("div", { staticClass: "front-image2" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: doc.mandatory == "yes",
                                            size: 10240,
                                            ext: ["jpeg", "jpg", "png", "pdf"],
                                            mimes: [
                                              "image/jpeg",
                                              "image/jpg",
                                              "image/png",
                                              "application/pdf"
                                            ]
                                          },
                                          expression:
                                            "{required: doc.mandatory == 'yes',size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                        }
                                      ],
                                      ref: "fileInput" + index,
                                      refInFor: true,
                                      staticClass:
                                        "btn btn-primary btn-xl btnRed",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "fileInput" + index
                                        ),
                                        valid: !!_vm.invoiceFront,
                                        helper: !!_vm.invoiceFrontBucket
                                      },
                                      attrs: {
                                        type: "file",
                                        name: "fileInput" + index,
                                        id: "fileInput" + index,
                                        "data-vv-as": doc.name
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.uploadFile(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _vm._m(26, true)
                                  ])
                                : (_vm.uploadFrontPercentage[index][
                                    "completed"
                                  ] &&
                                    _vm.item.status == 1 &&
                                    _vm.item.hasErrors == "no") ||
                                  (_vm.item.status == 1 &&
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: {
                                        to: {
                                          name: "editDocument",
                                          params: {
                                            doc: doc,
                                            dbdoc:
                                              _vm.uploadFrontPercentage[index],
                                            item: _vm.item,
                                            docIndex: index
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Modifica\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-4 col-md-1 bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.show(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Visualizza")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "viewer",
                                {
                                  ref: "viewer" + index,
                                  refInFor: true,
                                  staticClass: "imagesViewer clearfix widthFull"
                                },
                                [
                                  _vm._l(
                                    _vm.uploadFrontPercentage[index]["images"],
                                    function(image, key) {
                                      return [
                                        image
                                          .substring(
                                            image.lastIndexOf(".") + 1,
                                            image.length
                                          )
                                          .toLowerCase() != "pdf"
                                          ? _c("img", {
                                              key: key,
                                              staticClass: "img-fluid",
                                              attrs: { src: image }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                staticClass: "pdfViewer",
                                                attrs: {
                                                  href: image,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  key: key,
                                                  staticClass: "img-fluid",
                                                  attrs: {
                                                    src: __webpack_require__("Ta3C")
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 text-center bordered tablePdMob"
                            },
                            [
                              _vm._l(
                                _vm.uploadFrontPercentage[index]["images"],
                                function(img) {
                                  return [
                                    img
                                      .substring(
                                        img.lastIndexOf(".") + 1,
                                        img.length
                                      )
                                      .toLowerCase() != "pdf"
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "docThumb",
                                            attrs: {
                                              href: img,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-alt" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "a",
                                          {
                                            staticClass: "docThumb relative",
                                            attrs: {
                                              href: img,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-pdf" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "littlePdf" },
                                              [_vm._v("PDF")]
                                            )
                                          ],
                                          1
                                        )
                                  ]
                                }
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 center bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-green btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeDocumentBlock(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Concludi")]
                                  )
                                : _vm.uploadFrontPercentage[index]["completed"]
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "check" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                ((_vm.item.dl != "old" && _vm.item.flow == "poste") ||
                  _vm.item.flow == "cdp" ||
                  _vm.item.flow == "general" ||
                  _vm.item.flow == "agileenergy" ||
                  _vm.item.flow == "mbfacta" ||
                  _vm.item.flow == "mbfacta_recovery") &&
                _vm.item.enea_request == "0"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "row justify-content-center vaillantCont pt-2 pb-2"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col-md-12 bordered center tablePdMob"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row justify-content-center  align-items-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-md-1 bordered center tablePdMob "
                                  },
                                  [
                                    _vm.item.enea_cpid
                                      ? [
                                          _vm.item.enea_cpid
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull maxBomTr",
                                                attrs: {
                                                  src: __webpack_require__("9x6x")
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      : [
                                          _c("img", {
                                            staticClass:
                                              "img-fluid widthFull maxBomTr",
                                            attrs: {
                                              src: __webpack_require__("ckMO")
                                            }
                                          })
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-5 mb-3" }, [
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "widthFull black mt-0 pt-0 pb-0 mb-0 docTitleMob pl-md-3 text-left"
                                    },
                                    [
                                      _vm.item.bonus != "Bonus Casa 50%"
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mandatoryDoc",
                                            attrs: {
                                              icon: "star-of-life",
                                              size: "xs"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                  Inserisci codice CPID della Pratica ENEA\n                "
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-5 mb-3 text-left" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "group pt-0 mt-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.enea_cpid,
                                              expression: "enea_cpid"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required:
                                                  _vm.item.bonus !=
                                                  "Bonus Casa 50%"
                                                    ? true
                                                    : false,
                                                max: 30,
                                                min: 28,
                                                regex:
                                                  "[0-9]*[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][A-Z]-[A-Z]*"
                                              },
                                              expression:
                                                "{required: item.bonus != 'Bonus Casa 50%' ? true : false, max: 30, min: 28, regex: '[0-9]*[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][A-Z]-[A-Z]*'}"
                                            }
                                          ],
                                          staticClass: "form-control pb-0 mb-0",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "enea_cpid"
                                            ),
                                            valid: !!_vm.enea_cpid,
                                            disabled: _vm.item.enea_cpid
                                          },
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.item.enea_cpid,
                                            id: "enea_cpid",
                                            name: "enea_cpid",
                                            "data-vv-as": "CPID"
                                          },
                                          domProps: { value: _vm.enea_cpid },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.enea_cpid =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel ",
                                            staticStyle: {
                                              color: "black !important",
                                              top: "0px",
                                              left: "5px"
                                            },
                                            attrs: { for: "name" }
                                          },
                                          [_vm._v("CPID *")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("enea_cpid")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "enea_cpid"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-1 mb-3 text-center" },
                                  [
                                    !_vm.item.enea_cpid
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-green btn-xl",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveCpid()
                                              }
                                            }
                                          },
                                          [_vm._v("Concludi")]
                                        )
                                      : _vm.item.enea_cpid
                                      ? _c("font-awesome-icon", {
                                          attrs: { icon: "check" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.item.aditional_enea_data == null ||
                  _vm.item.aditional_enea_data == "") &&
                _vm.item.enea_request == "1"
                  ? _c("div", { staticClass: "col-md-12 center mb-4" }, [
                      _c(
                        "h5",
                        { staticClass: "Regular text-center h0 widthFull " },
                        [
                          _vm._m(27),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary m-2 btn-sm",
                              attrs: {
                                to: {
                                  name: "complateEneaData",
                                  params: { item: _vm.item }
                                }
                              }
                            },
                            [_vm._v("\n            Inserisci Dati\n          ")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.status == 1
                  ? _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-12 text-right" },
                        [
                          !_vm.preSend
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btnRed",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.preSendPracticeToKPMG()
                                    }
                                  }
                                },
                                [_vm._v("Avanti")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.preSend
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btnRed",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.sendPracticeToKPMG()
                                    }
                                  }
                                },
                                [_vm._v("Procedi")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                           false
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "widthFull requiredCont p-4 mt-4 text-left"
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      "Ti informiamo che è in programma un aggiornamento informatico da parte del nostro partner KPMG che migliorerà ulteriormente la tua esperienza utente sulla piattaforma"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.brand == "CHEBONUS"
                                    ? _c("b", { staticClass: "green" }, [
                                        _vm._v("Vaillant CheBonus")
                                      ])
                                    : _c("b", { staticClass: "red" }, [
                                        _vm._v(
                                          "Hermann Saunier Duval HappyBonus"
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "Ci scusiamo per l'eventuale disagio, con l'obiettivo di migliorare sempre di più la tua soddisfazione ed esperienza sulla piattaforma\n            "
                                  ),
                                  _vm.brand == "CHEBONUS"
                                    ? _c("b", { staticClass: "green" }, [
                                        _vm._v("Vaillant CheBonus")
                                      ])
                                    : _c("b", { staticClass: "red" }, [
                                        _vm._v(
                                          "Hermann Saunier Duval HappyBonus"
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "Per procedere all'inoltro delle pratiche ti suggeriamo di riprovare a partire dalle ore 18:00 del 08/11/2021.\n\n          "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var loadDocuments_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-3 text-center" }, [
      _c("h4", { staticClass: "Regular text-center h0 widthFull " }, [
        _c("b", [
          _vm._v(
            "Avvertenza per Decreto Legge dell’11 Novembre 2021 n. 157 relativo al contrasto alle frodi  "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 text-center widthFull " })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-12 center mb-0 vaillantCont text-left" },
      [
        _c("h4", { staticClass: "Regular text-center h0 widthFull " }, [
          _c("b", [
            _vm._v(
              " Per procedere con la tua pratica scegli il riquadro che è idoneo alla tua documentazione"
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-3 text-center" }, [
      _c("h4", { staticClass: "Regular text-center h0 widthFull " }, [
        _c("b", [
          _vm._v(
            "Avvertenza per Decreto Legge dell’11 Novembre 2021 n. 157 relativo al contrasto alle frodi  "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 text-center widthFull " })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-12 center mb-0 vaillantCont text-left" },
      [
        _c(
          "h4",
          { staticClass: "Regular text-center h0 widthFull uppercase" },
          [_c("b", [_vm._v(" Integrazione ")])]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(" Visto di conformità (IVA Esclusa) ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0 red" }, [_vm._v(" Sconto ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v(" IVA 22% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 borderTopBlack text-left" }, [
      _c("h5", { staticClass: " text-right mb-4" }, [
        _vm._v(
          "\n                        TOTALE (IVA inclusa)\n                      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center  mb-3 mt-0 pt-0" }, [
      _c("b", [_vm._v("Paga con")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 center mb-3 text-left" }, [
      _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
        _c("b", [
          _vm._v(
            " Per completare la tua pratica, paga il servizio con una Carta, PayPal o Bonifico Bancario (SOFORT) "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 text-left widthFull " }, [
        _vm._v(
          "\n          Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(" Prezzo Servizio/Pratica (IVA Esclusa) ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(" Visto conformità (IVA Esclusa) ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0 red" }, [_vm._v(" Sconto ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v(" IVA 22% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left borderTopBlack" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(
          "Prezzo Servizio di redazione e invio pratica ENEA (IVA Esclusa) "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v(" IVA 22% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left borderTopBlack" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(' Prezzo Servizio "Visura Catastale" (IVA Esclusa) ')
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v(" IVA 22% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 borderTopBlack text-left" }, [
      _c("h5", { staticClass: " text-right mb-4" }, [
        _vm._v("\n                    TOTALE (IVA inclusa)\n                  ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center  mb-3 mt-0 pt-3" }, [
      _c("b", [_vm._v("Paga con")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
      _c("b", [_vm._v(" Gestione Documenti ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-md-1 bordered text-center tablePdMob" },
      [_c("small", [_vm._v("Stato ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-md-1 text-center bordered tablePdMob" },
      [_c("small", [_vm._v("Informazioni")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-md-3 center bordered tablePdMob" },
      [
        _c("small", [
          _vm._v("Carica/modifica Documento\n              "),
          _c("br"),
          _vm._v("(solo formati: JPG,PNG,PDF)\n            ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-md-1 text-center bordered tablePdMob" },
      [_c("small", [_vm._v("File Documento")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _c("b", [
        _vm._v(
          "Per le Pratiche con “data fattura” antecedente al 4 aprile potrà essere caricato un documento “blank” vuoto."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel2 labelFileInput",
        attrs: { for: "invoiceFront" }
      },
      [_c("span", { staticClass: "smallText center white" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c("span", { staticClass: "yellow" }, [_vm._v("Attenzione!")]),
      _vm._v(
        " Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni "
      )
    ])
  }
]
loadDocuments_render._withStripped = true
var loadDocuments_esExports = { render: loadDocuments_render, staticRenderFns: loadDocuments_staticRenderFns }
/* harmony default export */ var components_loadDocuments = (loadDocuments_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38471c95", loadDocuments_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/loadDocuments/index.vue
var loadDocuments_disposed = false
function loadDocuments_injectStyle (ssrContext) {
  if (loadDocuments_disposed) return
  __webpack_require__("7EV4")
}
var loadDocuments_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loadDocuments___vue_template_functional__ = false
/* styles */
var loadDocuments___vue_styles__ = loadDocuments_injectStyle
/* scopeId */
var loadDocuments___vue_scopeId__ = "data-v-38471c95"
/* moduleIdentifier (server only) */
var loadDocuments___vue_module_identifier__ = null
var loadDocuments_Component = loadDocuments_normalizeComponent(
  loadDocuments,
  components_loadDocuments,
  loadDocuments___vue_template_functional__,
  loadDocuments___vue_styles__,
  loadDocuments___vue_scopeId__,
  loadDocuments___vue_module_identifier__
)
loadDocuments_Component.options.__file = "src/components/loadDocuments/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38471c95", loadDocuments_Component.options)
  } else {
    hotAPI.reload("data-v-38471c95", loadDocuments_Component.options)
  }
  module.hot.dispose(function (data) {
    loadDocuments_disposed = true
  })
})()}

/* harmony default export */ var src_components_loadDocuments = (loadDocuments_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/editDocuments/index.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var editDocuments_moment = __webpack_require__("PJh5");

var editDocuments_viewer = __webpack_require__("EAZf");

/* harmony default export */ var editDocuments = ({
  name: 'loadDocuments',
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      token: '',
      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      cellulare: '',
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      client_ownership: '',
      subalterno: '',
      particella: '',
      savedDocuments: {},
      foglio: ''
    }, defineProperty_default()(_ref, 'item', ''), defineProperty_default()(_ref, 'dbdoc', ''), defineProperty_default()(_ref, 'doc', ''), defineProperty_default()(_ref, 'docIndex', ''), _ref;
  },

  methods: {
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      console.log(viewer);

      console.log("ZOOOOOM");

      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show(index) {
      console.log(this);
      var el = this.$refs['viewer' + index];

      console.log(this.$refs);

      console.log(el[0]);

      //const viewerV = el.$viewer

      el[0].destroyViewer();

      el[0].createViewer();

      el[0].$viewer.show();
      //viewer.zoomTo(2)
      //	viewer.move(-1, 0);
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    },
    removeDocument: function removeDocument(docIndex, code, name, codice, id, index) {
      var _this = this;

      var _vue = this;

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: '<br/>Sei sicuro di voler eliminare File ' + index + ' del documento ' + name + ' ?<br/><br/>',
        showCancelButton: true,
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        console.log(result);
        if (result.value) {
          _this.loadingState = true;
          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/removeDocument',
            method: 'POST',
            data: {
              docIndex: docIndex,
              code: code,
              name: name,
              codice: codice,
              id: id
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            console.log(1);
            _this.loadingState = false;
            var obj = _vue.dbdoc['images'];

            for (var x in obj) {
              if (x == id) {
                delete obj[x];
                delete _vue.dbdoc['images'][x];
              }
            }

            _vue.dbdoc['countImages'] = _vue.dbdoc['countImages'] - 1;
          }).catch(function (resp) {

            _this.loadingState = false;
          });
        }
      });
    },
    uploadFile: function uploadFile(doc, code, name, docCode, completed) {

      console.log(this.$refs['fileInput' + doc]);
      var input = this.$refs['fileInput' + doc];

      console.log(input);

      console.log(doc);
      console.log(code);
      console.log(name);
      console.log(docCode);

      var ind = doc;
      console.log(0);
      var file = input.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.files[0].size;
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append('fattura0', input.files[0]);

        console.log(this.uploadFrontPercentage);

        formData.append('doc', doc);
        formData.append('code', code);
        formData.append('name', name);
        formData.append('docCode', docCode);
        formData.append('completed', completed);

        console.log(1);

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadDocument', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {

            var r = 0;
            r = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
            //  Object.assign(this.uploadFrontPercentage, r)

            vue_esm["a" /* default */].set(this.dbdoc, 'percent', r);

            //  this.uploadFrontPercentage[ind]['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          console.log(2);
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.document)) {
            _vue.dbdoc['percent'] = 0;

            var x = _vue.dbdoc['images'];

            x[e.data.id] = e.data.document;

            _vue.dbdoc['images'] = x;

            _vue.dbdoc['countImages'] = _vue.dbdoc['countImages'] + 1;

            //_vue.invoiceFrontBucket = e.data.fattura
          } else {
            _vue.dbdoc['percent'] = 0;
            //_vue.invoiceFront = ''
            //_vue.invoiceFrontBucket = ''

            //input.value = null
          }

          _vue.getDocuments(_vue.item.code, _vue.item.user_token);
        }).catch(function () {
          _vue.dbdoc['percent'] = 0;
          //  _vue.invoiceFront = ''
          ///  _vue.invoiceFrontBucket = ''

          //input.value = null
        });
      }
    },
    getDocuments: function getDocuments(code, user_token) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getDocumentsByCode',
                  method: 'POST',
                  data: {
                    code: code,
                    user_token: user_token
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  //console.log( resp.data.documents )
                  var docs = resp.data.documents;
                  _this2.dbdoc.images = {};
                  var y = 0;
                  for (var x in docs) {
                    if (docs[x].codice == _this2.docIndex) {
                      _this2.dbdoc.images[docs[x].id] = docs[x].url;
                      _this2.dbdoc.countImages = _this2.dbdoc.countImages + 1;
                      y = y + 1;
                    }
                  }

                  //console.log( this.dbdoc )
                  //console.log( this.doc )
                  //console.log( this.docIndex )
                }).catch(function (resp) {
                  //this.savedDocuments = {}
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  watch: {},
  created: function created() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  mounted: function mounted() {
    console.log(this.$route.params);

    if (this.$route.params.item) {
      this.item = this.$route.params.item;

      this.dbdoc = this.$route.params.dbdoc;
      this.doc = this.$route.params.doc;
      this.docIndex = this.$route.params.docIndex;

      if (this.item && this.item.client_type != 'Amministratore di condominio') {
        this.address = this.item.building_address;
        this.civic = this.item.building_civic;
      }
    } else {
      this.$router.push('/pratiche');
    }

    this.$scrollTo('#app', 700, { offset: -75 });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4811f8f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editDocuments/index.vue
var editDocuments_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-8 text-left mb-3" }, [
            _c("h3", { staticClass: "Regular h0 widthFull" }, [
              _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
              _vm._v(" Modifica Documento: "),
              _c("b", [_vm._v(" " + _vm._s(_vm.doc.name) + " ")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
              _vm._v(
                "\n          In questa pagina puoi eliminare i documenti caricati e aggiungerne di nuovi.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-4 pt-4 center mb-3 text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary btnRed m-2 btn-sm ml-md-5",
                  attrs: {
                    to: { name: "loadDocuments", params: { item: _vm.item } }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "arrow-left", size: "1x" }
                  }),
                  _vm._v("\n          Indietro\n        ")
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "pb-5 pt-3 black widthFull vaillantCont",
            attrs: { id: "doc-form" }
          },
          [
            _c(
              "div",
              { staticClass: "row justify-content-center text-left pl-4 pr-4" },
              [
                _c("div", { staticClass: "col-md-8 center mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center text-left" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._l(_vm.dbdoc.images, function(url, key, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-6 col-md-4 center mb-5"
                          },
                          [
                            _c("p", { staticClass: "pb-1 mb-1" }, [
                              _vm._v("File " + _vm._s(index + 1) + " ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "viewer",
                              {
                                ref: "viewer" + key,
                                refInFor: true,
                                staticClass: " clearfix widthFull",
                                on: { inited: _vm.inited }
                              },
                              [
                                _c("img", {
                                  key: key,
                                  staticClass: "img-fluid editImageCont",
                                  attrs: { src: url }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-xl mt-3",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.show(key)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "eye", size: "sm" }
                                }),
                                _vm._v(" Visualizza\n              ")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-xl  mt-3",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeDocument(
                                      _vm.docIndex,
                                      _vm.item.code,
                                      _vm.doc.name,
                                      _vm.doc.codice,
                                      key,
                                      index
                                    )
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "trash-alt", size: "sm" }
                                }),
                                _vm._v(" Elimina\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4 center mb-3 even" }, [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center text-left" },
                    [
                      _c("div", { staticClass: "col-md-12 center mb-3" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "front-image" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: false,
                                  size: 10240,
                                  ext: ["jpeg", "jpg", "png", "pdf"],
                                  mimes: [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/pdf"
                                  ]
                                },
                                expression:
                                  "{required:false,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                              }
                            ],
                            ref: "fileInput" + _vm.docIndex,
                            staticClass: "fileInput",
                            class: {
                              "is-invalid": _vm.errors.has("invoiceFront"),
                              valid: !!_vm.invoiceFront,
                              helper: !!_vm.invoiceFrontBucket
                            },
                            attrs: {
                              type: "file",
                              name: "invoiceFront",
                              id: "invoiceFront",
                              "data-vv-as": "Logo"
                            },
                            on: {
                              change: function($event) {
                                return _vm.uploadFile(
                                  _vm.docIndex,
                                  _vm.item.code,
                                  _vm.doc.name,
                                  _vm.doc.codice,
                                  _vm.dbdoc.completed
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel labelFileInput",
                              attrs: { for: "invoiceFront" }
                            },
                            [
                              !_vm.invoiceFrontName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "smallText center white mt-3 mb-0 pb-0"
                                            },
                                            [
                                              _vm._v(
                                                "Scegli il Contratto quadro*"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "smallText center white",
                                    style: {
                                      backgroundImage:
                                        "url(" + _vm.invoiceFrontBucket + ")"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("invoiceFront")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.errors.first("invoiceFront")) +
                                    "\n                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dbdoc.percent
                            ? _c(
                                "div",
                                {
                                  staticClass: "progress mt-5",
                                  attrs: { id: "progFront" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar ",
                                      style: { width: _vm.dbdoc.percent + "%" },
                                      attrs: {
                                        id: "progress-bar-front",
                                        role: "progressbar",
                                        "aria-valuenow": "50",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.dbdoc.percent) +
                                          " %\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceFrontName
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                },
                                [_vm._v(_vm._s(_vm.invoiceFrontName))]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(2)
                    ]
                  )
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var editDocuments_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-3" }, [
      _c("h5", { staticClass: "Regular" }, [_c("b", [_vm._v("File caricati")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "Regular" }, [
      _c("b", [_vm._v("Carica nuovo File")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 center mt-5 mb-3" }, [
      _c("small", [
        _vm._v(
          "\n                Il documento può essere caricato nei formati jpeg, pdf, png, jpg (max 10MB)\n              "
        )
      ])
    ])
  }
]
editDocuments_render._withStripped = true
var editDocuments_esExports = { render: editDocuments_render, staticRenderFns: editDocuments_staticRenderFns }
/* harmony default export */ var components_editDocuments = (editDocuments_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4811f8f1", editDocuments_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/editDocuments/index.vue
var editDocuments_disposed = false
function editDocuments_injectStyle (ssrContext) {
  if (editDocuments_disposed) return
  __webpack_require__("ZDvS")
}
var editDocuments_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editDocuments___vue_template_functional__ = false
/* styles */
var editDocuments___vue_styles__ = editDocuments_injectStyle
/* scopeId */
var editDocuments___vue_scopeId__ = "data-v-4811f8f1"
/* moduleIdentifier (server only) */
var editDocuments___vue_module_identifier__ = null
var editDocuments_Component = editDocuments_normalizeComponent(
  editDocuments,
  components_editDocuments,
  editDocuments___vue_template_functional__,
  editDocuments___vue_styles__,
  editDocuments___vue_scopeId__,
  editDocuments___vue_module_identifier__
)
editDocuments_Component.options.__file = "src/components/editDocuments/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4811f8f1", editDocuments_Component.options)
  } else {
    hotAPI.reload("data-v-4811f8f1", editDocuments_Component.options)
  }
  module.hot.dispose(function (data) {
    editDocuments_disposed = true
  })
})()}

/* harmony default export */ var src_components_editDocuments = (editDocuments_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
	name: 'confirm',
	components: {},
	data: function data() {

		return {
			result: 'Verifica Token',
			status: false,
			loading: false
		};
	},

	methods: {
		confirm: function confirm() {
			var _this = this;

			var token = this.$route.query.token;
			if (token) {
				this.loading = true;
				axios_default()({
					url: "https://wsbot.eu/21005back/public/" + 'fapi/confirmAccount',
					data: {
						token: token
					},
					method: 'POST',
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this.status = true;
					_this.loading = false;
					_this.result = 'Il tuo account è stato attivato.';
				}).catch(function (resp) {
					_this.loading = false;
					_this.result = "Token non presente";
				});
			} else {
				this.result = "Token non presente";
			}
		}
	},
	beforeMount: function beforeMount() {
		this.confirm();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0a1213a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirm/index.vue
var confirm_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container whiteCont mt-5 mb-5" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center verticalCentred" },
          [
            _c("div", { staticClass: "col-6 mt-5 pt-5" }, [
              _c(
                "h1",
                {
                  staticClass: "mb-5 center",
                  attrs: { type: "text" },
                  model: {
                    value: _vm.result,
                    callback: function($$v) {
                      _vm.result = $$v
                    },
                    expression: "result"
                  }
                },
                [_vm._v(_vm._s(_vm.result))]
              ),
              _vm._v(" "),
              _vm.status
                ? _c(
                    "div",
                    { staticClass: "mt-5 center" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-primary btn-lg",
                          attrs: { to: "/login" }
                        },
                        [_vm._v("Accedi")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ],
    1
  )
}
var confirm_staticRenderFns = []
confirm_render._withStripped = true
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_confirm = (confirm_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0a1213a", confirm_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/confirm/index.vue
var confirm_disposed = false
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = null
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  components_confirm,
  selectortype_template_index_0_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)
confirm_Component.options.__file = "src/components/confirm/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0a1213a", confirm_Component.options)
  } else {
    hotAPI.reload("data-v-c0a1213a", confirm_Component.options)
  }
  module.hot.dispose(function (data) {
    confirm_disposed = true
  })
})()}

/* harmony default export */ var src_components_confirm = (confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forgotpassword/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var forgotpassword = ({
		name: 'forgotpassword',
		components: {},
		data: function data() {
				return {
						username: '',
						state: false,
						error: '',
						loading: false,
						brand: "CHEBONUS"
				};
		},

		methods: {
				forgot: function forgot() {
						var _this = this;

						var username = this.username;

						this.$validator.validate().then(function (valid) {
								if (valid) {
										_this.loading = true;
										axios_default()({
												url: "https://wsbot.eu/21005back/public/" + 'fapi/send_forgot_pass_email',
												data: {
														email: username
												},
												method: 'POST',
												headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
												if (resp.data.error == "") {
														_this.state = true;
												}
												if (resp.data.error == "email_not_present") {
														_this.state = false;
														_this.error = "Indirizzo e-mail non presente in nostra sistema";
												}

												if (resp.data.error == "account_not_confirmed") {
														_this.state = false;
														_this.error = 'Attenzione! Non hai confermato il tuo account';
												}
												_this.loading = false;
										}).catch(function (resp) {
												_this.state = false;
												_this.error = "Indirizzo e-mail non presente in nostra sistema";
												_this.loading = false;
										});
								}
						});
				}
		},
		mounted: function mounted() {
				this.$scrollTo('#app', 700, {
						offset: -775
				});
		},

		computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
				//login_error: state => `${state.login_error}`,
		}))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea681d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forgotpassword/index.vue
var forgotpassword_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mb-5 pb-5 vaillantCont" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9 col-md-5 pt-4" }, [
            _c(
              "form",
              {
                staticClass: "forgot-password mt-3  pt-4 pb-4",
                attrs: { id: "forgot-form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.forgot($event)
                  }
                }
              },
              [
                !_vm.state
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12 mb-3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "group custInput ",
                                class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.username,
                                      expression: "username"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        email: true,
                                        temporaryEmail: true,
                                        plusIssueEmail: true,
                                        max: 56
                                      },
                                      expression:
                                        "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("username"),
                                    valid: !!_vm.username
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "username",
                                    name: "username",
                                    "data-vv-as": "Email"
                                  },
                                  domProps: { value: _vm.username },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.username = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "username" }
                                  },
                                  [_vm._v("Email")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("username")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.errors.first("username")
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.error
                                  ? _c(
                                      "div",
                                      { staticClass: "mb-3 text-left" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "errorMes ml-1" },
                                          [_vm._v(_vm._s(_vm.error))]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-12 mb-3 mt-3 text-center " },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btm-lg",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { type: "submit" }
                                },
                                [_vm._v("Invia")]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  : _c("div", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-12 mb-3 text-center" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary btn-lg mt-4",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { to: "/" }
                                },
                                [_vm._v("Continua")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var forgotpassword_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12 col-md-12" }, [
      _c("h3", { staticClass: "Bold center pt-5 widthFull" }, [
        _c("strong", [_vm._v("Recupero Password")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c(
        "label",
        { staticClass: "widthFull text-center", attrs: { for: "email" } },
        [
          _c("h5", { staticClass: "Regular black widthFull text-center" }, [
            _vm._v(
              "Inserisci l'indirizzo email che hai inserito in fase di registrazione, e clicca Invia"
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "Regular black widthFull text-center mt-3" }, [
            _vm._v(
              "Ti sarà inviata una email con il link per recuperare la tua password."
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 mb-3 mt-3" }, [
        _c(
          "h5",
          {
            staticClass: "center pl-4 pr-4",
            attrs: { for: "email", role: "alert" }
          },
          [
            _c("p", { staticClass: "black" }, [
              _vm._v(
                "Ti è stata inviata una mail con il link per reimpostare la tua password di accesso,controlla nella tua posta in arrivo."
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black" }, [
              _vm._v(
                "Se non dovessi trovarla controlla anche nella casella spam."
              )
            ])
          ]
        )
      ])
    ])
  }
]
forgotpassword_render._withStripped = true
var forgotpassword_esExports = { render: forgotpassword_render, staticRenderFns: forgotpassword_staticRenderFns }
/* harmony default export */ var components_forgotpassword = (forgotpassword_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ea681d1", forgotpassword_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/forgotpassword/index.vue
var forgotpassword_disposed = false
var forgotpassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var forgotpassword___vue_template_functional__ = false
/* styles */
var forgotpassword___vue_styles__ = null
/* scopeId */
var forgotpassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var forgotpassword___vue_module_identifier__ = null
var forgotpassword_Component = forgotpassword_normalizeComponent(
  forgotpassword,
  components_forgotpassword,
  forgotpassword___vue_template_functional__,
  forgotpassword___vue_styles__,
  forgotpassword___vue_scopeId__,
  forgotpassword___vue_module_identifier__
)
forgotpassword_Component.options.__file = "src/components/forgotpassword/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ea681d1", forgotpassword_Component.options)
  } else {
    hotAPI.reload("data-v-5ea681d1", forgotpassword_Component.options)
  }
  module.hot.dispose(function (data) {
    forgotpassword_disposed = true
  })
})()}

/* harmony default export */ var src_components_forgotpassword = (forgotpassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/recoverypassword/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var recoverypassword = ({
		name: 'recoverypassword',
		components: {},
		data: function data() {
				return {
						password: '',
						confirm_password: '',
						state: false,
						error: '',
						loading: false,
						brand: "CHEBONUS"
				};
		},

		methods: {
				recovery: function recovery() {
						var _this = this;

						var password = this.password,
						    confirm_password = this.confirm_password;

						var token = this.$route.query.token;

						this.$validator.validate().then(function (valid) {
								if (valid && token) {
										_this.loading = true;
										axios_default()({
												url: "https://wsbot.eu/21005back/public/" + 'fapi/change_password',
												data: {
														password: password,
														token: token
												},
												method: 'POST',
												headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
												_this.state = true;
												_this.loading = false;
										}).catch(function (resp) {
												_this.state = false;
												_this.error = "Il token scaduto o non presente";
												_this.loading = false;
										});
								}
						});
				}
		},
		computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'loadingState', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
				//login_error: state => `${state.login_error}`,
		}))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264227c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recoverypassword/index.vue
var recoverypassword_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mb-5" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "row justify-content-center verticalCentred vaillantCont"
          },
          [
            _c("div", { staticClass: "col-sm-9 col-md-5 pt-4 " }, [
              _c("div", { staticClass: "container-fluid" }, [
                _c(
                  "form",
                  {
                    staticClass: "recovery-password  pb-4",
                    attrs: { id: "recovery-form" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.recovery($event)
                      }
                    }
                  },
                  [
                    !_vm.state
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "form-row justify-content-center" },
                            [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "group custInput mt-5",
                                    class: {
                                      inputHSD: _vm.brand == "HAPPYBONUS"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.password,
                                          expression: "password"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            passwordCheck: true,
                                            min: 8,
                                            max: 56
                                          },
                                          expression:
                                            "{required:true, passwordCheck: true, min: 8, max: 56}"
                                        }
                                      ],
                                      staticClass: "form-control mt-1",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "password"
                                        ),
                                        valid: !!_vm.password
                                      },
                                      attrs: {
                                        type: "password",
                                        id: "password",
                                        name: "password"
                                      },
                                      domProps: { value: _vm.password },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.password = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: { for: "password" }
                                      },
                                      [_vm._v("Nuova Password")]
                                    ),
                                    _vm._v(" "),
                                    _vm.errors.has("password")
                                      ? _c(
                                          "div",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.errors.first("password")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "group custInput mt-5",
                                    class: {
                                      inputHSD: _vm.brand == "HAPPYBONUS"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.confirm_password,
                                          expression: "confirm_password"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            passwordCheck: true,
                                            min: 8,
                                            max: 56
                                          },
                                          expression:
                                            "{required:true, passwordCheck: true, min: 8, max: 56}"
                                        }
                                      ],
                                      staticClass: "form-control mt-3",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "confirm_password"
                                        ),
                                        valid: !!_vm.confirm_password
                                      },
                                      attrs: {
                                        type: "password",
                                        id: "confirm_password",
                                        name: "confirm_password",
                                        "data-vv-as": "conferma password"
                                      },
                                      domProps: { value: _vm.confirm_password },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.confirm_password =
                                            $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: { for: "password" }
                                      },
                                      [_vm._v("Conferma Nuova Password")]
                                    ),
                                    _vm._v(" "),
                                    _vm.errors.has("confirm_password")
                                      ? _c(
                                          "div",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "confirm_password"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.error
                                      ? _c("div", { staticClass: "mt-3" }, [
                                          _c(
                                            "span",
                                            { staticClass: "formError ml-1" },
                                            [_vm._v(_vm._s(_vm.error))]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row justify-content-center" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 mb-3 mt-5 text-center"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary  btn-lg",
                                      class: {
                                        btnHSDRed: _vm.brand == "HAPPYBONUS"
                                      },
                                      attrs: { type: "submit" }
                                    },
                                    [_vm._v("CONFERMA")]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _c("div", [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row justify-content-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-12 mb-3 text-center" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary btn-lg",
                                      class: {
                                        btnHSDRed: _vm.brand == "HAPPYBONUS"
                                      },
                                      attrs: { to: "/login" }
                                    },
                                    [_vm._v("Accedi")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var recoverypassword_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 center " }, [
        _c(
          "h3",
          { staticClass: "Bold center pb-4 mt-5 subtitle fancy widthFull" },
          [_c("strong", [_vm._v("Reimposta Password")])]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 mb-5 mt-5" }, [
        _c(
          "h5",
          {
            staticClass: "center widthFull",
            attrs: { for: "email", role: "alert" }
          },
          [
            _c("p", { staticClass: "black" }, [
              _vm._v("La password è stata aggiornata correttamente,")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black" }, [
              _vm._v("adesso puoi accedere utilizzando la tua nuova password..")
            ])
          ]
        )
      ])
    ])
  }
]
recoverypassword_render._withStripped = true
var recoverypassword_esExports = { render: recoverypassword_render, staticRenderFns: recoverypassword_staticRenderFns }
/* harmony default export */ var components_recoverypassword = (recoverypassword_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-264227c3", recoverypassword_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/recoverypassword/index.vue
var recoverypassword_disposed = false
var recoverypassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recoverypassword___vue_template_functional__ = false
/* styles */
var recoverypassword___vue_styles__ = null
/* scopeId */
var recoverypassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var recoverypassword___vue_module_identifier__ = null
var recoverypassword_Component = recoverypassword_normalizeComponent(
  recoverypassword,
  components_recoverypassword,
  recoverypassword___vue_template_functional__,
  recoverypassword___vue_styles__,
  recoverypassword___vue_scopeId__,
  recoverypassword___vue_module_identifier__
)
recoverypassword_Component.options.__file = "src/components/recoverypassword/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-264227c3", recoverypassword_Component.options)
  } else {
    hotAPI.reload("data-v-264227c3", recoverypassword_Component.options)
  }
  module.hot.dispose(function (data) {
    recoverypassword_disposed = true
  })
})()}

/* harmony default export */ var src_components_recoverypassword = (recoverypassword_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/showProducts/index.vue
var showProducts = __webpack_require__("UqUd");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7191a0d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/showProducts/index.vue
var showProducts_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fullWidth logo center", attrs: { id: "report" } },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "constainer-fluid dataContainer " },
        [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("h1", { staticClass: "Peace center violet widthFull" }, [
              _vm._v("Prodotti Caricati")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-9" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c(
                "form",
                {
                  staticClass: "form-inline d-flex mx-1 justify-content-end",
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.doSearch($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quickSearch,
                          expression: "quickSearch"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "search", placeholder: "Cerca" },
                      domProps: { value: _vm.quickSearch },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.quickSearch = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("vdtnet-table", {
            ref: "table",
            attrs: {
              fields: _vm.fields,
              url: _vm.url,
              opts: _vm.options,
              "select-checkbox": 0,
              "container-classname": ""
            },
            on: {
              edit: _vm.doAlertEdit,
              reloaded: _vm.doAfterReload,
              "table-creating": _vm.doCreating,
              "table-created": _vm.doCreated
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var showProducts_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-outline-secondary", attrs: { type: "submit" } },
        [
          _c("i", { staticClass: "mdi mdi-magnify" }),
          _vm._v(" Go\n              ")
        ]
      )
    ])
  }
]
showProducts_render._withStripped = true
var showProducts_esExports = { render: showProducts_render, staticRenderFns: showProducts_staticRenderFns }
/* harmony default export */ var components_showProducts = (showProducts_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7191a0d4", showProducts_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/showProducts/index.vue
var showProducts_disposed = false
function showProducts_injectStyle (ssrContext) {
  if (showProducts_disposed) return
  __webpack_require__("DjRw")
}
var showProducts_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var showProducts___vue_template_functional__ = false
/* styles */
var showProducts___vue_styles__ = showProducts_injectStyle
/* scopeId */
var showProducts___vue_scopeId__ = "data-v-7191a0d4"
/* moduleIdentifier (server only) */
var showProducts___vue_module_identifier__ = null
var showProducts_Component = showProducts_normalizeComponent(
  showProducts["a" /* default */],
  components_showProducts,
  showProducts___vue_template_functional__,
  showProducts___vue_styles__,
  showProducts___vue_scopeId__,
  showProducts___vue_module_identifier__
)
showProducts_Component.options.__file = "src/components/showProducts/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7191a0d4", showProducts_Component.options)
  } else {
    hotAPI.reload("data-v-7191a0d4", showProducts_Component.options)
  }
  module.hot.dispose(function (data) {
    showProducts_disposed = true
  })
})()}

/* harmony default export */ var src_components_showProducts = (showProducts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pratiche/index.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var pratiche_moment = __webpack_require__("PJh5");

/* harmony default export */ var pratiche = ({
  name: 'Practics',
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"],
    Pagination: main_default.a
  },
  data: function data() {
    var _ref;

    return _ref = {
      token: '',
      loadingState: false,
      lotOfData: false,
      loading: false,
      practices: {},
      countloop: 1,
      moment: __webpack_require__("PJh5"),
      presentPractices: true,
      countPractices: 0,
      countCashClient: 0,
      countCashInst: 0,
      practicesFiltred: {},
      filter: false
    }, defineProperty_default()(_ref, 'moment', __webpack_require__("PJh5")), defineProperty_default()(_ref, 'maxTotCash', 1000000), defineProperty_default()(_ref, 'totCash', 0), defineProperty_default()(_ref, 'step', 1000), defineProperty_default()(_ref, 'showFilterText', false), defineProperty_default()(_ref, 'countErrorPractice', 0), defineProperty_default()(_ref, 'totErrorCashClient', 0), defineProperty_default()(_ref, 'totErrorCashInst', 0), defineProperty_default()(_ref, 'countStep1Practice', 0), defineProperty_default()(_ref, 'totStep1CashClient', 0), defineProperty_default()(_ref, 'totStep1CashInst', 0), defineProperty_default()(_ref, 'countStep2Practice', 0), defineProperty_default()(_ref, 'totStep2CashClient', 0), defineProperty_default()(_ref, 'totStep2CashInst', 0), defineProperty_default()(_ref, 'countStep3Practice', 0), defineProperty_default()(_ref, 'totStep3CashClient', 0), defineProperty_default()(_ref, 'totStep3CashInst', 0), defineProperty_default()(_ref, 'countStep4Practice', 0), defineProperty_default()(_ref, 'totStep4CashClient', 0), defineProperty_default()(_ref, 'totStep4CashInst', 0), defineProperty_default()(_ref, 'totUserReceived', 0), defineProperty_default()(_ref, 'totAmountBefore10', 0), defineProperty_default()(_ref, 'totAmountAfter10', 0), defineProperty_default()(_ref, 'hasRemovedPractics', false), defineProperty_default()(_ref, 'length', 0), defineProperty_default()(_ref, 'filter', ''), defineProperty_default()(_ref, 'filterVal', ''), defineProperty_default()(_ref, 'counts', {
      countCashClient: "0",
      countCashInst: "0",
      countErrorPractice: "0",
      countPractices: "0",
      countStep1Practice: "0",
      countStep2Practice: "0",
      countStep3Practice: "0",
      countStep4Practice: "0",
      sumTotal: "0",
      hasRemovedPractics: '0'
    }), defineProperty_default()(_ref, 'displayPerPage', 10), defineProperty_default()(_ref, 'page', 1), defineProperty_default()(_ref, 'loaded', false), defineProperty_default()(_ref, 'loadedCount', false), defineProperty_default()(_ref, 'filterType', false), defineProperty_default()(_ref, 'practicesFiltredCount', 0), defineProperty_default()(_ref, 'flow_cdp_active', false), defineProperty_default()(_ref, 'cdp_not_active_text', "Al momento il flusso CDP è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di CDP."), defineProperty_default()(_ref, 'flow_poste_active', false), defineProperty_default()(_ref, 'poste_not_active_text', "Al momento il flusso Poste Italiane è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di Poste Italiane."), _ref;
  },

  methods: {
    // NEW PAGINATION

    checkEneaComplate: function checkEneaComplate(val) {
      if (val) {
        if (val.includes('"status":"success"')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    searchBy: function searchBy(type, filter) {

      this.page = 1;
      this.getPractices(type, filter);

      if (filter == '10' || filter == '9') {
        this.hasRemovedPractics = true;
      } else {
        this.hasRemovedPractics = false;
      }
    },


    callback: function callback(page) {
      console.log('CHANGE PAGE => To: ' + page);
      this.page = page;
      this.getPractices(this.filterType, this.filterVal);
    },

    getPractices: function getPractices(type, filter) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _vue, token;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('SEARCH BY => ' + type + ' / ' + filter);
                _vue = _this;

                _vue.practicesFiltred = {};

                _vue.showFilterText = false;

                if (type && type != '') {
                  _this.filterType = type;
                } else {
                  _this.filterType = false;
                }

                if (filter && filter != '') {
                  _this.filterVal = filter;
                } else {
                  _this.filterVal = '';
                }

                _this.loadingState = true;
                token = _vue.getProfile.userToken;

                if (!token) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getPracticesPagination',
                  method: 'POST',
                  data: {
                    type: 'practices',
                    user_token: token,
                    displayPerPage: _this.displayPerPage,
                    page: _this.page,
                    filterType: _this.filterType,
                    filter: _this.filterVal
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _vue.practices = resp.data.practices;

                  if (_vue.practices.length == 0) {
                    _vue.showFilterText = true;
                  }

                  _vue.practicesFiltred = _vue.practices;
                  _vue.practicesFiltredCount = parseInt(resp.data.total);

                  _vue.loadingState = false;
                  _vue.loaded = true;
                }).catch(function (resp) {
                  console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor');
                  _vue.presentPractices = false, _vue.loadingState = false;
                  _vue.loaded = true;
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getPracticesCounts: function getPracticesCounts() {

      var _vue = this;

      this.loadingState = true;
      var token = _vue.getProfile.userToken;

      if (token) {
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getPracticesCounts',
          method: 'POST',
          data: {
            type: 'practices',
            user_token: token
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          console.log('COUNT PRACTICES => ' + resp.data.counts);

          _vue.counts = resp.data.counts;

          _vue.length = parseInt(_vue.counts.countPractices);

          _vue.totCash = parseFloat(_vue.counts.sumTotal);
          if (_vue.totCash < 10000) {
            _vue.maxTotCash = 10000;
            _vue.step = 1000;
          } else if (_vue.totCash < 100000) {
            _vue.maxTotCash = 100000;
            _vue.step = 10000;
          } else if (_vue.totCash < 1000000) {
            _vue.maxTotCash = 1000000;
            _vue.step = 100000;
          } else if (_vue.totCash < 10000000) {
            _vue.maxTotCash = 10000000;
            _vue.step = 1000000;
          }

          _vue.loadingState = false;

          _vue.loadedCount = true;

          _vue.getPractices();
        }).catch(function (resp) {
          console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor');
          _vue.presentPractices = false, _vue.loadingState = false;
        });
      }
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    },
    removePractice: function removePractice(id, code, key) {
      var id_order = id;
      var _vue = this;

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: '<br/>Sei sicuro di voler eliminare Pratica N. ' + code + '?<br/><br/>',
        showCancelButton: true,
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        console.log(result);
        if (result.value) {

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/changeOrderState',
            method: 'POST',
            data: {
              id: id,
              user_token: _vue.getProfile.userToken,
              status: 10
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {

            _vue.getPractices();
            _vue.$swal('Pratica N. ' + code + ' <br/>è stato eliminata ', '', 'success');
          }).catch(function (resp) {
            _vue.$swal('Ops. Riprova piu tardi', '', 'error');
          });
        }
      });
    },
    checkBonusValues: function checkBonusValues() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _vue;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _vue = _this2;

                _this2.loadingState = true;
                _context2.next = 4;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/checkBonusValues',
                  method: 'POST',
                  data: {
                    user_token: _vue.getProfile.userToken
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _this2.loadingState = false;
                }).catch(function (resp) {
                  _this2.loadingState = false;
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      if (val) {
        console.log(val);
        this.getPracticesCounts();
        //this.getPractices()
      }
    },
    filter: function filter(val) {
      this.filterValues();
    }
  },

  mounted: function mounted() {

    var x = {
      0: {
        "text": "Carta Identita non leggibile",
        "document": "4sg233"
      },
      1: {
        "text": "Codice Fiscale non leggibile",
        "document": "4sg233"
      }
    };

    x = stringify_default()(x);
    console.log(x);

    if (this.getProfile) {
      this.getPracticesCounts();
      //this.getPractices()
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe741b42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pratiche/index.vue
var pratiche_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container pt-2" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("Non hai preventivi accettati")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/offerte" }
                  },
                  [_vm._v("Gestione Preventivi")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-3 pt-3 align-items-end"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-md-3 pb-0 pl-1 pr-1 pl-md-5 pr-md-5 d-none d-md-block"
                  },
                  [
                    _vm.counts.countCashClient
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.counts.countCashClient),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": _vm.step
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v(" € ")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.counts.countCashClient
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("small", [
                                  _vm._v("Totale Fatt. quota Clienti")
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-5 col-md-3 pb-0 pr-0 pl-0" },
                  [
                    _vm.counts.countCashInst
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.counts.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": _vm.step
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v(" € ")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.counts.countCashInst
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("small", [
                                  _vm._v("Totale Fatt. quota Cessione")
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-md-3 center pl-1 pr-1 pl-md-5 pr-md-5  d-none d-md-block"
                  },
                  [
                    _vm.counts.countCashClient
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value:
                                parseFloat(_vm.counts.countCashClient) +
                                parseFloat(_vm.counts.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": _vm.step
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v(" € ")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        parseFloat(_vm.counts.countCashClient) +
                                          parseFloat(_vm.counts.countCashInst)
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull " }, [
                                _c("small", [_vm._v("Totale Fatturato")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 col-md-3" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.searchBy("text", _vm.filterVal)
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "text-center grey pb-0 mb-0" }, [
                        _vm._v("Ricerca Pratica")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterVal,
                              expression: "filterVal"
                            }
                          ],
                          staticClass: "form-control seachMobButton",
                          attrs: {
                            type: "text",
                            placeholder: "Numero Pratica o Cognome..."
                          },
                          domProps: { value: _vm.filterVal },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filterVal = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append " }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary btnYellow",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.searchBy("text", _vm.filterVal)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "white",
                                attrs: { icon: "search", size: "sm" }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger widthFull mt-2",
                      staticStyle: { width: "68%" },
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "10")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "trash-alt", size: "sm" }
                      }),
                      _vm._v(" Eliminate "),
                      _c("b", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " + _vm._s(_vm.counts.hasRemovedPractics) + " "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btnYellow mt-2",
                      staticStyle: { width: "28%" },
                      on: {
                        click: function($event) {
                          return _vm.searchBy("", "")
                        }
                      }
                    },
                    [_vm._v("\n           Reset\n        ")]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              { staticClass: "row justify-content-center align-items-end" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-md-2 text-left text-center text-md-left "
                  },
                  [
                    !_vm.lotOfData
                      ? _c(
                          "div",
                          { staticClass: "buttonTextCont widthfull " },
                          [
                            _c(
                              "h1",
                              {
                                staticClass: "widthFull mt-0 center pb-0 mb-0"
                              },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.counts.countPractices))
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-info btn-green btn-sm  widthFull",
                        on: {
                          click: function($event) {
                            return _vm.searchBy("", "")
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "white",
                          attrs: { icon: "clipboard-list", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "d-none d-md-inline white" },
                          [_vm._v(" Totale Pratiche")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-4 col-md-2 text-center text-md-left" },
                  [
                    !_vm.lotOfData
                      ? _c(
                          "div",
                          {
                            staticClass: "buttonTextCont widthfull lightRight"
                          },
                          [
                            _c(
                              "h1",
                              {
                                staticClass: "widthFull mt-0 center pb-0 mb-0"
                              },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.counts.countErrorPractice))
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-danger btn-sm  widthFull",
                        on: {
                          click: function($event) {
                            return _vm.searchBy("errors", "")
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "exclamation-triangle", size: "sm" }
                        }),
                        _c("span", { staticClass: "d-none d-md-inline" }, [
                          _vm._v(" Con anomalie")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-4 col-md-2 text-center text-md-left  "
                  },
                  [
                    !_vm.lotOfData
                      ? _c(
                          "div",
                          {
                            staticClass: "buttonTextCont widthfull lightRight"
                          },
                          [
                            _c(
                              "h1",
                              {
                                staticClass: "widthFull mt-0 center pb-0 mb-0"
                              },
                              [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.counts.countStep1Practice))
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-danger btn-sm  widthFull",
                        on: {
                          click: function($event) {
                            return _vm.searchBy("status", "1")
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "white",
                          attrs: { icon: "balance-scale", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "d-none d-md-inline white" },
                          [_vm._v(" Da completare")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left  " }, [
                  !_vm.lotOfData
                    ? _c("div", { staticClass: "buttonTextCont widthfull " }, [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [
                            _c("b", [
                              _vm._v(_vm._s(_vm.counts.countStep2Practice))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-primary btn-sm btnYellow uppercase widthFull",
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "2")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v("In verifica")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left" }, [
                  !_vm.lotOfData
                    ? _c("div", { staticClass: "buttonTextCont widthfull " }, [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [
                            _c("b", [
                              _vm._v(_vm._s(_vm.counts.countStep3Practice))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-sm btnYellow widthFull",
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "3")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v(" In elaborazione ")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left  " }, [
                  !_vm.lotOfData
                    ? _c("div", { staticClass: "buttonTextCont widthfull " }, [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [
                            _c("b", [
                              _vm._v(_vm._s(_vm.counts.countStep4Practice))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-sm btn-green widthFull",
                      on: {
                        click: function($event) {
                          return _vm.searchBy("status", "4")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v(" Elaborate ")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator"
                  },
                  [
                    _vm.loaded
                      ? _c("pagination", {
                          attrs: {
                            options: {
                              theme: "bootstrap4",
                              texts: {
                                count:
                                  "Visualizzazione da {from} a {to} di {count} Pratiche|{count} Pratiche|Una Pratica"
                              }
                            },
                            records: _vm.practicesFiltredCount,
                            "per-page": _vm.displayPerPage
                          },
                          on: { paginate: _vm.callback },
                          model: {
                            value: _vm.page,
                            callback: function($$v) {
                              _vm.page = $$v
                            },
                            expression: "page"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5 " }, [
          !_vm.showFilterText
            ? _c(
                "div",
                { staticClass: "col-md-12 col-lg-12" },
                [
                  _c(
                    "badger-accordion",
                    {
                      key: "sdfg345",
                      staticClass: "pb-5 mt-4",
                      attrs: {
                        icons: {
                          opened: "<span></span>",
                          closed: "<span></span>"
                        }
                      }
                    },
                    _vm._l(_vm.practicesFiltred, function(item, key) {
                      return item.status != 10
                        ? _c(
                            "badger-accordion-item",
                            { key: item.code + "_" + _vm.countloop },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center "
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-9 text-center text-md-left"
                                        },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              " Cessionario Finale:\n                    "
                                            ),
                                            item.flow == "poste"
                                              ? _c("b", [
                                                  _vm._v(" Poste Italiane ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "cdp"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Cassa Depositi e Prestiti "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "general"
                                              ? _c("b", [
                                                  _vm._v(" Flusso Base ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "agileenergy"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Flusso Agile Energy "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "mbfacta"
                                              ? _c("b", [
                                                  _vm._v(" Flusso MBFACTA ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.flow == "mbfacta_recovery"
                                              ? _c("b", [
                                                  _vm._v(
                                                    " Flusso Personalizzato "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "h5",
                                            {
                                              staticClass: "black csLineHeight2"
                                            },
                                            [
                                              _vm._v(
                                                "\n                     Pratica N. "
                                              ),
                                              _c(
                                                "b",
                                                { staticClass: "underline" },
                                                [_vm._v(_vm._s(item.code))]
                                              ),
                                              _vm._v(
                                                "\n                     del " +
                                                  _vm._s(
                                                    _vm
                                                      .moment(item.created_at)
                                                      .format(
                                                        "DD-MM-YYYY HH:mm"
                                                      )
                                                  ) +
                                                  " ( " +
                                                  _vm._s(item.bonus) +
                                                  " ) "
                                              ),
                                              item.payment_id != "0"
                                                ? [
                                                    item.flow != "agileenergy"
                                                      ? _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "green uppercase ml-4"
                                                          },
                                                          [_vm._v(" Pagata ")]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : [
                                                    item.flow != "agileenergy"
                                                      ? _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "red uppercase ml-4"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Non Pagata "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" Cliente: "),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.client_lastname
                                                    ) +
                                                    " " +
                                                    _vm._s(item.client_name) +
                                                    "  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                " Indirizzo dell'immobile: "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.building_address
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      item.building_civic
                                                    ) +
                                                    " " +
                                                    _vm._s(item.building_city) +
                                                    " (" +
                                                    _vm._s(
                                                      item.building_province
                                                    ) +
                                                    ") CAP " +
                                                    _vm._s(item.building_zip) +
                                                    "  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              item.flow != "agileenergy"
                                                ? [
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            " Totale Fatturato quota Cliente: "
                                                          ),
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "€ " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item.total_transfer_for_client
                                                                    )
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " Totale Fatturato quota Cessione: "
                                                        ),
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass: "black"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.total_bonus_savings
                                                                  )
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass: "pt-4 mb-1"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              "\n\n                          Altri Oneri per il Committente: "
                                                            ),
                                                            _c(
                                                              "b",
                                                              {
                                                                staticClass:
                                                                  "black"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "€ " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        item.tot_extra_for_user
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            item.payment_id !=
                                                            "0"
                                                              ? [
                                                                  _c(
                                                                    "b",
                                                                    {
                                                                      staticClass:
                                                                        "green uppercase ml-4"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Pagato "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              : [
                                                                  _c(
                                                                    "b",
                                                                    {
                                                                      staticClass:
                                                                        "red uppercase ml-4"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Non Pagato "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-1" },
                                                      [
                                                        _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              "\n                          Installazione e posa in opera  "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              " dei beni per il Committente: "
                                                            ),
                                                            _c(
                                                              "b",
                                                              {
                                                                staticClass:
                                                                  "black ml-3"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "€ " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        item.tot_bonifico_for_user
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            item.payment_id2 !=
                                                              "0" &&
                                                            item.payment_id2 !=
                                                              "1"
                                                              ? [
                                                                  _c(
                                                                    "b",
                                                                    {
                                                                      staticClass:
                                                                        "green uppercase ml-4"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Pagato "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              : [
                                                                  _c(
                                                                    "b",
                                                                    {
                                                                      staticClass:
                                                                        "red uppercase ml-4"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Non Pagato "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("span", [
                                                          _c("br"),
                                                          _vm._v(
                                                            "Totale Fattura da installatore professionista in subappalto verso AGILE ENERGY\n                        "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "per il materiale e l'installazione, come indicati nel Preventivo: "
                                                          ),
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                "green"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "€ " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatNumber"
                                                                    )(
                                                                      item.totale_imponibile
                                                                    )
                                                                  ) +
                                                                  "*"
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("small", [
                                                          _vm._v(
                                                            "* Da fatturare "
                                                          ),
                                                          _c("b", [
                                                            _vm._v("senza IVA ")
                                                          ]),
                                                          _vm._v(
                                                            " in quanto operazione soggetta al reverse charge art. 17, comma 6, lett. a-ter DPR 633/1972.\n\n                       "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          " Costo di gestione del Servizio del General Contractor AGILE ENERGY\n                     "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "a supporto della gestione di questa Pratica è pari a:\n                     "
                                                        ),
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass: "green"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "€ " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    item.price_agile
                                                                  )
                                                                ) +
                                                                " + IVA (22%)"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(
                                                          "che sarà fatturato da AGILE ENERGY verso l'installatore professionista in subappalto\n                   "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          item.flow != "agileenergy"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary m-2 btnBlue btn-sm",
                                                    attrs: {
                                                      href: item.signed_order,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "eye",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza Preventivo Firmato\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "agileenergy"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary m-2 btnBlue btn-sm",
                                                    attrs: {
                                                      href:
                                                        item.lettera_di_affidamento_signed,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "eye",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza Lettera di Affidamento\n                    "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary m-2 btnBlue btn-sm",
                                                    attrs: {
                                                      href: item.signed_order,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "eye",
                                                        size: "sm"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " Visualizza Contratto per la fornitura e l’installazione\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow != "agileenergy"
                                            ? [
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-green m-2 btn-sm ",
                                                    attrs: {
                                                      to: {
                                                        name: "loadDocuments",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "clipboard-check",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Gestione Documenti\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow == "agileenergy" &&
                                          item.payment_id != 0
                                            ? [
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-green m-2 btn-sm ",
                                                    attrs: {
                                                      to: {
                                                        name: "loadDocuments",
                                                        params: { item: item }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "clipboard-check",
                                                        size: "1x"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                      Gestione Documenti\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.flow != "agileenergy"
                                            ? [
                                                item.status == 1 &&
                                                item.payment_id == "0"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-danger m-2 btn-sm",
                                                        attrs: {
                                                          type: "button"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removePractice(
                                                              item.id,
                                                              item.code,
                                                              key
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "trash-alt",
                                                              size: "sm"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(
                                                          " Elimina\n                  "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 1
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: __webpack_require__("ckMO")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 2 ||
                                          item.status == 3 ||
                                          item.status == 4
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: __webpack_require__("Jkjn")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 5
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: __webpack_require__("9x6x")
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-7 col-md-1 center pl-md-0 pr-md-0 pt-3 "
                                        },
                                        [
                                          item.enea_request == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                class: {
                                                  "bg-success": _vm.checkEneaComplate(
                                                    item.aditional_enea_data
                                                  )
                                                },
                                                attrs: {
                                                  src: __webpack_require__("vg18")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.to_get_cadastral_data == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                class: {
                                                  "bg-success":
                                                    item.dcast_export == "10"
                                                },
                                                attrs: {
                                                  src: __webpack_require__("6Z51")
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2 center pt-3" },
                                        [
                                          item.status == 1 &&
                                          item.flow != "agileenergy"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "inline-block center relative topCust2 d-none d-md-inline ",
                                                  staticStyle: {
                                                    position:
                                                      "initial!important"
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "qrcodeImg qrcodeImg2",
                                                    attrs: { src: item.qrcode }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "qrcodeText"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Carica documenti con"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status != 1 &&
                                          item.ade_protocol_number
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "inline-block center relative topCust2 d-md-inline pt-4 pt-md-0 pb-0 ",
                                                  staticStyle: {
                                                    position:
                                                      "initial!important"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "pt-0 pt-md-2 pb-md-2 bgGreen white Regular"
                                                    },
                                                    [
                                                      _c("small", [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Protocollo AdE nr. " +
                                                              _vm._s(
                                                                item.ade_protocol_number
                                                              )
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.status == 1 && item.hasErrors == "no"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              item.flow == "poste"
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "loadDocuments",
                                                          params: { item: item }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "black widthFull text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                " mr-4"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Per procedere:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              " Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : item.flow == "cdp" ||
                                                  item.flow == "general" ||
                                                  item.flow == "mbfacta" ||
                                                  item.flow ==
                                                    "mbfacta_recovery"
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "loadDocuments",
                                                          params: { item: item }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "black widthFull text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                " mr-4"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Per procedere:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              " Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : item.flow == "agileenergy" &&
                                                  item.payment_id == "0"
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "black widthFull text-left"
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass: " mr-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "In attesa Pagamento:"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          ' Appena riceviamo pagamento dal cliente finale "degli Altri Oneri al committente" - abilitiamo set documentale '
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : item.flow == "agileenergy" &&
                                                  item.payment_id != "0"
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "loadDocuments",
                                                          params: { item: item }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "black widthFull text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "b",
                                                            {
                                                              staticClass:
                                                                " mr-4"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Per procedere:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              " Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.enea_request == "1" &&
                                      _vm.checkEneaComplate(
                                        item.aditional_enea_data
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11  requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "Regular text-center h0 widthFull "
                                                },
                                                [
                                                  _c("b", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "green underline mr-3"
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "green",
                                                            attrs: {
                                                              href:
                                                                item.enea_pdf,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Dichiarazione ENEA "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    item.enea_email
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green underline mr-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    item.enea_email,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Ricevuta ENEA E-mail  "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("small", [
                                                      _vm._v("Il codice CPID:")
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.enea_cpid) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.modelloAde || item.ricevutaAde
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11  requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "Regular text-center h0 widthFull "
                                                },
                                                [
                                                  _c("b", [
                                                    item.modelloAde
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green underline mr-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    item.modelloAde,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Modello AdE "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.ricevutaAde
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green underline mr-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    item.ricevutaAde,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Ricevuta AdE  "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.duediligence
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "green underline mr-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "green",
                                                                attrs: {
                                                                  href:
                                                                    item.duediligence,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Due Diligence  "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (item.aditional_enea_data == null ||
                                        item.aditional_enea_data == "") &&
                                      item.enea_request == "1" &&
                                      item.payment_id != "0"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11  requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "Regular text-center h0 widthFull "
                                                },
                                                [
                                                  _c("b", [
                                                    _c(
                                                      "span",
                                                      { staticClass: "red" },
                                                      [_vm._v("Attenzione!")]
                                                    ),
                                                    _vm._v(
                                                      " Per redigere ed inviare la Pratica ENEA necessitiamo di ulteriori informazioni "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "router-link",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary m-2 btn-sm",
                                                      attrs: {
                                                        to: {
                                                          name:
                                                            "complateEneaData",
                                                          params: { item: item }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Inserisci\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.hasErrors == "yes"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black widthFull text-left"
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull mr-4"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "red" },
                                                        [_vm._v(" Attenzione ")]
                                                      ),
                                                      _vm._v(
                                                        " abbiamo rilevato le seguenti anomalie:"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "red widthFull text-left pl-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.errors) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 center pt-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card step-progress pt-3 "
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "step-slider" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item ",
                                                      class: {
                                                        active:
                                                          item.status == 1,
                                                        "active passed":
                                                          item.status != 1
                                                      },
                                                      attrs: {
                                                        "data-id": "step1"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$router.push(
                                                            {
                                                              name:
                                                                "loadDocuments",
                                                              params: {
                                                                item: item
                                                              }
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 1 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "Carica Documentazione"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item ",
                                                      class: {
                                                        notactive:
                                                          item.status == 1,
                                                        active:
                                                          item.status == 2,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2
                                                      },
                                                      attrs: {
                                                        "data-id": "step2"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 2 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "In verifica"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item notactive",
                                                      class: {
                                                        notactive:
                                                          item.status == 2,
                                                        active:
                                                          item.status == 3,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2 &&
                                                          item.status != 3
                                                      },
                                                      attrs: {
                                                        "data-id": "step3"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 3 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "In elaborazione"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item notactive",
                                                      class: {
                                                        notactive:
                                                          item.status == 3,
                                                        active:
                                                          item.status == 4,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2 &&
                                                          item.status != 3 &&
                                                          item.status != 4
                                                      },
                                                      attrs: {
                                                        "data-id": "step4"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 4 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(" Elaborata")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "step-content"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasRemovedPractics
                    ? _c(
                        "div",
                        [
                          _vm.hasRemovedPractics
                            ? _c(
                                "h5",
                                { staticClass: "text-left black Regular" },
                                [_vm._v("Pratiche Eliminate")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRemovedPractics
                            ? _c(
                                "p",
                                { staticClass: "text-left black Regular" },
                                [
                                  _vm._v(
                                    "Attenzione! I dati contenuti in questa schermata non includono le Pratiche eliminate. "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "badger-accordion",
                            { staticClass: "pb-5 mt-4 greyBg" },
                            _vm._l(_vm.practicesFiltred, function(item, key) {
                              return item.status == 10
                                ? _c(
                                    "badger-accordion-item",
                                    {
                                      key: item.code + "12",
                                      staticClass: "greyBg"
                                    },
                                    [
                                      _c(
                                        "template",
                                        {
                                          staticClass: "greyBg",
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center "
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-9 text-center text-md-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        "\n                          Pratica N. "
                                                      ),
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "underline"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.code)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                          del " +
                                                          _vm._s(
                                                            _vm
                                                              .moment(
                                                                item.created_at
                                                              )
                                                              .format(
                                                                "DD-MM-YYYY HH:mm"
                                                              )
                                                          ) +
                                                          " ( " +
                                                          _vm._s(item.bonus) +
                                                          " )\n                          per "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.client_name
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.client_lastname
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary m-2 btnBlue btn-sm",
                                                      attrs: {
                                                        href: item.signed_order,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "eye",
                                                          size: "sm"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        " visualizza Preventivo Firmato\n                        "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "col-md-3 center pt-3"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "template",
                                        {
                                          staticClass: "greyBg",
                                          slot: "content"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-9 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    { staticClass: "black" },
                                                    [
                                                      _vm._v(
                                                        " Indirizzo dell'immobile\n                          "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.building_address
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              item.building_civic
                                                            ) +
                                                            " - " +
                                                            _vm._s(
                                                              item.building_zip
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              item.building_city
                                                            ) +
                                                            " (" +
                                                            _vm._s(
                                                              item.building_province
                                                            ) +
                                                            ") "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass: "black pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Dati dell'intervento"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                        Tipo: "
                                                  ),
                                                  _c("b", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "uppercase Regular"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.intervention_type
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "black pb-0 text-left widthFull"
                                                    },
                                                    [
                                                      _vm._v(" Da Cliente: "),
                                                      _c("b", [
                                                        _vm._v(
                                                          " € " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  item.total_transfer_for_client
                                                                )
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "black pb-0 text-left"
                                                    },
                                                    [
                                                      _vm._v(" Da Cessione: "),
                                                      _c("b", [
                                                        _vm._v(
                                                          " € " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  item.total_transfer_for_user
                                                                )
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "black pb-0 text-left"
                                                    },
                                                    [
                                                      _vm._v(" Totale: "),
                                                      _c("b", [
                                                        _vm._v(
                                                          " € " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                parseFloat(
                                                                  item.total_transfer_for_client
                                                                ) +
                                                                  parseFloat(
                                                                    item.total_transfer_for_user
                                                                  )
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-3 text-left"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass: "black pb-0"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Data:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .moment(
                                                                  item.intervention_date
                                                                )
                                                                .format(
                                                                  "DD-MM-YYYY"
                                                                )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5"
                },
                [
                  _c("h5", { staticClass: "center" }, [
                    _vm._v(
                      "Nessun risultato  " +
                        _vm._s(
                          _vm.filterVal != 1 &&
                            _vm.filterVal != 2 &&
                            _vm.filterVal != 3 &&
                            _vm.filterVal != 4
                            ? " per " + _vm.filterVal
                            : ""
                        )
                    )
                  ])
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator"
            },
            [
              _vm.loaded
                ? _c("pagination", {
                    attrs: {
                      options: {
                        theme: "bootstrap4",
                        texts: {
                          count:
                            "Visualizzazione da {from} a {to} di {count} Pratiche|{count} Pratiche|Una Pratica"
                        }
                      },
                      records: _vm.practicesFiltredCount,
                      "per-page": _vm.displayPerPage
                    },
                    on: { paginate: _vm.callback },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var pratiche_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", { staticClass: "Regular  h0 widthFull" }, [
          _c("b", [_vm._v("Gestione Pratiche ")])
        ])
      ])
    ])
  }
]
pratiche_render._withStripped = true
var pratiche_esExports = { render: pratiche_render, staticRenderFns: pratiche_staticRenderFns }
/* harmony default export */ var components_pratiche = (pratiche_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe741b42", pratiche_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/pratiche/index.vue
var pratiche_disposed = false
function pratiche_injectStyle (ssrContext) {
  if (pratiche_disposed) return
  __webpack_require__("yqhM")
}
var pratiche_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pratiche___vue_template_functional__ = false
/* styles */
var pratiche___vue_styles__ = pratiche_injectStyle
/* scopeId */
var pratiche___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pratiche___vue_module_identifier__ = null
var pratiche_Component = pratiche_normalizeComponent(
  pratiche,
  components_pratiche,
  pratiche___vue_template_functional__,
  pratiche___vue_styles__,
  pratiche___vue_scopeId__,
  pratiche___vue_module_identifier__
)
pratiche_Component.options.__file = "src/components/pratiche/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fe741b42", pratiche_Component.options)
  } else {
    hotAPI.reload("data-v-fe741b42", pratiche_Component.options)
  }
  module.hot.dispose(function (data) {
    pratiche_disposed = true
  })
})()}

/* harmony default export */ var src_components_pratiche = (pratiche_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/end/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var end_moment = __webpack_require__("PJh5");

/* harmony default export */ var end = ({
	name: 'play',
	components: {
		Datepicker: vuejs_datepicker_esm["a" /* default */],
		VueTimepicker: vue2_timepicker_default.a
	},
	data: function data() {
		return {
			loadingState: false,
			userToken: '',
			partita_iva: '',
			existPIVA: false,
			existEmail: false,
			existCF: false,
			tempIva: '',
			tempCF: '',
			tempEmail: '',
			azienda: '',
			name: '',
			lastname: '',
			email: '',
			phone: '',
			cellulare: '',
			codice_fiscale: '',
			shipEqual: true,
			shipData: {},
			address: '',
			civic: '',
			region: '',
			province: '',
			city: '',
			zip: '',
			regions: [],
			regionsState: true,
			provincies: [],
			provinciesState: false,
			cities: [],
			citiesState: false,
			zips: [],
			zipsState: false,
			provinceError: false,
			cityError: false,
			zipError: false,

			ship_regions: [],
			ship_regionsState: true,
			ship_provincies: [],
			ship_provinciesState: false,
			ship_cities: [],
			ship_citiesState: false,
			ship_zips: [],
			ship_zipsState: false,
			ship_provinceError: false,
			ship_cityError: false,
			ship_zipError: false,

			ship_name: '',
			ship_lastname: '',
			near: '',
			ship_phone: '',
			ship_cellulare: '',
			ship_address: '',
			ship_civic: '',
			ship_region: '',
			ship_province: '',
			ship_city: '',
			ship_zip: '',
			note: '',

			invoiceFront: '',
			invoiceFrontName: '',
			invoiceFrontBucket: '',
			uploadFrontPercentage: 0,
			invoiceRear: '',
			invoiceRearName: '',
			invoiceRearBucket: '',
			uploadRearPercentage: 0,
			id_eps: '',

			vw: window.innerWidth
		};
	},

	methods: {

		registration: function registration() {
			var _this = this;

			this.$validator.validate().then(function (valid) {
				if (valid && _this.profile.email && _this.profile.id) {

					var data = defineProperty_default()({
						name: _this.name,
						cognome: _this.lastname,
						email: _this.email,
						password: _this.profile.password,
						azienda: _this.azienda,
						id_eps: '',
						target: 0,
						partita_iva: _this.partita_iva,
						codice_fiscale: _this.codice_fiscale,
						indirizzo: _this.address,
						civico: _this.civic,
						comune: _this.city.city,
						provincia: _this.province,
						regione: _this.region.text,
						cap: _this.zip,
						telefono: _this.phone,
						cellulare: _this.cellulare,
						privacy: 1,
						privacy1: _this.invoiceFrontBucket,
						privacy2: _this.invoiceRearBucket,

						ship_presso: _this.near,
						ship_note: _this.note,
						ship_name: _this.shipEqual ? _this.name : _this.ship_name,
						ship_cognome: _this.shipEqual ? _this.lastname : _this.ship_lastname,
						ship_indirizzo: _this.shipEqual ? _this.address : _this.ship_address,
						ship_civico: _this.shipEqual ? _this.civic : _this.ship_civic,
						ship_comune: _this.shipEqual ? _this.city.city : _this.ship_city.city,
						ship_provincia: _this.shipEqual ? _this.province : _this.ship_province,
						ship_regione: _this.shipEqual ? _this.region.text : _this.ship_region.text,
						ship_cap: _this.shipEqual ? _this.zip : _this.ship_zip,
						ship_telefono: _this.shipEqual ? _this.phone : _this.ship_phone,
						ship_cellulare: _this.shipEqual ? _this.cellulare : _this.ship_cellulare,

						type: _this.profile.email,
						confirmed: _this.profile.id
					}, 'id_eps', _this.id_eps);

					console.log(data);

					axios_default()({
						url: "https://wsbot.eu/21005back/public/" + 'api/newUser',
						method: 'POST',
						data: {
							user: data,
							regType: 'new',
							who: _this.profile.email,
							operator_id: _this.profile.id
						},
						headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {

						_this.addClientSuccess();
						_this.$router.push('/');
					}).catch(function (error) {

						var text = error.response.data.error;
						_this.addClientError(text);
					});
				} else {
					if (!_this.profile.email) {
						alert('Sessione scaduta - devi effetuare login');
					}
				}
			});
		},

		checkIfExistUser: function checkIfExistUser(value) {
			var _this2 = this;

			var newValue = value.target.value;
			var field = this.$validator.fields.find({ name: 'partita_iva' });
			var typeCall;
			var tempVal;
			if (value.target.id == 'partita_iva') {
				typeCall = 'partita_iva';
				tempVal = this.tempIva;
			}
			if (value.target.id == 'codice_fiscale') {
				typeCall = 'codice_fiscale';
				tempVal = this.tempCF;
			}
			if (value.target.id == 'email') {
				typeCall = 'email';
				tempVal = this.tempEmail;
			}

			if (!this.errors.has(value.target.id) && tempVal != newValue && newValue) {

				if (typeCall == 'partita_iva') {
					this.tempIva = newValue;
				}
				if (typeCall == 'codice_fiscale') {
					this.tempCF = newValue;
				}
				if (typeCall == 'email') {
					this.tempEmail = newValue;
				}

				axios_default()({
					url: "https://wsbot.eu/21005back/public/" + 'api/checkExUser',
					method: 'POST',
					data: {
						value: newValue,
						typeCall: typeCall
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {

					if (typeCall == 'partita_iva') {
						_this2.existPIVA = false;
					}
					if (typeCall == 'codice_fiscale') {
						_this2.existCF = false;
					}
					if (typeCall == 'email') {
						_this2.existEmail = false;
					}
				}).catch(function (error) {

					if (typeCall == 'partita_iva') {
						_this2.existPIVA = true;
					}
					if (typeCall == 'codice_fiscale') {
						_this2.existCF = true;
					}
					if (typeCall == 'email') {
						_this2.existEmail = true;
					}
				});
			}
		},

		uploadFile: function uploadFile(input) {
			var file = input.target.files[0].name;
			this.invoiceFrontName = file;
			var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
			var size = input.target.files[0].size;

			if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {

				this.invoiceFront = input.target.files[0].name;

				var formData = new FormData();
				var _vue = this; // << here
				formData.append('fattura0', input.target.files[0]);

				axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
					},
					onUploadProgress: function (progressEvent) {
						this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
					}.bind(this)
				}).then(function (e) {
					var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
					if (regex.test(e.data.fattura)) {
						_vue.uploadFrontPercentage = 0;
						_vue.invoiceFrontBucket = e.data.fattura;
					} else {
						_vue.uploadFrontPercentage = 0;
						_vue.invoiceFront = '';
						_vue.invoiceFrontBucket = '';
						_vue.UploadError();
						input.target.value = null;
					}
				}).catch(function () {
					_vue.uploadFrontPercentage = 0;
					_vue.invoiceFront = '';
					_vue.invoiceFrontBucket = '';
					_vue.UploadError();
					input.target.value = null;
				});
			}
		},

		uploadFileRear: function uploadFileRear(input) {
			var file = input.target.files[0].name;

			this.invoiceRearName = file;
			var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
			var size = input.target.files[0].size;

			if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
				this.invoiceRear = input.target.files[0].name;

				var formData = new FormData();
				var _vue = this; // << here
				formData.append('fattura0', input.target.files[0]);

				axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
					},
					onUploadProgress: function (progressEvent) {
						this.uploadRearPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
					}.bind(this)
				}).then(function (e) {
					var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
					if (regex.test(e.data.fattura)) {

						_vue.uploadRearPercentage = 0;
						_vue.invoiceRearBucket = e.data.fattura;
					} else {
						_vue.uploadRearPercentage = 0;
						_vue.invoiceRear = '';
						_vue.invoiceRearBucket = '';
						_vue.UploadError();
						input.target.value = null;
					}
				}).catch(function () {
					_vue.uploadRearPercentage = 0;
					_vue.invoiceRear = '';
					_vue.invoiceRearBucket = '';
					_vue.UploadError();
					input.target.value = null;
				});
			}
		},

		addClientSuccess: function addClientSuccess() {
			this.$swal({
				type: 'success',
				title: '<strong class="modalText ">L`installatore registrato con successo </strong>',
				html: '',
				confirmButtonText: 'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267'
			});
		},
		addClientError: function addClientError(text) {
			this.$swal({
				type: 'error',
				title: '<strong class="modalText danger">Registrazione non andato a buon fine.</strong>',
				html: text,
				confirmButtonText: 'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267'
			});
		},
		UploadError: function UploadError() {
			this.$swal({
				type: 'error',
				title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
				html: '',
				confirmButtonText: 'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267'
			});
		},


		populateRegions: function populateRegions() {
			var _this3 = this;

			axios_default()({
				url: "https://wsbot.eu/21005back/public/" + 'api/getRegions',
				method: 'POST',
				headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
				_this3.regions = resp.data.regions;
				_this3.regionsState = false;

				_this3.ship_regions = resp.data.regions;
				_this3.ship_regionsState = false;
			}).catch(function (resp) {
				_this3.regions = [];
				_this3.regionsState = false;

				_this3.ship_regions = [];
				_this3.ship_regionsState = false;
			});
		},

		checkRegion: function checkRegion() {
			var region = this.region;

			if (region) {
				this.provinceError = false;
			} else {
				this.provinceError = true;
			}
		},
		checkProvince: function checkProvince() {
			var province = this.province;

			if (province) {
				this.cityError = false;
			} else {
				this.cityError = true;
			}
		},
		checkZip: function checkZip() {
			var city = this.city;

			if (city) {
				this.zipError = false;
			} else {
				this.zipError = true;
			}
		},

		ship_checkRegion: function ship_checkRegion() {
			var ship_region = this.ship_region;

			if (ship_region) {
				this.ship_provinceError = false;
			} else {
				this.ship_provinceError = true;
			}
		},
		ship_checkProvince: function ship_checkProvince() {
			var ship_province = this.ship_province;

			if (ship_province) {
				this.ship_cityError = false;
			} else {
				this.ship_cityError = true;
			}
		},
		ship_checkZip: function ship_checkZip() {
			var ship_city = this.ship_city;

			if (ship_city) {
				this.ship_zipError = false;
			} else {
				this.ship_zipError = true;
			}
		},

		calcToDate: function calcToDate() {
			var start = Object({"year":2021,"month":2,"day":15});
			var date = new Date(new Date().setDate(new Date().getDate() - 5));
			var startDate = new Date(start.year, start.month - 1, start.day);
			if (startDate > date) {
				var finalTo = startDate;
			} else {
				var finalTo = date;
			}
			return finalTo;
		},
		calcFromDate: function calcFromDate() {
			var stopObj = Object({"year":2030,"month":12,"day":15});
			var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
			var nowDate = new Date();
			if (nowDate <= stopDate) {
				var finalFrom = nowDate;
			} else {
				var finalFrom = stopDate;
			}
			return finalFrom;
		},


		handleResize: function handleResize() {
			this.vw = window.innerWidth;
		}

	},
	watch: {
		azienda: function azienda(value) {
			this.azienda = value.toUpperCase();
		},
		name: function name(value) {
			this.name = value.toUpperCase();
		},
		lastname: function lastname(value) {
			this.lastname = value.toUpperCase();
		},
		ship_name: function ship_name(value) {
			this.ship_name = value.toUpperCase();
		},
		ship_lastname: function ship_lastname(value) {
			this.ship_lastname = value.toUpperCase();
		},
		number: function number(value) {
			this.number = parseInt(value);
		},
		phone: function phone(val) {
			if (val) {
				this.phone = val.replace(/\D+/g, '');
			}
		},
		id_eps: function id_eps(val) {
			if (val) {
				this.id_eps = val.replace(/\D+/g, '');
			}
		},
		cellulare: function cellulare(val) {
			if (val) {
				this.cellulare = val.replace(/\D+/g, '');
			}
		},
		ship_phone: function ship_phone(val) {
			if (val) {
				this.ship_phone = val.replace(/\D+/g, '');
			}
		},
		ship_cellulare: function ship_cellulare(val) {
			if (val) {
				this.ship_cellulare = val.replace(/\D+/g, '');
			}
		},
		region: function region(newVal) {
			var _this4 = this;

			this.zips = [];
			this.cities = [];
			this.zip = '';
			this.city = '';
			this.cityError = false;
			this.provinceError = false;
			this.zipError = false;
			this.province = '';
			this.provincies = [];
			this.provinciesState = true;

			var provincies = this.provincies,
			    provinciesState = this.provinciesState;

			axios_default()({
				url: "https://wsbot.eu/21005back/public/" + 'api/getProvincies',
				method: 'POST',
				data: {
					region: newVal.id
				},
				headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
				_this4.provincies = resp.data.provincies;
				_this4.provinciesState = false;
			}).catch(function (resp) {
				_this4.provincies = [];
				_this4.provinciesState = false;
			});
		},
		ship_region: function ship_region(newVal) {
			var _this5 = this;

			this.ship_zips = [];
			this.ship_cities = [];
			this.ship_zip = '';
			this.ship_city = '';
			this.ship_cityError = false;
			this.ship_provinceError = false;
			this.ship_zipError = false;
			this.ship_province = '';
			this.ship_provincies = [];
			this.ship_provinciesState = true;

			var ship_provincies = this.ship_provincies,
			    ship_provinciesState = this.ship_provinciesState;

			axios_default()({
				url: "https://wsbot.eu/21005back/public/" + 'api/getProvincies',
				method: 'POST',
				data: {
					region: newVal.id
				},
				headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
				_this5.ship_provincies = resp.data.provincies;
				_this5.ship_provinciesState = false;
			}).catch(function (resp) {
				_this5.ship_provincies = [];
				_this5.ship_provinciesState = false;
			});
		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		province: function province(newProvince) {
			var _this6 = this;

			this.zips = [];
			this.cities = [];
			this.zip = '';
			this.city = '';
			this.cityError = false;
			this.zipError = false;

			if (newProvince) {
				this.citiesState = true;
				axios_default()({
					url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
					method: 'POST',
					data: {
						provincia: newProvince
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this6.cities = resp.data.cities;
					_this6.citiesState = false;
				}).catch(function (resp) {
					_this6.cities = [];
					_this6.citiesState = false;
				});
			}
		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		ship_province: function ship_province(newProvince) {
			var _this7 = this;

			this.ship_zips = [];
			this.ship_cities = [];
			this.ship_zip = '';
			this.ship_city = '';
			this.ship_cityError = false;
			this.ship_zipError = false;

			if (newProvince) {
				this.ship_citiesState = true;
				axios_default()({
					url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
					method: 'POST',
					data: {
						provincia: newProvince
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this7.ship_cities = resp.data.cities;
					_this7.ship_citiesState = false;
				}).catch(function (resp) {
					_this7.ship_cities = [];
					_this7.ship_citiesState = false;
				});
			}
		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		city: function city(newCity) {
			var _this8 = this;

			this.zipError = false;
			this.zips = [];
			this.zip = '';

			if (newCity.cityistat) {
				this.zipsState = true;
				axios_default()({
					url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
					method: 'POST',
					data: {
						istat: newCity.cityistat
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this8.zips = resp.data.zips;
					_this8.zipsState = false;
				}).catch(function (resp) {
					_this8.zips = [];
					_this8.zipsState = false;
				});
			}
		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		ship_city: function ship_city(newCity) {
			var _this9 = this;

			this.ship_zipError = false;
			this.ship_zips = [];
			this.ship_zip = '';

			if (newCity.cityistat) {
				this.ship_zipsState = true;
				axios_default()({
					url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
					method: 'POST',
					data: {
						istat: newCity.cityistat
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this9.ship_zips = resp.data.zips;
					_this9.ship_zipsState = false;
				}).catch(function (resp) {
					_this9.ship_zips = [];
					_this9.ship_zipsState = false;
				});
			}
		},
		vw: function vw() {}

	},
	updated: function updated() {},
	created: function created() {
		this.$validator.extend('notZeros', {
			getMessage: function getMessage(field) {
				return ' Il campo Numero di telefono non ha un formato valido.';
			},
			validate: function validate(value) {
				// value must be > zero
				if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000) return true;
				return false;
			}
		});
	},
	mounted: function mounted() {

		window.addEventListener('resize', this.handleResize);
		this.handleResize();

		this.lastnamex = this.getProfile.cognome;
		this.xuserx = this.getProfile.name;

		var _vue = this;

		setTimeout(function () {

			_vue.populateRegions(), _vue.disabledDates = {
				to: _vue.calcToDate(), // Disable all dates up to specific date
				from: _vue.calcFromDate() // Disable all dates after specific date
			};

			_vue.scrollFinished = true;
		}, 1500);
	},
	computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
		profile: function profile(state) {
			return state.user.profile;
		}
	}))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415b2084","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/end/index.vue
var end_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var end_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "widthFull container logo dataContainer" },
      [
        _c("h1", { staticClass: "h2 center mt-5 pb-4" }, [
          _c("b"),
          _vm._v("ATTENZIONE!")
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "h2 center mt-5 pb-4 red" }, [
          _c("b", [
            _vm._v("Il programma di incentivazione  "),
            _c("br"),
            _vm._v(" è terminato il 31 luglio 2020.")
          ])
        ])
      ]
    )
  }
]
end_render._withStripped = true
var end_esExports = { render: end_render, staticRenderFns: end_staticRenderFns }
/* harmony default export */ var components_end = (end_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-415b2084", end_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/end/index.vue
var end_disposed = false
function end_injectStyle (ssrContext) {
  if (end_disposed) return
  __webpack_require__("u+93")
  __webpack_require__("+qws")
}
var end_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var end___vue_template_functional__ = false
/* styles */
var end___vue_styles__ = end_injectStyle
/* scopeId */
var end___vue_scopeId__ = "data-v-415b2084"
/* moduleIdentifier (server only) */
var end___vue_module_identifier__ = null
var end_Component = end_normalizeComponent(
  end,
  components_end,
  end___vue_template_functional__,
  end___vue_styles__,
  end___vue_scopeId__,
  end___vue_module_identifier__
)
end_Component.options.__file = "src/components/end/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-415b2084", end_Component.options)
  } else {
    hotAPI.reload("data-v-415b2084", end_Component.options)
  }
  module.hot.dispose(function (data) {
    end_disposed = true
  })
})()}

/* harmony default export */ var src_components_end = (end_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/notActive/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var notActive_moment = __webpack_require__("PJh5");
/* harmony default export */ var notActive = ({

  name: 'NotActive',
  data: function data() {
    return {
      time: false,
      countdown: 0,
      datenow: ''
    };
  },

  methods: {
    timeReactive: function timeReactive() {
      var self = this;
      this.datenow = notActive_moment();

      if (notActive_moment() >= notActive_moment("2021-02-15 00:00:00")) {
        window.location.replace('/');
      }
    }
  },
  created: function created() {
    //// COUNDOWN
    //var data = '2019-09-09 00:00:00'

    setInterval(this.timeReactive, 1000);

    var now = notActive_moment();

    var then = notActive_moment("2021-02-15 00:00:00");

    var dif = then.diff(now);

    //moment.utc(moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(then,"DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")
    this.countdown = dif;
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de2e1c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notActive/index.vue
var notActive_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "widthFull ptHeader mainBackVaillant",
      staticStyle: { "min-height": "100vh" },
      attrs: { id: "firstElem" }
    },
    [
      _c("div", { staticClass: "container pt-5 pb-5" }, [
        _c("div", { staticClass: "row justify-content-center  pb-5" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("h2", { staticClass: "Bold blue center widthFull mb-5 mt-5" }, [
            _vm._v("\n\n         La piattaforma sarà attiva tra:\n\n       ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-7 pb-2 mb-5 pt-5 center custForm" },
            [
              _c("countdown", {
                attrs: { time: _vm.countdown },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "row center justify-content-center pb-5 pt-1"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timeElement BoldFont" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.days) +
                                        "\n\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.days == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("giorno")]
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("giorni")]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4  text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timeElement BoldFont " },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.hours) +
                                        "\n\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.hours == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("ora")]
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("ore")]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timeElement BoldFont" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.minutes) +
                                        "\n                      "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.minutes == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("minuto")]
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("minuti")]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timeElement BoldFont" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.seconds) +
                                        "\n\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.seconds == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("secondo")]
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("secondi")]
                                    )
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var notActive_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid   pt-5 pb-5" }, [
      _c("div", { staticClass: "row pt-5 pb-3 center" })
    ])
  }
]
notActive_render._withStripped = true
var notActive_esExports = { render: notActive_render, staticRenderFns: notActive_staticRenderFns }
/* harmony default export */ var components_notActive = (notActive_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0de2e1c8", notActive_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/notActive/index.vue
var notActive_disposed = false
function notActive_injectStyle (ssrContext) {
  if (notActive_disposed) return
  __webpack_require__("vOz5")
}
var notActive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var notActive___vue_template_functional__ = false
/* styles */
var notActive___vue_styles__ = notActive_injectStyle
/* scopeId */
var notActive___vue_scopeId__ = "data-v-0de2e1c8"
/* moduleIdentifier (server only) */
var notActive___vue_module_identifier__ = null
var notActive_Component = notActive_normalizeComponent(
  notActive,
  components_notActive,
  notActive___vue_template_functional__,
  notActive___vue_styles__,
  notActive___vue_scopeId__,
  notActive___vue_module_identifier__
)
notActive_Component.options.__file = "src/components/notActive/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0de2e1c8", notActive_Component.options)
  } else {
    hotAPI.reload("data-v-0de2e1c8", notActive_Component.options)
  }
  module.hot.dispose(function (data) {
    notActive_disposed = true
  })
})()}

/* harmony default export */ var src_components_notActive = (notActive_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complateEneaData/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var complateEneaData_moment = __webpack_require__("PJh5");

/* harmony default export */ var complateEneaData = ({
  name: 'acceptInvoice',
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */]
  },
  data: function data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      eventEndtdate: '',
      it: locale["it"],
      eventStartdate: '',
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: {},
      hideData: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      mobile: '',
      cellulare: '',
      address: '',
      civic: '',
      azienda: '',
      region: '',
      province: '',
      city: '',
      cap: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      client_ownership: '',
      subalterno: '',
      particella: '',
      foglio: '',
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      quantHouses: '',
      disabledDatesStart: {
        to: '',
        from: ''
      },
      noValvole: false,
      // NEW
      house_surface: '',
      house_count: '',
      house_work_on: '',
      has_condensazione: false,
      has_tradizionale: false,
      has_pompadicalore: false,
      has_ibridi: false,
      has_scaldacqua: false,
      has_climatizzatore: false,
      has_solare: false,

      type_system_old: '',
      count_system_old: '',
      group_system_old: '',
      group_system_old_other: '',
      potenza_utile_system_old: '',
      rendimento_100_system_old: '',
      vettore_termico_system_old: '',

      building_type: '',
      building_type_other: '',
      building_year: '',
      building_merged: '',

      // SOLARE
      solare_inclinazione: '',
      solare_orientamento: '',
      solare_tipo_impianto_sostituito: '',
      // CONDENSAZIONE
      condensazione_caldaia_destinata_a: '',
      condensazione_alimentazione_caldaia: '',
      condensazione_present_clima: '',

      // PDC
      pdc_superficie_utile_riscaldata: '',
      // IBRIDI


      products: false
    };
  },

  methods: {
    setAditionalEneaData: function setAditionalEneaData() {
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;

          var data = {
            aditional_enea_data: {
              company: _this.azienda,
              partita_iva: _this.partita_iva,
              client_ownership: _this.client_ownership,
              company_address: _this.address,
              company_civic: _this.civic,
              company_zip: _this.cap,
              intervention_start_date: complateEneaData_moment(_this.eventStartdate).format('DD-MM-YYYY'),
              intervention_end_date: complateEneaData_moment(_this.eventEndtdate).format('DD-MM-YYYY'),
              house_quantity: _this.quantHouses,
              valvole_doc: _this.invoiceFrontBucket,
              // NEWWWWWWWW
              house_surface: _this.house_surface,
              house_count: _this.house_count,
              house_work_on: _this.house_work_on,
              type_system_old: _this.type_system_old,
              count_system_old: _this.count_system_old,
              group_system_old: _this.group_system_old,
              group_system_old_other: _this.group_system_old_other,
              potenza_utile_system_old: _this.potenza_utile_system_old,
              rendimento_100_system_old: _this.rendimento_100_system_old,
              vettore_termico_system_old: _this.vettore_termico_system_old,

              // NEW ADED ENEA 2022
              building_type: _this.building_type,
              building_type_other: _this.building_type_other,
              building_year: _this.building_year,
              building_merged: _this.building_merged,
              condensazione_present_clima: _this.condensazione_present_clima,

              // SOLARE
              solare_inclinazione: _this.solare_inclinazione,
              solare_orientamento: _this.solare_orientamento,
              solare_tipo_impianto_sostituito: _this.solare_tipo_impianto_sostituito,
              // CONDENSAZIONE
              condensazione_caldaia_destinata_a: _this.condensazione_caldaia_destinata_a,
              condensazione_alimentazione_caldaia: _this.condensazione_alimentazione_caldaia,

              // PDC
              pdc_superficie_utile_riscaldata: _this.pdc_superficie_utile_riscaldata,

              has_condensazione: _this.has_condensazione,
              has_tradizionale: _this.has_tradizionale,
              has_pompadicalore: _this.has_pompadicalore,
              has_ibridi: _this.has_ibridi,
              has_scaldacqua: _this.has_scaldacqua,
              has_climatizzatore: _this.has_climatizzatore,
              has_solare: _this.has_solare

            },
            user_token: _this.getProfile.userToken,
            code: _this.item.code

          };

          console.log(data);
          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/addAdditionalEneaData',
            method: 'POST',
            data: data,
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            _this.loadingState = false;
            _this.addSuccess();
            _this.$router.push('/pratiche');
          }).catch(function (resp) {
            _this.loadingState = false;
            _this.showAlert();
          });

          //

        } else {
          _this.$scrollTo('#app', 700, {
            offset: -75
          });
        }
      });
    },
    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        var t = 0;
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1;
        }

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = '';
            _vue.invoiceFrontBucket = '';
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = '';
          _vue.invoiceFrontBucket = '';
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },
    addSuccess: function addSuccess() {
      this.$swal({
        type: 'success',
        title: '<strong class="modalText ">I tuoi dati sono state salvati correttamente.</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },

    populateProvincies: function populateProvincies() {
      var _this2 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/21005back/public/" + 'api/getProvinciesAll',
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this2.provincies = resp.data.provincies;
        _this2.provinciesState = false;
      }).catch(function (resp) {
        _this2.provincies = [];
        _this2.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Riprova più tardi!'
      });
    },
    setCap: function setCap(cap) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var x;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (x in _this3.zips) {
                  if (_this3.zips[x].cap == cap.toUpperCase()) {
                    _this3.zip = _this3.zips[x].cap;
                  }
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    setCity: function setCity(city) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var x, k;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                for (x in _this4.cities) {
                  if (_this4.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this4.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this4.city = k;
                  }
                }
                console.log(_this4.city);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var x;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:

                for (x in _this5.provincies) {
                  if (_this5.provincies[x].sigla == province.toUpperCase()) {
                    _this5.province = _this5.provincies[x].sigla;
                  }
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    calcToDateStart: function calcToDateStart() {
      //var date = new Date(2021, 0, 1)
      var date = new Date(new Date().setDate(new Date().getDate() - 75));
      var finalTo = date;
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate()));
      var finalTo = date;
      return finalTo;
    },
    getInvoiceProducts: function getInvoiceProducts(code) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.loadingState = true;
                _context4.next = 3;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getInvoiceProducts',
                  method: 'POST',
                  data: {
                    code: code
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  var items = resp.data.products;
                  _this6.products = resp.data.products;

                  var _vue = _this6;

                  console.log(items);

                  _vue.productIndex = 0;
                  _vue.accessoriesIndex = 0;

                  var prodCount = 0;
                  var accCount = 0;

                  for (var x in items) {
                    // SET PRODUCTS
                    if (items[x].tipo == "product") {

                      if (items[x].gruppo == 'condensazione') {
                        _this6.has_condensazione = true;
                      }
                      if (items[x].gruppo == 'tradizionale') {
                        _this6.has_tradizionale = true;
                      }
                      if (items[x].gruppo == 'pompadicalore') {
                        _this6.has_pompadicalore = true;
                      }
                      if (items[x].gruppo == 'ibridi') {
                        _this6.has_ibridi = true;
                      }
                      if (items[x].gruppo == 'scaldacqua') {
                        _this6.has_scaldacqua = true;
                      }
                      if (items[x].gruppo == 'climatizzatore') {
                        _this6.has_climatizzatore = true;
                      }
                      if (items[x].gruppo == 'solare') {
                        _this6.has_solare = true;
                      }
                    }
                    // SET ACCESORIES
                    else {}
                  }

                  _this6.loadingState = false;
                }).catch(function (resp) {
                  _this6.loadingState = false;
                });

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    }
  },
  watch: {
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },
    mobile: function mobile(val) {
      if (val) {
        this.mobile = val.replace(/\D+/g, '');
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this7 = this;

      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = '';
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this7.cities = resp.data.cities;
          _this7.citiesState = false;
        }).catch(function (resp) {
          _this7.cities = [];
          _this7.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this8 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this8.zips = resp.data.zips;
          _this8.zipsState = false;
        }).catch(function (resp) {
          _this8.zips = [];
          _this8.zipsState = false;
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this9 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!_this9.$route.params.item) {
                _context5.next = 6;
                break;
              }

              _this9.item = _this9.$route.params.item;
              _context5.next = 4;
              return _this9.getInvoiceProducts(_this9.item.id);

            case 4:
              _context5.next = 7;
              break;

            case 6:
              if (!_this9.tokenControl) {
                _this9.$router.push('/pratiche');
              }

            case 7:
              _this9.disabledDatesStart = {
                to: _this9.calcToDateStart(), // Disable all dates up to specific date
                from: _this9.calcFromDateStart() // Disable all dates after specific date
              };
              _this9.populateProvincies();

              _this9.$scrollTo('#app', 700, {
                offset: -75
              });

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this9);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5414bf37","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/complateEneaData/index.vue
var complateEneaData_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container  pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-8 pt-md-4 " }, [
                _c("h3", { staticClass: "Regular text-left h0 widthFull" }, [
                  _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code))])
                ]),
                _vm._v(" "),
                _c("h5", { staticClass: "Regular h0 widthFull" }, [
                  _vm._v(
                    "Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 widthFull" }, [
                  _vm._v(
                    "\n          Completa il form qui sotto.\n          I dati inseriti verranno poi utilizzati per inviare la pratica Enea.\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 mt-3 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary m-2 btn-sm btnRed ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\n          Indietro\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pb-5 pt-4  black vaillantCont widthFull",
                attrs: { id: "registration-form" }
              },
              [
                _c(
                  "div",
                  { staticClass: "row justify-content-center " },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.item.client_type == "Persona fisica"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 mb-3",
                              staticStyle: { opacity: "1" }
                            },
                            [
                              _c("div", { staticClass: "group custInput" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.client_ownership,
                                        expression: "client_ownership"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          max: 63,
                                          min: 2
                                        },
                                        expression:
                                          "{required:true, max: 63, min: 2}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "client_ownership"
                                      ),
                                      valid: !!_vm.client_ownership
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomq",
                                      id: "client_ownership",
                                      name: "client_ownership",
                                      "data-vv-as": "Titolo di possesso"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.client_ownership = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "Proprietario" } },
                                      [_vm._v("Proprietario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Usufruttuario" } },
                                      [_vm._v("Usufruttuario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Locatario/Comodatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Comodatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Promissario acquirente"
                                        }
                                      },
                                      [_vm._v("Promissario acquirente")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Familiare convivente del possessore/detentore"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Familiare convivente del possessore/detentore"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Erede" } },
                                      [_vm._v("Erede")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Coniuge separato assegnatario"
                                        }
                                      },
                                      [_vm._v("Coniuge separato assegnatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà indivisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà indivisa"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà divisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà divisa"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "client_ownership" }
                                  },
                                  [_vm._v("Titolo di possesso *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("client_ownership")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "client_ownership"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center pb-5 " }, [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.house_surface,
                            expression: "house_surface"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 8, min: 1 },
                            expression: "{required:true, max: 8, min: 1}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("house_surface"),
                          valid: !!_vm.house_surface
                        },
                        attrs: {
                          type: "number",
                          id: "house_surface",
                          name: "house_surface",
                          "data-vv-as": "Superficie utile in m2"
                        },
                        domProps: { value: _vm.house_surface },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.house_surface = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _vm.errors.has("house_surface")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("house_surface")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-5" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.house_count,
                            expression: "house_count"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 8, min: 1 },
                            expression: "{required:true, max: 8, min: 1}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("house_count"),
                          valid: !!_vm.house_count
                        },
                        attrs: {
                          type: "number",
                          id: "house_count",
                          name: "house_count",
                          "data-vv-as":
                            "Numero unità immobiliari che compongono l'edificio"
                        },
                        domProps: { value: _vm.house_count },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.house_count = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "house_count" }
                        },
                        [
                          _vm._v(
                            "Num. unità immob. che compongono l'edificio * "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("house_count")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("house_count")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-4 mb-3",
                      staticStyle: { opacity: "1" }
                    },
                    [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.house_work_on,
                                expression: "house_work_on"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 163, min: 2 },
                                expression: "{required:true, max: 163, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("house_work_on"),
                              valid: !!_vm.house_work_on
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomq",
                              id: "house_work_on",
                              name: "house_work_on",
                              "data-vv-as": "intevento su"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.house_work_on = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Singola unità immobliare in un edificio costituito da più unità immobliari"
                                }
                              },
                              [
                                _vm._v(
                                  "Singola unità immobliare in un edificio costituito da più unità immobliari"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Edificio costitutito da una singola unità immobiliare"
                                }
                              },
                              [
                                _vm._v(
                                  "Edificio costitutito da una singola unità immobiliare"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Parti comuni condominiali" } },
                              [_vm._v("Parti comuni condominiali")]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Intero edifico o qualsiasi altro edifico non incluso nei casi sopra riportati"
                                }
                              },
                              [
                                _vm._v(
                                  "Intero edifico o qualsiasi altro edifico non incluso nei casi sopra riportati"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "house_work_on" }
                          },
                          [_vm._v("intevento su *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("house_work_on")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.first("house_work_on")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-4 mb-3",
                      staticStyle: { opacity: "1" }
                    },
                    [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.building_type,
                                expression: "building_type"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 163, min: 2 },
                                expression: "{required:true, max: 163, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("building_type"),
                              valid: !!_vm.building_type
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomq",
                              id: "building_type",
                              name: "building_type",
                              "data-vv-as": "Tipologia dell`edificio"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.building_type = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Edificio in linea e condominio oltre i tre piani fuori terra"
                                }
                              },
                              [
                                _vm._v(
                                  "Edificio in linea e condominio oltre i tre piani fuori terra"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Edificio a schiera e condominio fino a tre piani"
                                }
                              },
                              [
                                _vm._v(
                                  "Edificio a schiera e condominio fino a tre piani"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "costruzione isolata (es. mono o plurifamiliare)"
                                }
                              },
                              [
                                _vm._v(
                                  "Costruzione isolata (es. mono o plurifamiliare)"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value:
                                    "Edificio industriale, artigianale o commerciale"
                                }
                              },
                              [
                                _vm._v(
                                  "Edificio industriale, artigianale o commerciale"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "altro (specificare)" } },
                              [_vm._v("altro (specificare)")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "building_type" }
                          },
                          [_vm._v("Tipologia dell`edificio *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("building_type")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.first("building_type")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.building_type == "altro (specificare)"
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.building_type_other,
                                expression: "building_type_other"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 128, min: 3 },
                                expression: "{required:true, max: 128, min: 3}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has(
                                "building_type_other"
                              ),
                              valid: !!_vm.building_type_other
                            },
                            attrs: {
                              type: "text",
                              id: "building_type_other",
                              name: "building_type_other",
                              "data-vv-as": "Tipologia di impianto sostituito"
                            },
                            domProps: { value: _vm.building_type_other },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.building_type_other = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "building_type_other" }
                            },
                            [_vm._v("Tipologia dell`edificio * ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("building_type_other")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.errors.first("building_type_other")
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.building_year,
                            expression: "building_year"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              max: 4,
                              min: 4,
                              max_value: _vm.moment().format("Y"),
                              min_value: 1800
                            },
                            expression:
                              "{required:true, max: 4, min: 4, max_value: moment().format('Y'), min_value: 1800}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("building_year"),
                          valid: !!_vm.building_year
                        },
                        attrs: {
                          type: "number",
                          id: "building_year",
                          name: "building_year",
                          "data-vv-as": "Anno di costruzione (anche se stimato)"
                        },
                        domProps: { value: _vm.building_year },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.building_year = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _vm.errors.has("building_year")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("building_year")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-4 mb-3",
                      staticStyle: { opacity: "1" }
                    },
                    [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.building_merged,
                                expression: "building_merged"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 163, min: 2 },
                                expression: "{required:true, max: 163, min: 2}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("building_merged"),
                              valid: !!_vm.building_merged
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomq",
                              id: "building_merged",
                              name: "building_merged",
                              "data-vv-as": "accorpamenti di unità immobiliari"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.building_merged = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "SI" } }, [
                              _vm._v("SI")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "NO" } }, [
                              _vm._v("NO")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _vm.errors.has("building_merged")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.first("building_merged")) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.item.bonus != "Bonus Casa 50%" &&
                (_vm.has_condensazione ||
                  _vm.has_tradizionale ||
                  _vm.has_pompadicalore ||
                  _vm.has_ibridi ||
                  _vm.has_scaldacqua ||
                  _vm.has_climatizzatore)
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.type_system_old,
                                      expression: "type_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "type_system_old"
                                    ),
                                    valid: !!_vm.type_system_old
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "type_system_old",
                                    name: "type_system_old",
                                    "data-vv-as": "Tipo di impianto sostituito"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.type_system_old = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Impianto autonomo" } },
                                    [_vm._v("Impianto autonomo")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "Impianto centralizzato "
                                      }
                                    },
                                    [_vm._v("Impianto centralizzato ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Impianto centralizzato con contabilizzazione di calore per singolo utente"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Impianto centralizzato con contabilizzazione di calore per singolo utente"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Impianto centralizzato con più generatori di calore"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Impianto centralizzato con più generatori di calore"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Impianto centralizzato con più generatori di calore e contabilizzazione per singolo utente "
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Impianto centralizzato con più generatori di calore e contabilizzazione per singolo utente "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "altro" } }, [
                                    _vm._v("altro")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "type_system_old" }
                                },
                                [_vm._v("Tipo di impianto sostituito *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("type_system_old")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first("type_system_old")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.count_system_old,
                                  expression: "count_system_old"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "count_system_old"
                                ),
                                valid: !!_vm.count_system_old
                              },
                              attrs: {
                                type: "number",
                                id: "count_system_old",
                                name: "count_system_old",
                                "data-vv-as": "Numero di impianti sostituiti"
                              },
                              domProps: { value: _vm.count_system_old },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.count_system_old = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "count_system_old" }
                              },
                              [_vm._v("Numero di impianti sostituiti * ")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("count_system_old")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first("count_system_old")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.group_system_old,
                                      expression: "group_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "group_system_old"
                                    ),
                                    valid: !!_vm.group_system_old
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "group_system_old",
                                    name: "group_system_old",
                                    "data-vv-as":
                                      "Tipologia di impianto sostituito"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.group_system_old = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "caldaia ad acqua standard"
                                      }
                                    },
                                    [_vm._v("caldaia ad acqua standard")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "caldaia ad acqua calda a bassa temperatura"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "caldaia ad acqua calda a bassa temperatura"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "caldaia a gas a condensazione"
                                      }
                                    },
                                    [_vm._v("caldaia a gas a condensazione")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "caldaia a gasolio a condensazione"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "caldaia a gasolio a condensazione"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Pompa di calore/Impianto Geotermico"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Pompa di calore/Impianto Geotermico"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: { value: "Generatore aria calda" }
                                    },
                                    [_vm._v("Generatore aria calda")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Scambiatore per teleriscaldamento"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Scambiatore per teleriscaldamento"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Caldaia a Biomassa" } },
                                    [_vm._v("Caldaia a Biomassa")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "altro (specificare)" } },
                                    [_vm._v("altro (specificare)")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "group_system_old" }
                                },
                                [_vm._v("Tipologia di impianto sostituito *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("group_system_old")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first("group_system_old")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.group_system_old == "altro (specificare)"
                          ? _c("div", { staticClass: "col-md-12" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.group_system_old_other,
                                      expression: "group_system_old_other"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 128,
                                        min: 3
                                      },
                                      expression:
                                        "{required:true, max: 128, min: 3}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "group_system_old_other"
                                    ),
                                    valid: !!_vm.group_system_old_other
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "group_system_old_other",
                                    name: "group_system_old_other",
                                    "data-vv-as":
                                      "Tipologia di impianto sostituito"
                                  },
                                  domProps: {
                                    value: _vm.group_system_old_other
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.group_system_old_other =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "group_system_old_other" }
                                  },
                                  [
                                    _vm._v(
                                      "Tipologia di impianto sostituito * "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("group_system_old_other")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "group_system_old_other"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.potenza_utile_system_old,
                                  expression: "potenza_utile_system_old"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "potenza_utile_system_old"
                                ),
                                valid: !!_vm.potenza_utile_system_old
                              },
                              attrs: {
                                type: "number",
                                id: "potenza_utile_system_old",
                                name: "potenza_utile_system_old",
                                "data-vv-as":
                                  "Potenza utile nominale del impianto sostituito (KW)"
                              },
                              domProps: { value: _vm.potenza_utile_system_old },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.potenza_utile_system_old =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "potenza_utile_system_old" }
                              },
                              [_vm._v("Potenza utile nominale (KW) * ")]
                            ),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(" del impianto sostituito   ")
                            ]),
                            _vm._v(" "),
                            _vm.errors.has("potenza_utile_system_old")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "potenza_utile_system_old"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.rendimento_100_system_old,
                                  expression: "rendimento_100_system_old"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    max: 4,
                                    min: 1,
                                    max_value: 100
                                  },
                                  expression:
                                    "{required:true, max: 4, min: 1, max_value: 100 }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "rendimento_100_system_old"
                                ),
                                valid: !!_vm.rendimento_100_system_old
                              },
                              attrs: {
                                type: "number",
                                id: "rendimento_100_system_old",
                                name: "rendimento_100_system_old",
                                "data-vv-as": "Rendimento al 100% della potenza"
                              },
                              domProps: {
                                value: _vm.rendimento_100_system_old
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.rendimento_100_system_old =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "rendimento_100_system_old" }
                              },
                              [_vm._v("Rendimento al 100% * ")]
                            ),
                            _vm._v(" "),
                            _vm.group_system_old ==
                              "caldaia ad acqua standard" ||
                            _vm.group_system_old ==
                              "caldaia a gas a condensazione"
                              ? _c("small", [
                                  _vm._v(
                                    " rendimento nelle condizioni di temperatura di mandata e ritorno rispettivamente di 80°C e 60°C  "
                                  )
                                ])
                              : _vm.group_system_old ==
                                "Pompa di calore/Impianto Geotermico"
                              ? _c("small", [
                                  _vm._v(
                                    " la potenza elettrica assorbita (kW)  "
                                  )
                                ])
                              : _c("small", [_vm._v(" della potenza  ")]),
                            _vm._v(" "),
                            _vm.errors.has("rendimento_100_system_old")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "rendimento_100_system_old"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.vettore_termico_system_old,
                                      expression: "vettore_termico_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "vettore_termico_system_old"
                                    ),
                                    valid: !!_vm.vettore_termico_system_old
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "vettore_termico_system_old",
                                    name: "vettore_termico_system_old",
                                    "data-vv-as":
                                      "Vettore termico prevalentemente utilizzato"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.vettore_termico_system_old = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Gas metano" } },
                                    [_vm._v("Gas metano")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Gasolio" } },
                                    [_vm._v("Gasolio")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Gpl" } }, [
                                    _vm._v("Gpl")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Teleriscaldamento" } },
                                    [_vm._v("Teleriscaldamento")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Olio combustibile" } },
                                    [_vm._v("Olio combustibile")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Energia elettrica" } },
                                    [_vm._v("Energia elettrica")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Biomassa" } },
                                    [_vm._v("Biomassa")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Altro" } }, [
                                    _vm._v("Altro")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "vettore_termico_system_old" }
                                },
                                [_vm._v("Vettore termico *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("vettore_termico_system_old")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "vettore_termico_system_old"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(" prevalentemente utilizzato  ")
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(5)
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_solare
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.solare_inclinazione,
                                  expression: "solare_inclinazione"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "solare_inclinazione"
                                ),
                                valid: !!_vm.solare_inclinazione
                              },
                              attrs: {
                                type: "number",
                                id: "solare_inclinazione",
                                name: "solare_inclinazione",
                                "data-vv-as": "Inclinazione"
                              },
                              domProps: { value: _vm.solare_inclinazione },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.solare_inclinazione = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "solare_inclinazione" }
                              },
                              [_vm._v("Inclinazione % * ")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("solare_inclinazione")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first("solare_inclinazione")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.solare_orientamento,
                                      expression: "solare_orientamento"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "solare_orientamento"
                                    ),
                                    valid: !!_vm.solare_orientamento
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "solare_orientamento",
                                    name: "solare_orientamento",
                                    "data-vv-as": "Orientamento"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.solare_orientamento = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "nord" } }, [
                                    _vm._v("nord")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "nord-est" } },
                                    [_vm._v("nord-est")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "est" } }, [
                                    _vm._v("est")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "sud-est" } },
                                    [_vm._v("sud-est")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "ovest" } }, [
                                    _vm._v("ovest")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "nord-ovest" } },
                                    [_vm._v("nord-ovest")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "p-orizzontale" } },
                                    [_vm._v("p-orizzontale")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "solare_orientamento" }
                                },
                                [_vm._v("Orientamento *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("solare_orientamento")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "solare_orientamento"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.solare_tipo_impianto_sostituito,
                                      expression:
                                        "solare_tipo_impianto_sostituito"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "solare_tipo_impianto_sostituito"
                                    ),
                                    valid: !!_vm.solare_tipo_impianto_sostituito
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "solare_tipo_impianto_sostituito",
                                    name: "solare_tipo_impianto_sostituito",
                                    "data-vv-as":
                                      "Tipo di impianto integrato o sostituito"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.solare_tipo_impianto_sostituito = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Boiler elettrico" } },
                                    [_vm._v("Boiler elettrico")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "Scaldacqua a Gas o Gasolio"
                                      }
                                    },
                                    [_vm._v("Scaldacqua a Gas o Gasolio")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Altro" } }, [
                                    _vm._v("Altro")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Nessuno" } },
                                    [_vm._v("Nessuno")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: {
                                    for: "solare_tipo_impianto_sostituito"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Tipo di impianto integrato o sostituito *"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("solare_tipo_impianto_sostituito")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "solare_tipo_impianto_sostituito"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_condensazione
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.potenza_utile_system_old,
                                      expression: "potenza_utile_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, max: 8, min: 1 },
                                      expression:
                                        "{required:true, max: 8, min: 1}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "potenza_utile_system_old"
                                    ),
                                    valid: !!_vm.potenza_utile_system_old
                                  },
                                  attrs: {
                                    type: "number",
                                    id: "potenza_utile_system_old",
                                    name: "potenza_utile_system_old",
                                    "data-vv-as":
                                      "Potenza utile nominale del impianto sostituito (KW)"
                                  },
                                  domProps: {
                                    value: _vm.potenza_utile_system_old
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.potenza_utile_system_old =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "potenza_utile_system_old" }
                                  },
                                  [_vm._v("Potenza utile nominale (KW) * ")]
                                ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(" del impianto sostituito   ")
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("potenza_utile_system_old")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "potenza_utile_system_old"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.condensazione_caldaia_destinata_a,
                                      expression:
                                        "condensazione_caldaia_destinata_a"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "condensazione_caldaia_destinata_a"
                                    ),
                                    valid: !!_vm.condensazione_caldaia_destinata_a
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "condensazione_caldaia_destinata_a",
                                    name: "condensazione_caldaia_destinata_a",
                                    "data-vv-as": "Caldaia destinata a"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.condensazione_caldaia_destinata_a = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: { value: "Riscaldamento Ambiente" }
                                    },
                                    [_vm._v("Riscaldamento Ambiente")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value:
                                          "Riscaldamento Ambiente + Produzione ACS"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Riscaldamento Ambiente + Produzione ACS"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.item.bonus != "Bonus Casa 50%"
                                    ? _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Solo produzione di ACS centralizzata"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Solo produzione di ACS centralizzata"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: {
                                    for: "condensazione_caldaia_destinata_a"
                                  }
                                },
                                [_vm._v("Caldaia destinata a *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has(
                                "condensazione_caldaia_destinata_a"
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "condensazione_caldaia_destinata_a"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.condensazione_alimentazione_caldaia,
                                      expression:
                                        "condensazione_alimentazione_caldaia"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "condensazione_alimentazione_caldaia"
                                    ),
                                    valid: !!_vm.condensazione_alimentazione_caldaia
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "condensazione_alimentazione_caldaia",
                                    name: "condensazione_alimentazione_caldaia",
                                    "data-vv-as": "Alimentazione Caldaia"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.condensazione_alimentazione_caldaia = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Gas Naturale" } },
                                    [_vm._v("Gas Naturale")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Gpl" } }, [
                                    _vm._v("Gpl")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Gasolio" } },
                                    [_vm._v("Gasolio")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: {
                                    for: "condensazione_alimentazione_caldaia"
                                  }
                                },
                                [_vm._v("Alimentazione Caldaia *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has(
                                "condensazione_alimentazione_caldaia"
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "condensazione_alimentazione_caldaia"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.item.bonus != "Bonus Casa 50%"
                          ? _c(
                              "div",
                              {
                                staticClass: "col-md-4 mb-3",
                                staticStyle: { opacity: "1" }
                              },
                              [
                                _c("div", { staticClass: "group custInput" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.condensazione_present_clima,
                                          expression:
                                            "condensazione_present_clima"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 163,
                                            min: 2
                                          },
                                          expression:
                                            "{required:true, max: 163, min: 2}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "condensazione_present_clima"
                                        ),
                                        valid: !!_vm.condensazione_present_clima
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "randomq",
                                        id: "condensazione_present_clima",
                                        name: "condensazione_present_clima",
                                        "data-vv-as":
                                          "Presenza dell’impianto di climatizzazione estivo"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.condensazione_present_clima = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "SI" } }, [
                                        _vm._v("SI")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "NO" } }, [
                                        _vm._v("NO")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _vm.errors.has("condensazione_present_clima")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "condensazione_present_clima"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_pompadicalore || _vm.has_scaldacqua
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(9),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c(
                              "div",
                              {
                                staticClass: "col-md-4 mb-3",
                                staticStyle: { opacity: "1" }
                              },
                              [
                                _c("div", { staticClass: "group custInput" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.group_system_old,
                                          expression: "group_system_old"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 163,
                                            min: 2
                                          },
                                          expression:
                                            "{required:true, max: 163, min: 2}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "group_system_old"
                                        ),
                                        valid: !!_vm.group_system_old
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "randomq",
                                        id: "group_system_old",
                                        name: "group_system_old",
                                        "data-vv-as":
                                          "Tipologia di impianto sostituito"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.group_system_old = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "caldaia ad acqua standard"
                                          }
                                        },
                                        [_vm._v("caldaia ad acqua standard")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia ad acqua calda a bassa temperatura"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia ad acqua calda a bassa temperatura"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia a gas a condensazione"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia a gas a condensazione"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia a gasolio a condensazione"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia a gasolio a condensazione"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Pompa di calore/Impianto Geotermico"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Pompa di calore/Impianto Geotermico"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "Generatore aria calda"
                                          }
                                        },
                                        [_vm._v("Generatore aria calda")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Scambiatore per teleriscaldamento"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Scambiatore per teleriscaldamento"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: { value: "Caldaia a Biomassa" }
                                        },
                                        [_vm._v("Caldaia a Biomassa")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "altro" } },
                                        [_vm._v("altro")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "Nessuno" } },
                                        [_vm._v("Nessuno")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "group_system_old" }
                                    },
                                    [
                                      _vm._v(
                                        "Tipologia di impianto sostituito *"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("group_system_old")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "group_system_old"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.potenza_utile_system_old,
                                      expression: "potenza_utile_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, max: 8, min: 1 },
                                      expression:
                                        "{required:true, max: 8, min: 1}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "potenza_utile_system_old"
                                    ),
                                    valid: !!_vm.potenza_utile_system_old
                                  },
                                  attrs: {
                                    type: "number",
                                    id: "potenza_utile_system_old",
                                    name: "potenza_utile_system_old",
                                    "data-vv-as":
                                      "Potenza utile nominale del impianto sostituito (KW)"
                                  },
                                  domProps: {
                                    value: _vm.potenza_utile_system_old
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.potenza_utile_system_old =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _vm.group_system_old !=
                                "Pompa di calore/Impianto Geotermico"
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: {
                                          for: "potenza_utile_system_old"
                                        }
                                      },
                                      [_vm._v("Potenza utile nominale (KW) * ")]
                                    )
                                  : _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: {
                                          for: "potenza_utile_system_old"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "la potenza elettrica assorbita (kW) * "
                                        )
                                      ]
                                    ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(" del impianto sostituito   ")
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("potenza_utile_system_old")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "potenza_utile_system_old"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.pdc_superficie_utile_riscaldata,
                                  expression: "pdc_superficie_utile_riscaldata"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "pdc_superficie_utile_riscaldata"
                                ),
                                valid: !!_vm.pdc_superficie_utile_riscaldata
                              },
                              attrs: {
                                type: "number",
                                id: "pdc_superficie_utile_riscaldata",
                                name: "pdc_superficie_utile_riscaldata",
                                "data-vv-as":
                                  "Superficie utile riscaldata dalla PDC (m2)"
                              },
                              domProps: {
                                value: _vm.pdc_superficie_utile_riscaldata
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.pdc_superficie_utile_riscaldata =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: {
                                  for: "pdc_superficie_utile_riscaldata"
                                }
                              },
                              [_vm._v("Superficie utile riscaldata (m2) * ")]
                            ),
                            _vm._v(" "),
                            _c("small", [_vm._v(" dalla PDC  ")]),
                            _vm._v(" "),
                            _vm.errors.has("pdc_superficie_utile_riscaldata")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "pdc_superficie_utile_riscaldata"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_climatizzatore
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _c("div", { staticClass: "col-md-4" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.pdc_superficie_utile_riscaldata,
                                  expression: "pdc_superficie_utile_riscaldata"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 8, min: 1 },
                                  expression: "{required:true, max: 8, min: 1}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "pdc_superficie_utile_riscaldata"
                                ),
                                valid: !!_vm.pdc_superficie_utile_riscaldata
                              },
                              attrs: {
                                type: "number",
                                id: "pdc_superficie_utile_riscaldata",
                                name: "pdc_superficie_utile_riscaldata",
                                "data-vv-as":
                                  "Superficie utile riscaldata dalla PDC (m2)"
                              },
                              domProps: {
                                value: _vm.pdc_superficie_utile_riscaldata
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.pdc_superficie_utile_riscaldata =
                                    $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: {
                                  for: "pdc_superficie_utile_riscaldata"
                                }
                              },
                              [_vm._v("Superficie utile riscaldata (m2) * ")]
                            ),
                            _vm._v(" "),
                            _c("small", [_vm._v(" ( o raffreddata )  ")]),
                            _vm._v(" "),
                            _vm.errors.has("pdc_superficie_utile_riscaldata")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "pdc_superficie_utile_riscaldata"
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c(
                              "div",
                              {
                                staticClass: "col-md-4 mb-3",
                                staticStyle: { opacity: "1" }
                              },
                              [
                                _c("div", { staticClass: "group custInput" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.group_system_old,
                                          expression: "group_system_old"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 163,
                                            min: 2
                                          },
                                          expression:
                                            "{required:true, max: 163, min: 2}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "group_system_old"
                                        ),
                                        valid: !!_vm.group_system_old
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "randomq",
                                        id: "group_system_old",
                                        name: "group_system_old",
                                        "data-vv-as":
                                          "Tipologia di impianto sostituito"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.group_system_old = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "caldaia ad acqua standard"
                                          }
                                        },
                                        [_vm._v("caldaia ad acqua standard")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia ad acqua calda a bassa temperatura"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia ad acqua calda a bassa temperatura"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia a gas a condensazione"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia a gas a condensazione"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "caldaia a gasolio a condensazione"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "caldaia a gasolio a condensazione"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Pompa di calore/Impianto Geotermico"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Pompa di calore/Impianto Geotermico"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "Generatore aria calda"
                                          }
                                        },
                                        [_vm._v("Generatore aria calda")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Scambiatore per teleriscaldamento"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Scambiatore per teleriscaldamento"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: { value: "Caldaia a Biomassa" }
                                        },
                                        [_vm._v("Caldaia a Biomassa")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "altro" } },
                                        [_vm._v("altro")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "Nessuno" } },
                                        [_vm._v("Nessuno")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "group_system_old" }
                                    },
                                    [
                                      _vm._v(
                                        "Tipologia di impianto sostituito *"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("group_system_old")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "group_system_old"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.potenza_utile_system_old,
                                      expression: "potenza_utile_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, max: 8, min: 1 },
                                      expression:
                                        "{required:true, max: 8, min: 1}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "potenza_utile_system_old"
                                    ),
                                    valid: !!_vm.potenza_utile_system_old
                                  },
                                  attrs: {
                                    type: "number",
                                    id: "potenza_utile_system_old",
                                    name: "potenza_utile_system_old",
                                    "data-vv-as":
                                      "Potenza utile nominale del impianto sostituito (KW)"
                                  },
                                  domProps: {
                                    value: _vm.potenza_utile_system_old
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.potenza_utile_system_old =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _vm.group_system_old !=
                                "Pompa di calore/Impianto Geotermico"
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: {
                                          for: "potenza_utile_system_old"
                                        }
                                      },
                                      [_vm._v("Potenza utile nominale (KW) * ")]
                                    )
                                  : _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: {
                                          for: "potenza_utile_system_old"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "la potenza elettrica assorbita (kW) * "
                                        )
                                      ]
                                    ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v("* del impianto sostituito   ")
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("potenza_utile_system_old")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "potenza_utile_system_old"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.has_ibridi
                  ? _c(
                      "div",
                      { staticClass: "row justify-content-center pb-5 " },
                      [
                        _vm._m(10),
                        _vm._v(" "),
                        _vm.item.bonus == "Bonus Casa 50%"
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.potenza_utile_system_old,
                                      expression: "potenza_utile_system_old"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, max: 8, min: 1 },
                                      expression:
                                        "{required:true, max: 8, min: 1}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "potenza_utile_system_old"
                                    ),
                                    valid: !!_vm.potenza_utile_system_old
                                  },
                                  attrs: {
                                    type: "number",
                                    id: "potenza_utile_system_old",
                                    name: "potenza_utile_system_old",
                                    "data-vv-as":
                                      "Potenza utile nominale del impianto sostituito (KW)"
                                  },
                                  domProps: {
                                    value: _vm.potenza_utile_system_old
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.potenza_utile_system_old =
                                        $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "potenza_utile_system_old" }
                                  },
                                  [_vm._v("Potenza utile nominale (KW) * ")]
                                ),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(" del impianto sostituito   ")
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("potenza_utile_system_old")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "potenza_utile_system_old"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-4 mb-3",
                            staticStyle: { opacity: "1" }
                          },
                          [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.ibrido_alimentazione_caldaia,
                                      expression: "ibrido_alimentazione_caldaia"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        max: 163,
                                        min: 2
                                      },
                                      expression:
                                        "{required:true, max: 163, min: 2}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "ibrido_alimentazione_caldaia"
                                    ),
                                    valid: !!_vm.ibrido_alimentazione_caldaia
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomq",
                                    id: "ibrido_alimentazione_caldaia",
                                    name: "ibrido_alimentazione_caldaia",
                                    "data-vv-as": "Alimentazione Caldaia"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.ibrido_alimentazione_caldaia = $event
                                        .target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "Gas Naturale" } },
                                    [_vm._v("Gas Naturale")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Gpl" } }, [
                                    _vm._v("Gpl")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Gasolio" } },
                                    [_vm._v("Gasolio")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "ibrido_alimentazione_caldaia" }
                                },
                                [_vm._v("Alimentazione Caldaia *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("ibrido_alimentazione_caldaia")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "ibrido_alimentazione_caldaia"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row justify-content-center pb-5 " },
                  [
                    _vm.item.client_type == "Partita IVA"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _vm.item.client_type == "Partita IVA"
                              ? _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\n              Completa i dati del cliente finale ("
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.item.client_name) +
                                          " " +
                                          _vm._s(_vm.item.client_lastname)
                                      )
                                    ]),
                                    _vm._v(")\n            ")
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.azienda,
                                    expression: "azienda"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 3 },
                                    expression:
                                      "{required:true, max: 128, min: 3}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("azienda"),
                                  valid: !!_vm.azienda
                                },
                                attrs: {
                                  type: "text",
                                  id: "azienda",
                                  name: "azienda",
                                  "data-vv-as": "Ragione sociale"
                                },
                                domProps: { value: _vm.azienda },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.azienda = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "azienda" }
                                },
                                [_vm._v("Ragione sociale * ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("azienda")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("azienda")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.partita_iva,
                                    expression: "partita_iva"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      partitaIva: true,
                                      max: 11,
                                      min: 11
                                    },
                                    expression:
                                      "{required: true, partitaIva: true, max: 11, min: 11,}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("partita_iva"),
                                  valid: !!_vm.partita_iva
                                },
                                attrs: {
                                  type: "text",
                                  id: "partita_iva",
                                  name: "partita_iva",
                                  "data-vv-as": "Partita IVA"
                                },
                                domProps: { value: _vm.partita_iva },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.partita_iva = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "partita_iva" }
                                },
                                [_vm._v("Partita IVA *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("partita_iva")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("partita_iva")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 mb-3",
                              staticStyle: { opacity: "1" }
                            },
                            [
                              _c("div", { staticClass: "group custInput" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.client_ownership,
                                        expression: "client_ownership"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          max: 63,
                                          min: 2
                                        },
                                        expression:
                                          "{required:true, max: 63, min: 2}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "client_ownership"
                                      ),
                                      valid: !!_vm.client_ownership
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomq",
                                      id: "client_ownership",
                                      name: "client_ownership",
                                      "data-vv-as": "Titolo di possesso"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.client_ownership = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "Proprietario" } },
                                      [_vm._v("Proprietario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Usufruttuario" } },
                                      [_vm._v("Usufruttuario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Locatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Promissario acquirente"
                                        }
                                      },
                                      [_vm._v("Promissario acquirente")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Familiare convivente del possessore/detentore"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Familiare convivente del possessore/detentore"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Erede" } },
                                      [_vm._v("Erede")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Coniuge separato assegnatario"
                                        }
                                      },
                                      [_vm._v("Coniuge separato assegnatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà indivisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà indivisa"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà divisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà divisa"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "client_ownership" }
                                  },
                                  [_vm._v("Titolo di possesso *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("client_ownership")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "client_ownership"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "widthFull center black" }, [
                            _vm._v("\n            Sede Legale\n          ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.address,
                                    expression: "address"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 5 },
                                    expression:
                                      "{required:true, max: 128, min: 5}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("address"),
                                  valid: !!_vm.address
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomr",
                                  id: "address",
                                  name: "address",
                                  "data-vv-as": "Indirizzo"
                                },
                                domProps: { value: _vm.address },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.address = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "address" }
                                },
                                [_vm._v("Indirizzo *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("address")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("address")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.civic,
                                    expression: "civic"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 15 },
                                    expression: "{required:true, max: 15}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("civic"),
                                  valid: !!_vm.civic
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "civic",
                                  name: "civic",
                                  "data-vv-as": "N. Civico"
                                },
                                domProps: { value: _vm.civic },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.civic = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "civic" }
                                },
                                [_vm._v("N. Civico *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("civic")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("civic")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.cap,
                                    expression: "cap"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 5, max: 6 },
                                    expression:
                                      "{required:true, min: 5, max: 6}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("cap"),
                                  valid: !!_vm.cap
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "cap",
                                  name: "cap",
                                  "data-vv-as": "CAP"
                                },
                                domProps: { value: _vm.cap },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.cap = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "cap" }
                                },
                                [_vm._v("CAP *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("cap")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("cap")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.client_type == "Amministratore di condominio"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "h4",
                              { staticClass: "widthFull center black" },
                              [
                                _vm._v(
                                  "\n              Completa i dati dell'Amministratore del condominio ("
                                ),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.item.client_name) +
                                      " " +
                                      _vm._s(_vm.item.client_lastname)
                                  )
                                ]),
                                _vm._v(")\n            ")
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.quantHouses,
                                    expression: "quantHouses"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 1, max: 6 },
                                    expression:
                                      "{required:true, min: 1, max: 6}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("quantHouses"),
                                  valid: !!_vm.quantHouses
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "quantHouses",
                                  name: "quantHouses",
                                  "data-vv-as": "Numero di unità immobiliari"
                                },
                                domProps: { value: _vm.quantHouses },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.quantHouses = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "quantHouses" }
                                },
                                [
                                  _vm._v(
                                    "Numero di unità immobiliari che compongono l’edificio *"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("quantHouses")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("quantHouses")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(11),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3 " }, [
                      _c(
                        "div",
                        { staticClass: "group custInput" },
                        [
                          _c("datepicker", {
                            attrs: {
                              language: _vm.it,
                              "full-month-name": true,
                              format: "dd MMMM yyyy",
                              "monday-first": true,
                              id: "eventStartdate",
                              name: "eventStartdate",
                              "input-class": "form-control dateInput"
                            },
                            model: {
                              value: _vm.eventStartdate,
                              callback: function($$v) {
                                _vm.eventStartdate = $$v
                              },
                              expression: "eventStartdate"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventStartdate,
                                expression: "eventStartdate"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("eventStartdate"),
                              valid: !!_vm.eventStartdate
                            },
                            attrs: {
                              type: "text",
                              id: "eventStartdate",
                              name: "eventStartdate",
                              "data-vv-as": "Data inizio"
                            },
                            domProps: { value: _vm.eventStartdate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.eventStartdate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "eventStartdate" }
                            },
                            [_vm._v("Data inizio")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("eventStartdate")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("eventStartdate")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3 " }, [
                      _c(
                        "div",
                        { staticClass: "group custInput" },
                        [
                          _c("datepicker", {
                            attrs: {
                              language: _vm.it,
                              "full-month-name": true,
                              format: "dd MMMM yyyy",
                              "monday-first": true,
                              disabledDates: _vm.disabledDatesStart,
                              id: "eventEndtdate",
                              name: "eventEndtdate",
                              "input-class": "form-control dateInput"
                            },
                            model: {
                              value: _vm.eventEndtdate,
                              callback: function($$v) {
                                _vm.eventEndtdate = $$v
                              },
                              expression: "eventEndtdate"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventEndtdate,
                                expression: "eventEndtdate"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("eventEndtdate"),
                              valid: !!_vm.eventEndtdate
                            },
                            attrs: {
                              type: "text",
                              id: "eventEndtdate",
                              name: "eventEndtdate",
                              "data-vv-as": "Data ultimazione dei lavori"
                            },
                            domProps: { value: _vm.eventEndtdate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.eventEndtdate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "eventEndtdate" }
                            },
                            [_vm._v("Data ultimazione dei lavori (collaudo)")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("eventEndtdate")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("eventEndtdate")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.item.bonus != "Bonus Casa 50%"
                      ? [
                          _vm._m(12),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-8 mb-3 pr-4 text-left" },
                            [
                              _c("div", { staticClass: "form-check" }, [
                                _c("div", { staticClass: "p-3" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.noValvole,
                                        expression: "noValvole"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {},
                                        expression: "{}"
                                      }
                                    ],
                                    staticClass: "form-check-input",
                                    class: {
                                      "is-invalid": _vm.errors.has("noValvole")
                                    },
                                    attrs: {
                                      type: "checkbox",
                                      id: "noValvole",
                                      name: "noValvole",
                                      "data-vv-as": ""
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.noValvole)
                                        ? _vm._i(_vm.noValvole, null) > -1
                                        : _vm.noValvole
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.noValvole,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.noValvole = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.noValvole = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.noValvole = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._m(13),
                                  _vm._v(" "),
                                  _vm.errors.has("noValvole")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.errors.first("noValvole")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.noValvole
                            ? _c("div", { staticClass: "col-md-12 mb-4" }, [
                                _c("p", { staticClass: "center" }, [
                                  _vm._v(
                                    "Se necessario è possibile selezionare piu di un file"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "front-image" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          size: 10240,
                                          ext: ["jpeg", "jpg", "png", "pdf"],
                                          mimes: [
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                            "application/pdf"
                                          ]
                                        },
                                        expression:
                                          "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                      }
                                    ],
                                    ref: "fileInput",
                                    staticClass: "fileInput",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "invoiceFront"
                                      ),
                                      valid: !!_vm.invoiceFront,
                                      helper: !!_vm.invoiceFrontBucket
                                    },
                                    attrs: {
                                      type: "file",
                                      multiple: "",
                                      name: "invoiceFront",
                                      id: "invoiceFront",
                                      "data-vv-as":
                                        "Scheda tecnica delle valvole termostatiche"
                                    },
                                    on: { change: _vm.uploadFile }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoiceFront" }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "smallText center white",
                                              style: {
                                                backgroundImage:
                                                  "url(" +
                                                  _vm.invoiceFrontBucket +
                                                  ")"
                                              }
                                            },
                                            [
                                              !_vm.invoiceFrontName
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "smallText center white mt-3 mb-0 pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli il Contratto quadro*"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "smallText center white",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                _vm.invoiceFrontBucket +
                                                ")"
                                            }
                                          })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoiceFront")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { top: "185px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.errors.first("invoiceFront")
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress mt-5",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar ",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                        },
                                        [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 mb-3 center mt-5" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btnRed",
                          attrs: { type: "button" },
                          on: { click: _vm.setAditionalEneaData }
                        },
                        [_vm._v(" Salva ")]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var complateEneaData_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v("\n            Inserisci i dati dell'immobile\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "niceInputLabel", attrs: { for: "house_surface" } },
      [_vm._v("Superficie utile in m"), _c("sup", [_vm._v("2")]), _vm._v(" * ")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "niceInputLabel", attrs: { for: "building_year" } },
      [
        _vm._v("Anno di costruzione "),
        _c("small", [_vm._v("(anche se stimato)")]),
        _vm._v(" * ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "niceInputLabel", attrs: { for: "building_merged" } },
      [
        _c("small", [
          _vm._v("Si sono verificati degli accorpamenti di unità immobiliari?")
        ]),
        _vm._v(" *")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Inserisci i dati dell'impianto termico sostituito\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-11 center" }, [
      _c("p", { staticClass: "center mb-0 small" }, [
        _vm._v(
          "\n          Nel caso di più generatori dello stesso tipo indicare la somma delle potenze e il valore medio pesato rispetto alla potenza nominale del rendimento.\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "center mb-0 small " }, [
        _vm._v(
          "\n          Per le pompe di calore indicare la potenza elettrica assorbita e la potenza utile nelle condizioni nominali indicate nell’Allegato I del decreto 10/02/2007 come modificato dal DM 06/08/2009.\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "center mb-0 small" }, [
        _vm._v(
          "\n          Per le caldaia ad acqua inserire il rendimento nelle condizioni di temperatura di mandata e ritorno rispettivamente di 80 °C e 60 °C.\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v("\n            Inserisci i dati del Solare termico\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Inserisci i dati della Caldaia a condensazione\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel",
        attrs: { for: "condensazione_present_clima" }
      },
      [
        _c("small", [
          _vm._v("Presenza dell’impianto di climatizzazione estivo?")
        ]),
        _vm._v(" *")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Inserisci i dati della Pompa di calore\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n            Inserisci i dati della Sistema Ibrido\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-9" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v("\n            Inserisci i dati dell'intervento\n          ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "center " }, [
        _vm._v(
          "\n            Sulla piattaforma entro 75 giorni dalla chiusura dei lavori o dal collaudo delle opere in modo da permetterci di rispettare, nella gestione, il termine ultimo di 90 giorni dalla chiusura dei lavori o dal collaudo delle opere previsto dalla legge.\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "center red" }, [
        _vm._v(
          "\n            Se i dati per la compilazione della dichiarazione non vengono comunicati nei tempi richiesti per legge non possiamo prendere in carico la gestione della dichiarazione Enea.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\n              Scheda tecnica delle valvole termostatiche\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "form-check-label textStable",
        attrs: { for: "noValvole" }
      },
      [
        _c("b", [
          _vm._v(
            "Valvole termostatiche non installate come da relazione allegata alla Dichiarazione di Conformità.\n                  "
          ),
          _c("br"),
          _vm._v(
            "Se questo campo viene valorizzato il documento richiesto può essere omesso."
          )
        ])
      ]
    )
  }
]
complateEneaData_render._withStripped = true
var complateEneaData_esExports = { render: complateEneaData_render, staticRenderFns: complateEneaData_staticRenderFns }
/* harmony default export */ var components_complateEneaData = (complateEneaData_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5414bf37", complateEneaData_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/complateEneaData/index.vue
var complateEneaData_disposed = false
function complateEneaData_injectStyle (ssrContext) {
  if (complateEneaData_disposed) return
  __webpack_require__("Cz55")
}
var complateEneaData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var complateEneaData___vue_template_functional__ = false
/* styles */
var complateEneaData___vue_styles__ = complateEneaData_injectStyle
/* scopeId */
var complateEneaData___vue_scopeId__ = "data-v-5414bf37"
/* moduleIdentifier (server only) */
var complateEneaData___vue_module_identifier__ = null
var complateEneaData_Component = complateEneaData_normalizeComponent(
  complateEneaData,
  components_complateEneaData,
  complateEneaData___vue_template_functional__,
  complateEneaData___vue_styles__,
  complateEneaData___vue_scopeId__,
  complateEneaData___vue_module_identifier__
)
complateEneaData_Component.options.__file = "src/components/complateEneaData/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5414bf37", complateEneaData_Component.options)
  } else {
    hotAPI.reload("data-v-5414bf37", complateEneaData_Component.options)
  }
  module.hot.dispose(function (data) {
    complateEneaData_disposed = true
  })
})()}

/* harmony default export */ var src_components_complateEneaData = (complateEneaData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/paymentError/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var paymentError_moment = __webpack_require__("PJh5");

/* harmony default export */ var paymentError = ({
  name: 'play',
  components: {},
  data: function data() {
    return {
      loadingState: false,
      userToken: '',
      vw: window.innerWidth,
      practice: ''
    };
  },

  methods: {},
  watch: {},
  updated: function updated() {},
  created: function created() {
    console.log(this.$route.params.id);
    this.practice = this.$route.params.id;
  },
  mounted: function mounted() {},
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f46a2896","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentError/index.vue
var paymentError_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull container-fluid mainBackVaillant pt-5 mt-5" },
    [
      _c("div", { staticClass: "row justify-content-center " }, [
        _c(
          "div",
          { staticClass: "widthFull container vaillantCont pt-5 mt-5" },
          [
            _c("div", { staticClass: "row justify-content-center pb-5 mb-5" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6  center" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("h1", { staticClass: "h2 center Regular Bold  " }, [
                  _c("b", [_vm._v("Pratica " + _vm._s(_vm.practice))])
                ]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(
                  "\n\n          Di solito il problema più comune con i tentativi di pagamento è che siano bloccati dalla banca.\n          Per favore prova a contattare la tua banca per ottenere più informazioni e autorizzare l'addebito.\n          Prova a impostare un metodo di pagamento diverso, una diversa carta di credito / debit o il tuo account PayPal.\n          Potrebbe trattarsi di un rifiuto temporaneo da parte della banca.\n\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 mt-5 center" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-secondary btn-lg",
                      attrs: { to: "/pratiche" }
                    },
                    [_vm._v(" Gestione Pratiche ")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ])
    ]
  )
}
var paymentError_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12  center" }, [
      _c("img", {
        staticClass: "img-fluid widthFull errorIcon",
        attrs: { src: __webpack_require__("jmlf") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "h2 center Regular Bold red" }, [
      _c("b", [_vm._v("ATTENZIONE!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "h2 center Regular Bold pb-4 " }, [
      _c("b", [_vm._v("Pagamento non andato a buon fine.")])
    ])
  }
]
paymentError_render._withStripped = true
var paymentError_esExports = { render: paymentError_render, staticRenderFns: paymentError_staticRenderFns }
/* harmony default export */ var components_paymentError = (paymentError_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f46a2896", paymentError_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/paymentError/index.vue
var paymentError_disposed = false
function paymentError_injectStyle (ssrContext) {
  if (paymentError_disposed) return
  __webpack_require__("qex6")
}
var paymentError_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var paymentError___vue_template_functional__ = false
/* styles */
var paymentError___vue_styles__ = paymentError_injectStyle
/* scopeId */
var paymentError___vue_scopeId__ = "data-v-f46a2896"
/* moduleIdentifier (server only) */
var paymentError___vue_module_identifier__ = null
var paymentError_Component = paymentError_normalizeComponent(
  paymentError,
  components_paymentError,
  paymentError___vue_template_functional__,
  paymentError___vue_styles__,
  paymentError___vue_scopeId__,
  paymentError___vue_module_identifier__
)
paymentError_Component.options.__file = "src/components/paymentError/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f46a2896", paymentError_Component.options)
  } else {
    hotAPI.reload("data-v-f46a2896", paymentError_Component.options)
  }
  module.hot.dispose(function (data) {
    paymentError_disposed = true
  })
})()}

/* harmony default export */ var src_components_paymentError = (paymentError_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/paymentSuccess/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var paymentSuccess_moment = __webpack_require__("PJh5");

/* harmony default export */ var paymentSuccess = ({
  name: 'paymentError',
  components: {},
  data: function data() {
    return {
      loadingState: false,
      userToken: '',
      vw: window.innerWidth,
      practice: ''
    };
  },

  methods: {},
  watch: {},
  updated: function updated() {},
  created: function created() {
    console.log(this.$route.params.id);
    this.practice = this.$route.params.id;
  },
  mounted: function mounted() {},
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48050120","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentSuccess/index.vue
var paymentSuccess_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull container-fluid mainBackVaillant pt-5 mt-5" },
    [
      _c("div", { staticClass: "row justify-content-center " }, [
        _c(
          "div",
          { staticClass: "widthFull container vaillantCont pt-5 mt-5" },
          [
            _c("div", { staticClass: "row justify-content-center pb-5 mb-5" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6  center" }, [
                _c("h1", { staticClass: "h2 center Regular Bold  " }, [
                  _c("b", [_vm._v("Pratica " + _vm._s(_vm.practice))])
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 mt-5 center" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-secondary btn-lg",
                      attrs: { to: "/pratiche" }
                    },
                    [_vm._v(" Gestione Pratiche ")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ])
    ]
  )
}
var paymentSuccess_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12  center" }, [
      _c("img", {
        staticClass: "img-fluid payImage",
        attrs: { src: __webpack_require__("4AGf") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "center" }, [
      _c("b", [_vm._v("Grazie per averci scelto, ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center " }, [
      _c("b", [_vm._v("il tuo pagamento è avvenuto con successo")])
    ])
  }
]
paymentSuccess_render._withStripped = true
var paymentSuccess_esExports = { render: paymentSuccess_render, staticRenderFns: paymentSuccess_staticRenderFns }
/* harmony default export */ var components_paymentSuccess = (paymentSuccess_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48050120", paymentSuccess_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/paymentSuccess/index.vue
var paymentSuccess_disposed = false
function paymentSuccess_injectStyle (ssrContext) {
  if (paymentSuccess_disposed) return
  __webpack_require__("sSMI")
}
var paymentSuccess_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var paymentSuccess___vue_template_functional__ = false
/* styles */
var paymentSuccess___vue_styles__ = paymentSuccess_injectStyle
/* scopeId */
var paymentSuccess___vue_scopeId__ = "data-v-48050120"
/* moduleIdentifier (server only) */
var paymentSuccess___vue_module_identifier__ = null
var paymentSuccess_Component = paymentSuccess_normalizeComponent(
  paymentSuccess,
  components_paymentSuccess,
  paymentSuccess___vue_template_functional__,
  paymentSuccess___vue_styles__,
  paymentSuccess___vue_scopeId__,
  paymentSuccess___vue_module_identifier__
)
paymentSuccess_Component.options.__file = "src/components/paymentSuccess/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48050120", paymentSuccess_Component.options)
  } else {
    hotAPI.reload("data-v-48050120", paymentSuccess_Component.options)
  }
  module.hot.dispose(function (data) {
    paymentSuccess_disposed = true
  })
})()}

/* harmony default export */ var src_components_paymentSuccess = (paymentSuccess_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cobrowsing/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var cobrowsing_moment = __webpack_require__("PJh5");

/* harmony default export */ var cobrowsing = ({
  name: 'play',
  components: {},
  data: function data() {
    return {
      loadingState: false,
      userToken: '',
      vw: window.innerWidth,
      practice: '',
      page: ''
    };
  },

  methods: {},
  watch: {},
  updated: function updated() {},
  created: function created() {},
  mounted: function mounted() {
    this.$scrollTo('#app', 700, {
      offset: -75
    });
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff98e3f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cobrowsing/index.vue
var cobrowsing_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull container-fluid mainBackVaillant pt-1 mt-5" },
    [
      _c("div", { staticClass: "row justify-content-center " }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4 col-md-2  center mr-md-5 pr-5 pl-5 pt-2" },
          [
            _c("h1", { staticClass: "center widthFull" }, [
              _c("img", {
                staticClass: "img-fluid widthFull pointer linkImage",
                attrs: {
                  src: __webpack_require__("sb9c")
                },
                on: {
                  click: function($event) {
                    _vm.page = "ade"
                  }
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4 col-md-2  center pt-2 ml-md-5 pr-5 pl-5 pt-3" },
          [
            _c("h1", { staticClass: "center widthFull" }, [
              _c("img", {
                staticClass: "img-fluid widthFull pointer linkImage",
                attrs: { src: __webpack_require__("0rFJ") },
                on: {
                  click: function($event) {
                    _vm.page = "poste"
                  }
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "widthFull container-fluid vaillantCont mt-4 borderRed"
          },
          [
            _c("div", { staticClass: "row justify-content-center  mb-5" }, [
              _vm.page == "ade" || _vm.page == ""
                ? _c("iframe", {
                    staticStyle: {
                      border: "none",
                      width: "100%",
                      "min-height": "500px",
                      height: "70vh!important"
                    },
                    attrs: {
                      id: "contestentry",
                      src:
                        "https://telematici.agenziaentrate.gov.it/Main/login.jsp",
                      allowvr: "yes",
                      width: "100%",
                      scrolling: "yes",
                      title: "Contest Entry"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.page == "poste"
                ? _c("iframe", {
                    staticStyle: {
                      border: "none",
                      width: "100%",
                      "min-height": "500px",
                      height: "70vh!important"
                    },
                    attrs: {
                      frameborder: "0",
                      target: "_self",
                      id: "contestentry",
                      src:
                        "https://business.poste.it/professionisti-imprese/prodotti/conto-bancoposta-affari.html",
                      allowvr: "yes",
                      width: "100%",
                      allowtransparency: "true",
                      scrolling: "yes",
                      title: "Contest Entry"
                    }
                  })
                : _vm._e()
            ])
          ]
        )
      ])
    ]
  )
}
var cobrowsing_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mt-3 center" }, [
      _c("h1", { staticClass: "center widthFull" }, [_vm._v(" Co-Browsing ")])
    ])
  }
]
cobrowsing_render._withStripped = true
var cobrowsing_esExports = { render: cobrowsing_render, staticRenderFns: cobrowsing_staticRenderFns }
/* harmony default export */ var components_cobrowsing = (cobrowsing_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff98e3f4", cobrowsing_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/cobrowsing/index.vue
var cobrowsing_disposed = false
function cobrowsing_injectStyle (ssrContext) {
  if (cobrowsing_disposed) return
  __webpack_require__("rW15")
}
var cobrowsing_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cobrowsing___vue_template_functional__ = false
/* styles */
var cobrowsing___vue_styles__ = cobrowsing_injectStyle
/* scopeId */
var cobrowsing___vue_scopeId__ = "data-v-ff98e3f4"
/* moduleIdentifier (server only) */
var cobrowsing___vue_module_identifier__ = null
var cobrowsing_Component = cobrowsing_normalizeComponent(
  cobrowsing,
  components_cobrowsing,
  cobrowsing___vue_template_functional__,
  cobrowsing___vue_styles__,
  cobrowsing___vue_scopeId__,
  cobrowsing___vue_module_identifier__
)
cobrowsing_Component.options.__file = "src/components/cobrowsing/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ff98e3f4", cobrowsing_Component.options)
  } else {
    hotAPI.reload("data-v-ff98e3f4", cobrowsing_Component.options)
  }
  module.hot.dispose(function (data) {
    cobrowsing_disposed = true
  })
})()}

/* harmony default export */ var src_components_cobrowsing = (cobrowsing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/flowSettings/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var flowSettings_moment = __webpack_require__("PJh5");

var flowSettings_numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';










/* harmony default export */ var flowSettings = ({
  name: 'login',
  data: function data() {
    var _ref;

    return _ref = {
      username: '',
      documents: {},
      password: '',
      token: '',
      numeral: __webpack_require__("ViqS"),
      proccess: 'START',
      loading: false,
      priceAcc: '',
      brand: "CHEBONUS",
      flow: '',
      zeroEnea: false,
      zeroDcast: false,
      zeroAT: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroVdC: false,
      zeroEneaOld: '',
      zeroDcastOld: '',
      zeroATOld: '',
      zeroOneriOld: '',
      zeroPraticaOld: '',
      zeroVdCOld: '',

      //NEWWWW 222
      client_owner_type: '',
      client_owner_codice_fiscale: '',

      client_codice_fiscale: '',
      client_partita_iva: '',

      priceWork: '',
      tempMail: '',
      socialEmail: false,
      social: '',
      items: {},
      ecoBonus: '',
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: 'Caldaia a condensazione',
          value: 'condensazione'
        },
        1: {
          name: 'Caldaia tradizionale',
          value: 'tradizionale'
        },
        2: {
          name: 'Pompa di calore',
          value: 'pompadicalore'
        },
        3: {
          name: 'Sistemi Ibridi kit completo',
          value: 'ibridi'
        },
        4: {
          name: 'Scaldacqua PDC',
          value: 'scaldacqua'
        },
        5: {
          name: 'Climatizzatore',
          value: 'climatizzatore'
        },
        6: {
          name: 'Collettore solare termico',
          value: 'solare'
        },
        7: {
          name:  true ? 'Altro Prodotto Vaillant' : 'Altro Prodotto HSD',
          value: 'altroVaillant'
        }
      },
      groupsAccessori: {
        0: {
          name: 'Termoregolazione evoluta',
          value: 'termoregolazione'
        },
        1: {
          name: 'Altro Accessorio ' + ( true ? 'Vaillant' : 'HSD'),
          value: 'altroV'
        },
        2: {
          name: 'Valvole termostatiche',
          value: 'valvole_termostatiche'
        },
        3: {
          name: 'Altro materiale/valvolame',
          value: 'altro'
        }

      },
      groupsAccessoriDestination: {},
      confirmed: true,
      usoAbitativo: 1,
      resend_success: false,
      loadingState2: false,
      loadingState: false,
      passwordFieldType: 'password',
      moment: flowSettings_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [{
        index: 'product' + 0,
        indexCount: 'quantity' + 0,
        group: '',
        product: '',
        price: '',
        quantity: '',
        kw: '',
        error: false
      }],

      accessories: [{
        index: 'product' + 0,
        indexCount: 'quantity' + 0,
        group: '',
        product: '',
        price: '',
        quantity: '',
        kw: '',
        error: false
      }],

      quantity: '',
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: 'md',
      client_ragione_sociale: '',
      // TAB 1 CLIENT
      clientLastname: '',
      clientName: '',
      adress: '',
      civic: '',
      email: '',
      phone: '',
      mobile: '',
      provincies: [],
      province: '',
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: '',
      zip: '',
      datiCatastali: '',

      // RESIDENCE
      client_province: '',
      client_city: '',
      client_zip: '',
      client_address: '',
      client_civic: '',

      client_mobile: '',
      client_phone: '',
      client_email: '',
      //TAB2 INTERVENTO
      eventType: '',
      eventStartdate: '',
      it: locale["it"]
    }, defineProperty_default()(_ref, 'eventStartdate', ''), defineProperty_default()(_ref, 'disabledDatesStart', {
      to: '',
      from: ''
    }), defineProperty_default()(_ref, 'allProducts', {}), defineProperty_default()(_ref, 'totalAccessories', '0,00'), defineProperty_default()(_ref, 'totalProducts', '0,00'), defineProperty_default()(_ref, 'enea', ''), defineProperty_default()(_ref, 'requiredOperations', ''), defineProperty_default()(_ref, 'client_type', ''), defineProperty_default()(_ref, 'priceEnea', ''), defineProperty_default()(_ref, 'client_ownership', 'Proprietario'), defineProperty_default()(_ref, 'totalExtraMise', 0), defineProperty_default()(_ref, 'clearExtraMise', false), defineProperty_default()(_ref, 'NoEnea', false), defineProperty_default()(_ref, 'priceDcast', ''), defineProperty_default()(_ref, 'priceAT', '0,00'), defineProperty_default()(_ref, 'iva_altri_oneri', 0.22), defineProperty_default()(_ref, 'iva_accessori_lavoro', 0.10), defineProperty_default()(_ref, 'iva_age_extra', 0.22), defineProperty_default()(_ref, 'iva_age_lavoro', 0.10), defineProperty_default()(_ref, 'iva_age_accessori', 0.10), defineProperty_default()(_ref, 'age_lavoro', 0), defineProperty_default()(_ref, 'age_extra', 0), defineProperty_default()(_ref, 'bonusError', false), defineProperty_default()(_ref, 'bonusErrorText', ''), defineProperty_default()(_ref, 'dl', '0'), defineProperty_default()(_ref, 'tqsa', '10.000'), defineProperty_default()(_ref, 'edilLibera', '0'), defineProperty_default()(_ref, 'showEdilLiberaSelect', false), defineProperty_default()(_ref, 'iban_agileenergy', "IT25J0306933911100000014182"), defineProperty_default()(_ref, 'priceAgileenergy', 0), defineProperty_default()(_ref, 'agileDiscount', false), _ref;
  },

  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    Flows: components_flowSettings_flows

  },
  methods: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getNotifications', 'getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return '' + state.notifications;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f06c4c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowSettings/index.vue
var flowSettings_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull " },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _c(
          "div",
          {
            staticClass:
              "row justify-content-center text-left vaillantCont mt-5"
          },
          [
            _c(
              "div",
              { staticClass: "col-md-12 pt-5 pb-5" },
              [
                _vm._v("\n\n        Gentile Professionista,\n        "),
                _c("br"),
                _c("br"),
                _vm._v(
                  '\n        Recentemente è stato pubblicato in Gazzetta Ufficiale il Decreto Legge n. 50/2022 recante "Misure\n        urgenti in materia di politiche energetiche nazionali, produttività delle imprese e attrazione degli\n        investimenti, nonché in materia di politiche sociali e di crisi Ucraina".\n        '
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Le ultime disposizioni inserite nel testo di Legge prevedono un sostanziale cambiamento delle\n        normative sui trasferimenti dei crediti dei Bonus edilizi, una variazione che interessa direttamente le\n        imprese oltre ad istituti bancari ed enti di credito, i quali dovranno recepire ed allinearsi alle nuove\n        disposizioni.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Per tali ragioni esterne sopra menzionate purtroppo indipendenti dalla nostra volontà, ci vediamo\n        costretti a sospendere temporaneamente i servizi di cessione del credito erogati nella piattaforma\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v("  CheBonus (www.chebonus.it)  ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" HappyBonus (www.happybonus.it)  ")
                      ])
                    ],
                _vm._v(
                  "\n\n\n        sino a quando non si saranno ripristinate le condizioni per poter\n        ripartire e garantire stabilità e continuità al servizio per i nostri clienti professionisti e privati.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Il flusso relativo ad Agile Energy sarà anch’esso temporaneamente sospeso, fermo restando che le\n        Pratiche già approvate verranno regolarmente evase alle condizioni preventivamente concordate.\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Per ogni informazione, richiesta o supporto dedicato non esitare a contattarci al numero\n        tel.\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v("  02.94756.677 ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" 02.94751.001 ")
                      ])
                    ],
                _vm._v(
                  "\n        , sempre disponibili dal lunedì al venerdì negli orari 09:00-13:00 e 14:00-18:00,\n        oppure inviaci una mail a\n        "
                ),
                _vm.brand == "CHEBONUS" ? [_vm._m(0)] : [_vm._m(1)],
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        Ringraziandoti per aver scelto di installare i nostri prodotti ed in attesa di ripristino del programma\n        ufficiale di sconto in fattura e cessione del credito\n        "
                ),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v(" CheBonus, Vaillant  ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v(" HappyBonus, Hermann Saunier Duval  ")
                      ])
                    ],
                _vm._v("\n\n\n        ti augura Buon lavoro.\n        "),
                _c("br"),
                _c("br"),
                _vm._v("\n        Il tuo team\n        "),
                _vm.brand == "CHEBONUS"
                  ? [
                      _c("b", { staticClass: "green" }, [
                        _vm._v(" Vaillant CheBonus ")
                      ])
                    ]
                  : [
                      _c("b", { staticClass: "red" }, [
                        _vm._v("  Hermann Saunier Duval HappyBonus ")
                      ])
                    ],
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _vm._m(2)
              ],
              2
            )
          ]
        )
      ])
    ],
    1
  )
}
var flowSettings_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", { staticClass: "green" }, [
      _c(
        "a",
        {
          staticClass: "green",
          attrs: { href: "mailto:info@chebonus.it", target: "_blank" }
        },
        [_vm._v(" info@chebonus.it ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", { staticClass: "green" }, [
      _c(
        "a",
        {
          staticClass: "red",
          attrs: { href: "info@happybonus.it", target: "_blank" }
        },
        [_vm._v(" info@happybonus.it ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v(
        "\n          Questa comunicazione è strettamente confidenziale.\n          "
      ),
      _c("br"),
      _vm._v(
        "E’ vietata qualsiasi divulgazione, riproduzione, distribuzione o uso del contenuto.\n        "
      )
    ])
  }
]
flowSettings_render._withStripped = true
var flowSettings_esExports = { render: flowSettings_render, staticRenderFns: flowSettings_staticRenderFns }
/* harmony default export */ var components_flowSettings = (flowSettings_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f06c4c4", flowSettings_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/flowSettings/index.vue
var flowSettings_disposed = false
function flowSettings_injectStyle (ssrContext) {
  if (flowSettings_disposed) return
  __webpack_require__("aWqY")
}
var flowSettings_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flowSettings___vue_template_functional__ = false
/* styles */
var flowSettings___vue_styles__ = flowSettings_injectStyle
/* scopeId */
var flowSettings___vue_scopeId__ = "data-v-4f06c4c4"
/* moduleIdentifier (server only) */
var flowSettings___vue_module_identifier__ = null
var flowSettings_Component = flowSettings_normalizeComponent(
  flowSettings,
  components_flowSettings,
  flowSettings___vue_template_functional__,
  flowSettings___vue_styles__,
  flowSettings___vue_scopeId__,
  flowSettings___vue_module_identifier__
)
flowSettings_Component.options.__file = "src/components/flowSettings/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f06c4c4", flowSettings_Component.options)
  } else {
    hotAPI.reload("data-v-4f06c4c4", flowSettings_Component.options)
  }
  module.hot.dispose(function (data) {
    flowSettings_disposed = true
  })
})()}

/* harmony default export */ var src_components_flowSettings = (flowSettings_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/flowSettings/editDocumentCDP.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var editDocumentCDP_moment = __webpack_require__("PJh5");

var editDocumentCDP_viewer = __webpack_require__("EAZf");

/* harmony default export */ var editDocumentCDP = ({
  name: 'loadDocuments',
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      token: '',
      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      cellulare: '',
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      client_ownership: '',
      subalterno: '',
      particella: '',
      savedDocuments: {},
      foglio: ''
    }, defineProperty_default()(_ref, 'item', ''), defineProperty_default()(_ref, 'dbdoc', ''), defineProperty_default()(_ref, 'doc', ''), defineProperty_default()(_ref, 'docIndex', ''), _ref;
  },

  methods: {
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      console.log(viewer);

      console.log("ZOOOOOM");

      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show(index) {
      console.log(this);
      var el = this.$refs['viewer' + index];

      console.log(this.$refs);

      console.log(el[0]);

      //const viewerV = el.$viewer

      el[0].destroyViewer();

      el[0].createViewer();

      el[0].$viewer.show();
      //viewer.zoomTo(2)
      //	viewer.move(-1, 0);
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    },
    removeDocument: function removeDocument(docIndex, name, codice, id, index) {
      var _this = this;

      var _vue = this;

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: '<br/>Sei sicuro di voler eliminare File ' + index + ' del documento ' + name + ' ?<br/><br/>',
        showCancelButton: true,
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        console.log(result);
        if (result.value) {
          _this.loadingState = true;
          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/removeDocumentCdpAccess',
            method: 'POST',
            data: {
              docIndex: docIndex,
              code: _vue.getProfile.userToken,
              name: name,
              codice: codice,
              id: id
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            console.log(1);
            _this.loadingState = false;
            var obj = _vue.dbdoc['images'];

            for (var x in obj) {
              if (x == id) {
                delete obj[x];
                delete _vue.dbdoc['images'][x];
              }
            }

            _vue.dbdoc['countImages'] = _vue.dbdoc['countImages'] - 1;
          }).catch(function (resp) {

            _this.loadingState = false;
          });
        }
      });
    },
    uploadFile: function uploadFile(doc, name, docCode, completed) {

      console.log(this.$refs['fileInput' + doc]);
      var input = this.$refs['fileInput' + doc];

      console.log(input);

      console.log(doc);
      console.log(name);
      console.log(docCode);

      var ind = doc;
      console.log(0);
      var file = input.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.files[0].size;
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append('fattura0', input.files[0]);

        console.log(this.uploadFrontPercentage);

        formData.append('doc', doc);
        formData.append('code', this.getProfile.userToken);
        formData.append('name', name);
        formData.append('docCode', docCode);
        formData.append('completed', completed);

        console.log(1);

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadDocumentCdpAccess', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {

            var r = 0;
            r = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
            //  Object.assign(this.uploadFrontPercentage, r)

            vue_esm["a" /* default */].set(this.dbdoc, 'percent', r);

            //  this.uploadFrontPercentage[ind]['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          console.log(2);
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.document)) {
            _vue.dbdoc['percent'] = 0;

            var x = _vue.dbdoc['images'];

            x[e.data.id] = e.data.document;

            _vue.dbdoc['images'] = x;

            _vue.dbdoc['countImages'] = _vue.dbdoc['countImages'] + 1;

            //_vue.invoiceFrontBucket = e.data.fattura
          } else {
            _vue.dbdoc['percent'] = 0;
            //_vue.invoiceFront = ''
            //_vue.invoiceFrontBucket = ''

            //input.value = null
          }

          _vue.getDocuments(_vue.getProfile.userToken);
        }).catch(function () {
          _vue.dbdoc['percent'] = 0;
          //  _vue.invoiceFront = ''
          ///  _vue.invoiceFrontBucket = ''

          //input.value = null
        });
      }
    },
    getDocuments: function getDocuments(user_token) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/21005back/public/" + 'api/getDocumentsCdpAccess',
                  method: 'POST',
                  data: {
                    user_token: user_token
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  //console.log( resp.data.documents )
                  var docs = resp.data.documents;
                  _this2.dbdoc.images = {};
                  var y = 0;
                  for (var x in docs) {
                    if (docs[x].codice == _this2.docIndex) {
                      _this2.dbdoc.images[docs[x].id] = docs[x].url;
                      _this2.dbdoc.countImages = _this2.dbdoc.countImages + 1;
                      y = y + 1;
                    }
                  }

                  //console.log( this.dbdoc )
                  //console.log( this.doc )
                  //console.log( this.docIndex )
                }).catch(function (resp) {
                  //this.savedDocuments = {}
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  watch: {},
  created: function created() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  mounted: function mounted() {
    console.log(this.$route.params);

    if (this.$route.params.docIndex) {
      this.item = this.$route.params;

      this.dbdoc = this.$route.params.dbdoc;
      this.doc = this.$route.params.doc;
      this.docIndex = this.$route.params.docIndex;
    } else {
      this.$router.push('/flowSettings');
    }

    this.$scrollTo('#app', 700, { offset: -75 });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4359101c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowSettings/editDocumentCDP.vue
var editDocumentCDP_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-5 pt-4" }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-10 center mb-3" }, [
            _c("h4", { staticClass: "Regular text-left h0 widthFull ml-3" }, [
              _vm._v(" Modifica Documento: "),
              _c("b", [_vm._v(" " + _vm._s(_vm.item.docName) + " ")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black mt-0 text-left widthFull ml-3" }, [
              _vm._v(
                "\n          In questa pagina puoi eliminare i documenti caricati e aggiungerne di nuovi.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-2 pt-4 center mb-3 text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary m-2 btn-sm ml-md-5",
                  attrs: { to: { name: "flowSettings" } }
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "arrow-left", size: "1x" }
                  }),
                  _vm._v("\n          Indietro\n        ")
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "pb-5 pt-3 black widthFull vaillantCont",
            attrs: { id: "doc-form" }
          },
          [
            _c(
              "div",
              { staticClass: "row justify-content-center text-left pl-4 pr-4" },
              [
                _c("div", { staticClass: "col-md-8 center mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center text-left" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._l(_vm.dbdoc.images, function(url, key, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-6 col-md-4 center mb-5"
                          },
                          [
                            _c("p", { staticClass: "pb-1 mb-1" }, [
                              _vm._v("File " + _vm._s(index + 1) + " ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "viewer",
                              {
                                ref: "viewer" + key,
                                refInFor: true,
                                staticClass: " clearfix widthFull",
                                on: { inited: _vm.inited }
                              },
                              [
                                _c("img", {
                                  key: key,
                                  staticClass: "img-fluid editImageCont",
                                  attrs: { src: url }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-xl mt-3",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.show(key)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "eye", size: "sm" }
                                }),
                                _vm._v(" Visualizza\n              ")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-xl  mt-3",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeDocument(
                                      _vm.docIndex,
                                      _vm.doc.name,
                                      _vm.doc.codice,
                                      key,
                                      index
                                    )
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "trash-alt", size: "sm" }
                                }),
                                _vm._v(" Elimina\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4 center mb-3 even" }, [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center text-left" },
                    [
                      _c("div", { staticClass: "col-md-12 center mb-3" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "front-image" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: false,
                                  size: 10240,
                                  ext: ["jpeg", "jpg", "png", "pdf"],
                                  mimes: [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/pdf"
                                  ]
                                },
                                expression:
                                  "{required:false,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                              }
                            ],
                            ref: "fileInput" + _vm.docIndex,
                            staticClass: "fileInput",
                            class: {
                              "is-invalid": _vm.errors.has("invoiceFront"),
                              valid: !!_vm.invoiceFront,
                              helper: !!_vm.invoiceFrontBucket
                            },
                            attrs: {
                              type: "file",
                              name: "invoiceFront",
                              id: "invoiceFront",
                              "data-vv-as": "Logo"
                            },
                            on: {
                              change: function($event) {
                                return _vm.uploadFile(
                                  _vm.docIndex,
                                  _vm.doc.name,
                                  _vm.doc.codice,
                                  _vm.dbdoc.completed
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel labelFileInput",
                              attrs: { for: "invoiceFront" }
                            },
                            [
                              !_vm.invoiceFrontName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "smallText center white mt-3 mb-0 pb-0"
                                            },
                                            [
                                              _vm._v(
                                                "Scegli il Contratto quadro*"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "smallText center white",
                                    style: {
                                      backgroundImage:
                                        "url(" + _vm.invoiceFrontBucket + ")"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("invoiceFront")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.errors.first("invoiceFront")) +
                                    "\n                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dbdoc.percent
                            ? _c(
                                "div",
                                {
                                  staticClass: "progress mt-5",
                                  attrs: { id: "progFront" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar ",
                                      style: { width: _vm.dbdoc.percent + "%" },
                                      attrs: {
                                        id: "progress-bar-front",
                                        role: "progressbar",
                                        "aria-valuenow": "50",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.dbdoc.percent) +
                                          " %\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceFrontName
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                },
                                [_vm._v(_vm._s(_vm.invoiceFrontName))]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(3)
                    ]
                  )
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var editDocumentCDP_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "Regular center h0 widthFull" }, [
      _c("b", [_vm._v("Documenti per cessionari finali  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-3" }, [
      _c("h5", { staticClass: "Regular" }, [_c("b", [_vm._v("File caricati")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "Regular" }, [
      _c("b", [_vm._v("Carica nuovo File")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 center mt-5 mb-3" }, [
      _c("small", [
        _vm._v(
          "\n                Il documento può essere caricato nei formati jpeg, pdf, png, jpg (max 10MB)\n              "
        )
      ])
    ])
  }
]
editDocumentCDP_render._withStripped = true
var editDocumentCDP_esExports = { render: editDocumentCDP_render, staticRenderFns: editDocumentCDP_staticRenderFns }
/* harmony default export */ var flowSettings_editDocumentCDP = (editDocumentCDP_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4359101c", editDocumentCDP_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/flowSettings/editDocumentCDP.vue
var editDocumentCDP_disposed = false
function editDocumentCDP_injectStyle (ssrContext) {
  if (editDocumentCDP_disposed) return
  __webpack_require__("/DdD")
}
var editDocumentCDP_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editDocumentCDP___vue_template_functional__ = false
/* styles */
var editDocumentCDP___vue_styles__ = editDocumentCDP_injectStyle
/* scopeId */
var editDocumentCDP___vue_scopeId__ = "data-v-4359101c"
/* moduleIdentifier (server only) */
var editDocumentCDP___vue_module_identifier__ = null
var editDocumentCDP_Component = editDocumentCDP_normalizeComponent(
  editDocumentCDP,
  flowSettings_editDocumentCDP,
  editDocumentCDP___vue_template_functional__,
  editDocumentCDP___vue_styles__,
  editDocumentCDP___vue_scopeId__,
  editDocumentCDP___vue_module_identifier__
)
editDocumentCDP_Component.options.__file = "src/components/flowSettings/editDocumentCDP.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4359101c", editDocumentCDP_Component.options)
  } else {
    hotAPI.reload("data-v-4359101c", editDocumentCDP_Component.options)
  }
  module.hot.dispose(function (data) {
    editDocumentCDP_disposed = true
  })
})()}

/* harmony default export */ var components_flowSettings_editDocumentCDP = (editDocumentCDP_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contact/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var contact = ({
  name: 'contact',
  components: {},
  data: function data() {

    return {
      loadingState: false,
      phone: "02 9475 6677",
      email: "info@chebonus.it",
      phone_hsd: "02 9475 1001",
      email_hsd: "info@happybonus.it",
      brand: "CHEBONUS"

    };
  },

  methods: {},
  mounted: function mounted() {
    this.$scrollTo('#app', 700, {
      offset: -775
    });
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249074c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/index.vue
var contact_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mb-5" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row justify-content-center vaillantCont pt-5" },
          [
            _c(
              "div",
              { staticClass: "col-md-6 pl-5 " },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("img", {
                  staticClass: "wa_icon mr-3",
                  attrs: { src: __webpack_require__("7KbZ") }
                }),
                _vm._v(" "),
                _c("font-awesome-icon", {
                  staticClass: "green mr-3",
                  class: { redHSD: _vm.brand == "HAPPYBONUS" },
                  attrs: { icon: "headset", size: "2x" }
                }),
                _vm._v(" "),
                _c("font-awesome-icon", {
                  staticClass: "green mr-3",
                  class: { redHSD: _vm.brand == "HAPPYBONUS" },
                  attrs: { icon: "envelope", size: "2x" }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v("  al numero tel. "),
                _c("b", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.brand == "CHEBONUS" ? _vm.phone : _vm.phone_hsd
                    )
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v("oppure inviaci una mail a "),
                _c("b", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.brand == "CHEBONUS" ? _vm.email : _vm.email_hsd
                    )
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _vm._v(" disponibili "),
                _vm._m(2),
                _vm._v(" "),
                _c("br"),
                _vm._v(" esclusi i giorni festivi\r\n\r\n\r\n        ")
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(3)
          ]
        )
      ])
    ],
    1
  )
}
var contact_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center mb-3 " }, [
      _c("div", { staticClass: "col-md-12 mt-4" }, [
        _c("h2", { staticClass: " ", attrs: { type: "text" } }, [
          _vm._v(" Informazioni e contatti")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _vm._v(" Per ogni tua richiesta "),
      _c("br"),
      _vm._v(" non esitare a contattarci ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("dal lunedì al venerdì "),
      _c("br"),
      _vm._v("dalle 09:00-13:00 e 14:00-18:00")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 " }, [
      _c("div", {}),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid widthFull",
        attrs: { src: __webpack_require__("e0x8") }
      })
    ])
  }
]
contact_render._withStripped = true
var contact_esExports = { render: contact_render, staticRenderFns: contact_staticRenderFns }
/* harmony default export */ var components_contact = (contact_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-249074c3", contact_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/contact/index.vue
var contact_disposed = false
function contact_injectStyle (ssrContext) {
  if (contact_disposed) return
  __webpack_require__("dzjw")
}
var contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var contact___vue_template_functional__ = false
/* styles */
var contact___vue_styles__ = contact_injectStyle
/* scopeId */
var contact___vue_scopeId__ = "data-v-249074c3"
/* moduleIdentifier (server only) */
var contact___vue_module_identifier__ = null
var contact_Component = contact_normalizeComponent(
  contact,
  components_contact,
  contact___vue_template_functional__,
  contact___vue_styles__,
  contact___vue_scopeId__,
  contact___vue_module_identifier__
)
contact_Component.options.__file = "src/components/contact/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-249074c3", contact_Component.options)
  } else {
    hotAPI.reload("data-v-249074c3", contact_Component.options)
  }
  module.hot.dispose(function (data) {
    contact_disposed = true
  })
})()}

/* harmony default export */ var src_components_contact = (contact_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cessioni/practicesToDo.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var practicesToDo_moment = __webpack_require__("PJh5");

/* harmony default export */ var practicesToDo = ({
  name: 'DisposalAvailable',
  components: {},
  props: {},
  data: function data() {
    return {
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      loadingState: false,
      flow: 'cdp',
      practices: {},
      loaded: false,
      countPractices: 0,
      moment: __webpack_require__("PJh5"),
      countValues: 0,
      countPracticesNextMonth: 0,
      countValuesNextMonth: 0,
      arrayPracticesAvailable: [],
      arrayPracticesNextMonth: [],
      min_disposal_price_cdp: 75000,
      min_disposal_price_poste: 2000,
      disposalArray: {},
      allChecked: false,
      totalDisposal: 0,
      totalDisposalNextMonth: 0,

      flow_cdp_active: false,
      cdp_not_active_text: "Al momento il flusso CDP è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di CDP.",
      flow_poste_active: false,
      poste_not_active_text: "Al momento il flusso Poste Italiane è disabilitato. <br/> Ti aggiorneremo non appena riceveremo maggiori informazioni sulla operativita di Poste Italiane."

    };
  },

  methods: {
    addDisposal: function addDisposal() {
      if (this.totalDisposal >= this.min_disposal_price_cdp && practicesToDo_moment().date() >= 11) {
        console.log('Send Disposal');
        var _vue = this;
        _vue.loadingState = true;

        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/addDisposals',
          method: 'POST',
          data: {
            practices: _vue.disposalArray,
            user_token: _vue.getProfile.userToken,
            user: _vue.getProfile,
            flow: this.flow,
            finalAmount: _vue.totalDisposal
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _vue.loadingState = false;

          if (_vue.flow == 'cdp') {
            var text = 'Nei prossimi giorni riceverai via e-mail il contratto di cessione da sottoscrivere con le relative istruzioni .';
          } else {
            var text = 'Accedi alla tua area riservata del tuo conto BancoPosta Affari e sottoscrivi il cotratto di cessione del credito in funzione del codice tributo';
          }

          _vue.$swal({
            type: 'success',
            title: '<strong class="modalText danger white">Richiesta di cessione avviata</strong>',
            html: text,
            confirmButtonText: 'CHIUDI',
            confirmButton: 'closeProductsModal',
            confirmButtonColor: '#15267',
            onClose: function onClose() {
              window.location.reload();
            }
          });
        }).catch(function (resp) {
          console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor');
          _vue.addClientError('Riprova più tardi');
          _vue.loadingState = false;
        });
      } else {
        console.log('Min Value');
      }
    },
    addAllItemToDisposal: function addAllItemToDisposal() {
      var _vue = this;
      _vue.loaded = false;
      if (_vue.allChecked == false) {
        _vue.disposalArray = {};
        setTimeout(function () {
          for (var x in _vue.arrayPracticesAvailable) {
            _vue.disposalArray[_vue.arrayPracticesAvailable[x].id] = _vue.arrayPracticesAvailable[x];
          }
          _vue.allChecked = true;
          _vue.loaded = true;
          console.warn(_vue.disposalArray);
          _vue.calcTotalDisposalValue();
        }, 2);
      } else {
        setTimeout(function () {
          for (var x in _vue.arrayPracticesAvailable) {
            delete _vue.disposalArray[_vue.arrayPracticesAvailable[x].id];
          }
          _vue.allChecked = false;
          _vue.loaded = true;
          console.warn(_vue.disposalArray);
          _vue.calcTotalDisposalValue();
        }, 2);
      }
    },
    calcTotalDisposalValue: function calcTotalDisposalValue() {
      console.warn('Init calc');
      var _vue = this;
      _vue.totalDisposal = 0;

      for (var x in _vue.disposalArray) {
        var p = _vue.disposalArray[x].finalAmmount;
        p = parseFloat(p.replace(',', '.'));
        _vue.totalDisposal = _vue.totalDisposal + p;
        console.log(p);
      }
      _vue.totalDisposal = _vue.totalDisposal.toFixed(2);
    },
    selectItemForDisposal: function selectItemForDisposal(item, e) {
      console.log(item);
      console.log(e.target.checked);

      if (e.target.checked) {
        this.disposalArray[item.id] = item;
      } else {
        this.allChecked = false;
        delete this.disposalArray[item.id];
      }

      console.warn(this.disposalArray);
      this.calcTotalDisposalValue();
    },
    addClientError: function addClientError(text) {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger white">Operazione non andata a buon fine.</strong>',
        html: text,
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },
    checkIfExistUser: function checkIfExistUser() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data, _vue;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.getProfile) {
                  _this.loaded = false;
                  data = _this.getProfile;
                  _vue = _this;

                  _vue.loadingState = true;
                  axios_default()({
                    url: "https://wsbot.eu/21005back/public/" + 'api/getPracticesWithAvailableDisposals',
                    method: 'POST',
                    data: {
                      type: 'available',
                      user_token: data.userToken,
                      flow: _this.flow
                    },
                    headers: {
                      'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                      'Content-type': 'application/json'
                    }
                  }).then(function (resp) {
                    _vue.practices = resp.data.practices;
                    console.log('COUNT ***********************************************');
                    console.log(_vue.practices);
                    _vue.countPractices = _vue.practices.length;
                    var count = 0;
                    var countNextmonth = 0;

                    _vue.countValues = 0, _vue.countPracticesNextMonth = 0, _vue.countValuesNextMonth = 0, _vue.arrayPracticesAvailable = [], _vue.arrayPracticesNextMonth = [], _vue.disposalArray = [], _vue.allChecked = false, _vue.totalDisposal = 0;
                    _vue.totalDisposalNextMonth = 0;

                    console.log(' DAY OF MONTH => ' + practicesToDo_moment().date());

                    for (var x in _vue.practices) {
                      var adeDate = _vue.practices[x].ade_protocol_number;
                      adeDate = adeDate.substring(0, 6);
                      adeDate = practicesToDo_moment(adeDate, "YYMMDD");
                      var monthNow = parseInt(practicesToDo_moment().format('MM'));
                      var monthOfAde = parseInt(adeDate.format('MM'));

                      if (monthNow == monthOfAde) {
                        // credits available in next month
                        var p = _vue.practices[x].finalAmmount;
                        p = parseFloat(p.replace(',', '.'));
                        countNextmonth = countNextmonth + p;
                        _vue.countPracticesNextMonth = _vue.countPracticesNextMonth + 1;
                        _vue.arrayPracticesNextMonth.push(_vue.practices[x]);
                      } else {

                        // credits available yet
                        _vue.arrayPracticesAvailable.push(_vue.practices[x]);
                        var p = _vue.practices[x].finalAmmount;
                        p = parseFloat(p.replace(',', '.'));
                        count = count + p;
                      }
                    }

                    console.warn(' AVAILABLE NOW ');
                    console.warn(_vue.arrayPracticesAvailable);
                    console.warn(' AVAILABLE NEXT MONTH ');
                    console.warn(_vue.arrayPracticesNextMonth);
                    // next Month count
                    _vue.countValuesNextMonth = countNextmonth.toFixed(2);

                    // Available in this month count
                    _vue.countValues = count.toFixed(2);
                    _vue.addAllItemToDisposal();
                    _vue.loaded = true;
                    _vue.loadingState = false;
                  }).catch(function (resp) {
                    console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor');
                    _vue.loadingState = false;
                  });
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  watch: {
    iban: function iban(value) {
      this.iban = value.toUpperCase().trim();
      this.iban = this.iban.replace(' ', '');
    },
    flow: function flow(val) {
      this.checkIfExistUser();

      if (val == 'cdp') {
        this.min_disposal_price_cdp = 75000;
      } else {
        this.min_disposal_price_cdp = 2000;
      }
    },
    getProfile: function getProfile() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.checkIfExistUser();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {

    console.log('Section 1 LOADED');
  },
  mounted: function mounted() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.checkIfExistUser();

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-866a5c7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cessioni/practicesToDo.vue
var practicesToDo_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-0 pb-3 mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center text-left pt-2" }, [
        _c(
          "div",
          {
            staticClass: "col-md-6 center mb-3 text-center pointer selectBlock",
            class: { blockActive: _vm.flow == "cdp" },
            on: {
              click: function($event) {
                _vm.flow = "cdp"
              }
            }
          },
          [
            _c(
              "h1",
              { staticClass: "mt-4", class: { grey: _vm.flow == "poste" } },
              [_c("b", [_vm._v(" CDP ")])]
            ),
            _vm._v(" "),
            _c("h4", { class: { grey: _vm.flow == "poste" } }, [
              _vm._v("Cassa Depositi e Prestiti")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-md-6 center mb-3 text-center pointer selectBlock",
            class: { blockActive: _vm.flow == "poste" },
            on: {
              click: function($event) {
                _vm.flow = "poste"
              }
            }
          },
          [
            _c(
              "h1",
              { staticClass: "mt-4", class: { grey: _vm.flow == "cdp" } },
              [_c("b", [_vm._v(" Poste Italiane ")])]
            ),
            _vm._v(" "),
            _c("h4", { class: { grey: _vm.flow == "cdp" } }, [
              _vm._v(" BancoPosta Affari")
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12 center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "p",
            { class: { red: _vm.totalDisposal < _vm.min_disposal_price_cdp } },
            [
              _vm._v(" Importo minimo di Cessione "),
              _c("b", [
                _vm._v(
                  "€ " +
                    _vm._s(_vm._f("formatNumber")(_vm.min_disposal_price_cdp)) +
                    " "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "black" }, [
                _vm._v(
                  "( Solo dopo aver raggiunto questo importo, anche cumulando più Pratiche, potrai cedere il credito )"
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 pr-md-5 pl-md-5 pt-4" }, [
          _c(
            "div",
            { staticClass: "buttonTextCont widthfull lightGreen mt-5" },
            [
              _c("h1", { staticClass: "widthFull mt-0 center pb-0 mb-0" }, [
                _c("b", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.countPractices - _vm.countPracticesNextMonth)
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-primary btn-green btnRed btn-sm  uppercase widthFull",
              on: {
                click: function($event) {
                  _vm.filter = ""
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "d-none d-md-inline white" },
                [
                  _vm._v(" Pratiche con credito cedibile a "),
                  _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttonTextCont widthfull lightGreen mt-5" },
            [
              _c("h1", { staticClass: "widthFull mt-0 center pb-0 mb-0" }, [
                _c(
                  "b",
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: "euro-sign", size: "sm" }
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatNumber")(_vm.countValues)) +
                        "\n          "
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-primary btn-green btnRed btn-sm  uppercase widthFull",
              on: {
                click: function($event) {
                  _vm.filter = ""
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "d-none d-md-inline white" },
                [
                  _vm._v(" Importo totale del credito cedibile a "),
                  _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "widthFull center" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "scroll-to",
                    rawName: "v-scroll-to",
                    value: { el: "#nextMonth", offset: -145 },
                    expression: "{ el: '#nextMonth', offset: -145 }"
                  }
                ],
                staticClass: "btn btn-primary btnBlue btn-sm mt-5",
                attrs: { type: "button" }
              },
              [_vm._v(" Pratiche con credito cedibile dal mese successivo ")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("p", { staticClass: "center mt-0 mb-0" }, [
            _vm._v(
              "Seleziona le Pratiche per le quali vuoi avviare la cessione del credito "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selectListBox" },
            [
              _vm.arrayPracticesAvailable.length
                ? _vm._l(_vm.arrayPracticesAvailable, function(item, index) {
                    return _c("h5", { staticClass: "pb-0 pt-0 mt-0" }, [
                      _c("div", { staticClass: "form-check pb-0 mb-0" }, [
                        _c("input", {
                          staticClass: "form-check-input pb-0 mb-0",
                          attrs: {
                            disabled: _vm.moment().date() < 11,
                            type: "checkbox",
                            value: "",
                            id: "box_" + index
                          },
                          domProps: {
                            checked:
                              _vm.disposalArray[item.id] &&
                              _vm.moment().date() >= 11
                                ? true
                                : false
                          },
                          on: {
                            change: function($event) {
                              return _vm.selectItemForDisposal(item, $event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "form-check-label custLabelFontSize pointer pb-0 mb-0",
                            attrs: { for: "box_" + index }
                          },
                          [
                            _vm._v("\n              Pratica N. "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(item.code))
                            ]),
                            _vm._v(
                              "\n              del " +
                                _vm._s(
                                  _vm
                                    .moment(item.created_at)
                                    .format("DD-MM-YYYY")
                                ) +
                                "\n              di "
                            ),
                            _c("b", [
                              _vm._v(
                                " " +
                                  _vm._s(item.client_lastname) +
                                  "  " +
                                  _vm._s(item.client_name) +
                                  " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-1" }, [
                              _c("b", [_vm._v(_vm._s(item.bonus))]),
                              _vm._v(" Importo di Cessione : "),
                              _c("b", [
                                _vm._v(
                                  "€ " +
                                    _vm._s(
                                      _vm._f("formatNumber")(item.finalAmmount)
                                    )
                                )
                              ])
                            ])
                          ]
                        )
                      ])
                    ])
                  })
                : [
                    _c("h5", { staticClass: "pb-0 pt-0 mt-0" }, [
                      _c("div", { staticClass: "form-check pb-0 mb-0" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "form-check-label custLabelFontSize pointer pb-0 mb-0",
                            attrs: { for: "box_1231231231" }
                          },
                          [
                            _vm._v(
                              "\n              No ci sono pratiche disponibili per cessione\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row pt-4 pb-4" }, [
            _c(
              "div",
              { staticClass: "col-md-12 center pb-4" },
              [
                _vm._v("\n          Importo totale del credito cedibile a "),
                _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                _vm._v(" "),
                _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e(),
                _vm._v(" delle Pratiche selezionate: "),
                _c(
                  "b",
                  {
                    class: {
                      red: _vm.totalDisposal < _vm.min_disposal_price_cdp
                    }
                  },
                  [
                    _vm._v(
                      " € " +
                        _vm._s(_vm._f("formatNumber")(_vm.totalDisposal)) +
                        " "
                    )
                  ]
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btnBlue btn-sm",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.addAllItemToDisposal()
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.allChecked ? "Deseleziona tutte" : "Seleziona tutte"
                      ) +
                      " "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 center" },
              [
                (_vm.flow == "cdp" && _vm.flow_cdp_active) ||
                (_vm.flow == "poste" && _vm.flow_poste_active)
                  ? [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-sm btn-green btnRed",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.totalDisposal < _vm.min_disposal_price_cdp ||
                              _vm.moment().date() < 11
                          },
                          on: {
                            click: function($event) {
                              return _vm.addDisposal()
                            }
                          }
                        },
                        [_vm._v(" Avvia Cessione ")]
                      )
                    ]
                  : [
                      _vm.flow == "poste"
                        ? _c("a", {
                            staticClass:
                              "btn btn-primary btnYellow btn-sm white small",
                            attrs: { disabled: "" },
                            domProps: {
                              innerHTML: _vm._s(_vm.poste_not_active_text)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.flow == "cdp"
                        ? _c("a", {
                            staticClass:
                              "btn btn-primary btnYellow btn-sm white small",
                            attrs: { disabled: "" },
                            domProps: {
                              innerHTML: _vm._s(_vm.cdp_not_active_text)
                            }
                          })
                        : _vm._e()
                    ]
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center divider" }),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 pr-md-5 pl-md-5 pt-4" }, [
          _c(
            "div",
            { staticClass: "buttonTextCont widthfull lightYellow mt-5" },
            [
              _c("h1", { staticClass: "widthFull mt-0 center pb-0 mb-0" }, [
                _c("b", [_vm._v(" " + _vm._s(_vm.countPracticesNextMonth))])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-primary btnRed  btn-sm  uppercase widthFull",
              on: {
                click: function($event) {
                  _vm.filter = ""
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "d-none d-md-inline white" },
                [
                  _vm._v(" Pratiche con credito cedibile a "),
                  _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e(),
                  _vm._v(" dal mese successivo ")
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttonTextCont widthfull lightYellow mt-5" },
            [
              _c("h1", { staticClass: "widthFull mt-0 center pb-0 mb-0" }, [
                _c(
                  "b",
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: "euro-sign", size: "sm" }
                    }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("formatNumber")(_vm.countValuesNextMonth)
                        ) +
                        "\n          "
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "btn btn-primary  btn-sm btnRed  uppercase widthFull",
              on: {
                click: function($event) {
                  _vm.filter = ""
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "d-none d-md-inline white" },
                [
                  _vm._v("Importo totale del credito cedibile a "),
                  _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e(),
                  _vm._v(" dal mese successivo ")
                ],
                2
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("h5", { staticClass: "mt-1 pt-4 center mb-3" }, [
            _vm._v("Elenco Pratiche con credito cedibile dal mese successivo")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selectListBox lightYellow" },
            [
              _vm.arrayPracticesNextMonth.length
                ? _vm._l(_vm.arrayPracticesNextMonth, function(item, index) {
                    return _c("h5", { staticClass: "pb-0 pt-0 mt-0" }, [
                      _c("div", { staticClass: "form-check pb-0 mb-0" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "form-check-label custLabelFontSize pointer pb-0 mb-0",
                            attrs: { for: "box_2" + index }
                          },
                          [
                            _vm._v("\n              Pratica N. "),
                            _c("b", { staticClass: "underline" }, [
                              _vm._v(_vm._s(item.code))
                            ]),
                            _vm._v(
                              "\n              del " +
                                _vm._s(
                                  _vm
                                    .moment(item.created_at)
                                    .format("DD-MM-YYYY")
                                ) +
                                "\n              di "
                            ),
                            _c("b", [
                              _vm._v(
                                " " +
                                  _vm._s(item.client_lastname) +
                                  " " +
                                  _vm._s(item.client_name) +
                                  "  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-1" }, [
                              _c("b", [_vm._v(_vm._s(item.bonus))]),
                              _vm._v(" Importo di Cessione: "),
                              _c("b", [
                                _vm._v(
                                  "€ " +
                                    _vm._s(
                                      _vm._f("formatNumber")(item.finalAmmount)
                                    )
                                )
                              ])
                            ])
                          ]
                        )
                      ])
                    ])
                  })
                : [
                    _c("h5", { staticClass: "pb-0 pt-0 mt-0" }, [
                      _c("div", { staticClass: "form-check pb-0 mb-0" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "form-check-label custLabelFontSize pointer pb-0 mb-0",
                            attrs: { for: "box_1231231231" }
                          },
                          [
                            _vm._v(
                              "\n              No ci sono pratiche disponibili per cessione dal mese successivo\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12 center mt-3 pb-4" },
            [
              _vm._v("\n          Importo totale del credito cedibile a "),
              _vm.flow == "cdp" ? [_vm._v(" CDP ")] : _vm._e(),
              _vm._v(" "),
              _vm.flow == "poste" ? [_vm._v(" Poste Italiane ")] : _vm._e(),
              _vm._v(" dal mese successivo: "),
              _c(
                "b",
                {
                  class: { red: _vm.totalDisposal < _vm.min_disposal_price_cdp }
                },
                [
                  _vm._v(
                    " € " +
                      _vm._s(_vm._f("formatNumber")(_vm.countValuesNextMonth)) +
                      " "
                  )
                ]
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.editUser()
            }
          }
        },
        [_c("div", { staticClass: "row justify-content-center pt-4" })]
      )
    ],
    1
  )
}
var practicesToDo_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _c("b", [_vm._v("Riepilogo Pratiche disponibili per la Cessione (*)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "mt-1 pt-0 center mb-3" }, [
      _vm._v("Elenco Pratiche con credito cedibile "),
      _c("b", [_vm._v("dal giorno 11 del mese corrente")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-11 pb-3 " }, [
      _c("b", [_vm._v("* NOTA")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        " Nel caso di Ditte Individuali o in assenza di delega all'intermediario abilitato per le Società di capitali o di persone, le stesse dovranno provedere autonamente ad accettare nel proprio cassetto fiscale\n       i crediti ceduti dai loro clienti ( utenti finali ) per poter procedere alla cessione del credito.\n    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-12 center mt-4 ", attrs: { id: "nextMonth" } },
      [
        _c("h4", [
          _c("b", [
            _vm._v("Pratiche con credito cedibile dal mese successivo ")
          ])
        ])
      ]
    )
  }
]
practicesToDo_render._withStripped = true
var practicesToDo_esExports = { render: practicesToDo_render, staticRenderFns: practicesToDo_staticRenderFns }
/* harmony default export */ var cessioni_practicesToDo = (practicesToDo_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-866a5c7c", practicesToDo_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/cessioni/practicesToDo.vue
var practicesToDo_disposed = false
function practicesToDo_injectStyle (ssrContext) {
  if (practicesToDo_disposed) return
  __webpack_require__("cley")
}
var practicesToDo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var practicesToDo___vue_template_functional__ = false
/* styles */
var practicesToDo___vue_styles__ = practicesToDo_injectStyle
/* scopeId */
var practicesToDo___vue_scopeId__ = "data-v-866a5c7c"
/* moduleIdentifier (server only) */
var practicesToDo___vue_module_identifier__ = null
var practicesToDo_Component = practicesToDo_normalizeComponent(
  practicesToDo,
  cessioni_practicesToDo,
  practicesToDo___vue_template_functional__,
  practicesToDo___vue_styles__,
  practicesToDo___vue_scopeId__,
  practicesToDo___vue_module_identifier__
)
practicesToDo_Component.options.__file = "src/components/cessioni/practicesToDo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-866a5c7c", practicesToDo_Component.options)
  } else {
    hotAPI.reload("data-v-866a5c7c", practicesToDo_Component.options)
  }
  module.hot.dispose(function (data) {
    practicesToDo_disposed = true
  })
})()}

/* harmony default export */ var components_cessioni_practicesToDo = (practicesToDo_Component.exports);

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var index_es = __webpack_require__("C/JF");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cessioni/practicesinWork.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var practicesinWork = ({
  name: 'DisposalAvailable',
  components: {},
  props: {},
  data: function data() {
    return {
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      loadingState: false,
      flow: 'cdp',
      disposals: {},
      practices: {},
      loaded: false,
      countPractices: 0,
      moment: __webpack_require__("PJh5"),
      countValues: 0,

      min_disposal_price_cdp: 75000,
      min_disposal_price_poste: 2000,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      totalDisposal: 0,

      countEcobonus: 0,
      countBonusCasa: 0,

      input: ''

    };
  },

  methods: {
    confirmLoadContract: function confirmLoadContract(val, disposal) {
      var _vue = this;

      if (_vue.invoiceFrontBucket) {
        _vue.loadingState = true;

        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/confirmLoadContractPoste',
          method: 'POST',
          data: {
            contract: _vue.invoiceFrontBucket,
            userToken: _vue.getProfile.userToken,
            disposal_id: val,
            user: _vue.getProfile,
            disposal: disposal
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          console.log(resp);
          _vue.getDisposals();
          _vue.loadingState = false;
          var text = "";
          if (_vue.getProfile.delegate_move_credits == 1 || _vue.getProfile.delegate_move_credits == '1') {
            text = 'Abbiamo inviato la richiesta ad Advisor per spostare il tuo credito a Poste Italiane. Riceverai una conferma via e-mail una volta conclusa positivamente l`operazione. ';
          } else {
            text = 'Per procedere con la Cessione del credito devi spostare il credito dal tuo cassetto fiscale al cessionario finale in base ai codici tributo presenti nella pratica di cessione. ';
          }

          _vue.$swal({
            type: 'success',
            title: 'Contratto caricato con successo!',
            text: text
          });
        }).catch(function (resp) {
          _vue.loadingState = false;
          _vue.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Riprova piu tardi!'
          });
        });
      } else {
        _vue.$swal({
          type: 'error',
          title: 'Carica Contratto'
        });
      }
    },
    confirmLoadScreenshot: function confirmLoadScreenshot(val) {
      var _vue = this;

      if (_vue.invoiceFrontBucket) {
        _vue.loadingState = true;

        axios_default()({
          url: "https://wsbot.eu/21005back/public/" + 'api/confirmLoadScreenshotOfMoveCredits',
          method: 'POST',
          data: {
            screenshot: _vue.invoiceFrontBucket,
            userToken: _vue.getProfile.userToken,
            disposal_id: val,
            user: _vue.getProfile,
            flow: _vue.flow
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          console.log(resp);
          _vue.getDisposals();
          _vue.loadingState = false;

          if (_vue.flow == 'poste') {
            _vue.$swal({
              type: 'success',
              title: 'La Cessione del credito avvenuta con successo',
              text: 'Per maggiori info entra nella sezione Cessioni - Cessioni completate'
            });
          }
        }).catch(function (resp) {
          _vue.loadingState = false;
          _vue.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Riprova piu tardi!'
          });
        });
      } else {
        _vue.$swal({
          type: 'error',
          title: 'Carica Screenshot'
        });
      }
    },
    getDisposals: function getDisposals() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data, _vue;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.getProfile) {
                  _this.loaded = false;
                  data = _this.getProfile;
                  _vue = _this;

                  _vue.loadingState = true;
                  axios_default()({
                    url: "https://wsbot.eu/21005back/public/" + 'api/getDisposals',
                    method: 'POST',
                    data: {
                      type: 'inwork',
                      user_token: data.userToken,
                      flow: _this.flow
                    },
                    headers: {
                      'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                      'Content-type': 'application/json'
                    }
                  }).then(function (resp) {
                    var disposals = resp.data.disposals;
                    _vue.practices = resp.data.practices;
                    _vue.totalDisposal = 0;

                    for (var x in disposals) {

                      // COUNT TOTAL VALUE
                      var p = disposals[x].totalDisposalAmount;
                      p = parseFloat(p.replace(',', '.'));
                      _vue.totalDisposal = _vue.totalDisposal + p;

                      // COUNT VALUES FOR SINGLE DISPOSAL DIVIDED BY TRIBUTE CODE
                      var countEcobonus = 0;
                      var countBonusCasa = 0;
                      var practices = disposals[x].practices.split(",");
                      for (var z in practices) {

                        if (_vue.practices[practices[z]].bonus == 'Bonus Casa 50%') {

                          countBonusCasa = countBonusCasa + parseFloat(_vue.practices[practices[z]].finalAmmount);
                        } else {

                          countEcobonus = countEcobonus + parseFloat(_vue.practices[practices[z]].finalAmmount);
                        }
                      }

                      countBonusCasa = countBonusCasa.toFixed(2);
                      countEcobonus = countEcobonus.toFixed(2);

                      disposals[x]['countBonusCasa'] = countBonusCasa;
                      disposals[x]['countEcobonus'] = countEcobonus;
                    }

                    _vue.totalDisposal = _vue.totalDisposal.toFixed(2);

                    _vue.disposals = disposals;

                    _vue.loaded = true;
                    _vue.loadingState = false;

                    _vue.uploadFrontPercentage = 0;
                    _vue.invoiceFront = '';
                    _vue.invoiceFrontBucket = '';
                    _vue.input.target.value = null;
                  }).catch(function (resp) {

                    _vue.loadingState = false;
                  });
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    uploadFile: function uploadFile(input) {
      this.input = input;
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        var t = 0;
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1;
        }

        this.loadingState = true;

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.loadingState = false;
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = '';
            _vue.invoiceFrontBucket = '';
            _vue.UploadError();
            input.target.value = null;
            _vue.loadingState = false;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = '';
          _vue.invoiceFrontBucket = '';
          _vue.UploadError();
          input.target.value = null;
          _vue.loadingState = false;
        });
      }
    }

  },
  watch: {
    iban: function iban(value) {
      this.iban = value.toUpperCase().trim();
      this.iban = this.iban.replace(' ', '');
    },
    flow: function flow(val) {
      this.getDisposals();

      if (val == 'cdp') {
        this.min_disposal_price_cdp = 75000;
      } else {
        this.min_disposal_price_cdp = 2000;
      }
    },
    getProfile: function getProfile() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getDisposals();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {

    console.log('Section 1 LOADED');
  },
  mounted: function mounted() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getDisposals();

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54242612","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cessioni/practicesinWork.vue
var practicesinWork_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-0 pb-3 mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "csHeight2" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center text-left pt-2 " },
          [
            _c(
              "div",
              {
                staticClass:
                  "col-md-6 center mb-3 text-center pointer selectBlock",
                class: { blockActive: _vm.flow == "cdp" },
                on: {
                  click: function($event) {
                    _vm.flow = "cdp"
                  }
                }
              },
              [
                _c(
                  "h1",
                  { staticClass: "mt-4", class: { grey: _vm.flow == "poste" } },
                  [_c("b", [_vm._v(" CDP ")])]
                ),
                _vm._v(" "),
                _c("h4", { class: { grey: _vm.flow == "poste" } }, [
                  _vm._v("Cassa Depositi e Prestiti")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-6 center mb-3 text-center pointer selectBlock",
                class: { blockActive: _vm.flow == "poste" },
                on: {
                  click: function($event) {
                    _vm.flow = "poste"
                  }
                }
              },
              [
                _c(
                  "h1",
                  { staticClass: "mt-4", class: { grey: _vm.flow == "cdp" } },
                  [_c("b", [_vm._v(" Poste Italiane ")])]
                ),
                _vm._v(" "),
                _c("h4", { class: { grey: _vm.flow == "cdp" } }, [
                  _vm._v(" BancoPosta Affari")
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.disposals, function(item, index, k) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "widthFull row pt-2 mb-5",
                    class: {
                      "pt-0": k == 0,
                      even33: String(index / 2).includes(".")
                    }
                  },
                  [
                    _c("div", { staticClass: "col-md-1 " }, [
                      _c("b", [_vm._v(_vm._s(item.id))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 " }, [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.moment(item.created_at).format("DD-MM-YYYY")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5 " },
                      [
                        item.state == 0
                          ? [
                              _vm._v(
                                "\n              Creazione contratto di cessione a "
                              ),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 1
                          ? [
                              _vm._v(
                                "\n              Spostamento del credito dal cassetto fiscale dell'installatore a "
                              ),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 2
                          ? [
                              _vm._v("\n              Verifica "),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")],
                              _vm._v(" in corso\n            ")
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 3
                          ? [
                              _vm._v(
                                "\n              Cessione completata. Attendi il bonifico bancario di "
                              ),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")],
                              _vm._v(" sul tuo conto corrente\n              "),
                              _vm.flow == "cdp"
                                ? [
                                    _vm._v(
                                      " indicato nel set Documenti per Eleggibilità CDP "
                                    )
                                  ]
                                : [_vm._v(" IBAN BancoPosta Affari ")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 5
                          ? [_vm._v("\n              Errore\n            ")]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-1 " },
                      [
                        item.contract
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "check", size: "1x" }
                            })
                          : item.state == 0
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "", size: "1x" }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-1 " },
                      [
                        item.screenshot
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "check", size: "1x" }
                            })
                          : item.state == 1
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "", size: "1x" }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 text-right" }, [
                      _c("b", [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm._f("formatNumber")(item.totalDisposalAmount)
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    item.state == 1 &&
                    (_vm.getProfile.delegate_move_credits == 2 ||
                      _vm.getProfile.delegate_move_credits == "2")
                      ? _c(
                          "div",
                          { staticClass: "col-md-12 borderTop mt-2 pt-3 pb-3" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-5 pl-md-5" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull  black" },
                                  [
                                    _vm._v(
                                      "\n                  Per procedere con la Cessione a "
                                    ),
                                    _vm.flow == "cdp"
                                      ? [_vm._v(" CDP ")]
                                      : [_vm._v(" Poste Italiane ")],
                                    _vm._v(":\n                ")
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("b", [_vm._v("1)")]),
                                    _vm._v(
                                      "  Effettua lo spostamento del credito dal tuo cassetto fiscale a quello "
                                    ),
                                    _vm.flow == "cdp"
                                      ? [_vm._v(" CDP ")]
                                      : [_vm._v(" Poste Italiane ")],
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "ml-4" },
                                      [
                                        _vm._v(" - codice fiscale di "),
                                        _vm.flow == "cdp"
                                          ? [_vm._v(" CDP")]
                                          : [_vm._v(" Poste Italiane")],
                                        _vm._v(": "),
                                        _c("b", [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.cessionaryCode) +
                                              " "
                                          )
                                        ])
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-4" }, [
                                      _vm._v(
                                        " Totale importo di Cessione per codice tributo:\n                      "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-4" }, [
                                        _vm._v(" - Ecobonus Ordinario "),
                                        _c("b", [
                                          _vm._v(
                                            " ( Codice Tributo 6922 ): €  " +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  item.countEcobonus
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-4" }, [
                                        _vm._v(" - Ristrutturazione "),
                                        _c("b", [
                                          _vm._v(
                                            " ( Codice Tributo 6926 ): €  " +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  item.countBonusCasa
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ])
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm._m(2, true),
                                _vm._v(" "),
                                _vm._m(3, true)
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\n                  Carica la fotografia (screenshot)\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "center" },
                                  [
                                    _vm._v(
                                      "che conferma la movimentazione del credito a "
                                    ),
                                    _vm.flow == "cdp"
                                      ? [_vm._v(" CDP ")]
                                      : [_vm._v(" Poste Italiane ")]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "front-image" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          size: 10240,
                                          ext: ["jpeg", "jpg", "png", "pdf"],
                                          mimes: [
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                            "application/pdf"
                                          ]
                                        },
                                        expression:
                                          "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                      }
                                    ],
                                    ref: "fileInput",
                                    refInFor: true,
                                    staticClass: "fileInput",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "invoiceFront"
                                      ),
                                      valid: !!_vm.invoiceFront,
                                      helper: !!_vm.invoiceFrontBucket
                                    },
                                    attrs: {
                                      type: "file",
                                      multiple: "",
                                      name: "invoiceFront",
                                      id: "invoiceFront",
                                      "data-vv-as": "screenshot"
                                    },
                                    on: { change: _vm.uploadFile }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoiceFront" }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "smallText center white",
                                              style: {
                                                backgroundImage:
                                                  "url(" +
                                                  _vm.invoiceFrontBucket +
                                                  ")"
                                              }
                                            },
                                            [
                                              !_vm.invoiceFrontName
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "smallText center white mt-3 mb-0 pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli il Contratto quadro*"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "smallText center white",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                _vm.invoiceFrontBucket +
                                                ")"
                                            }
                                          })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoiceFront")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { top: "185px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.errors.first("invoiceFront")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress mt-5",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar ",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                        },
                                        [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 mt-5 mb-3 center" },
                                [
                                  _vm.invoiceFrontBucket
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.invoiceFrontBucket,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm.invoiceFrontBucket.substring(
                                            _vm.invoiceFrontBucket.lastIndexOf(
                                              "."
                                            ) + 1,
                                            _vm.invoiceFrontBucket.length
                                          ) == "pdf"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "center widthFull pdfLink",
                                                  attrs: {
                                                    href:
                                                      _vm.invoiceFrontBucket,
                                                    target: "_blank"
                                                  }
                                                },
                                                [_vm._v("APRI PDF")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 center pt-1" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btnRed",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmLoadScreenshot(
                                            item.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Procedi")]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    item.state == 0 && _vm.flow == "poste"
                      ? _c(
                          "div",
                          { staticClass: "col-md-12 borderTop mt-2 pt-3 pb-3" },
                          [
                            item.final_responce_message
                              ? _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 pl-md-5" },
                                    [
                                      _c("h5", {
                                        staticClass: "red center",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            item.final_responce_message
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-5 pl-md-5" }, [
                                _c("h4", { staticClass: "widthFull  black" }, [
                                  _vm._v(
                                    "\n                  Per procedere con la Cessione a Poste Italiane:\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _c("b", [_vm._v("1)")]),
                                  _vm._v(
                                    "  Accedi all'area riservata del tuo conto BancoPosta Business e sottoscrivi il contratto di Cessione del credito in funzione del codice tributo:\n                    "
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-4" }, [
                                    _vm._v(
                                      " Totale importo di Cessione per codice tributo:\n                      "
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-4" }, [
                                      _vm._v(" - Ecobonus Ordinario "),
                                      _c("b", [
                                        _vm._v(
                                          " ( Codice Tributo 6922 ): €  " +
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                item.countEcobonus
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-4" }, [
                                      _vm._v(" - Ristrutturazione "),
                                      _c("b", [
                                        _vm._v(
                                          " ( Codice Tributo 6926 ): €  " +
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                item.countBonusCasa
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm._m(4, true)
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\n                  Carica il contratto\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "center" }, [
                                  _vm._v(
                                    "di Cessione del credito ricevuto da Poste Italiane"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "front-image" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          size: 10240,
                                          ext: ["jpeg", "jpg", "png", "pdf"],
                                          mimes: [
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                            "application/pdf"
                                          ]
                                        },
                                        expression:
                                          "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                      }
                                    ],
                                    ref: "fileInput",
                                    refInFor: true,
                                    staticClass: "fileInput",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "invoiceFront"
                                      ),
                                      valid: !!_vm.invoiceFront,
                                      helper: !!_vm.invoiceFrontBucket
                                    },
                                    attrs: {
                                      type: "file",
                                      multiple: "",
                                      name: "invoiceFront",
                                      id: "invoiceFront",
                                      "data-vv-as": "contratto di Cessione"
                                    },
                                    on: { change: _vm.uploadFile }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoiceFront" }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "smallText center white",
                                              style: {
                                                backgroundImage:
                                                  "url(" +
                                                  _vm.invoiceFrontBucket +
                                                  ")"
                                              }
                                            },
                                            [
                                              !_vm.invoiceFrontName
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "smallText center white mt-3 mb-0 pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli il Contratto quadro*"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "smallText center white",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                _vm.invoiceFrontBucket +
                                                ")"
                                            }
                                          })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoiceFront")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { top: "185px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.errors.first("invoiceFront")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress mt-5",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar ",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                        },
                                        [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 mt-5 mb-3 center" },
                                [
                                  _vm.invoiceFrontBucket
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.invoiceFrontBucket,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm.invoiceFrontBucket.substring(
                                            _vm.invoiceFrontBucket.lastIndexOf(
                                              "."
                                            ) + 1,
                                            _vm.invoiceFrontBucket.length
                                          ) == "pdf"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "center widthFull pdfLink",
                                                  attrs: {
                                                    href:
                                                      _vm.invoiceFrontBucket,
                                                    target: "_blank"
                                                  }
                                                },
                                                [_vm._v("APRI PDF")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 center pt-1" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btnRed",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmLoadContract(
                                            item.id,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Procedi")]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 borderTop2 mt-2" }, [
                      _vm._v("\n            Derivante dalle Pratiche: "),
                      _c("b", [
                        _vm._v(_vm._s(item.practices.replaceAll(",", ", ")))
                      ])
                    ])
                  ]
                )
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "widthFull row  mb-2" }, [
          _c("div", { staticClass: "col-md-8 " }),
          _vm._v(" "),
          _vm.totalDisposal != 0
            ? _c("div", { staticClass: "col-md-4 text-right" }, [
                _vm._v("\n        Importo totale Cessioni in corso "),
                _c("b", [
                  _vm._v(
                    "€ " +
                      _vm._s(_vm._f("formatNumber")(_vm.totalDisposal)) +
                      " "
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "widthFull  mt-5 " },
        [
          _vm._v(
            "* Trasferimento dei crediti dal cassetto fiscale dell'installatore a quello di "
          ),
          _vm.flow == "cdp" ? [_vm._v(" CDP ")] : [_vm._v(" Poste Italiane ")]
        ],
        2
      )
    ],
    1
  )
}
var practicesinWork_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-4" }, [
      _c("h4", [_c("b", [_vm._v("Elenco Cessioni in corso")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widthFull row even mb-2" }, [
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("N.Cessione")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 " }, [
        _c("small", [_vm._v("Data di creazione")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-5 " }, [_c("small", [_vm._v("Stato")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("Contratto")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("Movimentazione*")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 text-right" }, [
        _c("small", [_vm._v("Importo di Cessione")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("b", [_vm._v("2)")]),
      _vm._v(
        "  Fai una fotografia (screenshot) della movimentazione del credito sul tuo cassetto fiscale\n\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("b", [_vm._v("3)")]),
      _vm._v("  Carica la fotografia (screenshot) e clicca sul pulsante "),
      _c("b", [_vm._v('"PROCEDI"')])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("b", [_vm._v("2)")]),
      _vm._v(
        "  Carica contratto di Cessione ricevuto da Poste Italiane e clicca sul pulsante "
      ),
      _c("b", [_vm._v('"PROCEDI"')])
    ])
  }
]
practicesinWork_render._withStripped = true
var practicesinWork_esExports = { render: practicesinWork_render, staticRenderFns: practicesinWork_staticRenderFns }
/* harmony default export */ var cessioni_practicesinWork = (practicesinWork_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54242612", practicesinWork_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/cessioni/practicesinWork.vue
var practicesinWork_disposed = false
function practicesinWork_injectStyle (ssrContext) {
  if (practicesinWork_disposed) return
  __webpack_require__("jmdN")
  __webpack_require__("VwWl")
}
var practicesinWork_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var practicesinWork___vue_template_functional__ = false
/* styles */
var practicesinWork___vue_styles__ = practicesinWork_injectStyle
/* scopeId */
var practicesinWork___vue_scopeId__ = "data-v-54242612"
/* moduleIdentifier (server only) */
var practicesinWork___vue_module_identifier__ = null
var practicesinWork_Component = practicesinWork_normalizeComponent(
  practicesinWork,
  cessioni_practicesinWork,
  practicesinWork___vue_template_functional__,
  practicesinWork___vue_styles__,
  practicesinWork___vue_scopeId__,
  practicesinWork___vue_module_identifier__
)
practicesinWork_Component.options.__file = "src/components/cessioni/practicesinWork.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-54242612", practicesinWork_Component.options)
  } else {
    hotAPI.reload("data-v-54242612", practicesinWork_Component.options)
  }
  module.hot.dispose(function (data) {
    practicesinWork_disposed = true
  })
})()}

/* harmony default export */ var components_cessioni_practicesinWork = (practicesinWork_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cessioni/practicesFinished.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var practicesFinished = ({
  name: 'DisposalAvailable',
  components: {},
  props: {},
  data: function data() {
    return {
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      loadingState: false,
      flow: 'cdp',
      disposals: {},
      practices: {},
      loaded: false,
      countPractices: 0,
      moment: __webpack_require__("PJh5"),
      countValues: 0,

      min_disposal_price_cdp: 75000,
      min_disposal_price_poste: 2000,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      totalDisposal: 0,

      countEcobonus: 0,
      countBonusCasa: 0,

      input: ''

    };
  },

  methods: {
    getDisposals: function getDisposals() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data, _vue;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.getProfile) {
                  _this.loaded = false;
                  data = _this.getProfile;
                  _vue = _this;

                  _vue.loadingState = true;
                  axios_default()({
                    url: "https://wsbot.eu/21005back/public/" + 'api/getDisposals',
                    method: 'POST',
                    data: {
                      type: 'complated',
                      user_token: data.userToken,
                      flow: _this.flow
                    },
                    headers: {
                      'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                      'Content-type': 'application/json'
                    }
                  }).then(function (resp) {
                    var disposals = resp.data.disposals;
                    //_vue.practices = resp.data.practices
                    _vue.totalDisposal = 0;

                    for (var x in disposals) {

                      // COUNT TOTAL VALUE
                      var p = disposals[x].totalDisposalAmount;
                      p = parseFloat(p.replace(',', '.'));
                      _vue.totalDisposal = _vue.totalDisposal + p;

                      /// COUNT VALUES FOR SINGLE DISPOSAL DIVIDED BY TRIBUTE CODE
                      /*var countEcobonus = 0
                      var countBonusCasa = 0
                      var practices = disposals[x].practices.split(",");
                      for (var z in practices) {
                         if (_vue.practices[practices[z]].bonus == 'Bonus Casa 50%') {
                           countBonusCasa = countBonusCasa + parseFloat(_vue.practices[practices[z]].finalAmmount)
                         } else {
                           countEcobonus = countEcobonus + parseFloat(_vue.practices[practices[z]].finalAmmount)
                         }
                      }
                       countBonusCasa = countBonusCasa.toFixed(2)
                      countEcobonus = countEcobonus.toFixed(2)
                       disposals[x]['countBonusCasa'] = countBonusCasa
                      disposals[x]['countEcobonus'] = countEcobonus
                      */
                    }

                    _vue.totalDisposal = _vue.totalDisposal.toFixed(2);

                    _vue.disposals = disposals;

                    console.log(_vue.disposals);

                    _vue.loaded = true;
                    _vue.loadingState = false;

                    /*_vue.uploadFrontPercentage = 0
                    _vue.invoiceFront = ''
                    _vue.invoiceFrontBucket = ''
                    _vue.input.target.value = null*/
                  }).catch(function (resp) {

                    _vue.loadingState = false;
                  });
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    uploadFile: function uploadFile(input) {
      this.input = input;
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        var t = 0;
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1;
        }

        this.loadingState = true;

        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.loadingState = false;
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = '';
            _vue.invoiceFrontBucket = '';
            _vue.UploadError();
            input.target.value = null;
            _vue.loadingState = false;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = '';
          _vue.invoiceFrontBucket = '';
          _vue.UploadError();
          input.target.value = null;
          _vue.loadingState = false;
        });
      }
    }

  },
  watch: {
    iban: function iban(value) {
      this.iban = value.toUpperCase().trim();
      this.iban = this.iban.replace(' ', '');
    },
    flow: function flow(val) {
      this.getDisposals();

      if (val == 'cdp') {
        this.min_disposal_price_cdp = 75000;
      } else {
        this.min_disposal_price_cdp = 2000;
      }
    },
    getProfile: function getProfile() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getDisposals();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {

    console.log('Section 1 LOADED');
  },
  mounted: function mounted() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getDisposals();

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6487464","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cessioni/practicesFinished.vue
var practicesFinished_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-0 pb-3 mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "csHeight2" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center text-left pt-2 " },
          [
            _c(
              "div",
              {
                staticClass:
                  "col-md-6 center mb-3 text-center pointer selectBlock",
                class: { blockActive: _vm.flow == "cdp" },
                on: {
                  click: function($event) {
                    _vm.flow = "cdp"
                  }
                }
              },
              [
                _c(
                  "h1",
                  { staticClass: "mt-4", class: { grey: _vm.flow == "poste" } },
                  [_c("b", [_vm._v(" CDP ")])]
                ),
                _vm._v(" "),
                _c("h4", { class: { grey: _vm.flow == "poste" } }, [
                  _vm._v("Cassa Depositi e Prestiti")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-6 center mb-3 text-center pointer selectBlock",
                class: { blockActive: _vm.flow == "poste" },
                on: {
                  click: function($event) {
                    _vm.flow = "poste"
                  }
                }
              },
              [
                _c(
                  "h1",
                  { staticClass: "mt-4", class: { grey: _vm.flow == "cdp" } },
                  [_c("b", [_vm._v(" Poste Italiane ")])]
                ),
                _vm._v(" "),
                _c("h4", { class: { grey: _vm.flow == "cdp" } }, [
                  _vm._v(" BancoPosta Affari")
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.disposals, function(item, index, k) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "widthFull row pt-2 mb-5",
                    class: {
                      "pt-0": k == 0,
                      even34: String(index / 2).includes(".")
                    }
                  },
                  [
                    _c("div", { staticClass: "col-md-1 " }, [
                      _c("b", [_vm._v(_vm._s(item.id))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 " }, [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.moment(item.created_at).format("DD-MM-YYYY")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5 " },
                      [
                        item.state == 3
                          ? [
                              _vm._v(
                                "\n              Cessione completata. Attendi il bonifico bancario di\n              "
                              ),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")],
                              _vm._v(
                                "\n              sul tuo conto corrente\n              "
                              ),
                              _vm.flow == "cdp"
                                ? [
                                    _vm._v(
                                      " indicato nei Documenti per Eleggibilità CDP "
                                    )
                                  ]
                                : [_vm._v(" BancoPosta Business ")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 5
                          ? [_vm._v("\n              Errore\n            ")]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-1 center" }, [
                      _c(
                        "a",
                        { attrs: { href: item.contract } },
                        [
                          item.contract
                            ? _c("font-awesome-icon", {
                                staticClass: "green",
                                attrs: { icon: "file-alt", size: "1x" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-1 " },
                      [
                        item.screenshot
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "check", size: "1x" }
                            })
                          : item.state == 1
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "", size: "1x" }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 text-right" }, [
                      _c("b", [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm._f("formatNumber")(item.totalDisposalAmount)
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 borderTop2 mt-2" }, [
                      _vm._v("\n            Derivante dalle Pratiche: "),
                      _c("b", [
                        _vm._v(_vm._s(item.practices.replaceAll(",", ", ")))
                      ])
                    ])
                  ]
                )
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "widthFull row  mb-2" }, [
          _c("div", { staticClass: "col-md-8 " }),
          _vm._v(" "),
          _vm.totalDisposal != 0
            ? _c("div", { staticClass: "col-md-4 text-right" }, [
                _vm._v("\n        Importo totale Cessioni completate "),
                _c("b", [
                  _vm._v(
                    "€ " +
                      _vm._s(_vm._f("formatNumber")(_vm.totalDisposal)) +
                      " "
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "widthFull  mt-5 " },
        [
          _vm._v(
            "* Trasferimento dei crediti dal cassetto fiscale dell'installatore a quello di "
          ),
          _vm.flow == "cdp" ? [_vm._v(" CDP ")] : [_vm._v(" Poste Italiane ")]
        ],
        2
      )
    ],
    1
  )
}
var practicesFinished_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-4" }, [
      _c("h4", [_c("b", [_vm._v("Elenco Cessioni completate")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widthFull row even mb-2" }, [
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("N.Cessione")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 " }, [
        _c("small", [_vm._v("Data di creazione")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-5 " }, [_c("small", [_vm._v("Stato")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("Contratto")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("Movimentazione*")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 text-right" }, [
        _c("small", [_vm._v("Importo di Cessione")])
      ])
    ])
  }
]
practicesFinished_render._withStripped = true
var practicesFinished_esExports = { render: practicesFinished_render, staticRenderFns: practicesFinished_staticRenderFns }
/* harmony default export */ var cessioni_practicesFinished = (practicesFinished_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6487464", practicesFinished_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/cessioni/practicesFinished.vue
var practicesFinished_disposed = false
function practicesFinished_injectStyle (ssrContext) {
  if (practicesFinished_disposed) return
  __webpack_require__("6fPw")
  __webpack_require__("o/Aw")
}
var practicesFinished_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var practicesFinished___vue_template_functional__ = false
/* styles */
var practicesFinished___vue_styles__ = practicesFinished_injectStyle
/* scopeId */
var practicesFinished___vue_scopeId__ = "data-v-f6487464"
/* moduleIdentifier (server only) */
var practicesFinished___vue_module_identifier__ = null
var practicesFinished_Component = practicesFinished_normalizeComponent(
  practicesFinished,
  cessioni_practicesFinished,
  practicesFinished___vue_template_functional__,
  practicesFinished___vue_styles__,
  practicesFinished___vue_scopeId__,
  practicesFinished___vue_module_identifier__
)
practicesFinished_Component.options.__file = "src/components/cessioni/practicesFinished.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f6487464", practicesFinished_Component.options)
  } else {
    hotAPI.reload("data-v-f6487464", practicesFinished_Component.options)
  }
  module.hot.dispose(function (data) {
    practicesFinished_disposed = true
  })
})()}

/* harmony default export */ var components_cessioni_practicesFinished = (practicesFinished_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/flowSettings/delegaForm.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var delegaForm_moment = __webpack_require__("PJh5");

/* harmony default export */ var delegaForm = ({
  name: 'delegaForm',
  components: {},
  props: {},
  data: function data() {
    return {
      brand: "CHEBONUS",
      delegate_move_credits: '',
      delegate_move_credits_doc: '',
      loadingState: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      invoiceRear: '',
      invoiceRearName: '',
      invoiceRearBucket: '',
      uploadRearPercentage: 0
    };
  },

  methods: {
    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append('fattura0', input.target.files[0]);
        axios_default.a.post("https://wsbot.eu/21005back/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
            _vue.delegate_move_credits_doc = e.data.fattura;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = '';
            _vue.invoiceFrontBucket = '';
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = '';
          _vue.invoiceFrontBucket = '';
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },
    UploadError: function UploadError() {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },
    editUser: function editUser() {
      console.log(this);
      var _vue = this;
      //this.$validator.validateAll(scope).then(function (res) {
      this.$validator.validate().then(function (valid) {

        if (valid) {
          _vue.loadingState = true;
          var data = {
            email: _vue.getProfile.email,
            delegate_move_credits: _vue.delegate_move_credits
            //delegate_move_credits_doc: _vue.delegate_move_credits_doc,
          };

          axios_default()({
            url: "https://wsbot.eu/21005back/public/" + 'api/editUser',
            method: 'POST',
            data: {
              user: data,
              regType: 'old'
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            _vue.$store.dispatch(actions_user["d" /* USER_REQUEST */]);

            _vue.loadingState = false;
            window.location.reload();
          }).catch(function (error) {

            _vue.loadingState = false;
            var text = error.response.data.error;
            _vue.addClientError(text);
          });
        }
      });
    },
    addClientError: function addClientError(text) {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger">Operazione non andata a buon fine.</strong>',
        html: text,
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },
    checkIfExistUser: function checkIfExistUser() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('11');
                if (_this.getProfile) {
                  data = _this.getProfile;

                  console.log('22  ');
                  if (data.delegate_move_credits == '0' || data.delegate_move_credits == 0) {
                    console.log('33');
                    if (data.tipo_azienda == 'Ditta Individuale' || data.tipo_azienda == 'Professionista iscritto ad albi') {
                      // ADVISOR CAN'T MOVE CREDIT BY DEFAUL
                      _this.delegate_move_credits = 2;
                      _this.editUser();
                    } else {
                      _this.delegate_move_credits = 0;
                    }
                  } else {
                    _this.delegate_move_credits = data.delegate_move_credits;
                  }
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  watch: {
    iban: function iban(value) {
      this.iban = value.toUpperCase().trim();
      this.iban = this.iban.replace(' ', '');
    },

    getProfile: function getProfile() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.checkIfExistUser();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.checkIfExistUser();

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  mounted: function mounted() {
    var _this4 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.checkIfExistUser();

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10101776","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowSettings/delegaForm.vue
var delegaForm_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-1 pb-1" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: " black pl-4 pr-4 mb-3 widthFull vaillantCont",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.editUser()
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("div", { staticClass: "col-md-12 vaillantCont  text-left" }, [
              _c("div", { staticClass: "group mt-1" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm.getProfile.tipo_azienda != "Ditta Individuale" &&
                _vm.getProfile.tipo_azienda != "Professionista iscritto ad albi"
                  ? _c(
                      "div",
                      { staticClass: "form-check form-check-inline mt-2" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ",
                            on: {
                              click: function($event) {
                                _vm.delegate_move_credits = 1
                              }
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.delegate_move_credits,
                                  expression: "delegate_move_credits"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|included:1,2",
                                  expression: "'required|included:1,2'"
                                }
                              ],
                              staticClass: "form-check-input inline mr-3",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "delegate_move_credits"
                                )
                              },
                              attrs: {
                                type: "radio",
                                value: "1",
                                name: "delegate_move_credits"
                              },
                              domProps: {
                                checked: _vm._q(_vm.delegate_move_credits, "1")
                              },
                              on: {
                                change: function($event) {
                                  _vm.delegate_move_credits = "1"
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                "AUTORIZZO la delega all'intermediario abilitato"
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-check form-check-inline" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label Bold pt-3",
                      on: {
                        click: function($event) {
                          _vm.delegate_move_credits = 2
                        }
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.delegate_move_credits,
                            expression: "delegate_move_credits"
                          }
                        ],
                        staticClass: "form-check-input inline mr-3",
                        class: {
                          "is-invalid": _vm.errors.has("delegate_move_credits")
                        },
                        attrs: {
                          type: "radio",
                          value: "2",
                          name: "delegate_move_credits"
                        },
                        domProps: {
                          checked: _vm._q(_vm.delegate_move_credits, "2")
                        },
                        on: {
                          change: function($event) {
                            _vm.delegate_move_credits = "2"
                          }
                        }
                      }),
                      _vm._v(
                        "\n              NON AUTORIZZO la delega all'intermediario abilitato (*)\n              "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("privacy4"),
                        expression: "errors.has('privacy4')"
                      }
                    ],
                    staticClass: "errorMes Bold"
                  },
                  [
                    _vm._v(
                      "\n            Il consenso deve essere accettato oppure rifiutato\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.delegate_move_credits == 1
                ? _c("h5", { staticClass: "pl-md-5 pb-1 " }, [
                    _vm._v(
                      "\n            Si richiede di accedere alla Piattaforma di Gestione Crediti Agenzia delle Entrate "
                    ),
                    _vm._m(1),
                    _vm._v(
                      "\n            della Società per l’inserimento del Codice Fiscale e del Nome dell'intermediario abilitato per la delega:\n\n            "
                    ),
                    _c(
                      "h5",
                      { staticClass: "h5 pt-1 Bold " },
                      [
                        _vm._v(
                          "\n              Inserire il seguente Codice Fiscale e Nome dell'intermediario abilitato"
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _vm.brand != "CHEBONUS"
                          ? [
                              _c("b", [
                                _vm._v(" SLMFMR80D25F205P – Fabio Salamina")
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brand == "CHEBONUS"
                          ? [
                              _c("b", [
                                _vm._v(
                                  " DLFMSM72D02H501O – Massimiliano Delfini"
                                )
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("h5", { staticClass: " mb-5 pb-md-5 borderBottom" }, [
                      _vm.brand != "CHEBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "black underline",
                              attrs: {
                                href:
                                  "https://storage.googleapis.com/happybonus/Nomina_incarica_o_KPMG_Salamina_Fabio.pdf",
                                target: "_blank"
                              }
                            },
                            [_c("b", [_vm._v(" Qui ")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "black underline",
                              attrs: {
                                href:
                                  "https://storage.googleapis.com/chebonus/Nomina_incaricato_KPMG_Delfini_Massimiliano.pdf",
                                target: "_blank"
                              }
                            },
                            [_c("b", [_vm._v(" Qui ")])]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n               è possibile scaricare il manuale operativo per la nomina dell'intermediario abilitato.\n            "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("p", { staticClass: "pb-4 pb-1" }, [
                _vm._v(
                  "\n          Gli aderenti con forma giuridica Ditte Individuali o Professionisti iscritti all'albo dovranno provvedere autonomamente alla gestione dei crediti nel proprio cassetto fiscale.\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _vm.getProfile.delegate_move_credits != _vm.delegate_move_credits
              ? _c("div", { staticClass: "col-md-12 center mb-3 pt-0  mb-1" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { type: "submit" }
                    },
                    [_vm._v("\n          Salva\n        ")]
                  )
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var delegaForm_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "form-check-label widthFull Bold blue h5",
        attrs: { for: "delegate_move_credits" }
      },
      [
        _c("b", [
          _vm._v(
            "Delega intermediario abilitato ad operare nel cassetto fiscale dell'aderente"
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "\n              ( con la presente delega autorizzi l'intermediario abilitato ad operare nel tuo cassetto fiscale per accettare il credito dal tuo cliente e cedere il relativo credito al cessionario finale )"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _c(
        "a",
        {
          staticClass: "black underline",
          attrs: {
            href: "https://www.agenziaentrate.gov.it/portale/area-riservata",
            target: "_blank"
          }
        },
        [_vm._v(" Fisconline / Entratel")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "pl-md-5 pb-1" }, [
      _c("b", [
        _vm._v(
          "(*) Se \"NON AUTORIZZO\", l'operatività all'interno del cassetto fiscale rimarrà a tuo carico o del consulente fiscale/commercialista da te delegato. "
        )
      ])
    ])
  }
]
delegaForm_render._withStripped = true
var delegaForm_esExports = { render: delegaForm_render, staticRenderFns: delegaForm_staticRenderFns }
/* harmony default export */ var flowSettings_delegaForm = (delegaForm_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10101776", delegaForm_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/flowSettings/delegaForm.vue
var delegaForm_disposed = false
function delegaForm_injectStyle (ssrContext) {
  if (delegaForm_disposed) return
  __webpack_require__("iKmc")
  __webpack_require__("L4aP")
}
var delegaForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var delegaForm___vue_template_functional__ = false
/* styles */
var delegaForm___vue_styles__ = delegaForm_injectStyle
/* scopeId */
var delegaForm___vue_scopeId__ = "data-v-10101776"
/* moduleIdentifier (server only) */
var delegaForm___vue_module_identifier__ = null
var delegaForm_Component = delegaForm_normalizeComponent(
  delegaForm,
  flowSettings_delegaForm,
  delegaForm___vue_template_functional__,
  delegaForm___vue_styles__,
  delegaForm___vue_scopeId__,
  delegaForm___vue_module_identifier__
)
delegaForm_Component.options.__file = "src/components/flowSettings/delegaForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-10101776", delegaForm_Component.options)
  } else {
    hotAPI.reload("data-v-10101776", delegaForm_Component.options)
  }
  module.hot.dispose(function (data) {
    delegaForm_disposed = true
  })
})()}

/* harmony default export */ var components_flowSettings_delegaForm = (delegaForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cessioni/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var cessioni_moment = __webpack_require__("PJh5");

/* harmony default export */ var cessioni = ({
  name: 'Practics',
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"],
    practicesToDo: components_cessioni_practicesToDo,
    practicesinWork: components_cessioni_practicesinWork,
    practicesFinished: components_cessioni_practicesFinished,
    delegaForm: components_flowSettings_delegaForm
  },
  data: function data() {
    return {
      token: '',
      section1: ' active',
      section11: ' show active',
      section2: ' ',
      section22: ' ',
      section3: ' ',
      section33: ' ',
      section4: ' ',
      section44: ' ',
      loadingState: false,
      loading: false,
      practices: {},

      moment: __webpack_require__("PJh5"),
      showDelegateForm: false

    };
  },

  methods: {
    checkDelega: function checkDelega() {
      console.log('CHECK IF PRESENT AUTORIZATION FOR ADVISOR => ' + this.getProfile.delegate_move_credits);

      if (this.getProfile.delegate_move_credits == 0 || this.getProfile.delegate_move_credits == '0') {
        this.showDelegateForm = true;
      } else {
        this.showDelegateForm = false;
      }
    },
    setSection: function setSection(section) {

      console.log(section);

      this.section1 = ' ';
      this.section11 = ' ';
      this.section2 = ' ';
      this.section22 = ' ';
      this.section3 = ' ';
      this.section33 = ' ';
      this.section4 = ' ';
      this.section44 = ' ';

      if (section == 1) {
        this.section1 = ' active';
        this.section11 = ' show active';
      }
      if (section == 2) {
        this.section2 = ' active';
        this.section22 = ' show active';
      }
      if (section == 3) {
        this.section3 = ' active';
        this.section33 = ' show active';
      }
      if (section == 4) {
        this.section4 = ' active';
        this.section44 = ' show active';
      }
    },
    getPractices: function getPractices() {

      //await this.checkBonusValues()
      /*
      var _vue = this
       _vue.totUserReceived = _vue.getProfile.total_bonus_received
        this.loadingState = true
      console.log(_vue.getProfile.userToken)
      var token = _vue.getProfile.userToken
      if (token) {
        await axios({
            url: process.env.ROOT_API + 'api/getPractices',
            method: 'POST',
            data: {
              type: 'all',
              user_token: token
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            _vue.practices = resp.data.practices
             console.log(_vue.practices)
             _vue.totCash = 0
            _vue.countPractices = 0
            _vue.countCashInst = 0
            _vue.countCashClient = 0
             // ERRORS
            _vue.countErrorPractice = 0
            _vue.totErrorCashClient = 0
            _vue.totErrorCashInst = 0
            // STEP 1
            _vue.countStep1Practice = 0
            _vue.totStep1CashClient = 0
            _vue.totStep1CashInst = 0
            // STEP 2
            _vue.countStep2Practice = 0
            _vue.totStep2CashClient = 0
            _vue.totStep2CashInst = 0
            // STEP 3
            _vue.countStep3Practice = 0
            _vue.totStep3CashClient = 0
            _vue.totStep3CashInst = 0
            // STEP 4
            _vue.countStep4Practice = 0
            _vue.totStep4CashClient = 0
            _vue.totStep4CashInst = 0
             // NEWWWWWW
             _vue.totAmountBefore10 = 0
            _vue.totAmountAfter10 = 0
             for (var x in _vue.practices) {
               if (_vue.practices[x].status != '10') {
                 _vue.countPractices++
                _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_work_and_iva)).toFixed(2)
                //_vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_bonus_savings)).toFixed(2)
                  // NEWWWWWW
                 _vue.totAmountBefore10 = (parseFloat(_vue.totAmountBefore10) + parseFloat(_vue.practices[x].amount_before_10)).toFixed(2)
                _vue.totAmountAfter10 = ( parseFloat(_vue.totAmountAfter10) + parseFloat(_vue.practices[x].amount_after_10) ).toFixed(2)
                  _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                console.log(1)
                if (_vue.practices[x].hasErrors == 'yes') {
                  console.log(22)
                  _vue.countErrorPractice = _vue.countErrorPractice + 1
                  _vue.totErrorCashClient = (parseFloat(_vue.countErrorPractice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totErrorCashInst = (parseFloat(_vue.totErrorCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }
                 if (_vue.practices[x].status == '1') {
                  _vue.countStep1Practice = _vue.countStep1Practice + 1
                  _vue.totStep1CashClient = (parseFloat(_vue.countStep1Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totStep1CashInst = (parseFloat(_vue.totStep1CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }
                 if (_vue.practices[x].status == '2') {
                  _vue.countStep2Practice = _vue.countStep2Practice + 1
                  _vue.totStep2CashClient = (parseFloat(_vue.countStep2Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totStep2CashInst = (parseFloat(_vue.totStep2CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }
                 if (_vue.practices[x].status == '3') {
                  _vue.countStep3Practice = _vue.countStep3Practice + 1
                  _vue.totStep3CashClient = (parseFloat(_vue.countStep3Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totStep3CashInst = (parseFloat(_vue.totStep3CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }
                 if (_vue.practices[x].status == '4') {
                  _vue.countStep4Practice = _vue.countStep4Practice + 1
                  _vue.totStep4CashClient = (parseFloat(_vue.countStep4Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totStep4CashInst = (parseFloat(_vue.totStep4CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }
               }
               if (_vue.practices[x].status == '10') {
                _vue.hasRemovedPractics = true
              }
               console.log(333)
             }
             _vue.totAmountAfter10 = ( parseFloat(_vue.totAmountAfter10)- parseFloat(_vue.totUserReceived) ).toFixed(2)
             this.totCash = parseFloat(this.totCash)
            if (this.totCash < 10000) {
              this.maxTotCash = 10000
              this.step = 1000
            } else if (this.totCash < 100000) {
              this.maxTotCash = 100000
              this.step = 10000
            } else if (this.totCash < 1000000) {
              this.maxTotCash = 1000000
              this.step = 100000
            } else if (this.totCash < 100000000) {
              this.maxTotCash = 100000000
              this.step = 1000000
            }
            _vue.practicesFiltred = _vue.practices
             console.log(4444)
             _vue.loadingState = false
          })
          .catch(resp => {
            console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor')
            _vue.presentPractices = false,
              _vue.loadingState = false
          })
      }*/

      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      if (val) {
        console.log(val);
        this.getPractices();
        this.checkDelega();
      }
    }

  },
  created: function created() {},
  mounted: function mounted() {

    if (this.getProfile) {
      this.getPractices();
      this.checkDelega();
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f74d14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cessioni/index.vue
var cessioni_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container pt-2" }, [
        !_vm.showDelegateForm
          ? _c("div", { staticClass: "row justify-content-center text-left" }, [
              _vm._m(0)
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row " }, [
          !_vm.showDelegateForm
            ? _c("section", { attrs: { id: "tabs" } }, [
                _c("div", { staticClass: "container" }, [
                  _c("h5", { staticClass: "section-title h3" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row pt-0" }, [
                    _c("div", { staticClass: "col-12 col-md-12" }, [
                      _c("nav", [
                        _c(
                          "div",
                          {
                            staticClass: "nav nav-tabs nav-fill",
                            attrs: { id: "nav-tab", role: "tablist" }
                          },
                          [
                            _c(
                              "a",
                              {
                                class:
                                  "nav-item nav-link  cblack customNItem " +
                                  _vm.section1,
                                attrs: {
                                  id: "nav-home-tab",
                                  "data-toggle": "tab",
                                  href: "#nav-home",
                                  role: "tab",
                                  "aria-controls": "nav-to-do",
                                  "aria-selected": "true"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.setSection(1)
                                  }
                                }
                              },
                              [_vm._v("Pratiche in attesa di Cessione ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                class:
                                  "nav-item nav-link  cblack customNItem " +
                                  _vm.section2,
                                attrs: {
                                  id: "nav-poste-tab",
                                  "data-toggle": "tab",
                                  href: "#nav-poste",
                                  role: "tab",
                                  "aria-controls": "nav-in-work",
                                  "aria-selected": "false"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.setSection(2)
                                  }
                                }
                              },
                              [_vm._v("Cessioni in corso ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                class:
                                  "nav-item nav-link  cblack customNItem " +
                                  _vm.section3,
                                attrs: {
                                  id: "nav-cdp-docs-tab",
                                  "data-toggle": "tab",
                                  href: "#nav-cdp-docs",
                                  role: "tab",
                                  "aria-controls": "nav-ended",
                                  "aria-selected": "false"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.setSection(3)
                                  }
                                }
                              },
                              [_vm._v("Cessioni completate")]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "tab-content  pt-0 mt-0 p-0 vaillantCont",
                          attrs: { id: "nav-tabContent" }
                        },
                        [
                          _c(
                            "div",
                            {
                              class: "pt-0 mt-0 tab-pane fade " + _vm.section11,
                              attrs: {
                                id: "nav-to-do",
                                role: "tabpanel",
                                "aria-labelledby": "nav-home-tab"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 center mb-3 center boxNt"
                                },
                                [
                                  _vm.section1 == " active"
                                    ? _c("practicesToDo")
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: "tab-pane fade " + _vm.section22,
                              attrs: {
                                id: "nav-poste",
                                role: "tabpanel",
                                "aria-labelledby": "nav-in-work"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 center mb-3 center boxNt"
                                },
                                [
                                  _vm.section2 == " active"
                                    ? _c("practicesinWork")
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: "tab-pane fade " + _vm.section33,
                              attrs: {
                                id: "nav-cdp-docs",
                                role: "nav-ended",
                                "aria-labelledby": "nav-cdp-docs-tab"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 center mb-3 center boxNt"
                                },
                                [
                                  _vm.section3 == " active"
                                    ? _c("practicesFinished")
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showDelegateForm
            ? _c(
                "div",
                { staticClass: "row justify-content-center text-left" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", { staticClass: "pb-0 mb-0 Bold mb-5" }, [
                    _vm._v(
                      "Prima di procedere con cessioni abbiamo bisogno del tuo consenso  "
                    )
                  ]),
                  _vm._v(" "),
                  _c("delegaForm")
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var cessioni_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-12" }, [
      _c("h3", { staticClass: "Regular text-left  h0 widthFull" }, [
        _c("b", [_vm._v("Gestione Cessioni ")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "pb-0 mb-0 text-left Bold" }, [
        _vm._v(
          "In questa sezione puoi gestire le cessioni delle tue Pratiche approvate e validate dopo il 04 ottobre 2021  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "Regular center h0 widthFull" }, [
      _c("b", [_vm._v("Delega intermediario")])
    ])
  }
]
cessioni_render._withStripped = true
var cessioni_esExports = { render: cessioni_render, staticRenderFns: cessioni_staticRenderFns }
/* harmony default export */ var components_cessioni = (cessioni_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1f74d14", cessioni_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/cessioni/index.vue
var cessioni_disposed = false
function cessioni_injectStyle (ssrContext) {
  if (cessioni_disposed) return
  __webpack_require__("3t9Z")
}
var cessioni_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cessioni___vue_template_functional__ = false
/* styles */
var cessioni___vue_styles__ = cessioni_injectStyle
/* scopeId */
var cessioni___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cessioni___vue_module_identifier__ = null
var cessioni_Component = cessioni_normalizeComponent(
  cessioni,
  components_cessioni,
  cessioni___vue_template_functional__,
  cessioni___vue_styles__,
  cessioni___vue_scopeId__,
  cessioni___vue_module_identifier__
)
cessioni_Component.options.__file = "src/components/cessioni/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c1f74d14", cessioni_Component.options)
  } else {
    hotAPI.reload("data-v-c1f74d14", cessioni_Component.options)
  }
  module.hot.dispose(function (data) {
    cessioni_disposed = true
  })
})()}

/* harmony default export */ var src_components_cessioni = (cessioni_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/testIframe/index.vue

//
//
//
//
//
//
//
//








var testIframe_moment = __webpack_require__("PJh5");

/* harmony default export */ var testIframe = ({
		name: 'play',
		components: {
				Datepicker: vuejs_datepicker_esm["a" /* default */],
				VueTimepicker: vue2_timepicker_default.a
		},
		data: function data() {
				return {
						loadingState: false,

						vw: window.innerWidth
				};
		},

		methods: {},
		watch: {},
		updated: function updated() {},
		created: function created() {},
		mounted: function mounted() {},
		computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
				profile: function profile(state) {
						return state.user.profile;
				}
		}))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4b69a2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/testIframe/index.vue
var testIframe_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull  " })
}
var testIframe_staticRenderFns = []
testIframe_render._withStripped = true
var testIframe_esExports = { render: testIframe_render, staticRenderFns: testIframe_staticRenderFns }
/* harmony default export */ var components_testIframe = (testIframe_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4b69a2e", testIframe_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/testIframe/index.vue
var testIframe_disposed = false
function testIframe_injectStyle (ssrContext) {
  if (testIframe_disposed) return
  __webpack_require__("CufG")
  __webpack_require__("nNqh")
}
var testIframe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var testIframe___vue_template_functional__ = false
/* styles */
var testIframe___vue_styles__ = testIframe_injectStyle
/* scopeId */
var testIframe___vue_scopeId__ = "data-v-e4b69a2e"
/* moduleIdentifier (server only) */
var testIframe___vue_module_identifier__ = null
var testIframe_Component = testIframe_normalizeComponent(
  testIframe,
  components_testIframe,
  testIframe___vue_template_functional__,
  testIframe___vue_styles__,
  testIframe___vue_scopeId__,
  testIframe___vue_module_identifier__
)
testIframe_Component.options.__file = "src/components/testIframe/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e4b69a2e", testIframe_Component.options)
  } else {
    hotAPI.reload("data-v-e4b69a2e", testIframe_Component.options)
  }
  module.hot.dispose(function (data) {
    testIframe_disposed = true
  })
})()}

/* harmony default export */ var src_components_testIframe = (testIframe_Component.exports);

// EXTERNAL MODULE: ./src/store/index.js + 3 modules
var store = __webpack_require__("IcnI");

// CONCATENATED MODULE: ./src/router/index.js




//import CheckAge from 'components/checkage'






































// NEW FLOW 02.08.2021







//import Forgotpassword from 'components/forgotpassword'
//import Recoverypassword from 'components/recoverypassword'
//import ComplateRegistration from 'components/ComplateRegistration'
//import Receipts from 'components/receipts'




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router_ifNotAuthenticated = function ifNotAuthenticated(to, from, next) {
  if (!store["a" /* default */].getters.isAuthenticated || !store["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

var router_ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (store["a" /* default */].getters.isProfileLoaded || store["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

var router_moment = __webpack_require__("PJh5");

var ifActive = function ifActive(to, from, next) {

  var finish = router_moment("2030-12-15 23:59:59");
  if (router_moment() < finish) {
    next();
    return;
  }
  next('/end');
};

var ifStart = function ifStart(to, from, next) {

  var start = router_moment("2021-02-15 00:00:00");
  if (router_moment() > start) {
    next();
    return;
  }
  next('/notActive');
};

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  //base: '/nttest/vaillantecobonus/',
  base: '/',
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_home,
    beforeEnter: router_guards([ifStart, ifActive])

  }, {
    path: '/testIframe',
    name: 'testIframe',
    component: src_components_testIframe,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/contact',
    name: 'contact',
    component: src_components_contact,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/faq',
    name: 'faq',
    component: src_components_faq,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/cessioni',
    name: 'cessioni',
    component: src_components_cessioni,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/paymentError/:id',
    name: 'paymentError',
    component: src_components_paymentError,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/paymentSuccess/:id',
    name: 'paymentSuccess',
    component: src_components_paymentSuccess,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/registration',
    name: 'addClient',
    component: src_components_addClient,
    beforeEnter: router_guards([ifStart, ifActive, router_ifNotAuthenticated])

  }, {
    path: '/confirm',
    name: 'Confirm',
    component: src_components_confirm,
    beforeEnter: router_ifNotAuthenticated
  }, {
    path: '/forgot-password',
    name: 'Forgotpassword',
    component: src_components_forgotpassword,
    beforeEnter: router_ifNotAuthenticated
  }, {
    path: '/recovery-password',
    name: 'Recoverypassword',
    component: src_components_recoverypassword,
    beforeEnter: router_ifNotAuthenticated

  }, {
    path: '/Calcolatore',
    name: 'Calcolatore',
    component: src_components_calcolatore,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/account',
    name: 'Account',
    component: src_components_account,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/cobrowsing',
    name: 'CoBrowsing',
    component: src_components_cobrowsing,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/offerte',
    name: 'offerte',
    component: src_components_offerte,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/superbonus',
    name: 'superbonus',
    component: src_components_superbonus,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/acceptInvoice',
    name: 'acceptInvoice',
    component: src_components_acceptInvoice
    //beforeEnter: ifAuthenticated
  }, {
    path: '/editInvoice',
    name: 'editInvoice',
    component: src_components_editCalc
    //beforeEnter: ifAuthenticated
  }, {
    path: '/loadDocuments',
    name: 'loadDocuments',
    component: src_components_loadDocuments,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])
  }, {
    path: '/editDocument',
    name: 'editDocument',
    component: src_components_editDocuments,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])
  }, {
    path: '/pratiche',
    name: 'pratiche',
    component: src_components_pratiche,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/complateEneaData',
    name: 'complateEneaData',
    component: src_components_complateEneaData,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/login',
    name: 'Login',
    component: src_components_areaRiservata,
    beforeEnter: router_guards([ifStart, ifActive, router_ifNotAuthenticated])
  }, {
    path: '/loginasgod',
    name: 'loginasgod',
    component: src_components_loginasgod
  }, {
    path: '/privacy',
    name: 'Privacy',
    component: src_components_privacy
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/validUser',
    name: 'admin',
    component: src_components_admin
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/cookie',
    name: 'cookie',
    component: src_components_cookie
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/regulation',
    name: 'regulation',
    component: src_components_regulation
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/end',
    name: 'end',
    component: src_components_end
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/notActive',
    name: 'notActive',
    component: src_components_notActive
    // beforeEnter: ifComplateAccount,
  },

  // NEW FLOW 02.08.2021
  {
    path: '/flowSettings',
    name: 'flowSettings',
    component: src_components_flowSettings,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/editDocumentCDP',
    name: 'editDocumentCDP',
    component: components_flowSettings_editDocumentCDP,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }]
}));

// allows using multiple guards for routes
function router_guards(guards) {
  var _this = this;

  return function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
      var changed, mNext, i;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              // a flag to discard remaining guards
              changed = false;

              // handle next for multiple guards

              mNext = function mNext(value) {
                // prevent calling next after it is already resolved with a value
                if (changed) return;

                // if we have 'value' reslove next with the value and set changed flag
                if (typeof value != 'undefined') {
                  changed = true;
                  next(value);
                }
              };

              // call guards


              i = 0;

            case 3:
              if (!(i < guards.length)) {
                _context.next = 11;
                break;
              }

              if (!changed) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('break', 11);

            case 6:
              _context.next = 8;
              return guards[i](to, from, mNext);

            case 8:
              i++;
              _context.next = 3;
              break;

            case 11:

              // move on if none of guards resolved next with a value
              if (!changed) next();

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/loading.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  props: {},
  components: {},
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6428c8d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/loading.vue
var loading_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var loading_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg_load" }, [
      _c("img", {
        staticClass: "loadScreen imgLoad",
        attrs: { src: __webpack_require__("vp/L") }
      })
    ])
  }
]
loading_render._withStripped = true
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var lib_loading = (loading_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6428c8d2", loading_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/lib/loading.vue
var loading_disposed = false
function loading_injectStyle (ssrContext) {
  if (loading_disposed) return
  __webpack_require__("8gwm")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = "data-v-6428c8d2"
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  lib_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)
loading_Component.options.__file = "src/components/lib/loading.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6428c8d2", loading_Component.options)
  } else {
    hotAPI.reload("data-v-6428c8d2", loading_Component.options)
  }
  module.hot.dispose(function (data) {
    loading_disposed = true
  })
})()}

/* harmony default export */ var components_lib_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/center-container.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var center_container = ({
  name: 'center-container'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-896ab43a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/center-container.vue
var center_container_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "center-container" }, [_vm._t("default")], 2)
}
var center_container_staticRenderFns = []
center_container_render._withStripped = true
var center_container_esExports = { render: center_container_render, staticRenderFns: center_container_staticRenderFns }
/* harmony default export */ var lib_center_container = (center_container_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-896ab43a", center_container_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/lib/center-container.vue
var center_container_disposed = false
function center_container_injectStyle (ssrContext) {
  if (center_container_disposed) return
  __webpack_require__("Ry4p")
}
var center_container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var center_container___vue_template_functional__ = false
/* styles */
var center_container___vue_styles__ = center_container_injectStyle
/* scopeId */
var center_container___vue_scopeId__ = "data-v-896ab43a"
/* moduleIdentifier (server only) */
var center_container___vue_module_identifier__ = null
var center_container_Component = center_container_normalizeComponent(
  center_container,
  lib_center_container,
  center_container___vue_template_functional__,
  center_container___vue_styles__,
  center_container___vue_scopeId__,
  center_container___vue_module_identifier__
)
center_container_Component.options.__file = "src/components/lib/center-container.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-896ab43a", center_container_Component.options)
  } else {
    hotAPI.reload("data-v-896ab43a", center_container_Component.options)
  }
  module.hot.dispose(function (data) {
    center_container_disposed = true
  })
})()}

/* harmony default export */ var components_lib_center_container = (center_container_Component.exports);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/js/bootstrap.js
var bootstrap = __webpack_require__("K3J8");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__("fhbW");

// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var vue_fontawesome_index_es = __webpack_require__("1e6/");

// EXTERNAL MODULE: ./node_modules/vue-headful/dist/vue-headful.js
var vue_headful = __webpack_require__("WiKS");
var vue_headful_default = /*#__PURE__*/__webpack_require__.n(vue_headful);

// EXTERNAL MODULE: ./src/utils/vee-validate/index.js
var vee_validate = __webpack_require__("byWf");

// EXTERNAL MODULE: ./node_modules/vue-sweetalert2/src/index.js
var src = __webpack_require__("oYt9");

// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto = __webpack_require__("bm7V");
var vue_scrollto_default = /*#__PURE__*/__webpack_require__.n(vue_scrollto);

// EXTERNAL MODULE: ./node_modules/vue-moment/dist/vue-moment.js
var vue_moment = __webpack_require__("8AgW");
var vue_moment_default = /*#__PURE__*/__webpack_require__.n(vue_moment);

// EXTERNAL MODULE: ./node_modules/@chenfengyuan/vue-countdown/dist/vue-countdown.js
var vue_countdown = __webpack_require__("aCbg");
var vue_countdown_default = /*#__PURE__*/__webpack_require__.n(vue_countdown);

// EXTERNAL MODULE: ./node_modules/v-viewer/dist/v-viewer.js
var v_viewer = __webpack_require__("EAZf");
var v_viewer_default = /*#__PURE__*/__webpack_require__.n(v_viewer);

// EXTERNAL MODULE: ./node_modules/vue-paypal-checkout/dist/vue-paypal-checkout.esm.js
var vue_paypal_checkout_esm = __webpack_require__("PH4i");

// EXTERNAL MODULE: ./node_modules/vue-recaptcha-v3/dist/ReCaptchaVuePlugin.js
var ReCaptchaVuePlugin = __webpack_require__("oHEs");
var ReCaptchaVuePlugin_default = /*#__PURE__*/__webpack_require__.n(ReCaptchaVuePlugin);

// EXTERNAL MODULE: ./node_modules/vue-load-script-plus/index.js
var vue_load_script_plus = __webpack_require__("1gqv");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vue-numeral-filter/dist/vue-numeral-filter.es.js
var vue_numeral_filter_es = __webpack_require__("gu9R");

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral_numeral = __webpack_require__("ViqS");
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral_numeral);

// EXTERNAL MODULE: ./node_modules/vue-filter-number-format/dist/vue-filter-number-format.esm.min.js
var vue_filter_number_format_esm_min = __webpack_require__("BLOL");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// IE EXPLORER NEEDS


















//import VueAnalytics from 'vue-analytics'


vue_esm["a" /* default */].component(vue_countdown_default.a.name, vue_countdown_default.a);


vue_esm["a" /* default */].use(v_viewer_default.a);
v_viewer_default.a.setDefaults({
  fullscreen: true,
  inline: false
});


vue_esm["a" /* default */].component('paypal-checkout', vue_paypal_checkout_esm["a" /* default */]);
vue_esm["a" /* default */].component('billing-page', vue_paypal_checkout_esm["a" /* default */]);


vue_esm["a" /* default */].use(ReCaptchaVuePlugin["VueReCaptcha"], {
  siteKey: '6Le9jeQUAAAAABWhlGbyFaHC2X4EpmKwQZIryQbV', //6Le9jeQUAAAAAOnPo0iTqQHNA_IQiB4I9WFEXYvI
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: true
  }
});


vue_esm["a" /* default */].use(vue_load_script_plus["a" /* default */]);

//Vue.use(VueAnalytics, {
//  id: 'UA-49774803-10',
//  router
//})

vue_esm["a" /* default */].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-ST09WDML37" }
}, router);

// VUE MOMENT
vue_esm["a" /* default */].use(vue_moment_default.a);

// Scroll TO
vue_esm["a" /* default */].use(vue_scrollto_default.a);

// SWEET ALERT 2
vue_esm["a" /* default */].use(src["a" /* default */]);

// HEAD DATA PLUGIN
vue_esm["a" /* default */].component('vue-headful', vue_headful_default.a);
// FONT AWEASOME PLUGIN
vue_esm["a" /* default */].component('font-awesome-icon', vue_fontawesome_index_es["a" /* FontAwesomeIcon */]);

// LOADSCREEN
vue_esm["a" /* default */].component('loading', components_lib_loading);
// CENTER CONTAINER
vue_esm["a" /* default */].component('center-container', components_lib_center_container);

vue_esm["a" /* default */].config.productionTip = false;

// ADD AWEASOME ICOMS:
index_es["c" /* library */].add(free_solid_svg_icons_index_es["E" /* faSpinner */], free_solid_svg_icons_index_es["b" /* faArrowLeft */], free_solid_svg_icons_index_es["c" /* faArrowRight */], free_solid_svg_icons_index_es["v" /* faInfoCircle */], free_solid_svg_icons_index_es["n" /* faEye */], free_solid_svg_icons_index_es["s" /* faGift */], free_solid_svg_icons_index_es["j" /* faEdit */], free_solid_svg_icons_index_es["u" /* faHeadset */], free_solid_svg_icons_index_es["k" /* faEnvelope */], free_solid_svg_icons_index_es["L" /* faUserCheck */], free_solid_svg_icons_index_es["J" /* faUniversity */], free_solid_svg_icons_index_es["a" /* faArchive */], free_solid_svg_icons_index_es["z" /* faPrint */], free_solid_svg_icons_index_es["r" /* faFilePdf */], free_solid_svg_icons_index_es["I" /* faTrashRestoreAlt */], free_solid_svg_icons_index_es["F" /* faStarOfLife */], free_solid_svg_icons_index_es["o" /* faFileAlt */], free_solid_svg_icons_index_es["f" /* faCheck */], free_solid_svg_icons_index_es["d" /* faBalanceScale */], free_solid_svg_icons_index_es["l" /* faEuroSign */], free_solid_svg_icons_index_es["i" /* faClipboardList */], free_solid_svg_icons_index_es["p" /* faFileDownload */], free_solid_svg_icons_index_es["m" /* faExclamationTriangle */], free_solid_svg_icons_index_es["h" /* faClipboardCheck */], free_solid_svg_icons_index_es["B" /* faSearch */], free_solid_svg_icons_index_es["K" /* faUser */], free_solid_svg_icons_index_es["x" /* faPhoneVolume */], free_solid_svg_icons_index_es["y" /* faPlusCircle */], free_solid_svg_icons_index_es["w" /* faMinus */], free_solid_svg_icons_index_es["G" /* faTimesCircle */], free_solid_svg_icons_index_es["H" /* faTrashAlt */], free_solid_svg_icons_index_es["g" /* faCheckCircle */], free_solid_svg_icons_index_es["q" /* faFileInvoice */], free_solid_svg_icons_index_es["A" /* faReceipt */], free_solid_svg_icons_index_es["M" /* faWineBottle */], free_solid_svg_icons_index_es["e" /* faCamera */], free_solid_svg_icons_index_es["C" /* faShippingFast */], free_solid_svg_icons_index_es["t" /* faGlobe */], free_solid_svg_icons_index_es["D" /* faShoppingCart */]);






//import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
//import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
__webpack_require__("6A3X");

vue_esm["a" /* default */].use(vue_numeral_filter_es["a" /* default */], { locale: 'it' });

vue_esm["a" /* default */].filter("formatNumber", function (value) {
  var value = parseFloat(value);
  return numeral_default()(value).format("0.0,[00]"); // displaying other groupings/separators is possible, look at the docs
});

vue_esm["a" /* default */].filter("formatNumberNoDecimals", function (value) {
  var value = parseFloat(value);
  return numeral_default()(value).format("0,[]"); // displaying other groupings/separators is possible, look at the docs
});

vue_esm["a" /* default */].use(vee_validate["a" /* default */].core, vee_validate["a" /* default */].config);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store["a" /* default */],
  Loading: components_lib_loading,
  template: '<App/>',
  components: { App: src_App }

});

/***/ }),

/***/ "NdTM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/more.3cf5266.jpg";

/***/ }),

/***/ "OBAr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-03a5036f] {\n  font-size: 26px;\n}\n.imageIcons[data-v-03a5036f] {\n\t\tvertical-align: bottom!important;\n\t\twidth: 50px;\n}\n.hSize[data-v-03a5036f] {\n    font-size: 33px!important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-03a5036f] {\n\t\tmax-width: 333px;\n\t\ttext-align: left;\n\t\tmargin: 0 auto;\n\t\tline-height: 27px;\n\t\tpadding-left: 61px;\n}\n\n\n\t/* new PRICE */\n.swal2-popup .swal2-title[data-v-03a5036f], #swal2-content[data-v-03a5036f] {\n\t\tcolor: #fffbde!important;\n\t\tdisplay: block!important;\n}\n.replaceButton[data-v-03a5036f]{\n\t\tmax-width: 40px;\n}\n.inputHelper[data-v-03a5036f]{\n    margin-top: -32px;\n    color: #0e3d8b;\n    font-size: 16px;\n    left: 0;\n}\n.priceVal[data-v-03a5036f], .priceCent[data-v-03a5036f]{\n\t\twidth: calc(50% - 1.5vw - 7.5px);\n\t\tdisplay: inline-table;\n}\n.pseudoEuro[data-v-03a5036f] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n}\n.pseudoCent[data-v-03a5036f] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n\t\tright:0;\n}\n.group input:focus + .pseudoEuro[data-v-03a5036f] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoEuro[data-v-03a5036f]{\n\t\tdisplay:block;\n}\n.group input:focus + .pseudoCent[data-v-03a5036f] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoCent[data-v-03a5036f]{\n\t\tdisplay:block;\n}\n.euroInput[data-v-03a5036f]{\n\t\tposition: relative;\n\t\twidth:200%;\n\t\tz-index: 4;\n}\n.euroInput[data-v-03a5036f]::before{\n\t\tcontent: 'Euro';\n}\n.euroInput[data-v-03a5036f]:focus, .euroInput.valid[data-v-03a5036f]{\n\t\twidth:100%;\n}\n.euroInput[data-v-03a5036f]:focus::before, .euroInput.valid[data-v-03a5036f]::before{\n\t\tcontent: 'Euro';\n\t\tcolor: white;\n\t\tposition: absolute;\n}\n.table[data-v-03a5036f]{\n\t\tdisplay: table;\n}\n.newPriceLabel[data-v-03a5036f]{\n\t\tz-index: 5;\n\t\tbackground: white;\n\t\tmargin-left: -5px;\n\t\tpadding-left: 5px;\n\t\toverflow: initial;\n\t\tmin-width: calc(200% + 17px);\n}\n\n\n\t/*  ------------ */\n.image-margin0[data-v-03a5036f]{\n\t\tmargin: 0!important;\n}\n.helper[data-v-03a5036f]{\n\t\tcolor: #0e3d8b;\n\t\tfont-size: 23px;\n\t\tfont-family: Oswald-Medium;\n}\n.greyDesc2[data-v-03a5036f]{\n\t\tfont-size: 1.1vw;\n\t\tcolor: #fffbde;\n}\n.redDesc[data-v-03a5036f]{\n\t\tfont-size: 1.1vw;\n\t\ttext-decoration: underline;\n\t\tcursor: pointer;\n}\n.uploadDone[data-v-03a5036f] {\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\tright: 0;\n\t\tcolor: #a1614f;\n}\n.helperUnderline[data-v-03a5036f] {\n}\n.labelFileInput[data-v-03a5036f]{\n\t\ttop: -20px!important;\n\t\tfont-size: 22px;\n\t\tcolor: #000000;\n}\n.fileInput[data-v-03a5036f]{\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\ttop: 17px;\n\t\tborder-bottom: none;\n\t\tcolor: #000000;\n}\n.fileInputLabel[data-v-03a5036f]{\n\t\tz-index: 3;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\tpadding-right: 20px;\n\t\ttext-overflow: ellipsis;\n\t\tcolor: #fffbde;\n}\n.removeProduct[data-v-03a5036f]{\n\t\tposition: absolute;\n\t\tright: 21px;\n\t\tmargin: 0px!important;\n\t\ttop: 48px;\n\t\tcolor: #e7201d;\n}\n.typeDisabled[data-v-03a5036f]{\n\t\tcolor: #676767;\n\t\tcursor: pointer;\n}\n.typeSelected[data-v-03a5036f] {\n\t\tcolor: #fffbde!important;\n\t\tcursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-03a5036f] {\n      margin-top: -12px;\n      color: #0e3d8b;\n      font-size: 16px;\n      left: 0;\n}\n.hSize[data-v-03a5036f] {\n      font-size: 19px!important;\n}\n.sweetText[data-v-03a5036f] {\n      font-size: 19px;\n}\n.removeProduct[data-v-03a5036f]{\n    position: absolute;\n    right: 21px;\n    margin: 0px!important;\n    top: 26px;\n    color: #e7201d;\n}\n.greyDesc2[data-v-03a5036f], .redDesc[data-v-03a5036f]{\n\t\t\tfont-size: 3.1vw;\n}\n.fluid[data-v-03a5036f] {\n\t\t\tmax-width: 107px;\n}\n.mobTQ[data-v-03a5036f]{\n\t\t\tfont-size: 23px;\n}\n.smMob[data-v-03a5036f]{\n\t\t\tfont-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-03a5036f] {\n\t\t\tmax-width: 350px;\n\t\t\ttext-align: left;\n\t\t\tmargin: 0 auto;\n\t\t\tline-height: 27px;\n\t\t\tpadding-left: 43px;\n\t\t\tfont-size: 17px;\n}\n.helper[data-v-03a5036f] {\n\t\t\tcolor: #0e3d8b;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: Oswald-Medium;\n}\n.imageIcons[data-v-03a5036f] {\n\t\t\tvertical-align: bottom!important;\n\t\t\twidth: 39px;\n}\n.fileInput[data-v-03a5036f] {\n\n\t\t\ttop: 8px!important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-03a5036f]{\n\t\t\t top: -250%;\n}\n}\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "OJIF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/area.8a7939a.jpg";

/***/ }),

/***/ "P/cV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("MoJE");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("898b2cbc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-777bab22\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./address.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-777bab22\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./address.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "PCb9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.regulationContainer[data-v-665f5baa]{\n\tfont-size: 18px;\n}\n.page__title[data-v-665f5baa]{\n\tfont-size: 18px!important;\n\tfont-weight: 800;\n}\n.navigation[data-v-665f5baa] {\n\tposition: fixed;\n\tbottom: 0;\n\tbackground: #fffbde;\n\tcolor: #8a222f;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 5px;\n\tfont-size: 22px;\n\ttext-align: center;\n}\n.navItem[data-v-665f5baa] {\n\tmargin: 10px;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.regulationContainer[data-v-665f5baa]{\n\t\tfont-size: 14px;\n}\n.col-md-4.text-right[data-v-665f5baa]{\n\t\ttext-align: left!important;\n}\n.navigation[data-v-665f5baa] {\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "QCBm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Tayt");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3b3ed8a3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1eacecb2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1eacecb2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "QHXV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("XKjK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6b362660", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c3e6f9a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./stripe.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c3e6f9a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./stripe.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "RH4N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/howplayBack.befa379.jpg";

/***/ }),

/***/ "Rb+6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/callcenterHSD.81e9192.jpg";

/***/ }),

/***/ "RhT6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.badger-toggle-indicator[data-v-d8b643a0] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),

/***/ "Ry4p":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3Gu/");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b7bbfb9c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-896ab43a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./center-container.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-896ab43a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./center-container.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Rzk4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-54242612] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-54242612] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-54242612] {\n  width: 75px;\n}\n.bigTitle[data-v-54242612] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-54242612] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-54242612] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-54242612] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-54242612] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-54242612] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-54242612] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-54242612] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-54242612] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-54242612] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 177px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-54242612] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-54242612] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-54242612] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-54242612] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-54242612] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-54242612] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-54242612]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-54242612] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-54242612] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-54242612]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-54242612]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-54242612]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-54242612] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-54242612] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-54242612] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "SwIb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.errorIcon[data-v-48050120] {\n  max-width: 150px;\n  margin: 0 auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "TMYC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/callcenter.54d0313.jpg";

/***/ }),

/***/ "Ta3C":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAC9CAYAAABBJgiOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABGdJREFUeNrsneFR6kAURiNjAXYgJWgHWoFagXQAVCBWEKggYwXPDtAKsAOhAzrg5XN0RkMSSLLL3iTnzOTHc3xLzGHv3ezeZKMIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABscWbsfO7TY9xjH+/pMbN2UqP02HF8XYdoYEhKQgD7YmhFDFJyGCAFMZWlLJfLaLfbdfbQ32dNDD3FYI9BikExhVKurq6w8YtzC1KSJIk2m0308fGBkRP3mFIpo9EIEwHEIMWgGKQYFIMUg2KQYnBUFlyKRnfb7TbIBb25uTEpxkRPmU6n0dvbWxAxmmqxFsoIXwZDmRcp+uZfXFyU/k7ZRGDfxXjrKX2eCRhYlcJwGSmdEoMUgznmZFK0FHAo+SMmQE+J49jZDVuXQxnhy6AYpBgUgxSDYpBiMPkHl8KUjNGewpQM4ct8jymUops9lRg9Pz97OZFQ6ydtEHMflVRIKqxQ9xVGjLknuRQ2h8Mhocwa4/G4t6WzA6snpt7S53rmc4v3CLp36XuReamYvs7sEsrAXfI/O7P1agBXdVz0GEAMYgAxJH9j9zaIOUAb7m0eHx9bfw923sVvWxfWjMgxiAHvoUyP0bFo5jcH1xIjKbe3t1jIweKjfkCOQQwgBhonfy37MjVjUIzW5Fl2JpQhBhADPnIMUzLFMCVjFKZkyDGAGEBMJ0dlGnl0tTSVHgOIQQwghuSfw3q9jl5eXrh6OTw9PTlvUytff/ZkLGK5XLJfZcFRhYLrOCOUkWMAMYgBc6MypmToMYgBxABiepb8VYyhN7xCzvSJo9Lh2uVLvMOSUIYYQAz4yDE8hmFUDA8uEcroMcfCMLkeVd+MW1kMVf71UE6uEv4JZeQYQExfh8t10K4Wx7zgTROkqlvLe5Tw2DY0QNH/15xeEXV22pjNZkEkHVVXFtWst0qTX+Waq3Qk06iNJEn22vg51H5Vogb1Znnn3sq6sp9RTJMtfdUrVqtVK7cFDvZOzN9PPiuk5IUVjfsnk0lhCPndRtG+zGpXgq+vrw+G0LLQF5KThrK8bpxexF36Df/ze5+fn5XbiON477zT3lMaytR25LF0ttWhTEn/4eFh7xtftQ2trs7n8z8/1+5NDJcbynHBYrHYC4ttyjXmxCinuBKcHXK3aRenYMk/b03n7u5uT8zr62ujAUb2MwsT7IF5rFPvmxNMzLFrOtmQ1PQzm4hmSuYb7VLb12UGk+/217daPcW1lLL2NJKz9EapYGKyRYM+XrVVJdnrsy31zqB3/j4vRHZ43LYixc5O+6d3/85Gd+QYB0Nu/Vsb+2RnDHxtd4+YBkNuSXE1o0Aoc4TmzEItcPW2xxSh3qFE38aecnIxulBNpzVctPGD9TIsijEQA4jpAJVzTBtHOBa4vLz0K8bH+7iAUIYYQAxiwMiojIeU/FJW+Vkqhsf6CGVQImbN5bAR4bI/0AL5XmE5x0mPf98eAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKDP/BdgAE40KXXfZX+LAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Tayt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.redHSDBack[data-v-1eacecb2]{\n  background: #d40c2d;\n}\n.custNavWidth[data-v-1eacecb2]{\n\n  max-width: 240px;\n}\n.contactImg[data-v-1eacecb2] {\n    width: 47px;\n    -webkit-transform: rotate(62deg);\n            transform: rotate(62deg);\n}\n.sidebar-opened[data-v-1eacecb2] {\n\tright: 0;\n\t-webkit-animation: open;\n\t        animation: open;\n\t-webkit-animation-duration: 0.5s;\n\t        animation-duration: 0.5s;\n\t-webkit-animation-timing-function: ease;\n\t        animation-timing-function: ease;\n}\n.dropdown-toggle[data-v-1eacecb2]{\n\tmargin-top: 0px!important;\n\tmargin-bottom: 0px!important;\n}\n.sidetab > .label[data-v-1eacecb2] {\n    cursor: pointer;\n    border: 1px solid #9898ab;\n    font-size: 17px!important;\n    padding-top: 15px!important;\n\t\tcolor: #fdfdfd;\n\t\theight: 60px;\n\t\tfont-size: 21px;\n\t\tfont-weight: bold;\n\t\tbackground: #00917e;\n    text-transform: uppercase;\n    text-align: center;\n    padding-top: 3px;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-box-shadow: 0 0 8px #262626;\n    box-shadow: 0 0 8px #262626;\n}\n.sidebar-opened > .label > .contactImg[data-v-1eacecb2]{\n\topacity: 0;\n}\n.tabMobile > .label[data-v-1eacecb2]{\n\tbackground: transparent;\n\tpadding-top: 0px!important;\n}\n.sidebar-opened > .label[data-v-1eacecb2]{\n\tbackground-color: #101417;\n\theight: 48px;\n\tcolor: transparent;\n}\n.content[data-v-1eacecb2] {\n    height: 240px;\n    padding-left: 39px;\n    padding-top: 31px;\n}\n.content[data-v-1eacecb2] {\n    background-color: #F2F2F2;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    padding-bottom: 10px;\n}\n.sidebar-closed[data-v-1eacecb2] {\n    -webkit-animation: close;\n            animation: close;\n    -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n}\n.sidetab[data-v-1eacecb2] {\n    width: 256px;\n    height: 280px;\n\t\tborder-top-left-radius: 50%;\n\t\tborder-top-right-radius: 50%;\n    left: auto;\n    top: 75%;\n    margin-top: -185px;\n    bottom: auto;\n    border-radius: 10px 10px 0 0;\n    -webkit-transform: rotate(-90deg);\n            transform: rotate(-90deg);\n\t\tz-index: 2147483647;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n\n    position: fixed;\n\t\tletter-spacing: 0px !important;\n}\n.sidetab2[data-v-1eacecb2] {\n\tborder-top-left-radius: 50%;\n\tborder-top-right-radius: 50%;\n    right: -223px;\n    -webkit-animation: reveal;\n            animation: reveal;\n    -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n}\n.sidetab2[data-v-1eacecb2] {\n\twidth: 187px;\n\theight: 280px;\n\t\tborder-top-left-radius: 50%;\n\t\tborder-top-right-radius: 50%;\n    left: auto;\n    top: 25%;\n    margin-top: -15px;\n    bottom: auto;\n    border-radius: 10px 10px 0 0;\n    -webkit-transform: rotate(-90deg);\n            transform: rotate(-90deg);\n\t\tz-index: 2147483647;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n\n    position: fixed;\n\t\tletter-spacing: 0px !important;\n}\n.sidetab[data-v-1eacecb2] {\n\tborder-top-left-radius: 50%;\n\tborder-top-right-radius: 50%;\n    right: -223px;\n    -webkit-animation: reveal;\n            animation: reveal;\n    -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n}\n.sidetab2[data-v-1eacecb2] {\n\tborder-top-left-radius: 50%;\n\tborder-top-right-radius: 50%;\n    right: -188px;\n    -webkit-animation: reveal;\n            animation: reveal;\n    -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n}\n.sidetab2 > .label[data-v-1eacecb2] {\n    cursor: pointer;\n    border: 1px solid #9898ab;\n    font-size: 17px!important;\n    padding-top: 15px!important;\n\t\tcolor: #fdfdfd;\n\t\theight: 60px;\n\t\tfont-size: 21px;\n\t\tfont-weight: bold;\n\t\tbackground: #f39324;\n    text-transform: uppercase;\n    text-align: center;\n    padding-top: 3px;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-box-shadow: 0 0 8px #262626;\n    box-shadow: 0 0 8px #262626;\n}\n.sidetab2.container .content[data-v-1eacecb2] {\n    background-color: #F2F2F2;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    padding-bottom: 10px;\n}\n.sidetab2.sidebar-opened[data-v-1eacecb2] {\n    right: 0!important;\n    -webkit-animation: open;\n            animation: open;\n    -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n}\n.media-label[data-v-1eacecb2] {\n    padding: 4px 8px;\n}\n.inner-content[data-v-1eacecb2] {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg);\n\t\theight: 173px;\n}\n.media[data-v-1eacecb2] {\n    width: 215px;\n}\n.content-message[data-v-1eacecb2] {\n    color: rgba(0,0,0,0.54);\n    font-size: 14px;\n    font-weight: 900;\n    text-transform: uppercase;\n    text-align: center;\n    padding: 10px 0;\n\t\twidth: 200px;\n}\n.content-message[data-v-1eacecb2] {\n    padding: 8px 10px;\n}\n.sidetab.container .content[data-v-1eacecb2] {\n    background-color: #F2F2F2;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    padding-bottom: 10px;\n}\n.sidetab.sidebar-opened[data-v-1eacecb2] {\n    right: 0!important;\n    -webkit-animation: open;\n            animation: open;\n    -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n}\n.fa-question-circle[data-v-1eacecb2] {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg);\n\t\tcolor: #e3000f;\nbackground: azure;\nborder-radius: 50%;\n}\n@media (min-width: 20px) and (max-width: 499px) {\n.cookieText[data-v-1eacecb2]{\n    font-size: 14px;\n}\n.cookieBaner[data-v-1eacecb2] {\n\n    height: 350px;\n}\n.notificationContent[data-v-1eacecb2] {\n    position: absolute;\n    z-index: 2;\n    left: 0;\n    top: 65px;\n    background: #eeeeee;\n    width: 100%;\n    overflow: hidden;\n    -webkit-transition: .3s ease !important;\n    transition: .3s ease !important;\n    height: 0px;\n    border-bottom: 10px solid white;\n}\n}\n@media (min-width: 500px) and (max-width: 768px) {\n.cookieText[data-v-1eacecb2]{\n    font-size: 18px;\n}\n.cookieBaner[data-v-1eacecb2] {\n\n    height: 250px;\n}\n.notificationContent[data-v-1eacecb2] {\n    position: absolute;\n    z-index: 2;\n    left: 0;\n    top: 65px;\n    background: #ffd8ab;\n    width: 100%;\n    overflow: hidden;\n    -webkit-transition: .3s ease !important;\n    transition: .3s ease !important;\n    height: 0px;\n    border-bottom: 10px solid white;\n}\n}\n@media (min-width: 769px) and (max-width: 1550px) {\n.cookieText[data-v-1eacecb2]{\n  font-size: 15px;\n}\n}\n#site-nav .navbar-toggler[data-v-1eacecb2] {\n}\n#site-nav .navbar-toggler[data-v-1eacecb2] {\n  border: none!important;\n  background: transparent !important;\n}\n#site-nav .navbar-toggler .icon-bar[data-v-1eacecb2] {\n  width: 22px;\n  -webkit-transition: all 0.2s!important;\n  transition: all 0.2s!important;\n  width: 30px!important;\n  height: 3px!important;\n  display: block;\n  margin: 5px;\n}\n#site-nav .navbar-toggler .top-bar[data-v-1eacecb2] {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  -webkit-transform-origin: 10% 10%!important;\n          transform-origin: 10% 10%!important;\n}\n#site-nav .navbar-toggler .middle-bar[data-v-1eacecb2] {\n  opacity: 0!important;\n}\n#site-nav .navbar-toggler .bottom-bar[data-v-1eacecb2] {\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n  -webkit-transform-origin: 10% 90%!important;\n          transform-origin: 10% 90%!important;\n}\n#site-nav .navbar-toggler.collapsed .top-bar[data-v-1eacecb2] {\n  -webkit-transform: rotate(0)!important;\n          transform: rotate(0)!important;\n}\n#site-nav .navbar-toggler.collapsed .middle-bar[data-v-1eacecb2] {\n  opacity: 1!important;\n}\n#site-nav .navbar-toggler.collapsed .bottom-bar[data-v-1eacecb2] {\n  -webkit-transform: rotate(0)!important;\n          transform: rotate(0)!important;\n}\n.navbar-toggler .icon-bar[data-v-1eacecb2] {\n    background-color: #00897e!important;\n}\n.navbar-toggler[data-v-1eacecb2] {\n  padding: .25rem .75rem;\n  font-size: 1.25rem;\n  line-height: 15;\n  background-color: white;\n  border: 1px solid transparent;\n  border-radius: .25rem;\n\n  margin-top: 10px;\n}\n.btnBurgrHSDRed > .icon-bar[data-v-1eacecb2]{\n    background-color: #c03!important;\n}\n", ""]);

// exports


/***/ }),

/***/ "UH1c":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-f6487464] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-f6487464] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-f6487464] {\n  width: 75px;\n}\n.bigTitle[data-v-f6487464] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-f6487464] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-f6487464] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-f6487464] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-f6487464] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-f6487464] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-f6487464] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-f6487464] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-f6487464] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-f6487464] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 177px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-f6487464] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-f6487464] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-f6487464] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-f6487464] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-f6487464] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-f6487464] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-f6487464]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-f6487464] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-f6487464] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-f6487464]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-f6487464]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-f6487464]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-f6487464] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-f6487464] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-f6487464] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "UdIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UqUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__table_productsTable_vue__ = __webpack_require__("YZMT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4__ = __webpack_require__("jCvU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_datatables_net_buttons_js_dataTables_buttons_js__ = __webpack_require__("122j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_datatables_net_buttons_js_dataTables_buttons_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_datatables_net_buttons_js_dataTables_buttons_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_datatables_net_buttons_js_buttons_html5_js__ = __webpack_require__("wtxW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_datatables_net_buttons_js_buttons_html5_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_datatables_net_buttons_js_buttons_html5_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_datatables_net_buttons_js_buttons_print_js__ = __webpack_require__("Wqz6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_datatables_net_buttons_js_buttons_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_datatables_net_buttons_js_buttons_print_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_datatables_net_buttons_bs4__ = __webpack_require__("BJHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_datatables_net_buttons_bs4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_datatables_net_buttons_bs4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_datatables_net_select_bs4__ = __webpack_require__("urWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_datatables_net_select_bs4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_datatables_net_select_bs4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_datatables_net_select_bs4_css_select_bootstrap4_min_css__ = __webpack_require__("7N6W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_datatables_net_select_bs4_css_select_bootstrap4_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_datatables_net_select_bs4_css_select_bootstrap4_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_datatables_net_buttons_bs4_css_buttons_bootstrap4_min_css__ = __webpack_require__("r20c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_datatables_net_buttons_bs4_css_buttons_bootstrap4_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_datatables_net_buttons_bs4_css_buttons_bootstrap4_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import Datepicker from 'vuejs-datepicker'
//import {it} from 'vuejs-datepicker/dist/locale'
//import VueTimepicker from 'vue2-timepicker'




// import buttons and plugins



// import the rest






var moment = __webpack_require__("PJh5");

var _vue = this;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'users',
	components: {
		//Datepicker,
		//VueTimepicker,
		VdtnetTable: __WEBPACK_IMPORTED_MODULE_6__table_productsTable_vue__["a" /* default */]
	},
	//props: ["fields"],
	data: function data() {
		var _this = this;

		//const vm = this
		//const compiler = require('vue-template-compiler')
		return {
			loadingState: false,
			loaded: false,
			userToken: '',
			company: '',
			//username: '',
			//it: it,
			eventName: '',
			objectMail: '',
			sms: '',
			smsSender: '',
			json: {},
			textMail: '',
			eventDescription: '',
			_vue: this,
			//role: '',
			nome: '',
			password: '',
			active: 0,
			id: 0,
			rows: {},
			url: "https://wsbot.eu/21005back/public/" + 'api/loadProducts?id=' + this.$route.params.id,
			routeParam: this.$route.params.id,
			options: {
				ajax: {
					url: "https://wsbot.eu/21005back/public/" + 'api/loadProducts?id=' + this.$route.params.id,
					headers: {
						'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
						'Content-type': 'application/json'
					},
					type: 'GET',
					dataSrc: function dataSrc(json) {
						//this.buildFields(json)
						if (_this.$route.params.id) {
							return json.data;
						} else {
							return false;
						}
					}
				},
				buttons: [
					//'copy',
					//'print',
					//{
					//	 text: 'CSV',
					//	 extend: 'csv',
					//	 fieldSeparator: ';',
					//	 extension: '.csv'
					// }
					//{
					//	 text: 'Aggiungi utente',
					//	 action: function ( e, dt, node, config ) {
					//	  	_vue.a.methods.addUser( _vue.a, dt )
					//   }

					//},

				],
				/*eslint-disable */
				dom: "Btr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",
				/*eslint-enable */
				responsive: true,
				processing: true,
				searching: true,
				searchDelay: 1500,
				destroy: true,
				ordering: true,
				lengthChange: true,
				serverSide: true,
				fixedHeader: true,
				saveState: true
			},
			fields: {
				confirmed: {
					label: 'Esito',
					sortable: true,
					searchable: true,
					render: function render(data, display, row) {

						if (data == 0) {
							return ' In Verifica ';
						}

						if (data == 1) {
							return ' Approvato ';
						}

						if (data == 2) {
							return ' Respinto <br/> <small> ' + row.confirm_info + '</small>';
						}

						if (data == 3) {
							if (row.confirm_info == 'finish') {
								return ' Documentazione non verificata per soglia premi/agenzia raggiunta ';
							}
							if (row.confirm_info == 'finish_award') {
								return ' Documentazione non verificata - obiettivo raggiunto ';
							}
						}
					}
				},
				credits: {
					label: 'Valore',
					sortable: true,
					searchable: true,
					render: function render(data, display, row) {

						if (data == 1) {
							return ' 25% del premio ';
						}

						if (data == 2) {
							return ' 50% del premio ';
						}
					}
				},
				azienda: { label: 'Azienda', sortable: true, searchable: true },
				partita_iva: { label: 'Partita IVA', sortable: true, searchable: true },
				codice_fiscale: { label: 'Codice Fiscale', sortable: true, searchable: true },

				barcode: {
					label: 'Matricola',
					sortable: true,
					searchable: true,
					render: function render(data, display, row) {
						return ' <a class="simpleLink green" target="_blank" href="' + row.image + '"> <small>' + data + '</small> </a> ';
					}
				},
				product: { label: 'Prodotto', sortable: true, searchable: true },

				invoice_number: {
					label: 'Prova d`acquisto',
					sortable: true,
					searchable: true,
					render: function render(data, display, row) {
						return ' <a class="simpleLink green" target="_blank" href="' + row.invoice + '"> <small>' + data + '</small> </a> ';
					}
				},

				invoice_date: { label: 'Data Doc.', sortable: true, searchable: true }

			},
			quickSearch: '',
			details: {},
			customTheme: {
				logo: "https://storage.googleapis.com/novatagstage/logo_custom.png",
				background: "https://storage.googleapis.com/novatagstage/custom_background.jpg",
				textColor: "#fff",
				windowColor: "#000000e0"
			}
		};
	},

	methods: {
		doLoadTable: function doLoadTable(cb) {},
		doAlertEdit: function doAlertEdit(data) {
			window.alert('row edit click for item ID: ' + data.id);
		},
		doAfterReload: function doAfterReload(data, table) {},
		doCreating: function doCreating(comp, el) {},
		doCreated: function doCreated(comp) {},
		doSearch: function doSearch() {
			this.$refs.table.search(this.quickSearch);
		},
		doExport: function doExport(type) {
			var parms = this.$refs.table.getServerParams();
			parms.export = type;
			window.alert('GET /api/v1/export?' + jQuery.param(parms));
		},
		formatCode: function formatCode(zipcode) {
			return zipcode.split('-')[0];
		},
		loadRegistrationData: function loadRegistrationData() {
			var _vue = this;
			var fields = {};

			var data = { getFieldsNames: true };

			_vue.loadingState = true;
			__WEBPACK_IMPORTED_MODULE_4_axios___default()({
				url: "https://wsbot.eu/21005back/public/" + 'api/loadProducts?id=' + this.$route.params.id,
				method: 'POST',
				headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' },
				data: data
			}).then(function (resp) {
				_vue.loadingState = false;
				_vue.rows = resp.data;
				//console.log(_vue.rows)
				for (var x in _vue.rows) {
					fields[_vue.rows[x].db] = { label: '' + _vue.rows[x].db + '' };
				}
				//console.log(fields)
				_vue.fields = fields;
				var table = _vue.$refs.table;
				console.log(table);
				//table.dataTable.destroy()
				//table.dataTable.fields = fields
				table.dataTable.init();
				table.dataTable.draw(false);
				table.dataTable.columns.adjust();
				table.reload();
			}).catch(function (resp) {
				_vue.loadingState = false;
				console.log(resp);
			});
		}
	},
	watch: {
		'$route.params.id': {
			handler: function handler(id) {
				console.log(id);
				if (this.loaded) {
					//window.location.reload()
				}
			},
			deep: true,
			immediate: true
		},
		getProfile: function getProfile() {
			var _vue = this;
			_vue.id = _vue.$route.params.id;
			setTimeout(function () {
				_vue.id = _vue.$route.params.id;
				_vue.loaded = true;
			}, 1000);
		}
	},
	created: function created() {
		var _this2 = this;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							if (!_this2.$route.params.id) {
								_context.next = 5;
								break;
							}

							_context.next = 3;
							return _this2.loadRegistrationData();

						case 3:
							_context.next = 6;
							break;

						case 5:
							_this2.$router.push('/');

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this2);
		}))();
	},


	mounted: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
			var _this3 = this;

			var _vue;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_vue = this;

							this.id = this.$route.params.id;

							if (!this.$route.params.id) {
								_context2.next = 7;
								break;
							}

							_context2.next = 5;
							return this.loadRegistrationData();

						case 5:
							_context2.next = 8;
							break;

						case 7:
							this.$router.push('/');

						case 8:

							setTimeout(function () {
								_vue.loaded = true;
							}, 1000);

							window.onresize = function () {
								_this3.vw = window.innerWidth;
							};

						case 10:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function mounted() {
			return _ref.apply(this, arguments);
		}

		return mounted;
	}(),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['tappa', 'isAuthenticated', 'authStatus', 'tappa', 'getProfile']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
		authLoading: function authLoading(state) {
			return state.auth.status === 'loading';
		},
		profile: function profile(state) {
			return state.user.profile;
		}
	}))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "UuNy":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("pDSP"), "");

// module
exports.push([module.i, "\n", ""]);

// exports


/***/ }),

/***/ "VwWl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Rzk4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("475d1210", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-54242612\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./practicesinWork.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-54242612\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./practicesinWork.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "X6x5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/regitem.aceeb88.jpg";

/***/ }),

/***/ "XKjK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nform[data-v-4c3e6f9a] {\n  width: 30vw;\n  min-width: 500px;\n  -ms-flex-item-align: center;\n      align-self: center;\n  -webkit-box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n          box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n  border-radius: 7px;\n  padding: 40px;\n}\ninput[data-v-4c3e6f9a] {\n  border-radius: 6px;\n  margin-bottom: 6px;\n  padding: 12px;\n  border: 1px solid rgba(50, 50, 93, 0.1);\n  height: 44px;\n  font-size: 16px;\n  width: 100%;\n  background: white;\n}\n.result-message[data-v-4c3e6f9a] {\n  line-height: 22px;\n  font-size: 16px;\n}\n.result-message a[data-v-4c3e6f9a] {\n  color: rgb(89, 111, 214);\n  font-weight: 600;\n  text-decoration: none;\n}\n.hidden[data-v-4c3e6f9a] {\n  display: none;\n}\n#card-error[data-v-4c3e6f9a] {\n  color: rgb(105, 115, 134);\n  text-align: left;\n  font-size: 13px;\n  line-height: 17px;\n  margin-top: 12px;\n}\n#card-element[data-v-4c3e6f9a] {\n  border-radius: 4px 4px 0 0 ;\n  padding: 12px;\n  border: 1px solid rgba(50, 50, 93, 0.1);\n  height: 44px;\n  width: 100%;\n  background: white;\n}\n#payment-request-button[data-v-4c3e6f9a] {\n  margin-bottom: 32px;\n}\n/* Buttons and links */\nbutton[data-v-4c3e6f9a] {\n  background: #5469d4;\n  color: #ffffff;\n  font-family: Arial, sans-serif;\n  border-radius: 0 0 4px 4px;\n  border: 0;\n  padding: 12px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  display: block;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  -webkit-box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\n          box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\n  width: 100%;\n}\nbutton[data-v-4c3e6f9a]:hover {\n  -webkit-filter: contrast(115%);\n          filter: contrast(115%);\n}\nbutton[data-v-4c3e6f9a]:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n/* spinner/processing state, errors */\n.spinner[data-v-4c3e6f9a],\n.spinner[data-v-4c3e6f9a]:before,\n.spinner[data-v-4c3e6f9a]:after {\n  border-radius: 50%;\n}\n.spinner[data-v-4c3e6f9a] {\n  color: #ffffff;\n  font-size: 22px;\n  text-indent: -99999px;\n  margin: 0px auto;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  -webkit-box-shadow: inset 0 0 0 2px;\n          box-shadow: inset 0 0 0 2px;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n}\n.spinner[data-v-4c3e6f9a]:before,\n.spinner[data-v-4c3e6f9a]:after {\n  position: absolute;\n  content: \"\";\n}\n.spinner[data-v-4c3e6f9a]:before {\n  width: 10.4px;\n  height: 20.4px;\n  background: #5469d4;\n  border-radius: 20.4px 0 0 20.4px;\n  top: -0.2px;\n  left: -0.2px;\n  -webkit-transform-origin: 10.4px 10.2px;\n  transform-origin: 10.4px 10.2px;\n  -webkit-animation: loading-data-v-4c3e6f9a 2s infinite ease 1.5s;\n  animation: loading-data-v-4c3e6f9a 2s infinite ease 1.5s;\n}\n.spinner[data-v-4c3e6f9a]:after {\n  width: 10.4px;\n  height: 10.2px;\n  background: #5469d4;\n  border-radius: 0 10.2px 10.2px 0;\n  top: -0.1px;\n  left: 10.2px;\n  -webkit-transform-origin: 0px 10.2px;\n  transform-origin: 0px 10.2px;\n  -webkit-animation: loading-data-v-4c3e6f9a 2s infinite ease;\n  animation: loading-data-v-4c3e6f9a 2s infinite ease;\n}\n@-webkit-keyframes loading-data-v-4c3e6f9a {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes loading-data-v-4c3e6f9a {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@media only screen and (max-width: 600px) {\nform[data-v-4c3e6f9a] {\n    width: 80vw;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "Xwnd":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "YABF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-e4b69a2e] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-e4b69a2e] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-e4b69a2e] {\n  width: 75px;\n}\n.bigTitle[data-v-e4b69a2e] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-e4b69a2e] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-e4b69a2e] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: .4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-e4b69a2e] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-e4b69a2e] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-e4b69a2e] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-e4b69a2e] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-e4b69a2e] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-e4b69a2e] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-e4b69a2e] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-e4b69a2e] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-e4b69a2e] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-e4b69a2e] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-e4b69a2e] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-e4b69a2e] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important;\n    left: 0;\n}\n.front-image > label > span[data-v-e4b69a2e] {\n      background-color: #dee6ff;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: 1px solid white;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-e4b69a2e]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-e4b69a2e] {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-e4b69a2e] {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n.front-image > label[data-v-e4b69a2e]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-e4b69a2e]:after {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-e4b69a2e]:after {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-e4b69a2e] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin-bottom: 40px !important;\n        margin: 0 auto !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-e4b69a2e] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin-bottom: 40px !important !important;\n        margin: 0 auto !important;\n}\n}\n.center-container[data-v-e4b69a2e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "YSGn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DEFAULT_LOGO.65f758b.png";

/***/ }),

/***/ "YZMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/table/productsTable.vue
var productsTable = __webpack_require__("FMAQ");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eab2c2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/productsTable.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [_vm._m(0)])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        ref: "table",
        class: _vm.className,
        attrs: { id: _vm.tableId, cellpadding: "0" }
      },
      [
        _c("thead", { staticClass: "thead-dark" }, [
          _c(
            "tr",
            _vm._l(_vm.options.columns, function(field, i) {
              return _c(
                "th",
                { key: i, class: field.className },
                [
                  _vm._t(
                    "HEAD_" + field.name,
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(field.title) }
                      })
                    ],
                    { field: field, i: i }
                  )
                ],
                2
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("tbody"),
        _vm._v(" "),
        _c("tfoot", { attrs: { id: "footR" } })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var table_productsTable = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eab2c2e", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/table/productsTable.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Z9kb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  productsTable["a" /* default */],
  table_productsTable,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/table/productsTable.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6eab2c2e", Component.options)
  } else {
    hotAPI.reload("data-v-6eab2c2e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_table_productsTable = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z9kb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AaPU");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6ff88bc0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6eab2c2e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./productsTable.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6eab2c2e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./productsTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ZDvS":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("aVkd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8f701f9a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4811f8f1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4811f8f1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "aHDP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9fMG");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5fb2516c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25a8184a\",\"scoped\":false,\"hasInlineConfig\":false}!../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./BadgerAccordionItem.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25a8184a\",\"scoped\":false,\"hasInlineConfig\":false}!../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./BadgerAccordionItem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "aVkd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-4811f8f1] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-4811f8f1] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-4811f8f1] {\n  width: 75px;\n}\n.bigTitle[data-v-4811f8f1] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-4811f8f1] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-4811f8f1] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-4811f8f1] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-4811f8f1] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-4811f8f1] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-4811f8f1] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-4811f8f1] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-4811f8f1] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-4811f8f1] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-4811f8f1] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-4811f8f1] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-4811f8f1] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-4811f8f1] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-4811f8f1] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-4811f8f1] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-4811f8f1]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-4811f8f1] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-4811f8f1] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-4811f8f1]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-4811f8f1]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-4811f8f1]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-4811f8f1] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-4811f8f1] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.front-image2[data-v-4811f8f1] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 29px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 100%;\n  margin-bottom: 0;\n  background: #00897e !important;\n  color: white;\n  border-radius: 5px;\n  overflow: hidden;\n  cursor: pointer;\n}\n@media screen and (max-width: 1024px) {\n.front-image2[data-v-4811f8f1] {\n      margin-top: 15px !important;\n}\n}\n.front-image2 > .fileInputLabel[data-v-4811f8f1] {\n    display: none;\n}\n.front-image2 > .invalid-feedback[data-v-4811f8f1] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image2 > input[data-v-4811f8f1] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 30px;\n    z-index: 10;\n    top: 0;\n    cursor: pointer !important;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 99;\n    /*This makes the button huge. If you want a bigger button, increase the font size*/\n    font-size: 50px;\n    /*Opacity settings for all browsers*/\n    opacity: 0;\n    -moz-opacity: 0;\n    filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);\n}\n.front-image2 > label[data-v-4811f8f1] {\n    /*display: none;*/\n    cursor: pointer;\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image2 > label > span[data-v-4811f8f1] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 100%;\n      margin-top: 0 !important;\n      display: block;\n      height: 29px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 0;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 19px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n      cursor: pointer;\n}\n.front-image2 > label > span[data-v-4811f8f1]:before {\n        cursor: pointer;\n        content: \"CARICA\";\n        font-family: Regular;\n        font-weight: 300 !important;\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 29px;\n        width: 100%;\n        border-radius: 7px;\n        padding-top: 3px;\n        font-size: 0.775rem !important;\n        font-weight: 600;\n        color: white;\n        border: 3px solid #00917e;\n        /*padding: .55rem .55rem !important;*/\n        font-size: 0.775rem !important;\n        line-height: 0.9 !important;\n        border-radius: 0.1rem !important;\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label > span[data-v-4811f8f1] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label > span[data-v-4811f8f1] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image2 > label[data-v-4811f8f1]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 100%;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      cursor: pointer;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-4811f8f1]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-4811f8f1]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-4811f8f1] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-4811f8f1] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.niceInputLabel2[data-v-4811f8f1] {\n  color: #ffffff !important;\n  font-size: 21px;\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  left: 0;\n  top: 0;\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-right: 0;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n.center-container[data-v-4811f8f1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "aWqY":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kKOV");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1deb02b6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f06c4c4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f06c4c4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "b+/z":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PCb9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8e1aa04a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-665f5baa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-665f5baa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bYAS":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Gloria+Hallelujah);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);

// module
exports.push([module.i, "@font-face {\r\n  font-family: \"Regular\";\r\n  src: url(" + escape(__webpack_require__("z5ke")) + ");\r\n  src: url(" + escape(__webpack_require__("z5ke")) + "?#iefix) format('embedded-opentype'),\r\n    url(" + escape(__webpack_require__("LdOU")) + ") format(\"woff2\"),\r\n    url(" + escape(__webpack_require__("mJhL")) + "),\r\n    url(" + escape(__webpack_require__("mJhL")) + "?#iefix) format(\"embedded-opentype\");\r\n}\r\n\r\n.tab-content{\r\n  border-top: 1px solid black;\r\n}\r\n\r\n.row.accRow {\r\n    border-bottom: 14px solid #eeeeee;\r\n    margin-bottom: 16px;\r\n}\r\n.fa-lg {\r\n  color: red;\r\n  cursor: pointer;\r\n}\r\n.customAccordion > dl > dt{\r\n  box-shadow: none!important;\r\npadding: 0px!important;\r\nmargin-bottom: 0px;\r\n}\r\n\r\n.yellowBg{\r\n      background: #ffeb3b;\r\n}\r\n\r\n.pagination {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-left: 0;\r\n    list-style: none;\r\n    border-radius: 0.25rem;\r\n    justify-content: space-evenly;\r\n\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.paginator{\r\n\r\n  background: white;\r\n    padding: 0.5rem;\r\n    box-shadow: 0px 0px 3px #00000078;\r\n    padding: 10px;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.BloclDivider{\r\n  border: 1px solid grey;\r\n}\r\n\r\n.page-item.active .page-link {\r\n    z-index: 3;\r\n    color: #000;\r\n    background-color: #f39324;\r\n    border-color: #f39324;\r\n    font-weight: 900;\r\n    cursor: pointer;\r\n}\r\n\r\n.page-item{\r\n  cursor: pointer;\r\n}\r\n\r\n.page-link{\r\n  color: #000;\r\n}\r\n\r\np.VuePagination__count.VuePagination__count {\r\n    font-weight: 900;\r\n    font-size: 20px;\r\n}\r\n\r\n.page-link {\r\n    position: relative;\r\n    display: block;\r\n    padding: 1.3rem 1.95rem;\r\n    margin-left: -1px;\r\n    line-height: 1.25;\r\n    color: #007bff;\r\n    background-color: #fff;\r\n    border: 1px solid #dee2e6;\r\n    font-size: 20px;\r\n}\r\n\r\n.quardContainer {\r\n  background: #00897e36;\r\n  height: 100%;\r\n  width: 100%;\r\n  padding: 5px;\r\n  display: inline-grid;\r\n  padding-top: 0px;\r\n  padding-bottom: 15px;\r\n      font-size: 14px;\r\n      color: black\r\n}\r\n.quardValue {\r\n    margin: 0;\r\n    font-size: 29px;\r\n    align-items: center;\r\nalign-content: center;\r\nalign-self: center;\r\nvertical-align: middle;\r\n}\r\n.orangeCont{\r\n  background: #f3932440;\r\n}\r\n\r\n.quardDescription{\r\n  align-items: center;\r\nalign-content: center;\r\nalign-self: center;\r\nvertical-align: middle;\r\ncolor: black;\r\n}\r\n\r\n\r\n.customAccordion{\r\n  border-bottom: 1px solid black;\r\n}\r\n\r\n.customAccordion > dl > dt > div > button > .badger-accordion-title{\r\n  flex: 0 0 94% !important;\r\n}\r\n\r\n.customAccordion > dl > dt > div > button > .badger-toggle-indicator{\r\n  flex: 0 0 6% !important;\r\n}\r\n.cooper {\r\n  font-family: \"Regular\" !important;\r\n  text-shadow: 0px 0px 6px white, 0px 0px 12px white;\r\n}\r\n.bgGreen {\r\n    background: #00897e;\r\n}\r\n\r\n\r\n\r\n.notificationContent {\r\n  position: absolute;\r\n  z-index: 2;\r\n  left: 0;\r\n  top: 78px;\r\n  background: #eeeeee;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  transition: .3s ease !important;\r\n  height: 0px;\r\n  border-bottom: 10px solid white;\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\r\n    color: #495057;\r\n    background-color: #00897e;\r\n    border-color: #dee2e6 #dee2e6 #000;\r\n}\r\n.nav-tabs {\r\n    border-bottom: 1px solid #909090;\r\n}\r\n\r\n.reverse {\r\n  display: flex;\r\n  flex-direction: column-reverse;\r\n}\r\n\r\n.notificationC {\r\n  transition: .3s ease !important;\r\n  height: 210%;\r\n}\r\n\r\n.maxNotification {\r\n  max-height: 100%;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.leftIm {\r\n  position: absolute;\r\n  width: 25px;\r\n  left: 19px;\r\n  top: 17px;\r\n}\r\n\r\n.customAccordion > dl > dt{\r\n  box-shadow: none!important;\r\npadding: 0px!important;\r\nmargin-bottom: 0px;\r\n}\r\n\r\n.customAccordion > dl > dt > div > button > .badger-accordion-title{\r\n  flex: 0 0 94% !important;\r\n}\r\n\r\n.customAccordion > dl > dt > div > button > .badger-toggle-indicator{\r\n  flex: 0 0 6% !important;\r\n}\r\n\r\n/* Chrome, Safari, Edge, Opera */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type=number] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n.leftIm2 {\r\n  position: absolute;\r\n  width: 25px;\r\n  left: 9px;\r\n  top: 17px;\r\n}\r\n\r\n.greenBg{\r\n  background: #00897e;\r\n  color: white;\r\n}\r\n\r\n.posWA {\r\n  left: 141px !important;\r\n  top: 18px;\r\n  width: 45px;\r\n}\r\n\r\n.rightIm {\r\n  position: absolute;\r\n  width: 25px;\r\n  right: 20px;\r\n  top: 17px;\r\n}\r\n\r\n.posTEL {\r\n  left: 178px !important;\r\n  top: 222px;\r\n  width: 45px;\r\n  transform: rotate(90deg);\r\n  filter: invert(100%);\r\n  opacity: .2;\r\n}\r\n\r\n.shadowBox {\r\n  background: white;\r\n  box-shadow: 0px 3px 13px 0px #00000094;\r\n}\r\n\r\n.Barlow-Black {\r\n  font-family: Regular;\r\n}\r\n\r\n.yellowX {\r\n  color: #e49632 !important;\r\n}\r\n\r\n.yellowY {\r\n  background: #e49632 !important;\r\n}\r\n\r\n.titleImg {\r\n  max-width: 150px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.azzure {\r\n  color: #a82a21 !important;\r\n}\r\n\r\n.dataContainer {\r\n  padding-top: 130px;\r\n}\r\n\r\n.normText{\r\n  font-weight: 500;\r\n}\r\n\r\n.Regular {\r\n  font-family: Regular;\r\n}\r\n\r\n.Bold-Italic {\r\n  font-family: Regular;\r\n}\r\n\r\n.Bold {\r\n  font-family: Regular;\r\n  font-weight: 800;\r\n}\r\n\r\n.scrollactive-item.activeMenuItem {\r\n  font-family: Regular !important;\r\n  color: #a82a21 !important;\r\n}\r\n\r\n.scrollactive-item.activeMenuItem {\r\n  font-family: Regular !important;\r\n}\r\n\r\n.carousel__indicator::before {\r\n  background-color: #000 !important;\r\n  height: 2.125rem;\r\n  left: 50%;\r\n  top: 50%;\r\n  width: 100%;\r\n}\r\n\r\n.carousel__indicators--disc>.carousel__indicator {\r\n  width: 1.55rem;\r\n}\r\n\r\n.carousel__indicators--disc>.carousel__indicator::before {\r\n  border-radius: 50%;\r\n  height: 0.7rem;\r\n  width: 0.7rem;\r\n}\r\n\r\n/* MAIN\r\n\r\nhtml{\r\n\toverflow: hidden;\r\n}\r\n*/\r\nhtml, body {\r\n  height: 100%;\r\n  font-family: Regular;\r\n  color: #333;\r\n  text-rendering: optimizeSpeed;\r\n  -webkit-text-size-adjust: 100%;\r\n  -moz-text-size-adjust: 100%;\r\n  -ms-text-size-adjust: 100%;\r\n  background: #eee!important;\r\n}\r\n\r\n.requiredCont {\r\n  border: 2px dashed red;\r\n  padding: 15px;\r\n  padding-top: 5px\r\n}\r\n\r\n.swal2-icon.swal2-info {\r\n  border-color: #ffffff;\r\n      color: #ffffff;\r\n}\r\n\r\n.green {\r\n  color: #00917e !important;\r\n}\r\n\r\n.section-heading {\r\n  font-size: 1.5rem;\r\n  line-height: 1.875rem;\r\n  font-weight: normal !important;\r\n}\r\n\r\n.custom-control-input:checked~.custom-control-label::before {\r\n  color: #fff;\r\n  border-color: #a50034;\r\n  background-color: #a50034;\r\n  font-family: Regular !important;\r\n}\r\n\r\n.borderBottom {\r\n  border-bottom: 2px solid grey;\r\n}\r\n\r\n.helperUnderline::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 70%;\r\n  left: 30%;\r\n  bottom: 0;\r\n  border: 1px dashed green;\r\n}\r\n\r\nbody {\r\n  -webkit-overflow-scrolling: touch;\r\n  overflow: scroll !important;\r\n  overflow-x: hidden !important;\r\n  background: WHITE;\r\n}\r\n\r\nh1.tizaFont {\r\n  font-size: 60px;\r\n}\r\n\r\n.customLink {\r\n  font-size: 15px !important;\r\n}\r\n\r\n.fancy {\r\n  line-height: 0.2;\r\n  text-align: center;\r\n}\r\n\r\n.fancy span {\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.fancy span:before,\r\n.fancy span:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 5px;\r\n  border-bottom: 2.5px solid #000000;\r\n  border-top: 2.5px solid #000000;\r\n  top: 0;\r\n  width: 1800px;\r\n}\r\n\r\n.selectBonusCont {\r\n  padding: 1rem;\r\n  border: 2px solid #e3e3e3;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  background-color: #fff;\r\n  transition: all 0.2s;\r\n  z-index: 1;\r\n  position: relative;\r\n  transition: .3s all;\r\n}\r\n\r\n.selectBonusContBack {\r\n  position: absolute;\r\n  z-index: -1;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #00917e;\r\n  color: white;\r\n  text-align: center;\r\n  align-items: center;\r\n  align-self: center;\r\n  left: 0;\r\n  top: 0;\r\n  display: grid;\r\n  opacity: 0;\r\n  font-size: 22px;\r\n  font-weight: 500;\r\n  transition: .3s all;\r\n}\r\n\r\n.bonusSelected {\r\n  background: #00917e;\r\n}\r\n\r\n.selectBonusCont:hover>.selectBonusContBack {\r\n  background-color: #00917e;\r\n  z-index: 2;\r\n  opacity: 1;\r\n}\r\n\r\n.selectBonusCont:hover {\r\n  background-color: #00917e;\r\n}\r\n\r\n.mainBackVaillant {\r\n  min-height: calc(100vh);\r\n  background-color: #eee !important;\r\n}\r\n\r\n.bg-success {\r\n    background-color: #75fe7b!important;\r\n}\r\n.concludedStatus::before{\r\n  content: \"FATTO\";\r\n  position: absolute;\r\n  color: green;\r\n  background: white;\r\n  width: 30%;\r\n  height: 50%;\r\n  background-position: 0 0;\r\n  display: inline-block;\r\n  background-image: white;\r\n}\r\n\r\n\r\n.bgWhite{\r\n  background: white;\r\n}\r\n\r\n.vaillantCont {\r\n  background-color: #fff !important;\r\n}\r\n\r\noptgroup {\r\n  background: #00897e;\r\n  color: white;\r\n}\r\n\r\n.fancy span:before {\r\n  right: 120%;\r\n  margin-right: 15px;\r\n}\r\n\r\n.fancy span:after {\r\n  left: 120%;\r\n  margin-left: 15px;\r\n}\r\n\r\nbody.swal2-shown.swal2-height-auto {\r\n  padding: 0 !important;\r\n  overflow: scroll !important;\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n.lightRight {\r\n  background: #ffcacf;\r\n}\r\n\r\n.dashCont>.buttonTextCont {\r\n  display: none;\r\n}\r\n\r\n.lightGreen {\r\n  background: #00897e2b;\r\n}\r\n\r\n.swal2-popup.swal2-modal.swal2-show {}\r\n\r\n.fixed-top {\r\n  top: 0!important;\r\n  transition: top 0.3s ease;\r\n}\r\n\r\n.buttonTextCont {\r\n  padding: 5px;\r\n  border: 1px solid #d0d0d0;\r\n  margin: 0 auto;\r\n}\r\n\r\n.navGreen {\r\n  mix-blend-mode: normal;\r\n  max-width: 100vw;\r\n}\r\n\r\n#app {\r\n  min-height: 100%;\r\n}\r\n\r\n.tizaFont {\r\n  font-family: Tiza;\r\n  font-weight: 900;\r\n}\r\n\r\n.fixed {\r\n  position: fixed;\r\n\r\n}\r\n\r\na {\r\n  color: #fae49f;\r\n}\r\n\r\na:hover {\r\n  color: #3f3f3f;\r\n}\r\n\r\n.underline {\r\n  text-decoration: underline!important;\r\n}\r\n\r\n.greyBg {\r\n  background: #eeeeee;\r\n}\r\n\r\n.cookieBaner {\r\n  background: #00897e;\r\n  z-index: 155557;\r\n  margin: 0;\r\n  padding-top: 10px;\r\n  padding-bottom: 5px;\r\n  left: 0;\r\n  bottom: 0;\r\n  color: #ffffff;\r\n  height: 105px;\r\n  font-weight: 800;\r\n  vertical-align: middle;\r\n  align-items: center;\r\n  align-self: center;\r\n  font-size: 18px;\r\n  display: flex;\r\n}\r\n\r\n.navbar-brand {\r\n  margin-right: 0;\r\n}\r\n\r\n.menuItem {\r\n  text-decoration: none;\r\n  font-family: Regular !important;\r\n  font-weight: 800 !important;\r\n  font-size: 16px;\r\n  margin: 15px;\r\n}\r\n\r\n.mobPlayButton {\r\n  margin-bottom: 0 !important;\r\n  width: 27vw !important;\r\n  font-size: 16px !important;\r\n  text-align: center !important;\r\n  padding: 5px !important;\r\n  margin-left: -3vw;\r\n}\r\n\r\n.js-badger-accordion-panel-inner {\r\n  color: black;\r\n  padding-top: 0vw;\r\n  padding-bottom: 1vw;\r\n  font-family: Regular !important;\r\n  font-size: 16px;\r\n  background: white;\r\n}\r\n\r\n.badger-accordion--initialized .badger-accordion__panel {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.badger-accordion-toggle {\r\n  font-size: 14px;\r\n}\r\n\r\n.greenLinkAccordion {\r\n  color: #00897e !important;\r\n  font-size: 15px;\r\n  text-transform: uppercase;\r\n  float: right;\r\n  font-weight: 700;\r\n  margin-top: 59px;\r\n}\r\n\r\n.inline-block {\r\n  display: inline-block;\r\n}\r\n\r\n.qrcodeText {\r\n  line-height: 14px;\r\n  margin-top: 0px !important;\r\n  position: absolute;\r\n  top: auto;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.relative {\r\n  position: relative;\r\n}\r\n\r\n.qrcodeImg {\r\n  max-width: 150px;\r\n  margin-top: -11px;\r\n}\r\n\r\n.qrcodeImg {\r\n  max-width: 150px;\r\n  margin-top: -41px;\r\n}\r\n\r\n.card {\r\n  position: relative;\r\n  margin-bottom: 24px;\r\n  background-color: #fff;\r\n  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\r\n  box-shadow: none !important;\r\n  border: none\r\n}\r\n\r\n.step-progress {\r\n  padding: 5px;\r\n  background-color: #FAFAFA;\r\n  margin: 0 auto;\r\n}\r\n\r\n.step-progress .step-slider {\r\n  width: 100%;\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item {\r\n  width: 25%;\r\n  padding-top: 10px;\r\n  height: 75px;\r\n  position: relative;\r\n  float: left;\r\n  /*background-color: #E0E0E0;*/\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item:after {\r\n  content: \"\";\r\n  width: 25px;\r\n  height: 25px;\r\n  position: absolute;\r\n  top: -13px;\r\n  right: -11px;\r\n  background-color: #eeeeee;\r\n  border: 1px solid #00897e;\r\n  border-radius: 50%;\r\n  z-index: 2;\r\n  transition: all 0.3s ease-out 0.5s;\r\n  -webkit-transition: all 0.3s ease-out 0.5s;\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -6px;\r\n  left: 0;\r\n  width: 0%;\r\n  height: 10px;\r\n  background-color: #f39324;\r\n  z-index: 1;\r\n  -webkit-transition: all 0.5s ease-out;\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item.active:before {\r\n  width: 100%;\r\n  background-color: #f39324;\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item.active:after {\r\n  border-color: #f39324;\r\n}\r\n\r\n.step-content {\r\n  padding: 16px 0;\r\n}\r\n\r\n.invalid-feedback-custom {\r\n  color: red;\r\n  font-size: 13px;\r\n}\r\n\r\n.payImage {\r\n  max-width: 300px;\r\n  width: 100%;\r\n}\r\n\r\n.step-content .step-content-foot {\r\n  text-align: right;\r\n}\r\n\r\n.step-content .step-content-foot button {\r\n  border: 0;\r\n  padding: 8px 16px;\r\n  background-color: #CFD8DC;\r\n  font-size: 14px;\r\n  border-radius: 3px;\r\n  outline: 0;\r\n}\r\n\r\n.step-content .step-content-foot button:active {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.step-content .step-content-foot button.out {\r\n  display: none;\r\n}\r\n\r\n.step-slider-item.notactive {\r\n  background: #f9f9f9;\r\n}\r\n\r\n.step-slider-item.active {\r\n  background: #ffe5c6;\r\n}\r\n\r\n.yellow {\r\n  color: #f39324;\r\n}\r\n\r\n.step-slider-item.active.passed {\r\n  background: #00897e;\r\n  color: white;\r\n}\r\n\r\n.step-content .step-content-foot button.disable {\r\n  background-color: #ECEFF1;\r\n}\r\n\r\n.step-content .step-content-foot button.active {\r\n  background-color: #00ACC1;\r\n  color: white;\r\n}\r\n\r\n.custInput>.form-control, .custInput .vdp-datepicker div>.form-control {\r\n  background: transparent !important;\r\n  border: none !important;\r\n  border-bottom: 2px solid #00917e !important;\r\n  border-radius: 0 !important;\r\n  color: #00917e !important;\r\n  height: 70px !important;\r\n  outline: none !important;\r\n  padding-top: 24px;\r\n}\r\n\r\n.custInput>.disabled {\r\n  background: grey !important;\r\n  background: linear-gradient(0deg, rgba(147, 147, 147, 0.7287289915966386) 0%, rgba(255, 255, 255, 0) 70%) !important;\r\n}\r\n\r\n.custInput>.form-control:focus, .custInput .vdp-datepicker div>.form-control:focus {\r\n  color: #00917e !important;\r\n  outline: none !important;\r\n  height: 70px !important;\r\n  padding: 7px !important;\r\n  padding-top: 23px !important;\r\n}\r\n\r\n.removeProduct {\r\n  position: absolute;\r\n  top: 35px;\r\n  right: 33px;\r\n}\r\n\r\n.addProduct {}\r\n\r\n.custInput>input:focus~label, .custInput .valid~label {\r\n  top: 1px !important;\r\n  left: 4px !important;\r\n  font-size: 12px !important;\r\n  color: black !important;\r\n  outline: none !important;\r\n}\r\n\r\n.custInput .valid {\r\n  height: 70px !important;\r\n}\r\n\r\n.custInput {\r\n  margin-top: 0px;\r\n}\r\n\r\n.custInput>.niceInputLabel {\r\n  color: #00917e !important;\r\n  left: 5px !important;\r\n  top: 29px !important;\r\n}\r\n\r\n.step-content .step-content-body {\r\n  padding: 16px 0;\r\n  text-align: center;\r\n  font-size: 18px;\r\n  display: inline;\r\n}\r\n\r\n.stTitle {\r\n  font-size: 130%;\r\n  padding-top: 20px;\r\n  font-family: Regular;\r\n}\r\n\r\n.step-content .step-content-body.out {\r\n  display: none;\r\n}\r\n\r\n.traficLight {\r\n  max-width: 120px;\r\n}\r\n\r\n.greenLinkAccordion2 {\r\n  color: #00897e !important;\r\n  font-size: 15px;\r\n  text-transform: uppercase;\r\n  float: right;\r\n  font-weight: 700;\r\n  margin-top: 45px\r\n}\r\n\r\nspan.badger-toggle-indicator {\r\n  font-size: 32px;\r\n  line-height: 25px;\r\n  font-weight: 800;\r\n}\r\n\r\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-accordion-title {\r\n  -webkit-box-flex: 0;\r\n  -ms-flex: 0 0 97% ;\r\n  flex: 0 0 97% ;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-toggle-indicator {\r\n  -webkit-box-flex: 0;\r\n  -ms-flex: 0 0 3% ;\r\n  flex: 0 0 3% ;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: end;\r\n  -ms-flex-pack: end;\r\n  justify-content: flex-end;\r\n  cursor: pointer;\r\n}\r\n\r\n.component-badger-accordion {\r\n  font-family: Bold !important;\r\n  font-size: 18px;\r\n}\r\n\r\n.DKLemonYellowSunFont {\r\n  font-family: DKLemonYellowSun;\r\n}\r\n\r\n.DINPro-Bold {\r\n  font-family: Regular !important;\r\n}\r\n\r\nhr {\r\n  margin-top: 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 0;\r\n  border-top: 1px solid rgb(185, 185, 185);\r\n}\r\n\r\n.howplaybtn {\r\n  position: absolute !important;\r\n  right: 0 !important;\r\n  bottom: 80px !important;\r\n}\r\n\r\n.spbutton {\r\n  color: #c70000 !important;\r\n  background: white !important;\r\n  border-radius: 30px !important;\r\n  font-size: 30px !important;\r\n  line-height: 40px !important;\r\n  font-weight: 900 !important;\r\n  padding-top: 6px !important;\r\n  padding-bottom: 3px !important;\r\n  padding-left: 40px !important;\r\n  padding-right: 40px !important;\r\n  box-shadow: inset 0px -11px 20px 7px #9a9a9a !important;\r\n}\r\n\r\n.bbaBackground {\r\n  background: #a82a21;\r\n}\r\n\r\n.alert-success {\r\n  color: #fffbde;\r\n  background-color: #00ff3d00;\r\n  border-color: transparent;\r\n  text-align: center;\r\n  font-size: x-large;\r\n}\r\n\r\n.card {\r\n  background-color: transparent;\r\n}\r\n\r\n.bbaRed {\r\n  color: #d9222a !important;\r\n}\r\n\r\nsmall {\r\n  font-size: 15px;\r\n}\r\n\r\n.textAlt {\r\n  transform: scale(.9, 1.5);\r\n}\r\n\r\n.widthFull {\r\n  width: 100%;\r\n}\r\n\r\n.mainBack {\r\n  min-width: 100vw;\r\n  width: 100vw;\r\n  min-height: 100vh;\r\n  background: url(" + escape(__webpack_require__("DydT")) + ");\r\n  background-size: cover;\r\n  background-position: left;\r\n}\r\n\r\n.calcBack {\r\n  min-width: 100vw;\r\n  width: 100vw;\r\n  min-height: 100vh;\r\n  background: url(" + escape(__webpack_require__("2TQw")) + ");\r\n  background-size: cover;\r\n  background-position: bottom;\r\n}\r\n\r\n.logo:before {\r\n  content: '';\r\n  width: 200px;\r\n  position: absolute;\r\n  top: 0;\r\n  left: auto;\r\n  background: url(" + escape(__webpack_require__("4GjL")) + ");\r\n  right: 107px;\r\n  background-size: contain;\r\n  background-position: left;\r\n  height: 105px;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.h1B {\r\n  font-size: 60px;\r\n}\r\n\r\n.login {\r\n  width: 100%;\r\n  color: black !important;\r\n  margin: 0 auto;\r\n}\r\n\r\n.h100 {\r\n  min-height: 100vh;\r\n  min-width: 100vw;\r\n}\r\n\r\n.center-container {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 100%;\r\n}\r\n\r\n.centerFlex {\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.bm-menu {\r\n  background-color: #008479;\r\n  padding-top: 0;\r\n}\r\n\r\n.bm-burger-bars {\r\n  background-color: #3c3c3c;\r\n}\r\n\r\n.skewHalf {\r\n  min-height: 100vh;\r\n  z-index: 2;\r\n}\r\n\r\n.center-container>img {\r\n  max-width: 450px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.skewHalf::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -13vw;\r\n  top: 0;\r\n  height: 100vh;\r\n  width: 63vw;\r\n  background: #00917e;\r\n  z-index: -1;\r\n  transform: skewX(-10deg);\r\n  box-shadow: 3px -1px 13px 0px #000000c7;\r\n}\r\n\r\n.mt-header {\r\n  padding-top: 135px;\r\n}\r\n\r\n.bm-burger-button {\r\n  cursor: pointer;\r\n  height: 30px;\r\n  left: 36px;\r\n  position: absolute;\r\n  top: 45px;\r\n  width: 36px;\r\n  z-index: 100;\r\n}\r\n\r\n.whiteBackground {\r\n  /*\r\n\tbackground: url(../../assets/images/bg-pattern2.jpg);\r\n\tbackground-size: 200px 200px;\r\n\tbackground-repeat: repeat;\r\n\t*/\r\n  background: white;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .container {\r\n    max-width: 1340px !important;\r\n  }\r\n\r\n  .swal2-popup.swal2-modal.swal2-show {\r\n    min-width: 777px;\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .container {\r\n    max-width: 100vw;\r\n  }\r\n\r\n  .span.stepImage.center.pl-5.pr-5.stepDesc.pb-3 {\r\n    padding-right: 0 !important;\r\n    padding-left: 0 !important;\r\n  }\r\n}\r\n\r\n.black {\r\n  color: #333 !important;\r\n}\r\n\r\n.formBack {\r\n  background: #042366;\r\n  box-shadow: 0px 0px 11px 0px white;\r\n}\r\n\r\n.formHeader {\r\n  background: white;\r\n  color: #0e235b;\r\n  font-weight: 700;\r\n}\r\n\r\n.red {\r\n  color: red !important;\r\n}\r\n\r\n.jumbotron {\r\n  background-color: transparent;\r\n}\r\n\r\n.navbar-brand {\r\n  width: 190px;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.pdfViewer {\r\n  z-index: 5555555\r\n}\r\n\r\n.littlePdf {\r\n  position: absolute;\r\n  font-size: 9px;\r\n  margin-top: -3px;\r\n  left: -3px;\r\n  bottom: -15px\r\n}\r\n\r\n.howPlayTitle {\r\n  max-width: 486px;\r\n}\r\n\r\n.howplayContainers {\r\n  max-width: 356px;\r\n  background: white;\r\n  margin: 0 auto;\r\n}\r\n\r\n.howPlayImg {\r\n  max-width: 80%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.bg-light {\r\n  background-color: white !important;\r\n}\r\n\r\n.main {\r\n  overflow: hidden;\r\n  padding-top: 0px;\r\n  /*padding-bottom:320px;  this needs to be bigger than footer height*/\r\n  min-height: 100vh;\r\n  padding-bottom: 70px;\r\n  height: 100%;\r\n}\r\n\r\n.vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover {\r\n  background: #e15267;\r\n}\r\n\r\n.socialLogin {\r\n  min-height: 150px;\r\n}\r\n\r\n.noVisible {\r\n  opacity: 0;\r\n}\r\n\r\n.smallDesc {\r\n  font-size: 16px !important;\r\n  line-height: 19px;\r\n}\r\n\r\n.navmobile {\r\n  display: none;\r\n}\r\n\r\n/* FOOTER */\r\n.footer {\r\n  position: relative;\r\n  margin-top: -70px;\r\n  /*height: 70px;*/\r\n  clear: both;\r\n  padding-top: 0px;\r\n  background: white;\r\n}\r\n\r\n/* CUSTOM */\r\n.center {\r\n  text-align: center;\r\n}\r\n\r\n.fullWidth {\r\n  width: 100%;\r\n}\r\n\r\n.formError {\r\n  color: #d60043;\r\n  font-size: medium;\r\n  font-weight: bold;\r\n}\r\n\r\n#content {\r\n  text-align: center !important;\r\n}\r\n\r\n#oa_social_login_container {\r\n  padding-top: 10px;\r\n}\r\n\r\niframe {\r\n  /*width: auto !important;\r\n  padding: 15px;*/\r\n  border-radius: 15px !important;\r\n  padding-left: 0;\r\n  min-height: 81px;\r\n  padding-top: 0px;\r\n}\r\n\r\n.bbaWhite {\r\n  color: black;\r\n}\r\n\r\nselect option {\r\n  background: #67c8ab;\r\n  color: #ffffff;\r\n}\r\n\r\noption:checked {\r\n  background: #004b41 !important;\r\n}\r\n\r\noption:[selected] {\r\n  background: red !important;\r\n}\r\n\r\nselect[multiple]:focus option:checked {\r\n  background: #820900 !important;\r\n}\r\n\r\niframe~.name {\r\n  color: #f8bb08;\r\n}\r\n\r\n.provider {\r\n  color: #f8bb08;\r\n}\r\n\r\n#providers {\r\n  display: inline-block !important;\r\n  float: none !important;\r\n}\r\n\r\n.verticalCentred {\r\n  height: 85vh !important;\r\n}\r\n\r\n.loadSpinner {\r\n  position: absolute;\r\n  right: 25px;\r\n  bottom: 10px;\r\n}\r\n\r\n.closeProductsModal {\r\n  background: black;\r\n}\r\n\r\n.form-control {\r\n  background-color: transparent;\r\n  color: #000000 !important;\r\n  border: none;\r\n  border-bottom: 1px solid black;\r\n  padding: 7px;\r\n  border-radius: 0px !important;\r\n  border-top: none !important;\r\n  font-family: Regular !important;\r\n  font-weight: 700;\r\n  font-size: 1.1rem;\r\n  height: 52px;\r\n  outline: none !important;\r\n}\r\n\r\n.modalText {\r\n  color: #fffbde;\r\n}\r\n\r\n.even {\r\n  color: #000000;\r\n  background: #00736a26;\r\n  border-radius: 25px;\r\n}\r\n\r\n.closeProductsModal {}\r\n\r\n.swal2-popup.swal2-modal.swal2-show {\r\n  background: linear-gradient(0deg, #00917e, #00dcbf);\r\n  color: #2196F3 !important;\r\n  border-radius: 25px;\r\n  border: 1px solid #ffffff;\r\n  box-shadow: 1px 1px 20px 0px #b1e7ff;\r\n}\r\n\r\n.dashboardCount {\r\n  font-size: 55px;\r\n}\r\n\r\n.dashboardCard {\r\n  background: linear-gradient(0deg, #005f52, #00917e);\r\n  color: white !important;\r\n  padding-top: 23px;\r\n  padding-bottom: 33px;\r\n  border-radius: 7px;\r\n  border: 1px solid white;\r\n  box-shadow: 0px 5px 18px 0px #1d1d1d;\r\n}\r\n\r\n.pdfLink {\r\n  color: #00917e !important;\r\n  position: absolute;\r\n  right: 0;\r\n  left: auto;\r\n  bottom: 0;\r\n  text-decoration: underline;\r\n  font-weight: 900;\r\n  z-index: 1111111111111111;\r\n}\r\n\r\n.greenButton {\r\n  background: #00736a;\r\n  color: white;\r\n  padding: 5px;\r\n}\r\n\r\n.table td, .table th {\r\n  padding: .75rem;\r\n  vertical-align: middle;\r\n  border-top: 1px solid #dee2e6;\r\n}\r\n\r\n.swal2-success-circular-line-left, .swal2-success-fix, .swal2-success-circular-line-right {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.swal2-popup .swal2-title, #swal2-content {\r\n  color: #ffffff;\r\n}\r\n\r\ndt.badger-accordion__header {\r\n  background: white;\r\n  padding: .5rem;\r\n}\r\n\r\n.errorBg {\r\n  background: #ff7d7d;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\nbutton:focus {\r\n  outline: 1px dotted;\r\n  outline: none;\r\n}\r\n\r\n.successBg {\r\n  background: #00800024;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.loadBox {\r\n  background: white;\r\n  box-shadow: 0px 0px 8px #8c8c8c;\r\n  border-radius: 7px;\r\n  padding-bottom: 1.5rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.swal2-popup .swal2-styled.swal2-confirm {\r\n      background-color: #ffffff !important;\r\n}\r\n.swal2-popup .swal2-styled.swal2-confirm {\r\n    border: 0;\r\n    border-radius: .25em;\r\n    background: initial;\r\n    background-color: #3085d6;\r\n    color: #000;\r\n    font-size: 1.0625em;\r\n}\r\n.pointer, .nav-link {\r\n  cursor: pointer;\r\n}\r\n\r\n.nav-link {\r\n  color: #666!important;\r\n  font-weight: bold;\r\n  text-decoration: none !important;\r\n  /*text-transform: uppercase;*/\r\n  font-family: Regular;\r\n}\r\n\r\n.navWhite {\r\n  background: white;\r\n}\r\n\r\n.uppercase {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.btn-outline-secondary {\r\n  color: #ffffff;\r\n  border-color: #6c757d;\r\n  background: #00736a;\r\n}\r\n\r\n.seePass {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 0;\r\n  color: #a50034;\r\n}\r\n\r\n.table .thead-dark th {\r\n  color: #fff;\r\n  background-color: #00736a;\r\n  border-color: #17151a;\r\n}\r\n\r\n.btn-primary {\r\n  /*\r\n  text-transform: uppercase !important;\r\n  font-family: Regular !important;\r\n  border-radius: 31px !important;\r\n  border-bottom-right-radius: 0px !important;\r\n  font-size: 18px !important;\r\n  padding: 13px !important;\r\n  box-shadow: -1px 0px 15px 0px #ffffff;\r\n  color: white;\r\n  border-color: #00917e !important;\r\n  background-color: #00917e !important;\r\n  padding-left: 32px !important;\r\n  padding-right: 32px !important;*/\r\n\r\n  font-size: 1rem;\r\nposition: relative;\r\ndisplay: inline-block;\r\nline-height: 1;\r\nmax-width: 100%;\r\ncursor: pointer;\r\ncolor: #fff;\r\nborder: 1px solid #00917e;\r\nfont-family: Regular;\r\nbackground-color: #00917e;\r\ntext-decoration: none;\r\nborder-radius: 22px;\r\npadding: 0.75rem 1.5rem;\r\ntext-shadow: none;\r\nbox-shadow: none;\r\ntransition: background-color 0.3s;\r\ntext-align: center;\r\n\r\ntext-transform: none!important;\r\n\r\n\r\n\r\n}\r\n\r\n.whiteCont {\r\n  margin-top: 10px !important;\r\n  background: linear-gradient(0deg, rgba(244, 244, 244, 0.7287289915966386) 0%, rgba(244, 244, 244, 0.1287289915966386) 40%, rgba(255, 255, 255, 0) 100%);\r\n  border: none;\r\n  border-radius: 49px;\r\n}\r\n\r\n.stepTitle {\r\n  font-size: 17px;\r\n  font-weight: 800;\r\n}\r\n\r\n.divider {\r\n  width: calc(100% + 100px) !important;\r\n  margin-left: -35px !important;\r\n  height: 18px !important;\r\n  background: #eeeeee !important;\r\n}\r\n\r\n.divider2 {\r\n  width: calc(100% + 100px) !important;\r\n  margin-left: -15px !important;\r\n  height: 18px !important;\r\n  background: #eeeeee !important;\r\n}\r\n\r\n.vue-form-wizard .wizard-nav-pills>li>a {\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  margin: 0 auto;\r\n  color: rgb(0 0 0 / 40%);\r\n  position: relative;\r\n  top: 3px;\r\n}\r\n\r\n.btnWhite {\r\n  text-transform: uppercase !important;\r\n  font-family: Regular !important;\r\n  border-radius: 31px !important;\r\n  border-bottom-right-radius: 0px !important;\r\n  font-size: 22px !important;\r\n  padding: 13px !important;\r\n  box-shadow: -1px 0px 15px 0px #ffffff;\r\n  font-weight: 900;\r\n  padding-left: 32px !important;\r\n  padding-right: 32px !important;\r\n  color: #00917e;\r\n  background-color: white !important;\r\n  border-color: white !important;\r\n  min-width: 80%;\r\n  box-shadow: none;\r\n}\r\n\r\n.btnWhite:hover {\r\n  color: #00917e !important;\r\n  background-color: white !important;\r\n  border-color: white !important;\r\n  min-width: 80% !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\nsvg.svg-inline--fa.fa-search.fa-w-16.fa-sm {\r\n  color: #f39324;\r\n}\r\n\r\n.form-check-input.is-invalid~.form-check-label, .was-validated .form-check-input:invalid~.form-check-label {\r\n  color: #880726;\r\n}\r\n\r\n.imagesViewer {\r\n  display: none;\r\n}\r\n\r\n.progress {\r\n  background-color: #00000054;\r\n  border-radius: .25rem;\r\n  position: absolute;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 98%;\r\n  z-index: 5;\r\n  border-bottom-left-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.progress-bar {\r\n  color: white;\r\n  background: #00917e !important;\r\n  transition: width .6s ease;\r\n  font-size: 20px;\r\n  opacity: .8;\r\n}\r\n\r\n.rotate90 {\r\n  -webkit-transform: rotate(90deg);\r\n  -ms-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.viewer-open>#app {\r\n  filter: blur(3px);\r\n}\r\n\r\n.tableSimulator {\r\n  border: 1px solid grey\r\n}\r\n\r\n.docThumb {\r\n  color: #00897e;\r\n  margin: 1px;\r\n}\r\n\r\n.viewer-navbar {\r\n  background-color: #00897e;\r\n  overflow: hidden;\r\n  height: 20vh;\r\n}\r\n\r\n.viewer-list {\r\n  -webkit-box-sizing: content-box;\r\n  box-sizing: content-box;\r\n  height: 100%;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  padding: 1px 0;\r\n}\r\n\r\n.viewer-list>li {\r\n  color: transparent;\r\n  cursor: pointer;\r\n  float: left;\r\n  font-size: 0;\r\n  height: 100%;\r\n  line-height: 0;\r\n  opacity: 0.5;\r\n  overflow: hidden;\r\n  -webkit-transition: opacity 0.15s;\r\n  transition: opacity 0.15s;\r\n  width: 100px;\r\n}\r\n\r\n.viewer-open {\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.viewer-navbar {\r\n  background-color: rgb(0 68 63);\r\n  overflow: hidden;\r\n  height: 20vh;\r\n}\r\n\r\n.btn-primary:hover {\r\n  text-decoration: none;\r\n    background-image: none;\r\n    background-color: #007465;\r\n    border-color: #007465;\r\n}\r\n\r\n .wizard-btn {\r\n  border-radius: 0 !important;\r\n  font-weight: normal;\r\n  font-family: Regular !important;\r\n  display: inline-block;\r\n  margin-bottom: 0;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  -ms-touch-action: manipulation;\r\n  touch-action: manipulation;\r\n  cursor: pointer;\r\n  background-image: none;\r\n  border: 1px solid transparent;\r\n  white-space: nowrap;\r\n  padding: 6px 12px;\r\n  font-size: 14px;\r\n  line-height: 1.42857;\r\n  border-radius: 4px;\r\n  background: #f39324 !important;\r\n  border: none !important;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.btn:hover {\r\n\r\n}\r\n\r\n.siteBackground {\r\n  /*\r\n\tbackground: url(../../assets/images/bg-pattern.jpg);\r\n\tbackground-size: 200px 200px;\r\n\tbackground-repeat: repeat;\r\n\t*/\r\n}\r\n\r\n.dividerImg {\r\n  width: 100vw;\r\n  height: 50px;\r\n}\r\n\r\n.brownDesc {\r\n  color: #fffbde;\r\n  font-family: museo-slab;\r\n  font-weight: 600;\r\n  font-size: 1.88vw;\r\n}\r\n\r\n.redDesc {\r\n  color: #d9222a;\r\n  font-size: 2.08vw;\r\n}\r\n\r\n.red {\r\n  color: #ff222c;\r\n}\r\n\r\n.sidebarHeader {\r\n  margin-left: -11%;\r\n  background: #00917e;\r\n}\r\n\r\n.ibanForm {\r\n  background: #ffffffc4;\r\n  border-radius: 50px;\r\n  padding: 73px;\r\n}\r\n\r\n.greyDesc {\r\n  color: #fffbde;\r\n  font-size: 2.08vw;\r\n}\r\n\r\n.headerRigth {\r\n  text-align: left;\r\n}\r\n\r\n.headerLeft {\r\n  text-align: right;\r\n}\r\n\r\n.headerImgMain {\r\n  width: 70%;\r\n  z-index: 3;\r\n  position: relative;\r\n}\r\n\r\n.dateInput[readonly] {\r\n  background-color: #e9ecef00;\r\n  opacity: 1;\r\n}\r\n\r\n.display-time[readonly] {\r\n  background-color: transparent;\r\n  opacity: 1;\r\n  padding: .375rem .75rem !important;\r\n  margin-top: 3px;\r\n  font-weight: 600;\r\n  color: transparent;\r\n}\r\n\r\n.time-picker {\r\n  width: 100% !important;\r\n}\r\n\r\n.inline {\r\n  display: inline-block;\r\n}\r\n\r\n.fileInput.is-invalid~.invalid-feedback {\r\n  display: block;\r\n}\r\n\r\n.invalid-feedback {\r\n  color: #ff1100;\r\n  font-size: 15px !important;\r\n  font-weight: bold;\r\n}\r\n\r\n.time-picker.valid .display-time {\r\n  color: #ffffff !important;\r\n  margin-top: -3px !important;\r\n  font-weight: 400;\r\n}\r\n\r\n.time-picker .dropdown {\r\n  width: 100% !important;\r\n  border: 1px solid;\r\n  border-radius: 5px;\r\n  background: #ffffff !important;\r\n  z-index: 7 !important;\r\n  color: #0e235b !important;\r\n}\r\n\r\n.time-picker .dropdown .select-list {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n.text-warning {\r\n  color: #be8e00 !important;\r\n}\r\n\r\n.time-picker .dropdown ul li.active, .time-picker .dropdown ul li.active:hover {\r\n  background: #135b96 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.time-picker .dropdown ul li {\r\n  text-align: center;\r\n  padding: 0.3em 0;\r\n  color: #0e235b !important;\r\n}\r\n\r\n.fitAvailableHeight {\r\n  /*\r\n\tmin-height: -webkit-fill-available;\r\n\tmin-height: -moz-available;\r\n    min-height: stretch;\r\n\r\n\theight: auto;\r\n\t*/\r\n  position: relative;\r\n  display: block;\r\n  overflow: auto;\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n.custom-control-input:checked~.custom-control-label::before {\r\n  color: #fff;\r\n  border-color: #185d57;\r\n  background-color: #00796e;\r\n}\r\n\r\n.time-picker .dropdown ul {\r\n  width: 50%;\r\n  margin: 5px !important;\r\n  overflow-y: scroll !important;\r\n}\r\n\r\n.grey {\r\n  color: #767676e6;\r\n}\r\n\r\n.form-control:disabled, .form-control[readonly] {\r\n  background-color: transparent;\r\n  opacity: 1;\r\n}\r\n\r\n.w-100 {\r\n  width: 100%;\r\n}\r\n\r\n.vdp-datepicker__calendar {\r\n  width: 100% !important;\r\n  min-width: 330px;\r\n  border: 1px solid #000 !important;\r\n  border-radius: 5px !important;\r\n  background-color: #ffffff;\r\n  font-weight: 700;\r\n  color: #0e235b !important;\r\n  padding: 10px;\r\n  font-family: Regular;\r\n}\r\n\r\n.vdp-datepicker__calendar .disabled {\r\n  color: #b3b3b3;\r\n  cursor: default;\r\n}\r\n\r\n.display-time {\r\n  background-color: transparent;\r\n  border: 1px solid #482f24 !important;\r\n  border-top: none !important;\r\n  border-left: none !important;\r\n  border-right: none !important;\r\n  display: block;\r\n  width: 100% !important;\r\n  height: calc(1.5em + .75rem + 2px);\r\n  padding: .375rem .75rem;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #495057;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #ced4da;\r\n  border-radius: .25rem;\r\n  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n  border-bottom: none !important;\r\n  margin-top: -3px;\r\n}\r\n\r\n.group {\r\n  position: relative;\r\n  margin: 1vw;\r\n  margin-bottom: 25px !important;\r\n}\r\n\r\n.navbar-light .navbar-toggler {\r\n  color: rgb(64, 20, 7);\r\n  border-color: rgb(64, 20, 7);\r\n  margin-right: 15px;\r\n  background-color: #00897e!important;\r\n}\r\n\r\n.borderRed {\r\n  border-bottom: 1px solid #89082d !important;\r\n  color: #89082d !important;\r\n}\r\n\r\n.image-margin0 {\r\n  margin: 0 !important;\r\n  margin-top: 0 !important;\r\n}\r\n\r\n@media (min-width: 767px) and (max-width: 992px) {\r\n  .navDesktop {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-brand.navmobile {\r\n    position: relative;\r\n    width: 100vw !important;\r\n    text-align: center;\r\n    display: block;\r\n  }\r\n\r\n  .seachMobButton {\r\n    padding: 0 !important;\r\n    height: 30px !important;\r\n  }\r\n\r\n  .navmobileImage {\r\n    width: 111px !important;\r\n    margin-right: 1vw;\r\n  }\r\n\r\n  .navbar-light .navbar-toggler {\r\n    margin-top: 25px;\r\n    position: absolute;\r\n    right: 0px;\r\n    border: none;\r\n    background-color: #00897e!important;\r\n  }\r\n\r\n  .fixed-top {\r\n    padding-top: 0px;\r\n  }\r\n}\r\n\r\n.custom-toggler.navbar-toggler {\r\n  border-color: rgb(242, 28, 20);\r\n  background-color: #00897e!important;\r\n}\r\n\r\n.custom-toggler .navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgb(0, 155, 173)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\");\r\n}\r\n\r\n.btn-group-sm>.btn, .btn-sm {\r\n  padding: .55rem .75rem !important;\r\n  font-size: .875rem !important;\r\n  line-height: 1.5 !important;\r\n  border-radius: .2rem !important;\r\n}\r\n\r\n.mandatoryDoc {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 5px;\r\n}\r\n\r\n@media (min-width: 20px) and (max-width: 767px) {\r\n  .navDesktop {\r\n    display: none;\r\n  }\r\n\r\n  .qrcodeImg {\r\n    max-width: 150px;\r\n    margin-top: 1px;\r\n  }\r\n\r\n  .selectBonusContBack {\r\n    display: none;\r\n  }\r\n\r\n  .fixed-top {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .mobSearchT {\r\n    font-size: 18px !important;\r\n    padding-bottom: 0 !important;\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .howplaybtn {\r\n    position: relative !important;\r\n    right: 0 !important;\r\n    margin-top: 90px !important;\r\n  }\r\n\r\n  .selectBonusContBack {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .step-progress .step-slider .step-slider-item {\r\n    width: 100%;\r\n    padding-top: 10px;\r\n    height: 65px;\r\n    position: relative;\r\n    float: left;\r\n    /* background-color: #E0E0E0; */\r\n  }\r\n\r\n  .stTitle {\r\n    font-size: 100%;\r\n    padding-top: 20px;\r\n    font-family: Regular;\r\n  }\r\n\r\n  .center-container {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    min-height: -47vh;\r\n  }\r\n\r\n  .docTitleMob {\r\n    font-size: 1.1rem !important;\r\n  }\r\n\r\n  .editImageCont {\r\n    max-height: 150px !important;\r\n    max-width: 150px !important;\r\n    width: 100% !important;\r\n    height: 150px !important;\r\n    cursor: zoom-in;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .seachMobButton {\r\n    padding: 0 !important;\r\n    height: 30px !important;\r\n    background: transparent !important;\r\n    border-radius: 0 !important;\r\n    border: none !important;\r\n    font-size: 11px;\r\n    border-bottom: 1px solid black !important;\r\n    padding-top: 10px !important;\r\n  }\r\n\r\n  .maxBomTr {\r\n    max-width: 70px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .maxBomTr2 {\r\n    max-width: 100px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .codCount {\r\n    right: 0px !important;\r\n  }\r\n\r\n  .h1, h1 {\r\n    font-size: 1.7rem;\r\n  }\r\n\r\n  .h2, h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .h3, h3 {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .h4, h4 {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .h5, h5 {\r\n    font-size: .9rem;\r\n  }\r\n\r\n  .tablePdMob {\r\n    padding-bottom: 15px;\r\n  }\r\n\r\n  .btn-sm {\r\n    padding: .25rem .5rem !important;\r\n    font-size: .675rem !important;\r\n    line-height: 1.5 !important;\r\n    border-radius: .2rem !important;\r\n  }\r\n\r\n  .logo:before {\r\n    content: '';\r\n    width: 150px !important;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 7px !important;\r\n    background-size: contain;\r\n    background-position: left;\r\n    height: 57px !important;\r\n    background-repeat: no-repeat !important;\r\n  }\r\n\r\n  .bm-burger-button {\r\n    cursor: pointer;\r\n    height: 30px;\r\n    left: 12px;\r\n    position: absolute;\r\n    top: 14px;\r\n    width: 36px;\r\n    z-index: 100;\r\n    right: 12px !important;\r\n  }\r\n\r\n  .ibanForm {\r\n    background: #ffffffc4;\r\n    border-radius: 15px !important;\r\n    padding: 3px !important;\r\n    padding-top: 23px !important;\r\n  }\r\n\r\n  .loginBack {\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    height: auto;\r\n    width: 100vw;\r\n    height: 100vw;\r\n    padding-top: 30px;\r\n    padding-bottom: 30px;\r\n  }\r\n\r\n  .login {\r\n    width: 90%;\r\n    color: black !important;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .navbar-light .navbar-toggler {\r\n    margin-top: 4px;\r\n    margin-right: 0;\r\n    position: absolute;\r\n    right: 0px;\r\n    border: none;\r\n    top: 15px;\r\n    background-color: #00897e!important;\r\n  }\r\n\r\n  .titleMobSize {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .navbar-brand.navmobile {\r\n    position: relative;\r\n    width: 100vw !important;\r\n    text-align: center;\r\n    display: block;\r\n  }\r\n\r\n  .navmobileImage {\r\n    width: 111px !important;\r\n    margin-right: 1vw;\r\n  }\r\n\r\n  .cookieBaner {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n    font-weight: 800;\r\n    vertical-align: middle;\r\n    align-items: center;\r\n    align-self: center;\r\n    font-size: 12px;\r\n    display: flex;\r\n    height: 200px;\r\n  }\r\n\r\n  .swal2-popup.swal2-modal.swal2-show {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .swal2-popup #swal2-content {\r\n    text-align: center;\r\n    font-size: 12px;\r\n  }\r\n\r\n  h2#swal2-title {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .tizaFont {\r\n    font-size: 18px;\r\n  }\r\n\r\n  h1.tizaFont {\r\n    font-size: 30px !important;\r\n  }\r\n\r\n  .DINPro-Bold {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .badger-accordion-toggle {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .js-badger-accordion-panel-inner {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .niceInputLabel {\r\n    font-size: 19px !important;\r\n    top: 8px !important;\r\n  }\r\n\r\n  .group input:focus~label, .group .valid~label {\r\n    top: 5px;\r\n    left: 34px;\r\n    font-size: 12px;\r\n    color: #a2a2a2 !important;\r\n  }\r\n\r\n  .headerRigth, .headerLeft {\r\n    text-align: center;\r\n  }\r\n\r\n  .redDesc, .brownDesc, .greyDesc {\r\n    font-size: 4.08vw;\r\n  }\r\n\r\n  /**.mt-5 {\r\n\t\tmargin-top: 1rem!important;\r\n\t}**/\r\n  .modalText {\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .main {\r\n    padding-top: 0px;\r\n    padding-bottom: 306px;\r\n    min-height: 100vh;\r\n    height: 100%;\r\n  }\r\n\r\n  .mobPlayButton {\r\n    min-width: 30vw !important;\r\n  }\r\n\r\n  .navbar-brand {\r\n    width: 110px;\r\n  }\r\n\r\n  .lastNavLink {\r\n    margin-bottom: 30px;\r\n    padding-left: 10px !important;\r\n    padding-right: 10px !important;\r\n  }\r\n\r\n  iframe {\r\n    padding-left: 12px;\r\n    padding-top: 0px !important;\r\n  }\r\n}\r\n\r\n.playButton {\r\n  color: white;\r\n  font-family: \"Regular\";\r\n  background: #e15267;\r\n  color: white;\r\n  line-height: 21px;\r\n  font-size: 22px;\r\n  border-radius: 8px;\r\n  align-self: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.white {\r\n  color: white !important;\r\n}\r\n\r\n.nav-fill .nav-item {\r\n  vertical-align: middle;\r\n  align-items: center;\r\n  align-self: center;\r\n}\r\n\r\na:not([href]):not([tabindex]) {\r\n  color: #FF9800;\r\n  text-decoration: none;\r\n}\r\n\r\na:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {\r\n  color: #FF9800;\r\n  text-decoration: none;\r\n}\r\n\r\n/* INPUTS */\r\n/* Change Autocomplete styles in Chrome*/\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus textarea:-webkit-autofill,\r\ntextarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,\r\nselect:-webkit-autofill,\r\nselect:-webkit-autofill:hover,\r\nselect:-webkit-autofill:focus {\r\n  border-left: none !important;\r\n  border-right: none !important;\r\n  -webkit-text-fill-color: #00917e !important;\r\n  -webkit-box-shadow: 0 0 0px 1000px #0000 inset;\r\n  transition: background-color 5000s ease-in-out 0s;\r\n  background: transparent;\r\n  background-color: transparent !important;\r\n}\r\n\r\n/* form starting stylings ------------------------------- */\r\n.group {\r\n  position: relative;\r\n  margin: 1vw;\r\n}\r\n\r\ninput, .display-time {\r\n  font-size: 18px;\r\n  padding: 10px 10px 10px 5px;\r\n  display: block;\r\n  border: none;\r\n  border-bottom: 1px solid #757575;\r\n}\r\n\r\ninput:focus {\r\n  outline: none;\r\n}\r\n\r\n/* LABEL ======================================= */\r\n.niceInputLabel {\r\n  color: #ffffff !important;\r\n  font-size: 21px;\r\n  font-weight: normal;\r\n  position: absolute;\r\n  pointer-events: none;\r\n  left: 33px;\r\n  top: 20px;\r\n  transition: 0.2s ease all;\r\n  -moz-transition: 0.2s ease all;\r\n  -webkit-transition: 0.2s ease all;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  padding-right: 20px;\r\n  text-overflow: ellipsis;\r\n  max-width: 100%;\r\n}\r\n\r\n/* active state */\r\n.group input:focus~label, .group .valid~label {\r\n  top: 5px;\r\n  left: 34px;\r\n  font-size: 12px;\r\n  color: #a2a2a2 !important\r\n}\r\n\r\n.backButton {\r\n  position: fixed;\r\n  z-index: -1;\r\n  left: 90px;\r\n  top: 27px;\r\n}\r\n\r\n/* BOTTOM BARS ================================= */\r\n.bar {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.bar:before, .bar:after {\r\n  content: '';\r\n  height: 1px;\r\n  width: 0;\r\n  bottom: 1px;\r\n  position: absolute;\r\n  background: #fffbde;\r\n  transition: 0.2s ease all;\r\n  -moz-transition: 0.2s ease all;\r\n  -webkit-transition: 0.2s ease all;\r\n}\r\n\r\n.bar:before {\r\n  left: 40%;\r\n}\r\n\r\n.bar:after {\r\n  right: 40%;\r\n}\r\n\r\n/* active state */\r\n.group input:focus~.bar:before, .group input:focus~.bar:after {\r\n  width: 50%;\r\n}\r\n\r\n/* HIGHLIGHTER ================================== */\r\n.highlight {\r\n  position: absolute;\r\n  height: 60%;\r\n  width: 100px;\r\n  top: 25%;\r\n  left: 0;\r\n  pointer-events: none;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* active state */\r\ninput:focus~.highlight {\r\n  -webkit-animation: inputHighlighter 0.3s ease;\r\n  -moz-animation: inputHighlighter 0.3s ease;\r\n  animation: inputHighlighter 0.3s ease;\r\n}\r\n\r\n/* ANIMATIONS ================ */\r\n@-webkit-keyframes inputHighlighter {\r\n  from {\r\n    background: #5264AE;\r\n  }\r\n\r\n  to {\r\n    width: 0;\r\n    background: transparent;\r\n  }\r\n}\r\n\r\n@-moz-keyframes inputHighlighter {\r\n  from {\r\n    background: #5264AE;\r\n  }\r\n\r\n  to {\r\n    width: 0;\r\n    background: transparent;\r\n  }\r\n}\r\n\r\n@keyframes inputHighlighter {\r\n  from {\r\n    background: #5264AE;\r\n  }\r\n\r\n  to {\r\n    width: 0;\r\n    background: transparent;\r\n  }\r\n}\r\n\r\n.form-control.is-invalid, .was-validated .form-control:invalid {\r\n  border-top: none;\r\n  border-right: none;\r\n  border-left: none;\r\n  border-radius: 0;\r\n  color: transparent;\r\n  background-image: none;\r\n}\r\n\r\n.display-time.is-invalid, .was-validated .display-time:invalid {\r\n  border-top: none;\r\n  border-right: none;\r\n  border-left: none;\r\n  border-radius: 0;\r\n  background-image: none;\r\n}\r\n\r\n.form-control.is-invalid:focus, .was-validated .form-control:invalid:focus {\r\n  border-color: #dc3545;\r\n  box-shadow: none;\r\n  border-top: none;\r\n}\r\n\r\n.display-time.is-invalid:focus, .was-validated .display-time:invalid:focus {\r\n  border-color: #dc3545;\r\n  box-shadow: none;\r\n  border-top: none;\r\n}\r\n\r\n.form-control {\r\n  border-top: none;\r\n  border-right: none;\r\n  border-left: none;\r\n  border-radius: 0;\r\n}\r\n\r\n.display-time {\r\n  border-top: none;\r\n  border-right: none;\r\n  border-left: none;\r\n  border-radius: 0;\r\n}\r\n\r\n.form-control:focus {\r\n  color: #495057;\r\n  background-color: transparent;\r\n  border-color: black;\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.form-control:focus {\r\n  /*background-color: #00917e;\r\n  color: #000000 !important;\r\n  border: 1px solid #00917e !important;\r\n  padding: 33px;\r\n  border-radius: 50px !important;\r\n  border-top: 5px solid #008372 !important;\r\n  font-family: Regular !important;\r\n  font-weight: 700;\r\n  box-shadow: none!important;*/\r\n}\r\n\r\n.gaugeText>p {\r\n  line-height: 12%;\r\n  text-align: center;\r\n  align-items: baseline;\r\n}\r\n\r\n.gaugeText>p>small {\r\n  font-size: 10px;\r\n}\r\n\r\n.display-time:focus {\r\n  color: #00000000;\r\n  background-color: transparent;\r\n  border-color: #015325;\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n\r\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\r\n  margin: 1em 0 0.5em;\r\n  word-wrap: break-word;\r\n  -webkit-hyphens: auto;\r\n  -ms-hyphens: auto;\r\n  hyphens: auto;\r\n  overflow-wrap: break-word;\r\n  font-weight: normal;\r\n  font-family: 'Regular';\r\n  color: #333;\r\n}\r\n\r\n.btnYellow {\r\n  background: #f39324 !important;\r\n  border: none !important;\r\n}\r\n\r\n.btnYellow:hover {\r\n  color: white;\r\n  background: #cc6e00 !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.howplayImages {\r\n  max-width: 600px;\r\n}\r\n\r\n.btn-green {\r\n  background: #00897e;\r\n}\r\n\r\n.btn-xl {\r\n  padding: .55rem .35rem !important;\r\n  font-size: .715rem !important;\r\n  line-height: .9 !important;\r\n  border-radius: .3rem !important;\r\n}\r\n\r\n.btn-danger {\r\n  color: #fff !important;\r\n  background-color: #dc3545 !important;\r\n  border-color: #dc3545 !important;\r\n  text-decoration: none !important;\r\n  font-family: Regular!important;\r\n}\r\n\r\n.csLineHeight2{\r\n  line-height: 28px;\r\n}\r\n\r\n.editImageCont {\r\n  max-height: 250px;\r\n  max-width: 250px;\r\n  width: 100%;\r\n  height: 250px;\r\n  cursor: zoom-in;\r\n  object-fit: cover;\r\n}\r\n\r\n.btn-info {\r\n  color: #fff !important;\r\n  background-color: #9d9d9d !important;\r\n  border-color: #666666 !important;\r\n  text-decoration: none !important;\r\n}\r\n\r\n.swal2-icon.swal2-warning {\r\n  border-color: #FF9800;\r\n  color: #FF9800;\r\n}\r\n\r\n.mr-auto, .mx-auto {\r\n  margin-right: auto !important;\r\n  margin-top: 19px;\r\n}\r\n\r\ndt.badger-accordion__header {\r\n  background: white;\r\n  padding: .5rem;\r\n  box-shadow: 0px 0px 5px #00000078;\r\n  padding: 30px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.bordered {\r\n  /*border: 1px solid #f4f4f4;*/\r\n}\r\n\r\n.vcenter {\r\n  align-self: center;\r\n  align-items: center;\r\n  height: 100% !important;\r\n}\r\n\r\ninput.swal2-input {\r\n  max-width: 300px;\r\n}\r\n\r\n.outer {\r\n  display: table;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.swal2-shown>#app {\r\n  filter: blur(5px);\r\n}\r\n\r\n.even {\r\n  background: #00897e12 !important;\r\n  border-radius: 0px;\r\n}\r\n\r\n.middle {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n}\r\n\r\n.borderTopBlack {\r\n  border-top: 1px solid black;\r\n}\r\n\r\n.boxActive {\r\n    border: 6px solid #00897e;\r\n}\r\n\r\n.borderTopTras {\r\n  border-top: 1px solid transparent;\r\n}\r\n\r\n.inner {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 400px;\r\n  /*whatever width you want*/\r\n}\r\n\r\n.ptImage {\r\n  max-width: 150px\r\n}\r\n\r\n.viewer-list>li {\r\n  color: transparent;\r\n  cursor: pointer;\r\n  float: left;\r\n  font-size: 0;\r\n  height: 100%;\r\n  line-height: 0;\r\n  opacity: 0.5;\r\n  overflow: hidden;\r\n  -webkit-transition: opacity 0.15s;\r\n  transition: opacity 0.15s;\r\n  width: 100px;\r\n  padding: 7px;\r\n  box-shadow: inset 0px 0px 5px 0px white;\r\n  border: 3px solid white;\r\n}\r\n\r\n.greyBg {\r\n  background: lightgrey !important;\r\n}\r\n\r\n.topCust2 {\r\n  margin-top: -35px !important\r\n}\r\n\r\n.greyBg>.badger-accordion__header, .greyBg>.badger-accordion__panel .js-badger-accordion-panel-inner {\r\n  background: lightgrey !important;\r\n}\r\n.cblack{\r\n  color: black!important;\r\n}\r\n\r\n.cblack.active{\r\n    color: white!important;\r\n}\r\n.black {\r\n  color: black !important;\r\n}\r\n\r\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\r\n    margin: 1em 0 0.5em;\r\n    word-wrap: break-word!important;\r\n    -webkit-hyphens: auto!important;\r\n    -ms-hyphens: auto!important;\r\n    hyphens: auto!important;\r\n    overflow-wrap: break-word!important;\r\n    font-weight: normal!important;\r\n    font-family: Regular!important;\r\n    color: #333!important;\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {\r\n    color: #fff!important;\r\n    background-color: #00917e!important;\r\n    border-color: #00917e!important;\r\n}\r\n.btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:not(:disabled):not(.disabled):active:focus, .show>.btn-primary.dropdown-toggle:focus {\r\n    box-shadow: 0 0 0 0.2rem rgb(0 145 126)!important;\r\n}\r\n\r\n.btn-primary.focus, .btn-primary:focus {\r\n    color: #fff;\r\n    background-color: #00917e;\r\n    border-color: #00917e;\r\n    box-shadow: 0 0 0 0.2rem rgb(0 145 126);\r\n}\r\n\r\n\r\n\r\n#swal2-content {\r\n    max-height: 60vh;\r\n    overflow-y: auto;\r\n    border-bottom: 1px solid #535353;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n\r\n/*\r\n****************************************************************************\r\n        HSD\r\n******************************************************************************\r\n*/\r\n.btnHSDRed{\r\n  background: #c03!important;\r\n  border:  #c03!important;\r\n}\r\n.btnHSDRed:hover{\r\n  background: #a30029!important;\r\n}\r\n\r\n.btnBurgrHSDRed{\r\n  color: #c03!important;\r\n  background: #c03!important;\r\n  background-color: #c03!important;\r\n}\r\n\r\n.btnBurgrHSDRed > .icon-bar{\r\n    background-color: #c03!important;\r\n}\r\n\r\n\r\n.inputHSD > .form-control, .inputHSD .vdp-datepicker div>.form-control{\r\n  border-bottom: 2px solid black !important;\r\n  color: black !important;\r\n}\r\n.inputHSD>.niceInputLabel {\r\n    color: #000000 !important;\r\n    left: 5px !important;\r\n    top: 29px !important;\r\n}\r\n\r\n.inputHSD option {\r\n    background: white;\r\n    color: black;\r\n}\r\n\r\n.inputHSD optgroup {\r\n    background: #c03!important;\r\n    color: white;\r\n}\r\n\r\n.inputHSD > input:-webkit-autofill, .inputHSD > input:-webkit-autofill:hover, .inputHSD > input:-webkit-autofill:focus  textarea:-webkit-autofill, .inputHSD > textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus, .inputHSD > select:-webkit-autofill, .inputHSD > select:-webkit-autofill:hover, .inputHSD > select:-webkit-autofill:focus {\r\n    border-left: none !important;\r\n    border-right: none !important;\r\n    -webkit-text-fill-color: black !important;\r\n    -webkit-box-shadow: 0 0 0px 1000px #0000 inset;\r\n    transition: background-color 5000s ease-in-out 0s;\r\n    background: transparent;\r\n    background-color: transparent !important;\r\n}\r\n\r\n.inputHSD>.form-control:focus, .inputHSD .vdp-datepicker div>.form-control:focus {\r\n    color: black !important;\r\n    outline: none !important;\r\n    height: 70px !important;\r\n    padding: 7px !important;\r\n    padding-top: 23px !important;\r\n}\r\n\r\n.front-imageHSD > label > span:before {\r\n    content: \"+\";\r\n    display: block;\r\n    clear: both;\r\n    text-align: center;\r\n    height: 141px;\r\n    width: 179px;\r\n    border-radius: 7px;\r\n    padding-top: 51px;\r\n    font-size: 51px;\r\n    font-weight: 600;\r\n    color: #c03!important;\r\n    border: 3px solid #c03!important;\r\n}\r\n\r\n.redHSD{\r\n  color: #c03!important;\r\n}\r\n\r\n.sidetabHSD > .label{\r\n    background: #c03!important;\r\n}\r\n\r\n.btn-primary.disabled, .btn-primary:disabled {\r\n    color: #fff;\r\n    background-color: #00917e;\r\n    border-color: #00917e;\r\n}\r\n\r\n.inputLabel {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 9px;\r\n    font-size: 22px;\r\n    font-weight: bold;\r\n}\r\n\r\n.cardBox {\r\n  float: left;\r\n  font-size: 1.2em;\r\n  margin: 0 .8% 0 .8%;\r\n  perspective: 800px;\r\n  transition: all 0.3s ease 0s;\r\n  width: 47.7%;\r\n\r\n}\r\n\r\n.cardBox.is-flipped .cardFlow {\r\n  transform: rotateY( 180deg);\r\n}\r\n\r\n.cardBox.is-flipped .cardFlow .cardFooter {\r\n  transform: rotateY( 180deg);\r\n  right: auto;\r\n  left: 0px;\r\n  z-index: 15\r\n}\r\n\r\n.cardFlow {\r\n  /*background: white;*/\r\n  cursor: default;\r\n  min-height: 480px;\r\n  transform-style: preserve-3d;\r\n  position: relative;\r\n  transition: transform 0.4s ease 0s;\r\n  width: 100%;\r\n  -webkit-animation: giro 1.5s 1;\r\n  -ms-animation: giro 1.5s 1;\r\n  animation: giro 1.5s 1;\r\n\r\n\r\n}\r\n\r\n.cardFlow p {\r\n  margin-bottom: 1.8em;\r\n}\r\n\r\n.cardFlow .front,\r\n.cardFlow .back {\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  box-sizing: border-box;\r\n  color: white;\r\n  display: block;\r\n  font-size: 1.2em;\r\n  height: 100%;\r\n  padding: 0.8em;\r\n  position: absolute!important;\r\n  text-align: center;\r\n  width: 100%;\r\n  min-height: 430px;\r\n  height: 430px;\r\n  border-bottom: 1px solid grey;\r\n\r\n}\r\n.cardFlow .front{\r\n  z-index: 1;\r\n}\r\n\r\n.cardBox.is-flipped .cardFlow .back{\r\n  z-index: 2!important;\r\n}\r\n\r\n.cardFooter{\r\n  position: absolute;\r\nz-index: 3;\r\nbottom: 0;\r\nright: 0px;\r\n    width: 100%;\r\n    background: white;\r\n/*border-top: 1px solid #80808052;*/\r\npadding-left: 15px;\r\npadding-right: 15px;\r\ntext-align: right;\r\n}\r\n\r\n.cardFlow .front strong {\r\n  /*background: #fff;*/\r\n  border-radius: 100%;\r\n  color: #222;\r\n  font-size: 1.5em;\r\n  line-height: 30px;\r\n  padding: 0 7px 4px 6px;\r\n}\r\n\r\n.cardFlow .back {\r\n  transform: rotateY( 180deg);\r\n  -webkit-perspective: 900000px;\r\n}\r\n\r\n.cardFlow .back a {\r\n  padding: 0.3em 0.5em;\r\n  /*background: #333;*/\r\n  color: #fff;\r\n  text-decoration: none;\r\n  border-radius: 1px;\r\n  font-size: 0.9em;\r\n  transition: all 0.8s ease 0s;\r\n}\r\n\r\n.cardFlow .back a:hover {\r\n  background: #fff;\r\n  color: #333;\r\n  text-shadow: 0 0 1px #333;\r\n}\r\n\r\n.cardBox:nth-child(1) .cardFlow .back {\r\n  background: cornflowerblue;\r\n}\r\n\r\n.cardBox:nth-child(2) .cardFlow .back {\r\n  background: orange;\r\n}\r\n\r\n.cardBox:nth-child(3) .cardFlow .back {\r\n  background: yellowgreen;\r\n}\r\n\r\n.cardBox:nth-child(4) .cardFlow .back {\r\n  background: tomato;\r\n}\r\n\r\n.cardBox:nth-child(5) .cardFlow .back {\r\n  background: tomato;\r\n}\r\n\r\n.cardBox:nth-child(1) .cardFlow {\r\n  -webkit-animation: giro .3s 1;\r\n  animation: giro .3s 1;\r\n}\r\n\r\n.cardBox:nth-child(2) .cardFlow {\r\n  -webkit-animation: giro .4s 1;\r\n  animation: giro .4s 1;\r\n}\r\n\r\n.cardBox:nth-child(3) .cardFlow {\r\n  -webkit-animation: giro .5s 1;\r\n  animation: giro .5s 1;\r\n}\r\n\r\n.cardBox:nth-child(4) .cardFlow {\r\n  -webkit-animation: giro .6s 1;\r\n  animation: giro .6s 1;\r\n}\r\n\r\n.cardBox:nth-child(5) .cardFlow {\r\n  -webkit-animation: giro .6s 1;\r\n  animation: giro .6s 1;\r\n}\r\n\r\n\r\n@-webkit-keyframes giro {\r\n  0% {\r\n    -webkit-transform: rotateY( 179deg);\r\n    -webkit-animation-timing-function: ease-in;\r\n  }\r\n  100% {\r\n    -webkit-transform: rotateY( 0deg);\r\n    -webkit-animation-timing-function: ease-in;\r\n  }\r\n}\r\n\r\n\r\n@keyframes giro {\r\n  0% {\r\n    transform: rotateY( 180deg);\r\n    animation-timing-function: ease-in;\r\n  }\r\n  100% {\r\n    transform: rotateY( 0deg);\r\n    animation-timing-function: ease-in;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1340px) {\r\n  .cardBox {\r\n    margin-left: 2.8%;\r\n    margin-top: 3%;\r\n    width: 46%;\r\n  }\r\n  .cardFlow {\r\n    height: 285px;\r\n  }\r\n  .cardBox:last-child {\r\n    margin-bottom: 3%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 772px) {\r\n  .cardBox {\r\n    width: 94.5%;\r\n  }\r\n  .cardFlow {\r\n    height: 330px;\r\n    min-height: 330px;\r\n    min-height: 330px;\r\n  }\r\n\r\n  .cardFlow .front, .cardFlow .back {\r\n    height: 290px;\r\n    min-height: 290px;\r\n    padding: 0.1em;\r\n    padding-top: 0.4em;\r\n  }\r\n  .customNItem {\r\n    font-size: 17px;\r\n    background: white;\r\n    width: 50%;\r\n    font-size: 13px!important;\r\n    height: 117px;\r\n    border: 1px solid #cccccc;\r\n    align-items: center;\r\n    align-self: center;\r\n    align-content: center;\r\n    vertical-align: middle;\r\n    display: grid;\r\n  }\r\n\r\n  .flowTitle, .quardValue {\r\n    font-size: 17px;\r\n  }\r\n\r\n  .quardDescription {\r\n    font-size: 11px!important;\r\n  }\r\n\r\n}\r\n\r\n.newBackDesc{\r\n  color: black;\r\n  font-size: 14px;\r\n}\r\n\r\n.scrollContainer{\r\n  overflow: auto;\r\n  @media screen and (max-width: 772px) {\r\n    overflow-y: scroll;\r\n  }\r\n}\r\n\r\n.greyBg2 {\r\n    background: #eeeeee !important;\r\n}\r\n\r\n.flowBoxGrey {\r\n    width: calc(100% + 100px) !important;\r\n    margin-left: -15px !important;\r\n    background: #eeeeee !important;\r\n}\r\n\r\n.brTop{\r\n  border-top: 1px solid #80808052;\r\n}\r\n\r\n.smallTxt{\r\n  font-size: 12px;\r\n  line-height: 13px;\r\n}\r\n\r\n.red{\r\n  color: #a90000!important;\r\n}\r\n\r\n.bluetify{\r\n  background: #2196f338\r\n}\r\n\r\niframe{\r\n  min-height: 10px!important;\r\n}\r\n\r\n.underlineBox{\r\n  border-bottom: 2px solid grey;\r\n}\r\n\r\n.small2{\r\n  font-size: 14px;\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "biI2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JHcX");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2808cd68", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2a523c12\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2a523c12\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "byWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It__ = __webpack_require__("vfoj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It__);




// Merge the locales.
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].localize({ it: __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a });

// CUSTOM RULES:

// NOT USE TEMPORARY EMAIL
var emailTemporaryArray = ['10minutemail.com', '163.com', '1chuan.com', '1zhuan.com', '20minutemail.com', '21cn.com', '2prong.com', '30minutesmail.com', '4warding.com', '4warding.com', '4warding.net', '4warding.org', '675hosting.com', '675hosting.net', '675hosting.org', '6url.com', '75hosting.com', '75hosting.net', '75hosting.org', 'afrobacon.com', 'ajaxapp.net', 'amiri.net', 'amiriindustries.com', 'anonymail.dk', 'anonymbox.com', 'aol.com', 'bambooclub.cn', 'binkmail.com', 'blogmyway.org', 'bobmail.info', 'bofthew.com', 'bsnow.net', 'bugmenot.com', 'bumpymail.com', 'buyusedlibrarybooks.org', 'centermail.com', 'centermail.net', 'choicemail1.com', 'chongsoft.cn', 'chongsoft.com', 'chongsoft.org', 'cool.fr.nf', 'courriel.fr.nf', 'csoftmail.cn', 'deadspam.com', 'despam.it', 'despammed.com', 'discardmail.com', 'discardmail.de', 'dispose.it', 'disposeamail.com', 'dispostable.com', 'dodgeit.com', 'dodgit.com', 'dontreg.com', 'dontsendmespam.de', 'dotmsg.com', 'dumpandjunk.com', 'dumpmail.de', 'dunflimblag.mailexpire.com', 'e4ward.com', 'emaildienst.de', 'emailias.com', 'emailmiser.com', 'emailtemporanea.net', 'emailto.de', 'emailxfer.com', 'emz.net', 'enterto.com', 'etranquil.com', 'etranquil.net', 'etranquil.org', 'fakeinformation.com', 'fakemailz.com', 'fastacura.com', 'fastchevy.com', 'fastchrysler.com', 'fastkawasaki.com', 'fastmazda.com', 'fastmitsubishi.com', 'fastnissan.com', 'fastsubaru.com', 'fastsuzuki.com', 'fasttoyota.com', 'fastyamaha.com', 'filzmail.com', 'filzmail.com', 'footard.com', 'forgetmail.com', 'front14.org', 'fuckingduh.com', 'fux0ringduh.com', 'getonemail.com', 'ghosttexter.de', 'gishpuppy.com', 'gowikibooks.com', 'gowikicampus.com', 'gowikicars.com', 'gowikifilms.com', 'gowikigames.com', 'gowikimusic.com', 'gowikinetwork.com', 'gowikitravel.com', 'gowikitv.com', 'greensloth.com', 'guerrillamail.com', 'guerrillamail.net', 'guerrillamailblock.com', 'h8s.org', 'haltospam.com', 'hatespam.org', 'hidemail.de', 'hush.ai', 'i-b2c.com', 'iheartspam.org', 'imstations.com', 'incognitomail.net', 'ipoo.org', 'iwi.net', 'jetable.com', 'jetable.fr.nf', 'jetable.fr.nf', 'jetable.net', 'jetable.org', 'jnxjn.com', 'justonemail.net', 'kasmail.com', 'killmail.com', 'killmail.net', 'klassmaster.com', 'klassmaster.net', 'klzlk.com', 'legworld.cn', 'letmymail.com', 'lhsdv.com', 'link2mail.net', 'lortemail.dk', 'lovemeleaveme.com', 'lroid.com', 'mail.ru', 'mail2rss.org', 'mail333.com', 'mailblocks.com', 'mailcatch.com', 'maileater.com', 'mailexpire.com', 'mailfreeonline.com', 'mailin8r.com', 'mailinator.com', 'mailinator2.com', 'mailmetrash.com', 'mailmoat.com', 'mailnesia.com', 'mailnull.com', 'mailquack.com', 'mailshell.com', 'mailsiphon.com', 'mailslapping.com', 'mailtemp.net', 'mailzilla.com', 'mega.zik.dj', 'mega.zik.dj', 'meinspamschutz.de', 'meltmail.com', 'messagebeamer.de', 'mintemail.com', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'mt2009.com', 'myspaceinc.com', 'myspaceinc.net', 'myspaceinc.org', 'myspacepimpedup.com', 'myspamless.com', 'mytrashmail.com', 'neomailbox.com', 'nepwk.com', 'nervmich.net', 'nervtmich.net', 'netmails.com', 'netmails.net', 'netzidiot.de', 'nobulk.com', 'noclickemail.com', 'nomail.xl.cx', 'nospam.ze.tc', 'nospamfor.us', 'nurfuerspam.de', 'nwldx.com', 'onemoremail.net', 'oneoffemail.com', 'oneoffmail.com', 'oopi.org', 'ourklips.com', 'outlawspam.com', 'owlpic.com', 'pancakemail.com', 'pc1520.com', 'pimpedupmyspace.com', 'pjjkp.com', 'poofy.org', 'pookmail.com', 'privacy.net', 'prtnx.com', 'punkass.com', 'recyclemail.dk', 'rejectmail.com', 'rklips.com', 'safersignup.de', 'seorj.cn', 'sharklasers.com', 'shiftmail.com', 'shortmail.net', 'sibmail.com', 'sina.com', 'siteposter.net', 'slaskpost.se', 'slopsbox.com', 'sneakemail.com', 'sofimail.com', 'sofort-mail.de', 'sogetthis.com', 'sohu.com', 'spam.la', 'spam.su', 'spamavert.com', 'spambob.com', 'spambob.net', 'spambob.org', 'spambog.com', 'spambog.de', 'spambox.us', 'spamcon.org', 'spamcorptastic.com', 'spamday.com', 'spamex.com', 'spamexperts.com', 'spamfree24.com', 'spamfree24.net', 'spamfree24.org', 'spamgourmet.com', 'spamhole.com', 'spamhouse.com', 'spamify.com', 'spaminator.de', 'spaml.com', 'spammotel.com', 'spamoff.de', 'spamslicer.com', 'spamsphere.com', 'spamtrail.com', 'speed.1s.fr', 'teleworm.com', 'tempemail.net', 'tempinbox.com', 'tempmail.it', 'tempomail.fr', 'temporarily.de', 'temporaryforwarding.com', 'temporaryinbox.com', 'thankyou2010.com', 'tom.com', 'tracciabi.li', 'trash2009.com', 'trashdevil.com', 'trashdevil.de', 'trashmail.com', 'trashmail.de', 'trash-mail.de', 'trashmail.net', 'trashmail.org', 'trashymail.com', 'turual.com', 'twinmail.de', 'tyldd.com', 'uggsrock.com', 'upliftnow.com', 'uplipht.com', 'uymail.com', 'venompen.com', 'viditag.com', 'viewcastmedia.com', 'viewcastmedia.net', 'viewcastmedia.org', 'visit.onlatedotcom.info', 'walala.org', 'wegwerfadresse.de', 'wetrainbayarea.com', 'wetrainbayarea.org', 'wh4f.org', 'whopy.com', 'wilemail.com', 'willselfdestruct.com', 'wormseo.cn', 'wuzup.net', 'wwwnew.eu', 'xagloo.com', 'xemaps.com', 'xents.com', 'xmaily.com', 'yep.it', 'yopmail.com', 'yopmail.fr', 'yopmail.fr', 'yopmail.net', 'youumail.com', 'zoemail.org', 'MakeMeTheKing.com', 'tempemail.co.za', 'mail-temp.com', 'emailthrow.net ', 'rppkn.com', 'incognitomail.org', 'email60.com', 'rtrtr.com'];
var temporaryEmail = {
	getMessage: function getMessage(field) {
		return 'Le email temporanee non sono consentite';
	},
	validate: function validate(value) {
		var domain = value.split('@');
		var count = domain.length;
		domain = domain[count - 1];
		if (emailTemporaryArray.indexOf(domain) !== -1) {
			return false;
		} else {
			return true;
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('temporaryEmail', temporaryEmail);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { temporaryEmail: function temporaryEmail(field) {
		return 'Le email temporanee non sono consentite';
	} });

// PASSWORD SECURITY CHECK
var checkImei = {
	getMessage: function getMessage(field) {
		return 'Codice IMEI non valido.';
	},
	validate: function validate(value) {
		var use_checksum = true;
		var sum = 0;
		if (jQuery.type(value) === "string") {
			if (value.match('^[0-9]{15}$')) {
				if (!use_checksum) return true;

				for (var i = 0, sum = 0; i < 14; i++) {
					var tmp = value[i] * (i % 2 + 1);
					sum += tmp % 10 + parseInt(tmp / 10);
				}
				return (10 - sum % 10) % 10 == value[14];
			} else {
				if (value == '') {
					return true;
				} else {
					return false;
				}
			}
		} else {
			if (value == '') {
				return true;
			} else {
				return false;
			}
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('checkImei', checkImei);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { checkImei: function checkImei(field) {
		return 'Codice IMEI non valido.';
	} });

// EMAIL CHECK PLUS + CHARACTER ( FOR GMAIL....+1@gmail.com )
var plusIssueEmail = {
	getMessage: function getMessage(field) {
		return 'L`indirizzo email contiene caratteri non consentiti';
	},
	validate: function validate(value) {
		var str = value;
		if (str.indexOf('+') == -1) {
			return true;
		} else {
			return false;
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('plusIssueEmail', plusIssueEmail);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { plusIssueEmail: function plusIssueEmail(field) {
		return 'L`indirizzo email contiene caratteri non consentiti';
	} });

// PASSWORD SECURITY CHECK
var passwordCheck = {
	getMessage: function getMessage(field) {
		return 'La password deve essere composta da lettere e numeri.';
	},
	validate: function validate(value) {
		if (!/[a-z]/.test(value)) {
			return false;
		} else if (!/[0-9]/.test(value)) {
			return false;
		}
		return true;
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('passwordCheck', passwordCheck);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { passwordCheck: function passwordCheck(field) {
		return 'La password deve essere composta da lettere e numeri.';
	} });

// PASSWORD SECURITY CHECK
var emptyTime = {
	getMessage: function getMessage(field) {
		return 'Il campo Ora è richiesto.';
	},
	validate: function validate(value) {
		if (value.HH == '' || value.mm == '') {
			return false;
		}
		return true;
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('emptyTime', emptyTime);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { emptyTime: function emptyTime(field) {
		return 'Il campo Ora è richiesto.';
	} });

// NEW VALIDATE RULE FOR PARTITA IVA
var partitaIva = {
	getMessage: function getMessage(field) {
		return 'Partita IVA non valida';
	},
	validate: function validate(value) {
		var pi = value;
		if (pi.length == 11) {

			var s = 0;
			for (i = 0; i <= 9; i += 2) {
				s += pi.charCodeAt(i) - '0'.charCodeAt(0);
			}for (var i = 1; i <= 9; i += 2) {
				var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
				if (c > 9) c = c - 9;
				s += c;
			}
			var atteso = (10 - s % 10) % 10;
			if (atteso != pi.charCodeAt(10) - '0'.charCodeAt(0)) {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('partitaIva', partitaIva);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { partitaIva: function partitaIva(field) {
		return 'Partita IVA non valida.';
	} });

// IBAN CHECK
var ibanControl = {
	getMessage: function getMessage(field) {
		return 'Il campo Iban non é corretto.';
	},
	validate: function validate(value) {

		// Remove spaces and to upper case
		var iban = value.replace(/ /g, "").toUpperCase(),
		    ibancheckdigits = "",
		    leadingZeroes = true,
		    cRest = "",
		    cOperator = "",
		    countrycode,
		    ibancheck,
		    charAt,
		    cChar,
		    bbanpattern,
		    bbancountrypatterns,
		    ibanregexp,
		    i,
		    p;

		// Check for IBAN code length.
		// It contains:
		// country code ISO 3166-1 - two letters,
		// two check digits,
		// Basic Bank Account Number (BBAN) - up to 30 chars
		var minimalIBANlength = 5;
		if (iban.length < minimalIBANlength) {
			return false;
		}

		// Check the country code and find the country specific format
		countrycode = iban.substring(0, 2);
		bbancountrypatterns = {
			"AL": "\\d{8}[\\dA-Z]{16}",
			"AD": "\\d{8}[\\dA-Z]{12}",
			"AT": "\\d{16}",
			"AZ": "[\\dA-Z]{4}\\d{20}",
			"BE": "\\d{12}",
			"BH": "[A-Z]{4}[\\dA-Z]{14}",
			"BA": "\\d{16}",
			"BR": "\\d{23}[A-Z][\\dA-Z]",
			"BG": "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
			"CR": "\\d{17}",
			"HR": "\\d{17}",
			"CY": "\\d{8}[\\dA-Z]{16}",
			"CZ": "\\d{20}",
			"DK": "\\d{14}",
			"DO": "[A-Z]{4}\\d{20}",
			"EE": "\\d{16}",
			"FO": "\\d{14}",
			"FI": "\\d{14}",
			"FR": "\\d{10}[\\dA-Z]{11}\\d{2}",
			"GE": "[\\dA-Z]{2}\\d{16}",
			"DE": "\\d{18}",
			"GI": "[A-Z]{4}[\\dA-Z]{15}",
			"GR": "\\d{7}[\\dA-Z]{16}",
			"GL": "\\d{14}",
			"GT": "[\\dA-Z]{4}[\\dA-Z]{20}",
			"HU": "\\d{24}",
			"IS": "\\d{22}",
			"IE": "[\\dA-Z]{4}\\d{14}",
			"IL": "\\d{19}",
			"IT": "[A-Z]\\d{10}[\\dA-Z]{12}",
			"KZ": "\\d{3}[\\dA-Z]{13}",
			"KW": "[A-Z]{4}[\\dA-Z]{22}",
			"LV": "[A-Z]{4}[\\dA-Z]{13}",
			"LB": "\\d{4}[\\dA-Z]{20}",
			"LI": "\\d{5}[\\dA-Z]{12}",
			"LT": "\\d{16}",
			"LU": "\\d{3}[\\dA-Z]{13}",
			"MK": "\\d{3}[\\dA-Z]{10}\\d{2}",
			"MT": "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
			"MR": "\\d{23}",
			"MU": "[A-Z]{4}\\d{19}[A-Z]{3}",
			"MC": "\\d{10}[\\dA-Z]{11}\\d{2}",
			"MD": "[\\dA-Z]{2}\\d{18}",
			"ME": "\\d{18}",
			"NL": "[A-Z]{4}\\d{10}",
			"NO": "\\d{11}",
			"PK": "[\\dA-Z]{4}\\d{16}",
			"PS": "[\\dA-Z]{4}\\d{21}",
			"PL": "\\d{24}",
			"PT": "\\d{21}",
			"RO": "[A-Z]{4}[\\dA-Z]{16}",
			"SM": "[A-Z]\\d{10}[\\dA-Z]{12}",
			"SA": "\\d{2}[\\dA-Z]{18}",
			"RS": "\\d{18}",
			"SK": "\\d{20}",
			"SI": "\\d{15}",
			"ES": "\\d{20}",
			"SE": "\\d{20}",
			"CH": "\\d{5}[\\dA-Z]{12}",
			"TN": "\\d{20}",
			"TR": "\\d{5}[\\dA-Z]{17}",
			"AE": "\\d{3}\\d{16}",
			"GB": "[A-Z]{4}\\d{14}",
			"VG": "[\\dA-Z]{4}\\d{16}"
		};

		bbanpattern = bbancountrypatterns[countrycode];

		// As new countries will start using IBAN in the
		// future, we only check if the countrycode is known.
		// This prevents false negatives, while almost all
		// false positives introduced by this, will be caught
		// by the checksum validation below anyway.
		// Strict checking should return FALSE for unknown
		// countries.
		if (typeof bbanpattern !== "undefined") {
			ibanregexp = new RegExp("^[A-Z]{2}\\d{2}" + bbanpattern + "$", "");
			if (!ibanregexp.test(iban)) {
				return false; // Invalid country specific format
			}
		}

		// Now check the checksum, first convert to digits
		ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
		for (i = 0; i < ibancheck.length; i++) {
			charAt = ibancheck.charAt(i);
			if (charAt !== "0") {
				leadingZeroes = false;
			}
			if (!leadingZeroes) {
				ibancheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(charAt);
			}
		}

		// Calculate the result of: ibancheckdigits % 97
		for (p = 0; p < ibancheckdigits.length; p++) {
			cChar = ibancheckdigits.charAt(p);
			cOperator = "" + cRest + "" + cChar;
			cRest = cOperator % 97;
		}
		return cRest === 1;
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('ibanControl', ibanControl);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { ibanControl: function ibanControl(field) {
		return 'Il campo Iban non é corretto.';
	} });

// IBAN ITALIAN
var ibanItalian = {
	getMessage: function getMessage(field) {
		return 'Non si tratta di un iban italiano.';
	},
	validate: function validate(value) {
		if (value == '') {
			return true;
		} else {
			if (value) {

				var lower = value.toLowerCase();

				//console.log( lower.indexOf("it") )
				if (lower.indexOf("it") == 0) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('ibanItalian', ibanItalian);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { ibanItalian: function ibanItalian(field) {
		return 'Non si tratta di un iban italiano.';
	} });

// NEW VALIDATE RULE FOR IBAN
var ibanPoste = {
	getMessage: function getMessage(field) {
		return 'IBAN inserito non risulta essere un IBAN di BancoPosta Business';
	},
	validate: function validate(value) {
		// Remove spaces and to upper case
		var iban = value.replace(/ /g, "").toUpperCase();
		if (iban.substring(5, 10) == '07601') {
			return true;
		} else {
			return false;
		}
	}
};

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('ibanPoste', ibanPoste);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { ibanPoste: function ibanPoste(field) {
		return 'IBAN inserito non risulta essere un IBAN di BancoPosta Business .';
	} });

// PASSWORD SECURITY CHECK
var codiceFiscale = {
	getMessage: function getMessage(field) {
		return 'Codice Fiscale non valido.';
	},
	validate: function validate(value) {
		var cf = value;
		var validi, i, s, set1, set2, setpari, setdisp;
		if (cf == '') {
			return '';
		}
		cf = cf.toUpperCase();

		if (cf.length != 16) {
			return false;
		}

		validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		for (i = 0; i < 16; i++) {
			if (validi.indexOf(cf.charAt(i)) == -1) {
				return false;
			}
		}
		set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
		setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
		s = 0;
		for (i = 1; i <= 13; i += 2) {
			s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
		}

		for (i = 0; i <= 14; i += 2) {
			s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
		}

		if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0)) {
			return false;
		} else {
			return true;
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('codiceFiscale', codiceFiscale);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { codiceFiscale: function codiceFiscale(field) {
		return 'Codice Fiscale non valido.';
	} });

// VEE VALIDATE CONFIG
var config = {
	aria: true,
	classNames: {},
	classes: false,
	delay: 0,
	dictionary: {
		it: __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a
	},
	errorBagName: 'errors', // change if property conflicts
	events: 'input|blur',
	fieldsBagName: 'fields',
	i18n: null, // the vue-i18n plugin instance
	i18nRootKey: 'validations', // the nested key under which the validation messages will be located
	inject: true,
	locale: 'it',
	validity: false,
	useConstraintAttrs: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
	config: config,
	core: __WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "ckMO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/traficLight_red.1d40c8f.png";

/***/ }),

/***/ "cley":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vIh7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("177570ae", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-866a5c7c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./practicesToDo.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-866a5c7c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./practicesToDo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ctsv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/moreHSD.c5d4676.jpg";

/***/ }),

/***/ "dF35":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/regitem.02f47e5.png";

/***/ }),

/***/ "dJ7y":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-10101776] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.custSize[data-v-10101776] {\n  max-width: 100px;\n}\n.borderTop[data-v-10101776] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-10101776] {\n  width: 75px;\n}\n.bigTitle[data-v-10101776] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-10101776] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-10101776] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-10101776] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-10101776] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-10101776] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-10101776] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-10101776] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-10101776] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-10101776] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-10101776] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-10101776] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-10101776] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-10101776] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-10101776] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-10101776] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-10101776]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-10101776] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-10101776] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-10101776]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-10101776]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-10101776]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-10101776] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-10101776] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-10101776] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "dPwX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.regulationContainer[data-v-648fb19c]{\n\tfont-size: 18px;\n}\n.page__title[data-v-648fb19c]{\n\tfont-size: 18px!important;\n\tfont-weight: 800;\n}\n.navigation[data-v-648fb19c] {\n\tposition: fixed;\n\tbottom: 0;\n\tbackground: #fffbde;\n\tcolor: #8a222f;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 5px;\n\tfont-size: 22px;\n\ttext-align: center;\n}\n.navItem[data-v-648fb19c] {\n\tmargin: 10px;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.regulationContainer[data-v-648fb19c]{\n\t\tfont-size: 14px;\n}\n.col-md-4.text-right[data-v-648fb19c]{\n\t\ttext-align: left!important;\n}\n.navigation[data-v-648fb19c] {\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "du22":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.regulationContainer[data-v-711de7bd]{\n\tfont-size: 18px;\n}\n.page__title[data-v-711de7bd]{\n\tfont-size: 18px!important;\n\tfont-weight: 800;\n}\n.navigation[data-v-711de7bd] {\n\tposition: fixed;\n\tbottom: 0;\n\tbackground: #fffbde;\n\tcolor: #8a222f;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 5px;\n\tfont-size: 22px;\n\ttext-align: center;\n}\n.navItem[data-v-711de7bd] {\n\tmargin: 10px;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.regulationContainer[data-v-711de7bd]{\n\t\tfont-size: 14px;\n}\n.col-md-4.text-right[data-v-711de7bd]{\n\t\ttext-align: left!important;\n}\n.navigation[data-v-711de7bd] {\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "dzjw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("sCpE");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e54a57ea", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-249074c3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-249074c3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "e0x8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact.260a83b.jpg";

/***/ }),

/***/ "en44":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("du22");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1d2c0314", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-711de7bd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-711de7bd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "fcBF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("noPh");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3445f528", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-03a5036f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-03a5036f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "fjxO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/50_hsd.f50c4fe.png";

/***/ }),

/***/ "flBD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.quardDescription.center.mb-0[data-v-3c2a4680] {\n  font-size: 15px;\n}\n", ""]);

// exports


/***/ }),

/***/ "ftX1":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.vaillantCont[data-v-baeb6964] {\n  height: 100%;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "gCMD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ "gEuQ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oNvF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2b0789e1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-42d13b52\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-42d13b52\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hEAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/badger-accordion/dist/badger-accordion.esm.js
var badger_accordion_esm = __webpack_require__("pQNc");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordion.vue

//
//
//
//
//
//



// Helper-function to unwrap child-component-wrapper
function unwrap(wrapper) {
    // place childNodes in document fragment
    var docFrag = document.createDocumentFragment();
    while (wrapper.firstChild) {
        var child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
    }

    // replace wrapper with document fragment
    wrapper.parentNode.replaceChild(docFrag, wrapper);
}

/* harmony default export */ var BadgerAccordion = ({
    name: 'BadgerAccordion',
    props: {
        options: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        icons: {
            default: function _default() {
                return { opened: '-', closed: '+' };
            }
        },
        iconComponent: {
            default: null
        }
    },
    data: function data() {
        return {
            accordion: null,
            itemsReady: false,
            show: true,
            rerendering: false,
            children: this.$children
        };
    },

    watch: {
        "accordion.states": {
            handler: function handler(states) {
                this.calculateAllPanelsHeight();
                this.$children.forEach(function (child, n) {
                    if (typeof_default()(states[n]) == 'object') {
                        child.changeState(states[n].state == 'open');
                    }
                });
            },

            deep: true
        }
    },
    created: function created() {
        var _this = this;

        // On child-item rendered initiate badger-accordion
        this.$on('item:ready', function () {
            // Unwrap child-wrapper due issues with badger-accordion
            unwrap(_this.$refs.badger.querySelector('.badger-accordion-item'));
            // Init badger-accordion if child-component is loaded
            _this.accordion = new badger_accordion_esm["a" /* default */](_this.$refs.badger, _this.options || {});
            _this.$forceUpdate();
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$watch(function () {
            return _this2.children.length;
        }, function (items) {
            _this2.rerender();
        });
    },


    methods: {
        init: function init() {
            this.accordion.init();
        },
        getState: function getState() {
            var headerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            return this.accordion.getState(headerIds);
        },
        open: function open(headerIndex) {
            this.accordion.open(headerIndex);
        },
        close: function close(headerIndex) {
            this.accordion.close(headerIndex);
        },
        togglePanel: function togglePanel(animationAction, headerIndex) {
            this.accordion.togglePanel(animationAction, headerIndex);
        },
        openAll: function openAll() {
            this.accordion.openAll();
        },
        closeAll: function closeAll() {
            this.accordion.closeAll();
        },
        calculateAllPanelsHeight: function calculateAllPanelsHeight() {
            this.accordion.calculateAllPanelsHeight();
        },
        calculatePanelHeight: function calculatePanelHeight(panel) {
            this.accordion.calculatePanelHeight(panel);
        },
        rerender: function rerender() {
            var _this3 = this;

            if (!this.rerendering) {
                this.rerendering = true;
                this.show = false;
                this.$nextTick(function () {
                    _this3.show = true;
                    _this3.$nextTick(function () {
                        _this3.rerendering = false;
                    });
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17205bd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordion.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "dl",
        { ref: "badger", staticClass: "component-badger-accordion" },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_BadgerAccordion = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17205bd2", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vue-badger-accordion/src/BadgerAccordion.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  BadgerAccordion,
  src_BadgerAccordion,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-badger-accordion/src/BadgerAccordion.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17205bd2", Component.options)
  } else {
    hotAPI.reload("data-v-17205bd2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vue_badger_accordion_src_BadgerAccordion = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iExx":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("flBD");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9db7d356", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c2a4680\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c2a4680\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "iKmc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dJ7y");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("61269bd4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-10101776\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./delegaForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-10101776\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./delegaForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "iedL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-415b2084] {\n  font-size: 26px;\n}\n.imageIcons[data-v-415b2084] {\n\t\tvertical-align: bottom!important;\n\t\twidth: 50px;\n}\n.hSize[data-v-415b2084] {\n    font-size: 33px!important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-415b2084] {\n\t\tmax-width: 333px;\n\t\ttext-align: left;\n\t\tmargin: 0 auto;\n\t\tline-height: 27px;\n\t\tpadding-left: 61px;\n}\n\n\n\t/* new PRICE */\n.swal2-popup .swal2-title[data-v-415b2084], #swal2-content[data-v-415b2084] {\n\t\tcolor: #fffbde!important;\n\t\tdisplay: block!important;\n}\n.replaceButton[data-v-415b2084]{\n\t\tmax-width: 40px;\n}\n.inputHelper[data-v-415b2084]{\n    margin-top: -32px;\n    color: #0e3d8b;\n    font-size: 16px;\n    left: 0;\n}\n.priceVal[data-v-415b2084], .priceCent[data-v-415b2084]{\n\t\twidth: calc(50% - 1.5vw - 7.5px);\n\t\tdisplay: inline-table;\n}\n.pseudoEuro[data-v-415b2084] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n}\n.pseudoCent[data-v-415b2084] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n\t\tright:0;\n}\n.group input:focus + .pseudoEuro[data-v-415b2084] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoEuro[data-v-415b2084]{\n\t\tdisplay:block;\n}\n.group input:focus + .pseudoCent[data-v-415b2084] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoCent[data-v-415b2084]{\n\t\tdisplay:block;\n}\n.euroInput[data-v-415b2084]{\n\t\tposition: relative;\n\t\twidth:200%;\n\t\tz-index: 4;\n}\n.euroInput[data-v-415b2084]::before{\n\t\tcontent: 'Euro';\n}\n.euroInput[data-v-415b2084]:focus, .euroInput.valid[data-v-415b2084]{\n\t\twidth:100%;\n}\n.euroInput[data-v-415b2084]:focus::before, .euroInput.valid[data-v-415b2084]::before{\n\t\tcontent: 'Euro';\n\t\tcolor: white;\n\t\tposition: absolute;\n}\n.table[data-v-415b2084]{\n\t\tdisplay: table;\n}\n.newPriceLabel[data-v-415b2084]{\n\t\tz-index: 5;\n\t\tbackground: white;\n\t\tmargin-left: -5px;\n\t\tpadding-left: 5px;\n\t\toverflow: initial;\n\t\tmin-width: calc(200% + 17px);\n}\n\n\n\t/*  ------------ */\n.image-margin0[data-v-415b2084]{\n\t\tmargin: 0!important;\n}\n.helper[data-v-415b2084]{\n\t\tcolor: #0e3d8b;\n\t\tfont-size: 23px;\n\t\tfont-family: Oswald-Medium;\n}\n.greyDesc2[data-v-415b2084]{\n\t\tfont-size: 1.1vw;\n\t\tcolor: #fffbde;\n}\n.redDesc[data-v-415b2084]{\n\t\tfont-size: 1.1vw;\n\t\ttext-decoration: underline;\n\t\tcursor: pointer;\n}\n.uploadDone[data-v-415b2084] {\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\tright: 0;\n\t\tcolor: #a1614f;\n}\n.helperUnderline[data-v-415b2084] {\n}\n.labelFileInput[data-v-415b2084]{\n\t\ttop: -20px!important;\n\t\tfont-size: 22px;\n\t\tcolor: #000000;\n}\n.fileInput[data-v-415b2084]{\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\ttop: 17px;\n\t\tborder-bottom: none;\n\t\tcolor: #000000;\n}\n.fileInputLabel[data-v-415b2084]{\n\t\tz-index: 3;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\tpadding-right: 20px;\n\t\ttext-overflow: ellipsis;\n\t\tcolor: #fffbde;\n}\n.removeProduct[data-v-415b2084]{\n\t\tposition: absolute;\n\t\tright: 21px;\n\t\tmargin: 0px!important;\n\t\ttop: 48px;\n\t\tcolor: #e7201d;\n}\n.typeDisabled[data-v-415b2084]{\n\t\tcolor: #676767;\n\t\tcursor: pointer;\n}\n.typeSelected[data-v-415b2084] {\n\t\tcolor: #fffbde!important;\n\t\tcursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-415b2084] {\n      margin-top: -12px;\n      color: #0e3d8b;\n      font-size: 16px;\n      left: 0;\n}\n.hSize[data-v-415b2084] {\n      font-size: 19px!important;\n}\n.sweetText[data-v-415b2084] {\n      font-size: 19px;\n}\n.removeProduct[data-v-415b2084]{\n    position: absolute;\n    right: 21px;\n    margin: 0px!important;\n    top: 26px;\n    color: #e7201d;\n}\n.greyDesc2[data-v-415b2084], .redDesc[data-v-415b2084]{\n\t\t\tfont-size: 3.1vw;\n}\n.fluid[data-v-415b2084] {\n\t\t\tmax-width: 107px;\n}\n.mobTQ[data-v-415b2084]{\n\t\t\tfont-size: 23px;\n}\n.smMob[data-v-415b2084]{\n\t\t\tfont-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-415b2084] {\n\t\t\tmax-width: 350px;\n\t\t\ttext-align: left;\n\t\t\tmargin: 0 auto;\n\t\t\tline-height: 27px;\n\t\t\tpadding-left: 43px;\n\t\t\tfont-size: 17px;\n}\n.helper[data-v-415b2084] {\n\t\t\tcolor: #0e3d8b;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: Oswald-Medium;\n}\n.imageIcons[data-v-415b2084] {\n\t\t\tvertical-align: bottom!important;\n\t\t\twidth: 39px;\n}\n.fileInput[data-v-415b2084] {\n\n\t\t\ttop: 8px!important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-415b2084]{\n\t\t\t top: -250%;\n}\n}\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "jmdN":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oCBP");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3465d5e8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-54242612\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./practicesinWork.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-54242612\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./practicesinWork.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jmlf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/error_icon.3964004.png";

/***/ }),

/***/ "kKOV":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.quardDescription.center.mb-0[data-v-4f06c4c4] {\n  font-size: 15px;\n}\n", ""]);

// exports


/***/ }),

/***/ "kMKJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.swal2-popup.swal2-modal.swal2-show[data-v-bcfb22e0] {\n  background: var(--popupbg) !important;\n}\n.fileNameText[data-v-bcfb22e0] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-bcfb22e0] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-bcfb22e0] {\n  width: 75px;\n}\n.bigTitle[data-v-bcfb22e0] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-bcfb22e0] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-bcfb22e0] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-bcfb22e0] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-bcfb22e0] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-bcfb22e0] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-bcfb22e0] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-bcfb22e0] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-bcfb22e0] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-bcfb22e0] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-bcfb22e0] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-bcfb22e0] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-bcfb22e0] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-bcfb22e0] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-bcfb22e0] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-bcfb22e0] {\n      background-color: #dee6ff;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: 1px solid white;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-bcfb22e0]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-bcfb22e0] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-bcfb22e0] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-bcfb22e0]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-bcfb22e0]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-bcfb22e0]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-bcfb22e0] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-bcfb22e0] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-bcfb22e0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "ki2I":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.azzure[data-v-62fe346e]{\n\t\tcolor: #0490a5!important;\n}\n.footer__social .social[data-v-62fe346e] {\n\n    padding: 0.1rem 0;\n    display: block;\n}\n.social[data-v-62fe346e] {\n    margin: 0 -0.25rem;\n    list-style: none;\n    padding: 0;\n    font-size: 0;\n}\n.footer__social .social [class^=\"social__\"][data-v-62fe346e] {\n    padding: 0 0.25rem 0.1rem;\n    display: inline-block;\n    float: none;\n    font-size: 0;\n}\n.social>li>a[data-v-62fe346e] {\n    display: block;\n    background-size: 100% 100%;\n    text-indent: -99em;\n    overflow: hidden;\n    width: 32px;\n    height: 32px;\n}\n.footerText[data-v-62fe346e]{\n\t\tfont-size: 14px;\n\t\tmargin-bottom: 0px;\n}\n.footerBrownDesc[data-v-62fe346e] {\n\t\tcolor: #000000;\n\t\tfont-family: museo-slab;\n\t\tfont-size:16px\n}\n.footerImageRight[data-v-62fe346e]{\n\t\ttext-align: right;\n}\n.support[data-v-62fe346e]{\n\t\tcolor: #000000;\n\t\tfont-size: 16px;\n}\n.techImage[data-v-62fe346e]{\n\t\twidth: 90%;\n}\n.tech[data-v-62fe346e] {\n\t\tposition: absolute;\n\t\ttop: -80px;\n\t\tleft: -80px;\n\t\tfont-size: small;\n}\n.bottomBrand[data-v-62fe346e]{\n\n\t\tpadding: 28px;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.footerImageRight[data-v-62fe346e]{\n\t\t\ttext-align: left;\n}\n.footerText[data-v-62fe346e]{\n\t\t\tfont-size: 12px;\n\t\t\tmargin-bottom: 0px;\n}\n.tech[data-v-62fe346e] {\n\t\t\ttop: -100px;\n}\n.bottomBrand[data-v-62fe346e]{\n\t\t\twidth: 27vw;\n\t\t\tpadding-top: 10px;\n\t\t\tpadding: 10px;\n}\n.footer[data-v-62fe346e] {\n\t\t\tmargin-top: -306px;\n\t     height: auto;\n}\n.alignBottomMobile[data-v-62fe346e]{\n\t\t\t-ms-flex-item-align: end;\n\t\t\t    align-self: flex-end;\n}\n.techImage[data-v-62fe346e] {\n\t\t\twidth: 59%;\n}\n.tech[data-v-62fe346e] {\n\t\t\ttop: -60px;\n\t\t\tleft: -57px;\n\t\t\twidth: 172px;\n}\n.footerBrownDesc[data-v-62fe346e][data-v-62fe346e] {\n\t\t\tcolor: #000000;\n\t\t\tfont-family: museo-slab;\n\t\t\tfont-size: 13px;\n}\n.support[data-v-62fe346e][data-v-62fe346e] {\n\t\t\tcolor: #000000;\n\t\t\tfont-size: 11px;\n}\n}\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "l+T2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "time-picker" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.displayTime,
          expression: "displayTime"
        }
      ],
      staticClass: "display-time",
      attrs: { id: _vm.id, type: "text", readonly: "" },
      domProps: { value: _vm.displayTime },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggleDropdown($event)
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.displayTime = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    !_vm.hideClearButton
      ? _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showDropdown && _vm.showClearBtn,
                expression: "!showDropdown && showClearBtn"
              }
            ],
            staticClass: "clear-btn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.clearTime($event)
              }
            }
          },
          [_vm._v("×")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showDropdown
      ? _c("div", {
          staticClass: "time-picker-overlay",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleDropdown($event)
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDropdown,
            expression: "showDropdown"
          }
        ],
        staticClass: "dropdown"
      },
      [
        _c("div", { staticClass: "select-list" }, [
          _c(
            "ul",
            { staticClass: "hours" },
            [
              _c("li", {
                staticClass: "hint",
                domProps: { textContent: _vm._s(_vm.hourType) }
              }),
              _vm._v(" "),
              _vm._l(_vm.hours, function(hr) {
                return _c("li", {
                  class: { active: _vm.hour === hr },
                  domProps: { textContent: _vm._s(hr) },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.select("hour", hr)
                    }
                  }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "minutes" },
            [
              _c("li", {
                staticClass: "hint",
                domProps: { textContent: _vm._s(_vm.minuteType) }
              }),
              _vm._v(" "),
              _vm._l(_vm.minutes, function(m) {
                return _c("li", {
                  class: { active: _vm.minute === m },
                  domProps: { textContent: _vm._s(m) },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.select("minute", m)
                    }
                  }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.secondType
            ? _c(
                "ul",
                { staticClass: "seconds" },
                [
                  _c("li", {
                    staticClass: "hint",
                    domProps: { textContent: _vm._s(_vm.secondType) }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.seconds, function(s) {
                    return _c("li", {
                      class: { active: _vm.second === s },
                      domProps: { textContent: _vm._s(s) },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.select("second", s)
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.apmType
            ? _c(
                "ul",
                { staticClass: "apms" },
                [
                  _c("li", {
                    staticClass: "hint",
                    domProps: { textContent: _vm._s(_vm.apmType) }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.apms, function(a) {
                    return _c("li", {
                      class: { active: _vm.apm === a },
                      domProps: { textContent: _vm._s(a) },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.select("apm", a)
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4588f32", esExports)
  }
}

/***/ }),

/***/ "l+gf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("UuNy");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3e50e643", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c4588f32\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./vue-timepicker.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c4588f32\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./vue-timepicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "lT51":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.borderRed[data-v-ff98e3f4] {\n  border: 3px solid black;\n}\n.errorIcon[data-v-ff98e3f4] {\n  max-width: 150px;\n  margin: 0 auto;\n}\n.linkImage[data-v-ff98e3f4] {\n  max-width: 150px;\n}\n", ""]);

// exports


/***/ }),

/***/ "mJhL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/arial.6dd6913.otf";

/***/ }),

/***/ "mLBv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/65_hsd.26affaa.png";

/***/ }),

/***/ "muof":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/accountHSD.2101b2e.jpg";

/***/ }),

/***/ "nIi4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/paypal1.d0ff928.png";

/***/ }),

/***/ "nNqh":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+mhg");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("02b57700", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e4b69a2e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e4b69a2e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "noPh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.custLabel[data-v-03a5036f] {\n  position: absolute;\n  top: 30px;\n  left: 0px;\n  font-size: 17px;\n}\n.cspad[data-v-03a5036f] {\n  margin-left: 28px;\n}\n.fileNameText[data-v-03a5036f] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-03a5036f] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-03a5036f] {\n  width: 75px;\n}\n.bigTitle[data-v-03a5036f] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-03a5036f] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-03a5036f] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-03a5036f] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-03a5036f] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-03a5036f] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-03a5036f] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-03a5036f] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-03a5036f] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-03a5036f] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-03a5036f] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-03a5036f] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-03a5036f] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-03a5036f] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-03a5036f] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-03a5036f] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-03a5036f]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-03a5036f] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-03a5036f] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-03a5036f]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\n      display: block;\nclear: both;\ntext-align: center;\nheight: 188px;\nwidth: 188px;\nborder-radius: 7px;\nfont-size: 10px;\ntext-decoration: underline;\ncolor: black;\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-03a5036f]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-03a5036f]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-03a5036f] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-03a5036f] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-03a5036f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "o/Aw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("UH1c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0b27f699", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6487464\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./practicesFinished.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6487464\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./practicesFinished.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "oCBP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.csHeight2[data-v-54242612]{\n    min-height: 52vh!important;\n}\n.selectListBox[data-v-54242612] {\n  background: #d4ebe9;\n  border: 1px solid grey;\n  padding: 3%;\n  max-height: 254px;\n  height: 254px;\n  overflow-y: scroll;\n  -webkit-transition: all .1s;\n  transition: all .1s;\n}\n.borderTop[data-v-54242612]{\n  border-top: 1px solid lightgrey!important;\n}\n.borderTop2[data-v-54242612]{\n  border-top: 1px solid lightgrey;\n}\n.lightYellow[data-v-54242612] {\n  background:   #f393241c\n}\n.custLabelFontSize[data-v-54242612]{\n    font-size: 14px;\n}\n.selectBlock[data-v-54242612]{\n    background: #eeeeee;\n    border: 1px solid #a5a5a5;\n    border-top: none;\n}\n.blockActive[data-v-54242612]{\n    background: white;\n    border-bottom: none!important;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "oNvF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.quardDescription.center.mb-0[data-v-42d13b52] {\n  font-size: 15px;\n}\n", ""]);

// exports


/***/ }),

/***/ "oiZF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("RhT6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("045899bd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d8b643a0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d8b643a0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "pDSP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".time-picker {\n  display: inline-block;\n  position: relative;\n  font-size: 1em;\n  width: 10em;\n  font-family: sans-serif;\n  vertical-align: middle;\n}\n\n.time-picker * {\n  box-sizing: border-box;\n}\n\n.time-picker input.display-time {\n  border: 1px solid #d2d2d2;\n  width: 10em;\n  height: 2.2em;\n  padding: 0.3em 0.5em;\n  font-size: 1em;\n}\n\n.time-picker .clear-btn {\n  position: absolute;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  margin-top: -0.15em;\n  z-index: 3;\n  font-size: 1.1em;\n  line-height: 1em;\n  vertical-align: middle;\n  width: 1.3em;\n  color: #d2d2d2;\n  background: rgba(255,255,255,0);\n  text-align: center;\n  font-style: normal;\n\n  -webkit-transition: color .2s;\n  transition: color .2s;\n}\n\n.time-picker .clear-btn:hover {\n  color: #797979;\n  cursor: pointer;\n}\n\n.time-picker .time-picker-overlay {\n  z-index: 2;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.time-picker .dropdown {\n  position: absolute;\n  z-index: 5;\n  top: calc(2.2em + 2px);\n  left: 0;\n  background: #fff;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.15);\n  width: 10em;\n  height: 10em;\n  font-weight: normal;\n}\n\n.time-picker .dropdown .select-list {\n  width: 10em;\n  height: 10em;\n  overflow: hidden;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  justify-content: space-between;\n}\n\n.time-picker .dropdown ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.time-picker .dropdown ul.minutes,\n.time-picker .dropdown ul.seconds,\n.time-picker .dropdown ul.apms{\n  border-left: 1px solid #fff;\n}\n\n.time-picker .dropdown ul li {\n  text-align: center;\n  padding: 0.3em 0;\n  color: #161616;\n}\n\n.time-picker .dropdown ul li:not(.hint):hover {\n  background: rgba(0,0,0,.08);\n  color: #161616;\n  cursor: pointer;\n}\n\n.time-picker .dropdown ul li.active,\n.time-picker .dropdown ul li.active:hover {\n  background: #41B883;\n  color: #fff;\n}\n\n.time-picker .dropdown .hint {\n  color: #a5a5a5;\n  cursor: default;\n  font-size: 0.8em;\n}\n", ""]);

// exports


/***/ }),

/***/ "pNxK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kMKJ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c2861fea", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bcfb22e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bcfb22e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "pWsl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-bcfb22e0] {\n  font-size: 26px;\n}\n.imageIcons[data-v-bcfb22e0] {\n\t\tvertical-align: bottom!important;\n\t\twidth: 50px;\n}\n.hSize[data-v-bcfb22e0] {\n    font-size: 33px!important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-bcfb22e0] {\n\t\tmax-width: 333px;\n\t\ttext-align: left;\n\t\tmargin: 0 auto;\n\t\tline-height: 27px;\n\t\tpadding-left: 61px;\n}\n\n\n\t/* new PRICE */\n.swal2-popup .swal2-title[data-v-bcfb22e0], #swal2-content[data-v-bcfb22e0] {\n\t\tcolor: #fffbde!important;\n\t\tdisplay: block!important;\n}\n.replaceButton[data-v-bcfb22e0]{\n\t\tmax-width: 40px;\n}\n.inputHelper[data-v-bcfb22e0]{\n    margin-top: -32px;\n    color: #0e3d8b;\n    font-size: 16px;\n    left: 0;\n}\n.priceVal[data-v-bcfb22e0], .priceCent[data-v-bcfb22e0]{\n\t\twidth: calc(50% - 1.5vw - 7.5px);\n\t\tdisplay: inline-table;\n}\n.pseudoEuro[data-v-bcfb22e0] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n}\n.pseudoCent[data-v-bcfb22e0] {\n\t\tposition: absolute;\n\t\ttop: 6px;\n\t\tright:0;\n}\n.group input:focus + .pseudoEuro[data-v-bcfb22e0] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoEuro[data-v-bcfb22e0]{\n\t\tdisplay:block;\n}\n.group input:focus + .pseudoCent[data-v-bcfb22e0] {\n\t\tdisplay:block;\n}\n.group .valid + .pseudoCent[data-v-bcfb22e0]{\n\t\tdisplay:block;\n}\n.euroInput[data-v-bcfb22e0]{\n\t\tposition: relative;\n\t\twidth:200%;\n\t\tz-index: 4;\n}\n.euroInput[data-v-bcfb22e0]::before{\n\t\tcontent: 'Euro';\n}\n.euroInput[data-v-bcfb22e0]:focus, .euroInput.valid[data-v-bcfb22e0]{\n\t\twidth:100%;\n}\n.euroInput[data-v-bcfb22e0]:focus::before, .euroInput.valid[data-v-bcfb22e0]::before{\n\t\tcontent: 'Euro';\n\t\tcolor: white;\n\t\tposition: absolute;\n}\n.table[data-v-bcfb22e0]{\n\t\tdisplay: table;\n}\n.newPriceLabel[data-v-bcfb22e0]{\n\t\tz-index: 5;\n\t\tbackground: white;\n\t\tmargin-left: -5px;\n\t\tpadding-left: 5px;\n\t\toverflow: initial;\n\t\tmin-width: calc(200% + 17px);\n}\n\n\n\t/*  ------------ */\n.image-margin0[data-v-bcfb22e0]{\n\t\tmargin: 0!important;\n}\n.helper[data-v-bcfb22e0]{\n\t\tcolor: #0e3d8b;\n\t\tfont-size: 23px;\n\t\tfont-family: Oswald-Medium;\n}\n.greyDesc2[data-v-bcfb22e0]{\n\t\tfont-size: 1.1vw;\n\t\tcolor: #fffbde;\n}\n.redDesc[data-v-bcfb22e0]{\n\t\tfont-size: 1.1vw;\n\t\ttext-decoration: underline;\n\t\tcursor: pointer;\n}\n.uploadDone[data-v-bcfb22e0] {\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\tright: 0;\n\t\tcolor: #a1614f;\n}\n.helperUnderline[data-v-bcfb22e0] {\n}\n.labelFileInput[data-v-bcfb22e0]{\n\t\ttop: -20px!important;\n\t\tfont-size: 22px;\n\t\tcolor: #000000;\n}\n.fileInput[data-v-bcfb22e0]{\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\ttop: 17px;\n\t\tborder-bottom: none;\n\t\tcolor: #000000;\n}\n.fileInputLabel[data-v-bcfb22e0]{\n\t\tz-index: 3;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\tpadding-right: 20px;\n\t\ttext-overflow: ellipsis;\n\t\tcolor: #fffbde;\n}\n.removeProduct[data-v-bcfb22e0]{\n\t\tposition: absolute;\n\t\tright: 21px;\n\t\tmargin: 0px!important;\n\t\ttop: 48px;\n\t\tcolor: #e7201d;\n}\n.typeDisabled[data-v-bcfb22e0]{\n\t\tcolor: #676767;\n\t\tcursor: pointer;\n}\n.typeSelected[data-v-bcfb22e0] {\n\t\tcolor: #fffbde!important;\n\t\tcursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-bcfb22e0] {\n      margin-top: -12px;\n      color: #0e3d8b;\n      font-size: 16px;\n      left: 0;\n}\n.hSize[data-v-bcfb22e0] {\n      font-size: 19px!important;\n}\n.sweetText[data-v-bcfb22e0] {\n      font-size: 19px;\n}\n.removeProduct[data-v-bcfb22e0]{\n    position: absolute;\n    right: 21px;\n    margin: 0px!important;\n    top: 26px;\n    color: #e7201d;\n}\n.greyDesc2[data-v-bcfb22e0], .redDesc[data-v-bcfb22e0]{\n\t\t\tfont-size: 3.1vw;\n}\n.fluid[data-v-bcfb22e0] {\n\t\t\tmax-width: 107px;\n}\n.mobTQ[data-v-bcfb22e0]{\n\t\t\tfont-size: 23px;\n}\n.smMob[data-v-bcfb22e0]{\n\t\t\tfont-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-bcfb22e0] {\n\t\t\tmax-width: 350px;\n\t\t\ttext-align: left;\n\t\t\tmargin: 0 auto;\n\t\t\tline-height: 27px;\n\t\t\tpadding-left: 43px;\n\t\t\tfont-size: 17px;\n}\n.helper[data-v-bcfb22e0] {\n\t\t\tcolor: #0e3d8b;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: Oswald-Medium;\n}\n.imageIcons[data-v-bcfb22e0] {\n\t\t\tvertical-align: bottom!important;\n\t\t\twidth: 39px;\n}\n.fileInput[data-v-bcfb22e0] {\n\n\t\t\ttop: 8px!important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-bcfb22e0]{\n\t\t\t top: -250%;\n}\n}\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "pc4f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("xiib");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("63265398", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31b2d0d5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./paypal_nt.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31b2d0d5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./paypal_nt.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "q2xu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v4.5.3 (https://getbootstrap.com/)\n * Copyright 2011-2020 The Bootstrap Authors\n * Copyright 2011-2020 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,::after,::before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}article,aside,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus:not(:focus-visible){outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([class]){color:inherit;text-decoration:none}a:not([href]):not([class]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg{overflow:hidden;vertical-align:middle}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit;text-align:-webkit-match-parent}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[role=button]{cursor:pointer}select{word-wrap:normal}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem;font-weight:300;line-height:1.2}.display-2{font-size:5.5rem;font-weight:300;line-height:1.2}.display-3{font-size:4.5rem;font-weight:300;line-height:1.2}.display-4{font-size:3.5rem;font-weight:300;line-height:1.2}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#6c757d}.blockquote-footer::before{content:\"\\2014\\A0\"}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container,.container-fluid,.container-lg,.container-md,.container-sm,.container-xl{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-md,.container-sm{max-width:720px}}@media (min-width:992px){.container,.container-lg,.container-md,.container-sm{max-width:960px}}@media (min-width:1200px){.container,.container-lg,.container-md,.container-sm,.container-xl{max-width:1140px}}.row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-ms-flex-order:-1;order:-1}.order-last{-ms-flex-order:13;order:13}.order-0{-ms-flex-order:0;order:0}.order-1{-ms-flex-order:1;order:1}.order-2{-ms-flex-order:2;order:2}.order-3{-ms-flex-order:3;order:3}.order-4{-ms-flex-order:4;order:4}.order-5{-ms-flex-order:5;order:5}.order-6{-ms-flex-order:6;order:6}.order-7{-ms-flex-order:7;order:7}.order-8{-ms-flex-order:8;order:8}.order-9{-ms-flex-order:9;order:9}.order-10{-ms-flex-order:10;order:10}.order-11{-ms-flex-order:11;order:11}.order-12{-ms-flex-order:12;order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-sm-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-sm-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-sm-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-sm-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-sm-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-sm-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-sm-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-ms-flex-order:-1;order:-1}.order-sm-last{-ms-flex-order:13;order:13}.order-sm-0{-ms-flex-order:0;order:0}.order-sm-1{-ms-flex-order:1;order:1}.order-sm-2{-ms-flex-order:2;order:2}.order-sm-3{-ms-flex-order:3;order:3}.order-sm-4{-ms-flex-order:4;order:4}.order-sm-5{-ms-flex-order:5;order:5}.order-sm-6{-ms-flex-order:6;order:6}.order-sm-7{-ms-flex-order:7;order:7}.order-sm-8{-ms-flex-order:8;order:8}.order-sm-9{-ms-flex-order:9;order:9}.order-sm-10{-ms-flex-order:10;order:10}.order-sm-11{-ms-flex-order:11;order:11}.order-sm-12{-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-md-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-md-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-md-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-md-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-md-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-md-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-md-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-ms-flex-order:-1;order:-1}.order-md-last{-ms-flex-order:13;order:13}.order-md-0{-ms-flex-order:0;order:0}.order-md-1{-ms-flex-order:1;order:1}.order-md-2{-ms-flex-order:2;order:2}.order-md-3{-ms-flex-order:3;order:3}.order-md-4{-ms-flex-order:4;order:4}.order-md-5{-ms-flex-order:5;order:5}.order-md-6{-ms-flex-order:6;order:6}.order-md-7{-ms-flex-order:7;order:7}.order-md-8{-ms-flex-order:8;order:8}.order-md-9{-ms-flex-order:9;order:9}.order-md-10{-ms-flex-order:10;order:10}.order-md-11{-ms-flex-order:11;order:11}.order-md-12{-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-lg-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-lg-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-lg-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-lg-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-lg-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-lg-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-lg-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-ms-flex-order:-1;order:-1}.order-lg-last{-ms-flex-order:13;order:13}.order-lg-0{-ms-flex-order:0;order:0}.order-lg-1{-ms-flex-order:1;order:1}.order-lg-2{-ms-flex-order:2;order:2}.order-lg-3{-ms-flex-order:3;order:3}.order-lg-4{-ms-flex-order:4;order:4}.order-lg-5{-ms-flex-order:5;order:5}.order-lg-6{-ms-flex-order:6;order:6}.order-lg-7{-ms-flex-order:7;order:7}.order-lg-8{-ms-flex-order:8;order:8}.order-lg-9{-ms-flex-order:9;order:9}.order-lg-10{-ms-flex-order:10;order:10}.order-lg-11{-ms-flex-order:11;order:11}.order-lg-12{-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-xl-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-xl-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-xl-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-xl-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-xl-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-xl-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-xl-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-ms-flex-order:-1;order:-1}.order-xl-last{-ms-flex-order:13;order:13}.order-xl-0{-ms-flex-order:0;order:0}.order-xl-1{-ms-flex-order:1;order:1}.order-xl-2{-ms-flex-order:2;order:2}.order-xl-3{-ms-flex-order:3;order:3}.order-xl-4{-ms-flex-order:4;order:4}.order-xl-5{-ms-flex-order:5;order:5}.order-xl-6{-ms-flex-order:6;order:6}.order-xl-7{-ms-flex-order:7;order:7}.order-xl-8{-ms-flex-order:8;order:8}.order-xl-9{-ms-flex-order:9;order:9}.order-xl-10{-ms-flex-order:10;order:10}.order-xl-11{-ms-flex-order:11;order:11}.order-xl-12{-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;margin-bottom:1rem;color:#212529}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table-sm td,.table-sm th{padding:.3rem}.table-bordered{border:1px solid #dee2e6}.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-borderless tbody+tbody,.table-borderless td,.table-borderless th,.table-borderless thead th{border:0}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{color:#212529;background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-primary tbody+tbody,.table-primary td,.table-primary th,.table-primary thead th{border-color:#7abaff}.table-hover .table-primary:hover{background-color:#9fcdff}.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#d6d8db}.table-secondary tbody+tbody,.table-secondary td,.table-secondary th,.table-secondary thead th{border-color:#b3b7bb}.table-hover .table-secondary:hover{background-color:#c8cbcf}.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#c8cbcf}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-success tbody+tbody,.table-success td,.table-success th,.table-success thead th{border-color:#8fd19e}.table-hover .table-success:hover{background-color:#b1dfbb}.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-info tbody+tbody,.table-info td,.table-info th,.table-info thead th{border-color:#86cfda}.table-hover .table-info:hover{background-color:#abdde5}.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-warning tbody+tbody,.table-warning td,.table-warning th,.table-warning thead th{border-color:#ffdf7e}.table-hover .table-warning:hover{background-color:#ffe8a1}.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-danger tbody+tbody,.table-danger td,.table-danger th,.table-danger thead th{border-color:#ed969e}.table-hover .table-danger:hover{background-color:#f1b0b7}.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-light tbody+tbody,.table-light td,.table-light th,.table-light thead th{border-color:#fbfcfc}.table-hover .table-light:hover{background-color:#ececf6}.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#95999c}.table-hover .table-dark:hover{background-color:#b9bbbe}.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#343a40;border-color:#454d55}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#343a40}.table-dark td,.table-dark th,.table-dark thead th{border-color:#454d55}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,.05)}.table-dark.table-hover tbody tr:hover{color:#fff;background-color:rgba(255,255,255,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.form-control::-moz-placeholder{color:#6c757d;opacity:1}.form-control:-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{-webkit-appearance:none;-moz-appearance:none;appearance:none}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm{padding-right:0;padding-left:0}.form-control-sm{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.form-control-lg{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}select.form-control[multiple],select.form-control[size]{height:auto}textarea.form-control{height:auto}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label,.form-check-input[disabled]~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,.9);border-radius:.25rem}.is-valid~.valid-feedback,.is-valid~.valid-tooltip,.was-validated :valid~.valid-feedback,.was-validated :valid~.valid-tooltip{display:block}.form-control.is-valid,.was-validated .form-control:valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.was-validated textarea.form-control:valid,textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-valid,.was-validated .custom-select:valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)}.custom-select.is-valid:focus,.was-validated .custom-select:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip,.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label::before,.was-validated .custom-control-input:valid~.custom-control-label::before{border-color:#28a745}.custom-control-input.is-valid:checked~.custom-control-label::before,.was-validated .custom-control-input:valid:checked~.custom-control-label::before{border-color:#34ce57;background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label::before,.was-validated .custom-control-input:valid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.is-invalid~.invalid-feedback,.is-invalid~.invalid-tooltip,.was-validated :invalid~.invalid-feedback,.was-validated :invalid~.invalid-tooltip{display:block}.form-control.is-invalid,.was-validated .form-control:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.was-validated textarea.form-control:invalid,textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-invalid,.was-validated .custom-select:invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)}.custom-select.is-invalid:focus,.was-validated .custom-select:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip,.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label::before,.was-validated .custom-control-input:invalid~.custom-control-label::before{border-color:#dc3545}.custom-control-input.is-invalid:checked~.custom-control-label::before,.was-validated .custom-control-input:invalid:checked~.custom-control-label::before{border-color:#e4606d;background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin-bottom:0}.form-inline .form-group{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center;margin-bottom:0}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .custom-select,.form-inline .input-group{width:auto}.form-inline .form-check{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;-ms-flex-negative:0;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:#212529;text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}.btn:not(:disabled):not(.disabled){cursor:pointer}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#0069d9;border-color:#0062cc;box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:not(:disabled):not(.disabled).active,.btn-primary:not(:disabled):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not(:disabled):not(.disabled).active:focus,.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-secondary{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-secondary.focus,.btn-secondary:focus{color:#fff;background-color:#5a6268;border-color:#545b62;box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-secondary.disabled,.btn-secondary:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#545b62;border-color:#4e555b}.btn-secondary:not(:disabled):not(.disabled).active:focus,.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#218838;border-color:#1e7e34;box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:not(:disabled):not(.disabled).active,.btn-success:not(:disabled):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not(:disabled):not(.disabled).active:focus,.btn-success:not(:disabled):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#138496;border-color:#117a8b;box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:not(:disabled):not(.disabled).active,.btn-info:not(:disabled):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not(:disabled):not(.disabled).active:focus,.btn-info:not(:disabled):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{color:#212529;background-color:#e0a800;border-color:#d39e00;box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:not(:disabled):not(.disabled).active,.btn-warning:not(:disabled):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not(:disabled):not(.disabled).active:focus,.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c82333;border-color:#bd2130;box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:not(:disabled):not(.disabled).active,.btn-danger:not(:disabled):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not(:disabled):not(.disabled).active:focus,.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{color:#212529;background-color:#e2e6ea;border-color:#dae0e5;box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not(:disabled):not(.disabled).active,.btn-light:not(:disabled):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not(:disabled):not(.disabled).active:focus,.btn-light:not(:disabled):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{color:#fff;background-color:#23272b;border-color:#1d2124;box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled).active,.btn-dark:not(:disabled):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled).active:focus,.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-outline-primary{color:#007bff;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled).active,.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#6c757d;border-color:#6c757d}.btn-outline-secondary:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#6c757d;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled).active,.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-success{color:#28a745;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled).active,.btn-outline-success:not(:disabled):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success:not(:disabled):not(.disabled).active:focus,.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled).active,.btn-outline-info:not(:disabled):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info:not(:disabled):not(.disabled).active:focus,.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled).active,.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled).active,.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled).active,.btn-outline-light:not(:disabled):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:not(:disabled):not(.disabled).active:focus,.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled).active,.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;text-decoration:none}.btn-link:hover{color:#0056b3;text-decoration:underline}.btn-link.focus,.btn-link:focus{text-decoration:underline}.btn-link.disabled,.btn-link:disabled{color:#6c757d;pointer-events:none}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{position:relative;height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing{transition:none}}.dropdown,.dropleft,.dropright,.dropup{position:relative}.dropdown-toggle{white-space:nowrap}.dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu-left{right:auto;left:0}.dropdown-menu-right{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-left{right:auto;left:0}.dropdown-menu-sm-right{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-left{right:auto;left:0}.dropdown-menu-md-right{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-left{right:auto;left:0}.dropdown-menu-lg-right{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-left{right:auto;left:0}.dropdown-menu-xl-right{right:0;left:auto}}.dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-toggle::after{vertical-align:0}.dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropleft .dropdown-toggle::after{display:none}.dropleft .dropdown-toggle::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty::after{margin-left:0}.dropleft .dropdown-toggle::before{vertical-align:0}.dropdown-menu[x-placement^=bottom],.dropdown-menu[x-placement^=left],.dropdown-menu[x-placement^=right],.dropdown-menu[x-placement^=top]{right:auto;bottom:auto}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#6c757d;pointer-events:none;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text{display:block;padding:.25rem 1.5rem;color:#212529}.btn-group,.btn-group-vertical{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.btn-group-vertical>.btn:hover,.btn-group>.btn:hover{z-index:1}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus{z-index:1}.btn-toolbar{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn-group:not(:first-child),.btn-group>.btn:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropright .dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after{margin-left:0}.dropleft .dropdown-toggle-split::before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn-group:not(:first-child),.btn-group-vertical>.btn:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio],.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control,.input-group>.form-control-plaintext{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0}.input-group>.custom-file+.custom-file,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.form-control,.input-group>.custom-select+.custom-file,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.form-control,.input-group>.form-control+.custom-file,.input-group>.form-control+.custom-select,.input-group>.form-control+.form-control,.input-group>.form-control-plaintext+.custom-file,.input-group>.form-control-plaintext+.custom-select,.input-group>.form-control-plaintext+.form-control{margin-left:-1px}.input-group>.custom-file .custom-file-input:focus~.custom-file-label,.input-group>.custom-select:focus,.input-group>.form-control:focus{z-index:3}.input-group>.custom-file .custom-file-input:focus{z-index:4}.input-group>.custom-select:not(:last-child),.input-group>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-select:not(:first-child),.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group>.custom-file:not(:last-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label::after{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-file:not(:first-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:-ms-flexbox;display:flex}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn:focus,.input-group-prepend .btn:focus{z-index:3}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group-lg>.custom-select,.input-group-lg>.form-control:not(textarea){height:calc(1.5em + 1rem + 2px)}.input-group-lg>.custom-select,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-sm>.custom-select,.input-group-sm>.form-control:not(textarea){height:calc(1.5em + .5rem + 2px)}.input-group-sm>.custom-select,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-lg>.custom-select,.input-group-sm>.custom-select{padding-right:1.75rem}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;z-index:1;display:block;min-height:1.5rem;padding-left:1.5rem;-webkit-print-color-adjust:exact;color-adjust:exact}.custom-control-inline{display:-ms-inline-flexbox;display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;left:0;z-index:-1;width:1rem;height:1.25rem;opacity:0}.custom-control-input:checked~.custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.custom-control-input:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:focus:not(:checked)~.custom-control-label::before{border-color:#80bdff}.custom-control-input:not(:disabled):active~.custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label,.custom-control-input[disabled]~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label::before,.custom-control-input[disabled]~.custom-control-label::before{background-color:#e9ecef}.custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.custom-control-label::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:#adb5bd solid 1px}.custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background:no-repeat 50%/50% 50%}.custom-checkbox .custom-control-label::before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before{border-color:#007bff;background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label::before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-switch{padding-left:2.25rem}.custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-switch .custom-control-label::after{transition:none}}.custom-switch .custom-control-input:checked~.custom-control-label::after{background-color:#fff;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{display:none}.custom-select:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.custom-select-sm{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.custom-select-lg{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.custom-file{position:relative;display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);margin-bottom:0}.custom-file-input{position:relative;z-index:2;width:100%;height:calc(1.5em + .75rem + 2px);margin:0;opacity:0}.custom-file-input:focus~.custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:disabled~.custom-file-label,.custom-file-input[disabled]~.custom-file-label{background-color:#e9ecef}.custom-file-input:lang(en)~.custom-file-label::after{content:\"Browse\"}.custom-file-input~.custom-file-label[data-browse]::after{content:attr(data-browse)}.custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.custom-range{width:100%;height:1.4rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-range:focus{outline:0}.custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range::-moz-focus-outer{border:0}.custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-moz-range-thumb{-moz-transition:none;transition:none}}.custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;-ms-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-ms-thumb{-ms-transition:none;transition:none}}.custom-range::-ms-thumb:active{background-color:#b3d7ff}.custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.custom-range:disabled::-moz-range-track{cursor:default}.custom-range:disabled::-ms-thumb{background-color:#adb5bd}.custom-control-label::before,.custom-file-label,.custom-select{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-control-label::before,.custom-file-label,.custom-select{transition:none}}.nav{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item,.nav-fill>.nav-link{-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified .nav-item,.nav-justified>.nav-link{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:.5rem 1rem}.navbar .container,.navbar .container-fluid,.navbar .container-lg,.navbar .container-md,.navbar .container-sm,.navbar .container-xl{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat center center;background-size:100% 100%}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}}.navbar-expand{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-light .navbar-brand{color:rgba(0,0,0,.9)}.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a{color:rgba(0,0,0,.9)}.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand{color:#fff}.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:rgba(255,255,255,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-dark .navbar-text{color:rgba(255,255,255,.5)}.navbar-dark .navbar-text a{color:#fff}.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group{border-top:inherit;border-bottom:inherit}.card>.list-group:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group,.card>.list-group+.card-footer{border-top:0}.card-body{-ms-flex:1 1 auto;flex:1 1 auto;min-height:1px;padding:1.25rem}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem;margin-bottom:0}.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem;border-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom,.card-img-top{-ms-flex-negative:0;flex-shrink:0;width:100%}.card-img,.card-img-top{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{-ms-flex:1 0 0%;flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom{border-bottom-left-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.card-columns .card{display:inline-block;width:100%}}.accordion{overflow-anchor:none}.accordion>.card{overflow:hidden}.accordion>.card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion>.card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.accordion>.card>.card-header{border-radius:0;margin-bottom:-1px}.breadcrumb{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item{display:-ms-flexbox;display:flex}.breadcrumb-item+.breadcrumb-item{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item::before{display:inline-block;padding-right:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:underline}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:3;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.badge{transition:none}}a.badge:focus,a.badge:hover{text-decoration:none}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}a.badge-primary:focus,a.badge-primary:hover{color:#fff;background-color:#0062cc}a.badge-primary.focus,a.badge-primary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.badge-secondary{color:#fff;background-color:#6c757d}a.badge-secondary:focus,a.badge-secondary:hover{color:#fff;background-color:#545b62}a.badge-secondary.focus,a.badge-secondary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.badge-success{color:#fff;background-color:#28a745}a.badge-success:focus,a.badge-success:hover{color:#fff;background-color:#1e7e34}a.badge-success.focus,a.badge-success:focus{outline:0;box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.badge-info{color:#fff;background-color:#17a2b8}a.badge-info:focus,a.badge-info:hover{color:#fff;background-color:#117a8b}a.badge-info.focus,a.badge-info:focus{outline:0;box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.badge-warning{color:#212529;background-color:#ffc107}a.badge-warning:focus,a.badge-warning:hover{color:#212529;background-color:#d39e00}a.badge-warning.focus,a.badge-warning:focus{outline:0;box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.badge-danger{color:#fff;background-color:#dc3545}a.badge-danger:focus,a.badge-danger:hover{color:#fff;background-color:#bd2130}a.badge-danger.focus,a.badge-danger:focus{outline:0;box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.badge-light{color:#212529;background-color:#f8f9fa}a.badge-light:focus,a.badge-light:hover{color:#212529;background-color:#dae0e5}a.badge-light.focus,a.badge-light:focus{outline:0;box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.badge-dark{color:#fff;background-color:#343a40}a.badge-dark:focus,a.badge-dark:hover{color:#fff;background-color:#1d2124}a.badge-dark.focus,a.badge-dark:focus{outline:0;box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;z-index:2;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.alert-secondary hr{border-top-color:#c8cbcf}.alert-secondary .alert-link{color:#202326}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.progress{display:-ms-flexbox;display:flex;height:1rem;overflow:hidden;line-height:0;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar{transition:none}}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:progress-bar-stripes 1s linear infinite;animation:progress-bar-stripes 1s linear infinite}@media (prefers-reduced-motion:reduce){.progress-bar-animated{-webkit-animation:none;animation:none}}.media{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.media-body{-ms-flex:1;flex:1}.list-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:-1px;border-top-width:1px}.list-group-horizontal{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-sm>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-md>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-lg>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-xl>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}.list-group-flush{border-radius:0}.list-group-flush>.list-group-item{border-width:0 0 1px}.list-group-flush>.list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{color:#004085;background-color:#b8daff}.list-group-item-primary.list-group-item-action:focus,.list-group-item-primary.list-group-item-action:hover{color:#004085;background-color:#9fcdff}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#383d41;background-color:#d6d8db}.list-group-item-secondary.list-group-item-action:focus,.list-group-item-secondary.list-group-item-action:hover{color:#383d41;background-color:#c8cbcf}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#383d41;border-color:#383d41}.list-group-item-success{color:#155724;background-color:#c3e6cb}.list-group-item-success.list-group-item-action:focus,.list-group-item-success.list-group-item-action:hover{color:#155724;background-color:#b1dfbb}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}.list-group-item-info.list-group-item-action:focus,.list-group-item-info.list-group-item-action:hover{color:#0c5460;background-color:#abdde5}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}.list-group-item-warning.list-group-item-action:focus,.list-group-item-warning.list-group-item-action:hover{color:#856404;background-color:#ffe8a1}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}.list-group-item-danger.list-group-item-action:focus,.list-group-item-danger.list-group-item-action:hover{color:#721c24;background-color:#f1b0b7}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}.list-group-item-light.list-group-item-action:focus,.list-group-item-light.list-group-item-action:hover{color:#818182;background-color:#ececf6}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:focus,.list-group-item-dark.list-group-item-action:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:hover{color:#000;text-decoration:none}.close:not(:disabled):not(.disabled):focus,.close:not(:disabled):not(.disabled):hover{opacity:.75}button.close{padding:0;background-color:transparent;border:0}a.close.disabled{pointer-events:none}.toast{-ms-flex-preferred-size:350px;flex-basis:350px;max-width:350px;font-size:.875rem;background-color:rgba(255,255,255,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.1);opacity:0;border-radius:.25rem}.toast:not(:last-child){margin-bottom:.75rem}.toast.showing{opacity:1}.toast.show{display:block;opacity:1}.toast.hide{display:none}.toast-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:rgba(255,255,255,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-body{padding:.75rem}.modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translate(0,-50px);transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{-webkit-transform:none;transform:none}.modal.modal-static .modal-dialog{-webkit-transform:scale(1.02);transform:scale(1.02)}.modal-dialog-scrollable{display:-ms-flexbox;display:flex;max-height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.modal-dialog-scrollable .modal-footer,.modal-dialog-scrollable .modal-header{-ms-flex-negative:0;flex-shrink:0}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-dialog-centered::before{display:block;height:calc(100vh - 1rem);height:-webkit-min-content;height:-moz-min-content;height:min-content;content:\"\"}.modal-dialog-centered.modal-dialog-scrollable{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.modal-dialog-centered.modal-dialog-scrollable .modal-content{max-height:none}.modal-dialog-centered.modal-dialog-scrollable::before{content:none}.modal-content{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:1rem 1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .close{padding:1rem 1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem}.modal-footer{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>*{margin:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 3.5rem)}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-dialog-centered::before{height:calc(100vh - 3.5rem);height:-webkit-min-content;height:-moz-min-content;height:min-content}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg,.modal-xl{max-width:800px}}@media (min-width:1200px){.modal-xl{max-width:1140px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow::before,.bs-tooltip-top .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow::before,.bs-tooltip-right .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow::before,.bs-tooltip-bottom .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow::before,.bs-tooltip-left .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.popover .arrow::after,.popover .arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top]>.arrow,.bs-popover-top>.arrow{bottom:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=top]>.arrow::before,.bs-popover-top>.arrow::before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top]>.arrow::after,.bs-popover-top>.arrow::after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right]>.arrow,.bs-popover-right>.arrow{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=right]>.arrow::before,.bs-popover-right>.arrow::before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right]>.arrow::after,.bs-popover-right>.arrow::after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom]>.arrow,.bs-popover-bottom>.arrow{top:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=bottom]>.arrow::before,.bs-popover-bottom>.arrow::before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom]>.arrow::after,.bs-popover-bottom>.arrow::after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header::before,.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left]>.arrow,.bs-popover-left>.arrow{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=left]>.arrow::before,.bs-popover-left>.arrow::before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left]>.arrow::after,.bs-popover-left>.arrow::after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel.pointer-event{-ms-touch-action:pan-y;touch-action:pan-y}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-inner::after{display:block;clear:both;content:\"\"}.carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out,-webkit-transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item{transition:none}}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.active.carousel-item-right,.carousel-item-next:not(.carousel-item-left){-webkit-transform:translateX(100%);transform:translateX(100%)}.active.carousel-item-left,.carousel-item-prev:not(.carousel-item-right){-webkit-transform:translateX(-100%);transform:translateX(-100%)}.carousel-fade .carousel-item{opacity:0;transition-property:opacity;-webkit-transform:none;transform:none}.carousel-fade .carousel-item-next.carousel-item-left,.carousel-fade .carousel-item-prev.carousel-item-right,.carousel-fade .carousel-item.active{z-index:1;opacity:1}.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{transition:none}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;z-index:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next,.carousel-control-prev{transition:none}}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:no-repeat 50%/100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")}.carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{box-sizing:content-box;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators li{transition:none}}.carousel-indicators .active{opacity:1}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}@-webkit-keyframes spinner-border{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner-border{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:spinner-border .75s linear infinite;animation:spinner-border .75s linear infinite}.spinner-border-sm{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1;-webkit-transform:none;transform:none}}@keyframes spinner-grow{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1;-webkit-transform:none;transform:none}}.spinner-grow{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:spinner-grow .75s linear infinite;animation:spinner-grow .75s linear infinite}.spinner-grow-sm{width:1rem;height:1rem}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#6c757d!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#545b62!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded-sm{border-radius:.2rem!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-right{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-lg{border-radius:.3rem!important}.rounded-circle{border-radius:50%!important}.rounded-pill{border-radius:50rem!important}.rounded-0{border-radius:0!important}.clearfix::after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:-ms-flexbox!important;display:flex!important}.d-print-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive::before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9::before{padding-top:42.857143%}.embed-responsive-16by9::before{padding-top:56.25%}.embed-responsive-4by3::before{padding-top:75%}.embed-responsive-1by1::before{padding-top:100%}.flex-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-sm-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-sm-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-sm-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-sm-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-sm-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-sm-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-md-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-md-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-md-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-md-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-md-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-md-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-lg-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-lg-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-lg-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-lg-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-lg-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-lg-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-xl-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-xl-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-xl-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-xl-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-xl-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-xl-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.user-select-all{-webkit-user-select:all!important;-moz-user-select:all!important;-ms-user-select:all!important;user-select:all!important}.user-select-auto{-webkit-user-select:auto!important;-moz-user-select:auto!important;-ms-user-select:auto!important;user-select:auto!important}.user-select-none{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.shadow-sm{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none{box-shadow:none!important}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.w-auto{width:auto!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.h-auto{height:auto!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.min-vw-100{min-width:100vw!important}.min-vh-100{min-height:100vh!important}.vw-100{width:100vw!important}.vh-100{height:100vh!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-n1{margin:-.25rem!important}.mt-n1,.my-n1{margin-top:-.25rem!important}.mr-n1,.mx-n1{margin-right:-.25rem!important}.mb-n1,.my-n1{margin-bottom:-.25rem!important}.ml-n1,.mx-n1{margin-left:-.25rem!important}.m-n2{margin:-.5rem!important}.mt-n2,.my-n2{margin-top:-.5rem!important}.mr-n2,.mx-n2{margin-right:-.5rem!important}.mb-n2,.my-n2{margin-bottom:-.5rem!important}.ml-n2,.mx-n2{margin-left:-.5rem!important}.m-n3{margin:-1rem!important}.mt-n3,.my-n3{margin-top:-1rem!important}.mr-n3,.mx-n3{margin-right:-1rem!important}.mb-n3,.my-n3{margin-bottom:-1rem!important}.ml-n3,.mx-n3{margin-left:-1rem!important}.m-n4{margin:-1.5rem!important}.mt-n4,.my-n4{margin-top:-1.5rem!important}.mr-n4,.mx-n4{margin-right:-1.5rem!important}.mb-n4,.my-n4{margin-bottom:-1.5rem!important}.ml-n4,.mx-n4{margin-left:-1.5rem!important}.m-n5{margin:-3rem!important}.mt-n5,.my-n5{margin-top:-3rem!important}.mr-n5,.mx-n5{margin-right:-3rem!important}.mb-n5,.my-n5{margin-bottom:-3rem!important}.ml-n5,.mx-n5{margin-left:-3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-n1{margin:-.25rem!important}.mt-sm-n1,.my-sm-n1{margin-top:-.25rem!important}.mr-sm-n1,.mx-sm-n1{margin-right:-.25rem!important}.mb-sm-n1,.my-sm-n1{margin-bottom:-.25rem!important}.ml-sm-n1,.mx-sm-n1{margin-left:-.25rem!important}.m-sm-n2{margin:-.5rem!important}.mt-sm-n2,.my-sm-n2{margin-top:-.5rem!important}.mr-sm-n2,.mx-sm-n2{margin-right:-.5rem!important}.mb-sm-n2,.my-sm-n2{margin-bottom:-.5rem!important}.ml-sm-n2,.mx-sm-n2{margin-left:-.5rem!important}.m-sm-n3{margin:-1rem!important}.mt-sm-n3,.my-sm-n3{margin-top:-1rem!important}.mr-sm-n3,.mx-sm-n3{margin-right:-1rem!important}.mb-sm-n3,.my-sm-n3{margin-bottom:-1rem!important}.ml-sm-n3,.mx-sm-n3{margin-left:-1rem!important}.m-sm-n4{margin:-1.5rem!important}.mt-sm-n4,.my-sm-n4{margin-top:-1.5rem!important}.mr-sm-n4,.mx-sm-n4{margin-right:-1.5rem!important}.mb-sm-n4,.my-sm-n4{margin-bottom:-1.5rem!important}.ml-sm-n4,.mx-sm-n4{margin-left:-1.5rem!important}.m-sm-n5{margin:-3rem!important}.mt-sm-n5,.my-sm-n5{margin-top:-3rem!important}.mr-sm-n5,.mx-sm-n5{margin-right:-3rem!important}.mb-sm-n5,.my-sm-n5{margin-bottom:-3rem!important}.ml-sm-n5,.mx-sm-n5{margin-left:-3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-n1{margin:-.25rem!important}.mt-md-n1,.my-md-n1{margin-top:-.25rem!important}.mr-md-n1,.mx-md-n1{margin-right:-.25rem!important}.mb-md-n1,.my-md-n1{margin-bottom:-.25rem!important}.ml-md-n1,.mx-md-n1{margin-left:-.25rem!important}.m-md-n2{margin:-.5rem!important}.mt-md-n2,.my-md-n2{margin-top:-.5rem!important}.mr-md-n2,.mx-md-n2{margin-right:-.5rem!important}.mb-md-n2,.my-md-n2{margin-bottom:-.5rem!important}.ml-md-n2,.mx-md-n2{margin-left:-.5rem!important}.m-md-n3{margin:-1rem!important}.mt-md-n3,.my-md-n3{margin-top:-1rem!important}.mr-md-n3,.mx-md-n3{margin-right:-1rem!important}.mb-md-n3,.my-md-n3{margin-bottom:-1rem!important}.ml-md-n3,.mx-md-n3{margin-left:-1rem!important}.m-md-n4{margin:-1.5rem!important}.mt-md-n4,.my-md-n4{margin-top:-1.5rem!important}.mr-md-n4,.mx-md-n4{margin-right:-1.5rem!important}.mb-md-n4,.my-md-n4{margin-bottom:-1.5rem!important}.ml-md-n4,.mx-md-n4{margin-left:-1.5rem!important}.m-md-n5{margin:-3rem!important}.mt-md-n5,.my-md-n5{margin-top:-3rem!important}.mr-md-n5,.mx-md-n5{margin-right:-3rem!important}.mb-md-n5,.my-md-n5{margin-bottom:-3rem!important}.ml-md-n5,.mx-md-n5{margin-left:-3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-n1{margin:-.25rem!important}.mt-lg-n1,.my-lg-n1{margin-top:-.25rem!important}.mr-lg-n1,.mx-lg-n1{margin-right:-.25rem!important}.mb-lg-n1,.my-lg-n1{margin-bottom:-.25rem!important}.ml-lg-n1,.mx-lg-n1{margin-left:-.25rem!important}.m-lg-n2{margin:-.5rem!important}.mt-lg-n2,.my-lg-n2{margin-top:-.5rem!important}.mr-lg-n2,.mx-lg-n2{margin-right:-.5rem!important}.mb-lg-n2,.my-lg-n2{margin-bottom:-.5rem!important}.ml-lg-n2,.mx-lg-n2{margin-left:-.5rem!important}.m-lg-n3{margin:-1rem!important}.mt-lg-n3,.my-lg-n3{margin-top:-1rem!important}.mr-lg-n3,.mx-lg-n3{margin-right:-1rem!important}.mb-lg-n3,.my-lg-n3{margin-bottom:-1rem!important}.ml-lg-n3,.mx-lg-n3{margin-left:-1rem!important}.m-lg-n4{margin:-1.5rem!important}.mt-lg-n4,.my-lg-n4{margin-top:-1.5rem!important}.mr-lg-n4,.mx-lg-n4{margin-right:-1.5rem!important}.mb-lg-n4,.my-lg-n4{margin-bottom:-1.5rem!important}.ml-lg-n4,.mx-lg-n4{margin-left:-1.5rem!important}.m-lg-n5{margin:-3rem!important}.mt-lg-n5,.my-lg-n5{margin-top:-3rem!important}.mr-lg-n5,.mx-lg-n5{margin-right:-3rem!important}.mb-lg-n5,.my-lg-n5{margin-bottom:-3rem!important}.ml-lg-n5,.mx-lg-n5{margin-left:-3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-n1{margin:-.25rem!important}.mt-xl-n1,.my-xl-n1{margin-top:-.25rem!important}.mr-xl-n1,.mx-xl-n1{margin-right:-.25rem!important}.mb-xl-n1,.my-xl-n1{margin-bottom:-.25rem!important}.ml-xl-n1,.mx-xl-n1{margin-left:-.25rem!important}.m-xl-n2{margin:-.5rem!important}.mt-xl-n2,.my-xl-n2{margin-top:-.5rem!important}.mr-xl-n2,.mx-xl-n2{margin-right:-.5rem!important}.mb-xl-n2,.my-xl-n2{margin-bottom:-.5rem!important}.ml-xl-n2,.mx-xl-n2{margin-left:-.5rem!important}.m-xl-n3{margin:-1rem!important}.mt-xl-n3,.my-xl-n3{margin-top:-1rem!important}.mr-xl-n3,.mx-xl-n3{margin-right:-1rem!important}.mb-xl-n3,.my-xl-n3{margin-bottom:-1rem!important}.ml-xl-n3,.mx-xl-n3{margin-left:-1rem!important}.m-xl-n4{margin:-1.5rem!important}.mt-xl-n4,.my-xl-n4{margin-top:-1.5rem!important}.mr-xl-n4,.mx-xl-n4{margin-right:-1.5rem!important}.mb-xl-n4,.my-xl-n4{margin-bottom:-1.5rem!important}.ml-xl-n4,.mx-xl-n4{margin-left:-1.5rem!important}.m-xl-n5{margin:-3rem!important}.mt-xl-n5,.my-xl-n5{margin-top:-3rem!important}.mr-xl-n5,.mx-xl-n5{margin-right:-3rem!important}.mb-xl-n5,.my-xl-n5{margin-bottom:-3rem!important}.ml-xl-n5,.mx-xl-n5{margin-left:-3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:rgba(0,0,0,0)}.text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.text-justify{text-align:justify!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-lighter{font-weight:lighter!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-weight-bolder{font-weight:bolder!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0056b3!important}.text-secondary{color:#6c757d!important}a.text-secondary:focus,a.text-secondary:hover{color:#494f54!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#19692c!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#0f6674!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#ba8b00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#a71d2a!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#cbd3da!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#121416!important}.text-body{color:#212529!important}.text-muted{color:#6c757d!important}.text-black-50{color:rgba(0,0,0,.5)!important}.text-white-50{color:rgba(255,255,255,.5)!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.text-decoration-none{text-decoration:none!important}.text-break{word-break:break-word!important;word-wrap:break-word!important}.text-reset{color:inherit!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,::after,::before{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]::after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #adb5bd;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}body{min-width:992px!important}.container{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #dee2e6!important}.table-dark{color:inherit}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#dee2e6}.table .thead-dark th{color:inherit;border-color:#dee2e6}}", ""]);

// exports


/***/ }),

/***/ "qex6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("z1r2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2c8b2ad8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f46a2896\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f46a2896\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "r20c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rW15":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lT51");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3af1c424", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ff98e3f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ff98e3f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "re5U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/newHome.2a7a854.jpg";

/***/ }),

/***/ "sCpE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.vaillantCont[data-v-249074c3] {\r\n  height: 100%;\n}\n.wa_icon[data-v-249074c3]{\r\n  max-width: 40px;\r\n  margin-top: -11px;\n}\r\n\r\n", ""]);

// exports


/***/ }),

/***/ "sSMI":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("SwIb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2afc900a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-48050120\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-48050120\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sb9c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AgenziaEntrate_logo.8091eaa.png";

/***/ }),

/***/ "tv1e":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.vaillantCont[data-v-4e3aaf92] {\n  height: 100%;\n}\n.wa_icon[data-v-4e3aaf92]{\n  max-width: 40px;\n  margin-top: -11px;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "u+93":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("54oZ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("62e45bdd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415b2084\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415b2084\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ug38":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vyw2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3a5ecc36", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-26cc6f77\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./flows.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-26cc6f77\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./flows.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v4hK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OBAr");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2e8fec5c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-03a5036f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-03a5036f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vIh7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.small[data-v-866a5c7c]{\n  font-size: 12px!important;\n}\n.selectListBox[data-v-866a5c7c] {\n  background: #d4ebe9;\n  border: 1px solid grey;\n  padding: 3%;\n  max-height: 254px;\n  height: 254px;\n  overflow-y: scroll;\n  -webkit-transition: all .1s;\n  transition: all .1s;\n}\n.lightYellow[data-v-866a5c7c] {\n  background:   #f393241c\n}\n.custLabelFontSize[data-v-866a5c7c]{\n    font-size: 14px;\n}\n.selectBlock[data-v-866a5c7c]{\n    background: #eeeeee;\n    border: 1px solid #a5a5a5;\n    border-top: none;\n}\n.blockActive[data-v-866a5c7c]{\n    background: white;\n    border-bottom: none!important;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "vOz5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("H0mA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5fe9b6fd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0de2e1c8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0de2e1c8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vQ6k":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "vdnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BadgerAccordionItem = ({
    name: 'BadgerAccordionItem',
    mounted: function mounted() {
        // If item rendered emit readyness to parent
        this.$parent.$emit('item:ready');
    },
    data: function data() {
        return {
            opened: false
        };
    },

    methods: {
        changeState: function changeState(state) {
            this.opened = state;
        },
        getIcon: function getIcon() {
            return this.icon;
        }
    },
    computed: {
        iconComponent: function iconComponent() {
            if (this.$parent.iconComponent) {
                return this.$parent.iconComponent;
            }

            return this.iconLoaded;
        },
        iconOpened: function iconOpened() {
            return this.$parent.icons ? this.$parent.icons.opened : '';
        },
        iconClosed: function iconClosed() {
            return this.$parent.icons ? this.$parent.icons.closed : '';
        },
        icon: function icon() {
            return this.opened ? this.iconOpened : this.iconClosed;
        },
        iconLoaded: function iconLoaded() {
            return {
                template: '<span>' + this.icon + '</span>'
            };
        }
    },
    watch: {
        opened: function opened(newValue) {
            this.$emit(newValue ? 'open' : 'close');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a8184a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "badger-accordion-item" }, [
    _c("dt", { staticClass: "badger-accordion__header" }, [
      _c("div", { staticClass: "js-badger-accordion-header" }, [
        _c(
          "button",
          { staticClass: "badger-accordion-toggle" },
          [
            _c(
              "span",
              { staticClass: "badger-accordion-title" },
              [_vm._t("header", [_vm._v("Collapse-Title")])],
              2
            ),
            _vm._v(" "),
            _vm.icon !== "" && _vm.iconComponent
              ? _c(_vm.iconComponent, {
                  tag: "component",
                  staticClass: "badger-toggle-indicator",
                  attrs: { opened: _vm.opened }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "dd",
      { staticClass: "badger-accordion__panel js-badger-accordion-panel" },
      [
        _c(
          "div",
          { staticClass: "js-badger-accordion-panel-inner" },
          [_vm._t("content")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_BadgerAccordionItem = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a8184a", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("aHDP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  BadgerAccordionItem,
  src_BadgerAccordionItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25a8184a", Component.options)
  } else {
    hotAPI.reload("data-v-25a8184a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vue_badger_accordion_src_BadgerAccordionItem = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vg18":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "vp/L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/load.e921351.gif";

/***/ }),

/***/ "vr5u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardonly.cfd25cc.png";

/***/ }),

/***/ "vyw2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.maxSem[data-v-26cc6f77]{\n  max-width: 100px;\n}\n", ""]);

// exports


/***/ }),

/***/ "w/IJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "wA9G":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "x/1t":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.btnOverlay[data-v-67f3a69c]{\n\tmargin-top: -350px!important;\n}\n.csmrtop[data-v-67f3a69c]{\n  margin-top: -30px;\n}\n.headerBack[data-v-67f3a69c]{\n\n/*background: url(../../assets/images/newHome.jpg);*/\nbackground-size: contain;\nbackground-position: top;\nbackground-repeat: no-repeat;\n-webkit-box-align: end;\n    -ms-flex-align: end;\n        align-items: end;\n-ms-flex-line-pack: end;\n    align-content: end;\n-ms-flex-item-align: end;\n    align-self: flex-end;\n}\n.section[data-v-67f3a69c]{\n\tmin-height: calc(100vh - 0px);\n}\n.howplayBack[data-v-67f3a69c]{\n\nbackground: url(" + escape(__webpack_require__("RH4N")) + ");\nbackground-size: cover;\nbackground-position: top;\nbackground-repeat: no-repeat;\n}\n.servicesBack[data-v-67f3a69c]{\n\nbackground: url(" + escape(__webpack_require__("FIF3")) + ");\nbackground-size: cover;\nbackground-position: bottom;\nbackground-repeat: no-repeat;\n}\n.verySmall[data-v-67f3a69c] {\n    font-size: 14px!important;\n    padding: 8px!important;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    vertical-align: middle;\n    margin: 10px;\n}\n.disabled[data-v-67f3a69c] {\n    background: #4d4d4d!important;\n}\n.back[data-v-67f3a69c]{\n\tbackground: #ececec;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "x3vu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HJqQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e56d5352", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xiib":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\niframe[data-v-31b2d0d5]{\n  min-height: 10px!important;\n}\n#card-form[data-v-31b2d0d5]{\n  text-align: left;\n}\n.cardFormLabel[data-v-31b2d0d5]{\n  text-align: left;\n}\n@media (max-width: 476px) {\n.form-container[data-v-31b2d0d5] {\n    border: none;\n}\n}\n.cardinfo-wrapper[data-v-31b2d0d5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.card-shape[data-v-31b2d0d5], #my-sample-form.visa[data-v-31b2d0d5], #my-sample-form.master-card[data-v-31b2d0d5], #my-sample-form.maestro[data-v-31b2d0d5], #my-sample-form.american-express[data-v-31b2d0d5], #my-sample-form.discover[data-v-31b2d0d5], #my-sample-form.unionpay[data-v-31b2d0d5], #my-sample-form.jcb[data-v-31b2d0d5], #my-sample-form.diners-club[data-v-31b2d0d5] {\n  border-radius: 6px;\n  padding: 2em 2em 1em;\n}\n@media (max-width: 476px) {\n.card-shape[data-v-31b2d0d5], #my-sample-form.visa[data-v-31b2d0d5], #my-sample-form.master-card[data-v-31b2d0d5], #my-sample-form.maestro[data-v-31b2d0d5], #my-sample-form.american-express[data-v-31b2d0d5], #my-sample-form.discover[data-v-31b2d0d5], #my-sample-form.unionpay[data-v-31b2d0d5], #my-sample-form.jcb[data-v-31b2d0d5], #my-sample-form.diners-club[data-v-31b2d0d5] {\n    padding: 2em 1.5em 1em;\n}\n}\n#pp-container[data-v-31b2d0d5] {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  padding: 10px;\n  width: 100%;\n  margin-bottom: 1em;\n  -webkit-transition: all 600ms cubic-bezier(0.2, 1.3, 0.7, 1);\n  transition: all 600ms cubic-bezier(0.2, 1.3, 0.7, 1);\n  -webkit-animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);\n          animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);\n  z-index: 1;\n}\n#my-sample-form[data-v-31b2d0d5] {\n  background-color: #FFF;\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  padding: 10px;\n  width: 100%;\n  margin-bottom: 2em;\n  -webkit-transition: all 600ms cubic-bezier(0.2, 1.3, 0.7, 1);\n  transition: all 600ms cubic-bezier(0.2, 1.3, 0.7, 1);\n  -webkit-animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);\n          animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);\n  z-index: 1;\n}\n#my-sample-form[data-v-31b2d0d5]:hover {\n  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);\n}\n@media (max-width: 476px) {\n#my-sample-form[data-v-31b2d0d5] {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    padding: 7em 2em 2em;\n    width: 100%;\n}\n}\n#my-sample-form.visa[data-v-31b2d0d5] {\n  color: #fff;\n  background-color: #0D4AA2;\n}\n#my-sample-form.master-card[data-v-31b2d0d5] {\n  color: #fff;\n  background-color: #363636;\n  background: linear-gradient(115deg, #d82332, #d82332 50%, #f1ad3d 50%, #f1ad3d);\n}\n#my-sample-form.maestro[data-v-31b2d0d5] {\n  color: #fff;\n  background-color: #363636;\n  background: linear-gradient(115deg, #009ddd, #009ddd 50%, #ed1c2e 50%, #ed1c2e);\n}\n#my-sample-form.american-express[data-v-31b2d0d5] {\n  color: #fff;\n  background-color: #007CC3;\n}\n#my-sample-form.discover[data-v-31b2d0d5] {\n  color: #fff;\n  background-color: #ff6000;\n  background: -webkit-gradient(linear, left top, left bottom, from(#d14310), to(#f7961e));\n  background: linear-gradient(#d14310, #f7961e);\n}\n#my-sample-form.unionpay[data-v-31b2d0d5], #my-sample-form.jcb[data-v-31b2d0d5], #my-sample-form.diners-club[data-v-31b2d0d5] {\n  color: #fff;\n  background-color: #363636;\n}\n.cardinfo-label[data-v-31b2d0d5] {\n  display: block;\n  font-size: 11px;\n  margin-bottom: 0.5em;\n  text-transform: uppercase;\n}\n.cardinfo-exp-date[data-v-31b2d0d5] {\n  margin-right: 1em;\n  width: 100%;\n}\n.cardinfo-cvv[data-v-31b2d0d5] {\n  width: 100%;\n}\n#button-pay[data-v-31b2d0d5] {\n  cursor: pointer;\n  width: 100%;\n  font-size: 15px;\n  border: 0;\n  padding: 1.2em 1em;\n  color: #fff;\n  background: #282c37;\n  border-radius: 4px;\n  z-index: 0;\n  -webkit-transform: translateY(-100px);\n          transform: translateY(-100px);\n  -webkit-transition: all 500ms cubic-bezier(0.2, 1.3, 0.7, 1);\n  transition: all 500ms cubic-bezier(0.2, 1.3, 0.7, 1);\n  opacity: 0;\n  -webkit-appearance: none;\n}\n#button-pay[data-v-31b2d0d5]:hover {\n  background: #535b72;\n}\n#button-pay[data-v-31b2d0d5]:active {\n  -webkit-animation: cardIntro 200ms cubic-bezier(0.2, 1.3, 0.7, 1);\n          animation: cardIntro 200ms cubic-bezier(0.2, 1.3, 0.7, 1);\n}\n#button-pay.show-button[data-v-31b2d0d5] {\n  -webkit-transform: translateY(0);\n          transform: translateY(0);\n  opacity: 1;\n}\n.cardinfo-card-number[data-v-31b2d0d5] {\n  position: relative;\n}\n.cardholder[data-v-31b2d0d5] {\n  position: relative;\n}\n#card-image[data-v-31b2d0d5] {\n  position: absolute;\n  top: 1em;\n  right: 0.5em;\n  width: 44px;\n  height: 28px;\n  background-image: url(\t);\n  background-size: 86px 458px;\n  border-radius: 4px;\n  background-position: -100px 0;\n  background-repeat: no-repeat;\n  margin-bottom: 1em;\n  background-size: contain;\n}\n#card-image.visa[data-v-31b2d0d5] {\n  background: url(" + escape(__webpack_require__("Xwnd")) + ");\n  background-size: contain;\n}\n#card-image.master-card[data-v-31b2d0d5] {\n  background: url(" + escape(__webpack_require__("wA9G")) + ");\n  background-size: contain;\n}\n#card-image.american-express[data-v-31b2d0d5] {\n  background: url(" + escape(__webpack_require__("MoMY")) + ");\n  background-size: contain;\n}\n#card-image.discover[data-v-31b2d0d5] {\n  background-position: 0 -163px;\n}\n#card-image.maestro[data-v-31b2d0d5] {\n  background: url(" + escape(__webpack_require__("IM0E")) + ");\n  background-size: contain;\n}\n#card-image.jcb[data-v-31b2d0d5] {\n  background-position: 0 -221px;\n}\n#card-image.diners-club[data-v-31b2d0d5] {\n  background-position: 0 -133px;\n}\n\n/*--------------------\nInputs\n--------------------*/\n.input-wrapper[data-v-31b2d0d5] {\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.86);\n  height: 1.75em;\n  border: 1px solid #eee;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);\n          box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);\n  padding: 5px 10px;\n  margin-bottom: 1em;\n}\n.card-holder-name[data-v-31b2d0d5],\n.cardinfo-card-number[data-v-31b2d0d5],\n.cardinfo-exp-date[data-v-31b2d0d5],\n.cardinfo-cvv[data-v-31b2d0d5] {\n  transition: -webkit-transform 0.3s;\n  -webkit-transition: -webkit-transform 0.3s;\n  transition: transform 0.3s;\n  transition: transform 0.3s, -webkit-transform 0.3s;\n}\n#form-container[data-v-31b2d0d5]\n{\n}\n#pp-container[data-v-31b2d0d5]\n{\n}\n\n", ""]);

// exports


/***/ }),

/***/ "yLEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_UPDATE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_SET_DEFAULT_SHIP_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_CHECK_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPT_COOKIES; });
var USER_REQUEST = 'USER_REQUEST';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_ERROR = 'USER_ERROR';
var USER_UPDATE_DATA = 'USER_UPDATE_DATA';
var USER_SET_DEFAULT_SHIP_DATA = 'USER_SET_DEFAULT_SHIP_DATA';
var USER_CHECK_AGE = 'USER_CHECK_AGE';
var ACCEPT_COOKIES = 'ACCEPT_COOKIES';

/***/ }),

/***/ "yTXc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AEYR");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4bde62e4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0d25b78e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0d25b78e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yqhM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Fp4o");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3a935d3f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fe741b42\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fe741b42\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "z1r2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.errorIcon[data-v-f46a2896] {\n  max-width: 150px;\n  margin: 0 auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "z5ke":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/arial.c28c322.eot";

/***/ }),

/***/ "zbSp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cardPP.721669c.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app-51a13a26ce78fd7b1ea091.js